/*!
 * sdk.js v1.26.8
 * 6/24/2024, 12:54:53 AM
 * (c) 2017 mudu.tv
 * 杭州雅顾科技有限公司 版权所有
 * 
 */
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	__webpack_require__(12);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * https://github.com/es-shims/es5-shim
	 * @license es5-shim Copyright 2009-2015 by contributors, MIT License
	 * see https://github.com/es-shims/es5-shim/blob/master/LICENSE
	 */
	
	// vim: ts=4 sts=4 sw=4 expandtab
	
	// Add semicolon to prevent IIFE from being passed as argument to concatenated code.
	;
	
	// UMD (Universal Module Definition)
	// see https://github.com/umdjs/umd/blob/master/templates/returnExports.js
	(function (root, factory) {
	    'use strict';
	
	    /* global define, exports, module */
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like enviroments that support module.exports,
	        // like Node.
	        module.exports = factory();
	    } else {
	        // Browser globals (root is window)
	        root.returnExports = factory();
	    }
	}(this, function () {
	    /**
	     * Brings an environment as close to ECMAScript 5 compliance
	     * as is possible with the facilities of erstwhile engines.
	     *
	     * Annotated ES5: http://es5.github.com/ (specific links below)
	     * ES5 Spec: http://www.ecma-international.org/publications/files/ECMA-ST/Ecma-262.pdf
	     * Required reading: http://javascriptweblog.wordpress.com/2011/12/05/extending-javascript-natives/
	     */
	
	    // Shortcut to an often accessed properties, in order to avoid multiple
	    // dereference that costs universally. This also holds a reference to known-good
	    // functions.
	    var $Array = Array;
	    var ArrayPrototype = $Array.prototype;
	    var $Object = Object;
	    var ObjectPrototype = $Object.prototype;
	    var $Function = Function;
	    var FunctionPrototype = $Function.prototype;
	    var $String = String;
	    var StringPrototype = $String.prototype;
	    var $Number = Number;
	    var NumberPrototype = $Number.prototype;
	    var array_slice = ArrayPrototype.slice;
	    var array_splice = ArrayPrototype.splice;
	    var array_push = ArrayPrototype.push;
	    var array_unshift = ArrayPrototype.unshift;
	    var array_concat = ArrayPrototype.concat;
	    var array_join = ArrayPrototype.join;
	    var call = FunctionPrototype.call;
	    var apply = FunctionPrototype.apply;
	    var max = Math.max;
	    var min = Math.min;
	
	    // Having a toString local variable name breaks in Opera so use to_string.
	    var to_string = ObjectPrototype.toString;
	
	    /* global Symbol */
	    /* eslint-disable one-var-declaration-per-line, no-redeclare, max-statements-per-line */
	    var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	    var isCallable; /* inlined from https://npmjs.com/is-callable */ var fnToStr = Function.prototype.toString, constructorRegex = /^\s*class /, isES6ClassFn = function isES6ClassFn(value) { try { var fnStr = fnToStr.call(value); var singleStripped = fnStr.replace(/\/\/.*\n/g, ''); var multiStripped = singleStripped.replace(/\/\*[.\s\S]*\*\//g, ''); var spaceStripped = multiStripped.replace(/\n/mg, ' ').replace(/ {2}/g, ' '); return constructorRegex.test(spaceStripped); } catch (e) { return false; /* not a function */ } }, tryFunctionObject = function tryFunctionObject(value) { try { if (isES6ClassFn(value)) { return false; } fnToStr.call(value); return true; } catch (e) { return false; } }, fnClass = '[object Function]', genClass = '[object GeneratorFunction]', isCallable = function isCallable(value) { if (!value) { return false; } if (typeof value !== 'function' && typeof value !== 'object') { return false; } if (hasToStringTag) { return tryFunctionObject(value); } if (isES6ClassFn(value)) { return false; } var strClass = to_string.call(value); return strClass === fnClass || strClass === genClass; };
	
	    var isRegex; /* inlined from https://npmjs.com/is-regex */ var regexExec = RegExp.prototype.exec, tryRegexExec = function tryRegexExec(value) { try { regexExec.call(value); return true; } catch (e) { return false; } }, regexClass = '[object RegExp]'; isRegex = function isRegex(value) { if (typeof value !== 'object') { return false; } return hasToStringTag ? tryRegexExec(value) : to_string.call(value) === regexClass; };
	    var isString; /* inlined from https://npmjs.com/is-string */ var strValue = String.prototype.valueOf, tryStringObject = function tryStringObject(value) { try { strValue.call(value); return true; } catch (e) { return false; } }, stringClass = '[object String]'; isString = function isString(value) { if (typeof value === 'string') { return true; } if (typeof value !== 'object') { return false; } return hasToStringTag ? tryStringObject(value) : to_string.call(value) === stringClass; };
	    /* eslint-enable one-var-declaration-per-line, no-redeclare, max-statements-per-line */
	
	    /* inlined from http://npmjs.com/define-properties */
	    var supportsDescriptors = $Object.defineProperty && (function () {
	        try {
	            var obj = {};
	            $Object.defineProperty(obj, 'x', { enumerable: false, value: obj });
	            for (var _ in obj) { // jscs:ignore disallowUnusedVariables
	                return false;
	            }
	            return obj.x === obj;
	        } catch (e) { /* this is ES3 */
	            return false;
	        }
	    }());
	    var defineProperties = (function (has) {
	        // Define configurable, writable, and non-enumerable props
	        // if they don't exist.
	        var defineProperty;
	        if (supportsDescriptors) {
	            defineProperty = function (object, name, method, forceAssign) {
	                if (!forceAssign && (name in object)) {
	                    return;
	                }
	                $Object.defineProperty(object, name, {
	                    configurable: true,
	                    enumerable: false,
	                    writable: true,
	                    value: method
	                });
	            };
	        } else {
	            defineProperty = function (object, name, method, forceAssign) {
	                if (!forceAssign && (name in object)) {
	                    return;
	                }
	                object[name] = method;
	            };
	        }
	        return function defineProperties(object, map, forceAssign) {
	            for (var name in map) {
	                if (has.call(map, name)) {
	                    defineProperty(object, name, map[name], forceAssign);
	                }
	            }
	        };
	    }(ObjectPrototype.hasOwnProperty));
	
	    //
	    // Util
	    // ======
	    //
	
	    /* replaceable with https://npmjs.com/package/es-abstract /helpers/isPrimitive */
	    var isPrimitive = function isPrimitive(input) {
	        var type = typeof input;
	        return input === null || (type !== 'object' && type !== 'function');
	    };
	
	    var isActualNaN = $Number.isNaN || function isActualNaN(x) {
	        return x !== x;
	    };
	
	    var ES = {
	        // ES5 9.4
	        // http://es5.github.com/#x9.4
	        // http://jsperf.com/to-integer
	        /* replaceable with https://npmjs.com/package/es-abstract ES5.ToInteger */
	        ToInteger: function ToInteger(num) {
	            var n = +num;
	            if (isActualNaN(n)) {
	                n = 0;
	            } else if (n !== 0 && n !== (1 / 0) && n !== -(1 / 0)) {
	                n = (n > 0 || -1) * Math.floor(Math.abs(n));
	            }
	            return n;
	        },
	
	        /* replaceable with https://npmjs.com/package/es-abstract ES5.ToPrimitive */
	        ToPrimitive: function ToPrimitive(input) {
	            var val, valueOf, toStr;
	            if (isPrimitive(input)) {
	                return input;
	            }
	            valueOf = input.valueOf;
	            if (isCallable(valueOf)) {
	                val = valueOf.call(input);
	                if (isPrimitive(val)) {
	                    return val;
	                }
	            }
	            toStr = input.toString;
	            if (isCallable(toStr)) {
	                val = toStr.call(input);
	                if (isPrimitive(val)) {
	                    return val;
	                }
	            }
	            throw new TypeError();
	        },
	
	        // ES5 9.9
	        // http://es5.github.com/#x9.9
	        /* replaceable with https://npmjs.com/package/es-abstract ES5.ToObject */
	        ToObject: function (o) {
	            if (o == null) { // this matches both null and undefined
	                throw new TypeError("can't convert " + o + ' to object');
	            }
	            return $Object(o);
	        },
	
	        /* replaceable with https://npmjs.com/package/es-abstract ES5.ToUint32 */
	        ToUint32: function ToUint32(x) {
	            return x >>> 0;
	        }
	    };
	
	    //
	    // Function
	    // ========
	    //
	
	    // ES-5 15.3.4.5
	    // http://es5.github.com/#x15.3.4.5
	
	    var Empty = function Empty() {};
	
	    defineProperties(FunctionPrototype, {
	        bind: function bind(that) { // .length is 1
	            // 1. Let Target be the this value.
	            var target = this;
	            // 2. If IsCallable(Target) is false, throw a TypeError exception.
	            if (!isCallable(target)) {
	                throw new TypeError('Function.prototype.bind called on incompatible ' + target);
	            }
	            // 3. Let A be a new (possibly empty) internal list of all of the
	            //   argument values provided after thisArg (arg1, arg2 etc), in order.
	            // XXX slicedArgs will stand in for "A" if used
	            var args = array_slice.call(arguments, 1); // for normal call
	            // 4. Let F be a new native ECMAScript object.
	            // 11. Set the [[Prototype]] internal property of F to the standard
	            //   built-in Function prototype object as specified in 15.3.3.1.
	            // 12. Set the [[Call]] internal property of F as described in
	            //   15.3.4.5.1.
	            // 13. Set the [[Construct]] internal property of F as described in
	            //   15.3.4.5.2.
	            // 14. Set the [[HasInstance]] internal property of F as described in
	            //   15.3.4.5.3.
	            var bound;
	            var binder = function () {
	
	                if (this instanceof bound) {
	                    // 15.3.4.5.2 [[Construct]]
	                    // When the [[Construct]] internal method of a function object,
	                    // F that was created using the bind function is called with a
	                    // list of arguments ExtraArgs, the following steps are taken:
	                    // 1. Let target be the value of F's [[TargetFunction]]
	                    //   internal property.
	                    // 2. If target has no [[Construct]] internal method, a
	                    //   TypeError exception is thrown.
	                    // 3. Let boundArgs be the value of F's [[BoundArgs]] internal
	                    //   property.
	                    // 4. Let args be a new list containing the same values as the
	                    //   list boundArgs in the same order followed by the same
	                    //   values as the list ExtraArgs in the same order.
	                    // 5. Return the result of calling the [[Construct]] internal
	                    //   method of target providing args as the arguments.
	
	                    var result = apply.call(
	                        target,
	                        this,
	                        array_concat.call(args, array_slice.call(arguments))
	                    );
	                    if ($Object(result) === result) {
	                        return result;
	                    }
	                    return this;
	
	                } else {
	                    // 15.3.4.5.1 [[Call]]
	                    // When the [[Call]] internal method of a function object, F,
	                    // which was created using the bind function is called with a
	                    // this value and a list of arguments ExtraArgs, the following
	                    // steps are taken:
	                    // 1. Let boundArgs be the value of F's [[BoundArgs]] internal
	                    //   property.
	                    // 2. Let boundThis be the value of F's [[BoundThis]] internal
	                    //   property.
	                    // 3. Let target be the value of F's [[TargetFunction]] internal
	                    //   property.
	                    // 4. Let args be a new list containing the same values as the
	                    //   list boundArgs in the same order followed by the same
	                    //   values as the list ExtraArgs in the same order.
	                    // 5. Return the result of calling the [[Call]] internal method
	                    //   of target providing boundThis as the this value and
	                    //   providing args as the arguments.
	
	                    // equiv: target.call(this, ...boundArgs, ...args)
	                    return apply.call(
	                        target,
	                        that,
	                        array_concat.call(args, array_slice.call(arguments))
	                    );
	
	                }
	
	            };
	
	            // 15. If the [[Class]] internal property of Target is "Function", then
	            //     a. Let L be the length property of Target minus the length of A.
	            //     b. Set the length own property of F to either 0 or L, whichever is
	            //       larger.
	            // 16. Else set the length own property of F to 0.
	
	            var boundLength = max(0, target.length - args.length);
	
	            // 17. Set the attributes of the length own property of F to the values
	            //   specified in 15.3.5.1.
	            var boundArgs = [];
	            for (var i = 0; i < boundLength; i++) {
	                array_push.call(boundArgs, '$' + i);
	            }
	
	            // XXX Build a dynamic function with desired amount of arguments is the only
	            // way to set the length property of a function.
	            // In environments where Content Security Policies enabled (Chrome extensions,
	            // for ex.) all use of eval or Function costructor throws an exception.
	            // However in all of these environments Function.prototype.bind exists
	            // and so this code will never be executed.
	            bound = $Function('binder', 'return function (' + array_join.call(boundArgs, ',') + '){ return binder.apply(this, arguments); }')(binder);
	
	            if (target.prototype) {
	                Empty.prototype = target.prototype;
	                bound.prototype = new Empty();
	                // Clean up dangling references.
	                Empty.prototype = null;
	            }
	
	            // TODO
	            // 18. Set the [[Extensible]] internal property of F to true.
	
	            // TODO
	            // 19. Let thrower be the [[ThrowTypeError]] function Object (13.2.3).
	            // 20. Call the [[DefineOwnProperty]] internal method of F with
	            //   arguments "caller", PropertyDescriptor {[[Get]]: thrower, [[Set]]:
	            //   thrower, [[Enumerable]]: false, [[Configurable]]: false}, and
	            //   false.
	            // 21. Call the [[DefineOwnProperty]] internal method of F with
	            //   arguments "arguments", PropertyDescriptor {[[Get]]: thrower,
	            //   [[Set]]: thrower, [[Enumerable]]: false, [[Configurable]]: false},
	            //   and false.
	
	            // TODO
	            // NOTE Function objects created using Function.prototype.bind do not
	            // have a prototype property or the [[Code]], [[FormalParameters]], and
	            // [[Scope]] internal properties.
	            // XXX can't delete prototype in pure-js.
	
	            // 22. Return F.
	            return bound;
	        }
	    });
	
	    // _Please note: Shortcuts are defined after `Function.prototype.bind` as we
	    // use it in defining shortcuts.
	    var owns = call.bind(ObjectPrototype.hasOwnProperty);
	    var toStr = call.bind(ObjectPrototype.toString);
	    var arraySlice = call.bind(array_slice);
	    var arraySliceApply = apply.bind(array_slice);
	    var strSlice = call.bind(StringPrototype.slice);
	    var strSplit = call.bind(StringPrototype.split);
	    var strIndexOf = call.bind(StringPrototype.indexOf);
	    var pushCall = call.bind(array_push);
	    var isEnum = call.bind(ObjectPrototype.propertyIsEnumerable);
	    var arraySort = call.bind(ArrayPrototype.sort);
	
	    //
	    // Array
	    // =====
	    //
	
	    var isArray = $Array.isArray || function isArray(obj) {
	        return toStr(obj) === '[object Array]';
	    };
	
	    // ES5 15.4.4.12
	    // http://es5.github.com/#x15.4.4.13
	    // Return len+argCount.
	    // [bugfix, ielt8]
	    // IE < 8 bug: [].unshift(0) === undefined but should be "1"
	    var hasUnshiftReturnValueBug = [].unshift(0) !== 1;
	    defineProperties(ArrayPrototype, {
	        unshift: function () {
	            array_unshift.apply(this, arguments);
	            return this.length;
	        }
	    }, hasUnshiftReturnValueBug);
	
	    // ES5 15.4.3.2
	    // http://es5.github.com/#x15.4.3.2
	    // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/isArray
	    defineProperties($Array, { isArray: isArray });
	
	    // The IsCallable() check in the Array functions
	    // has been replaced with a strict check on the
	    // internal class of the object to trap cases where
	    // the provided function was actually a regular
	    // expression literal, which in V8 and
	    // JavaScriptCore is a typeof "function".  Only in
	    // V8 are regular expression literals permitted as
	    // reduce parameters, so it is desirable in the
	    // general case for the shim to match the more
	    // strict and common behavior of rejecting regular
	    // expressions.
	
	    // ES5 15.4.4.18
	    // http://es5.github.com/#x15.4.4.18
	    // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/array/forEach
	
	    // Check failure of by-index access of string characters (IE < 9)
	    // and failure of `0 in boxedString` (Rhino)
	    var boxedString = $Object('a');
	    var splitString = boxedString[0] !== 'a' || !(0 in boxedString);
	
	    var properlyBoxesContext = function properlyBoxed(method) {
	        // Check node 0.6.21 bug where third parameter is not boxed
	        var properlyBoxesNonStrict = true;
	        var properlyBoxesStrict = true;
	        var threwException = false;
	        if (method) {
	            try {
	                method.call('foo', function (_, __, context) {
	                    if (typeof context !== 'object') {
	                        properlyBoxesNonStrict = false;
	                    }
	                });
	
	                method.call([1], function () {
	                    'use strict';
	
	                    properlyBoxesStrict = typeof this === 'string';
	                }, 'x');
	            } catch (e) {
	                threwException = true;
	            }
	        }
	        return !!method && !threwException && properlyBoxesNonStrict && properlyBoxesStrict;
	    };
	
	    defineProperties(ArrayPrototype, {
	        forEach: function forEach(callbackfn/*, thisArg*/) {
	            var object = ES.ToObject(this);
	            var self = splitString && isString(this) ? strSplit(this, '') : object;
	            var i = -1;
	            var length = ES.ToUint32(self.length);
	            var T;
	            if (arguments.length > 1) {
	                T = arguments[1];
	            }
	
	            // If no callback function or if callback is not a callable function
	            if (!isCallable(callbackfn)) {
	                throw new TypeError('Array.prototype.forEach callback must be a function');
	            }
	
	            while (++i < length) {
	                if (i in self) {
	                    // Invoke the callback function with call, passing arguments:
	                    // context, property value, property key, thisArg object
	                    if (typeof T === 'undefined') {
	                        callbackfn(self[i], i, object);
	                    } else {
	                        callbackfn.call(T, self[i], i, object);
	                    }
	                }
	            }
	        }
	    }, !properlyBoxesContext(ArrayPrototype.forEach));
	
	    // ES5 15.4.4.19
	    // http://es5.github.com/#x15.4.4.19
	    // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/map
	    defineProperties(ArrayPrototype, {
	        map: function map(callbackfn/*, thisArg*/) {
	            var object = ES.ToObject(this);
	            var self = splitString && isString(this) ? strSplit(this, '') : object;
	            var length = ES.ToUint32(self.length);
	            var result = $Array(length);
	            var T;
	            if (arguments.length > 1) {
	                T = arguments[1];
	            }
	
	            // If no callback function or if callback is not a callable function
	            if (!isCallable(callbackfn)) {
	                throw new TypeError('Array.prototype.map callback must be a function');
	            }
	
	            for (var i = 0; i < length; i++) {
	                if (i in self) {
	                    if (typeof T === 'undefined') {
	                        result[i] = callbackfn(self[i], i, object);
	                    } else {
	                        result[i] = callbackfn.call(T, self[i], i, object);
	                    }
	                }
	            }
	            return result;
	        }
	    }, !properlyBoxesContext(ArrayPrototype.map));
	
	    // ES5 15.4.4.20
	    // http://es5.github.com/#x15.4.4.20
	    // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/filter
	    defineProperties(ArrayPrototype, {
	        filter: function filter(callbackfn/*, thisArg*/) {
	            var object = ES.ToObject(this);
	            var self = splitString && isString(this) ? strSplit(this, '') : object;
	            var length = ES.ToUint32(self.length);
	            var result = [];
	            var value;
	            var T;
	            if (arguments.length > 1) {
	                T = arguments[1];
	            }
	
	            // If no callback function or if callback is not a callable function
	            if (!isCallable(callbackfn)) {
	                throw new TypeError('Array.prototype.filter callback must be a function');
	            }
	
	            for (var i = 0; i < length; i++) {
	                if (i in self) {
	                    value = self[i];
	                    if (typeof T === 'undefined' ? callbackfn(value, i, object) : callbackfn.call(T, value, i, object)) {
	                        pushCall(result, value);
	                    }
	                }
	            }
	            return result;
	        }
	    }, !properlyBoxesContext(ArrayPrototype.filter));
	
	    // ES5 15.4.4.16
	    // http://es5.github.com/#x15.4.4.16
	    // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/every
	    defineProperties(ArrayPrototype, {
	        every: function every(callbackfn/*, thisArg*/) {
	            var object = ES.ToObject(this);
	            var self = splitString && isString(this) ? strSplit(this, '') : object;
	            var length = ES.ToUint32(self.length);
	            var T;
	            if (arguments.length > 1) {
	                T = arguments[1];
	            }
	
	            // If no callback function or if callback is not a callable function
	            if (!isCallable(callbackfn)) {
	                throw new TypeError('Array.prototype.every callback must be a function');
	            }
	
	            for (var i = 0; i < length; i++) {
	                if (i in self && !(typeof T === 'undefined' ? callbackfn(self[i], i, object) : callbackfn.call(T, self[i], i, object))) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }, !properlyBoxesContext(ArrayPrototype.every));
	
	    // ES5 15.4.4.17
	    // http://es5.github.com/#x15.4.4.17
	    // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/some
	    defineProperties(ArrayPrototype, {
	        some: function some(callbackfn/*, thisArg */) {
	            var object = ES.ToObject(this);
	            var self = splitString && isString(this) ? strSplit(this, '') : object;
	            var length = ES.ToUint32(self.length);
	            var T;
	            if (arguments.length > 1) {
	                T = arguments[1];
	            }
	
	            // If no callback function or if callback is not a callable function
	            if (!isCallable(callbackfn)) {
	                throw new TypeError('Array.prototype.some callback must be a function');
	            }
	
	            for (var i = 0; i < length; i++) {
	                if (i in self && (typeof T === 'undefined' ? callbackfn(self[i], i, object) : callbackfn.call(T, self[i], i, object))) {
	                    return true;
	                }
	            }
	            return false;
	        }
	    }, !properlyBoxesContext(ArrayPrototype.some));
	
	    // ES5 15.4.4.21
	    // http://es5.github.com/#x15.4.4.21
	    // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/reduce
	    var reduceCoercesToObject = false;
	    if (ArrayPrototype.reduce) {
	        reduceCoercesToObject = typeof ArrayPrototype.reduce.call('es5', function (_, __, ___, list) {
	            return list;
	        }) === 'object';
	    }
	    defineProperties(ArrayPrototype, {
	        reduce: function reduce(callbackfn/*, initialValue*/) {
	            var object = ES.ToObject(this);
	            var self = splitString && isString(this) ? strSplit(this, '') : object;
	            var length = ES.ToUint32(self.length);
	
	            // If no callback function or if callback is not a callable function
	            if (!isCallable(callbackfn)) {
	                throw new TypeError('Array.prototype.reduce callback must be a function');
	            }
	
	            // no value to return if no initial value and an empty array
	            if (length === 0 && arguments.length === 1) {
	                throw new TypeError('reduce of empty array with no initial value');
	            }
	
	            var i = 0;
	            var result;
	            if (arguments.length >= 2) {
	                result = arguments[1];
	            } else {
	                do {
	                    if (i in self) {
	                        result = self[i++];
	                        break;
	                    }
	
	                    // if array contains no values, no initial value to return
	                    if (++i >= length) {
	                        throw new TypeError('reduce of empty array with no initial value');
	                    }
	                } while (true);
	            }
	
	            for (; i < length; i++) {
	                if (i in self) {
	                    result = callbackfn(result, self[i], i, object);
	                }
	            }
	
	            return result;
	        }
	    }, !reduceCoercesToObject);
	
	    // ES5 15.4.4.22
	    // http://es5.github.com/#x15.4.4.22
	    // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/reduceRight
	    var reduceRightCoercesToObject = false;
	    if (ArrayPrototype.reduceRight) {
	        reduceRightCoercesToObject = typeof ArrayPrototype.reduceRight.call('es5', function (_, __, ___, list) {
	            return list;
	        }) === 'object';
	    }
	    defineProperties(ArrayPrototype, {
	        reduceRight: function reduceRight(callbackfn/*, initial*/) {
	            var object = ES.ToObject(this);
	            var self = splitString && isString(this) ? strSplit(this, '') : object;
	            var length = ES.ToUint32(self.length);
	
	            // If no callback function or if callback is not a callable function
	            if (!isCallable(callbackfn)) {
	                throw new TypeError('Array.prototype.reduceRight callback must be a function');
	            }
	
	            // no value to return if no initial value, empty array
	            if (length === 0 && arguments.length === 1) {
	                throw new TypeError('reduceRight of empty array with no initial value');
	            }
	
	            var result;
	            var i = length - 1;
	            if (arguments.length >= 2) {
	                result = arguments[1];
	            } else {
	                do {
	                    if (i in self) {
	                        result = self[i--];
	                        break;
	                    }
	
	                    // if array contains no values, no initial value to return
	                    if (--i < 0) {
	                        throw new TypeError('reduceRight of empty array with no initial value');
	                    }
	                } while (true);
	            }
	
	            if (i < 0) {
	                return result;
	            }
	
	            do {
	                if (i in self) {
	                    result = callbackfn(result, self[i], i, object);
	                }
	            } while (i--);
	
	            return result;
	        }
	    }, !reduceRightCoercesToObject);
	
	    // ES5 15.4.4.14
	    // http://es5.github.com/#x15.4.4.14
	    // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/indexOf
	    var hasFirefox2IndexOfBug = ArrayPrototype.indexOf && [0, 1].indexOf(1, 2) !== -1;
	    defineProperties(ArrayPrototype, {
	        indexOf: function indexOf(searchElement/*, fromIndex */) {
	            var self = splitString && isString(this) ? strSplit(this, '') : ES.ToObject(this);
	            var length = ES.ToUint32(self.length);
	
	            if (length === 0) {
	                return -1;
	            }
	
	            var i = 0;
	            if (arguments.length > 1) {
	                i = ES.ToInteger(arguments[1]);
	            }
	
	            // handle negative indices
	            i = i >= 0 ? i : max(0, length + i);
	            for (; i < length; i++) {
	                if (i in self && self[i] === searchElement) {
	                    return i;
	                }
	            }
	            return -1;
	        }
	    }, hasFirefox2IndexOfBug);
	
	    // ES5 15.4.4.15
	    // http://es5.github.com/#x15.4.4.15
	    // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/lastIndexOf
	    var hasFirefox2LastIndexOfBug = ArrayPrototype.lastIndexOf && [0, 1].lastIndexOf(0, -3) !== -1;
	    defineProperties(ArrayPrototype, {
	        lastIndexOf: function lastIndexOf(searchElement/*, fromIndex */) {
	            var self = splitString && isString(this) ? strSplit(this, '') : ES.ToObject(this);
	            var length = ES.ToUint32(self.length);
	
	            if (length === 0) {
	                return -1;
	            }
	            var i = length - 1;
	            if (arguments.length > 1) {
	                i = min(i, ES.ToInteger(arguments[1]));
	            }
	            // handle negative indices
	            i = i >= 0 ? i : length - Math.abs(i);
	            for (; i >= 0; i--) {
	                if (i in self && searchElement === self[i]) {
	                    return i;
	                }
	            }
	            return -1;
	        }
	    }, hasFirefox2LastIndexOfBug);
	
	    // ES5 15.4.4.12
	    // http://es5.github.com/#x15.4.4.12
	    var spliceNoopReturnsEmptyArray = (function () {
	        var a = [1, 2];
	        var result = a.splice();
	        return a.length === 2 && isArray(result) && result.length === 0;
	    }());
	    defineProperties(ArrayPrototype, {
	        // Safari 5.0 bug where .splice() returns undefined
	        splice: function splice(start, deleteCount) {
	            if (arguments.length === 0) {
	                return [];
	            } else {
	                return array_splice.apply(this, arguments);
	            }
	        }
	    }, !spliceNoopReturnsEmptyArray);
	
	    var spliceWorksWithEmptyObject = (function () {
	        var obj = {};
	        ArrayPrototype.splice.call(obj, 0, 0, 1);
	        return obj.length === 1;
	    }());
	    defineProperties(ArrayPrototype, {
	        splice: function splice(start, deleteCount) {
	            if (arguments.length === 0) {
	                return [];
	            }
	            var args = arguments;
	            this.length = max(ES.ToInteger(this.length), 0);
	            if (arguments.length > 0 && typeof deleteCount !== 'number') {
	                args = arraySlice(arguments);
	                if (args.length < 2) {
	                    pushCall(args, this.length - start);
	                } else {
	                    args[1] = ES.ToInteger(deleteCount);
	                }
	            }
	            return array_splice.apply(this, args);
	        }
	    }, !spliceWorksWithEmptyObject);
	    var spliceWorksWithLargeSparseArrays = (function () {
	        // Per https://github.com/es-shims/es5-shim/issues/295
	        // Safari 7/8 breaks with sparse arrays of size 1e5 or greater
	        var arr = new $Array(1e5);
	        // note: the index MUST be 8 or larger or the test will false pass
	        arr[8] = 'x';
	        arr.splice(1, 1);
	        // note: this test must be defined *after* the indexOf shim
	        // per https://github.com/es-shims/es5-shim/issues/313
	        return arr.indexOf('x') === 7;
	    }());
	    var spliceWorksWithSmallSparseArrays = (function () {
	        // Per https://github.com/es-shims/es5-shim/issues/295
	        // Opera 12.15 breaks on this, no idea why.
	        var n = 256;
	        var arr = [];
	        arr[n] = 'a';
	        arr.splice(n + 1, 0, 'b');
	        return arr[n] === 'a';
	    }());
	    defineProperties(ArrayPrototype, {
	        splice: function splice(start, deleteCount) {
	            var O = ES.ToObject(this);
	            var A = [];
	            var len = ES.ToUint32(O.length);
	            var relativeStart = ES.ToInteger(start);
	            var actualStart = relativeStart < 0 ? max((len + relativeStart), 0) : min(relativeStart, len);
	            var actualDeleteCount = min(max(ES.ToInteger(deleteCount), 0), len - actualStart);
	
	            var k = 0;
	            var from;
	            while (k < actualDeleteCount) {
	                from = $String(actualStart + k);
	                if (owns(O, from)) {
	                    A[k] = O[from];
	                }
	                k += 1;
	            }
	
	            var items = arraySlice(arguments, 2);
	            var itemCount = items.length;
	            var to;
	            if (itemCount < actualDeleteCount) {
	                k = actualStart;
	                var maxK = len - actualDeleteCount;
	                while (k < maxK) {
	                    from = $String(k + actualDeleteCount);
	                    to = $String(k + itemCount);
	                    if (owns(O, from)) {
	                        O[to] = O[from];
	                    } else {
	                        delete O[to];
	                    }
	                    k += 1;
	                }
	                k = len;
	                var minK = len - actualDeleteCount + itemCount;
	                while (k > minK) {
	                    delete O[k - 1];
	                    k -= 1;
	                }
	            } else if (itemCount > actualDeleteCount) {
	                k = len - actualDeleteCount;
	                while (k > actualStart) {
	                    from = $String(k + actualDeleteCount - 1);
	                    to = $String(k + itemCount - 1);
	                    if (owns(O, from)) {
	                        O[to] = O[from];
	                    } else {
	                        delete O[to];
	                    }
	                    k -= 1;
	                }
	            }
	            k = actualStart;
	            for (var i = 0; i < items.length; ++i) {
	                O[k] = items[i];
	                k += 1;
	            }
	            O.length = len - actualDeleteCount + itemCount;
	
	            return A;
	        }
	    }, !spliceWorksWithLargeSparseArrays || !spliceWorksWithSmallSparseArrays);
	
	    var originalJoin = ArrayPrototype.join;
	    var hasStringJoinBug;
	    try {
	        hasStringJoinBug = Array.prototype.join.call('123', ',') !== '1,2,3';
	    } catch (e) {
	        hasStringJoinBug = true;
	    }
	    if (hasStringJoinBug) {
	        defineProperties(ArrayPrototype, {
	            join: function join(separator) {
	                var sep = typeof separator === 'undefined' ? ',' : separator;
	                return originalJoin.call(isString(this) ? strSplit(this, '') : this, sep);
	            }
	        }, hasStringJoinBug);
	    }
	
	    var hasJoinUndefinedBug = [1, 2].join(undefined) !== '1,2';
	    if (hasJoinUndefinedBug) {
	        defineProperties(ArrayPrototype, {
	            join: function join(separator) {
	                var sep = typeof separator === 'undefined' ? ',' : separator;
	                return originalJoin.call(this, sep);
	            }
	        }, hasJoinUndefinedBug);
	    }
	
	    var pushShim = function push(item) {
	        var O = ES.ToObject(this);
	        var n = ES.ToUint32(O.length);
	        var i = 0;
	        while (i < arguments.length) {
	            O[n + i] = arguments[i];
	            i += 1;
	        }
	        O.length = n + i;
	        return n + i;
	    };
	
	    var pushIsNotGeneric = (function () {
	        var obj = {};
	        var result = Array.prototype.push.call(obj, undefined);
	        return result !== 1 || obj.length !== 1 || typeof obj[0] !== 'undefined' || !owns(obj, 0);
	    }());
	    defineProperties(ArrayPrototype, {
	        push: function push(item) {
	            if (isArray(this)) {
	                return array_push.apply(this, arguments);
	            }
	            return pushShim.apply(this, arguments);
	        }
	    }, pushIsNotGeneric);
	
	    // This fixes a very weird bug in Opera 10.6 when pushing `undefined
	    var pushUndefinedIsWeird = (function () {
	        var arr = [];
	        var result = arr.push(undefined);
	        return result !== 1 || arr.length !== 1 || typeof arr[0] !== 'undefined' || !owns(arr, 0);
	    }());
	    defineProperties(ArrayPrototype, { push: pushShim }, pushUndefinedIsWeird);
	
	    // ES5 15.2.3.14
	    // http://es5.github.io/#x15.4.4.10
	    // Fix boxed string bug
	    defineProperties(ArrayPrototype, {
	        slice: function (start, end) {
	            var arr = isString(this) ? strSplit(this, '') : this;
	            return arraySliceApply(arr, arguments);
	        }
	    }, splitString);
	
	    var sortIgnoresNonFunctions = (function () {
	        try {
	            [1, 2].sort(null);
	            [1, 2].sort({});
	            return true;
	        } catch (e) {}
	        return false;
	    }());
	    var sortThrowsOnRegex = (function () {
	        // this is a problem in Firefox 4, in which `typeof /a/ === 'function'`
	        try {
	            [1, 2].sort(/a/);
	            return false;
	        } catch (e) {}
	        return true;
	    }());
	    var sortIgnoresUndefined = (function () {
	        // applies in IE 8, for one.
	        try {
	            [1, 2].sort(undefined);
	            return true;
	        } catch (e) {}
	        return false;
	    }());
	    defineProperties(ArrayPrototype, {
	        sort: function sort(compareFn) {
	            if (typeof compareFn === 'undefined') {
	                return arraySort(this);
	            }
	            if (!isCallable(compareFn)) {
	                throw new TypeError('Array.prototype.sort callback must be a function');
	            }
	            return arraySort(this, compareFn);
	        }
	    }, sortIgnoresNonFunctions || !sortIgnoresUndefined || !sortThrowsOnRegex);
	
	    //
	    // Object
	    // ======
	    //
	
	    // ES5 15.2.3.14
	    // http://es5.github.com/#x15.2.3.14
	
	    // http://whattheheadsaid.com/2010/10/a-safer-object-keys-compatibility-implementation
	    var hasDontEnumBug = !isEnum({ 'toString': null }, 'toString');
	    var hasProtoEnumBug = isEnum(function () {}, 'prototype');
	    var hasStringEnumBug = !owns('x', '0');
	    var equalsConstructorPrototype = function (o) {
	        var ctor = o.constructor;
	        return ctor && ctor.prototype === o;
	    };
	    var blacklistedKeys = {
	        $window: true,
	        $console: true,
	        $parent: true,
	        $self: true,
	        $frame: true,
	        $frames: true,
	        $frameElement: true,
	        $webkitIndexedDB: true,
	        $webkitStorageInfo: true,
	        $external: true
	    };
	    var hasAutomationEqualityBug = (function () {
	        /* globals window */
	        if (typeof window === 'undefined') {
	            return false;
	        }
	        for (var k in window) {
	            try {
	                if (!blacklistedKeys['$' + k] && owns(window, k) && window[k] !== null && typeof window[k] === 'object') {
	                    equalsConstructorPrototype(window[k]);
	                }
	            } catch (e) {
	                return true;
	            }
	        }
	        return false;
	    }());
	    var equalsConstructorPrototypeIfNotBuggy = function (object) {
	        if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
	            return equalsConstructorPrototype(object);
	        }
	        try {
	            return equalsConstructorPrototype(object);
	        } catch (e) {
	            return false;
	        }
	    };
	    var dontEnums = [
	        'toString',
	        'toLocaleString',
	        'valueOf',
	        'hasOwnProperty',
	        'isPrototypeOf',
	        'propertyIsEnumerable',
	        'constructor'
	    ];
	    var dontEnumsLength = dontEnums.length;
	
	    // taken directly from https://github.com/ljharb/is-arguments/blob/master/index.js
	    // can be replaced with require('is-arguments') if we ever use a build process instead
	    var isStandardArguments = function isArguments(value) {
	        return toStr(value) === '[object Arguments]';
	    };
	    var isLegacyArguments = function isArguments(value) {
	        return value !== null &&
	            typeof value === 'object' &&
	            typeof value.length === 'number' &&
	            value.length >= 0 &&
	            !isArray(value) &&
	            isCallable(value.callee);
	    };
	    var isArguments = isStandardArguments(arguments) ? isStandardArguments : isLegacyArguments;
	
	    defineProperties($Object, {
	        keys: function keys(object) {
	            var isFn = isCallable(object);
	            var isArgs = isArguments(object);
	            var isObject = object !== null && typeof object === 'object';
	            var isStr = isObject && isString(object);
	
	            if (!isObject && !isFn && !isArgs) {
	                throw new TypeError('Object.keys called on a non-object');
	            }
	
	            var theKeys = [];
	            var skipProto = hasProtoEnumBug && isFn;
	            if ((isStr && hasStringEnumBug) || isArgs) {
	                for (var i = 0; i < object.length; ++i) {
	                    pushCall(theKeys, $String(i));
	                }
	            }
	
	            if (!isArgs) {
	                for (var name in object) {
	                    if (!(skipProto && name === 'prototype') && owns(object, name)) {
	                        pushCall(theKeys, $String(name));
	                    }
	                }
	            }
	
	            if (hasDontEnumBug) {
	                var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	                for (var j = 0; j < dontEnumsLength; j++) {
	                    var dontEnum = dontEnums[j];
	                    if (!(skipConstructor && dontEnum === 'constructor') && owns(object, dontEnum)) {
	                        pushCall(theKeys, dontEnum);
	                    }
	                }
	            }
	            return theKeys;
	        }
	    });
	
	    var keysWorksWithArguments = $Object.keys && (function () {
	        // Safari 5.0 bug
	        return $Object.keys(arguments).length === 2;
	    }(1, 2));
	    var keysHasArgumentsLengthBug = $Object.keys && (function () {
	        var argKeys = $Object.keys(arguments);
	        return arguments.length !== 1 || argKeys.length !== 1 || argKeys[0] !== 1;
	    }(1));
	    var originalKeys = $Object.keys;
	    defineProperties($Object, {
	        keys: function keys(object) {
	            if (isArguments(object)) {
	                return originalKeys(arraySlice(object));
	            } else {
	                return originalKeys(object);
	            }
	        }
	    }, !keysWorksWithArguments || keysHasArgumentsLengthBug);
	
	    //
	    // Date
	    // ====
	    //
	
	    var hasNegativeMonthYearBug = new Date(-3509827329600292).getUTCMonth() !== 0;
	    var aNegativeTestDate = new Date(-1509842289600292);
	    var aPositiveTestDate = new Date(1449662400000);
	    var hasToUTCStringFormatBug = aNegativeTestDate.toUTCString() !== 'Mon, 01 Jan -45875 11:59:59 GMT';
	    var hasToDateStringFormatBug;
	    var hasToStringFormatBug;
	    var timeZoneOffset = aNegativeTestDate.getTimezoneOffset();
	    if (timeZoneOffset < -720) {
	        hasToDateStringFormatBug = aNegativeTestDate.toDateString() !== 'Tue Jan 02 -45875';
	        hasToStringFormatBug = !(/^Thu Dec 10 2015 \d\d:\d\d:\d\d GMT[-\+]\d\d\d\d(?: |$)/).test(aPositiveTestDate.toString());
	    } else {
	        hasToDateStringFormatBug = aNegativeTestDate.toDateString() !== 'Mon Jan 01 -45875';
	        hasToStringFormatBug = !(/^Wed Dec 09 2015 \d\d:\d\d:\d\d GMT[-\+]\d\d\d\d(?: |$)/).test(aPositiveTestDate.toString());
	    }
	
	    var originalGetFullYear = call.bind(Date.prototype.getFullYear);
	    var originalGetMonth = call.bind(Date.prototype.getMonth);
	    var originalGetDate = call.bind(Date.prototype.getDate);
	    var originalGetUTCFullYear = call.bind(Date.prototype.getUTCFullYear);
	    var originalGetUTCMonth = call.bind(Date.prototype.getUTCMonth);
	    var originalGetUTCDate = call.bind(Date.prototype.getUTCDate);
	    var originalGetUTCDay = call.bind(Date.prototype.getUTCDay);
	    var originalGetUTCHours = call.bind(Date.prototype.getUTCHours);
	    var originalGetUTCMinutes = call.bind(Date.prototype.getUTCMinutes);
	    var originalGetUTCSeconds = call.bind(Date.prototype.getUTCSeconds);
	    var originalGetUTCMilliseconds = call.bind(Date.prototype.getUTCMilliseconds);
	    var dayName = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	    var monthName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	    var daysInMonth = function daysInMonth(month, year) {
	        return originalGetDate(new Date(year, month, 0));
	    };
	
	    defineProperties(Date.prototype, {
	        getFullYear: function getFullYear() {
	            if (!this || !(this instanceof Date)) {
	                throw new TypeError('this is not a Date object.');
	            }
	            var year = originalGetFullYear(this);
	            if (year < 0 && originalGetMonth(this) > 11) {
	                return year + 1;
	            }
	            return year;
	        },
	        getMonth: function getMonth() {
	            if (!this || !(this instanceof Date)) {
	                throw new TypeError('this is not a Date object.');
	            }
	            var year = originalGetFullYear(this);
	            var month = originalGetMonth(this);
	            if (year < 0 && month > 11) {
	                return 0;
	            }
	            return month;
	        },
	        getDate: function getDate() {
	            if (!this || !(this instanceof Date)) {
	                throw new TypeError('this is not a Date object.');
	            }
	            var year = originalGetFullYear(this);
	            var month = originalGetMonth(this);
	            var date = originalGetDate(this);
	            if (year < 0 && month > 11) {
	                if (month === 12) {
	                    return date;
	                }
	                var days = daysInMonth(0, year + 1);
	                return (days - date) + 1;
	            }
	            return date;
	        },
	        getUTCFullYear: function getUTCFullYear() {
	            if (!this || !(this instanceof Date)) {
	                throw new TypeError('this is not a Date object.');
	            }
	            var year = originalGetUTCFullYear(this);
	            if (year < 0 && originalGetUTCMonth(this) > 11) {
	                return year + 1;
	            }
	            return year;
	        },
	        getUTCMonth: function getUTCMonth() {
	            if (!this || !(this instanceof Date)) {
	                throw new TypeError('this is not a Date object.');
	            }
	            var year = originalGetUTCFullYear(this);
	            var month = originalGetUTCMonth(this);
	            if (year < 0 && month > 11) {
	                return 0;
	            }
	            return month;
	        },
	        getUTCDate: function getUTCDate() {
	            if (!this || !(this instanceof Date)) {
	                throw new TypeError('this is not a Date object.');
	            }
	            var year = originalGetUTCFullYear(this);
	            var month = originalGetUTCMonth(this);
	            var date = originalGetUTCDate(this);
	            if (year < 0 && month > 11) {
	                if (month === 12) {
	                    return date;
	                }
	                var days = daysInMonth(0, year + 1);
	                return (days - date) + 1;
	            }
	            return date;
	        }
	    }, hasNegativeMonthYearBug);
	
	    defineProperties(Date.prototype, {
	        toUTCString: function toUTCString() {
	            if (!this || !(this instanceof Date)) {
	                throw new TypeError('this is not a Date object.');
	            }
	            var day = originalGetUTCDay(this);
	            var date = originalGetUTCDate(this);
	            var month = originalGetUTCMonth(this);
	            var year = originalGetUTCFullYear(this);
	            var hour = originalGetUTCHours(this);
	            var minute = originalGetUTCMinutes(this);
	            var second = originalGetUTCSeconds(this);
	            return dayName[day] + ', ' +
	                (date < 10 ? '0' + date : date) + ' ' +
	                monthName[month] + ' ' +
	                year + ' ' +
	                (hour < 10 ? '0' + hour : hour) + ':' +
	                (minute < 10 ? '0' + minute : minute) + ':' +
	                (second < 10 ? '0' + second : second) + ' GMT';
	        }
	    }, hasNegativeMonthYearBug || hasToUTCStringFormatBug);
	
	    // Opera 12 has `,`
	    defineProperties(Date.prototype, {
	        toDateString: function toDateString() {
	            if (!this || !(this instanceof Date)) {
	                throw new TypeError('this is not a Date object.');
	            }
	            var day = this.getDay();
	            var date = this.getDate();
	            var month = this.getMonth();
	            var year = this.getFullYear();
	            return dayName[day] + ' ' +
	                monthName[month] + ' ' +
	                (date < 10 ? '0' + date : date) + ' ' +
	                year;
	        }
	    }, hasNegativeMonthYearBug || hasToDateStringFormatBug);
	
	    // can't use defineProperties here because of toString enumeration issue in IE <= 8
	    if (hasNegativeMonthYearBug || hasToStringFormatBug) {
	        Date.prototype.toString = function toString() {
	            if (!this || !(this instanceof Date)) {
	                throw new TypeError('this is not a Date object.');
	            }
	            var day = this.getDay();
	            var date = this.getDate();
	            var month = this.getMonth();
	            var year = this.getFullYear();
	            var hour = this.getHours();
	            var minute = this.getMinutes();
	            var second = this.getSeconds();
	            var timezoneOffset = this.getTimezoneOffset();
	            var hoursOffset = Math.floor(Math.abs(timezoneOffset) / 60);
	            var minutesOffset = Math.floor(Math.abs(timezoneOffset) % 60);
	            return dayName[day] + ' ' +
	                monthName[month] + ' ' +
	                (date < 10 ? '0' + date : date) + ' ' +
	                year + ' ' +
	                (hour < 10 ? '0' + hour : hour) + ':' +
	                (minute < 10 ? '0' + minute : minute) + ':' +
	                (second < 10 ? '0' + second : second) + ' GMT' +
	                (timezoneOffset > 0 ? '-' : '+') +
	                (hoursOffset < 10 ? '0' + hoursOffset : hoursOffset) +
	                (minutesOffset < 10 ? '0' + minutesOffset : minutesOffset);
	        };
	        if (supportsDescriptors) {
	            $Object.defineProperty(Date.prototype, 'toString', {
	                configurable: true,
	                enumerable: false,
	                writable: true
	            });
	        }
	    }
	
	    // ES5 15.9.5.43
	    // http://es5.github.com/#x15.9.5.43
	    // This function returns a String value represent the instance in time
	    // represented by this Date object. The format of the String is the Date Time
	    // string format defined in 15.9.1.15. All fields are present in the String.
	    // The time zone is always UTC, denoted by the suffix Z. If the time value of
	    // this object is not a finite Number a RangeError exception is thrown.
	    var negativeDate = -62198755200000;
	    var negativeYearString = '-000001';
	    var hasNegativeDateBug = Date.prototype.toISOString && new Date(negativeDate).toISOString().indexOf(negativeYearString) === -1;
	    var hasSafari51DateBug = Date.prototype.toISOString && new Date(-1).toISOString() !== '1969-12-31T23:59:59.999Z';
	
	    var getTime = call.bind(Date.prototype.getTime);
	
	    defineProperties(Date.prototype, {
	        toISOString: function toISOString() {
	            if (!isFinite(this) || !isFinite(getTime(this))) {
	                // Adope Photoshop requires the second check.
	                throw new RangeError('Date.prototype.toISOString called on non-finite value.');
	            }
	
	            var year = originalGetUTCFullYear(this);
	
	            var month = originalGetUTCMonth(this);
	            // see https://github.com/es-shims/es5-shim/issues/111
	            year += Math.floor(month / 12);
	            month = (month % 12 + 12) % 12;
	
	            // the date time string format is specified in 15.9.1.15.
	            var result = [month + 1, originalGetUTCDate(this), originalGetUTCHours(this), originalGetUTCMinutes(this), originalGetUTCSeconds(this)];
	            year = (
	                (year < 0 ? '-' : (year > 9999 ? '+' : '')) +
	                strSlice('00000' + Math.abs(year), (0 <= year && year <= 9999) ? -4 : -6)
	            );
	
	            for (var i = 0; i < result.length; ++i) {
	                // pad months, days, hours, minutes, and seconds to have two digits.
	                result[i] = strSlice('00' + result[i], -2);
	            }
	            // pad milliseconds to have three digits.
	            return (
	                year + '-' + arraySlice(result, 0, 2).join('-') +
	                'T' + arraySlice(result, 2).join(':') + '.' +
	                strSlice('000' + originalGetUTCMilliseconds(this), -3) + 'Z'
	            );
	        }
	    }, hasNegativeDateBug || hasSafari51DateBug);
	
	    // ES5 15.9.5.44
	    // http://es5.github.com/#x15.9.5.44
	    // This function provides a String representation of a Date object for use by
	    // JSON.stringify (15.12.3).
	    var dateToJSONIsSupported = (function () {
	        try {
	            return Date.prototype.toJSON &&
	                new Date(NaN).toJSON() === null &&
	                new Date(negativeDate).toJSON().indexOf(negativeYearString) !== -1 &&
	                Date.prototype.toJSON.call({ // generic
	                    toISOString: function () { return true; }
	                });
	        } catch (e) {
	            return false;
	        }
	    }());
	    if (!dateToJSONIsSupported) {
	        Date.prototype.toJSON = function toJSON(key) {
	            // When the toJSON method is called with argument key, the following
	            // steps are taken:
	
	            // 1.  Let O be the result of calling ToObject, giving it the this
	            // value as its argument.
	            // 2. Let tv be ES.ToPrimitive(O, hint Number).
	            var O = $Object(this);
	            var tv = ES.ToPrimitive(O);
	            // 3. If tv is a Number and is not finite, return null.
	            if (typeof tv === 'number' && !isFinite(tv)) {
	                return null;
	            }
	            // 4. Let toISO be the result of calling the [[Get]] internal method of
	            // O with argument "toISOString".
	            var toISO = O.toISOString;
	            // 5. If IsCallable(toISO) is false, throw a TypeError exception.
	            if (!isCallable(toISO)) {
	                throw new TypeError('toISOString property is not callable');
	            }
	            // 6. Return the result of calling the [[Call]] internal method of
	            //  toISO with O as the this value and an empty argument list.
	            return toISO.call(O);
	
	            // NOTE 1 The argument is ignored.
	
	            // NOTE 2 The toJSON function is intentionally generic; it does not
	            // require that its this value be a Date object. Therefore, it can be
	            // transferred to other kinds of objects for use as a method. However,
	            // it does require that any such object have a toISOString method. An
	            // object is free to use the argument key to filter its
	            // stringification.
	        };
	    }
	
	    // ES5 15.9.4.2
	    // http://es5.github.com/#x15.9.4.2
	    // based on work shared by Daniel Friesen (dantman)
	    // http://gist.github.com/303249
	    var supportsExtendedYears = Date.parse('+033658-09-27T01:46:40.000Z') === 1e15;
	    var acceptsInvalidDates = !isNaN(Date.parse('2012-04-04T24:00:00.500Z')) || !isNaN(Date.parse('2012-11-31T23:59:59.000Z')) || !isNaN(Date.parse('2012-12-31T23:59:60.000Z'));
	    var doesNotParseY2KNewYear = isNaN(Date.parse('2000-01-01T00:00:00.000Z'));
	    if (doesNotParseY2KNewYear || acceptsInvalidDates || !supportsExtendedYears) {
	        // XXX global assignment won't work in embeddings that use
	        // an alternate object for the context.
	        /* global Date: true */
	        /* eslint-disable no-undef */
	        var maxSafeUnsigned32Bit = Math.pow(2, 31) - 1;
	        var hasSafariSignedIntBug = isActualNaN(new Date(1970, 0, 1, 0, 0, 0, maxSafeUnsigned32Bit + 1).getTime());
	        /* eslint-disable no-implicit-globals */
	        Date = (function (NativeDate) {
	        /* eslint-enable no-implicit-globals */
	        /* eslint-enable no-undef */
	            // Date.length === 7
	            var DateShim = function Date(Y, M, D, h, m, s, ms) {
	                var length = arguments.length;
	                var date;
	                if (this instanceof NativeDate) {
	                    var seconds = s;
	                    var millis = ms;
	                    if (hasSafariSignedIntBug && length >= 7 && ms > maxSafeUnsigned32Bit) {
	                        // work around a Safari 8/9 bug where it treats the seconds as signed
	                        var msToShift = Math.floor(ms / maxSafeUnsigned32Bit) * maxSafeUnsigned32Bit;
	                        var sToShift = Math.floor(msToShift / 1e3);
	                        seconds += sToShift;
	                        millis -= sToShift * 1e3;
	                    }
	                    date = length === 1 && $String(Y) === Y ? // isString(Y)
	                        // We explicitly pass it through parse:
	                        new NativeDate(DateShim.parse(Y)) :
	                        // We have to manually make calls depending on argument
	                        // length here
	                        length >= 7 ? new NativeDate(Y, M, D, h, m, seconds, millis) :
	                        length >= 6 ? new NativeDate(Y, M, D, h, m, seconds) :
	                        length >= 5 ? new NativeDate(Y, M, D, h, m) :
	                        length >= 4 ? new NativeDate(Y, M, D, h) :
	                        length >= 3 ? new NativeDate(Y, M, D) :
	                        length >= 2 ? new NativeDate(Y, M) :
	                        length >= 1 ? new NativeDate(Y instanceof NativeDate ? +Y : Y) :
	                                      new NativeDate();
	                } else {
	                    date = NativeDate.apply(this, arguments);
	                }
	                if (!isPrimitive(date)) {
	                    // Prevent mixups with unfixed Date object
	                    defineProperties(date, { constructor: DateShim }, true);
	                }
	                return date;
	            };
	
	            // 15.9.1.15 Date Time String Format.
	            var isoDateExpression = new RegExp('^' +
	                '(\\d{4}|[+-]\\d{6})' + // four-digit year capture or sign +
	                                          // 6-digit extended year
	                '(?:-(\\d{2})' + // optional month capture
	                '(?:-(\\d{2})' + // optional day capture
	                '(?:' + // capture hours:minutes:seconds.milliseconds
	                    'T(\\d{2})' + // hours capture
	                    ':(\\d{2})' + // minutes capture
	                    '(?:' + // optional :seconds.milliseconds
	                        ':(\\d{2})' + // seconds capture
	                        '(?:(\\.\\d{1,}))?' + // milliseconds capture
	                    ')?' +
	                '(' + // capture UTC offset component
	                    'Z|' + // UTC capture
	                    '(?:' + // offset specifier +/-hours:minutes
	                        '([-+])' + // sign capture
	                        '(\\d{2})' + // hours offset capture
	                        ':(\\d{2})' + // minutes offset capture
	                    ')' +
	                ')?)?)?)?' +
	            '$');
	
	            var months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365];
	
	            var dayFromMonth = function dayFromMonth(year, month) {
	                var t = month > 1 ? 1 : 0;
	                return (
	                    months[month] +
	                    Math.floor((year - 1969 + t) / 4) -
	                    Math.floor((year - 1901 + t) / 100) +
	                    Math.floor((year - 1601 + t) / 400) +
	                    365 * (year - 1970)
	                );
	            };
	
	            var toUTC = function toUTC(t) {
	                var s = 0;
	                var ms = t;
	                if (hasSafariSignedIntBug && ms > maxSafeUnsigned32Bit) {
	                    // work around a Safari 8/9 bug where it treats the seconds as signed
	                    var msToShift = Math.floor(ms / maxSafeUnsigned32Bit) * maxSafeUnsigned32Bit;
	                    var sToShift = Math.floor(msToShift / 1e3);
	                    s += sToShift;
	                    ms -= sToShift * 1e3;
	                }
	                return $Number(new NativeDate(1970, 0, 1, 0, 0, s, ms));
	            };
	
	            // Copy any custom methods a 3rd party library may have added
	            for (var key in NativeDate) {
	                if (owns(NativeDate, key)) {
	                    DateShim[key] = NativeDate[key];
	                }
	            }
	
	            // Copy "native" methods explicitly; they may be non-enumerable
	            defineProperties(DateShim, {
	                now: NativeDate.now,
	                UTC: NativeDate.UTC
	            }, true);
	            DateShim.prototype = NativeDate.prototype;
	            defineProperties(DateShim.prototype, {
	                constructor: DateShim
	            }, true);
	
	            // Upgrade Date.parse to handle simplified ISO 8601 strings
	            var parseShim = function parse(string) {
	                var match = isoDateExpression.exec(string);
	                if (match) {
	                    // parse months, days, hours, minutes, seconds, and milliseconds
	                    // provide default values if necessary
	                    // parse the UTC offset component
	                    var year = $Number(match[1]),
	                        month = $Number(match[2] || 1) - 1,
	                        day = $Number(match[3] || 1) - 1,
	                        hour = $Number(match[4] || 0),
	                        minute = $Number(match[5] || 0),
	                        second = $Number(match[6] || 0),
	                        millisecond = Math.floor($Number(match[7] || 0) * 1000),
	                        // When time zone is missed, local offset should be used
	                        // (ES 5.1 bug)
	                        // see https://bugs.ecmascript.org/show_bug.cgi?id=112
	                        isLocalTime = Boolean(match[4] && !match[8]),
	                        signOffset = match[9] === '-' ? 1 : -1,
	                        hourOffset = $Number(match[10] || 0),
	                        minuteOffset = $Number(match[11] || 0),
	                        result;
	                    var hasMinutesOrSecondsOrMilliseconds = minute > 0 || second > 0 || millisecond > 0;
	                    if (
	                        hour < (hasMinutesOrSecondsOrMilliseconds ? 24 : 25) &&
	                        minute < 60 && second < 60 && millisecond < 1000 &&
	                        month > -1 && month < 12 && hourOffset < 24 &&
	                        minuteOffset < 60 && // detect invalid offsets
	                        day > -1 &&
	                        day < (dayFromMonth(year, month + 1) - dayFromMonth(year, month))
	                    ) {
	                        result = (
	                            (dayFromMonth(year, month) + day) * 24 +
	                            hour +
	                            hourOffset * signOffset
	                        ) * 60;
	                        result = (
	                            (result + minute + minuteOffset * signOffset) * 60 +
	                            second
	                        ) * 1000 + millisecond;
	                        if (isLocalTime) {
	                            result = toUTC(result);
	                        }
	                        if (-8.64e15 <= result && result <= 8.64e15) {
	                            return result;
	                        }
	                    }
	                    return NaN;
	                }
	                return NativeDate.parse.apply(this, arguments);
	            };
	            defineProperties(DateShim, { parse: parseShim });
	
	            return DateShim;
	        }(Date));
	        /* global Date: false */
	    }
	
	    // ES5 15.9.4.4
	    // http://es5.github.com/#x15.9.4.4
	    if (!Date.now) {
	        Date.now = function now() {
	            return new Date().getTime();
	        };
	    }
	
	    //
	    // Number
	    // ======
	    //
	
	    // ES5.1 15.7.4.5
	    // http://es5.github.com/#x15.7.4.5
	    var hasToFixedBugs = NumberPrototype.toFixed && (
	      (0.00008).toFixed(3) !== '0.000' ||
	      (0.9).toFixed(0) !== '1' ||
	      (1.255).toFixed(2) !== '1.25' ||
	      (1000000000000000128).toFixed(0) !== '1000000000000000128'
	    );
	
	    var toFixedHelpers = {
	        base: 1e7,
	        size: 6,
	        data: [0, 0, 0, 0, 0, 0],
	        multiply: function multiply(n, c) {
	            var i = -1;
	            var c2 = c;
	            while (++i < toFixedHelpers.size) {
	                c2 += n * toFixedHelpers.data[i];
	                toFixedHelpers.data[i] = c2 % toFixedHelpers.base;
	                c2 = Math.floor(c2 / toFixedHelpers.base);
	            }
	        },
	        divide: function divide(n) {
	            var i = toFixedHelpers.size;
	            var c = 0;
	            while (--i >= 0) {
	                c += toFixedHelpers.data[i];
	                toFixedHelpers.data[i] = Math.floor(c / n);
	                c = (c % n) * toFixedHelpers.base;
	            }
	        },
	        numToString: function numToString() {
	            var i = toFixedHelpers.size;
	            var s = '';
	            while (--i >= 0) {
	                if (s !== '' || i === 0 || toFixedHelpers.data[i] !== 0) {
	                    var t = $String(toFixedHelpers.data[i]);
	                    if (s === '') {
	                        s = t;
	                    } else {
	                        s += strSlice('0000000', 0, 7 - t.length) + t;
	                    }
	                }
	            }
	            return s;
	        },
	        pow: function pow(x, n, acc) {
	            return (n === 0 ? acc : (n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc)));
	        },
	        log: function log(x) {
	            var n = 0;
	            var x2 = x;
	            while (x2 >= 4096) {
	                n += 12;
	                x2 /= 4096;
	            }
	            while (x2 >= 2) {
	                n += 1;
	                x2 /= 2;
	            }
	            return n;
	        }
	    };
	
	    var toFixedShim = function toFixed(fractionDigits) {
	        var f, x, s, m, e, z, j, k;
	
	        // Test for NaN and round fractionDigits down
	        f = $Number(fractionDigits);
	        f = isActualNaN(f) ? 0 : Math.floor(f);
	
	        if (f < 0 || f > 20) {
	            throw new RangeError('Number.toFixed called with invalid number of decimals');
	        }
	
	        x = $Number(this);
	
	        if (isActualNaN(x)) {
	            return 'NaN';
	        }
	
	        // If it is too big or small, return the string value of the number
	        if (x <= -1e21 || x >= 1e21) {
	            return $String(x);
	        }
	
	        s = '';
	
	        if (x < 0) {
	            s = '-';
	            x = -x;
	        }
	
	        m = '0';
	
	        if (x > 1e-21) {
	            // 1e-21 < x < 1e21
	            // -70 < log2(x) < 70
	            e = toFixedHelpers.log(x * toFixedHelpers.pow(2, 69, 1)) - 69;
	            z = (e < 0 ? x * toFixedHelpers.pow(2, -e, 1) : x / toFixedHelpers.pow(2, e, 1));
	            z *= 0x10000000000000; // Math.pow(2, 52);
	            e = 52 - e;
	
	            // -18 < e < 122
	            // x = z / 2 ^ e
	            if (e > 0) {
	                toFixedHelpers.multiply(0, z);
	                j = f;
	
	                while (j >= 7) {
	                    toFixedHelpers.multiply(1e7, 0);
	                    j -= 7;
	                }
	
	                toFixedHelpers.multiply(toFixedHelpers.pow(10, j, 1), 0);
	                j = e - 1;
	
	                while (j >= 23) {
	                    toFixedHelpers.divide(1 << 23);
	                    j -= 23;
	                }
	
	                toFixedHelpers.divide(1 << j);
	                toFixedHelpers.multiply(1, 1);
	                toFixedHelpers.divide(2);
	                m = toFixedHelpers.numToString();
	            } else {
	                toFixedHelpers.multiply(0, z);
	                toFixedHelpers.multiply(1 << (-e), 0);
	                m = toFixedHelpers.numToString() + strSlice('0.00000000000000000000', 2, 2 + f);
	            }
	        }
	
	        if (f > 0) {
	            k = m.length;
	
	            if (k <= f) {
	                m = s + strSlice('0.0000000000000000000', 0, f - k + 2) + m;
	            } else {
	                m = s + strSlice(m, 0, k - f) + '.' + strSlice(m, k - f);
	            }
	        } else {
	            m = s + m;
	        }
	
	        return m;
	    };
	    defineProperties(NumberPrototype, { toFixed: toFixedShim }, hasToFixedBugs);
	
	    var hasToPrecisionUndefinedBug = (function () {
	        try {
	            return 1.0.toPrecision(undefined) === '1';
	        } catch (e) {
	            return true;
	        }
	    }());
	    var originalToPrecision = NumberPrototype.toPrecision;
	    defineProperties(NumberPrototype, {
	        toPrecision: function toPrecision(precision) {
	            return typeof precision === 'undefined' ? originalToPrecision.call(this) : originalToPrecision.call(this, precision);
	        }
	    }, hasToPrecisionUndefinedBug);
	
	    //
	    // String
	    // ======
	    //
	
	    // ES5 15.5.4.14
	    // http://es5.github.com/#x15.5.4.14
	
	    // [bugfix, IE lt 9, firefox 4, Konqueror, Opera, obscure browsers]
	    // Many browsers do not split properly with regular expressions or they
	    // do not perform the split correctly under obscure conditions.
	    // See http://blog.stevenlevithan.com/archives/cross-browser-split
	    // I've tested in many browsers and this seems to cover the deviant ones:
	    //    'ab'.split(/(?:ab)*/) should be ["", ""], not [""]
	    //    '.'.split(/(.?)(.?)/) should be ["", ".", "", ""], not ["", ""]
	    //    'tesst'.split(/(s)*/) should be ["t", undefined, "e", "s", "t"], not
	    //       [undefined, "t", undefined, "e", ...]
	    //    ''.split(/.?/) should be [], not [""]
	    //    '.'.split(/()()/) should be ["."], not ["", "", "."]
	
	    if (
	        'ab'.split(/(?:ab)*/).length !== 2 ||
	        '.'.split(/(.?)(.?)/).length !== 4 ||
	        'tesst'.split(/(s)*/)[1] === 't' ||
	        'test'.split(/(?:)/, -1).length !== 4 ||
	        ''.split(/.?/).length ||
	        '.'.split(/()()/).length > 1
	    ) {
	        (function () {
	            var compliantExecNpcg = typeof (/()??/).exec('')[1] === 'undefined'; // NPCG: nonparticipating capturing group
	            var maxSafe32BitInt = Math.pow(2, 32) - 1;
	
	            StringPrototype.split = function (separator, limit) {
	                var string = String(this);
	                if (typeof separator === 'undefined' && limit === 0) {
	                    return [];
	                }
	
	                // If `separator` is not a regex, use native split
	                if (!isRegex(separator)) {
	                    return strSplit(this, separator, limit);
	                }
	
	                var output = [];
	                var flags = (separator.ignoreCase ? 'i' : '') +
	                            (separator.multiline ? 'm' : '') +
	                            (separator.unicode ? 'u' : '') + // in ES6
	                            (separator.sticky ? 'y' : ''), // Firefox 3+ and ES6
	                    lastLastIndex = 0,
	                    // Make `global` and avoid `lastIndex` issues by working with a copy
	                    separator2, match, lastIndex, lastLength;
	                var separatorCopy = new RegExp(separator.source, flags + 'g');
	                if (!compliantExecNpcg) {
	                    // Doesn't need flags gy, but they don't hurt
	                    separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	                }
	                /* Values for `limit`, per the spec:
	                 * If undefined: 4294967295 // maxSafe32BitInt
	                 * If 0, Infinity, or NaN: 0
	                 * If positive number: limit = Math.floor(limit); if (limit > 4294967295) limit -= 4294967296;
	                 * If negative number: 4294967296 - Math.floor(Math.abs(limit))
	                 * If other: Type-convert, then use the above rules
	                 */
	                var splitLimit = typeof limit === 'undefined' ? maxSafe32BitInt : ES.ToUint32(limit);
	                match = separatorCopy.exec(string);
	                while (match) {
	                    // `separatorCopy.lastIndex` is not reliable cross-browser
	                    lastIndex = match.index + match[0].length;
	                    if (lastIndex > lastLastIndex) {
	                        pushCall(output, strSlice(string, lastLastIndex, match.index));
	                        // Fix browsers whose `exec` methods don't consistently return `undefined` for
	                        // nonparticipating capturing groups
	                        if (!compliantExecNpcg && match.length > 1) {
	                            /* eslint-disable no-loop-func */
	                            match[0].replace(separator2, function () {
	                                for (var i = 1; i < arguments.length - 2; i++) {
	                                    if (typeof arguments[i] === 'undefined') {
	                                        match[i] = void 0;
	                                    }
	                                }
	                            });
	                            /* eslint-enable no-loop-func */
	                        }
	                        if (match.length > 1 && match.index < string.length) {
	                            array_push.apply(output, arraySlice(match, 1));
	                        }
	                        lastLength = match[0].length;
	                        lastLastIndex = lastIndex;
	                        if (output.length >= splitLimit) {
	                            break;
	                        }
	                    }
	                    if (separatorCopy.lastIndex === match.index) {
	                        separatorCopy.lastIndex++; // Avoid an infinite loop
	                    }
	                    match = separatorCopy.exec(string);
	                }
	                if (lastLastIndex === string.length) {
	                    if (lastLength || !separatorCopy.test('')) {
	                        pushCall(output, '');
	                    }
	                } else {
	                    pushCall(output, strSlice(string, lastLastIndex));
	                }
	                return output.length > splitLimit ? arraySlice(output, 0, splitLimit) : output;
	            };
	        }());
	
	    // [bugfix, chrome]
	    // If separator is undefined, then the result array contains just one String,
	    // which is the this value (converted to a String). If limit is not undefined,
	    // then the output array is truncated so that it contains no more than limit
	    // elements.
	    // "0".split(undefined, 0) -> []
	    } else if ('0'.split(void 0, 0).length) {
	        StringPrototype.split = function split(separator, limit) {
	            if (typeof separator === 'undefined' && limit === 0) {
	                return [];
	            }
	            return strSplit(this, separator, limit);
	        };
	    }
	
	    var str_replace = StringPrototype.replace;
	    var replaceReportsGroupsCorrectly = (function () {
	        var groups = [];
	        'x'.replace(/x(.)?/g, function (match, group) {
	            pushCall(groups, group);
	        });
	        return groups.length === 1 && typeof groups[0] === 'undefined';
	    }());
	
	    if (!replaceReportsGroupsCorrectly) {
	        StringPrototype.replace = function replace(searchValue, replaceValue) {
	            var isFn = isCallable(replaceValue);
	            var hasCapturingGroups = isRegex(searchValue) && (/\)[*?]/).test(searchValue.source);
	            if (!isFn || !hasCapturingGroups) {
	                return str_replace.call(this, searchValue, replaceValue);
	            } else {
	                var wrappedReplaceValue = function (match) {
	                    var length = arguments.length;
	                    var originalLastIndex = searchValue.lastIndex;
	                    searchValue.lastIndex = 0;
	                    var args = searchValue.exec(match) || [];
	                    searchValue.lastIndex = originalLastIndex;
	                    pushCall(args, arguments[length - 2], arguments[length - 1]);
	                    return replaceValue.apply(this, args);
	                };
	                return str_replace.call(this, searchValue, wrappedReplaceValue);
	            }
	        };
	    }
	
	    // ECMA-262, 3rd B.2.3
	    // Not an ECMAScript standard, although ECMAScript 3rd Edition has a
	    // non-normative section suggesting uniform semantics and it should be
	    // normalized across all browsers
	    // [bugfix, IE lt 9] IE < 9 substr() with negative value not working in IE
	    var string_substr = StringPrototype.substr;
	    var hasNegativeSubstrBug = ''.substr && '0b'.substr(-1) !== 'b';
	    defineProperties(StringPrototype, {
	        substr: function substr(start, length) {
	            var normalizedStart = start;
	            if (start < 0) {
	                normalizedStart = max(this.length + start, 0);
	            }
	            return string_substr.call(this, normalizedStart, length);
	        }
	    }, hasNegativeSubstrBug);
	
	    // ES5 15.5.4.20
	    // whitespace from: http://es5.github.io/#x15.5.4.20
	    var ws = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	        '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028' +
	        '\u2029\uFEFF';
	    var zeroWidth = '\u200b';
	    var wsRegexChars = '[' + ws + ']';
	    var trimBeginRegexp = new RegExp('^' + wsRegexChars + wsRegexChars + '*');
	    var trimEndRegexp = new RegExp(wsRegexChars + wsRegexChars + '*$');
	    var hasTrimWhitespaceBug = StringPrototype.trim && (ws.trim() || !zeroWidth.trim());
	    defineProperties(StringPrototype, {
	        // http://blog.stevenlevithan.com/archives/faster-trim-javascript
	        // http://perfectionkills.com/whitespace-deviations/
	        trim: function trim() {
	            if (typeof this === 'undefined' || this === null) {
	                throw new TypeError("can't convert " + this + ' to object');
	            }
	            return $String(this).replace(trimBeginRegexp, '').replace(trimEndRegexp, '');
	        }
	    }, hasTrimWhitespaceBug);
	    var trim = call.bind(String.prototype.trim);
	
	    var hasLastIndexBug = StringPrototype.lastIndexOf && 'abcあい'.lastIndexOf('あい', 2) !== -1;
	    defineProperties(StringPrototype, {
	        lastIndexOf: function lastIndexOf(searchString) {
	            if (typeof this === 'undefined' || this === null) {
	                throw new TypeError("can't convert " + this + ' to object');
	            }
	            var S = $String(this);
	            var searchStr = $String(searchString);
	            var numPos = arguments.length > 1 ? $Number(arguments[1]) : NaN;
	            var pos = isActualNaN(numPos) ? Infinity : ES.ToInteger(numPos);
	            var start = min(max(pos, 0), S.length);
	            var searchLen = searchStr.length;
	            var k = start + searchLen;
	            while (k > 0) {
	                k = max(0, k - searchLen);
	                var index = strIndexOf(strSlice(S, k, start + searchLen), searchStr);
	                if (index !== -1) {
	                    return k + index;
	                }
	            }
	            return -1;
	        }
	    }, hasLastIndexBug);
	
	    var originalLastIndexOf = StringPrototype.lastIndexOf;
	    defineProperties(StringPrototype, {
	        lastIndexOf: function lastIndexOf(searchString) {
	            return originalLastIndexOf.apply(this, arguments);
	        }
	    }, StringPrototype.lastIndexOf.length !== 1);
	
	    // ES-5 15.1.2.2
	    /* eslint-disable radix */
	    if (parseInt(ws + '08') !== 8 || parseInt(ws + '0x16') !== 22) {
	    /* eslint-enable radix */
	        /* global parseInt: true */
	        parseInt = (function (origParseInt) {
	            var hexRegex = /^[\-+]?0[xX]/;
	            return function parseInt(str, radix) {
	                var string = trim(String(str));
	                var defaultedRadix = $Number(radix) || (hexRegex.test(string) ? 16 : 10);
	                return origParseInt(string, defaultedRadix);
	            };
	        }(parseInt));
	    }
	
	    // https://es5.github.io/#x15.1.2.3
	    if (1 / parseFloat('-0') !== -Infinity) {
	        /* global parseFloat: true */
	        parseFloat = (function (origParseFloat) {
	            return function parseFloat(string) {
	                var inputString = trim(String(string));
	                var result = origParseFloat(inputString);
	                return result === 0 && strSlice(inputString, 0, 1) === '-' ? -0 : result;
	            };
	        }(parseFloat));
	    }
	
	    if (String(new RangeError('test')) !== 'RangeError: test') {
	        var errorToStringShim = function toString() {
	            if (typeof this === 'undefined' || this === null) {
	                throw new TypeError("can't convert " + this + ' to object');
	            }
	            var name = this.name;
	            if (typeof name === 'undefined') {
	                name = 'Error';
	            } else if (typeof name !== 'string') {
	                name = $String(name);
	            }
	            var msg = this.message;
	            if (typeof msg === 'undefined') {
	                msg = '';
	            } else if (typeof msg !== 'string') {
	                msg = $String(msg);
	            }
	            if (!name) {
	                return msg;
	            }
	            if (!msg) {
	                return name;
	            }
	            return name + ': ' + msg;
	        };
	        // can't use defineProperties here because of toString enumeration issue in IE <= 8
	        Error.prototype.toString = errorToStringShim;
	    }
	
	    if (supportsDescriptors) {
	        var ensureNonEnumerable = function (obj, prop) {
	            if (isEnum(obj, prop)) {
	                var desc = Object.getOwnPropertyDescriptor(obj, prop);
	                if (desc.configurable) {
	                    desc.enumerable = false;
	                    Object.defineProperty(obj, prop, desc);
	                }
	            }
	        };
	        ensureNonEnumerable(Error.prototype, 'message');
	        if (Error.prototype.message !== '') {
	            Error.prototype.message = '';
	        }
	        ensureNonEnumerable(Error.prototype, 'name');
	    }
	
	    if (String(/a/mig) !== '/a/gim') {
	        var regexToString = function toString() {
	            var str = '/' + this.source + '/';
	            if (this.global) {
	                str += 'g';
	            }
	            if (this.ignoreCase) {
	                str += 'i';
	            }
	            if (this.multiline) {
	                str += 'm';
	            }
	            return str;
	        };
	        // can't use defineProperties here because of toString enumeration issue in IE <= 8
	        RegExp.prototype.toString = regexToString;
	    }
	}));


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * https://github.com/es-shims/es5-shim
	 * @license es5-shim Copyright 2009-2015 by contributors, MIT License
	 * see https://github.com/es-shims/es5-shim/blob/master/LICENSE
	 */
	
	// vim: ts=4 sts=4 sw=4 expandtab
	
	// Add semicolon to prevent IIFE from being passed as argument to concatenated code.
	;
	
	// UMD (Universal Module Definition)
	// see https://github.com/umdjs/umd/blob/master/templates/returnExports.js
	(function (root, factory) {
	    'use strict';
	
	    /* global define, exports, module */
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like enviroments that support module.exports,
	        // like Node.
	        module.exports = factory();
	    } else {
	        // Browser globals (root is window)
	        root.returnExports = factory();
	    }
	}(this, function () {
	
	    var call = Function.call;
	    var prototypeOfObject = Object.prototype;
	    var owns = call.bind(prototypeOfObject.hasOwnProperty);
	    var isEnumerable = call.bind(prototypeOfObject.propertyIsEnumerable);
	    var toStr = call.bind(prototypeOfObject.toString);
	
	    // If JS engine supports accessors creating shortcuts.
	    var defineGetter;
	    var defineSetter;
	    var lookupGetter;
	    var lookupSetter;
	    var supportsAccessors = owns(prototypeOfObject, '__defineGetter__');
	    if (supportsAccessors) {
	        /* eslint-disable no-underscore-dangle */
	        defineGetter = call.bind(prototypeOfObject.__defineGetter__);
	        defineSetter = call.bind(prototypeOfObject.__defineSetter__);
	        lookupGetter = call.bind(prototypeOfObject.__lookupGetter__);
	        lookupSetter = call.bind(prototypeOfObject.__lookupSetter__);
	        /* eslint-enable no-underscore-dangle */
	    }
	
	    var isPrimitive = function isPrimitive(o) {
	        return o == null || (typeof o !== 'object' && typeof o !== 'function');
	    };
	
	    // ES5 15.2.3.2
	    // http://es5.github.com/#x15.2.3.2
	    if (!Object.getPrototypeOf) {
	        // https://github.com/es-shims/es5-shim/issues#issue/2
	        // http://ejohn.org/blog/objectgetprototypeof/
	        // recommended by fschaefer on github
	        //
	        // sure, and webreflection says ^_^
	        // ... this will nerever possibly return null
	        // ... Opera Mini breaks here with infinite loops
	        Object.getPrototypeOf = function getPrototypeOf(object) {
	            /* eslint-disable no-proto */
	            var proto = object.__proto__;
	            /* eslint-enable no-proto */
	            if (proto || proto === null) {
	                return proto;
	            } else if (toStr(object.constructor) === '[object Function]') {
	                return object.constructor.prototype;
	            } else if (object instanceof Object) {
	                return prototypeOfObject;
	            } else {
	                // Correctly return null for Objects created with `Object.create(null)`
	                // (shammed or native) or `{ __proto__: null}`.  Also returns null for
	                // cross-realm objects on browsers that lack `__proto__` support (like
	                // IE <11), but that's the best we can do.
	                return null;
	            }
	        };
	    }
	
	    // ES5 15.2.3.3
	    // http://es5.github.com/#x15.2.3.3
	
	    var doesGetOwnPropertyDescriptorWork = function doesGetOwnPropertyDescriptorWork(object) {
	        try {
	            object.sentinel = 0;
	            return Object.getOwnPropertyDescriptor(object, 'sentinel').value === 0;
	        } catch (exception) {
	            return false;
	        }
	    };
	
	    // check whether getOwnPropertyDescriptor works if it's given. Otherwise, shim partially.
	    if (Object.defineProperty) {
	        var getOwnPropertyDescriptorWorksOnObject = doesGetOwnPropertyDescriptorWork({});
	        var getOwnPropertyDescriptorWorksOnDom = typeof document === 'undefined' ||
	        doesGetOwnPropertyDescriptorWork(document.createElement('div'));
	        if (!getOwnPropertyDescriptorWorksOnDom || !getOwnPropertyDescriptorWorksOnObject) {
	            var getOwnPropertyDescriptorFallback = Object.getOwnPropertyDescriptor;
	        }
	    }
	
	    if (!Object.getOwnPropertyDescriptor || getOwnPropertyDescriptorFallback) {
	        var ERR_NON_OBJECT = 'Object.getOwnPropertyDescriptor called on a non-object: ';
	
	        /* eslint-disable no-proto */
	        Object.getOwnPropertyDescriptor = function getOwnPropertyDescriptor(object, property) {
	            if (isPrimitive(object)) {
	                throw new TypeError(ERR_NON_OBJECT + object);
	            }
	
	            // make a valiant attempt to use the real getOwnPropertyDescriptor
	            // for I8's DOM elements.
	            if (getOwnPropertyDescriptorFallback) {
	                try {
	                    return getOwnPropertyDescriptorFallback.call(Object, object, property);
	                } catch (exception) {
	                    // try the shim if the real one doesn't work
	                }
	            }
	
	            var descriptor;
	
	            // If object does not owns property return undefined immediately.
	            if (!owns(object, property)) {
	                return descriptor;
	            }
	
	            // If object has a property then it's for sure `configurable`, and
	            // probably `enumerable`. Detect enumerability though.
	            descriptor = {
	                enumerable: isEnumerable(object, property),
	                configurable: true
	            };
	
	            // If JS engine supports accessor properties then property may be a
	            // getter or setter.
	            if (supportsAccessors) {
	                // Unfortunately `__lookupGetter__` will return a getter even
	                // if object has own non getter property along with a same named
	                // inherited getter. To avoid misbehavior we temporary remove
	                // `__proto__` so that `__lookupGetter__` will return getter only
	                // if it's owned by an object.
	                var prototype = object.__proto__;
	                var notPrototypeOfObject = object !== prototypeOfObject;
	                // avoid recursion problem, breaking in Opera Mini when
	                // Object.getOwnPropertyDescriptor(Object.prototype, 'toString')
	                // or any other Object.prototype accessor
	                if (notPrototypeOfObject) {
	                    object.__proto__ = prototypeOfObject;
	                }
	
	                var getter = lookupGetter(object, property);
	                var setter = lookupSetter(object, property);
	
	                if (notPrototypeOfObject) {
	                    // Once we have getter and setter we can put values back.
	                    object.__proto__ = prototype;
	                }
	
	                if (getter || setter) {
	                    if (getter) {
	                        descriptor.get = getter;
	                    }
	                    if (setter) {
	                        descriptor.set = setter;
	                    }
	                    // If it was accessor property we're done and return here
	                    // in order to avoid adding `value` to the descriptor.
	                    return descriptor;
	                }
	            }
	
	            // If we got this far we know that object has an own property that is
	            // not an accessor so we set it as a value and return descriptor.
	            descriptor.value = object[property];
	            descriptor.writable = true;
	            return descriptor;
	        };
	        /* eslint-enable no-proto */
	    }
	
	    // ES5 15.2.3.4
	    // http://es5.github.com/#x15.2.3.4
	    if (!Object.getOwnPropertyNames) {
	        Object.getOwnPropertyNames = function getOwnPropertyNames(object) {
	            return Object.keys(object);
	        };
	    }
	
	    // ES5 15.2.3.5
	    // http://es5.github.com/#x15.2.3.5
	    if (!Object.create) {
	
	        // Contributed by Brandon Benvie, October, 2012
	        var createEmpty;
	        var supportsProto = !({ __proto__: null } instanceof Object);
	                            // the following produces false positives
	                            // in Opera Mini => not a reliable check
	                            // Object.prototype.__proto__ === null
	
	        // Check for document.domain and active x support
	        // No need to use active x approach when document.domain is not set
	        // see https://github.com/es-shims/es5-shim/issues/150
	        // variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
	        /* global ActiveXObject */
	        var shouldUseActiveX = function shouldUseActiveX() {
	            // return early if document.domain not set
	            if (!document.domain) {
	                return false;
	            }
	
	            try {
	                return !!new ActiveXObject('htmlfile');
	            } catch (exception) {
	                return false;
	            }
	        };
	
	        // This supports IE8 when document.domain is used
	        // see https://github.com/es-shims/es5-shim/issues/150
	        // variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
	        var getEmptyViaActiveX = function getEmptyViaActiveX() {
	            var empty;
	            var xDoc;
	
	            xDoc = new ActiveXObject('htmlfile');
	
	            var script = 'script';
	            xDoc.write('<' + script + '></' + script + '>');
	            xDoc.close();
	
	            empty = xDoc.parentWindow.Object.prototype;
	            xDoc = null;
	
	            return empty;
	        };
	
	        // The original implementation using an iframe
	        // before the activex approach was added
	        // see https://github.com/es-shims/es5-shim/issues/150
	        var getEmptyViaIFrame = function getEmptyViaIFrame() {
	            var iframe = document.createElement('iframe');
	            var parent = document.body || document.documentElement;
	            var empty;
	
	            iframe.style.display = 'none';
	            parent.appendChild(iframe);
	            /* eslint-disable no-script-url */
	            iframe.src = 'javascript:';
	            /* eslint-enable no-script-url */
	
	            empty = iframe.contentWindow.Object.prototype;
	            parent.removeChild(iframe);
	            iframe = null;
	
	            return empty;
	        };
	
	        /* global document */
	        if (supportsProto || typeof document === 'undefined') {
	            createEmpty = function () {
	                return { __proto__: null };
	            };
	        } else {
	            // In old IE __proto__ can't be used to manually set `null`, nor does
	            // any other method exist to make an object that inherits from nothing,
	            // aside from Object.prototype itself. Instead, create a new global
	            // object and *steal* its Object.prototype and strip it bare. This is
	            // used as the prototype to create nullary objects.
	            createEmpty = function () {
	                // Determine which approach to use
	                // see https://github.com/es-shims/es5-shim/issues/150
	                var empty = shouldUseActiveX() ? getEmptyViaActiveX() : getEmptyViaIFrame();
	
	                delete empty.constructor;
	                delete empty.hasOwnProperty;
	                delete empty.propertyIsEnumerable;
	                delete empty.isPrototypeOf;
	                delete empty.toLocaleString;
	                delete empty.toString;
	                delete empty.valueOf;
	
	                var Empty = function Empty() {};
	                Empty.prototype = empty;
	                // short-circuit future calls
	                createEmpty = function () {
	                    return new Empty();
	                };
	                return new Empty();
	            };
	        }
	
	        Object.create = function create(prototype, properties) {
	
	            var object;
	            var Type = function Type() {}; // An empty constructor.
	
	            if (prototype === null) {
	                object = createEmpty();
	            } else {
	                if (prototype !== null && isPrimitive(prototype)) {
	                    // In the native implementation `parent` can be `null`
	                    // OR *any* `instanceof Object`  (Object|Function|Array|RegExp|etc)
	                    // Use `typeof` tho, b/c in old IE, DOM elements are not `instanceof Object`
	                    // like they are in modern browsers. Using `Object.create` on DOM elements
	                    // is...err...probably inappropriate, but the native version allows for it.
	                    throw new TypeError('Object prototype may only be an Object or null'); // same msg as Chrome
	                }
	                Type.prototype = prototype;
	                object = new Type();
	                // IE has no built-in implementation of `Object.getPrototypeOf`
	                // neither `__proto__`, but this manually setting `__proto__` will
	                // guarantee that `Object.getPrototypeOf` will work as expected with
	                // objects created using `Object.create`
	                /* eslint-disable no-proto */
	                object.__proto__ = prototype;
	                /* eslint-enable no-proto */
	            }
	
	            if (properties !== void 0) {
	                Object.defineProperties(object, properties);
	            }
	
	            return object;
	        };
	    }
	
	    // ES5 15.2.3.6
	    // http://es5.github.com/#x15.2.3.6
	
	    // Patch for WebKit and IE8 standard mode
	    // Designed by hax <hax.github.com>
	    // related issue: https://github.com/es-shims/es5-shim/issues#issue/5
	    // IE8 Reference:
	    //     http://msdn.microsoft.com/en-us/library/dd282900.aspx
	    //     http://msdn.microsoft.com/en-us/library/dd229916.aspx
	    // WebKit Bugs:
	    //     https://bugs.webkit.org/show_bug.cgi?id=36423
	
	    var doesDefinePropertyWork = function doesDefinePropertyWork(object) {
	        try {
	            Object.defineProperty(object, 'sentinel', {});
	            return 'sentinel' in object;
	        } catch (exception) {
	            return false;
	        }
	    };
	
	    // check whether defineProperty works if it's given. Otherwise,
	    // shim partially.
	    if (Object.defineProperty) {
	        var definePropertyWorksOnObject = doesDefinePropertyWork({});
	        var definePropertyWorksOnDom = typeof document === 'undefined' ||
	            doesDefinePropertyWork(document.createElement('div'));
	        if (!definePropertyWorksOnObject || !definePropertyWorksOnDom) {
	            var definePropertyFallback = Object.defineProperty,
	                definePropertiesFallback = Object.defineProperties;
	        }
	    }
	
	    if (!Object.defineProperty || definePropertyFallback) {
	        var ERR_NON_OBJECT_DESCRIPTOR = 'Property description must be an object: ';
	        var ERR_NON_OBJECT_TARGET = 'Object.defineProperty called on non-object: ';
	        var ERR_ACCESSORS_NOT_SUPPORTED = 'getters & setters can not be defined on this javascript engine';
	
	        Object.defineProperty = function defineProperty(object, property, descriptor) {
	            if (isPrimitive(object)) {
	                throw new TypeError(ERR_NON_OBJECT_TARGET + object);
	            }
	            if (isPrimitive(descriptor)) {
	                throw new TypeError(ERR_NON_OBJECT_DESCRIPTOR + descriptor);
	            }
	            // make a valiant attempt to use the real defineProperty
	            // for I8's DOM elements.
	            if (definePropertyFallback) {
	                try {
	                    return definePropertyFallback.call(Object, object, property, descriptor);
	                } catch (exception) {
	                    // try the shim if the real one doesn't work
	                }
	            }
	
	            // If it's a data property.
	            if ('value' in descriptor) {
	                // fail silently if 'writable', 'enumerable', or 'configurable'
	                // are requested but not supported
	                /*
	                // alternate approach:
	                if ( // can't implement these features; allow false but not true
	                    ('writable' in descriptor && !descriptor.writable) ||
	                    ('enumerable' in descriptor && !descriptor.enumerable) ||
	                    ('configurable' in descriptor && !descriptor.configurable)
	                ))
	                    throw new RangeError(
	                        'This implementation of Object.defineProperty does not support configurable, enumerable, or writable.'
	                    );
	                */
	
	                if (supportsAccessors && (lookupGetter(object, property) || lookupSetter(object, property))) {
	                    // As accessors are supported only on engines implementing
	                    // `__proto__` we can safely override `__proto__` while defining
	                    // a property to make sure that we don't hit an inherited
	                    // accessor.
	                    /* eslint-disable no-proto */
	                    var prototype = object.__proto__;
	                    object.__proto__ = prototypeOfObject;
	                    // Deleting a property anyway since getter / setter may be
	                    // defined on object itself.
	                    delete object[property];
	                    object[property] = descriptor.value;
	                    // Setting original `__proto__` back now.
	                    object.__proto__ = prototype;
	                    /* eslint-enable no-proto */
	                } else {
	                    object[property] = descriptor.value;
	                }
	            } else {
	                var hasGetter = 'get' in descriptor;
	                var hasSetter = 'set' in descriptor;
	                if (!supportsAccessors && (hasGetter || hasSetter)) {
	                    throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);
	                }
	                // If we got that far then getters and setters can be defined !!
	                if (hasGetter) {
	                    defineGetter(object, property, descriptor.get);
	                }
	                if (hasSetter) {
	                    defineSetter(object, property, descriptor.set);
	                }
	            }
	            return object;
	        };
	    }
	
	    // ES5 15.2.3.7
	    // http://es5.github.com/#x15.2.3.7
	    if (!Object.defineProperties || definePropertiesFallback) {
	        Object.defineProperties = function defineProperties(object, properties) {
	            // make a valiant attempt to use the real defineProperties
	            if (definePropertiesFallback) {
	                try {
	                    return definePropertiesFallback.call(Object, object, properties);
	                } catch (exception) {
	                    // try the shim if the real one doesn't work
	                }
	            }
	
	            Object.keys(properties).forEach(function (property) {
	                if (property !== '__proto__') {
	                    Object.defineProperty(object, property, properties[property]);
	                }
	            });
	            return object;
	        };
	    }
	
	    // ES5 15.2.3.8
	    // http://es5.github.com/#x15.2.3.8
	    if (!Object.seal) {
	        Object.seal = function seal(object) {
	            if (Object(object) !== object) {
	                throw new TypeError('Object.seal can only be called on Objects.');
	            }
	            // this is misleading and breaks feature-detection, but
	            // allows "securable" code to "gracefully" degrade to working
	            // but insecure code.
	            return object;
	        };
	    }
	
	    // ES5 15.2.3.9
	    // http://es5.github.com/#x15.2.3.9
	    if (!Object.freeze) {
	        Object.freeze = function freeze(object) {
	            if (Object(object) !== object) {
	                throw new TypeError('Object.freeze can only be called on Objects.');
	            }
	            // this is misleading and breaks feature-detection, but
	            // allows "securable" code to "gracefully" degrade to working
	            // but insecure code.
	            return object;
	        };
	    }
	
	    // detect a Rhino bug and patch it
	    try {
	        Object.freeze(function () {});
	    } catch (exception) {
	        Object.freeze = (function (freezeObject) {
	            return function freeze(object) {
	                if (typeof object === 'function') {
	                    return object;
	                } else {
	                    return freezeObject(object);
	                }
	            };
	        }(Object.freeze));
	    }
	
	    // ES5 15.2.3.10
	    // http://es5.github.com/#x15.2.3.10
	    if (!Object.preventExtensions) {
	        Object.preventExtensions = function preventExtensions(object) {
	            if (Object(object) !== object) {
	                throw new TypeError('Object.preventExtensions can only be called on Objects.');
	            }
	            // this is misleading and breaks feature-detection, but
	            // allows "securable" code to "gracefully" degrade to working
	            // but insecure code.
	            return object;
	        };
	    }
	
	    // ES5 15.2.3.11
	    // http://es5.github.com/#x15.2.3.11
	    if (!Object.isSealed) {
	        Object.isSealed = function isSealed(object) {
	            if (Object(object) !== object) {
	                throw new TypeError('Object.isSealed can only be called on Objects.');
	            }
	            return false;
	        };
	    }
	
	    // ES5 15.2.3.12
	    // http://es5.github.com/#x15.2.3.12
	    if (!Object.isFrozen) {
	        Object.isFrozen = function isFrozen(object) {
	            if (Object(object) !== object) {
	                throw new TypeError('Object.isFrozen can only be called on Objects.');
	            }
	            return false;
	        };
	    }
	
	    // ES5 15.2.3.13
	    // http://es5.github.com/#x15.2.3.13
	    if (!Object.isExtensible) {
	        Object.isExtensible = function isExtensible(object) {
	            // 1. If Type(O) is not Object throw a TypeError exception.
	            if (Object(object) !== object) {
	                throw new TypeError('Object.isExtensible can only be called on Objects.');
	            }
	            // 2. Return the Boolean value of the [[Extensible]] internal property of O.
	            var name = '';
	            while (owns(object, name)) {
	                name += '?';
	            }
	            object[name] = true;
	            var returnValue = owns(object, name);
	            delete object[name];
	            return returnValue;
	        };
	    }
	
	}));


/***/ },
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v1.12.4
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-05-20T17:17Z
	 */
	
	(function( global, factory ) {
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Support: Firefox 18+
	// Can't be in strict mode, several libs including ASP.NET trace
	// the stack via arguments.caller.callee and Firefox dies if
	// you try to trace through "use strict" call chains. (#13335)
	//"use strict";
	var deletedIds = [];
	
	var document = window.document;
	
	var slice = deletedIds.slice;
	
	var concat = deletedIds.concat;
	
	var push = deletedIds.push;
	
	var indexOf = deletedIds.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var support = {};
	
	
	
	var
		version = "1.12.4",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android<4.1, IE<9
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([\da-z])/gi,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// Start with an empty selector
		selector: "",
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
			return num != null ?
	
				// Return just the one element from the set
				( num < 0 ? this[ num + this.length ] : this[ num ] ) :
	
				// Return all the elements in a clean array
				slice.call( this );
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
			ret.context = this.context;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: deletedIds.sort,
		splice: deletedIds.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var src, copyIsArray, copy, name, options, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = jQuery.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		// See test/unit/core.js for details concerning isFunction.
		// Since version 1.3, DOM methods and functions like alert
		// aren't supported. They return false on IE (#2968).
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isArray: Array.isArray || function( obj ) {
			return jQuery.type( obj ) === "array";
		},
	
		isWindow: function( obj ) {
			/* jshint eqeqeq: false */
			return obj != null && obj == obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// parseFloat NaNs numeric-cast false positives (null|true|false|"")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			// adding 1 corrects loss of precision from parseFloat (#15100)
			var realStringObj = obj && obj.toString();
			return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
		},
	
		isEmptyObject: function( obj ) {
			var name;
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		isPlainObject: function( obj ) {
			var key;
	
			// Must be an Object.
			// Because of IE, we also have to check the presence of the constructor property.
			// Make sure that DOM nodes and window objects don't pass through, as well
			if ( !obj || jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
				return false;
			}
	
			try {
	
				// Not own constructor property must be Object
				if ( obj.constructor &&
					!hasOwn.call( obj, "constructor" ) &&
					!hasOwn.call( obj.constructor.prototype, "isPrototypeOf" ) ) {
					return false;
				}
			} catch ( e ) {
	
				// IE8,9 Will throw exceptions on certain host objects #9897
				return false;
			}
	
			// Support: IE<9
			// Handle iteration over inherited properties before own properties.
			if ( !support.ownFirst ) {
				for ( key in obj ) {
					return hasOwn.call( obj, key );
				}
			}
	
			// Own properties are enumerated firstly, so to speed up,
			// if last one is own, then all properties are own.
			for ( key in obj ) {}
	
			return key === undefined || hasOwn.call( obj, key );
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Workarounds based on findings by Jim Driscoll
		// http://weblogs.java.net/blog/driscoll/archive/2009/09/08/eval-javascript-global-context
		globalEval: function( data ) {
			if ( data && jQuery.trim( data ) ) {
	
				// We use execScript on Internet Explorer
				// We use an anonymous function so that context is window
				// rather than jQuery in Firefox
				( window.execScript || function( data ) {
					window[ "eval" ].call( window, data ); // jscs:ignore requireDotNotation
				} )( data );
			}
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android<4.1, IE<9
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			var len;
	
			if ( arr ) {
				if ( indexOf ) {
					return indexOf.call( arr, elem, i );
				}
	
				len = arr.length;
				i = i ? i < 0 ? Math.max( 0, len + i ) : i : 0;
	
				for ( ; i < len; i++ ) {
	
					// Skip accessing in sparse arrays
					if ( i in arr && arr[ i ] === elem ) {
						return i;
					}
				}
			}
	
			return -1;
		},
	
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			while ( j < len ) {
				first[ i++ ] = second[ j++ ];
			}
	
			// Support: IE<9
			// Workaround casting of .length to NaN on otherwise arraylike objects (e.g., NodeLists)
			if ( len !== len ) {
				while ( second[ j ] !== undefined ) {
					first[ i++ ] = second[ j++ ];
				}
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var args, proxy, tmp;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: function() {
			return +( new Date() );
		},
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	// JSHint would error on this code due to the Symbol not being defined in ES5.
	// Defining this global in .jshintrc would create a danger of using the global
	// unguarded in another place, it seems safer to just disable JSHint for these
	// three lines.
	/* jshint ignore: start */
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = deletedIds[ Symbol.iterator ];
	}
	/* jshint ignore: end */
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: iOS 8.2 (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.2.1
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2015-10-17
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// General-purpose constants
		MAX_NEGATIVE = 1 << 31,
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// http://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
		rescape = /'|\\/g,
	
		// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		};
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, nidselect, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rescape, "\\$&" );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
						while ( i-- ) {
							groups[i] = nidselect + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created div and expects a boolean result
	 */
	function assert( fn ) {
		var div = document.createElement("div");
	
		try {
			return !!fn( div );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( div.parentNode ) {
				div.parentNode.removeChild( div );
			}
			// release memory in IE
			div = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				( ~b.sourceIndex || MAX_NEGATIVE ) -
				( ~a.sourceIndex || MAX_NEGATIVE );
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, parent,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( (parent = document.defaultView) && parent.top !== parent ) {
			// Support: IE 11
			if ( parent.addEventListener ) {
				parent.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( parent.attachEvent ) {
				parent.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( div ) {
			div.className = "i";
			return !div.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( div ) {
			div.appendChild( document.createComment("") );
			return !div.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( div ) {
			docElem.appendChild( div ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID find and filter
		if ( support.getById ) {
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var m = context.getElementById( id );
					return m ? [ m ] : [];
				}
			};
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
		} else {
			// Support: IE6/7
			// getElementById is not reliable as a find shortcut
			delete Expr.find["ID"];
	
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See http://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( div ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// http://bugs.jquery.com/ticket/12359
				docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( div.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !div.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibing-combinator selector` fails
				if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( div ) {
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				div.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( div.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":enabled").length ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				div.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( div ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( div, "div" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( div, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": function( elem ) {
				return elem.disabled === false;
			},
	
			"disabled": function( elem ) {
				return elem.disabled === true;
			},
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			checkNonElements = base && dir === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( (oldCache = uniqueCache[ dir ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ dir ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( div1 ) {
		// Should return 1, but returns 4 (following)
		return div1.compareDocumentPosition( document.createElement("div") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( div ) {
		div.innerHTML = "<a href='#'></a>";
		return div.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( div ) {
		div.innerHTML = "<input/>";
		div.firstChild.setAttribute( "value", "" );
		return div.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( div ) {
		return div.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				/* jshint -W018 */
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
	
		}
	
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
	
		}
	
		if ( typeof qualifier === "string" ) {
			if ( risSimple.test( qualifier ) ) {
				return jQuery.filter( qualifier, elements, not );
			}
	
			qualifier = jQuery.filter( qualifier, elements );
		}
	
		return jQuery.grep( elements, function( elem ) {
			return ( jQuery.inArray( elem, qualifier ) > -1 ) !== not;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		return elems.length === 1 && elem.nodeType === 1 ?
			jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
			jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
				return elem.nodeType === 1;
			} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i,
				ret = [],
				self = this,
				len = self.length;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			// Needed because $( selector, context ) becomes $( context ).find( selector )
			ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
			ret.selector = this.selector ? this.selector + " " + selector : selector;
			return ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// init accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector.charAt( 0 ) === "<" &&
					selector.charAt( selector.length - 1 ) === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						// Check parentNode to catch when Blackberry 4.6 returns
						// nodes that are no longer in the document #6963
						if ( elem && elem.parentNode ) {
	
							// Handle the case where IE and Opera return items
							// by name instead of ID
							if ( elem.id !== match[ 2 ] ) {
								return rootjQuery.find( selector );
							}
	
							// Otherwise, we inject the element directly into the jQuery object
							this.length = 1;
							this[ 0 ] = elem;
						}
	
						this.context = document;
						this.selector = selector;
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this.context = this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return typeof root.ready !== "undefined" ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			if ( selector.selector !== undefined ) {
				this.selector = selector.selector;
				this.context = selector.context;
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var i,
				targets = jQuery( target, this ),
				len = targets.length;
	
			return this.filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
					jQuery( selectors, context || this.context ) :
					0;
	
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
					// Always skip document fragments
					if ( cur.nodeType < 11 && ( pos ?
						pos.index( cur ) > -1 :
	
						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
						matched.push( cur );
						break;
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within
		// the matched set of elements
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// index in selector
			if ( typeof elem === "string" ) {
				return jQuery.inArray( this[ 0 ], jQuery( elem ) );
			}
	
			// Locate the position of the desired element
			return jQuery.inArray(
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem, this );
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		do {
			cur = cur[ dir ];
		} while ( cur && cur.nodeType !== 1 );
	
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			return jQuery.nodeName( elem, "iframe" ) ?
				elem.contentDocument || elem.contentWindow.document :
				jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var ret = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				ret = jQuery.filter( selector, ret );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					ret = jQuery.uniqueSort( ret );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					ret = ret.reverse();
				}
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnotwhite = ( /\S+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = true;
					if ( !memory ) {
						self.disable();
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, listener list, final state
					[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
					[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					then: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
								var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
	
								// deferred[ done | fail | progress ] for forwarding actions to newDefer
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this === promise ? newDefer.promise() : this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Keep pipe for back-compat
			promise.pipe = promise.then;
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 3 ];
	
				// promise[ done | fail | progress ] = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add( function() {
	
						// state = [ resolved | rejected ]
						state = stateString;
	
					// [ reject_list | resolve_list ].disable; progress_list.lock
					}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
				}
	
				// deferred[ resolve | reject | notify ]
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
					return this;
				};
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( subordinate /* , ..., subordinateN */ ) {
			var i = 0,
				resolveValues = slice.call( arguments ),
				length = resolveValues.length,
	
				// the count of uncompleted subordinates
				remaining = length !== 1 ||
					( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,
	
				// the master Deferred.
				// If resolveValues consist of only a single Deferred, just use that.
				deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
	
				// Update function for both resolve and progress values
				updateFunc = function( i, contexts, values ) {
					return function( value ) {
						contexts[ i ] = this;
						values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( values === progressValues ) {
							deferred.notifyWith( contexts, values );
	
						} else if ( !( --remaining ) ) {
							deferred.resolveWith( contexts, values );
						}
					};
				},
	
				progressValues, progressContexts, resolveContexts;
	
			// add listeners to Deferred subordinates; treat others as resolved
			if ( length > 1 ) {
				progressValues = new Array( length );
				progressContexts = new Array( length );
				resolveContexts = new Array( length );
				for ( ; i < length; i++ ) {
					if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
						resolveValues[ i ].promise()
							.progress( updateFunc( i, progressContexts, progressValues ) )
							.done( updateFunc( i, resolveContexts, resolveValues ) )
							.fail( deferred.reject );
					} else {
						--remaining;
					}
				}
			}
	
			// if we're not waiting on anything, resolve the master
			if ( !remaining ) {
				deferred.resolveWith( resolveContexts, resolveValues );
			}
	
			return deferred.promise();
		}
	} );
	
	
	// The deferred used on DOM ready
	var readyList;
	
	jQuery.fn.ready = function( fn ) {
	
		// Add the callback
		jQuery.ready.promise().done( fn );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
	
			// Trigger any bound ready events
			if ( jQuery.fn.triggerHandler ) {
				jQuery( document ).triggerHandler( "ready" );
				jQuery( document ).off( "ready" );
			}
		}
	} );
	
	/**
	 * Clean-up method for dom ready events
	 */
	function detach() {
		if ( document.addEventListener ) {
			document.removeEventListener( "DOMContentLoaded", completed );
			window.removeEventListener( "load", completed );
	
		} else {
			document.detachEvent( "onreadystatechange", completed );
			window.detachEvent( "onload", completed );
		}
	}
	
	/**
	 * The ready event handler and self cleanup method
	 */
	function completed() {
	
		// readyState === "complete" is good enough for us to call the dom ready in oldIE
		if ( document.addEventListener ||
			window.event.type === "load" ||
			document.readyState === "complete" ) {
	
			detach();
			jQuery.ready();
		}
	}
	
	jQuery.ready.promise = function( obj ) {
		if ( !readyList ) {
	
			readyList = jQuery.Deferred();
	
			// Catch cases where $(document).ready() is called
			// after the browser event has already occurred.
			// Support: IE6-10
			// Older IE sometimes signals "interactive" too soon
			if ( document.readyState === "complete" ||
				( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
				// Handle it asynchronously to allow scripts the opportunity to delay ready
				window.setTimeout( jQuery.ready );
	
			// Standards-based browsers support DOMContentLoaded
			} else if ( document.addEventListener ) {
	
				// Use the handy event callback
				document.addEventListener( "DOMContentLoaded", completed );
	
				// A fallback to window.onload, that will always work
				window.addEventListener( "load", completed );
	
			// If IE event model is used
			} else {
	
				// Ensure firing before onload, maybe late but safe also for iframes
				document.attachEvent( "onreadystatechange", completed );
	
				// A fallback to window.onload, that will always work
				window.attachEvent( "onload", completed );
	
				// If IE and not a frame
				// continually check to see if the document is ready
				var top = false;
	
				try {
					top = window.frameElement == null && document.documentElement;
				} catch ( e ) {}
	
				if ( top && top.doScroll ) {
					( function doScrollCheck() {
						if ( !jQuery.isReady ) {
	
							try {
	
								// Use the trick by Diego Perini
								// http://javascript.nwbox.com/IEContentLoaded/
								top.doScroll( "left" );
							} catch ( e ) {
								return window.setTimeout( doScrollCheck, 50 );
							}
	
							// detach all dom ready events
							detach();
	
							// and execute any waiting functions
							jQuery.ready();
						}
					} )();
				}
			}
		}
		return readyList.promise( obj );
	};
	
	// Kick off the DOM ready check even if the user does not
	jQuery.ready.promise();
	
	
	
	
	// Support: IE<9
	// Iteration over object's inherited properties before its own
	var i;
	for ( i in jQuery( support ) ) {
		break;
	}
	support.ownFirst = i === "0";
	
	// Note: most support tests are defined in their respective modules.
	// false until the test is run
	support.inlineBlockNeedsLayout = false;
	
	// Execute ASAP in case we need to set body.style.zoom
	jQuery( function() {
	
		// Minified: var a,b,c,d
		var val, div, body, container;
	
		body = document.getElementsByTagName( "body" )[ 0 ];
		if ( !body || !body.style ) {
	
			// Return for frameset docs that don't have a body
			return;
		}
	
		// Setup
		div = document.createElement( "div" );
		container = document.createElement( "div" );
		container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
		body.appendChild( container ).appendChild( div );
	
		if ( typeof div.style.zoom !== "undefined" ) {
	
			// Support: IE<8
			// Check if natively block-level elements act like inline-block
			// elements when setting their display to 'inline' and giving
			// them layout
			div.style.cssText = "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1";
	
			support.inlineBlockNeedsLayout = val = div.offsetWidth === 3;
			if ( val ) {
	
				// Prevent IE 6 from affecting layout for positioned elements #11048
				// Prevent IE from shrinking the body in IE 7 mode #12869
				// Support: IE<8
				body.style.zoom = 1;
			}
		}
	
		body.removeChild( container );
	} );
	
	
	( function() {
		var div = document.createElement( "div" );
	
		// Support: IE<9
		support.deleteExpando = true;
		try {
			delete div.test;
		} catch ( e ) {
			support.deleteExpando = false;
		}
	
		// Null elements to avoid leaks in IE.
		div = null;
	} )();
	var acceptData = function( elem ) {
		var noData = jQuery.noData[ ( elem.nodeName + " " ).toLowerCase() ],
			nodeType = +elem.nodeType || 1;
	
		// Do not set data on non-element DOM nodes because it will not be cleared (#8335).
		return nodeType !== 1 && nodeType !== 9 ?
			false :
	
			// Nodes accept data unless otherwise specified; rejection can be conditional
			!noData || noData !== true && elem.getAttribute( "classid" ) === noData;
	};
	
	
	
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /([A-Z])/g;
	
	function dataAttr( elem, key, data ) {
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
	
			var name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();
	
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = data === "true" ? true :
						data === "false" ? false :
						data === "null" ? null :
	
						// Only convert to a number if it doesn't change the string
						+data + "" === data ? +data :
						rbrace.test( data ) ? jQuery.parseJSON( data ) :
						data;
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				jQuery.data( elem, key, data );
	
			} else {
				data = undefined;
			}
		}
	
		return data;
	}
	
	// checks a cache object for emptiness
	function isEmptyDataObject( obj ) {
		var name;
		for ( name in obj ) {
	
			// if the public data object is empty, the private is still empty
			if ( name === "data" && jQuery.isEmptyObject( obj[ name ] ) ) {
				continue;
			}
			if ( name !== "toJSON" ) {
				return false;
			}
		}
	
		return true;
	}
	
	function internalData( elem, name, data, pvt /* Internal Use Only */ ) {
		if ( !acceptData( elem ) ) {
			return;
		}
	
		var ret, thisCache,
			internalKey = jQuery.expando,
	
			// We have to handle DOM nodes and JS objects differently because IE6-7
			// can't GC object references properly across the DOM-JS boundary
			isNode = elem.nodeType,
	
			// Only DOM nodes need the global jQuery cache; JS object data is
			// attached directly to the object so GC can occur automatically
			cache = isNode ? jQuery.cache : elem,
	
			// Only defining an ID for JS objects if its cache already exists allows
			// the code to shortcut on the same path as a DOM node with no cache
			id = isNode ? elem[ internalKey ] : elem[ internalKey ] && internalKey;
	
		// Avoid doing any more work than we need to when trying to get data on an
		// object that has no data at all
		if ( ( !id || !cache[ id ] || ( !pvt && !cache[ id ].data ) ) &&
			data === undefined && typeof name === "string" ) {
			return;
		}
	
		if ( !id ) {
	
			// Only DOM nodes need a new unique ID for each element since their data
			// ends up in the global cache
			if ( isNode ) {
				id = elem[ internalKey ] = deletedIds.pop() || jQuery.guid++;
			} else {
				id = internalKey;
			}
		}
	
		if ( !cache[ id ] ) {
	
			// Avoid exposing jQuery metadata on plain JS objects when the object
			// is serialized using JSON.stringify
			cache[ id ] = isNode ? {} : { toJSON: jQuery.noop };
		}
	
		// An object can be passed to jQuery.data instead of a key/value pair; this gets
		// shallow copied over onto the existing cache
		if ( typeof name === "object" || typeof name === "function" ) {
			if ( pvt ) {
				cache[ id ] = jQuery.extend( cache[ id ], name );
			} else {
				cache[ id ].data = jQuery.extend( cache[ id ].data, name );
			}
		}
	
		thisCache = cache[ id ];
	
		// jQuery data() is stored in a separate object inside the object's internal data
		// cache in order to avoid key collisions between internal data and user-defined
		// data.
		if ( !pvt ) {
			if ( !thisCache.data ) {
				thisCache.data = {};
			}
	
			thisCache = thisCache.data;
		}
	
		if ( data !== undefined ) {
			thisCache[ jQuery.camelCase( name ) ] = data;
		}
	
		// Check for both converted-to-camel and non-converted data property names
		// If a data property was specified
		if ( typeof name === "string" ) {
	
			// First Try to find as-is property data
			ret = thisCache[ name ];
	
			// Test for null|undefined property data
			if ( ret == null ) {
	
				// Try to find the camelCased property
				ret = thisCache[ jQuery.camelCase( name ) ];
			}
		} else {
			ret = thisCache;
		}
	
		return ret;
	}
	
	function internalRemoveData( elem, name, pvt ) {
		if ( !acceptData( elem ) ) {
			return;
		}
	
		var thisCache, i,
			isNode = elem.nodeType,
	
			// See jQuery.data for more information
			cache = isNode ? jQuery.cache : elem,
			id = isNode ? elem[ jQuery.expando ] : jQuery.expando;
	
		// If there is already no cache entry for this object, there is no
		// purpose in continuing
		if ( !cache[ id ] ) {
			return;
		}
	
		if ( name ) {
	
			thisCache = pvt ? cache[ id ] : cache[ id ].data;
	
			if ( thisCache ) {
	
				// Support array or space separated string names for data keys
				if ( !jQuery.isArray( name ) ) {
	
					// try the string as a key before any manipulation
					if ( name in thisCache ) {
						name = [ name ];
					} else {
	
						// split the camel cased version by spaces unless a key with the spaces exists
						name = jQuery.camelCase( name );
						if ( name in thisCache ) {
							name = [ name ];
						} else {
							name = name.split( " " );
						}
					}
				} else {
	
					// If "name" is an array of keys...
					// When data is initially created, via ("key", "val") signature,
					// keys will be converted to camelCase.
					// Since there is no way to tell _how_ a key was added, remove
					// both plain key and camelCase key. #12786
					// This will only penalize the array argument path.
					name = name.concat( jQuery.map( name, jQuery.camelCase ) );
				}
	
				i = name.length;
				while ( i-- ) {
					delete thisCache[ name[ i ] ];
				}
	
				// If there is no data left in the cache, we want to continue
				// and let the cache object itself get destroyed
				if ( pvt ? !isEmptyDataObject( thisCache ) : !jQuery.isEmptyObject( thisCache ) ) {
					return;
				}
			}
		}
	
		// See jQuery.data for more information
		if ( !pvt ) {
			delete cache[ id ].data;
	
			// Don't destroy the parent cache unless the internal data object
			// had been the only thing left in it
			if ( !isEmptyDataObject( cache[ id ] ) ) {
				return;
			}
		}
	
		// Destroy the cache
		if ( isNode ) {
			jQuery.cleanData( [ elem ], true );
	
		// Use delete when supported for expandos or `cache` is not a window per isWindow (#10080)
		/* jshint eqeqeq: false */
		} else if ( support.deleteExpando || cache != cache.window ) {
			/* jshint eqeqeq: true */
			delete cache[ id ];
	
		// When all else fails, undefined
		} else {
			cache[ id ] = undefined;
		}
	}
	
	jQuery.extend( {
		cache: {},
	
		// The following elements (space-suffixed to avoid Object.prototype collisions)
		// throw uncatchable exceptions if you attempt to set expando properties
		noData: {
			"applet ": true,
			"embed ": true,
	
			// ...but Flash objects (which have this classid) *can* handle expandos
			"object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
		},
	
		hasData: function( elem ) {
			elem = elem.nodeType ? jQuery.cache[ elem[ jQuery.expando ] ] : elem[ jQuery.expando ];
			return !!elem && !isEmptyDataObject( elem );
		},
	
		data: function( elem, name, data ) {
			return internalData( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			return internalRemoveData( elem, name );
		},
	
		// For internal use only.
		_data: function( elem, name, data ) {
			return internalData( elem, name, data, true );
		},
	
		_removeData: function( elem, name ) {
			return internalRemoveData( elem, name, true );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Special expections of .data basically thwart jQuery.access,
			// so implement the relevant behavior ourselves
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = jQuery.data( elem );
	
					if ( elem.nodeType === 1 && !jQuery._data( elem, "parsedAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE11+
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						jQuery._data( elem, "parsedAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					jQuery.data( this, key );
				} );
			}
	
			return arguments.length > 1 ?
	
				// Sets one value
				this.each( function() {
					jQuery.data( this, key, value );
				} ) :
	
				// Gets one value
				// Try to fetch any internally stored data first
				elem ? dataAttr( elem, key, jQuery.data( elem, key ) ) : undefined;
		},
	
		removeData: function( key ) {
			return this.each( function() {
				jQuery.removeData( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = jQuery._data( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = jQuery._data( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// not intended for public consumption - generates a queueHooks object,
		// or returns the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return jQuery._data( elem, key ) || jQuery._data( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					jQuery._removeData( elem, type + "queue" );
					jQuery._removeData( elem, key );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = jQuery._data( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	
	
	( function() {
		var shrinkWrapBlocksVal;
	
		support.shrinkWrapBlocks = function() {
			if ( shrinkWrapBlocksVal != null ) {
				return shrinkWrapBlocksVal;
			}
	
			// Will be changed later if needed.
			shrinkWrapBlocksVal = false;
	
			// Minified: var b,c,d
			var div, body, container;
	
			body = document.getElementsByTagName( "body" )[ 0 ];
			if ( !body || !body.style ) {
	
				// Test fired too early or in an unsupported environment, exit.
				return;
			}
	
			// Setup
			div = document.createElement( "div" );
			container = document.createElement( "div" );
			container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
			body.appendChild( container ).appendChild( div );
	
			// Support: IE6
			// Check if elements with layout shrink-wrap their children
			if ( typeof div.style.zoom !== "undefined" ) {
	
				// Reset CSS: box-sizing; display; margin; border
				div.style.cssText =
	
					// Support: Firefox<29, Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
					"box-sizing:content-box;display:block;margin:0;border:0;" +
					"padding:1px;width:1px;zoom:1";
				div.appendChild( document.createElement( "div" ) ).style.width = "5px";
				shrinkWrapBlocksVal = div.offsetWidth !== 3;
			}
	
			body.removeChild( container );
	
			return shrinkWrapBlocksVal;
		};
	
	} )();
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHidden = function( elem, el ) {
	
			// isHidden might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
			return jQuery.css( elem, "display" ) === "none" ||
				!jQuery.contains( elem.ownerDocument, elem );
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() { return tween.cur(); } :
				function() { return jQuery.css( elem, prop, "" ); },
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			length = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < length; i++ ) {
					fn(
						elems[ i ],
						key,
						raw ? value : value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		return chainable ?
			elems :
	
			// Gets
			bulk ?
				fn.call( elems ) :
				length ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([\w:-]+)/ );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	var rleadingWhitespace = ( /^\s+/ );
	
	var nodeNames = "abbr|article|aside|audio|bdi|canvas|data|datalist|" +
			"details|dialog|figcaption|figure|footer|header|hgroup|main|" +
			"mark|meter|nav|output|picture|progress|section|summary|template|time|video";
	
	
	
	function createSafeFragment( document ) {
		var list = nodeNames.split( "|" ),
			safeFrag = document.createDocumentFragment();
	
		if ( safeFrag.createElement ) {
			while ( list.length ) {
				safeFrag.createElement(
					list.pop()
				);
			}
		}
		return safeFrag;
	}
	
	
	( function() {
		var div = document.createElement( "div" ),
			fragment = document.createDocumentFragment(),
			input = document.createElement( "input" );
	
		// Setup
		div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
	
		// IE strips leading whitespace when .innerHTML is used
		support.leadingWhitespace = div.firstChild.nodeType === 3;
	
		// Make sure that tbody elements aren't automatically inserted
		// IE will insert them into empty tables
		support.tbody = !div.getElementsByTagName( "tbody" ).length;
	
		// Make sure that link elements get serialized correctly by innerHTML
		// This requires a wrapper element in IE
		support.htmlSerialize = !!div.getElementsByTagName( "link" ).length;
	
		// Makes sure cloning an html5 element does not cause problems
		// Where outerHTML is undefined, this still works
		support.html5Clone =
			document.createElement( "nav" ).cloneNode( true ).outerHTML !== "<:nav></:nav>";
	
		// Check if a disconnected checkbox will retain its checked
		// value of true after appended to the DOM (IE6/7)
		input.type = "checkbox";
		input.checked = true;
		fragment.appendChild( input );
		support.appendChecked = input.checked;
	
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		// Support: IE6-IE11+
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// #11217 - WebKit loses check when the name is after the checked attribute
		fragment.appendChild( div );
	
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input = document.createElement( "input" );
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Safari 5.1, iOS 5.1, Android 4.x, Android 2.3
		// old WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE<9
		// Cloned elements keep attachEvent handlers, we use addEventListener on IE9+
		support.noCloneEvent = !!div.addEventListener;
	
		// Support: IE<9
		// Since attributes and properties are the same in IE,
		// cleanData must set properties to undefined rather than use removeAttribute
		div[ jQuery.expando ] = 1;
		support.attributes = !div.getAttribute( jQuery.expando );
	} )();
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
		legend: [ 1, "<fieldset>", "</fieldset>" ],
		area: [ 1, "<map>", "</map>" ],
	
		// Support: IE8
		param: [ 1, "<object>", "</object>" ],
		thead: [ 1, "<table>", "</table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		col: [ 2, "<table><tbody></tbody><colgroup>", "</colgroup></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		// IE6-8 can't serialize link, script, style, or any html5 (NoScope) tags,
		// unless wrapped in a div with non-breaking characters in front of it.
		_default: support.htmlSerialize ? [ 0, "", "" ] : [ 1, "X<div>", "</div>" ]
	};
	
	// Support: IE8-IE9
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
		var elems, elem,
			i = 0,
			found = typeof context.getElementsByTagName !== "undefined" ?
				context.getElementsByTagName( tag || "*" ) :
				typeof context.querySelectorAll !== "undefined" ?
					context.querySelectorAll( tag || "*" ) :
					undefined;
	
		if ( !found ) {
			for ( found = [], elems = context.childNodes || context;
				( elem = elems[ i ] ) != null;
				i++
			) {
				if ( !tag || jQuery.nodeName( elem, tag ) ) {
					found.push( elem );
				} else {
					jQuery.merge( found, getAll( elem, tag ) );
				}
			}
		}
	
		return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
			jQuery.merge( [ context ], found ) :
			found;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var elem,
			i = 0;
		for ( ; ( elem = elems[ i ] ) != null; i++ ) {
			jQuery._data(
				elem,
				"globalEval",
				!refElements || jQuery._data( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/,
		rtbody = /<tbody/i;
	
	function fixDefaultChecked( elem ) {
		if ( rcheckableType.test( elem.type ) ) {
			elem.defaultChecked = elem.checked;
		}
	}
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var j, elem, contains,
			tmp, tag, tbody, wrap,
			l = elems.length,
	
			// Ensure a safe fragment
			safe = createSafeFragment( context ),
	
			nodes = [],
			i = 0;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || safe.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
	
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Manually add leading whitespace removed by IE
					if ( !support.leadingWhitespace && rleadingWhitespace.test( elem ) ) {
						nodes.push( context.createTextNode( rleadingWhitespace.exec( elem )[ 0 ] ) );
					}
	
					// Remove IE's autoinserted <tbody> from table fragments
					if ( !support.tbody ) {
	
						// String was a <table>, *may* have spurious <tbody>
						elem = tag === "table" && !rtbody.test( elem ) ?
							tmp.firstChild :
	
							// String was a bare <thead> or <tfoot>
							wrap[ 1 ] === "<table>" && !rtbody.test( elem ) ?
								tmp :
								0;
	
						j = elem && elem.childNodes.length;
						while ( j-- ) {
							if ( jQuery.nodeName( ( tbody = elem.childNodes[ j ] ), "tbody" ) &&
								!tbody.childNodes.length ) {
	
								elem.removeChild( tbody );
							}
						}
					}
	
					jQuery.merge( nodes, tmp.childNodes );
	
					// Fix #12392 for WebKit and IE > 9
					tmp.textContent = "";
	
					// Fix #12392 for oldIE
					while ( tmp.firstChild ) {
						tmp.removeChild( tmp.firstChild );
					}
	
					// Remember the top-level container for proper cleanup
					tmp = safe.lastChild;
				}
			}
		}
	
		// Fix #11356: Clear elements from fragment
		if ( tmp ) {
			safe.removeChild( tmp );
		}
	
		// Reset defaultChecked for any radios and checkboxes
		// about to be appended to the DOM in IE 6/7 (#8060)
		if ( !support.appendChecked ) {
			jQuery.grep( getAll( nodes, "input" ), fixDefaultChecked );
		}
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
	
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( safe.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		tmp = null;
	
		return safe;
	}
	
	
	( function() {
		var i, eventName,
			div = document.createElement( "div" );
	
		// Support: IE<9 (lack submit/change bubble), Firefox (lack focus(in | out) events)
		for ( i in { submit: true, change: true, focusin: true } ) {
			eventName = "on" + i;
	
			if ( !( support[ i ] = eventName in window ) ) {
	
				// Beware of CSP restrictions (https://developer.mozilla.org/en/Security/CSP)
				div.setAttribute( eventName, "t" );
				support[ i ] = div.attributes[ eventName ].expando === false;
			}
		}
	
		// Null elements to avoid leaks in IE.
		div = null;
	} )();
	
	
	var rformElems = /^(?:input|select|textarea)$/i,
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE9
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
			var tmp, events, t, handleObjIn,
				special, eventHandle, handleObj,
				handlers, type, namespaces, origType,
				elemData = jQuery._data( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" &&
						( !e || jQuery.event.triggered !== e.type ) ?
						jQuery.event.dispatch.apply( eventHandle.elem, arguments ) :
						undefined;
				};
	
				// Add elem as a property of the handle fn to prevent a memory leak
				// with IE non-native events
				eventHandle.elem = elem;
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener/attachEvent if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						// Bind the global event handler to the element
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle, false );
	
						} else if ( elem.attachEvent ) {
							elem.attachEvent( "on" + type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
			// Nullify elem to prevent memory leaks in IE
			elem = null;
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
			var j, handleObj, tmp,
				origCount, t, events,
				special, handlers, type,
				namespaces, origType,
				elemData = jQuery.hasData( elem ) && jQuery._data( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				delete elemData.handle;
	
				// removeData also checks for emptiness and clears the expando if empty
				// so use it instead of delete
				jQuery._removeData( elem, "events" );
			}
		},
	
		trigger: function( event, data, elem, onlyHandlers ) {
			var handle, ontype, cur,
				bubbleType, special, tmp, i,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( jQuery._data( cur, "events" ) || {} )[ event.type ] &&
					jQuery._data( cur, "handle" );
	
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if (
					( !special._default ||
					 special._default.apply( eventPath.pop(), data ) === false
					) && acceptData( elem )
				) {
	
					// Call a native DOM method on the target with the same name name as the event.
					// Can't use an .isFunction() check here because IE6/7 fails that test.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && elem[ type ] && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						try {
							elem[ type ]();
						} catch ( e ) {
	
							// IE<9 dies on focus/blur to hidden element (#1486,#12518)
							// only reproducible on winXP IE8 native, not IE9 in IE8 mode
						}
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		dispatch: function( event ) {
	
			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( event );
	
			var i, j, ret, matched, handleObj,
				handlerQueue = [],
				args = slice.call( arguments ),
				handlers = ( jQuery._data( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, matches, sel, handleObj,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Support (at least): Chrome, IE9
			// Find delegate handlers
			// Black-hole SVG <use> instance trees (#13180)
			//
			// Support: Firefox<=42+
			// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
			if ( delegateCount && cur.nodeType &&
				( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {
	
				/* jshint eqeqeq: false */
				for ( ; cur != this; cur = cur.parentNode || this ) {
					/* jshint eqeqeq: true */
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
						matches = [];
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matches[ sel ] === undefined ) {
								matches[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matches[ sel ] ) {
								matches.push( handleObj );
							}
						}
						if ( matches.length ) {
							handlerQueue.push( { elem: cur, handlers: matches } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		fix: function( event ) {
			if ( event[ jQuery.expando ] ) {
				return event;
			}
	
			// Create a writable copy of the event object and normalize some properties
			var i, prop, copy,
				type = event.type,
				originalEvent = event,
				fixHook = this.fixHooks[ type ];
	
			if ( !fixHook ) {
				this.fixHooks[ type ] = fixHook =
					rmouseEvent.test( type ) ? this.mouseHooks :
					rkeyEvent.test( type ) ? this.keyHooks :
					{};
			}
			copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;
	
			event = new jQuery.Event( originalEvent );
	
			i = copy.length;
			while ( i-- ) {
				prop = copy[ i ];
				event[ prop ] = originalEvent[ prop ];
			}
	
			// Support: IE<9
			// Fix target property (#1925)
			if ( !event.target ) {
				event.target = originalEvent.srcElement || document;
			}
	
			// Support: Safari 6-8+
			// Target should not be a text node (#504, #13143)
			if ( event.target.nodeType === 3 ) {
				event.target = event.target.parentNode;
			}
	
			// Support: IE<9
			// For mouse/key events, metaKey==false if it's undefined (#3368, #11328)
			event.metaKey = !!event.metaKey;
	
			return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
		},
	
		// Includes some event props shared by KeyEvent and MouseEvent
		props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
			"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),
	
		fixHooks: {},
	
		keyHooks: {
			props: "char charCode key keyCode".split( " " ),
			filter: function( event, original ) {
	
				// Add which for key events
				if ( event.which == null ) {
					event.which = original.charCode != null ? original.charCode : original.keyCode;
				}
	
				return event;
			}
		},
	
		mouseHooks: {
			props: ( "button buttons clientX clientY fromElement offsetX offsetY " +
				"pageX pageY screenX screenY toElement" ).split( " " ),
			filter: function( event, original ) {
				var body, eventDoc, doc,
					button = original.button,
					fromElement = original.fromElement;
	
				// Calculate pageX/Y if missing and clientX/Y available
				if ( event.pageX == null && original.clientX != null ) {
					eventDoc = event.target.ownerDocument || document;
					doc = eventDoc.documentElement;
					body = eventDoc.body;
	
					event.pageX = original.clientX +
						( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
						( doc && doc.clientLeft || body && body.clientLeft || 0 );
					event.pageY = original.clientY +
						( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
						( doc && doc.clientTop  || body && body.clientTop  || 0 );
				}
	
				// Add relatedTarget, if necessary
				if ( !event.relatedTarget && fromElement ) {
					event.relatedTarget = fromElement === event.target ?
						original.toElement :
						fromElement;
				}
	
				// Add which for click: 1 === left; 2 === middle; 3 === right
				// Note: button is not normalized, so don't use it
				if ( !event.which && button !== undefined ) {
					event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
				}
	
				return event;
			}
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						try {
							this.focus();
							return false;
						} catch ( e ) {
	
							// Support: IE<9
							// If we error on focus to hidden element (#1486, #12518),
							// let .trigger() run the handlers
						}
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( jQuery.nodeName( this, "input" ) && this.type === "checkbox" && this.click ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		},
	
		// Piggyback on a donor event to simulate a different one
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
	
					// Previously, `originalEvent: {}` was set here, so stopPropagation call
					// would not be triggered on donor event, since in our own
					// jQuery.event.stopPropagation function we had a check for existence of
					// originalEvent.stopPropagation method, so, consequently it would be a noop.
					//
					// Guard for simulated events was moved to jQuery.event.stopPropagation function
					// since `originalEvent` should point to the original event for the
					// constancy with other events and for more focused logic
				}
			);
	
			jQuery.event.trigger( e, null, elem );
	
			if ( e.isDefaultPrevented() ) {
				event.preventDefault();
			}
		}
	};
	
	jQuery.removeEvent = document.removeEventListener ?
		function( elem, type, handle ) {
	
			// This "if" is needed for plain objects
			if ( elem.removeEventListener ) {
				elem.removeEventListener( type, handle );
			}
		} :
		function( elem, type, handle ) {
			var name = "on" + type;
	
			if ( elem.detachEvent ) {
	
				// #8545, #7054, preventing memory leaks for custom events in IE6-8
				// detachEvent needed property on element, by name of that event,
				// to properly expose it to GC
				if ( typeof elem[ name ] === "undefined" ) {
					elem[ name ] = null;
				}
	
				elem.detachEvent( name, handle );
			}
		};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: IE < 9, Android < 4.0
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
			if ( !e ) {
				return;
			}
	
			// If preventDefault exists, run it on the original event
			if ( e.preventDefault ) {
				e.preventDefault();
	
			// Support: IE
			// Otherwise set the returnValue property of the original event to false
			} else {
				e.returnValue = false;
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( !e || this.isSimulated ) {
				return;
			}
	
			// If stopPropagation exists, run it on the original event
			if ( e.stopPropagation ) {
				e.stopPropagation();
			}
	
			// Support: IE
			// Set the cancelBubble property of the original event to true
			e.cancelBubble = true;
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && e.stopImmediatePropagation ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://code.google.com/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	// IE submit delegation
	if ( !support.submit ) {
	
		jQuery.event.special.submit = {
			setup: function() {
	
				// Only need this for delegated form submit events
				if ( jQuery.nodeName( this, "form" ) ) {
					return false;
				}
	
				// Lazy-add a submit handler when a descendant form may potentially be submitted
				jQuery.event.add( this, "click._submit keypress._submit", function( e ) {
	
					// Node name check avoids a VML-related crash in IE (#9807)
					var elem = e.target,
						form = jQuery.nodeName( elem, "input" ) || jQuery.nodeName( elem, "button" ) ?
	
							// Support: IE <=8
							// We use jQuery.prop instead of elem.form
							// to allow fixing the IE8 delegated submit issue (gh-2332)
							// by 3rd party polyfills/workarounds.
							jQuery.prop( elem, "form" ) :
							undefined;
	
					if ( form && !jQuery._data( form, "submit" ) ) {
						jQuery.event.add( form, "submit._submit", function( event ) {
							event._submitBubble = true;
						} );
						jQuery._data( form, "submit", true );
					}
				} );
	
				// return undefined since we don't need an event listener
			},
	
			postDispatch: function( event ) {
	
				// If form was submitted by the user, bubble the event up the tree
				if ( event._submitBubble ) {
					delete event._submitBubble;
					if ( this.parentNode && !event.isTrigger ) {
						jQuery.event.simulate( "submit", this.parentNode, event );
					}
				}
			},
	
			teardown: function() {
	
				// Only need this for delegated form submit events
				if ( jQuery.nodeName( this, "form" ) ) {
					return false;
				}
	
				// Remove delegated handlers; cleanData eventually reaps submit handlers attached above
				jQuery.event.remove( this, "._submit" );
			}
		};
	}
	
	// IE change delegation and checkbox/radio fix
	if ( !support.change ) {
	
		jQuery.event.special.change = {
	
			setup: function() {
	
				if ( rformElems.test( this.nodeName ) ) {
	
					// IE doesn't fire change on a check/radio until blur; trigger it on click
					// after a propertychange. Eat the blur-change in special.change.handle.
					// This still fires onchange a second time for check/radio after blur.
					if ( this.type === "checkbox" || this.type === "radio" ) {
						jQuery.event.add( this, "propertychange._change", function( event ) {
							if ( event.originalEvent.propertyName === "checked" ) {
								this._justChanged = true;
							}
						} );
						jQuery.event.add( this, "click._change", function( event ) {
							if ( this._justChanged && !event.isTrigger ) {
								this._justChanged = false;
							}
	
							// Allow triggered, simulated change events (#11500)
							jQuery.event.simulate( "change", this, event );
						} );
					}
					return false;
				}
	
				// Delegated event; lazy-add a change handler on descendant inputs
				jQuery.event.add( this, "beforeactivate._change", function( e ) {
					var elem = e.target;
	
					if ( rformElems.test( elem.nodeName ) && !jQuery._data( elem, "change" ) ) {
						jQuery.event.add( elem, "change._change", function( event ) {
							if ( this.parentNode && !event.isSimulated && !event.isTrigger ) {
								jQuery.event.simulate( "change", this.parentNode, event );
							}
						} );
						jQuery._data( elem, "change", true );
					}
				} );
			},
	
			handle: function( event ) {
				var elem = event.target;
	
				// Swallow native change events from checkbox/radio, we already triggered them above
				if ( this !== elem || event.isSimulated || event.isTrigger ||
					( elem.type !== "radio" && elem.type !== "checkbox" ) ) {
	
					return event.handleObj.handler.apply( this, arguments );
				}
			},
	
			teardown: function() {
				jQuery.event.remove( this, "._change" );
	
				return !rformElems.test( this.nodeName );
			}
		};
	}
	
	// Support: Firefox
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome, Safari
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = jQuery._data( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					jQuery._data( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = jQuery._data( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						jQuery._removeData( doc, fix );
					} else {
						jQuery._data( doc, fix, attaches );
					}
				}
			};
		} );
	}
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		},
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	var rinlinejQuery = / jQuery\d+="(?:null|\d+)"/g,
		rnoshimcache = new RegExp( "<(?:" + nodeNames + ")[\\s/>]", "i" ),
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
	
		// Support: IE 10-11, Edge 10240+
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
		safeFragment = createSafeFragment( document ),
		fragmentDiv = safeFragment.appendChild( document.createElement( "div" ) );
	
	// Support: IE<8
	// Manipulating tables requires a tbody
	function manipulationTarget( elem, content ) {
		return jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?
	
			elem.getElementsByTagName( "tbody" )[ 0 ] ||
				elem.appendChild( elem.ownerDocument.createElement( "tbody" ) ) :
			elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( jQuery.find.attr( elem, "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		if ( dest.nodeType !== 1 || !jQuery.hasData( src ) ) {
			return;
		}
	
		var type, i, l,
			oldData = jQuery._data( src ),
			curData = jQuery._data( dest, oldData ),
			events = oldData.events;
	
		if ( events ) {
			delete curData.handle;
			curData.events = {};
	
			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	
		// make the cloned public data object a copy from the original
		if ( curData.data ) {
			curData.data = jQuery.extend( {}, curData.data );
		}
	}
	
	function fixCloneNodeIssues( src, dest ) {
		var nodeName, e, data;
	
		// We do not need to do anything for non-Elements
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		nodeName = dest.nodeName.toLowerCase();
	
		// IE6-8 copies events bound via attachEvent when using cloneNode.
		if ( !support.noCloneEvent && dest[ jQuery.expando ] ) {
			data = jQuery._data( dest );
	
			for ( e in data.events ) {
				jQuery.removeEvent( dest, e, data.handle );
			}
	
			// Event data gets referenced instead of copied if the expando gets copied too
			dest.removeAttribute( jQuery.expando );
		}
	
		// IE blanks contents when cloning scripts, and tries to evaluate newly-set text
		if ( nodeName === "script" && dest.text !== src.text ) {
			disableScript( dest ).text = src.text;
			restoreScript( dest );
	
		// IE6-10 improperly clones children of object elements using classid.
		// IE10 throws NoModificationAllowedError if parent is null, #12132.
		} else if ( nodeName === "object" ) {
			if ( dest.parentNode ) {
				dest.outerHTML = src.outerHTML;
			}
	
			// This path appears unavoidable for IE9. When cloning an object
			// element in IE9, the outerHTML strategy above is not sufficient.
			// If the src has innerHTML and the destination does not,
			// copy the src.innerHTML into the dest.innerHTML. #10324
			if ( support.html5Clone && ( src.innerHTML && !jQuery.trim( dest.innerHTML ) ) ) {
				dest.innerHTML = src.innerHTML;
			}
	
		} else if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
	
			// IE6-8 fails to persist the checked state of a cloned checkbox
			// or radio button. Worse, IE6-7 fail to give the cloned element
			// a checked appearance if the defaultChecked value isn't also set
	
			dest.defaultChecked = dest.checked = src.checked;
	
			// IE6-7 get confused and end up setting the value of a cloned
			// checkbox/radio button to an empty string instead of "on"
			if ( dest.value !== src.value ) {
				dest.value = src.value;
			}
	
		// IE6-8 fails to return the selected option to the default selected
		// state when cloning options
		} else if ( nodeName === "option" ) {
			dest.defaultSelected = dest.selected = src.defaultSelected;
	
		// IE6-8 fails to set the defaultValue to the correct value when
		// cloning other types of input fields
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var first, node, hasScripts,
			scripts, doc, fragment,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android<4.1, PhantomJS<2
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!jQuery._data( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								jQuery.globalEval(
									( node.text || node.textContent || node.innerHTML || "" )
										.replace( rcleanScript, "" )
								);
							}
						}
					}
				}
	
				// Fix #11809: Avoid leaking memory
				fragment = first = null;
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			elems = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = elems[ i ] ) != null; i++ ) {
	
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var destElements, node, clone, i, srcElements,
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			if ( support.html5Clone || jQuery.isXMLDoc( elem ) ||
				!rnoshimcache.test( "<" + elem.nodeName + ">" ) ) {
	
				clone = elem.cloneNode( true );
	
			// IE<=8 does not properly clone detached, unknown element nodes
			} else {
				fragmentDiv.innerHTML = elem.outerHTML;
				fragmentDiv.removeChild( clone = fragmentDiv.firstChild );
			}
	
			if ( ( !support.noCloneEvent || !support.noCloneChecked ) &&
					( elem.nodeType === 1 || elem.nodeType === 11 ) && !jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				// Fix all IE cloning issues
				for ( i = 0; ( node = srcElements[ i ] ) != null; ++i ) {
	
					// Ensure that the destination node is not null; Fixes #9587
					if ( destElements[ i ] ) {
						fixCloneNodeIssues( node, destElements[ i ] );
					}
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0; ( node = srcElements[ i ] ) != null; i++ ) {
						cloneCopyEvent( node, destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			destElements = srcElements = node = null;
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems, /* internal */ forceAcceptData ) {
			var elem, type, id, data,
				i = 0,
				internalKey = jQuery.expando,
				cache = jQuery.cache,
				attributes = support.attributes,
				special = jQuery.event.special;
	
			for ( ; ( elem = elems[ i ] ) != null; i++ ) {
				if ( forceAcceptData || acceptData( elem ) ) {
	
					id = elem[ internalKey ];
					data = id && cache[ id ];
	
					if ( data ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Remove cache only if it was not already removed by jQuery.event.remove
						if ( cache[ id ] ) {
	
							delete cache[ id ];
	
							// Support: IE<9
							// IE does not allow us to delete expando properties from nodes
							// IE creates expando attributes along with the property
							// IE does not have a removeAttribute function on Document nodes
							if ( !attributes && typeof elem.removeAttribute !== "undefined" ) {
								elem.removeAttribute( internalKey );
	
							// Webkit & Blink performance suffers when deleting properties
							// from DOM nodes, so set to undefined instead
							// https://code.google.com/p/chromium/issues/detail?id=378607
							} else {
								elem[ internalKey ] = undefined;
							}
	
							deletedIds.push( id );
						}
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
	
		// Keep domManip exposed until 3.0 (gh-2225)
		domManip: domManip,
	
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().append(
						( this[ 0 ] && this[ 0 ].ownerDocument || document ).createTextNode( value )
					);
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
	
				// Remove element nodes and prevent memory leaks
				if ( elem.nodeType === 1 ) {
					jQuery.cleanData( getAll( elem, false ) );
				}
	
				// Remove any remaining nodes
				while ( elem.firstChild ) {
					elem.removeChild( elem.firstChild );
				}
	
				// If this is a select, ensure that it displays empty (#12336)
				// Support: IE<9
				if ( elem.options && jQuery.nodeName( elem, "select" ) ) {
					elem.options.length = 0;
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined ) {
					return elem.nodeType === 1 ?
						elem.innerHTML.replace( rinlinejQuery, "" ) :
						undefined;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					( support.htmlSerialize || !rnoshimcache.test( value )  ) &&
					( support.leadingWhitespace || !rleadingWhitespace.test( value ) ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
	
							// Remove element nodes and prevent memory leaks
							elem = this[ i ] || {};
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				i = 0,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Modern browsers can apply jQuery collections as arrays, but oldIE needs a .get()
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	
	
	var iframe,
		elemdisplay = {
	
			// Support: Firefox
			// We have to pre-define these values for FF (#10227)
			HTML: "block",
			BODY: "block"
		};
	
	/**
	 * Retrieve the actual display of a element
	 * @param {String} name nodeName of the element
	 * @param {Object} doc Document object
	 */
	
	// Called only from within defaultDisplay
	function actualDisplay( name, doc ) {
		var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),
	
			display = jQuery.css( elem[ 0 ], "display" );
	
		// We don't have any data stored on the element,
		// so use "detach" method as fast way to get rid of the element
		elem.detach();
	
		return display;
	}
	
	/**
	 * Try to determine the default display value of an element
	 * @param {String} nodeName
	 */
	function defaultDisplay( nodeName ) {
		var doc = document,
			display = elemdisplay[ nodeName ];
	
		if ( !display ) {
			display = actualDisplay( nodeName, doc );
	
			// If the simple way fails, read from inside an iframe
			if ( display === "none" || !display ) {
	
				// Use the already-created iframe if possible
				iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" ) )
					.appendTo( doc.documentElement );
	
				// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
				doc = ( iframe[ 0 ].contentWindow || iframe[ 0 ].contentDocument ).document;
	
				// Support: IE
				doc.write();
				doc.close();
	
				display = actualDisplay( nodeName, doc );
				iframe.detach();
			}
	
			// Store the correct default display
			elemdisplay[ nodeName ] = display;
		}
	
		return display;
	}
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var documentElement = document.documentElement;
	
	
	
	( function() {
		var pixelPositionVal, pixelMarginRightVal, boxSizingReliableVal,
			reliableHiddenOffsetsVal, reliableMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		div.style.cssText = "float:left;opacity:.5";
	
		// Support: IE<9
		// Make sure that element opacity exists (as opposed to filter)
		support.opacity = div.style.opacity === "0.5";
	
		// Verify style float existence
		// (IE uses styleFloat instead of cssFloat)
		support.cssFloat = !!div.style.cssFloat;
	
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container = document.createElement( "div" );
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		div.innerHTML = "";
		container.appendChild( div );
	
		// Support: Firefox<29, Android 2.3
		// Vendor-prefix box-sizing
		support.boxSizing = div.style.boxSizing === "" || div.style.MozBoxSizing === "" ||
			div.style.WebkitBoxSizing === "";
	
		jQuery.extend( support, {
			reliableHiddenOffsets: function() {
				if ( pixelPositionVal == null ) {
					computeStyleTests();
				}
				return reliableHiddenOffsetsVal;
			},
	
			boxSizingReliable: function() {
	
				// We're checking for pixelPositionVal here instead of boxSizingReliableVal
				// since that compresses better and they're computed together anyway.
				if ( pixelPositionVal == null ) {
					computeStyleTests();
				}
				return boxSizingReliableVal;
			},
	
			pixelMarginRight: function() {
	
				// Support: Android 4.0-4.3
				if ( pixelPositionVal == null ) {
					computeStyleTests();
				}
				return pixelMarginRightVal;
			},
	
			pixelPosition: function() {
				if ( pixelPositionVal == null ) {
					computeStyleTests();
				}
				return pixelPositionVal;
			},
	
			reliableMarginRight: function() {
	
				// Support: Android 2.3
				if ( pixelPositionVal == null ) {
					computeStyleTests();
				}
				return reliableMarginRightVal;
			},
	
			reliableMarginLeft: function() {
	
				// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
				if ( pixelPositionVal == null ) {
					computeStyleTests();
				}
				return reliableMarginLeftVal;
			}
		} );
	
		function computeStyleTests() {
			var contents, divStyle,
				documentElement = document.documentElement;
	
			// Setup
			documentElement.appendChild( container );
	
			div.style.cssText =
	
				// Support: Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:border-box;box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
	
			// Support: IE<9
			// Assume reasonable values in the absence of getComputedStyle
			pixelPositionVal = boxSizingReliableVal = reliableMarginLeftVal = false;
			pixelMarginRightVal = reliableMarginRightVal = true;
	
			// Check for getComputedStyle so that this code is not run in IE<9.
			if ( window.getComputedStyle ) {
				divStyle = window.getComputedStyle( div );
				pixelPositionVal = ( divStyle || {} ).top !== "1%";
				reliableMarginLeftVal = ( divStyle || {} ).marginLeft === "2px";
				boxSizingReliableVal = ( divStyle || { width: "4px" } ).width === "4px";
	
				// Support: Android 4.0 - 4.3 only
				// Some styles come back with percentage values, even though they shouldn't
				div.style.marginRight = "50%";
				pixelMarginRightVal = ( divStyle || { marginRight: "4px" } ).marginRight === "4px";
	
				// Support: Android 2.3 only
				// Div with explicit width and no margin-right incorrectly
				// gets computed margin-right based on width of container (#3333)
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				contents = div.appendChild( document.createElement( "div" ) );
	
				// Reset CSS: box-sizing; display; margin; border; padding
				contents.style.cssText = div.style.cssText =
	
					// Support: Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
					"box-sizing:content-box;display:block;margin:0;border:0;padding:0";
				contents.style.marginRight = contents.style.width = "0";
				div.style.width = "1px";
	
				reliableMarginRightVal =
					!parseFloat( ( window.getComputedStyle( contents ) || {} ).marginRight );
	
				div.removeChild( contents );
			}
	
			// Support: IE6-8
			// First check that getClientRects works as expected
			// Check if table cells still have offsetWidth/Height when they are set
			// to display:none and there are still other visible table cells in a
			// table row; if so, offsetWidth/Height are not reliable for use when
			// determining if an element has been hidden directly using
			// display:none (it is still safe to use offsets if a parent element is
			// hidden; don safety goggles and see bug #4512 for more information).
			div.style.display = "none";
			reliableHiddenOffsetsVal = div.getClientRects().length === 0;
			if ( reliableHiddenOffsetsVal ) {
				div.style.display = "";
				div.innerHTML = "<table><tr><td></td><td>t</td></tr></table>";
				div.childNodes[ 0 ].style.borderCollapse = "separate";
				contents = div.getElementsByTagName( "td" );
				contents[ 0 ].style.cssText = "margin:0;border:0;padding:0;display:none";
				reliableHiddenOffsetsVal = contents[ 0 ].offsetHeight === 0;
				if ( reliableHiddenOffsetsVal ) {
					contents[ 0 ].style.display = "";
					contents[ 1 ].style.display = "none";
					reliableHiddenOffsetsVal = contents[ 0 ].offsetHeight === 0;
				}
			}
	
			// Teardown
			documentElement.removeChild( container );
		}
	
	} )();
	
	
	var getStyles, curCSS,
		rposition = /^(top|right|bottom|left)$/;
	
	if ( window.getComputedStyle ) {
		getStyles = function( elem ) {
	
			// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
		curCSS = function( elem, name, computed ) {
			var width, minWidth, maxWidth, ret,
				style = elem.style;
	
			computed = computed || getStyles( elem );
	
			// getPropertyValue is only needed for .css('filter') in IE9, see #12537
			ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;
	
			// Support: Opera 12.1x only
			// Fall back to style even without computed
			// computed is undefined for elems on document fragments
			if ( ( ret === "" || ret === undefined ) && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			if ( computed ) {
	
				// A tribute to the "awesome hack by Dean Edwards"
				// Chrome < 17 and Safari 5.0 uses "computed value"
				// instead of "used value" for margin-right
				// Safari 5.1.7 (at least) returns percentage for a larger set of values,
				// but width seems to be reliably pixels
				// this is against the CSSOM draft spec:
				// http://dev.w3.org/csswg/cssom/#resolved-values
				if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
					// Remember the original values
					width = style.width;
					minWidth = style.minWidth;
					maxWidth = style.maxWidth;
	
					// Put in the new values to get a computed value out
					style.minWidth = style.maxWidth = style.width = ret;
					ret = computed.width;
	
					// Revert the changed values
					style.width = width;
					style.minWidth = minWidth;
					style.maxWidth = maxWidth;
				}
			}
	
			// Support: IE
			// IE returns zIndex value as an integer.
			return ret === undefined ?
				ret :
				ret + "";
		};
	} else if ( documentElement.currentStyle ) {
		getStyles = function( elem ) {
			return elem.currentStyle;
		};
	
		curCSS = function( elem, name, computed ) {
			var left, rs, rsLeft, ret,
				style = elem.style;
	
			computed = computed || getStyles( elem );
			ret = computed ? computed[ name ] : undefined;
	
			// Avoid setting ret to empty string here
			// so we don't default to auto
			if ( ret == null && style && style[ name ] ) {
				ret = style[ name ];
			}
	
			// From the awesome hack by Dean Edwards
			// http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	
			// If we're not dealing with a regular pixel number
			// but a number that has a weird ending, we need to convert it to pixels
			// but not position css attributes, as those are
			// proportional to the parent element instead
			// and we can't measure the parent instead because it
			// might trigger a "stacking dolls" problem
			if ( rnumnonpx.test( ret ) && !rposition.test( name ) ) {
	
				// Remember the original values
				left = style.left;
				rs = elem.runtimeStyle;
				rsLeft = rs && rs.left;
	
				// Put in the new values to get a computed value out
				if ( rsLeft ) {
					rs.left = elem.currentStyle.left;
				}
				style.left = name === "fontSize" ? "1em" : ret;
				ret = style.pixelLeft + "px";
	
				// Revert the changed values
				style.left = left;
				if ( rsLeft ) {
					rs.left = rsLeft;
				}
			}
	
			// Support: IE
			// IE returns zIndex value as an integer.
			return ret === undefined ?
				ret :
				ret + "" || "auto";
		};
	}
	
	
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
			ralpha = /alpha\([^)]*\)/i,
		ropacity = /opacity\s*=\s*([^)]*)/i,
	
		// swappable if display is none or starts with table except
		// "table", "table-cell", or "table-caption"
		// see here for display values:
		// https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rnumsplit = new RegExp( "^(" + pnum + ")(.*)$", "i" ),
	
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	
	// return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// check for vendor prefixed names
		var capName = name.charAt( 0 ).toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	function showHide( elements, show ) {
		var display, elem, hidden,
			values = [],
			index = 0,
			length = elements.length;
	
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			values[ index ] = jQuery._data( elem, "olddisplay" );
			display = elem.style.display;
			if ( show ) {
	
				// Reset the inline display of this element to learn if it is
				// being hidden by cascaded rules or not
				if ( !values[ index ] && display === "none" ) {
					elem.style.display = "";
				}
	
				// Set elements which have been overridden with display: none
				// in a stylesheet to whatever the default browser style is
				// for such an element
				if ( elem.style.display === "" && isHidden( elem ) ) {
					values[ index ] =
						jQuery._data( elem, "olddisplay", defaultDisplay( elem.nodeName ) );
				}
			} else {
				hidden = isHidden( elem );
	
				if ( display && display !== "none" || !hidden ) {
					jQuery._data(
						elem,
						"olddisplay",
						hidden ? display : jQuery.css( elem, "display" )
					);
				}
			}
		}
	
		// Set the display of most of the elements in a second loop
		// to avoid the constant reflow
		for ( index = 0; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
			if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
				elem.style.display = show ? values[ index ] || "" : "none";
			}
		}
	
		return elements;
	}
	
	function setPositiveNumber( elem, value, subtract ) {
		var matches = rnumsplit.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i = extra === ( isBorderBox ? "border" : "content" ) ?
	
			// If we already have the right measurement, avoid augmentation
			4 :
	
			// Otherwise initialize for horizontal or vertical properties
			name === "width" ? 1 : 0,
	
			val = 0;
	
		for ( ; i < 4; i += 2 ) {
	
			// both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// at this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// at this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// at this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var valueIsBorderBox = true,
			val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
			styles = getStyles( elem ),
			isBorderBox = support.boxSizing &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
	
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test( val ) ) {
				return val;
			}
	
			// we need the check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
	
			// normalize float css property
			"float": support.cssFloat ? "cssFloat" : "styleFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// gets hook for the prefixed version
			// followed by the unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set. See: #7116
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// Fixes #8908, it can be done more correctly by specifing setters in cssHooks,
				// but it would mean to define eight
				// (for every problematic property) identical functions
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					// Support: IE
					// Swallow errors from 'invalid' CSS values (#5509)
					try {
						style[ name ] = value;
					} catch ( e ) {}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var num, val, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// gets hook for the prefixed version
			// followed by the unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			//convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Return, converting to number if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// certain elements can have dimension info if we invisibly show them
					// however, it must have a current display style that would benefit from this
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
						elem.offsetWidth === 0 ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var styles = extra && getStyles( elem );
				return setPositiveNumber( elem, value, extra ?
					augmentWidthOrHeight(
						elem,
						name,
						extra,
						support.boxSizing &&
							jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					) : 0
				);
			}
		};
	} );
	
	if ( !support.opacity ) {
		jQuery.cssHooks.opacity = {
			get: function( elem, computed ) {
	
				// IE uses filters for opacity
				return ropacity.test( ( computed && elem.currentStyle ?
					elem.currentStyle.filter :
					elem.style.filter ) || "" ) ?
						( 0.01 * parseFloat( RegExp.$1 ) ) + "" :
						computed ? "1" : "";
			},
	
			set: function( elem, value ) {
				var style = elem.style,
					currentStyle = elem.currentStyle,
					opacity = jQuery.isNumeric( value ) ? "alpha(opacity=" + value * 100 + ")" : "",
					filter = currentStyle && currentStyle.filter || style.filter || "";
	
				// IE has trouble with opacity if it does not have layout
				// Force it by setting the zoom level
				style.zoom = 1;
	
				// if setting opacity to 1, and no other filters exist -
				// attempt to remove filter attribute #6652
				// if value === "", then remove inline opacity #12685
				if ( ( value >= 1 || value === "" ) &&
						jQuery.trim( filter.replace( ralpha, "" ) ) === "" &&
						style.removeAttribute ) {
	
					// Setting style.filter to null, "" & " " still leave "filter:" in the cssText
					// if "filter:" is present at all, clearType is disabled, we want to avoid this
					// style.removeAttribute is IE Only, but so apparently is this code path...
					style.removeAttribute( "filter" );
	
					// if there is no filter style applied in a css rule
					// or unset inline opacity, we are done
					if ( value === "" || currentStyle && !currentStyle.filter ) {
						return;
					}
				}
	
				// otherwise, set new filter values
				style.filter = ralpha.test( filter ) ?
					filter.replace( ralpha, opacity ) :
					filter + " " + opacity;
			}
		};
	}
	
	jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
		function( elem, computed ) {
			if ( computed ) {
				return swap( elem, { "display": "inline-block" },
					curCSS, [ elem, "marginRight" ] );
			}
		}
	);
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return (
					parseFloat( curCSS( elem, "marginLeft" ) ) ||
	
					// Support: IE<=11+
					// Running getBoundingClientRect on a disconnected node in IE throws an error
					// Support: IE8 only
					// getClientRects() errors on disconnected elems
					( jQuery.contains( elem.ownerDocument, elem ) ?
						elem.getBoundingClientRect().left -
							swap( elem, { marginLeft: 0 }, function() {
								return elem.getBoundingClientRect().left;
							} ) :
						0
					)
				) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		},
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHidden( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails
				// so, simple values such as "10px" are parsed to Float.
				// complex values such as "rotate(1rad)" are returned as is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// use step hook for back compat - use cssHook if its there - use .style if its
				// available and use plain properties where available
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9
	// Panic based approach to setting things on disconnected nodes
	
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back Compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			attrs = { height: type },
			i = 0;
	
		// if we include width, step value is 1 to do all cssExpand values,
		// if we don't include width, step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4 ; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// we're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		/* jshint validthis: true */
		var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHidden( elem ),
			dataShow = jQuery._data( elem, "fxshow" );
	
		// handle queue: false promises
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// doing this makes sure that the complete handler will be called
				// before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// height/width overflow pass
		if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
	
			// Make sure that nothing sneaks out
			// Record all 3 overflow attributes because IE does not
			// change the overflow attribute when overflowX and
			// overflowY are set to the same value
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Set display property to inline-block for height/width
			// animations on inline elements that are having width/height animated
			display = jQuery.css( elem, "display" );
	
			// Test default display if display is currently "none"
			checkDisplay = display === "none" ?
				jQuery._data( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;
	
			if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
	
				// inline-level elements accept inline-block;
				// block-level elements need to be inline with layout
				if ( !support.inlineBlockNeedsLayout || defaultDisplay( elem.nodeName ) === "inline" ) {
					style.display = "inline-block";
				} else {
					style.zoom = 1;
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			if ( !support.shrinkWrapBlocks() ) {
				anim.always( function() {
					style.overflow = opts.overflow[ 0 ];
					style.overflowX = opts.overflow[ 1 ];
					style.overflowY = opts.overflow[ 2 ];
				} );
			}
		}
	
		// show/hide pass
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.exec( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// If there is dataShow left over from a stopped hide or show
					// and we are going to proceed with show, we should pretend to be hidden
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
	
			// Any non-fx value stops us from restoring the original display value
			} else {
				display = undefined;
			}
		}
	
		if ( !jQuery.isEmptyObject( orig ) ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = jQuery._data( elem, "fxshow", {} );
			}
	
			// store state if its toggle - enables .stop().toggle() to "reverse"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}
			if ( hidden ) {
				jQuery( elem ).show();
			} else {
				anim.done( function() {
					jQuery( elem ).hide();
				} );
			}
			anim.done( function() {
				var prop;
				jQuery._removeData( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
			for ( prop in orig ) {
				tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
	
				if ( !( prop in dataShow ) ) {
					dataShow[ prop ] = tween.start;
					if ( hidden ) {
						tween.end = tween.start;
						tween.start = prop === "width" || prop === "height" ? 1 : 0;
					}
				}
			}
	
		// If this is a noop like .hide().hide(), restore an overwritten display value
		} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
			style.display = display;
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// not quite $.extend, this wont overwrite keys already present.
				// also - reusing 'index' from above because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// if we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length ; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// resolve when we played the last frame
					// otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length ; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnotwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length ; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
			opt.duration in jQuery.fx.speeds ?
				jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;
	
		// normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// show any hidden elements after setting opacity to 0
			return this.filter( isHidden ).css( "opacity", 0 ).show()
	
				// animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || jQuery._data( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = jQuery._data( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// start the next in the queue if the last step wasn't forced
				// timers currently will call their complete callbacks, which will dequeue
				// but only if they were gotoEnd
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = jQuery._data( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// enable finishing flag on private data
				data.finish = true;
	
				// empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			timers = jQuery.timers,
			i = 0;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		window.clearInterval( timerId );
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var a,
			input = document.createElement( "input" ),
			div = document.createElement( "div" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		// Setup
		div = document.createElement( "div" );
		div.setAttribute( "className", "t" );
		div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
		a = div.getElementsByTagName( "a" )[ 0 ];
	
		// Support: Windows Web Apps (WWA)
		// `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "checkbox" );
		div.appendChild( input );
	
		a = div.getElementsByTagName( "a" )[ 0 ];
	
		// First batch of tests.
		a.style.cssText = "top:1px";
	
		// Test setAttribute on camelCase class.
		// If it works, we need attrFixes when doing get/setAttribute (ie6/7)
		support.getSetAttribute = div.className !== "t";
	
		// Get the style information from getAttribute
		// (IE uses .cssText instead)
		support.style = /top/.test( a.getAttribute( "style" ) );
	
		// Make sure that URLs aren't manipulated
		// (IE normalizes it by default)
		support.hrefNormalized = a.getAttribute( "href" ) === "/a";
	
		// Check the default checkbox/radio value ("" on WebKit; "on" elsewhere)
		support.checkOn = !!input.value;
	
		// Make sure that a selected-by-default option has a working selected property.
		// (WebKit defaults to false instead of true, IE too, if it's in an optgroup)
		support.optSelected = opt.selected;
	
		// Tests for enctype support on a form (#6743)
		support.enctype = !!document.createElement( "form" ).enctype;
	
		// Make sure that the options inside disabled selects aren't marked as disabled
		// (WebKit marks them as disabled)
		select.disabled = true;
		support.optDisabled = !opt.disabled;
	
		// Support: IE8 only
		// Check if we can trust getAttribute("value")
		input = document.createElement( "input" );
		input.setAttribute( "value", "" );
		support.input = input.getAttribute( "value" ) === "";
	
		// Check if an input maintains its value after becoming a radio
		input.value = "t";
		input.setAttribute( "type", "radio" );
		support.radioValue = input.value === "t";
	} )();
	
	
	var rreturn = /\r/g,
		rspaces = /[\x20\t\r\n\f]+/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if (
						hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					return typeof ret === "string" ?
	
						// handle most common string cases
						ret.replace( rreturn, "" ) :
	
						// handle cases where value is null/undef or number
						ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
				} else if ( typeof val === "number" ) {
					val += "";
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE10-11+
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						jQuery.trim( jQuery.text( elem ) ).replace( rspaces, " " );
				}
			},
			select: {
				get: function( elem ) {
					var value, option,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one" || index < 0,
						values = one ? null : [],
						max = one ? index + 1 : options.length,
						i = index < 0 ?
							max :
							one ? index : 0;
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// oldIE doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								( support.optDisabled ?
									!option.disabled :
									option.getAttribute( "disabled" ) === null ) &&
								( !option.parentNode.disabled ||
									!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						if ( jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1 ) {
	
							// Support: IE6
							// When new option element is added to select box we need to
							// force reflow of newly added node in order to workaround delay
							// of initialization properties
							try {
								option.selected = optionSet = true;
	
							} catch ( _ ) {
	
								// Will be executed only in IE6
								option.scrollHeight;
							}
	
						} else {
							option.selected = false;
						}
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
	
					return options;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	var nodeHook, boolHook,
		attrHandle = jQuery.expr.attrHandle,
		ruseDefault = /^(?:checked|selected)$/i,
		getSetAttribute = support.getSetAttribute,
		getSetInput = support.input;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// All attributes are lowercase
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				name = name.toLowerCase();
				hooks = jQuery.attrHooks[ name ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : nodeHook );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
	
						// Setting the type on a radio button after the value resets the value in IE8-9
						// Reset value to default in case type is set after value during creation
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name, propName,
				i = 0,
				attrNames = value && value.match( rnotwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					propName = jQuery.propFix[ name ] || name;
	
					// Boolean attributes get special treatment (#10870)
					if ( jQuery.expr.match.bool.test( name ) ) {
	
						// Set corresponding property to false
						if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
							elem[ propName ] = false;
	
						// Support: IE<9
						// Also clear defaultChecked/defaultSelected (if appropriate)
						} else {
							elem[ jQuery.camelCase( "default-" + name ) ] =
								elem[ propName ] = false;
						}
	
					// See #9699 for explanation of this approach (setting first, then removal)
					} else {
						jQuery.attr( elem, name, "" );
					}
	
					elem.removeAttribute( getSetAttribute ? name : propName );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
	
				// IE<8 needs the *property* name
				elem.setAttribute( !getSetAttribute && jQuery.propFix[ name ] || name, name );
	
			} else {
	
				// Support: IE<9
				// Use defaultChecked and defaultSelected for oldIE
				elem[ jQuery.camelCase( "default-" + name ) ] = elem[ name ] = true;
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
			attrHandle[ name ] = function( elem, name, isXML ) {
				var ret, handle;
				if ( !isXML ) {
	
					// Avoid an infinite loop by temporarily removing this function from the getter
					handle = attrHandle[ name ];
					attrHandle[ name ] = ret;
					ret = getter( elem, name, isXML ) != null ?
						name.toLowerCase() :
						null;
					attrHandle[ name ] = handle;
				}
				return ret;
			};
		} else {
			attrHandle[ name ] = function( elem, name, isXML ) {
				if ( !isXML ) {
					return elem[ jQuery.camelCase( "default-" + name ) ] ?
						name.toLowerCase() :
						null;
				}
			};
		}
	} );
	
	// fix oldIE attroperties
	if ( !getSetInput || !getSetAttribute ) {
		jQuery.attrHooks.value = {
			set: function( elem, value, name ) {
				if ( jQuery.nodeName( elem, "input" ) ) {
	
					// Does not return so that setAttribute is also used
					elem.defaultValue = value;
				} else {
	
					// Use nodeHook if defined (#1954); otherwise setAttribute is fine
					return nodeHook && nodeHook.set( elem, value, name );
				}
			}
		};
	}
	
	// IE6/7 do not support getting/setting some attributes with get/setAttribute
	if ( !getSetAttribute ) {
	
		// Use this for any attribute in IE6/7
		// This fixes almost every IE6/7 issue
		nodeHook = {
			set: function( elem, value, name ) {
	
				// Set the existing or create a new attribute node
				var ret = elem.getAttributeNode( name );
				if ( !ret ) {
					elem.setAttributeNode(
						( ret = elem.ownerDocument.createAttribute( name ) )
					);
				}
	
				ret.value = value += "";
	
				// Break association with cloned elements by also using setAttribute (#9646)
				if ( name === "value" || value === elem.getAttribute( name ) ) {
					return value;
				}
			}
		};
	
		// Some attributes are constructed with empty-string values when not defined
		attrHandle.id = attrHandle.name = attrHandle.coords =
			function( elem, name, isXML ) {
				var ret;
				if ( !isXML ) {
					return ( ret = elem.getAttributeNode( name ) ) && ret.value !== "" ?
						ret.value :
						null;
				}
			};
	
		// Fixing value retrieval on a button requires this module
		jQuery.valHooks.button = {
			get: function( elem, name ) {
				var ret = elem.getAttributeNode( name );
				if ( ret && ret.specified ) {
					return ret.value;
				}
			},
			set: nodeHook.set
		};
	
		// Set contenteditable to false on removals(#10429)
		// Setting to empty string throws an error as an invalid value
		jQuery.attrHooks.contenteditable = {
			set: function( elem, value, name ) {
				nodeHook.set( elem, value === "" ? false : value, name );
			}
		};
	
		// Set width and height to auto instead of 0 on empty string( Bug #8150 )
		// This is for removals
		jQuery.each( [ "width", "height" ], function( i, name ) {
			jQuery.attrHooks[ name ] = {
				set: function( elem, value ) {
					if ( value === "" ) {
						elem.setAttribute( name, "auto" );
						return value;
					}
				}
			};
		} );
	}
	
	if ( !support.style ) {
		jQuery.attrHooks.style = {
			get: function( elem ) {
	
				// Return undefined in the case of empty string
				// Note: IE uppercases css property names, but if we were to .toLowerCase()
				// .cssText, that would destroy case sensitivity in URL's, like in "background"
				return elem.style.cssText || undefined;
			},
			set: function( elem, value ) {
				return ( elem.style.cssText = value + "" );
			}
		};
	}
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button|object)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			name = jQuery.propFix[ name ] || name;
			return this.each( function() {
	
				// try/catch handles cases where IE balks (such as removing a property on window)
				try {
					this[ name ] = undefined;
					delete this[ name ];
				} catch ( e ) {}
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					return tabindex ?
						parseInt( tabindex, 10 ) :
						rfocusable.test( elem.nodeName ) ||
							rclickable.test( elem.nodeName ) && elem.href ?
								0 :
								-1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Some attributes require a special call on IE
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !support.hrefNormalized ) {
	
		// href/src property should get the full normalized URL (#10299/#12915)
		jQuery.each( [ "href", "src" ], function( i, name ) {
			jQuery.propHooks[ name ] = {
				get: function( elem ) {
					return elem.getAttribute( name, 4 );
				}
			};
		} );
	}
	
	// Support: Safari, IE9+
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
				var parent = elem.parentNode;
	
				if ( parent ) {
					parent.selectedIndex;
	
					// Make sure that it also works with optgroups, see #5701
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
				return null;
			},
			set: function( elem ) {
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	// IE6/7 call enctype encoding
	if ( !support.enctype ) {
		jQuery.propFix.enctype = "encoding";
	}
	
	
	
	
	var rclass = /[\t\r\n\f]/g;
	
	function getClass( elem ) {
		return jQuery.attr( elem, "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							jQuery.attr( elem, "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							jQuery.attr( elem, "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnotwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// store className if set
						jQuery._data( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed "false",
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					jQuery.attr( this, "class",
						className || value === false ?
						"" :
						jQuery._data( this, "__className__" ) || ""
					);
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + getClass( elem ) + " " ).replace( rclass, " " )
						.indexOf( className ) > -1
				) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	var rvalidtokens = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
	
	jQuery.parseJSON = function( data ) {
	
		// Attempt to parse using the native JSON parser first
		if ( window.JSON && window.JSON.parse ) {
	
			// Support: Android 2.3
			// Workaround failure to string-cast null input
			return window.JSON.parse( data + "" );
		}
	
		var requireNonComma,
			depth = null,
			str = jQuery.trim( data + "" );
	
		// Guard against invalid (and possibly dangerous) input by ensuring that nothing remains
		// after removing valid tokens
		return str && !jQuery.trim( str.replace( rvalidtokens, function( token, comma, open, close ) {
	
			// Force termination if we see a misplaced comma
			if ( requireNonComma && comma ) {
				depth = 0;
			}
	
			// Perform no more replacements after returning to outermost depth
			if ( depth === 0 ) {
				return token;
			}
	
			// Commas must not follow "[", "{", or ","
			requireNonComma = open || comma;
	
			// Determine new depth
			// array/object open ("[" or "{"): depth += true - false (increment)
			// array/object close ("]" or "}"): depth += false - true (decrement)
			// other cases ("," or primitive): depth += true - true (numeric cast)
			depth += !close - !open;
	
			// Remove this token
			return "";
		} ) ) ?
			( Function( "return " + str ) )() :
			jQuery.error( "Invalid JSON: " + data );
	};
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, tmp;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		try {
			if ( window.DOMParser ) { // Standard
				tmp = new window.DOMParser();
				xml = tmp.parseFromString( data, "text/xml" );
			} else { // IE
				xml = new window.ActiveXObject( "Microsoft.XMLDOM" );
				xml.async = "false";
				xml.loadXML( data );
			}
		} catch ( e ) {
			xml = undefined;
		}
		if ( !xml || !xml.documentElement || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rhash = /#.*$/,
		rts = /([?&])_=[^&]*/,
	
		// IE leaves an \r character at EOL
		rheaders = /^(.*?):[ \t]*([^\r\n]*)\r?$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
		rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Document location
		ajaxLocation = location.href,
	
		// Segment location into parts
		ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType.charAt( 0 ) === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var deep, key,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
		var firstDataType, ct, finalDataType, type,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s[ "throws" ] ) { // jscs:ignore requireDotNotation
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: ajaxLocation,
			type: "GET",
			isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": jQuery.parseJSON,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var
	
				// Cross-domain detection vars
				parts,
	
				// Loop variable
				i,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers as string
				responseHeadersString,
	
				// timeout handle
				timeoutTimer,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				transport,
	
				// Response headers
				responseHeaders,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// The jqXHR state
				state = 0,
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( state === 2 ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return state === 2 ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						var lname = name.toLowerCase();
						if ( !state ) {
							name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( !state ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( state < 2 ) {
								for ( code in map ) {
	
									// Lazy-add the new callback in a way that preserves old ones
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							} else {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR ).complete = completeDeferred.add;
			jqXHR.success = jqXHR.done;
			jqXHR.error = jqXHR.fail;
	
			// Remove hash character (#7531: and string promotion)
			// Add protocol if not provided (#5866: IE7 issue with protocol-less urls)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || ajaxLocation ) + "" )
				.replace( rhash, "" )
				.replace( rprotocol, ajaxLocParts[ 1 ] + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];
	
			// A cross-domain request is in order when we have a protocol:host:port mismatch
			if ( s.crossDomain == null ) {
				parts = rurl.exec( s.url.toLowerCase() );
				s.crossDomain = !!( parts &&
					( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
						( parts[ 3 ] || ( parts[ 1 ] === "http:" ? "80" : "443" ) ) !==
							( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? "80" : "443" ) ) )
				);
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( state === 2 ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			cacheURL = s.url;
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add anti-cache in url if needed
				if ( s.cache === false ) {
					s.url = rts.test( cacheURL ) ?
	
						// If there is already a '_' parameter, set its value
						cacheURL.replace( rts, "$1_=" + nonce++ ) :
	
						// Otherwise add one to the end
						cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
				}
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			for ( i in { success: 1, error: 1, complete: 1 } ) {
				jqXHR[ i ]( s[ i ] );
			}
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( state === 2 ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					state = 1;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Propagate exception as error if not done
					if ( state < 2 ) {
						done( -1, e );
	
					// Simply rethrow otherwise
					} else {
						throw e;
					}
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Called once
				if ( state === 2 ) {
					return;
				}
	
				// State is "done" now
				state = 2;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// We extract error from statusText
					// then normalize statusText and status for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapAll( html.call( this, i ) );
				} );
			}
	
			if ( this[ 0 ] ) {
	
				// The elements to wrap the target around
				var wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstChild && elem.firstChild.nodeType === 1 ) {
						elem = elem.firstChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function() {
			return this.parent().each( function() {
				if ( !jQuery.nodeName( this, "body" ) ) {
					jQuery( this ).replaceWith( this.childNodes );
				}
			} ).end();
		}
	} );
	
	
	function getDisplay( elem ) {
		return elem.style && elem.style.display || jQuery.css( elem, "display" );
	}
	
	function filterHidden( elem ) {
	
		// Disconnected elements are considered hidden
		if ( !jQuery.contains( elem.ownerDocument || document, elem ) ) {
			return true;
		}
		while ( elem && elem.nodeType === 1 ) {
			if ( getDisplay( elem ) === "none" || elem.type === "hidden" ) {
				return true;
			}
			elem = elem.parentNode;
		}
		return false;
	}
	
	jQuery.expr.filters.hidden = function( elem ) {
	
		// Support: Opera <= 12.12
		// Opera reports offsetWidths and offsetHeights less than zero on some elements
		return support.reliableHiddenOffsets() ?
			( elem.offsetWidth <= 0 && elem.offsetHeight <= 0 &&
				!elem.getClientRects().length ) :
				filterHidden( elem );
	};
	
	jQuery.expr.filters.visible = function( elem ) {
		return !jQuery.expr.filters.hidden( elem );
	};
	
	
	
	
	var r20 = /%20/g,
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, value ) {
	
				// If value is a function, invoke it and return its value
				value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
				s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
			};
	
		// Set traditional to true for jQuery <= 1.3.2 behavior.
		if ( traditional === undefined ) {
			traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" ).replace( r20, "+" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is(":disabled") so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				return val == null ?
					null :
					jQuery.isArray( val ) ?
						jQuery.map( val, function( val ) {
							return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
						} ) :
						{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	// Create the request object
	// (This is still attached to ajaxSettings for backward compatibility)
	jQuery.ajaxSettings.xhr = window.ActiveXObject !== undefined ?
	
		// Support: IE6-IE8
		function() {
	
			// XHR cannot access local files, always use ActiveX for that case
			if ( this.isLocal ) {
				return createActiveXHR();
			}
	
			// Support: IE 9-11
			// IE seems to error on cross-domain PATCH requests when ActiveX XHR
			// is used. In IE 9+ always use the native XHR.
			// Note: this condition won't catch Edge as it doesn't define
			// document.documentMode but it also doesn't support ActiveX so it won't
			// reach this code.
			if ( document.documentMode > 8 ) {
				return createStandardXHR();
			}
	
			// Support: IE<9
			// oldIE XHR does not support non-RFC2616 methods (#13240)
			// See http://msdn.microsoft.com/en-us/library/ie/ms536648(v=vs.85).aspx
			// and http://www.w3.org/Protocols/rfc2616/rfc2616-sec9.html#sec9
			// Although this check for six methods instead of eight
			// since IE also does not support "trace" and "connect"
			return /^(get|post|head|put|delete|options)$/i.test( this.type ) &&
				createStandardXHR() || createActiveXHR();
		} :
	
		// For all other browsers, use the standard XMLHttpRequest object
		createStandardXHR;
	
	var xhrId = 0,
		xhrCallbacks = {},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	// Support: IE<10
	// Open requests must be manually aborted on unload (#5280)
	// See https://support.microsoft.com/kb/2856746 for more info
	if ( window.attachEvent ) {
		window.attachEvent( "onunload", function() {
			for ( var key in xhrCallbacks ) {
				xhrCallbacks[ key ]( undefined, true );
			}
		} );
	}
	
	// Determine support properties
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	xhrSupported = support.ajax = !!xhrSupported;
	
	// Create transport if the browser can provide an xhr
	if ( xhrSupported ) {
	
		jQuery.ajaxTransport( function( options ) {
	
			// Cross domain only allowed if supported through XMLHttpRequest
			if ( !options.crossDomain || support.cors ) {
	
				var callback;
	
				return {
					send: function( headers, complete ) {
						var i,
							xhr = options.xhr(),
							id = ++xhrId;
	
						// Open the socket
						xhr.open(
							options.type,
							options.url,
							options.async,
							options.username,
							options.password
						);
	
						// Apply custom fields if provided
						if ( options.xhrFields ) {
							for ( i in options.xhrFields ) {
								xhr[ i ] = options.xhrFields[ i ];
							}
						}
	
						// Override mime type if needed
						if ( options.mimeType && xhr.overrideMimeType ) {
							xhr.overrideMimeType( options.mimeType );
						}
	
						// X-Requested-With header
						// For cross-domain requests, seeing as conditions for a preflight are
						// akin to a jigsaw puzzle, we simply never set it to be sure.
						// (it can always be set on a per-request basis or even using ajaxSetup)
						// For same-domain requests, won't change header if already provided.
						if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
							headers[ "X-Requested-With" ] = "XMLHttpRequest";
						}
	
						// Set headers
						for ( i in headers ) {
	
							// Support: IE<9
							// IE's ActiveXObject throws a 'Type Mismatch' exception when setting
							// request header to a null-value.
							//
							// To keep consistent with other XHR implementations, cast the value
							// to string and ignore `undefined`.
							if ( headers[ i ] !== undefined ) {
								xhr.setRequestHeader( i, headers[ i ] + "" );
							}
						}
	
						// Do send the request
						// This may raise an exception which is actually
						// handled in jQuery.ajax (so no try/catch here)
						xhr.send( ( options.hasContent && options.data ) || null );
	
						// Listener
						callback = function( _, isAbort ) {
							var status, statusText, responses;
	
							// Was never called and is aborted or complete
							if ( callback && ( isAbort || xhr.readyState === 4 ) ) {
	
								// Clean up
								delete xhrCallbacks[ id ];
								callback = undefined;
								xhr.onreadystatechange = jQuery.noop;
	
								// Abort manually if needed
								if ( isAbort ) {
									if ( xhr.readyState !== 4 ) {
										xhr.abort();
									}
								} else {
									responses = {};
									status = xhr.status;
	
									// Support: IE<10
									// Accessing binary-data responseText throws an exception
									// (#11426)
									if ( typeof xhr.responseText === "string" ) {
										responses.text = xhr.responseText;
									}
	
									// Firefox throws an exception when accessing
									// statusText for faulty cross-domain requests
									try {
										statusText = xhr.statusText;
									} catch ( e ) {
	
										// We normalize with Webkit giving an empty statusText
										statusText = "";
									}
	
									// Filter status for non standard behaviors
	
									// If the request is local and we have data: assume a success
									// (success with no data won't get notified, that's the best we
									// can do given current implementations)
									if ( !status && options.isLocal && !options.crossDomain ) {
										status = responses.text ? 200 : 404;
	
									// IE - #1450: sometimes returns 1223 when it should be 204
									} else if ( status === 1223 ) {
										status = 204;
									}
								}
							}
	
							// Call complete if needed
							if ( responses ) {
								complete( status, statusText, responses, xhr.getAllResponseHeaders() );
							}
						};
	
						// Do send the request
						// `xhr.send` may raise an exception, but it will be
						// handled in jQuery.ajax (so no try/catch here)
						if ( !options.async ) {
	
							// If we're in sync mode we fire the callback
							callback();
						} else if ( xhr.readyState === 4 ) {
	
							// (IE6 & IE7) if it's in cache and has been
							// retrieved directly we need to fire the callback
							window.setTimeout( callback );
						} else {
	
							// Register the callback, but delay it in case `xhr.send` throws
							// Add to the list of active xhr callbacks
							xhr.onreadystatechange = xhrCallbacks[ id ] = callback;
						}
					},
	
					abort: function() {
						if ( callback ) {
							callback( undefined, true );
						}
					}
				};
			}
		} );
	}
	
	// Functions to create xhrs
	function createStandardXHR() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	}
	
	function createActiveXHR() {
		try {
			return new window.ActiveXObject( "Microsoft.XMLHTTP" );
		} catch ( e ) {}
	}
	
	
	
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and global
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
			s.global = false;
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
	
			var script,
				head = document.head || jQuery( "head" )[ 0 ] || document.documentElement;
	
			return {
	
				send: function( _, callback ) {
	
					script = document.createElement( "script" );
	
					script.async = true;
	
					if ( s.scriptCharset ) {
						script.charset = s.scriptCharset;
					}
	
					script.src = s.url;
	
					// Attach handlers for all browsers
					script.onload = script.onreadystatechange = function( _, isAbort ) {
	
						if ( isAbort || !script.readyState || /loaded|complete/.test( script.readyState ) ) {
	
							// Handle memory leak in IE
							script.onload = script.onreadystatechange = null;
	
							// Remove the script
							if ( script.parentNode ) {
								script.parentNode.removeChild( script );
							}
	
							// Dereference the script
							script = null;
	
							// Callback if not abort
							if ( !isAbort ) {
								callback( 200, "success" );
							}
						}
					};
	
					// Circumvent IE6 bugs with base elements (#2709 and #4378) by prepending
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					head.insertBefore( script, head.firstChild );
				},
	
				abort: function() {
					if ( script ) {
						script.onload( undefined, true );
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// data: string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
		context = context || document;
	
		var parsed = rsingleTag.exec( data ),
			scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	// Keep a copy of the old load method
	var _load = jQuery.fn.load;
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		if ( typeof url !== "string" && _load ) {
			return _load.apply( this, arguments );
		}
	
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = jQuery.trim( url.slice( off, url.length ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.filters.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ?
			elem :
			elem.nodeType === 9 ?
				elem.defaultView || elem.parentWindow :
				false;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				jQuery.inArray( "auto", [ curCSSTop, curCSSLeft ] ) > -1;
	
			// need to be able to calculate position if either top or left
			// is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var docElem, win,
				box = { top: 0, left: 0 },
				elem = this[ 0 ],
				doc = elem && elem.ownerDocument;
	
			if ( !doc ) {
				return;
			}
	
			docElem = doc.documentElement;
	
			// Make sure it's not a disconnected DOM node
			if ( !jQuery.contains( docElem, elem ) ) {
				return box;
			}
	
			// If we don't have gBCR, just use 0,0 rather than error
			// BlackBerry 5, iOS 3 (original iPhone)
			if ( typeof elem.getBoundingClientRect !== "undefined" ) {
				box = elem.getBoundingClientRect();
			}
			win = getWindow( doc );
			return {
				top: box.top  + ( win.pageYOffset || docElem.scrollTop )  - ( docElem.clientTop  || 0 ),
				left: box.left + ( win.pageXOffset || docElem.scrollLeft ) - ( docElem.clientLeft || 0 )
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				parentOffset = { top: 0, left: 0 },
				elem = this[ 0 ];
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// we assume that getBoundingClientRect is available when computed position is fixed
				offset = elem.getBoundingClientRect();
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset.top  += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
			}
	
			// Subtract parent offsets and element margins
			// note: when an element has margin: auto the offsetLeft and marginLeft
			// are the same in Safari causing offset.left to incorrectly be 0
			return {
				top:  offset.top  - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && ( !jQuery.nodeName( offsetParent, "html" ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) ) {
					offsetParent = offsetParent.offsetParent;
				}
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = /Y/.test( prop );
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? ( prop in win ) ? win[ prop ] :
						win.document.documentElement[ method ] :
						elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : jQuery( win ).scrollLeft(),
						top ? val : jQuery( win ).scrollTop()
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length, null );
		};
	} );
	
	// Support: Safari<7-8+, Chrome<37-44+
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// getComputedStyle returns percent when specified for top/left/bottom/right
	// rather than make the css module depend on the offset module, we just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// if curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {
	
			// margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
						// isn't a whole lot we can do. See pull request at this URL for discussion:
						// https://github.com/jquery/jquery/pull/764
						return elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						// unfortunately, this causes bug #3838 in IE6/8 only,
						// but there is currently no good, small way to fix it.
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable, null );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	// The number of elements contained in the matched element set
	jQuery.fn.size = function() {
		return this.length;
	};
	
	jQuery.fn.andSelf = jQuery.fn.addBack;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in
	// AMD (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	return jQuery;
	}));


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	__webpack_require__(13);
	
	__webpack_require__(16);
	
	__webpack_require__(20);
	
	var _nats = __webpack_require__(190);
	
	// iframe标记
	window.IS_IFRAME = window.self !== window.top;
	
	switch (window.MUDU_SERVER_ENV) {
	    case 'UAT':
	        // uat环境要重设ws域名
	        window.NAT_SERVERS = ['wss://mdl-ws-msg.uat.mudu.tv'];
	        window.IM_SERVER = 'wss://mdl-live-msg.uat.mudu.tv/sub';
	        break;
	    case 'TEST':
	        window.NAT_SERVERS = ['wss://mdl-ws-msg.test.mudu.tv'];
	        // window.IM_SERVER = 'wss://mdl-live-msg.test.mudu.tv/sub'; // 腾讯test，websdk暂时不加这个环境
	        window.IM_SERVER = 'wss://testsvc-3.mudu.tv/sub';
	        break;
	    case 'TX_PROD':
	    case 'PROD':
	    default:
	        // tx环境要重设ws域名
	        window.NAT_SERVERS = ['wss://msg-ws.mudu.tv'];
	        window.IM_SERVER = 'wss://live-msg.mudu.tv/sub';
	}
	
	__webpack_require__(191);
	(0, _nats.createNatsClient)();
	
	if (typeof window.Mudu === 'undefined') {
	    window.Mudu = _scope.Entry;
	}


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {if(!global["_scope"]) global["_scope"] = {};
	module.exports = global["_scope"]["Utils"] = __webpack_require__(14);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	var browser = __webpack_require__(15);
	
	exports.SetCookie = function (name, value) {
	    var Days = 30; //此 cookie 将被保存 30 天
	    var exp = new Date(); //new Date("December 31, 9998");
	    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
	    document.cookie = 'muduapi_' + name + '=' + encodeURIComponent(value) + ';expires=' + exp.toGMTString() + ';path=/';
	};
	exports.GetCookie = function (name) {
	    var arr = document.cookie.match(new RegExp('(^| )' + 'muduapi_' + name + '=([^;]*)(;|$)'));
	    if (arr != null) return decodeURIComponent(arr[2]);return null;
	};
	exports.DelCookie = function (name) {
	    var exp = new Date();
	    exp.setTime(exp.getTime() - 1);
	    var cval = exports.GetCookie(name);
	    if (cval != null) document.cookie = 'muduapi_' + name + '=' + cval + ';expires=' + exp.toGMTString();
	};
	
	exports.GetRandomNum = function (Max, Min) {
	    var Range = Max - Min;
	    var Rand = Math.random();
	    return Min + Math.round(Rand * Range);
	};
	
	exports.Guid = function () {
	    function s4() {
	        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	    }
	    return s4() + s4() + s4() + s4() + s4();
	};
	
	exports.GetAbsoluteUrl = function (_ref) {
	    var url = _ref.url,
	        domain = _ref.domain,
	        https = _ref.https,
	        http = _ref.http;
	
	    https = https || false;
	    http = http || false;
	    domain = domain || '';
	    if (url.indexOf('//') === 0 || url.indexOf('http') === 0) {
	        return url;
	    }
	    if (http) {
	        return 'http://' + domain + url;
	    }
	    if (https) {
	        return 'https://' + domain + url;
	    }
	    return '//' + domain + url;
	};
	
	exports.GetPrimarySocialLoginType = function (loginType) {
	    var primarySocialLoginType = exports.GetSocialLoginTypeByEnvor();
	    return primarySocialLoginType || loginType;
	};
	
	exports.GetSocialLoginTypeByEnvor = function () {
	    if (browser.isWechat()) {
	        return 'weixin';
	    }
	    if (browser.isQQ()) {
	        return 'qq';
	    }
	    return 'weibo';
	};
	
	exports.addEventListener = function (dom, evt, cb) {
	    if (window.addEventListener) {
	        dom.addEventListener(evt, cb);
	    } else if (window.attachEvent) {
	        dom.attachEvent(evt, cb);
	    }
	};
	
	exports.transformTimeStrToNumber = function (timeStr) {
	    if ('number' === typeof timeStr) {
	        return timeStr;
	    } else if ('string' === typeof timeStr && timeStr.indexOf(':') !== -1) {
	        return timeStr.split(':').reduce(function (sum, v, i) {
	            return sum + +v * Math.pow(60, 2 - i);
	        }, 0);
	    }
	    return 0;
	};
	
	exports.getPlayUrl = function (video) {
	    var video1080p_url, video720p_url, video480p_url, video360p_url, video240p_url, videoOrigin_url;
	    var play_set = video.play_set;
	    play_set && play_set.length > 0 && play_set.forEach(function (item) {
	        item.resolution === '1080P' && (video1080p_url = item.url);
	        item.resolution === '720P' && (video720p_url = item.url);
	        item.resolution === '480P' && (video480p_url = item.url);
	        item.resolution === '360P' && (video360p_url = item.url);
	        item.resolution === '240P' && (video240p_url = item.url);
	        item.resolution.toLowerCase() === 'origin' && (videoOrigin_url = item.url);
	    });
	    return videoOrigin_url || video1080p_url || video720p_url || video480p_url || video360p_url || video240p_url || video.video_url || video.url;
	};


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	exports.isWindowsWechat = function () {
	    return (/windowswechat/i.test(navigator.userAgent)
	    );
	};
	
	exports.isWechat = function () {
	    return (/micromessenger/i.test(navigator.userAgent)
	    );
	};
	
	exports.isMobile = function () {
	    return (/(mobile|android|iphone|symbianos|ipad|ipod|windows phone)/i.test(navigator.userAgent)
	    );
	};
	
	exports.isMobileWechat = function () {
	    return exports.isWechat() && exports.isMobile();
	};
	
	exports.isQQ = function () {
	    var str = navigator.userAgent;
	    return (/sq/i.test(str) && /qq/i.test(str) && !exports.isWechat()
	    );
	};
	
	exports.isDingding = function () {
	    return (/dingtalk/i.test(navigator.userAgent)
	    );
	};


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["JSON"] = __webpack_require__(17);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! JSON v3.3.2 | http://bestiejs.github.io/json3 | Copyright 2012-2014, Kit Cambridge | http://kit.mit-license.org */
	;(function () {
	  // Detect the `define` function exposed by asynchronous module loaders. The
	  // strict `define` check is necessary for compatibility with `r.js`.
	  var isLoader = "function" === "function" && __webpack_require__(19);
	
	  // A set of types used to distinguish objects from primitives.
	  var objectTypes = {
	    "function": true,
	    "object": true
	  };
	
	  // Detect the `exports` object exposed by CommonJS implementations.
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  // Use the `global` object exposed by Node (including Browserify via
	  // `insert-module-globals`), Narwhal, and Ringo as the default context,
	  // and the `window` object in browsers. Rhino exports a `global` function
	  // instead.
	  var root = objectTypes[typeof window] && window || this,
	      freeGlobal = freeExports && objectTypes[typeof module] && module && !module.nodeType && typeof global == "object" && global;
	
	  if (freeGlobal && (freeGlobal["global"] === freeGlobal || freeGlobal["window"] === freeGlobal || freeGlobal["self"] === freeGlobal)) {
	    root = freeGlobal;
	  }
	
	  // Public: Initializes JSON 3 using the given `context` object, attaching the
	  // `stringify` and `parse` functions to the specified `exports` object.
	  function runInContext(context, exports) {
	    context || (context = root["Object"]());
	    exports || (exports = root["Object"]());
	
	    // Native constructor aliases.
	    var Number = context["Number"] || root["Number"],
	        String = context["String"] || root["String"],
	        Object = context["Object"] || root["Object"],
	        Date = context["Date"] || root["Date"],
	        SyntaxError = context["SyntaxError"] || root["SyntaxError"],
	        TypeError = context["TypeError"] || root["TypeError"],
	        Math = context["Math"] || root["Math"],
	        nativeJSON = context["JSON"] || root["JSON"];
	
	    // Delegate to the native `stringify` and `parse` implementations.
	    if (typeof nativeJSON == "object" && nativeJSON) {
	      exports.stringify = nativeJSON.stringify;
	      exports.parse = nativeJSON.parse;
	    }
	
	    // Convenience aliases.
	    var objectProto = Object.prototype,
	        getClass = objectProto.toString,
	        isProperty, forEach, undef;
	
	    // Test the `Date#getUTC*` methods. Based on work by @Yaffle.
	    var isExtended = new Date(-3509827334573292);
	    try {
	      // The `getUTCFullYear`, `Month`, and `Date` methods return nonsensical
	      // results for certain dates in Opera >= 10.53.
	      isExtended = isExtended.getUTCFullYear() == -109252 && isExtended.getUTCMonth() === 0 && isExtended.getUTCDate() === 1 &&
	        // Safari < 2.0.2 stores the internal millisecond time value correctly,
	        // but clips the values returned by the date methods to the range of
	        // signed 32-bit integers ([-2 ** 31, 2 ** 31 - 1]).
	        isExtended.getUTCHours() == 10 && isExtended.getUTCMinutes() == 37 && isExtended.getUTCSeconds() == 6 && isExtended.getUTCMilliseconds() == 708;
	    } catch (exception) {}
	
	    // Internal: Determines whether the native `JSON.stringify` and `parse`
	    // implementations are spec-compliant. Based on work by Ken Snyder.
	    function has(name) {
	      if (has[name] !== undef) {
	        // Return cached feature test result.
	        return has[name];
	      }
	      var isSupported;
	      if (name == "bug-string-char-index") {
	        // IE <= 7 doesn't support accessing string characters using square
	        // bracket notation. IE 8 only supports this for primitives.
	        isSupported = "a"[0] != "a";
	      } else if (name == "json") {
	        // Indicates whether both `JSON.stringify` and `JSON.parse` are
	        // supported.
	        isSupported = has("json-stringify") && has("json-parse");
	      } else {
	        var value, serialized = '{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';
	        // Test `JSON.stringify`.
	        if (name == "json-stringify") {
	          var stringify = exports.stringify, stringifySupported = typeof stringify == "function" && isExtended;
	          if (stringifySupported) {
	            // A test function object with a custom `toJSON` method.
	            (value = function () {
	              return 1;
	            }).toJSON = value;
	            try {
	              stringifySupported =
	                // Firefox 3.1b1 and b2 serialize string, number, and boolean
	                // primitives as object literals.
	                stringify(0) === "0" &&
	                // FF 3.1b1, b2, and JSON 2 serialize wrapped primitives as object
	                // literals.
	                stringify(new Number()) === "0" &&
	                stringify(new String()) == '""' &&
	                // FF 3.1b1, 2 throw an error if the value is `null`, `undefined`, or
	                // does not define a canonical JSON representation (this applies to
	                // objects with `toJSON` properties as well, *unless* they are nested
	                // within an object or array).
	                stringify(getClass) === undef &&
	                // IE 8 serializes `undefined` as `"undefined"`. Safari <= 5.1.7 and
	                // FF 3.1b3 pass this test.
	                stringify(undef) === undef &&
	                // Safari <= 5.1.7 and FF 3.1b3 throw `Error`s and `TypeError`s,
	                // respectively, if the value is omitted entirely.
	                stringify() === undef &&
	                // FF 3.1b1, 2 throw an error if the given value is not a number,
	                // string, array, object, Boolean, or `null` literal. This applies to
	                // objects with custom `toJSON` methods as well, unless they are nested
	                // inside object or array literals. YUI 3.0.0b1 ignores custom `toJSON`
	                // methods entirely.
	                stringify(value) === "1" &&
	                stringify([value]) == "[1]" &&
	                // Prototype <= 1.6.1 serializes `[undefined]` as `"[]"` instead of
	                // `"[null]"`.
	                stringify([undef]) == "[null]" &&
	                // YUI 3.0.0b1 fails to serialize `null` literals.
	                stringify(null) == "null" &&
	                // FF 3.1b1, 2 halts serialization if an array contains a function:
	                // `[1, true, getClass, 1]` serializes as "[1,true,],". FF 3.1b3
	                // elides non-JSON values from objects and arrays, unless they
	                // define custom `toJSON` methods.
	                stringify([undef, getClass, null]) == "[null,null,null]" &&
	                // Simple serialization test. FF 3.1b1 uses Unicode escape sequences
	                // where character escape codes are expected (e.g., `\b` => `\u0008`).
	                stringify({ "a": [value, true, false, null, "\x00\b\n\f\r\t"] }) == serialized &&
	                // FF 3.1b1 and b2 ignore the `filter` and `width` arguments.
	                stringify(null, value) === "1" &&
	                stringify([1, 2], null, 1) == "[\n 1,\n 2\n]" &&
	                // JSON 2, Prototype <= 1.7, and older WebKit builds incorrectly
	                // serialize extended years.
	                stringify(new Date(-8.64e15)) == '"-271821-04-20T00:00:00.000Z"' &&
	                // The milliseconds are optional in ES 5, but required in 5.1.
	                stringify(new Date(8.64e15)) == '"+275760-09-13T00:00:00.000Z"' &&
	                // Firefox <= 11.0 incorrectly serializes years prior to 0 as negative
	                // four-digit years instead of six-digit years. Credits: @Yaffle.
	                stringify(new Date(-621987552e5)) == '"-000001-01-01T00:00:00.000Z"' &&
	                // Safari <= 5.1.5 and Opera >= 10.53 incorrectly serialize millisecond
	                // values less than 1000. Credits: @Yaffle.
	                stringify(new Date(-1)) == '"1969-12-31T23:59:59.999Z"';
	            } catch (exception) {
	              stringifySupported = false;
	            }
	          }
	          isSupported = stringifySupported;
	        }
	        // Test `JSON.parse`.
	        if (name == "json-parse") {
	          var parse = exports.parse;
	          if (typeof parse == "function") {
	            try {
	              // FF 3.1b1, b2 will throw an exception if a bare literal is provided.
	              // Conforming implementations should also coerce the initial argument to
	              // a string prior to parsing.
	              if (parse("0") === 0 && !parse(false)) {
	                // Simple parsing test.
	                value = parse(serialized);
	                var parseSupported = value["a"].length == 5 && value["a"][0] === 1;
	                if (parseSupported) {
	                  try {
	                    // Safari <= 5.1.2 and FF 3.1b1 allow unescaped tabs in strings.
	                    parseSupported = !parse('"\t"');
	                  } catch (exception) {}
	                  if (parseSupported) {
	                    try {
	                      // FF 4.0 and 4.0.1 allow leading `+` signs and leading
	                      // decimal points. FF 4.0, 4.0.1, and IE 9-10 also allow
	                      // certain octal literals.
	                      parseSupported = parse("01") !== 1;
	                    } catch (exception) {}
	                  }
	                  if (parseSupported) {
	                    try {
	                      // FF 4.0, 4.0.1, and Rhino 1.7R3-R4 allow trailing decimal
	                      // points. These environments, along with FF 3.1b1 and 2,
	                      // also allow trailing commas in JSON objects and arrays.
	                      parseSupported = parse("1.") !== 1;
	                    } catch (exception) {}
	                  }
	                }
	              }
	            } catch (exception) {
	              parseSupported = false;
	            }
	          }
	          isSupported = parseSupported;
	        }
	      }
	      return has[name] = !!isSupported;
	    }
	
	    if (!has("json")) {
	      // Common `[[Class]]` name aliases.
	      var functionClass = "[object Function]",
	          dateClass = "[object Date]",
	          numberClass = "[object Number]",
	          stringClass = "[object String]",
	          arrayClass = "[object Array]",
	          booleanClass = "[object Boolean]";
	
	      // Detect incomplete support for accessing string characters by index.
	      var charIndexBuggy = has("bug-string-char-index");
	
	      // Define additional utility methods if the `Date` methods are buggy.
	      if (!isExtended) {
	        var floor = Math.floor;
	        // A mapping between the months of the year and the number of days between
	        // January 1st and the first of the respective month.
	        var Months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
	        // Internal: Calculates the number of days between the Unix epoch and the
	        // first day of the given month.
	        var getDay = function (year, month) {
	          return Months[month] + 365 * (year - 1970) + floor((year - 1969 + (month = +(month > 1))) / 4) - floor((year - 1901 + month) / 100) + floor((year - 1601 + month) / 400);
	        };
	      }
	
	      // Internal: Determines if a property is a direct property of the given
	      // object. Delegates to the native `Object#hasOwnProperty` method.
	      if (!(isProperty = objectProto.hasOwnProperty)) {
	        isProperty = function (property) {
	          var members = {}, constructor;
	          if ((members.__proto__ = null, members.__proto__ = {
	            // The *proto* property cannot be set multiple times in recent
	            // versions of Firefox and SeaMonkey.
	            "toString": 1
	          }, members).toString != getClass) {
	            // Safari <= 2.0.3 doesn't implement `Object#hasOwnProperty`, but
	            // supports the mutable *proto* property.
	            isProperty = function (property) {
	              // Capture and break the object's prototype chain (see section 8.6.2
	              // of the ES 5.1 spec). The parenthesized expression prevents an
	              // unsafe transformation by the Closure Compiler.
	              var original = this.__proto__, result = property in (this.__proto__ = null, this);
	              // Restore the original prototype chain.
	              this.__proto__ = original;
	              return result;
	            };
	          } else {
	            // Capture a reference to the top-level `Object` constructor.
	            constructor = members.constructor;
	            // Use the `constructor` property to simulate `Object#hasOwnProperty` in
	            // other environments.
	            isProperty = function (property) {
	              var parent = (this.constructor || constructor).prototype;
	              return property in this && !(property in parent && this[property] === parent[property]);
	            };
	          }
	          members = null;
	          return isProperty.call(this, property);
	        };
	      }
	
	      // Internal: Normalizes the `for...in` iteration algorithm across
	      // environments. Each enumerated key is yielded to a `callback` function.
	      forEach = function (object, callback) {
	        var size = 0, Properties, members, property;
	
	        // Tests for bugs in the current environment's `for...in` algorithm. The
	        // `valueOf` property inherits the non-enumerable flag from
	        // `Object.prototype` in older versions of IE, Netscape, and Mozilla.
	        (Properties = function () {
	          this.valueOf = 0;
	        }).prototype.valueOf = 0;
	
	        // Iterate over a new instance of the `Properties` class.
	        members = new Properties();
	        for (property in members) {
	          // Ignore all properties inherited from `Object.prototype`.
	          if (isProperty.call(members, property)) {
	            size++;
	          }
	        }
	        Properties = members = null;
	
	        // Normalize the iteration algorithm.
	        if (!size) {
	          // A list of non-enumerable properties inherited from `Object.prototype`.
	          members = ["valueOf", "toString", "toLocaleString", "propertyIsEnumerable", "isPrototypeOf", "hasOwnProperty", "constructor"];
	          // IE <= 8, Mozilla 1.0, and Netscape 6.2 ignore shadowed non-enumerable
	          // properties.
	          forEach = function (object, callback) {
	            var isFunction = getClass.call(object) == functionClass, property, length;
	            var hasProperty = !isFunction && typeof object.constructor != "function" && objectTypes[typeof object.hasOwnProperty] && object.hasOwnProperty || isProperty;
	            for (property in object) {
	              // Gecko <= 1.0 enumerates the `prototype` property of functions under
	              // certain conditions; IE does not.
	              if (!(isFunction && property == "prototype") && hasProperty.call(object, property)) {
	                callback(property);
	              }
	            }
	            // Manually invoke the callback for each non-enumerable property.
	            for (length = members.length; property = members[--length]; hasProperty.call(object, property) && callback(property));
	          };
	        } else if (size == 2) {
	          // Safari <= 2.0.4 enumerates shadowed properties twice.
	          forEach = function (object, callback) {
	            // Create a set of iterated properties.
	            var members = {}, isFunction = getClass.call(object) == functionClass, property;
	            for (property in object) {
	              // Store each property name to prevent double enumeration. The
	              // `prototype` property of functions is not enumerated due to cross-
	              // environment inconsistencies.
	              if (!(isFunction && property == "prototype") && !isProperty.call(members, property) && (members[property] = 1) && isProperty.call(object, property)) {
	                callback(property);
	              }
	            }
	          };
	        } else {
	          // No bugs detected; use the standard `for...in` algorithm.
	          forEach = function (object, callback) {
	            var isFunction = getClass.call(object) == functionClass, property, isConstructor;
	            for (property in object) {
	              if (!(isFunction && property == "prototype") && isProperty.call(object, property) && !(isConstructor = property === "constructor")) {
	                callback(property);
	              }
	            }
	            // Manually invoke the callback for the `constructor` property due to
	            // cross-environment inconsistencies.
	            if (isConstructor || isProperty.call(object, (property = "constructor"))) {
	              callback(property);
	            }
	          };
	        }
	        return forEach(object, callback);
	      };
	
	      // Public: Serializes a JavaScript `value` as a JSON string. The optional
	      // `filter` argument may specify either a function that alters how object and
	      // array members are serialized, or an array of strings and numbers that
	      // indicates which properties should be serialized. The optional `width`
	      // argument may be either a string or number that specifies the indentation
	      // level of the output.
	      if (!has("json-stringify")) {
	        // Internal: A map of control characters and their escaped equivalents.
	        var Escapes = {
	          92: "\\\\",
	          34: '\\"',
	          8: "\\b",
	          12: "\\f",
	          10: "\\n",
	          13: "\\r",
	          9: "\\t"
	        };
	
	        // Internal: Converts `value` into a zero-padded string such that its
	        // length is at least equal to `width`. The `width` must be <= 6.
	        var leadingZeroes = "000000";
	        var toPaddedString = function (width, value) {
	          // The `|| 0` expression is necessary to work around a bug in
	          // Opera <= 7.54u2 where `0 == -0`, but `String(-0) !== "0"`.
	          return (leadingZeroes + (value || 0)).slice(-width);
	        };
	
	        // Internal: Double-quotes a string `value`, replacing all ASCII control
	        // characters (characters with code unit values between 0 and 31) with
	        // their escaped equivalents. This is an implementation of the
	        // `Quote(value)` operation defined in ES 5.1 section 15.12.3.
	        var unicodePrefix = "\\u00";
	        var quote = function (value) {
	          var result = '"', index = 0, length = value.length, useCharIndex = !charIndexBuggy || length > 10;
	          var symbols = useCharIndex && (charIndexBuggy ? value.split("") : value);
	          for (; index < length; index++) {
	            var charCode = value.charCodeAt(index);
	            // If the character is a control character, append its Unicode or
	            // shorthand escape sequence; otherwise, append the character as-is.
	            switch (charCode) {
	              case 8: case 9: case 10: case 12: case 13: case 34: case 92:
	                result += Escapes[charCode];
	                break;
	              default:
	                if (charCode < 32) {
	                  result += unicodePrefix + toPaddedString(2, charCode.toString(16));
	                  break;
	                }
	                result += useCharIndex ? symbols[index] : value.charAt(index);
	            }
	          }
	          return result + '"';
	        };
	
	        // Internal: Recursively serializes an object. Implements the
	        // `Str(key, holder)`, `JO(value)`, and `JA(value)` operations.
	        var serialize = function (property, object, callback, properties, whitespace, indentation, stack) {
	          var value, className, year, month, date, time, hours, minutes, seconds, milliseconds, results, element, index, length, prefix, result;
	          try {
	            // Necessary for host object support.
	            value = object[property];
	          } catch (exception) {}
	          if (typeof value == "object" && value) {
	            className = getClass.call(value);
	            if (className == dateClass && !isProperty.call(value, "toJSON")) {
	              if (value > -1 / 0 && value < 1 / 0) {
	                // Dates are serialized according to the `Date#toJSON` method
	                // specified in ES 5.1 section 15.9.5.44. See section 15.9.1.15
	                // for the ISO 8601 date time string format.
	                if (getDay) {
	                  // Manually compute the year, month, date, hours, minutes,
	                  // seconds, and milliseconds if the `getUTC*` methods are
	                  // buggy. Adapted from @Yaffle's `date-shim` project.
	                  date = floor(value / 864e5);
	                  for (year = floor(date / 365.2425) + 1970 - 1; getDay(year + 1, 0) <= date; year++);
	                  for (month = floor((date - getDay(year, 0)) / 30.42); getDay(year, month + 1) <= date; month++);
	                  date = 1 + date - getDay(year, month);
	                  // The `time` value specifies the time within the day (see ES
	                  // 5.1 section 15.9.1.2). The formula `(A % B + B) % B` is used
	                  // to compute `A modulo B`, as the `%` operator does not
	                  // correspond to the `modulo` operation for negative numbers.
	                  time = (value % 864e5 + 864e5) % 864e5;
	                  // The hours, minutes, seconds, and milliseconds are obtained by
	                  // decomposing the time within the day. See section 15.9.1.10.
	                  hours = floor(time / 36e5) % 24;
	                  minutes = floor(time / 6e4) % 60;
	                  seconds = floor(time / 1e3) % 60;
	                  milliseconds = time % 1e3;
	                } else {
	                  year = value.getUTCFullYear();
	                  month = value.getUTCMonth();
	                  date = value.getUTCDate();
	                  hours = value.getUTCHours();
	                  minutes = value.getUTCMinutes();
	                  seconds = value.getUTCSeconds();
	                  milliseconds = value.getUTCMilliseconds();
	                }
	                // Serialize extended years correctly.
	                value = (year <= 0 || year >= 1e4 ? (year < 0 ? "-" : "+") + toPaddedString(6, year < 0 ? -year : year) : toPaddedString(4, year)) +
	                  "-" + toPaddedString(2, month + 1) + "-" + toPaddedString(2, date) +
	                  // Months, dates, hours, minutes, and seconds should have two
	                  // digits; milliseconds should have three.
	                  "T" + toPaddedString(2, hours) + ":" + toPaddedString(2, minutes) + ":" + toPaddedString(2, seconds) +
	                  // Milliseconds are optional in ES 5.0, but required in 5.1.
	                  "." + toPaddedString(3, milliseconds) + "Z";
	              } else {
	                value = null;
	              }
	            } else if (typeof value.toJSON == "function" && ((className != numberClass && className != stringClass && className != arrayClass) || isProperty.call(value, "toJSON"))) {
	              // Prototype <= 1.6.1 adds non-standard `toJSON` methods to the
	              // `Number`, `String`, `Date`, and `Array` prototypes. JSON 3
	              // ignores all `toJSON` methods on these objects unless they are
	              // defined directly on an instance.
	              value = value.toJSON(property);
	            }
	          }
	          if (callback) {
	            // If a replacement function was provided, call it to obtain the value
	            // for serialization.
	            value = callback.call(object, property, value);
	          }
	          if (value === null) {
	            return "null";
	          }
	          className = getClass.call(value);
	          if (className == booleanClass) {
	            // Booleans are represented literally.
	            return "" + value;
	          } else if (className == numberClass) {
	            // JSON numbers must be finite. `Infinity` and `NaN` are serialized as
	            // `"null"`.
	            return value > -1 / 0 && value < 1 / 0 ? "" + value : "null";
	          } else if (className == stringClass) {
	            // Strings are double-quoted and escaped.
	            return quote("" + value);
	          }
	          // Recursively serialize objects and arrays.
	          if (typeof value == "object") {
	            // Check for cyclic structures. This is a linear search; performance
	            // is inversely proportional to the number of unique nested objects.
	            for (length = stack.length; length--;) {
	              if (stack[length] === value) {
	                // Cyclic structures cannot be serialized by `JSON.stringify`.
	                throw TypeError();
	              }
	            }
	            // Add the object to the stack of traversed objects.
	            stack.push(value);
	            results = [];
	            // Save the current indentation level and indent one additional level.
	            prefix = indentation;
	            indentation += whitespace;
	            if (className == arrayClass) {
	              // Recursively serialize array elements.
	              for (index = 0, length = value.length; index < length; index++) {
	                element = serialize(index, value, callback, properties, whitespace, indentation, stack);
	                results.push(element === undef ? "null" : element);
	              }
	              result = results.length ? (whitespace ? "[\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "]" : ("[" + results.join(",") + "]")) : "[]";
	            } else {
	              // Recursively serialize object members. Members are selected from
	              // either a user-specified list of property names, or the object
	              // itself.
	              forEach(properties || value, function (property) {
	                var element = serialize(property, value, callback, properties, whitespace, indentation, stack);
	                if (element !== undef) {
	                  // According to ES 5.1 section 15.12.3: "If `gap` {whitespace}
	                  // is not the empty string, let `member` {quote(property) + ":"}
	                  // be the concatenation of `member` and the `space` character."
	                  // The "`space` character" refers to the literal space
	                  // character, not the `space` {width} argument provided to
	                  // `JSON.stringify`.
	                  results.push(quote(property) + ":" + (whitespace ? " " : "") + element);
	                }
	              });
	              result = results.length ? (whitespace ? "{\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "}" : ("{" + results.join(",") + "}")) : "{}";
	            }
	            // Remove the object from the traversed object stack.
	            stack.pop();
	            return result;
	          }
	        };
	
	        // Public: `JSON.stringify`. See ES 5.1 section 15.12.3.
	        exports.stringify = function (source, filter, width) {
	          var whitespace, callback, properties, className;
	          if (objectTypes[typeof filter] && filter) {
	            if ((className = getClass.call(filter)) == functionClass) {
	              callback = filter;
	            } else if (className == arrayClass) {
	              // Convert the property names array into a makeshift set.
	              properties = {};
	              for (var index = 0, length = filter.length, value; index < length; value = filter[index++], ((className = getClass.call(value)), className == stringClass || className == numberClass) && (properties[value] = 1));
	            }
	          }
	          if (width) {
	            if ((className = getClass.call(width)) == numberClass) {
	              // Convert the `width` to an integer and create a string containing
	              // `width` number of space characters.
	              if ((width -= width % 1) > 0) {
	                for (whitespace = "", width > 10 && (width = 10); whitespace.length < width; whitespace += " ");
	              }
	            } else if (className == stringClass) {
	              whitespace = width.length <= 10 ? width : width.slice(0, 10);
	            }
	          }
	          // Opera <= 7.54u2 discards the values associated with empty string keys
	          // (`""`) only if they are used directly within an object member list
	          // (e.g., `!("" in { "": 1})`).
	          return serialize("", (value = {}, value[""] = source, value), callback, properties, whitespace, "", []);
	        };
	      }
	
	      // Public: Parses a JSON source string.
	      if (!has("json-parse")) {
	        var fromCharCode = String.fromCharCode;
	
	        // Internal: A map of escaped control characters and their unescaped
	        // equivalents.
	        var Unescapes = {
	          92: "\\",
	          34: '"',
	          47: "/",
	          98: "\b",
	          116: "\t",
	          110: "\n",
	          102: "\f",
	          114: "\r"
	        };
	
	        // Internal: Stores the parser state.
	        var Index, Source;
	
	        // Internal: Resets the parser state and throws a `SyntaxError`.
	        var abort = function () {
	          Index = Source = null;
	          throw SyntaxError();
	        };
	
	        // Internal: Returns the next token, or `"$"` if the parser has reached
	        // the end of the source string. A token may be a string, number, `null`
	        // literal, or Boolean literal.
	        var lex = function () {
	          var source = Source, length = source.length, value, begin, position, isSigned, charCode;
	          while (Index < length) {
	            charCode = source.charCodeAt(Index);
	            switch (charCode) {
	              case 9: case 10: case 13: case 32:
	                // Skip whitespace tokens, including tabs, carriage returns, line
	                // feeds, and space characters.
	                Index++;
	                break;
	              case 123: case 125: case 91: case 93: case 58: case 44:
	                // Parse a punctuator token (`{`, `}`, `[`, `]`, `:`, or `,`) at
	                // the current position.
	                value = charIndexBuggy ? source.charAt(Index) : source[Index];
	                Index++;
	                return value;
	              case 34:
	                // `"` delimits a JSON string; advance to the next character and
	                // begin parsing the string. String tokens are prefixed with the
	                // sentinel `@` character to distinguish them from punctuators and
	                // end-of-string tokens.
	                for (value = "@", Index++; Index < length;) {
	                  charCode = source.charCodeAt(Index);
	                  if (charCode < 32) {
	                    // Unescaped ASCII control characters (those with a code unit
	                    // less than the space character) are not permitted.
	                    abort();
	                  } else if (charCode == 92) {
	                    // A reverse solidus (`\`) marks the beginning of an escaped
	                    // control character (including `"`, `\`, and `/`) or Unicode
	                    // escape sequence.
	                    charCode = source.charCodeAt(++Index);
	                    switch (charCode) {
	                      case 92: case 34: case 47: case 98: case 116: case 110: case 102: case 114:
	                        // Revive escaped control characters.
	                        value += Unescapes[charCode];
	                        Index++;
	                        break;
	                      case 117:
	                        // `\u` marks the beginning of a Unicode escape sequence.
	                        // Advance to the first character and validate the
	                        // four-digit code point.
	                        begin = ++Index;
	                        for (position = Index + 4; Index < position; Index++) {
	                          charCode = source.charCodeAt(Index);
	                          // A valid sequence comprises four hexdigits (case-
	                          // insensitive) that form a single hexadecimal value.
	                          if (!(charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 102 || charCode >= 65 && charCode <= 70)) {
	                            // Invalid Unicode escape sequence.
	                            abort();
	                          }
	                        }
	                        // Revive the escaped character.
	                        value += fromCharCode("0x" + source.slice(begin, Index));
	                        break;
	                      default:
	                        // Invalid escape sequence.
	                        abort();
	                    }
	                  } else {
	                    if (charCode == 34) {
	                      // An unescaped double-quote character marks the end of the
	                      // string.
	                      break;
	                    }
	                    charCode = source.charCodeAt(Index);
	                    begin = Index;
	                    // Optimize for the common case where a string is valid.
	                    while (charCode >= 32 && charCode != 92 && charCode != 34) {
	                      charCode = source.charCodeAt(++Index);
	                    }
	                    // Append the string as-is.
	                    value += source.slice(begin, Index);
	                  }
	                }
	                if (source.charCodeAt(Index) == 34) {
	                  // Advance to the next character and return the revived string.
	                  Index++;
	                  return value;
	                }
	                // Unterminated string.
	                abort();
	              default:
	                // Parse numbers and literals.
	                begin = Index;
	                // Advance past the negative sign, if one is specified.
	                if (charCode == 45) {
	                  isSigned = true;
	                  charCode = source.charCodeAt(++Index);
	                }
	                // Parse an integer or floating-point value.
	                if (charCode >= 48 && charCode <= 57) {
	                  // Leading zeroes are interpreted as octal literals.
	                  if (charCode == 48 && ((charCode = source.charCodeAt(Index + 1)), charCode >= 48 && charCode <= 57)) {
	                    // Illegal octal literal.
	                    abort();
	                  }
	                  isSigned = false;
	                  // Parse the integer component.
	                  for (; Index < length && ((charCode = source.charCodeAt(Index)), charCode >= 48 && charCode <= 57); Index++);
	                  // Floats cannot contain a leading decimal point; however, this
	                  // case is already accounted for by the parser.
	                  if (source.charCodeAt(Index) == 46) {
	                    position = ++Index;
	                    // Parse the decimal component.
	                    for (; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
	                    if (position == Index) {
	                      // Illegal trailing decimal.
	                      abort();
	                    }
	                    Index = position;
	                  }
	                  // Parse exponents. The `e` denoting the exponent is
	                  // case-insensitive.
	                  charCode = source.charCodeAt(Index);
	                  if (charCode == 101 || charCode == 69) {
	                    charCode = source.charCodeAt(++Index);
	                    // Skip past the sign following the exponent, if one is
	                    // specified.
	                    if (charCode == 43 || charCode == 45) {
	                      Index++;
	                    }
	                    // Parse the exponential component.
	                    for (position = Index; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
	                    if (position == Index) {
	                      // Illegal empty exponent.
	                      abort();
	                    }
	                    Index = position;
	                  }
	                  // Coerce the parsed value to a JavaScript number.
	                  return +source.slice(begin, Index);
	                }
	                // A negative sign may only precede numbers.
	                if (isSigned) {
	                  abort();
	                }
	                // `true`, `false`, and `null` literals.
	                if (source.slice(Index, Index + 4) == "true") {
	                  Index += 4;
	                  return true;
	                } else if (source.slice(Index, Index + 5) == "false") {
	                  Index += 5;
	                  return false;
	                } else if (source.slice(Index, Index + 4) == "null") {
	                  Index += 4;
	                  return null;
	                }
	                // Unrecognized token.
	                abort();
	            }
	          }
	          // Return the sentinel `$` character if the parser has reached the end
	          // of the source string.
	          return "$";
	        };
	
	        // Internal: Parses a JSON `value` token.
	        var get = function (value) {
	          var results, hasMembers;
	          if (value == "$") {
	            // Unexpected end of input.
	            abort();
	          }
	          if (typeof value == "string") {
	            if ((charIndexBuggy ? value.charAt(0) : value[0]) == "@") {
	              // Remove the sentinel `@` character.
	              return value.slice(1);
	            }
	            // Parse object and array literals.
	            if (value == "[") {
	              // Parses a JSON array, returning a new JavaScript array.
	              results = [];
	              for (;; hasMembers || (hasMembers = true)) {
	                value = lex();
	                // A closing square bracket marks the end of the array literal.
	                if (value == "]") {
	                  break;
	                }
	                // If the array literal contains elements, the current token
	                // should be a comma separating the previous element from the
	                // next.
	                if (hasMembers) {
	                  if (value == ",") {
	                    value = lex();
	                    if (value == "]") {
	                      // Unexpected trailing `,` in array literal.
	                      abort();
	                    }
	                  } else {
	                    // A `,` must separate each array element.
	                    abort();
	                  }
	                }
	                // Elisions and leading commas are not permitted.
	                if (value == ",") {
	                  abort();
	                }
	                results.push(get(value));
	              }
	              return results;
	            } else if (value == "{") {
	              // Parses a JSON object, returning a new JavaScript object.
	              results = {};
	              for (;; hasMembers || (hasMembers = true)) {
	                value = lex();
	                // A closing curly brace marks the end of the object literal.
	                if (value == "}") {
	                  break;
	                }
	                // If the object literal contains members, the current token
	                // should be a comma separator.
	                if (hasMembers) {
	                  if (value == ",") {
	                    value = lex();
	                    if (value == "}") {
	                      // Unexpected trailing `,` in object literal.
	                      abort();
	                    }
	                  } else {
	                    // A `,` must separate each object member.
	                    abort();
	                  }
	                }
	                // Leading commas are not permitted, object property names must be
	                // double-quoted strings, and a `:` must separate each property
	                // name and value.
	                if (value == "," || typeof value != "string" || (charIndexBuggy ? value.charAt(0) : value[0]) != "@" || lex() != ":") {
	                  abort();
	                }
	                results[value.slice(1)] = get(lex());
	              }
	              return results;
	            }
	            // Unexpected token encountered.
	            abort();
	          }
	          return value;
	        };
	
	        // Internal: Updates a traversed object member.
	        var update = function (source, property, callback) {
	          var element = walk(source, property, callback);
	          if (element === undef) {
	            delete source[property];
	          } else {
	            source[property] = element;
	          }
	        };
	
	        // Internal: Recursively traverses a parsed JSON object, invoking the
	        // `callback` function for each value. This is an implementation of the
	        // `Walk(holder, name)` operation defined in ES 5.1 section 15.12.2.
	        var walk = function (source, property, callback) {
	          var value = source[property], length;
	          if (typeof value == "object" && value) {
	            // `forEach` can't be used to traverse an array in Opera <= 8.54
	            // because its `Object#hasOwnProperty` implementation returns `false`
	            // for array indices (e.g., `![1, 2, 3].hasOwnProperty("0")`).
	            if (getClass.call(value) == arrayClass) {
	              for (length = value.length; length--;) {
	                update(value, length, callback);
	              }
	            } else {
	              forEach(value, function (property) {
	                update(value, property, callback);
	              });
	            }
	          }
	          return callback.call(source, property, value);
	        };
	
	        // Public: `JSON.parse`. See ES 5.1 section 15.12.2.
	        exports.parse = function (source, callback) {
	          var result, value;
	          Index = 0;
	          Source = "" + source;
	          result = get(lex());
	          // If a JSON string contains multiple tokens, it is invalid.
	          if (lex() != "$") {
	            abort();
	          }
	          // Reset the parser state.
	          Index = Source = null;
	          return callback && getClass.call(callback) == functionClass ? walk((value = {}, value[""] = result, value), "", callback) : result;
	        };
	      }
	    }
	
	    exports["runInContext"] = runInContext;
	    return exports;
	  }
	
	  if (freeExports && !isLoader) {
	    // Export for CommonJS environments.
	    runInContext(root, freeExports);
	  } else {
	    // Export for web browsers and JavaScript engines.
	    var nativeJSON = root.JSON,
	        previousJSON = root["JSON3"],
	        isRestored = false;
	
	    var JSON3 = runInContext(root, (root["JSON3"] = {
	      // Public: Restores the original value of the global `JSON` object and
	      // returns a reference to the `JSON3` object.
	      "noConflict": function () {
	        if (!isRestored) {
	          isRestored = true;
	          root.JSON = nativeJSON;
	          root["JSON3"] = previousJSON;
	          nativeJSON = previousJSON = null;
	        }
	        return JSON3;
	      }
	    }));
	
	    root.JSON = {
	      "parse": JSON3.parse,
	      "stringify": JSON3.stringify
	    };
	  }
	
	  // Export for asynchronous module loaders.
	  if (isLoader) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return JSON3;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)(module), (function() { return this; }())))

/***/ },
/* 18 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 19 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {if(!global["_scope"]) global["_scope"] = {};
	module.exports = global["_scope"]["Entry"] = __webpack_require__(21);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	__webpack_require__(22);
	
	__webpack_require__(24);
	
	__webpack_require__(122);
	
	__webpack_require__(124);
	
	__webpack_require__(126);
	
	__webpack_require__(128);
	
	__webpack_require__(146);
	
	__webpack_require__(165);
	
	__webpack_require__(167);
	
	__webpack_require__(169);
	
	__webpack_require__(171);
	
	__webpack_require__(173);
	
	__webpack_require__(175);
	
	__webpack_require__(178);
	
	__webpack_require__(180);
	
	__webpack_require__(182);
	
	__webpack_require__(184);
	
	__webpack_require__(186);
	
	__webpack_require__(188);
	
	var _version = __webpack_require__(141);
	
	var _version2 = _interopRequireDefault(_version);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	module.exports = {
	    MsgBus: _scope.MsgBus,
	    Player: _scope.Player,
	    DB: _scope.DB,
	    Utils: _scope.Utils,
	    GetVersion: function GetVersion() {
	        return _version2["default"];
	    },
	    Init: function Init(id, cb) {
	        var roomId = void 0;
	        var roomHashId = void 0;
	        // 解析：n_${id} / s_${hashid}
	        if (typeof id === 'string') {
	            var idStrArr = id.split('_');
	            // number类型id
	            if (idStrArr.length === 2 && idStrArr[0] === 'n') {
	                roomId = +idStrArr[1];
	            }
	            // hash id
	            if (idStrArr.length === 2 && idStrArr[0] === 's') {
	                roomHashId = idStrArr[1];
	            }
	        }
	        if (!roomId && !roomHashId) {
	            roomId = +id;
	        }
	
	        if (typeof _scope.Entry === 'undefined') {
	            _scope.Entry = {};
	        }
	
	        _scope.Feature.EventBus(_scope.Entry);
	
	        _scope.MsgBus.OnMultiOnce(['Room.Init.Over', 'PPT.Inited.Over', 'User.Init.Over', 'Tracker.Init.Over', 'Comment.Init.Over'], function () {
	            _scope.MsgBus.Pub('Room.User.Over');
	            if (typeof cb === 'function') {
	                try {
	                    cb();
	                } catch (e) {
	                    console.warn(e); // eslint-disable-line
	                }
	            }
	        });
	        _scope.MsgBus.Sub('Room.Init.Error', function () {
	            if (typeof cb === 'function') {
	                try {
	                    cb();
	                } catch (e) {
	                    console.warn(e); // eslint-disable-line
	                }
	            }
	        });
	
	        var user = new _scope.User({});
	
	        var room = new _scope.Room({ roomId: roomId, roomHashId: roomHashId });
	        var luckyDraw = new _scope.LuckyDraw();
	        var barrage = new _scope.Barrage();
	        var redpack = new _scope.Redpack();
	        _scope.MsgBus.Pub('SendObj.User', user);
	        _scope.MsgBus.Pub('SendObj.LuckyDraw', luckyDraw);
	        _scope.MsgBus.Pub('SendObj.Barrage', barrage);
	        _scope.MsgBus.Pub('SendObj.Room', room);
	        _scope.MsgBus.Pub('SendObj.Redpack', redpack);
	
	        room.Init();
	        _scope.Entry.Room = room;
	    },
	    Destroy: function Destroy() {
	        _scope.MsgBus.UnSubAll('SendObj.User');
	        _scope.MsgBus.UnSubAll('Room.Init.Over');
	        _scope.MsgBus.UnSubAll('SendObj.LuckyDraw');
	        _scope.MsgBus.UnSubAll('SendObj.Barrage');
	        _scope.MsgBus.UnSubAll('SendObj.Room');
	        _scope.MsgBus.UnSubAll('SendObj.Redpack');
	        _scope.MsgBus.Pub('Destroy');
	        _scope.Entry.Room = {};
	        _scope.MsgBus.Clear();
	    }
	};


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {if(!global["_scope"]) global["_scope"] = {};
	module.exports = global["_scope"]["MsgBus"] = __webpack_require__(23);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	//this is a inner message bus
	var Slots = {};
	var MsgBus = {};
	MsgBus.Sub = function (topic, cb) {
	    if (typeof cb !== 'function') {
	        // eslint-disable-next-line
	        console.log("cant sub topic ,because cb is not a function(topic,data)");
	        return;
	    }
	
	    if (typeof Slots[topic] === 'undefined') {
	        Slots[topic] = {};
	    }
	    var id = _scope.Utils.Guid();
	    Slots[topic][id] = cb;
	    return { id: id, topic: topic };
	};
	
	MsgBus.On = function (topic, cb) {
	    return MsgBus.Sub.call(this, topic, cb);
	};
	
	MsgBus.OnMultiOnce = function (topicArr, cb) {
	    var _self = this;
	    var hasDoneCount = 0;
	    if (topicArr instanceof Array) {
	        var maxLen = topicArr.length;
	        topicArr.map(function (topic) {
	            var cancelKey = MsgBus.Sub.call(_self, topic, function () {
	                hasDoneCount++;
	                MsgBus.UnSub(cancelKey);
	                if (hasDoneCount == maxLen) {
	                    typeof cb === 'function' && cb();
	                }
	            });
	        });
	    }
	};
	
	MsgBus.Pub = function (topic, data) {
	    // eslint-disable-next-line
	    // window.MUDUDEBUG && console.log && console.log("mudubus log ", topic, data);
	    if (typeof Slots[topic] === 'undefined') {
	        return;
	    }
	    for (var id in Slots[topic]) {
	        Slots[topic][id](data, topic);
	    }
	};
	MsgBus.UnSub = function (key) {
	    if (typeof Slots[key.topic] === 'undefined') {
	        return;
	    }
	    if (typeof Slots[key.topic][key.id] === 'undefined') {
	        return;
	    }
	    delete Slots[key.topic][key.id];
	};
	
	MsgBus.UnSubAll = function (topic) {
	    delete Slots[topic];
	};
	
	MsgBus.Clear = function () {
	    Slots = {};
	};
	
	module.exports = MsgBus;


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {if(!global["_scope"]) global["_scope"] = {};
	module.exports = global["_scope"]["Player"] = __webpack_require__(25);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	var _slicedToArray2 = __webpack_require__(26);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(83);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(103);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(110);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(111);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	// this is a console player 
	var MuPlayer = __webpack_require__(115);
	var delegates = __webpack_require__(116);
	var utils = __webpack_require__(14);
	var config = __webpack_require__(117);
	var md5 = __webpack_require__(118);
	
	module.exports = function () {
	    function Player(param) {
	        var _this = this;
	
	        (0, _classCallCheck3["default"])(this, Player);
	
	        _scope.Feature.EventBus(this);
	        this.id = param.containerId;
	
	        this.useFakeUrl = false;
	
	        this.playerErrorCoverDom = null;
	        // 加载player之前挂载错误cover（如果加载了player，此处cover会被冲掉，所以setup之后会再挂载一次）
	        this._appendErrorCover();
	
	        var actErrcode = this._getUserInArrearsCode();
	        // 如果用户完全欠费，直接挂载错误页
	        if (actErrcode && actErrcode.hasLiveErrcode && actErrcode.hasTrailerErrcode) {
	            this._displayErrorCover();
	            return;
	        }
	
	        this.version = param.version;
	        this.x5Layer = param.x5Layer || false;
	        this.x5Inline = param.x5Inline || false;
	        param.src && !param.file && (param.file = param.src); //param.file好像没用到了，兼容之前的sdk
	        // 在拉直播流时，报错是否重试
	        this.retryWhenLiveError = param.retryWhenLiveError;
	        this.param = param;
	        this.timer = new _scope.Timer('User.WatchTime', (0, _extends3["default"])({}, this.param, {
	            timegap: 60000,
	            getPlayer: function getPlayer() {
	                return _this.player;
	            }
	        }));
	        this.player = null;
	        this.init(param);
	
	        _scope.MsgBus.Pub('timer.stop', function (timer) {
	            // 关闭其他使用当前containerId的播放器的计费
	            if (timer.param.containerId == _this.param.containerId && timer != _this.timer) {
	                return true;
	            }
	            return false;
	        });
	
	        this._listenBrowserEvent();
	    }
	
	    (0, _createClass3["default"])(Player, [{
	        key: 'init',
	        value: function init() {
	            var _this2 = this;
	
	            this.player = MuPlayer(this.id);
	            var x5Layer = this.x5Layer;
	            var x5Inline = this.x5Inline;
	            // 当前播放器是否在播放直播流
	            this.isLivePlaying = false;
	
	            // 兼容type='live'
	            if (this.param.type === 'live') {
	                this.param.isLive = true;
	                this.param.type = undefined;
	            }
	
	            var playerConfig = (0, _extends3["default"])({
	                preload: 'none',
	                autoplay: this.param.autoplay || this.param.autostart,
	                contextMenus: [],
	                plugin: {
	                    x5: {
	                        inline: x5Layer, // 让播放器inline播放, 播放器始终位于z-index顶层
	                        layer: x5Inline // 让播放器同层播放
	                    }
	                }
	            }, this.param);
	
	            // ？删除会引起冲突的param
	            delete playerConfig.x5Layer;
	            delete playerConfig.x5Inline;
	            delete playerConfig.version;
	
	            // 监听销毁mudusdk消息 销毁时要remove播放器
	            this._msgbusDestroy();
	
	            // video_id视频先获取video
	            if (!this.param.isLive && this.param.video_id) {
	                var resolution = ''; // 如果能匹配到回放视频，就用回放视频的分辨率（其他视频暂无分辨率）
	                var trailerInfo = _scope.DB.Get('trailerInfo') || {};
	                if (this.param.video_id === trailerInfo.video_id) {
	                    resolution = trailerInfo.resolution;
	                }
	                this._getVideoInfo(this.param.video_id, resolution).then(function (res) {
	                    playerConfig.playlist = _this2._getPlayOrigin((0, _extends3["default"])({}, _this2.param, {
	                        image: playerConfig.image || '',
	                        file: res.url,
	                        bookmarks: res.bookmarks || []
	                    }));
	                    _this2._setupPlayer(playerConfig);
	                });
	            } else {
	                playerConfig.playlist = this._getPlayOrigin(this.param);
	                if (playerConfig.isLive) {
	                    delete playerConfig.src;
	                    delete playerConfig.file;
	                }
	                this._setupPlayer(playerConfig);
	            }
	
	            // _scope.MsgBus.Sub('Room.ListliveConfig.Update', () => {
	            //     console.log('列表直播配置更新：', _scope.DB.Get('listLiveConfig'), this.isLivePlaying);
	            //     // 如果正在播放直播流，则触发重新拉流
	            //     // if (this.isLivePlaying) {
	            //     //     // this.load([{isLiveL: true}]);
	            //     //     this.play();
	            //     // }
	            // });
	
	            this.delegatesMethod();
	
	            this._subPlayerEvents();
	        }
	    }, {
	        key: '_setupPlayer',
	        value: function _setupPlayer(playerConfig) {
	            var _this3 = this;
	
	            this._setupPlayerConfig = playerConfig;
	            try {
	                this.player.setup(playerConfig).then(function () {
	
	                    // 加载频道错误提示cover
	                    _this3._appendErrorCover();
	
	                    _scope.MsgBus.Pub('Player.Ready', _this3);
	                    if (_this3.useFakeUrl) {
	                        _this3.player.stop();
	                        _this3.player.setControls(false);
	                    }
	                    _this3.pptTimer = new _scope.Timer('Player.pptTimer', {
	                        player: _this3.player,
	                        timegap: 1000,
	                        getPosition: function getPosition() {
	                            return _this3.player.getPosition();
	                        },
	                        getPlayFile: function getPlayFile() {
	                            var item = _this3.player.getPlaylistItem(0);
	                            return item && item.sources;
	                        }
	                    });
	                    _this3.pptTimer.start();
	                }, function (error) {
	                    _scope.MsgBus.Pub('Player.SetupError', error);
	                    if (_this3._getUserInArrearsCode().code) {
	                        _this3._appendErrorCover();
	                        _this3._displayErrorCover();
	                    }
	                });
	            } catch (e) {
	                console.warn(e); // eslint-disable-line
	                _scope.MsgBus.Pub('Player.SetupError', e);
	                return;
	            }
	        }
	    }, {
	        key: '_appendErrorCover',
	        value: function _appendErrorCover() {
	            var container = document.getElementById(this.id);
	            if (!container) {
	                return;
	            }
	
	            this.playerErrorCoverDom = document.createElement('div');
	            this.playerErrorCoverDom.className = 'mudu-reset extra-error-cover';
	            this.playerErrorCoverDom.style = 'display: none; position: absolute; inset: 0px; background: #000; opacity: 0.8; font-size: 18px; color: #fff;  text-align: center; white-space: break-spaces; padding-top: 20%; line-height: 1.3';
	            container.appendChild(this.playerErrorCoverDom);
	        }
	    }, {
	        key: '_displayErrorCover',
	        value: function _displayErrorCover() {
	            var errCode = this._getUserInArrearsCode();
	            this.playerErrorCoverDom.innerText = '\u56E0\u7BA1\u7406\u5458\u8C03\u8BD5(\u4EE3\u7801' + errCode.code + ')\r\n\u8282\u76EE\u6682\u65F6\u65E0\u6CD5\u89C2\u770B\uFF0C\u8BF7\u7A0D\u5019';
	            this.playerErrorCoverDom.style.display = 'block';
	            if (this.player) {
	                this.player.stop();
	            }
	        }
	    }, {
	        key: '_hideErrorCover',
	        value: function _hideErrorCover() {
	            this.playerErrorCoverDom.style.display = 'none';
	        }
	    }, {
	        key: '_subPlayerEvents',
	        value: function _subPlayerEvents() {
	            var _this4 = this;
	
	            try {
	                this.player.on('play', function () {
	                    _this4.timer.start();
	                    _scope.MsgBus.Pub('Player.Play', _this4);
	                });
	            } catch (e) {
	                console.warn(e); // eslint-disable-line
	                this.player.stop();
	                _scope.MsgBus.Pub('Player.PlayError', e);
	            }
	            this.player.on('buffer', function () {
	                _scope.MsgBus.Pub('Player.Waiting', _this4);
	            });
	            this.player.on('pause', function () {
	                _this4.timer.stop();
	                _scope.MsgBus.Pub('Player.Stoped', _this4);
	            });
	            this.player.on('complete', function () {
	                _this4.timer.stop();
	                _scope.MsgBus.Pub('Player.Ended', _this4);
	            });
	            this.player.on('switchQuality', function () {
	                _scope.MsgBus.Pub('Player.SwitchQuality', _this4);
	            });
	            this.player.on('error', function () {
	                _scope.MsgBus.Pub('Player.Error', _this4);
	
	                var listLiveConfig = _scope.DB.Get('listLiveConfig');
	                var liveStatus = _scope.DB.Get('Room').live_status;
	                // 列表直播中重试一下（列表直播开始拉流必报错一次）
	                if (listLiveConfig.isLiving && liveStatus && _this4.isLivePlaying) {
	                    setTimeout(function () {
	                        _this4.play();
	                    }, 2000);
	                    return;
	                }
	
	                // 如果直播中，有直播拉流重试
	                if (_this4.isLivePlaying && _this4.retryWhenLiveError && liveStatus) {
	                    // 直播中，重试
	                    _this4._liveRetryTimer = setTimeout(function () {
	                        // 已经不在直播中，退出
	                        if (!_scope.DB.Get('Room').live_status) {
	                            // 已经不在直播，但仍在播直播流，停一下
	                            if (_this4.isLivePlaying) {
	                                setTimeout(function () {
	                                    _this4.stop();
	                                }, 0);
	                            }
	                            return;
	                        }
	                        if (_this4._lastLoadPlayerConfig && _this4._lastLoadPlayerConfig.param) {
	                            _this4.load([_this4._lastLoadPlayerConfig.param], _this4._lastLoadPlayerConfig.autoPlay);
	                            return;
	                        } else if (_this4._setupPlayerConfig.isLive) {
	                            _this4.load([_this4._setupPlayerConfig], _this4._setupPlayerConfig.autoplay);
	                            return;
	                        } else {
	                            _this4.load([{ isLive: true }], true);
	                        }
	                    }, 2000);
	                    return;
	                }
	
	                // error后stop播放器
	                _this4.stop();
	            });
	        }
	    }, {
	        key: '_getUserInArrearsCode',
	        value: function _getUserInArrearsCode() {
	            return _scope.DB.Get('User.Arrears.Status') || {}; // 获取用户欠费状态的errCode
	        }
	    }, {
	        key: '_listenBrowserEvent',
	        value: function _listenBrowserEvent() {
	            var _this5 = this;
	
	            var feecb = function feecb() {
	                _this5.timer.task && _this5.timer.start();
	            };
	            _scope.Utils.addEventListener(window, 'beforeunload', feecb);
	            _scope.Utils.addEventListener(window, 'pagehide', feecb);
	            _scope.Utils.addEventListener(window, 'pageshow', feecb);
	            _scope.Utils.addEventListener(document, 'visibilitychange', feecb);
	            _scope.Utils.addEventListener(window, 'unload', feecb);
	        }
	    }, {
	        key: '_getVideoInfo',
	        value: function _getVideoInfo(video_id, resolution) {
	            var _this6 = this;
	
	            var tokenHeader = _scope.DB.Get('requestHeader').token;
	            return new _promise2["default"](function (resolve, reject) {
	                if (!video_id) {
	                    return;
	                }
	                var nowTimeStamp = Date.parse(new Date().toString()) / 1000;
	                return Fetcher.Get(config.API_DOMAIN + '/videos/view/act/' + _this6.actHashId + '/video?video_id=' + video_id + '&timestamp=' + nowTimeStamp + '&resolution=' + (resolution || ''), function (data) {
	                    var res = JSON.parse(data);
	                    if (res.errcode === 1000) {
	                        resolve(res.data);
	                    } else {
	                        reject('error');
	                    }
	                }, (0, _extends3["default"])({}, tokenHeader, {
	                    sign: md5(tokenHeader.authorization.split(' ')[1] + nowTimeStamp)
	                }));
	            });
	        }
	    }, {
	        key: 'load',
	        value: function load(_ref, autoPlay) {
	            var _this7 = this;
	
	            var _ref2 = (0, _slicedToArray3["default"])(_ref, 1),
	                param = _ref2[0];
	
	            this._lastLoadPlayerConfig = {
	                param: param,
	                autoPlay: autoPlay
	            };
	            if (param.video_id) {
	                var resolution = ''; // 如果能匹配到回放视频，就用回放视频的分辨率（其他视频暂无分辨率）
	                var trailerInfo = _scope.DB.Get('trailerInfo') || {};
	                if (param.video_id === trailerInfo.video_id) {
	                    resolution = trailerInfo.resolution;
	                }
	                return this._getVideoInfo(param.video_id, resolution).then(function (res) {
	                    return _this7.player.load(_this7._getPlayOrigin((0, _extends3["default"])({}, param, { file: res.url, bookmarks: res.bookmarks }))).then(function () {
	                        if (_this7.useFakeUrl) {
	                            _this7.player.stop();
	                            _this7.player.setControls(false);
	                        } else {
	                            _this7.player.setControls(typeof param.controls !== 'undefined' ? param.controls : true);
	                        }
	                    });
	                });
	            }
	            var loadParam = this._getPlayOrigin(param);
	            var playerAutoPlay = !this.useFakeUrl && (autoPlay || param.autoPlay);
	            return this.player.load(loadParam, playerAutoPlay).then(function () {
	                if (_this7.useFakeUrl) {
	                    _this7.player.stop();
	                    _this7.player.setControls(false);
	                } else {
	                    _this7.player.setControls(typeof param.controls !== 'undefined' ? param.controls : true);
	                }
	            });
	        }
	
	        /**
	         * 检查播放器加载的是不是直播流
	         * @returns boolean
	         */
	
	    }, {
	        key: '_getPlayerConfigIsLive',
	        value: function _getPlayerConfigIsLive() {
	            var isPlayerLive = false;
	            try {
	                var activeConfig = this.player._config && this.player._config.playlist.filter(function (item) {
	                    return !!item.active;
	                })[0];
	                isPlayerLive = activeConfig && activeConfig.isLive;
	            } catch (error) {
	                // 没拿到值就认为不是播直播
	            }
	            return isPlayerLive;
	        }
	    }, {
	        key: 'play',
	        value: function play() {
	            var playerConfigIsLive = this._getPlayerConfigIsLive();
	            var listLiveConfig = _scope.DB.Get('listLiveConfig');
	            // 列表直播中调用play，或者之前用过列表直播，重新load player
	            if (playerConfigIsLive && listLiveConfig && (listLiveConfig.isLiving || listLiveConfig.address)) {
	                this.load([{
	                    isLive: true
	                }], true);
	            } else {
	                this.timer.start();
	                this.player.play();
	                _scope.MsgBus.Pub('Player.Play', this);
	            }
	        }
	    }, {
	        key: 'stop',
	        value: function stop() {
	            if (!this.player) {
	                return;
	            }
	            this.timer.stop();
	            this.player.stop();
	            _scope.MsgBus.Pub('Player.Stoped', this);
	        }
	    }, {
	        key: 'pause',
	        value: function pause() {
	            this.timer.stop();
	            this.player.pause();
	            _scope.MsgBus.Pub('Player.Paused', this);
	        }
	    }, {
	        key: 'setPlayerSize',
	        value: function setPlayerSize(w, h) {
	            return this.player.resize(w, h);
	        }
	    }, {
	        key: 'remove',
	        value: function remove() {
	
	            if (this.timer) {
	                this.timer.stop();
	            }
	            if (this.pptTimer) {
	                this.pptTimer.stop();
	            }
	            this.player.remove();
	        }
	
	        // 将video info转换成player的参数格式
	
	    }, {
	        key: '_transformVideoInfoToPlay',
	        value: function _transformVideoInfoToPlay(videoInfo) {
	            var highlights = videoInfo.highlights || [];
	            if (!highlights.length && videoInfo.bookmarks) {
	                highlights = videoInfo.bookmarks.map(function (v) {
	                    return {
	                        time: utils.transformTimeStrToNumber(v.time),
	                        text: v.desc || ''
	                    };
	                });
	            }
	            return [{
	                file: videoInfo.m3u8 || videoInfo.file,
	                image: videoInfo.trailer_img || videoInfo.image || '',
	                isLive: false,
	                highlights: highlights,
	                controls: typeof videoInfo.draggable !== 'undefined' ? videoInfo.draggable : true,
	                isHideProgress: typeof videoInfo.isHideProgress !== 'undefined' ? !videoInfo.triple_speed : false
	            }];
	        }
	    }, {
	        key: '_msgbusDestroy',
	        value: function _msgbusDestroy() {
	            var _this8 = this;
	
	            this.destroyKey = _scope.MsgBus.Sub('Destroy', function () {
	                _this8.remove();
	                _scope.MsgBus.UnSub(_this8.destroyKey);
	            });
	        }
	    }, {
	        key: '_getFakePlayParam',
	        value: function _getFakePlayParam(param) {
	            this.useFakeUrl = true;
	            delete param.file;
	            delete param.src;
	            delete param.playlist;
	            delete param.isLive;
	            return [(0, _extends3["default"])({
	                file: 'https://myun-hw-s3.myun.tv/melj80jz/fake123.m3u8',
	                autoplay: false,
	                isLive: false,
	                image: _scope.DB.Get('liveAddrList')[0].image || ''
	            }, param)];
	        }
	    }, {
	        key: '_getLiveParam',
	        value: function _getLiveParam(param) {
	            delete param.file;
	            delete param.src;
	            delete param.playlist;
	
	            // 先检查是否是列表直播，列表直播则返回列表直播地址
	            var listLiveConfig = _scope.DB.Get('listLiveConfig');
	            console.log(listLiveConfig.isLiving);
	            if (listLiveConfig && listLiveConfig.isLiving) {
	                return [(0, _extends3["default"])({}, param, {
	                    file: listLiveConfig.address
	                })];
	            } else {
	                // 只取第一路流
	                var liveItem = _scope.DB.Get('liveAddrList')[0];
	
	                return [(0, _extends3["default"])({}, liveItem, param)];
	            }
	        }
	
	        // 获取播放视频源
	
	    }, {
	        key: '_getPlayOrigin',
	        value: function _getPlayOrigin(param) {
	            this.useFakeUrl = false;
	            var errCode = this._getUserInArrearsCode() || {};
	            // 播放直播
	            if (param.isLive) {
	                // 有直播错误码
	                if (errCode.hasLiveErrcode) {
	                    this.isLivePlaying = false;
	                    this._displayErrorCover();
	                    return this._getFakePlayParam(param);
	                }
	                this.isLivePlaying = true;
	                this._hideErrorCover();
	                return this._getLiveParam(param);
	            }
	
	            this.isLivePlaying = false;
	
	            // 有点播错误码
	            if (errCode.hasTrailerErrcode) {
	                this._displayErrorCover();
	                return this._getFakePlayParam(param);
	            }
	
	            this._hideErrorCover();
	
	            // 播放回看
	            if (!param.isLive && !param.file) {
	                var trailerInfo = _scope.DB.Get('trailerInfo') || {};
	                if (trailerInfo.open) {
	                    return this._transformVideoInfoToPlay(trailerInfo);
	                }
	            }
	
	            // 播放其他视频
	            var file = param.file || param.src;
	            if (file) {
	                var forceCutomHighlight = _scope.DB.Get('CUSTOM_FORCE_HIGHLIGHT') || [];
	                return this._transformVideoInfoToPlay((0, _extends3["default"])({ bookmarks: forceCutomHighlight }, param, { file: file }));
	            }
	
	            // 都播不了，用假地址，避免player load报错
	            return this._getFakePlayParam(param);
	        }
	    }, {
	        key: 'delegatesMethod',
	        value: function delegatesMethod() {
	            delegates(this, 'player').method('seek').method('on').method('getPlaylist').method('getPlaylistItem').method('getState').method('getPosition').method('getMute').method('setMute').method('setVolume').method('getFullscreen').method('getHeight').method('getWidth').method('resize')
	            // .method('getQualityLevels')
	            // .method('getCurrentQuality')
	            .method('switchQuality')
	            // .method('getVisualQuality')
	            // .method('setCurrentQuality')
	            // .method('getAudioTracks')
	            // .method('getCurrentAudioTrack')
	            // .method('setCurrentAudioTrack')
	            // .method('setCaptions')
	            // .method('getCaptionsList')
	            // .method('getCurrentCaptions')
	            // .method('setCurrentCaptions')
	            .method('getControls')
	            // .method('getSafeRegion')
	            // .method('addButton')
	            // .method('removeButton')
	            .method('setControls').method('playAd');
	            // .method('setFlashTip')
	            // .method('getJWVersion');
	        }
	    }]);
	    return Player;
	}();


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(27);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(79);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(28), __esModule: true };

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(29);
	__webpack_require__(75);
	module.exports = __webpack_require__(77);


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(30);
	var global = __webpack_require__(41);
	var hide = __webpack_require__(45);
	var Iterators = __webpack_require__(33);
	var TO_STRING_TAG = __webpack_require__(72)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(31);
	var step = __webpack_require__(32);
	var Iterators = __webpack_require__(33);
	var toIObject = __webpack_require__(34);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(38)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 31 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 32 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 33 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(35);
	var defined = __webpack_require__(37);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(36);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 36 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 37 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(39);
	var $export = __webpack_require__(40);
	var redefine = __webpack_require__(55);
	var hide = __webpack_require__(45);
	var has = __webpack_require__(56);
	var Iterators = __webpack_require__(33);
	var $iterCreate = __webpack_require__(57);
	var setToStringTag = __webpack_require__(71);
	var getPrototypeOf = __webpack_require__(73);
	var ITERATOR = __webpack_require__(72)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 39 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(41);
	var core = __webpack_require__(42);
	var ctx = __webpack_require__(43);
	var hide = __webpack_require__(45);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 41 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 42 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.5.1' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(44);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 44 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(46);
	var createDesc = __webpack_require__(54);
	module.exports = __webpack_require__(50) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(47);
	var IE8_DOM_DEFINE = __webpack_require__(49);
	var toPrimitive = __webpack_require__(53);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(50) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(48);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 48 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(50) && !__webpack_require__(51)(function () {
	  return Object.defineProperty(__webpack_require__(52)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(51)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 51 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(48);
	var document = __webpack_require__(41).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(48);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 54 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(45);


/***/ },
/* 56 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(58);
	var descriptor = __webpack_require__(54);
	var setToStringTag = __webpack_require__(71);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(45)(IteratorPrototype, __webpack_require__(72)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(47);
	var dPs = __webpack_require__(59);
	var enumBugKeys = __webpack_require__(69);
	var IE_PROTO = __webpack_require__(66)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(52)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(70).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(46);
	var anObject = __webpack_require__(47);
	var getKeys = __webpack_require__(60);
	
	module.exports = __webpack_require__(50) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(61);
	var enumBugKeys = __webpack_require__(69);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(56);
	var toIObject = __webpack_require__(34);
	var arrayIndexOf = __webpack_require__(62)(false);
	var IE_PROTO = __webpack_require__(66)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(34);
	var toLength = __webpack_require__(63);
	var toAbsoluteIndex = __webpack_require__(65);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(64);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 64 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(64);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(67)('keys');
	var uid = __webpack_require__(68);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(41);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ },
/* 68 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 69 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(41).document;
	module.exports = document && document.documentElement;


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(46).f;
	var has = __webpack_require__(56);
	var TAG = __webpack_require__(72)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(67)('wks');
	var uid = __webpack_require__(68);
	var Symbol = __webpack_require__(41).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(56);
	var toObject = __webpack_require__(74);
	var IE_PROTO = __webpack_require__(66)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(37);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(76)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(38)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(64);
	var defined = __webpack_require__(37);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(78);
	var ITERATOR = __webpack_require__(72)('iterator');
	var Iterators = __webpack_require__(33);
	module.exports = __webpack_require__(42).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(36);
	var TAG = __webpack_require__(72)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(80), __esModule: true };

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(29);
	__webpack_require__(75);
	module.exports = __webpack_require__(81);


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(47);
	var get = __webpack_require__(82);
	module.exports = __webpack_require__(42).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(78);
	var ITERATOR = __webpack_require__(72)('iterator');
	var Iterators = __webpack_require__(33);
	module.exports = __webpack_require__(42).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(84), __esModule: true };

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(85);
	__webpack_require__(75);
	__webpack_require__(29);
	__webpack_require__(86);
	__webpack_require__(101);
	__webpack_require__(102);
	module.exports = __webpack_require__(42).Promise;


/***/ },
/* 85 */
/***/ function(module, exports) {



/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(39);
	var global = __webpack_require__(41);
	var ctx = __webpack_require__(43);
	var classof = __webpack_require__(78);
	var $export = __webpack_require__(40);
	var isObject = __webpack_require__(48);
	var aFunction = __webpack_require__(44);
	var anInstance = __webpack_require__(87);
	var forOf = __webpack_require__(88);
	var speciesConstructor = __webpack_require__(91);
	var task = __webpack_require__(92).set;
	var microtask = __webpack_require__(94)();
	var newPromiseCapabilityModule = __webpack_require__(95);
	var perform = __webpack_require__(96);
	var promiseResolve = __webpack_require__(97);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(72)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value);
	            if (domain) domain.exit();
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  if (promise._h == 1) return false;
	  var chain = promise._a || promise._c;
	  var i = 0;
	  var reaction;
	  while (chain.length > i) {
	    reaction = chain[i++];
	    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
	  } return true;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(98)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(71)($Promise, PROMISE);
	__webpack_require__(99)(PROMISE);
	Wrapper = __webpack_require__(42)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(100)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ },
/* 87 */
/***/ function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(43);
	var call = __webpack_require__(89);
	var isArrayIter = __webpack_require__(90);
	var anObject = __webpack_require__(47);
	var toLength = __webpack_require__(63);
	var getIterFn = __webpack_require__(82);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(47);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(33);
	var ITERATOR = __webpack_require__(72)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(47);
	var aFunction = __webpack_require__(44);
	var SPECIES = __webpack_require__(72)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(43);
	var invoke = __webpack_require__(93);
	var html = __webpack_require__(70);
	var cel = __webpack_require__(52);
	var global = __webpack_require__(41);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(36)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ },
/* 93 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(41);
	var macrotask = __webpack_require__(92).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(36)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if (Observer) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    var promise = Promise.resolve();
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(44);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ },
/* 96 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(47);
	var isObject = __webpack_require__(48);
	var newPromiseCapability = __webpack_require__(95);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(45);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(41);
	var core = __webpack_require__(42);
	var dP = __webpack_require__(46);
	var DESCRIPTORS = __webpack_require__(50);
	var SPECIES = __webpack_require__(72)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(72)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(40);
	var core = __webpack_require__(42);
	var global = __webpack_require__(41);
	var speciesConstructor = __webpack_require__(91);
	var promiseResolve = __webpack_require__(97);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(40);
	var newPromiseCapability = __webpack_require__(95);
	var perform = __webpack_require__(96);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(104);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(105), __esModule: true };

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(106);
	module.exports = __webpack_require__(42).Object.assign;


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(40);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(107) });


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(60);
	var gOPS = __webpack_require__(108);
	var pIE = __webpack_require__(109);
	var toObject = __webpack_require__(74);
	var IObject = __webpack_require__(35);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(51)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ },
/* 108 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 109 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 110 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(112);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(113), __esModule: true };

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(114);
	var $Object = __webpack_require__(42).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(40);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(50), 'Object', { defineProperty: __webpack_require__(46).f });


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	* mudu-player.js v0.39.10
	* commit: d6d276a8
	* Copyright © 目睹 http://mudu.tv
	*/
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.muduPlayer = factory());
	}(this, (function () { 'use strict';
	
	  function _typeof(obj) {
	    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	      _typeof = function (obj) {
	        return typeof obj;
	      };
	    } else {
	      _typeof = function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	      };
	    }
	
	    return _typeof(obj);
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  function _createClass(Constructor, protoProps, staticProps) {
	    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) _defineProperties(Constructor, staticProps);
	    return Constructor;
	  }
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function _objectSpread(target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i] != null ? arguments[i] : {};
	      var ownKeys = Object.keys(source);
	
	      if (typeof Object.getOwnPropertySymbols === 'function') {
	        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
	          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	        }));
	      }
	
	      ownKeys.forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    }
	
	    return target;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function");
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) _setPrototypeOf(subClass, superClass);
	  }
	
	  function _getPrototypeOf(o) {
	    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	      return o.__proto__ || Object.getPrototypeOf(o);
	    };
	    return _getPrototypeOf(o);
	  }
	
	  function _setPrototypeOf(o, p) {
	    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	      o.__proto__ = p;
	      return o;
	    };
	
	    return _setPrototypeOf(o, p);
	  }
	
	  function _assertThisInitialized(self) {
	    if (self === void 0) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return self;
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (call && (typeof call === "object" || typeof call === "function")) {
	      return call;
	    }
	
	    return _assertThisInitialized(self);
	  }
	
	  function _superPropBase(object, property) {
	    while (!Object.prototype.hasOwnProperty.call(object, property)) {
	      object = _getPrototypeOf(object);
	      if (object === null) break;
	    }
	
	    return object;
	  }
	
	  function _get(target, property, receiver) {
	    if (typeof Reflect !== "undefined" && Reflect.get) {
	      _get = Reflect.get;
	    } else {
	      _get = function _get(target, property, receiver) {
	        var base = _superPropBase(target, property);
	
	        if (!base) return;
	        var desc = Object.getOwnPropertyDescriptor(base, property);
	
	        if (desc.get) {
	          return desc.get.call(receiver);
	        }
	
	        return desc.value;
	      };
	    }
	
	    return _get(target, property, receiver || target);
	  }
	
	  function _toConsumableArray(arr) {
	    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
	  }
	
	  function _arrayWithoutHoles(arr) {
	    if (Array.isArray(arr)) {
	      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	      return arr2;
	    }
	  }
	
	  function _iterableToArray(iter) {
	    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
	  }
	
	  function _nonIterableSpread() {
	    throw new TypeError("Invalid attempt to spread non-iterable instance");
	  }
	
	  var userAgent = navigator.userAgent;
	
	  var userAgentMatch = function userAgentMatch(regex) {
	    return userAgent.match(regex) !== null;
	  };
	
	  function lazyUserAgentMatch(regex) {
	    return function () {
	      return userAgentMatch(regex);
	    };
	  }
	
	  function isFlashInstalled() {
	    var version = flashVersion();
	    return !!version;
	  }
	  function isFlashSupported() {
	    var version = flashVersion();
	    return !!(version && version >= "5.0.2-15");
	  }
	  var isFF = lazyUserAgentMatch(/gecko\//i);
	  var isIETrident = lazyUserAgentMatch(/trident\/.+rv:\s*11/i);
	  var isIPod = lazyUserAgentMatch(/iP(hone|od)/i);
	  var isIPad = lazyUserAgentMatch(/iPad/i);
	  var isOSX = lazyUserAgentMatch(/Macintosh/i); // Check for Facebook App Version to see if it's Facebook
	
	  var isFacebook = lazyUserAgentMatch(/FBAV/i);
	  var isEdge = function isEdge() {
	    return userAgentMatch(/\sEdge\/\d+/i);
	  };
	  var isMSIE = function isMSIE() {
	    return userAgentMatch(/msie/i);
	  };
	  var isChrome = function isChrome() {
	    return userAgentMatch(/\s(?:(?:Headless)?Chrome|CriOS)\//i) && !isEdge() && !userAgentMatch(/UCBrowser/i);
	  };
	  var isIE = function isIE() {
	    return isEdge() || isIETrident() || isMSIE();
	  };
	  var isSafari = function isSafari() {
	    return userAgentMatch(/safari/i) && !userAgentMatch(/(?:Chrome|CriOS|chromium|android|phantom)/i);
	  };
	  var isIOS = function isIOS() {
	    return userAgentMatch(/iP(hone|ad|od)/i);
	  };
	  var isDebugMode = function isDebugMode() {
	    return window.location.href.indexOf('playerdebug') >= 0;
	  };
	  var getLanguage = function getLanguage() {
	    return navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage;
	  };
	  var isAndroidNative = function isAndroidNative() {
	    if (userAgentMatch(/chrome\/[123456789]/i) && !userAgentMatch(/chrome\/18/i) && !isFF()) {
	      return false;
	    }
	
	    return isAndroid();
	  };
	  var getWebkitVersion = function getWebkitVersion() {
	    var u = userAgent.toLowerCase();
	    return /webkit/.test(u) ? parseFloat(u.replace(/^.*webkit\/(\d+(\.\d+)?).*$/, '$1')) : false;
	  };
	  /** 是否是UC浏览器 */
	
	  var isUC = function isUC() {
	    return userAgentMatch(/UCBrowser/i);
	  };
	  /** 是否是移动QQ浏览器 或者QQ内置浏览器 */
	
	  var isMQQBrowser = function isMQQBrowser() {
	    return userAgentMatch(/MQQBrowser/i);
	  };
	  var isAndroid = function isAndroid() {
	    return userAgentMatch(/Android/i) && !userAgentMatch(/Windows Phone/i);
	  };
	  var isMobile = function isMobile() {
	    return isIOS() || isAndroid() || userAgentMatch(/Windows Phone/i);
	  };
	  var isWindows = function isWindows() {
	    return userAgentMatch('Windows') > -1;
	  };
	  var isIframe = function isIframe() {
	    try {
	      return window.self !== window.top;
	    } catch (e) {
	      return true;
	    }
	  };
	  var isX5Layer = function isX5Layer() {
	    return isWxLayer() || isQQLayer();
	  };
	  var isWxLayer = function isWxLayer() {
	    var ua = userAgent;
	    var res = /tbs\/(\d+) /gi.exec(ua);
	    var hasWechat = /wechat|micromessenger/gi.test(ua);
	
	    if (!isAndroid()) {
	      return false;
	    }
	
	    if (res || hasWechat) {
	      return hasWechat || (res[1] || '') > '036849';
	    }
	
	    return false;
	  };
	  var isQQLayer = function isQQLayer() {
	    var ua = userAgent;
	    var res = /MQQBrowser\/([\d+.]+) /gi.exec(ua);
	
	    if (!isAndroid()) {
	      return false;
	    }
	
	    if (res) {
	      return +(res[1] || '') >= 7.1;
	    }
	
	    return false;
	  };
	  var flashVersion = function flashVersion() {
	    if (isAndroid()) {
	      return 0;
	    }
	
	    var plugins = navigator.plugins;
	    var flash;
	
	    if (plugins) {
	      flash = plugins['Shockwave Flash'];
	
	      if (flash && flash.description) {
	        return parseFloat(flash.description.replace(/\D+(\d+\.?\d*).*/, '$1'));
	      }
	    }
	
	    if (typeof window.ActiveXObject !== 'undefined') {
	      try {
	        flash = new window.ActiveXObject('ShockwaveFlash.ShockwaveFlash');
	
	        if (flash) {
	          return parseFloat(flash.GetVariable('$version').split(' ')[1].replace(/\s*,\s*/, '.'));
	        }
	      } catch (e) {
	        return 0;
	      }
	
	      return flash;
	    }
	
	    return 0;
	  };
	
	  function browserVersion(browserEnvironment, agent) {
	    var version;
	    var major;
	    var minor;
	    var ix;
	
	    if (browserEnvironment.chrome) {
	      // A Chrome UA either contains "Chrome" (desktop/android) or "CriOS" (iOS)
	      if (agent.indexOf('Chrome') !== -1) {
	        version = agent.substring(agent.indexOf('Chrome') + 7);
	      } else {
	        version = agent.substring(agent.indexOf('CriOS') + 6);
	      }
	    } else if (browserEnvironment.safari) {
	      // Safari sets its version after the "Version" string in the agent
	      version = agent.substring(agent.indexOf('Version') + 8);
	    } else if (browserEnvironment.firefox) {
	      version = agent.substring(agent.indexOf('Firefox') + 8);
	    } else if (browserEnvironment.edge) {
	      version = agent.substring(agent.indexOf('Edge') + 5);
	    } else if (browserEnvironment.ie) {
	      // Older versions of IE use MSIE; IE11 uses rv:
	      if (agent.indexOf('rv:') !== -1) {
	        version = agent.substring(agent.indexOf('rv:') + 3);
	      } else if (agent.indexOf('MSIE') !== -1) {
	        version = agent.substring(agent.indexOf('MSIE') + 5);
	      }
	    }
	
	    if (version) {
	      // trim the version string
	      if ((ix = version.indexOf(';')) !== -1) {
	        version = version.substring(0, ix);
	      }
	
	      if ((ix = version.indexOf(' ')) !== -1) {
	        version = version.substring(0, ix);
	      }
	
	      if ((ix = version.indexOf(')')) !== -1) {
	        version = version.substring(0, ix);
	      }
	
	      major = parseInt(version, 10); // Versions will always be in the d.d.d format
	
	      minor = parseInt(version.split('.')[1], 10);
	    } // Allow undefined to represent unknown agents
	
	
	    return {
	      version: version,
	      major: major,
	      minor: minor
	    };
	  }
	
	  function execResult(array, index) {
	    if (array && array.length > index) {
	      return array[index];
	    }
	  }
	
	  function osVersion(osEnvironment, agent) {
	    var version;
	    var major;
	    var minor;
	
	    if (osEnvironment.windows) {
	      version = execResult(/Windows(?: NT|)? ([._\d]+)/.exec(agent), 1); // Map the Windows NT version to the canonical Windows version
	
	      switch (version) {
	        case '6.1':
	          version = '7.0';
	          break;
	
	        case '6.2':
	          version = '8.0';
	          break;
	
	        case '6.3':
	          version = '8.1';
	          break;
	      }
	    } else if (osEnvironment.android) {
	      version = execResult(/Android ([._\d]+)/.exec(agent), 1);
	    } else if (osEnvironment.iOS) {
	      version = execResult(/OS ([._\d]+)/.exec(agent), 1);
	    } else if (osEnvironment.mac) {
	      version = execResult(/Mac OS X (10[._\d]+)/.exec(agent), 1);
	    }
	
	    if (version) {
	      major = parseInt(version, 10); // Versions may be in the d.d.d or d_d_d format
	
	      var versionNumbers = version.split(/[._]/);
	
	      if (versionNumbers) {
	        minor = parseInt(versionNumbers[1], 10);
	      }
	    } // Allow undefined to represent unknown agents
	
	
	    return {
	      version: version,
	      major: major,
	      minor: minor
	    };
	  }
	
	  var userAgent$1 = navigator.userAgent;
	  var browser = {
	    chrome: isChrome(),
	    edge: isEdge(),
	    firefox: isFF(),
	    ie: isIE(),
	    msie: isMSIE(),
	    safari: isSafari()
	  };
	  browser.version = browserVersion(browser, userAgent$1);
	  var os = {
	    android: isAndroid(),
	    iOS: isIOS(),
	    mobile: isMobile(),
	    mac: isOSX(),
	    iPad: isIPad(),
	    iPhone: isIPod(),
	    windows: isWindows()
	  };
	  os.version = osVersion(os, userAgent$1);
	  var others = {
	    flashInstalled: isFlashInstalled(),
	    flashSupported: isFlashSupported(),
	    flashVersion: flashVersion(),
	    iframe: isIframe()
	  };
	  var envor = {
	    browser: browser,
	    os: os,
	    others: others
	  };
	  var browserVersion$1 = browser.version;
	  var osVersion$1 = os.version;
	  var getEnvor = function getEnvor() {
	    return JSON.parse(JSON.stringify(envor));
	  };
	
	  var browser$1 = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    browserVersion: browserVersion$1,
	    osVersion: osVersion$1,
	    getEnvor: getEnvor,
	    isFlashInstalled: isFlashInstalled,
	    isFlashSupported: isFlashSupported,
	    isFF: isFF,
	    isIETrident: isIETrident,
	    isIPod: isIPod,
	    isIPad: isIPad,
	    isOSX: isOSX,
	    isFacebook: isFacebook,
	    isEdge: isEdge,
	    isMSIE: isMSIE,
	    isChrome: isChrome,
	    isIE: isIE,
	    isSafari: isSafari,
	    isIOS: isIOS,
	    isDebugMode: isDebugMode,
	    getLanguage: getLanguage,
	    isAndroidNative: isAndroidNative,
	    getWebkitVersion: getWebkitVersion,
	    isUC: isUC,
	    isMQQBrowser: isMQQBrowser,
	    isAndroid: isAndroid,
	    isMobile: isMobile,
	    isWindows: isWindows,
	    isIframe: isIframe,
	    isX5Layer: isX5Layer,
	    isWxLayer: isWxLayer,
	    isQQLayer: isQQLayer,
	    flashVersion: flashVersion
	  });
	
	  /* This program is free software. It comes without any warranty, to
	       * the extent permitted by applicable law. You can redistribute it
	       * and/or modify it under the terms of the Do What The Fuck You Want
	       * To Public License, Version 2, as published by Sam Hocevar. See
	       * http://www.wtfpl.net/ for more details. */
	  var leftPad_1 = leftPad;
	
	  var cache = [
	    '',
	    ' ',
	    '  ',
	    '   ',
	    '    ',
	    '     ',
	    '      ',
	    '       ',
	    '        ',
	    '         '
	  ];
	
	  function leftPad (str, len, ch) {
	    // convert `str` to a `string`
	    str = str + '';
	    // `len` is the `pad`'s length now
	    len = len - str.length;
	    // doesn't need to pad
	    if (len <= 0) return str;
	    // `ch` defaults to `' '`
	    if (!ch && ch !== 0) ch = ' ';
	    // convert `ch` to a `string` cuz it could be a number
	    ch = ch + '';
	    // cache common use cases
	    if (ch === ' ' && len < 10) return cache[len] + str;
	    // `pad` starts with an empty string
	    var pad = '';
	    // loop
	    while (true) {
	      // add `ch` to `pad` if `len` is odd
	      if (len & 1) pad += ch;
	      // divide `len` by 2, ditch the remainder
	      len >>= 1;
	      // "double" the `ch` so this operation count grows logarithmically on `len`
	      // each time `ch` is "doubled", the `len` would need to be "doubled" too
	      // similar to finding a value in binary search tree, hence O(log(n))
	      if (len) ch += ch;
	      // `len` is 0, exit the loop
	      else break;
	    }
	    // pad `str`!
	    return pad + str;
	  }
	
	  /**
	   * A collection of shims that provide minimal functionality of the ES6 collections.
	   *
	   * These implementations are not meant to be used outside of the ResizeObserver
	   * modules as they cover only a limited range of use cases.
	   */
	  /* eslint-disable require-jsdoc, valid-jsdoc */
	  var MapShim = (function () {
	      if (typeof Map !== 'undefined') {
	          return Map;
	      }
	      /**
	       * Returns index in provided array that matches the specified key.
	       *
	       * @param {Array<Array>} arr
	       * @param {*} key
	       * @returns {number}
	       */
	      function getIndex(arr, key) {
	          var result = -1;
	          arr.some(function (entry, index) {
	              if (entry[0] === key) {
	                  result = index;
	                  return true;
	              }
	              return false;
	          });
	          return result;
	      }
	      return /** @class */ (function () {
	          function class_1() {
	              this.__entries__ = [];
	          }
	          Object.defineProperty(class_1.prototype, "size", {
	              /**
	               * @returns {boolean}
	               */
	              get: function () {
	                  return this.__entries__.length;
	              },
	              enumerable: true,
	              configurable: true
	          });
	          /**
	           * @param {*} key
	           * @returns {*}
	           */
	          class_1.prototype.get = function (key) {
	              var index = getIndex(this.__entries__, key);
	              var entry = this.__entries__[index];
	              return entry && entry[1];
	          };
	          /**
	           * @param {*} key
	           * @param {*} value
	           * @returns {void}
	           */
	          class_1.prototype.set = function (key, value) {
	              var index = getIndex(this.__entries__, key);
	              if (~index) {
	                  this.__entries__[index][1] = value;
	              }
	              else {
	                  this.__entries__.push([key, value]);
	              }
	          };
	          /**
	           * @param {*} key
	           * @returns {void}
	           */
	          class_1.prototype.delete = function (key) {
	              var entries = this.__entries__;
	              var index = getIndex(entries, key);
	              if (~index) {
	                  entries.splice(index, 1);
	              }
	          };
	          /**
	           * @param {*} key
	           * @returns {void}
	           */
	          class_1.prototype.has = function (key) {
	              return !!~getIndex(this.__entries__, key);
	          };
	          /**
	           * @returns {void}
	           */
	          class_1.prototype.clear = function () {
	              this.__entries__.splice(0);
	          };
	          /**
	           * @param {Function} callback
	           * @param {*} [ctx=null]
	           * @returns {void}
	           */
	          class_1.prototype.forEach = function (callback, ctx) {
	              if (ctx === void 0) { ctx = null; }
	              for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                  var entry = _a[_i];
	                  callback.call(ctx, entry[1], entry[0]);
	              }
	          };
	          return class_1;
	      }());
	  })();
	
	  /**
	   * Detects whether window and document objects are available in current environment.
	   */
	  var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	  // Returns global object of a current environment.
	  var global$1 = (function () {
	      if (typeof global !== 'undefined' && global.Math === Math) {
	          return global;
	      }
	      if (typeof self !== 'undefined' && self.Math === Math) {
	          return self;
	      }
	      if (typeof window !== 'undefined' && window.Math === Math) {
	          return window;
	      }
	      // eslint-disable-next-line no-new-func
	      return Function('return this')();
	  })();
	
	  /**
	   * A shim for the requestAnimationFrame which falls back to the setTimeout if
	   * first one is not supported.
	   *
	   * @returns {number} Requests' identifier.
	   */
	  var requestAnimationFrame$1 = (function () {
	      if (typeof requestAnimationFrame === 'function') {
	          // It's required to use a bounded function because IE sometimes throws
	          // an "Invalid calling object" error if rAF is invoked without the global
	          // object on the left hand side.
	          return requestAnimationFrame.bind(global$1);
	      }
	      return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	  })();
	
	  // Defines minimum timeout before adding a trailing call.
	  var trailingTimeout = 2;
	  /**
	   * Creates a wrapper function which ensures that provided callback will be
	   * invoked only once during the specified delay period.
	   *
	   * @param {Function} callback - Function to be invoked after the delay period.
	   * @param {number} delay - Delay after which to invoke callback.
	   * @returns {Function}
	   */
	  function throttle (callback, delay) {
	      var leadingCall = false, trailingCall = false, lastCallTime = 0;
	      /**
	       * Invokes the original callback function and schedules new invocation if
	       * the "proxy" was called during current request.
	       *
	       * @returns {void}
	       */
	      function resolvePending() {
	          if (leadingCall) {
	              leadingCall = false;
	              callback();
	          }
	          if (trailingCall) {
	              proxy();
	          }
	      }
	      /**
	       * Callback invoked after the specified delay. It will further postpone
	       * invocation of the original function delegating it to the
	       * requestAnimationFrame.
	       *
	       * @returns {void}
	       */
	      function timeoutCallback() {
	          requestAnimationFrame$1(resolvePending);
	      }
	      /**
	       * Schedules invocation of the original function.
	       *
	       * @returns {void}
	       */
	      function proxy() {
	          var timeStamp = Date.now();
	          if (leadingCall) {
	              // Reject immediately following calls.
	              if (timeStamp - lastCallTime < trailingTimeout) {
	                  return;
	              }
	              // Schedule new call to be in invoked when the pending one is resolved.
	              // This is important for "transitions" which never actually start
	              // immediately so there is a chance that we might miss one if change
	              // happens amids the pending invocation.
	              trailingCall = true;
	          }
	          else {
	              leadingCall = true;
	              trailingCall = false;
	              setTimeout(timeoutCallback, delay);
	          }
	          lastCallTime = timeStamp;
	      }
	      return proxy;
	  }
	
	  // Minimum delay before invoking the update of observers.
	  var REFRESH_DELAY = 20;
	  // A list of substrings of CSS properties used to find transition events that
	  // might affect dimensions of observed elements.
	  var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	  // Check if MutationObserver is available.
	  var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	  /**
	   * Singleton controller class which handles updates of ResizeObserver instances.
	   */
	  var ResizeObserverController = /** @class */ (function () {
	      /**
	       * Creates a new instance of ResizeObserverController.
	       *
	       * @private
	       */
	      function ResizeObserverController() {
	          /**
	           * Indicates whether DOM listeners have been added.
	           *
	           * @private {boolean}
	           */
	          this.connected_ = false;
	          /**
	           * Tells that controller has subscribed for Mutation Events.
	           *
	           * @private {boolean}
	           */
	          this.mutationEventsAdded_ = false;
	          /**
	           * Keeps reference to the instance of MutationObserver.
	           *
	           * @private {MutationObserver}
	           */
	          this.mutationsObserver_ = null;
	          /**
	           * A list of connected observers.
	           *
	           * @private {Array<ResizeObserverSPI>}
	           */
	          this.observers_ = [];
	          this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	          this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	      }
	      /**
	       * Adds observer to observers list.
	       *
	       * @param {ResizeObserverSPI} observer - Observer to be added.
	       * @returns {void}
	       */
	      ResizeObserverController.prototype.addObserver = function (observer) {
	          if (!~this.observers_.indexOf(observer)) {
	              this.observers_.push(observer);
	          }
	          // Add listeners if they haven't been added yet.
	          if (!this.connected_) {
	              this.connect_();
	          }
	      };
	      /**
	       * Removes observer from observers list.
	       *
	       * @param {ResizeObserverSPI} observer - Observer to be removed.
	       * @returns {void}
	       */
	      ResizeObserverController.prototype.removeObserver = function (observer) {
	          var observers = this.observers_;
	          var index = observers.indexOf(observer);
	          // Remove observer if it's present in registry.
	          if (~index) {
	              observers.splice(index, 1);
	          }
	          // Remove listeners if controller has no connected observers.
	          if (!observers.length && this.connected_) {
	              this.disconnect_();
	          }
	      };
	      /**
	       * Invokes the update of observers. It will continue running updates insofar
	       * it detects changes.
	       *
	       * @returns {void}
	       */
	      ResizeObserverController.prototype.refresh = function () {
	          var changesDetected = this.updateObservers_();
	          // Continue running updates if changes have been detected as there might
	          // be future ones caused by CSS transitions.
	          if (changesDetected) {
	              this.refresh();
	          }
	      };
	      /**
	       * Updates every observer from observers list and notifies them of queued
	       * entries.
	       *
	       * @private
	       * @returns {boolean} Returns "true" if any observer has detected changes in
	       *      dimensions of it's elements.
	       */
	      ResizeObserverController.prototype.updateObservers_ = function () {
	          // Collect observers that have active observations.
	          var activeObservers = this.observers_.filter(function (observer) {
	              return observer.gatherActive(), observer.hasActive();
	          });
	          // Deliver notifications in a separate cycle in order to avoid any
	          // collisions between observers, e.g. when multiple instances of
	          // ResizeObserver are tracking the same element and the callback of one
	          // of them changes content dimensions of the observed target. Sometimes
	          // this may result in notifications being blocked for the rest of observers.
	          activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	          return activeObservers.length > 0;
	      };
	      /**
	       * Initializes DOM listeners.
	       *
	       * @private
	       * @returns {void}
	       */
	      ResizeObserverController.prototype.connect_ = function () {
	          // Do nothing if running in a non-browser environment or if listeners
	          // have been already added.
	          if (!isBrowser || this.connected_) {
	              return;
	          }
	          // Subscription to the "Transitionend" event is used as a workaround for
	          // delayed transitions. This way it's possible to capture at least the
	          // final state of an element.
	          document.addEventListener('transitionend', this.onTransitionEnd_);
	          window.addEventListener('resize', this.refresh);
	          if (mutationObserverSupported) {
	              this.mutationsObserver_ = new MutationObserver(this.refresh);
	              this.mutationsObserver_.observe(document, {
	                  attributes: true,
	                  childList: true,
	                  characterData: true,
	                  subtree: true
	              });
	          }
	          else {
	              document.addEventListener('DOMSubtreeModified', this.refresh);
	              this.mutationEventsAdded_ = true;
	          }
	          this.connected_ = true;
	      };
	      /**
	       * Removes DOM listeners.
	       *
	       * @private
	       * @returns {void}
	       */
	      ResizeObserverController.prototype.disconnect_ = function () {
	          // Do nothing if running in a non-browser environment or if listeners
	          // have been already removed.
	          if (!isBrowser || !this.connected_) {
	              return;
	          }
	          document.removeEventListener('transitionend', this.onTransitionEnd_);
	          window.removeEventListener('resize', this.refresh);
	          if (this.mutationsObserver_) {
	              this.mutationsObserver_.disconnect();
	          }
	          if (this.mutationEventsAdded_) {
	              document.removeEventListener('DOMSubtreeModified', this.refresh);
	          }
	          this.mutationsObserver_ = null;
	          this.mutationEventsAdded_ = false;
	          this.connected_ = false;
	      };
	      /**
	       * "Transitionend" event handler.
	       *
	       * @private
	       * @param {TransitionEvent} event
	       * @returns {void}
	       */
	      ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	          var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	          // Detect whether transition may affect dimensions of an element.
	          var isReflowProperty = transitionKeys.some(function (key) {
	              return !!~propertyName.indexOf(key);
	          });
	          if (isReflowProperty) {
	              this.refresh();
	          }
	      };
	      /**
	       * Returns instance of the ResizeObserverController.
	       *
	       * @returns {ResizeObserverController}
	       */
	      ResizeObserverController.getInstance = function () {
	          if (!this.instance_) {
	              this.instance_ = new ResizeObserverController();
	          }
	          return this.instance_;
	      };
	      /**
	       * Holds reference to the controller's instance.
	       *
	       * @private {ResizeObserverController}
	       */
	      ResizeObserverController.instance_ = null;
	      return ResizeObserverController;
	  }());
	
	  /**
	   * Defines non-writable/enumerable properties of the provided target object.
	   *
	   * @param {Object} target - Object for which to define properties.
	   * @param {Object} props - Properties to be defined.
	   * @returns {Object} Target object.
	   */
	  var defineConfigurable = (function (target, props) {
	      for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	          var key = _a[_i];
	          Object.defineProperty(target, key, {
	              value: props[key],
	              enumerable: false,
	              writable: false,
	              configurable: true
	          });
	      }
	      return target;
	  });
	
	  /**
	   * Returns the global object associated with provided element.
	   *
	   * @param {Object} target
	   * @returns {Object}
	   */
	  var getWindowOf = (function (target) {
	      // Assume that the element is an instance of Node, which means that it
	      // has the "ownerDocument" property from which we can retrieve a
	      // corresponding global object.
	      var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	      // Return the local global object if it's not possible extract one from
	      // provided element.
	      return ownerGlobal || global$1;
	  });
	
	  // Placeholder of an empty content rectangle.
	  var emptyRect = createRectInit(0, 0, 0, 0);
	  /**
	   * Converts provided string to a number.
	   *
	   * @param {number|string} value
	   * @returns {number}
	   */
	  function toFloat(value) {
	      return parseFloat(value) || 0;
	  }
	  /**
	   * Extracts borders size from provided styles.
	   *
	   * @param {CSSStyleDeclaration} styles
	   * @param {...string} positions - Borders positions (top, right, ...)
	   * @returns {number}
	   */
	  function getBordersSize(styles) {
	      var positions = [];
	      for (var _i = 1; _i < arguments.length; _i++) {
	          positions[_i - 1] = arguments[_i];
	      }
	      return positions.reduce(function (size, position) {
	          var value = styles['border-' + position + '-width'];
	          return size + toFloat(value);
	      }, 0);
	  }
	  /**
	   * Extracts paddings sizes from provided styles.
	   *
	   * @param {CSSStyleDeclaration} styles
	   * @returns {Object} Paddings box.
	   */
	  function getPaddings(styles) {
	      var positions = ['top', 'right', 'bottom', 'left'];
	      var paddings = {};
	      for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	          var position = positions_1[_i];
	          var value = styles['padding-' + position];
	          paddings[position] = toFloat(value);
	      }
	      return paddings;
	  }
	  /**
	   * Calculates content rectangle of provided SVG element.
	   *
	   * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	   *      to be calculated.
	   * @returns {DOMRectInit}
	   */
	  function getSVGContentRect(target) {
	      var bbox = target.getBBox();
	      return createRectInit(0, 0, bbox.width, bbox.height);
	  }
	  /**
	   * Calculates content rectangle of provided HTMLElement.
	   *
	   * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	   * @returns {DOMRectInit}
	   */
	  function getHTMLElementContentRect(target) {
	      // Client width & height properties can't be
	      // used exclusively as they provide rounded values.
	      var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	      // By this condition we can catch all non-replaced inline, hidden and
	      // detached elements. Though elements with width & height properties less
	      // than 0.5 will be discarded as well.
	      //
	      // Without it we would need to implement separate methods for each of
	      // those cases and it's not possible to perform a precise and performance
	      // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	      // gives wrong results for elements with width & height less than 0.5.
	      if (!clientWidth && !clientHeight) {
	          return emptyRect;
	      }
	      var styles = getWindowOf(target).getComputedStyle(target);
	      var paddings = getPaddings(styles);
	      var horizPad = paddings.left + paddings.right;
	      var vertPad = paddings.top + paddings.bottom;
	      // Computed styles of width & height are being used because they are the
	      // only dimensions available to JS that contain non-rounded values. It could
	      // be possible to utilize the getBoundingClientRect if only it's data wasn't
	      // affected by CSS transformations let alone paddings, borders and scroll bars.
	      var width = toFloat(styles.width), height = toFloat(styles.height);
	      // Width & height include paddings and borders when the 'border-box' box
	      // model is applied (except for IE).
	      if (styles.boxSizing === 'border-box') {
	          // Following conditions are required to handle Internet Explorer which
	          // doesn't include paddings and borders to computed CSS dimensions.
	          //
	          // We can say that if CSS dimensions + paddings are equal to the "client"
	          // properties then it's either IE, and thus we don't need to subtract
	          // anything, or an element merely doesn't have paddings/borders styles.
	          if (Math.round(width + horizPad) !== clientWidth) {
	              width -= getBordersSize(styles, 'left', 'right') + horizPad;
	          }
	          if (Math.round(height + vertPad) !== clientHeight) {
	              height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	          }
	      }
	      // Following steps can't be applied to the document's root element as its
	      // client[Width/Height] properties represent viewport area of the window.
	      // Besides, it's as well not necessary as the <html> itself neither has
	      // rendered scroll bars nor it can be clipped.
	      if (!isDocumentElement(target)) {
	          // In some browsers (only in Firefox, actually) CSS width & height
	          // include scroll bars size which can be removed at this step as scroll
	          // bars are the only difference between rounded dimensions + paddings
	          // and "client" properties, though that is not always true in Chrome.
	          var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	          var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	          // Chrome has a rather weird rounding of "client" properties.
	          // E.g. for an element with content width of 314.2px it sometimes gives
	          // the client width of 315px and for the width of 314.7px it may give
	          // 314px. And it doesn't happen all the time. So just ignore this delta
	          // as a non-relevant.
	          if (Math.abs(vertScrollbar) !== 1) {
	              width -= vertScrollbar;
	          }
	          if (Math.abs(horizScrollbar) !== 1) {
	              height -= horizScrollbar;
	          }
	      }
	      return createRectInit(paddings.left, paddings.top, width, height);
	  }
	  /**
	   * Checks whether provided element is an instance of the SVGGraphicsElement.
	   *
	   * @param {Element} target - Element to be checked.
	   * @returns {boolean}
	   */
	  var isSVGGraphicsElement = (function () {
	      // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	      // interface.
	      if (typeof SVGGraphicsElement !== 'undefined') {
	          return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	      }
	      // If it's so, then check that element is at least an instance of the
	      // SVGElement and that it has the "getBBox" method.
	      // eslint-disable-next-line no-extra-parens
	      return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	          typeof target.getBBox === 'function'); };
	  })();
	  /**
	   * Checks whether provided element is a document element (<html>).
	   *
	   * @param {Element} target - Element to be checked.
	   * @returns {boolean}
	   */
	  function isDocumentElement(target) {
	      return target === getWindowOf(target).document.documentElement;
	  }
	  /**
	   * Calculates an appropriate content rectangle for provided html or svg element.
	   *
	   * @param {Element} target - Element content rectangle of which needs to be calculated.
	   * @returns {DOMRectInit}
	   */
	  function getContentRect(target) {
	      if (!isBrowser) {
	          return emptyRect;
	      }
	      if (isSVGGraphicsElement(target)) {
	          return getSVGContentRect(target);
	      }
	      return getHTMLElementContentRect(target);
	  }
	  /**
	   * Creates rectangle with an interface of the DOMRectReadOnly.
	   * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	   *
	   * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	   * @returns {DOMRectReadOnly}
	   */
	  function createReadOnlyRect(_a) {
	      var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	      // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	      var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	      var rect = Object.create(Constr.prototype);
	      // Rectangle's properties are not writable and non-enumerable.
	      defineConfigurable(rect, {
	          x: x, y: y, width: width, height: height,
	          top: y,
	          right: x + width,
	          bottom: height + y,
	          left: x
	      });
	      return rect;
	  }
	  /**
	   * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	   * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	   *
	   * @param {number} x - X coordinate.
	   * @param {number} y - Y coordinate.
	   * @param {number} width - Rectangle's width.
	   * @param {number} height - Rectangle's height.
	   * @returns {DOMRectInit}
	   */
	  function createRectInit(x, y, width, height) {
	      return { x: x, y: y, width: width, height: height };
	  }
	
	  /**
	   * Class that is responsible for computations of the content rectangle of
	   * provided DOM element and for keeping track of it's changes.
	   */
	  var ResizeObservation = /** @class */ (function () {
	      /**
	       * Creates an instance of ResizeObservation.
	       *
	       * @param {Element} target - Element to be observed.
	       */
	      function ResizeObservation(target) {
	          /**
	           * Broadcasted width of content rectangle.
	           *
	           * @type {number}
	           */
	          this.broadcastWidth = 0;
	          /**
	           * Broadcasted height of content rectangle.
	           *
	           * @type {number}
	           */
	          this.broadcastHeight = 0;
	          /**
	           * Reference to the last observed content rectangle.
	           *
	           * @private {DOMRectInit}
	           */
	          this.contentRect_ = createRectInit(0, 0, 0, 0);
	          this.target = target;
	      }
	      /**
	       * Updates content rectangle and tells whether it's width or height properties
	       * have changed since the last broadcast.
	       *
	       * @returns {boolean}
	       */
	      ResizeObservation.prototype.isActive = function () {
	          var rect = getContentRect(this.target);
	          this.contentRect_ = rect;
	          return (rect.width !== this.broadcastWidth ||
	              rect.height !== this.broadcastHeight);
	      };
	      /**
	       * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	       * from the corresponding properties of the last observed content rectangle.
	       *
	       * @returns {DOMRectInit} Last observed content rectangle.
	       */
	      ResizeObservation.prototype.broadcastRect = function () {
	          var rect = this.contentRect_;
	          this.broadcastWidth = rect.width;
	          this.broadcastHeight = rect.height;
	          return rect;
	      };
	      return ResizeObservation;
	  }());
	
	  var ResizeObserverEntry = /** @class */ (function () {
	      /**
	       * Creates an instance of ResizeObserverEntry.
	       *
	       * @param {Element} target - Element that is being observed.
	       * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	       */
	      function ResizeObserverEntry(target, rectInit) {
	          var contentRect = createReadOnlyRect(rectInit);
	          // According to the specification following properties are not writable
	          // and are also not enumerable in the native implementation.
	          //
	          // Property accessors are not being used as they'd require to define a
	          // private WeakMap storage which may cause memory leaks in browsers that
	          // don't support this type of collections.
	          defineConfigurable(this, { target: target, contentRect: contentRect });
	      }
	      return ResizeObserverEntry;
	  }());
	
	  var ResizeObserverSPI = /** @class */ (function () {
	      /**
	       * Creates a new instance of ResizeObserver.
	       *
	       * @param {ResizeObserverCallback} callback - Callback function that is invoked
	       *      when one of the observed elements changes it's content dimensions.
	       * @param {ResizeObserverController} controller - Controller instance which
	       *      is responsible for the updates of observer.
	       * @param {ResizeObserver} callbackCtx - Reference to the public
	       *      ResizeObserver instance which will be passed to callback function.
	       */
	      function ResizeObserverSPI(callback, controller, callbackCtx) {
	          /**
	           * Collection of resize observations that have detected changes in dimensions
	           * of elements.
	           *
	           * @private {Array<ResizeObservation>}
	           */
	          this.activeObservations_ = [];
	          /**
	           * Registry of the ResizeObservation instances.
	           *
	           * @private {Map<Element, ResizeObservation>}
	           */
	          this.observations_ = new MapShim();
	          if (typeof callback !== 'function') {
	              throw new TypeError('The callback provided as parameter 1 is not a function.');
	          }
	          this.callback_ = callback;
	          this.controller_ = controller;
	          this.callbackCtx_ = callbackCtx;
	      }
	      /**
	       * Starts observing provided element.
	       *
	       * @param {Element} target - Element to be observed.
	       * @returns {void}
	       */
	      ResizeObserverSPI.prototype.observe = function (target) {
	          if (!arguments.length) {
	              throw new TypeError('1 argument required, but only 0 present.');
	          }
	          // Do nothing if current environment doesn't have the Element interface.
	          if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	              return;
	          }
	          if (!(target instanceof getWindowOf(target).Element)) {
	              throw new TypeError('parameter 1 is not of type "Element".');
	          }
	          var observations = this.observations_;
	          // Do nothing if element is already being observed.
	          if (observations.has(target)) {
	              return;
	          }
	          observations.set(target, new ResizeObservation(target));
	          this.controller_.addObserver(this);
	          // Force the update of observations.
	          this.controller_.refresh();
	      };
	      /**
	       * Stops observing provided element.
	       *
	       * @param {Element} target - Element to stop observing.
	       * @returns {void}
	       */
	      ResizeObserverSPI.prototype.unobserve = function (target) {
	          if (!arguments.length) {
	              throw new TypeError('1 argument required, but only 0 present.');
	          }
	          // Do nothing if current environment doesn't have the Element interface.
	          if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	              return;
	          }
	          if (!(target instanceof getWindowOf(target).Element)) {
	              throw new TypeError('parameter 1 is not of type "Element".');
	          }
	          var observations = this.observations_;
	          // Do nothing if element is not being observed.
	          if (!observations.has(target)) {
	              return;
	          }
	          observations.delete(target);
	          if (!observations.size) {
	              this.controller_.removeObserver(this);
	          }
	      };
	      /**
	       * Stops observing all elements.
	       *
	       * @returns {void}
	       */
	      ResizeObserverSPI.prototype.disconnect = function () {
	          this.clearActive();
	          this.observations_.clear();
	          this.controller_.removeObserver(this);
	      };
	      /**
	       * Collects observation instances the associated element of which has changed
	       * it's content rectangle.
	       *
	       * @returns {void}
	       */
	      ResizeObserverSPI.prototype.gatherActive = function () {
	          var _this = this;
	          this.clearActive();
	          this.observations_.forEach(function (observation) {
	              if (observation.isActive()) {
	                  _this.activeObservations_.push(observation);
	              }
	          });
	      };
	      /**
	       * Invokes initial callback function with a list of ResizeObserverEntry
	       * instances collected from active resize observations.
	       *
	       * @returns {void}
	       */
	      ResizeObserverSPI.prototype.broadcastActive = function () {
	          // Do nothing if observer doesn't have active observations.
	          if (!this.hasActive()) {
	              return;
	          }
	          var ctx = this.callbackCtx_;
	          // Create ResizeObserverEntry instance for every active observation.
	          var entries = this.activeObservations_.map(function (observation) {
	              return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	          });
	          this.callback_.call(ctx, entries, ctx);
	          this.clearActive();
	      };
	      /**
	       * Clears the collection of active observations.
	       *
	       * @returns {void}
	       */
	      ResizeObserverSPI.prototype.clearActive = function () {
	          this.activeObservations_.splice(0);
	      };
	      /**
	       * Tells whether observer has active observations.
	       *
	       * @returns {boolean}
	       */
	      ResizeObserverSPI.prototype.hasActive = function () {
	          return this.activeObservations_.length > 0;
	      };
	      return ResizeObserverSPI;
	  }());
	
	  // Registry of internal observers. If WeakMap is not available use current shim
	  // for the Map collection as it has all required methods and because WeakMap
	  // can't be fully polyfilled anyway.
	  var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	  /**
	   * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	   * exposing only those methods and properties that are defined in the spec.
	   */
	  var ResizeObserver = /** @class */ (function () {
	      /**
	       * Creates a new instance of ResizeObserver.
	       *
	       * @param {ResizeObserverCallback} callback - Callback that is invoked when
	       *      dimensions of the observed elements change.
	       */
	      function ResizeObserver(callback) {
	          if (!(this instanceof ResizeObserver)) {
	              throw new TypeError('Cannot call a class as a function.');
	          }
	          if (!arguments.length) {
	              throw new TypeError('1 argument required, but only 0 present.');
	          }
	          var controller = ResizeObserverController.getInstance();
	          var observer = new ResizeObserverSPI(callback, controller, this);
	          observers.set(this, observer);
	      }
	      return ResizeObserver;
	  }());
	  // Expose public methods of ResizeObserver.
	  [
	      'observe',
	      'unobserve',
	      'disconnect'
	  ].forEach(function (method) {
	      ResizeObserver.prototype[method] = function () {
	          var _a;
	          return (_a = observers.get(this))[method].apply(_a, arguments);
	      };
	  });
	
	  var index = (function () {
	      // Export existing implementation if available.
	      if (typeof global$1.ResizeObserver !== 'undefined') {
	          return global$1.ResizeObserver;
	      }
	      return ResizeObserver;
	  })();
	
	  function uniqBy(array, fn) {
	    var uniqed = [];
	    var ret = [];
	
	    for (var i = 0; i < array.length; i++) {
	      var u = fn(array[i], i, array);
	
	      if (uniqed.indexOf(u) >= 0) {
	        continue;
	      } else {
	        ret.push(array[i]);
	        uniqed.push(u);
	      }
	    }
	
	    return ret;
	  }
	  function is(type, value) {
	    var vtype = Object.prototype.toString.call(value);
	    return "[object ".concat(type.toLowerCase(), "]") === vtype.toLowerCase();
	  }
	  function cssLength(value) {
	    if (is('number', value)) {
	      if (value <= 0) {
	        // ie < 0 will throw error
	        return 0;
	      } else if (value <= 1) {
	        return value * 100 + '%';
	      } else {
	        return value + 'px';
	      }
	    }
	
	    return value;
	  }
	  function noop() {}
	  var returnTrue = function returnTrue() {
	    return true;
	  };
	  var returnFalse = function returnFalse() {
	    return false;
	  };
	  function objectKeys(obj) {
	    var ret = [];
	
	    for (var i in obj) {
	      ret.push(i);
	    }
	
	    return ret;
	  }
	  function rtmpStreamToParts(src) {
	    var parts = {
	      connection: '',
	      stream: ''
	    };
	
	    if (!src) {
	      return parts;
	    } // Look for the normal URL separator we expect, '&'.
	    // If found, we split the URL into two pieces around the
	    // first '&'.
	
	
	    var connEnd = src.search(/&(?!\w+=)/);
	    var streamBegin;
	
	    if (connEnd !== -1) {
	      streamBegin = connEnd;
	    } else {
	      // If there's not a '&', we use the last '/' as the delimiter.
	      connEnd = streamBegin = src.lastIndexOf('/');
	
	      if (connEnd === 0) {
	        // really, there's not a '/'?
	        connEnd = streamBegin = src.length;
	      }
	    }
	
	    parts.connection = src.substring(0, connEnd);
	    parts.stream = src.substring(streamBegin + 1, src.length);
	    return parts;
	  }
	  /**
	   * Parse second to time string
	   *
	   * @param {Number} second
	   * @return {String} 00:00 or 00:00:00
	   */
	
	  function secondToTime(second) {
	    var isMinus = second < 0;
	
	    if (isMinus) {
	      second = -second;
	    }
	
	    var add0 = function add0(num) {
	      return num < 10 ? '0' + num : '' + num;
	    };
	
	    var hour = Math.floor(second / 3600);
	    var min = Math.floor((second - hour * 3600) / 60);
	    var sec = Math.floor(second - hour * 3600 - min * 60);
	    var str = (hour > 0 ? [hour, min, sec] : [min, sec]).map(add0).join(':');
	
	    if (isMinus) {
	      return '-' + str;
	    }
	
	    return str;
	  }
	  function cumulativeOffset(element) {
	    var top = 0;
	    var left = 0;
	
	    do {
	      top += element.offsetTop || 0;
	      left += element.offsetLeft || 0;
	      element = element.offsetParent;
	    } while (element);
	
	    return {
	      top: top,
	      left: left
	    };
	  }
	  function getComputedStyle(element) {
	    if (window.getComputedStyle) {
	      return window.getComputedStyle(element);
	    } else if (element.currentStyle) {
	      // ie8
	      return element.currentStyle;
	    }
	
	    return {};
	  }
	  function getElementViewLeft(element) {
	    var rect = getBoundingClientRect(element);
	    if (rect.left) return rect.left;
	    var actualLeft = element.offsetLeft;
	    var current = element.offsetParent;
	    var elementScrollLeft = document.body.scrollLeft + document.documentElement.scrollLeft;
	
	    if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement) {
	      while (current !== null) {
	        actualLeft += current.offsetLeft;
	        current = current.offsetParent;
	      }
	    } else {
	      while (current !== null && current !== element) {
	        actualLeft += current.offsetLeft;
	        current = current.offsetParent;
	      }
	    }
	
	    return actualLeft - elementScrollLeft;
	  }
	  var raf = function () {
	    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
	      return window.setTimeout(callback, 1000 / 60);
	    };
	  }();
	  var caf = function () {
	    return window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCanelAnimationFrame || window.oCancelAnimationFrame || window.msCancelAnimationFrame || function (timer) {
	      window.clearTimeout(timer);
	    };
	  }();
	  function addEventListener(dom) {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (document.addEventListener) {
	      return dom.addEventListener.apply(dom, args);
	    } else {
	      // dom.attachEvent can not call apply
	      return dom.attachEvent('on' + args[0], args[1]);
	    }
	  }
	  function removeEventListener(dom) {
	    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      args[_key2 - 1] = arguments[_key2];
	    }
	
	    if (document.removeEventListener) {
	      return dom.removeEventListener.apply(dom, args);
	    } else {
	      return dom.detachEvent('on' + args[0], args[1]);
	    }
	  }
	  function classList(element) {
	    var list = element.className.split(' ').filter(function (name) {
	      return name.replace(' ', '') !== '';
	    });
	
	    function add(name) {
	      list.push(name);
	      save();
	    }
	
	    function remove(name) {
	      var filterF;
	
	      if (is('RegExp', name)) {
	        filterF = function filterF(n) {
	          return !n.match(name);
	        };
	      } else {
	        filterF = function filterF(n) {
	          return n !== name;
	        };
	      }
	
	      list = list.filter(filterF);
	      save();
	    }
	
	    function toggle(name) {
	      var exist = contains(name);
	
	      if (exist) {
	        remove(name);
	      } else {
	        add(name);
	      }
	    }
	
	    function contains(name) {
	      return list.indexOf(name) >= 0;
	    }
	
	    function save() {
	      list = uniqBy(list, function (_) {
	        return _;
	      });
	      element.className = list.join(' ');
	    }
	
	    return {
	      add: add,
	      remove: remove,
	      toggle: toggle,
	      contains: contains
	    };
	  }
	  function stringToDom(string) {
	    var div = document.createElement('div');
	    div.innerHTML = string;
	    return div.firstChild;
	  }
	  function moment(d) {
	    d = d || new Date();
	
	    function format(f) {
	      f = f || 'YYYY-MM-DD HH:mm:ss.SSS';
	      var YYYY = d.getFullYear();
	      var MM = leftPad_1(d.getMonth() + 1, 2, '0');
	      var DD = leftPad_1(d.getDate(), 2, 0);
	      var HH = leftPad_1(d.getHours(), 2, 0);
	      var mm = leftPad_1(d.getMinutes(), 2, 0);
	      var ss = leftPad_1(d.getSeconds(), 2, 0);
	      var SSS = leftPad_1(d.getMilliseconds(), 3, 0);
	      var fd = f.replace('YYYY', YYYY).replace('MM', MM).replace('DD', DD).replace('HH', HH).replace('mm', mm).replace('ss', ss).replace('SSS', SSS);
	      return fd;
	    }
	
	    return {
	      format: format
	    };
	  }
	  /**
	   * @see https://www.ietf.org/rfc/rfc3339.txt
	   * @param {Date} d
	   */
	
	  function rfc3339nano(d) {
	    d = d || new Date();
	    var YYYY = d.getFullYear();
	    var MM = leftPad_1(d.getMonth() + 1, 2, '0');
	    var DD = leftPad_1(d.getDate(), 2, 0);
	    var HH = leftPad_1(d.getHours(), 2, 0);
	    var mm = leftPad_1(d.getMinutes(), 2, 0);
	    var ss = leftPad_1(d.getSeconds(), 2, 0);
	    var SSS = d.getMilliseconds() * 1e6;
	    var timeZoneOffset = -d.getTimezoneOffset();
	    var absTimeZoneOffset = Math.abs(d.getTimezoneOffset());
	    var hourOffset = leftPad_1(Math.floor(absTimeZoneOffset / 60), 2, 0);
	    var minuteOffset = leftPad_1(Math.floor(absTimeZoneOffset % 60), 2, 0);
	    var timeZoneOffsetMinus = timeZoneOffset < 0 ? '-' : '+';
	    var fullDate = "".concat(YYYY, "-").concat(MM, "-").concat(DD);
	    var timeSecfrac = SSS === 0 ? '' : ".".concat(SSS);
	    var partialTime = "".concat(HH, ":").concat(mm, ":").concat(ss).concat(timeSecfrac);
	    var timeOffset = timeZoneOffset === 0 ? '' : "".concat(timeZoneOffsetMinus).concat(hourOffset, ":").concat(minuteOffset);
	    var fullTime = "".concat(partialTime).concat(timeOffset);
	    var dateTime = "".concat(fullDate, "T").concat(fullTime);
	    return dateTime;
	  }
	  function genErrorId() {
	    var hms = moment().format('HHmmss');
	    var randomStr = randomString(3);
	    return hms + randomStr;
	  }
	  function genPlayerUniqId() {
	    var time = moment().format('MMDDHHmmss');
	    var randomStr = randomString(5);
	    return time + randomStr;
	  }
	  function urlStringify(obj) {
	    var keys = objectKeys(obj);
	    var pairs = keys.map(function (k) {
	      var str = typeof obj[k] !== 'string' ? safeJSONStringify(obj[k]) : obj[k];
	      return "".concat(k, "=").concat(encodeURIComponent(str));
	    });
	    return pairs.join('&');
	  }
	  function getBoundingClientRect(ele) {
	    var init = {
	      width: ele.offsetWidth,
	      height: ele.offsetHeight
	    };
	    var rect = ele.getBoundingClientRect(); // {...rect} -> {}
	
	    var rectCopy = {};
	    objectKeys(rect).forEach(function (v) {
	      rectCopy[v] = rect[v];
	    });
	    return _objectSpread({}, init, rectCopy);
	  }
	  function getTooltipString(text) {
	    var str = "<div class=\"mudu-reset mudu-tooltip-text-wrap\">" + "<span class=\"mudu-reset mudu-tooltip-text\">".concat(text, "</span>") + "</div>";
	    return str;
	  }
	  function safeJSONStringify(json) {
	    var cache = [];
	    return JSON.stringify(json, function (key, value) {
	      if (_typeof(value) === 'object' && value !== null) {
	        if (cache.indexOf(value) !== -1) {
	          return;
	        }
	
	        cache.push(value);
	      }
	
	      return value;
	    });
	  }
	  function randomString() {
	    var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
	    var upperChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
	    var lowerChars = upperChars.toLowerCase();
	    var digits = '0123456789';
	    var chars = upperChars + lowerChars + digits;
	    var rStr = '';
	
	    for (var i = 0; i < len; i++) {
	      rStr += chars[random(0, 62)];
	    }
	
	    return rStr;
	  }
	  function random(start, end) {
	    start = +start || 0;
	    end = typeof +end === 'number' && +end ? +end : 100;
	    start = Math.floor(start);
	    end = Math.floor(end);
	
	    if (start === end) {
	      return start;
	    }
	
	    var gap = Math.abs(start - end);
	
	    if (start > end) {
	      start = end;
	    }
	
	    return start + Math.floor(Math.random() * gap);
	  }
	  function getScrenAspect() {
	    return {
	      width: window.screen.width,
	      height: window.screen.height
	    };
	  }
	  function isCommonNumber(num) {
	    if (!is('number', num)) {
	      return false;
	    }
	
	    if (isNaN(num)) {
	      return false;
	    }
	
	    if (num === Infinity || num === -Infinity) {
	      return false;
	    }
	
	    return true;
	  }
	  function isNumber(num) {
	    if (!is('number', num)) {
	      return false;
	    }
	
	    if (isNaN(num)) {
	      return false;
	    }
	
	    return true;
	  }
	  function setStyle(el, style) {
	    if (el instanceof HTMLElement && is('object', style)) {
	      for (var key in style) {
	        if (style.hasOwnProperty(key)) {
	          el.style[key] = style[key];
	        }
	      }
	    }
	  }
	  /**
	   * 监听元素大小变动
	   */
	
	  function onResize(target, cb) {
	    var ro = new index(function (entries) {
	      cb(entries);
	    });
	    ro.observe(target);
	    return function () {
	      ro.disconnect();
	    };
	  }
	  function clamp(value, min, max) {
	    return Math.min(Math.max(value, min), max);
	  } // 腾讯快直播地址转换为 flv
	
	  function covertWebrtcUrlToM3u8(url) {
	    var arr = url.split(/\/?\?/);
	    return "//".concat(arr[0].split('//')[1], ".m3u8?").concat(arr[1]);
	  }
	
	  var index$1 = 0;
	  /**
	   * event-emitter class like nodejs events module
	   *
	   * @class EventEmitter
	   */
	
	  var EventEmitter =
	  /*#__PURE__*/
	  function () {
	    function EventEmitter() {
	      _classCallCheck(this, EventEmitter);
	
	      this._listeners = {};
	    }
	    /**
	     * Subscribe an event
	     *
	     * @param {string} evt The event you want to subscribe
	     * @param {function} listener The event handler
	     * @returns {string} an id that you can use it to off the event handler
	     * @memberof EventEmitter
	     */
	
	
	    _createClass(EventEmitter, [{
	      key: "on",
	      value: function on(evt, listener) {
	        var id = ++index$1;
	        this._listeners[evt] = this._listeners[evt] || [];
	
	        this._listeners[evt].push({
	          id: id,
	          listener: listener,
	          once: false
	        });
	
	        return id;
	      }
	      /**
	       * Subscribe an event once
	       *
	       * @param {string} evt The event you want to subscribe
	       * @param {function} listener The event handler
	       * @returns {string} an id that you can use it to off the event handler
	       * @memberof EventEmitter
	       */
	
	    }, {
	      key: "once",
	      value: function once(evt, listener) {
	        var id = ++index$1;
	        this._listeners[evt] = this._listeners[evt] || [];
	
	        this._listeners[evt].push({
	          id: id,
	          listener: listener,
	          once: true
	        });
	
	        return id;
	      }
	      /**
	       * Unsubscribe an event
	       *
	       * @param {string} evt The event you want to unsubscribe
	       * @param {function} listener  The event listener or id which is returned by `on` or `once`
	       * @memberof EventEmitter
	       */
	
	    }, {
	      key: "off",
	      value: function off(evt, listener) {
	        this._listeners[evt] = this._listeners[evt] || [];
	
	        for (var i = 0; i < this._listeners[evt].length; i++) {
	          var handler = this._listeners[evt][i];
	
	          if (handler.id === listener || handler.listener === listener) {
	            this._listeners[evt].splice(i, 1);
	
	            break;
	          }
	        }
	      }
	      /**
	       * Trigger an event
	       *
	       * @param {string} evt The event you want to trigger
	       * @param {arguments} args  Event args
	       * @memberof EventEmitter
	       */
	
	    }, {
	      key: "trigger",
	      value: function trigger(evt) {
	        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        this._listeners[evt] = this._listeners[evt] || [];
	
	        var newListener = _toConsumableArray(this._listeners[evt]);
	
	        isDebugMode() && console.log("[event] ".concat(this.constructor.name, " ").concat(evt, " "), safeJSONStringify([].slice.call(arguments)));
	
	        for (var i = this._listeners[evt].length - 1; i >= 0; i--) {
	          var handler = this._listeners[evt][i];
	
	          try {
	            handler.listener.apply(handler, args);
	          } catch (err) {
	            console.error(err);
	            throw err;
	          }
	
	          if (handler.once) {
	            newListener.splice(i, 1);
	          }
	        }
	
	        this._listeners[evt] = newListener;
	        evt !== 'all' && this.trigger.apply(this, ['all', evt].concat(args));
	      }
	    }, {
	      key: "clear",
	      value: function clear() {
	        this._listeners = {};
	      }
	    }]);
	
	    return EventEmitter;
	  }();
	
	  var zhCN = {
	    Pause: '暂停',
	    Normal: '正常',
	    Settings: '设置',
	    'Full screen': '全屏',
	    'Exit full screen': '退出全屏',
	    'You can try': '你可以尝试',
	    'Switch to Flash': '切换到Flash',
	    'Switch to HTML5': '切换到HTML5',
	    Reload: '重新加载',
	    'Unknown Error': '未知错误',
	    'Network Error': '网络错误',
	    'Media Error': '编解码错误',
	    Mute: '静音',
	    Unmute: '取消静音',
	    Quality: '画质',
	    Live: '直播',
	    Autoplay: '自动播放',
	    Captions: '字幕',
	    'Copy debug info': '复制排错日志',
	    'Upload debug info': '上传排错日志',
	    'Skip ahead to live broadcast': '直接跳到现场直播',
	    Line: '线路',
	    Speed: '倍速'
	  };
	  var zhTW = {
	    Pause: '暫停',
	    Normal: '正常',
	    Settings: '設置',
	    'Full screen': '全螢幕',
	    'Exit full screen': '結束全螢幕',
	    'You can try': '妳可以嘗試',
	    'Switch to Flash': '切換到Flash',
	    'Switch to HTML5': '切換到HTML5',
	    Reload: '重新加載',
	    'Unknown Error': '未知錯誤',
	    'Network Error': '網路錯誤',
	    'Media Error': '編解碼錯誤',
	    Mute: '靜音',
	    Unmute: '解除靜音',
	    Quality: '畫質',
	    Live: '直播',
	    Autoplay: '自動播放',
	    Captions: '字幕',
	    'Copy debug info': '複製偵錯資訊',
	    'Upload debug info': '上傳偵錯資訊',
	    'Skip ahead to live broadcast': '直接跳到現場直播',
	    Line: '線路',
	    Speed: '倍速'
	  };
	  var en = {};
	
	  for (var key in zhCN) {
	    en[key] = key;
	  }
	
	  var i18n = {
	    'zh-CN': zhCN,
	    'zh-TW': zhTW,
	    en: en
	  };
	  function chooseLanguage(language, localization) {
	    if (language === 'auto') {
	      language = getLanguage();
	    }
	
	    var majorLang = language.split('-')[0];
	    var langs = objectKeys(localization);
	    var lang = langs.filter(function (v) {
	      return v === language;
	    })[0]; // get exactly same lang: zh-CN -> zh-CN
	
	    if (!lang) {
	      lang = langs.filter(function (v) {
	        return v.indexOf(majorLang) === 0;
	      })[0]; // get major same lang: en-US -> en, en -> en, en -> en-US
	    }
	
	    return lang || 'en';
	  }
	
	  function getActive() {
	    var activeItem;
	
	    for (var i = 0; i < this._config.playlist.length; i++) {
	      var item = this._config.playlist[i];
	
	      if (item.active) {
	        activeItem = item;
	        break;
	      }
	    }
	
	    var activeSource;
	
	    for (var _i = 0; _i < activeItem.sources.length; _i++) {
	      var sour = activeItem.sources[_i];
	
	      if (sour.active) {
	        activeSource = sour;
	        break;
	      }
	    }
	
	    var file = activeSource.file;
	    var absoluteFile = getAbsoluteUrl(file);
	    var fileType = getSourceType(absoluteFile);
	    var type = activeSource.type || fileType;
	    var mineType = activeSource.mineType || getMinetype(type);
	    var isLive = activeItem.isLive;
	    var image = activeItem.image;
	    var alwaysDisplayImage = activeItem.alwaysDisplayImage;
	    var title = activeItem.title;
	    var highlights = activeItem.highlights;
	    var playbackMessages = activeItem.playbackMessages;
	    var isTimeShift = activeSource.isTimeShift;
	    var reloadAfterPausing = typeof activeItem.reloadAfterPausing === 'undefined' ? !!activeSource.reloadAfterPausing : activeItem.reloadAfterPausing;
	    var reloadAfterPausingTime = typeof activeItem.reloadAfterPausingTime === 'undefined' ? activeSource.reloadAfterPausingTime : activeItem.reloadAfterPausingTime;
	    var isHideProgress = activeItem.isHideProgress; // console.log('getActive', activeItem, activeSource)
	
	    return {
	      file: file,
	      absoluteFile: absoluteFile,
	      mineType: mineType,
	      type: type,
	      isLive: isLive,
	      image: image,
	      alwaysDisplayImage: alwaysDisplayImage,
	      title: title,
	      highlights: highlights,
	      playbackMessages: playbackMessages,
	      item: activeItem,
	      source: activeSource,
	      isTimeShift: isTimeShift,
	      reloadAfterPausing: reloadAfterPausing,
	      reloadAfterPausingTime: reloadAfterPausingTime,
	      isHideProgress: isHideProgress
	    };
	  }
	  function setDefaultPlayItemSourceActive(itemIndex) {
	    var list = this._config.playlist;
	    var len = list.length;
	    var sourceIndex = 0;
	    var activeItem;
	
	    if (is('number', itemIndex) && itemIndex < len) {
	      activeItem = list[itemIndex];
	    } else {
	      list.forEach(function (item, idx) {
	        if (item.defaultPlay) {
	          activeItem = item;
	          itemIndex = idx;
	        }
	      });
	
	      if (!activeItem) {
	        activeItem = list[0];
	        itemIndex = 0;
	      }
	    }
	
	    activeItem.sources.forEach(function (source, idx) {
	      if (source.defaultPlay) {
	        sourceIndex = idx;
	      }
	    });
	    return setActive.call(this, itemIndex, sourceIndex);
	  }
	  function setActive(listIndex) {
	    var sourceIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var playlist = this._config.playlist;
	    var success = !!playlist[listIndex];
	
	    if (!success) {
	      return success;
	    }
	
	    for (var i = 0; i < playlist.length; i++) {
	      playlist[i].active = i === listIndex;
	
	      for (var j = 0; j < playlist[i].sources.length; j++) {
	        // playlist[i].sources[j] = Object.assign({}, playlist[i].sources[j], { active: j === sourceIndex })
	        playlist[i].sources[j] = _objectSpread({}, playlist[i].sources[j], {
	          active: j === sourceIndex
	        });
	      }
	    }
	
	    return success;
	  }
	  function getActiveSources() {
	    var activeItem;
	
	    for (var i = 0; i < this._config.playlist.length; i++) {
	      var item = this._config.playlist[i];
	
	      if (item.active) {
	        activeItem = item;
	        break;
	      }
	    }
	
	    return activeItem.sources;
	  }
	  /**
	   * 设置当前倍速
	   */
	
	  function setActiveRate() {
	    var rateIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var playbackRates = this._config.playbackRates;
	    var success = !!playbackRates[rateIndex];
	
	    if (!success && rateIndex !== 'null') {
	      return success;
	    }
	
	    for (var i = 0; i < playbackRates.length; i++) {
	      playbackRates[i].active = false;
	      playbackRates[i].active = i === rateIndex;
	    }
	
	    return success;
	  }
	  var getAbsoluteUrl = function getAbsoluteUrl(url) {
	    var a = document.createElement('a');
	    a.setAttribute('href', url);
	    return a.href;
	  };
	  var getSourceType = function getSourceType(url) {
	    var httpRes = url.match(/^https?:[^?]+(\.(\w+))\??(?![.\w/])/);
	    var otherRes = url.match(/^([a-zA-Z]+):.*/);
	    var webrtcRes = url.match(/^webrtc:[^?]+(\.(\w+))\??(?![.\w/])/);
	
	    if (httpRes) {
	      return httpRes[2];
	    }
	
	    if (otherRes) {
	      return otherRes[1];
	    }
	
	    if (webrtcRes) {
	      return 'webrtc';
	    }
	
	    return '';
	  };
	  var getMinetype = function getMinetype(type) {
	    var mineTypes = {
	      aac: 'audio/mp4',
	      mp4: 'video/mp4',
	      f4v: 'video/mp4',
	      m4v: 'video/mp4',
	      mov: 'video/mp4',
	      // 'm4a': 'audio/x-m4a', // converted to aac by source.js
	      mp3: 'audio/mpeg',
	      mpeg: 'audio/mpeg',
	      ogv: 'video/ogg',
	      ogg: 'video/ogg',
	      oga: 'video/ogg',
	      vorbis: 'video/ogg',
	      webm: 'video/webm',
	      // The following are not expected to work in Chrome
	      f4a: 'video/aac',
	      m3u8: 'application/vnd.apple.mpegurl',
	      m3u: 'application/vnd.apple.mpegurl',
	      hls: 'application/vnd.apple.mpegurl',
	      flv: 'video/x-flv',
	      rtmp: 'rtmp/flv',
	      // other rtmp/mp4
	      dash: 'application/dash+xml',
	      mpd: 'application/dash+xml'
	    };
	    return mineTypes[type] || '';
	  };
	
	  var providers = [];
	  var extraProviders = [];
	  function registerProvider(name, Provider) {
	    var registerExtra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    var _providers = registerExtra ? _toConsumableArray(extraProviders) : _toConsumableArray(providers);
	
	    if (_providers.filter(function (item) {
	      return name === item.name;
	    }).length > 0) {
	      console.warn("provider [".concat(name, "] is existed, so it will not be register twice, you can change a name and retry"));
	      return;
	    }
	
	    var isHTML5 = Provider.isHTML5();
	    var isFlash = Provider.isFlash();
	    var isPlaybackRateSupported = Provider.isPlaybackRateSupported();
	
	    if (isHTML5 || isFlash) {
	      _providers.push({
	        name: name,
	        html5: isHTML5,
	        flash: isFlash,
	        isPlaybackRateSupported: isPlaybackRateSupported,
	        Provider: Provider
	      });
	
	      if (registerExtra) {
	        setDefaultOptions({
	          extraProvider: _defineProperty({}, name, Provider.defaultOptions)
	        });
	        extraProviders = _providers;
	      } else {
	        setDefaultOptions({
	          provider: _defineProperty({}, name, Provider.defaultOptions)
	        });
	        providers = _providers;
	      }
	    } else {
	      throw new TypeError('registerProvider(name, Provider): Provider should extends HTML5Provider or FlashProvider');
	    }
	  }
	  function registerExtraProvider(name, Provider) {
	    registerProvider(name, Provider, true);
	  }
	  function getProviders() {
	    return providers;
	  }
	  function getExtraProviders() {
	    return extraProviders;
	  }
	  function getProvider(name) {
	    for (var i = 0; i < providers.length; i++) {
	      var p = providers[i];
	
	      if (p.name === name) {
	        return p;
	      }
	    }
	  }
	  /**
	   * 过滤register过的provider
	   * @param {*} name provider 注册的name
	   */
	
	  function getExtraProvider(name) {
	    var filterProviders = extraProviders.filter(function (item) {
	      return item.name === name;
	    });
	
	    if (filterProviders.length === 1) {
	      return filterProviders[0];
	    }
	  }
	  function getSupportProviders() {
	    return getProviders().filter(function (p) {
	      return p.Provider.isSupported();
	    });
	  }
	  function getSupportExtraProviders() {
	    return getExtraProviders().filter(function (exP) {
	      return exP.Provider.isSupported();
	    });
	  }
	  function sortProviders(providers, order) {
	    // const nameSorted = sortNameProviders(providers, order)
	    // const hfSorted = sortH5FlashProviders(nameSorted, order)
	    // return hfSorted
	    var orderLen = order.length;
	    var html5Idx = order.indexOf('html5');
	    var flashIdx = order.indexOf('flash');
	    var providersWithWieght = providers.map(function (p) {
	      var nameIdx = order.indexOf(p.name);
	      var nameWeight = 0;
	      var typeWeight = 0;
	
	      if (nameIdx >= 0) {
	        nameWeight += orderLen - nameIdx;
	      }
	
	      if (html5Idx >= 0 && p.html5) {
	        typeWeight += orderLen - html5Idx;
	      }
	
	      if (flashIdx >= 0 && p.flash) {
	        typeWeight += orderLen - flashIdx;
	      }
	
	      var weight = Math.max(nameWeight, typeWeight);
	
	      if (nameWeight > 0 && typeWeight > 0) {
	        // make [html5, hlsjs] get [2.5, 2] rather than [2, 2]
	        weight += 0.5;
	      }
	
	      return {
	        p: p,
	        name: p.name,
	        w: weight
	      };
	    });
	    providersWithWieght.sort(function (pw1, pw2) {
	      return pw2.w - pw1.w;
	    });
	    return providersWithWieght.map(function (pw) {
	      return pw.p;
	    });
	  } // 给html5和order排序
	  function chooseProvider(_ref) {
	    var type = _ref.type,
	        mineType = _ref.mineType,
	        url = _ref.url,
	        isLive = _ref.isLive,
	        isTimeShift = _ref.isTimeShift;
	    var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    // vr provider 不作为外部可选的播放provider
	    var filteredOrder = order.filter(function (item) {
	      return item !== 'vr';
	    });
	    var supportedProviders = getSupportProviders();
	    var canPlayProviders = supportedProviders.filter(function (p) {
	      var Provider = p.Provider;
	      var canPlay = Provider.canPlay({
	        file: url,
	        type: type,
	        mimeType: mineType,
	        isLive: isLive,
	        isTimeShift: isTimeShift
	      });
	      return !!canPlay;
	    });
	    var sortedProviders = sortProviders(canPlayProviders, filteredOrder);
	    return sortedProviders[0];
	  }
	  function selectExtraProviders(_ref2, playerConfig) {
	    var type = _ref2.type,
	        mineType = _ref2.mineType,
	        url = _ref2.url,
	        isLive = _ref2.isLive,
	        isTimeShift = _ref2.isTimeShift;
	    var supportedProviders = getSupportExtraProviders();
	    var canPlayProviders = supportedProviders.filter(function (p) {
	      var Provider = p.Provider;
	      var canPlay = Provider.canPlay({
	        file: url,
	        type: type,
	        mimeType: mineType,
	        isLive: isLive,
	        isTimeShift: isTimeShift
	      });
	      return !!canPlay;
	    });
	    return canPlayProviders;
	  }
	
	  var defaultOptions = {
	    // behaviors
	    mute: false,
	    autoplay: false,
	    repeat: false,
	    playbackRatesLabel: '',
	    // 倍速默认文字
	    playbackRates: [],
	    // 倍速播放
	    trtcFallback: true,
	    // trtc 流不支持时候，自动降级到 m3u8
	    // apperance
	    controls: true,
	    videoLayerControl: true,
	    // 点击原生视频区域可控制播放暂停，默认开启
	    aspectratio: '',
	    height: 270,
	    width: 480,
	    displaytitle: true,
	    displaydescription: true,
	    stretching: 'contain',
	    qualityLabels: '',
	    // dash中不同带宽显示的文字: 如2500-HD, 1000-SD
	    renderLoading: '',
	    // preload
	    preload: 'none',
	    // playlist
	    playlist: [],
	    // skin
	    skin: {
	      name: 'default',
	      url: "https://static.mudu.tv/mudu-player/0.39.10/mudu-player.css"
	    },
	    // logo
	    logo: {
	      file: '',
	      hide: false,
	      link: '',
	      marginw: '3%',
	      marginh: '6%',
	      width: '15%',
	      height: '10%',
	      opacity: 1,
	      position: 'top-right'
	    },
	    providerOrder: ['html5', 'hlsjs'],
	    // plugin配置
	    plugin: {},
	    // provider配置
	    provider: {
	      flvjs: {
	        'flv.js': {
	          fixAudioTimestampGap: true
	        }
	      }
	    },
	    // 非流解析类provider配置
	    extraProvider: {
	      vr: {
	        use: false
	      }
	    },
	    // file的文件地址
	    fileCdnPath: "https://static.mudu.tv/mudu-player/0.39.10/assets",
	    videoAttributes: _objectSpread({
	      'x5-video-player-type': 'h5-page',
	      'webkit-playsinline': 'true',
	      playsinline: '',
	      'x-webkit-airplay': 'allow',
	      'mtt-playsinline': true
	    }, isX5Layer() ? {
	      loop: true
	    } : {}),
	    contextMenus: [{
	      key: 'version',
	      text: 'v' + "0.39.10"
	    }],
	    errorLogUrl: '',
	    perfLogUrl: '',
	    renderError: null,
	    language: 'auto',
	    localization: i18n,
	    // subtitle
	    showSubtitle: false,
	    myunSyncTextTrackLabel: 'ppt_sync',
	    uniqId: '',
	    // 播放器唯一id, 可以通过外部传入
	    enableErrorRetry: false,
	    errorMaxRetry: 10,
	    errorMaxRetryTimeout: 15000,
	    errorRetryDelay: 3000,
	    recordRestrict: {
	      enable360LoneWindowCloseStream: false
	    },
	    bufferDetectGap: 200,
	    textTrackDisable: false
	  };
	
	  function mergeOptions(options1, options2) {
	    // 直接复制值
	    var options = _objectSpread({}, options1, options2); // merge playbackRates
	
	
	    if (is('array', options2.playbackRates)) {
	      options.playbackRates = options2.playbackRates;
	      options.playbackRatesLabel = options2.playbackRatesLabel || options.playbackRatesLabel;
	    } // merge playlist: 直接使用options2的playlist
	
	
	    options.playlist = options2.playlist; // merge providerOrder
	
	    options.providerOrder = (is('array', options2.providerOrder) ? options2.providerOrder : options1.providerOrder).slice(); // merge skin
	
	    var skin2 = is('object', options2.skin) ? options2.skin : {};
	    options.skin = _objectSpread({}, options1.skin, skin2); // merge logo
	
	    var logo2 = is('object', options2.logo) ? options2.logo : {};
	    options.logo = _objectSpread({}, options1.logo, logo2); // merge recordRestrict
	
	    var rr = is('object', options2.recordRestrict) ? options2.recordRestrict : {};
	    options.recordRestrict = _objectSpread({}, options1.recordRestrict, rr); // merge localization
	
	    options.localization = _objectSpread({}, options1.localization);
	    objectKeys(options2.localization || {}).forEach(function (lang) {
	      if (is('object', options2.localization[lang])) {
	        options.localization[lang] = _objectSpread({}, options.localization.en, options1.localization[lang] || {}, options2.localization[lang]);
	      }
	    }); // merge videoAttributes
	
	    var va2 = is('object', options2.videoAttributes) ? options2.videoAttributes : {};
	    options.videoAttributes = _objectSpread({}, options1.videoAttributes, va2);
	    var ctxmenus1 = options1.contextMenus;
	    var ctxmenus2 = options2.contextMenus; // mrege contextMenus
	
	    if (is('function', ctxmenus2)) {
	      options.contextMenus = ctxmenus2(ctxmenus1);
	    } else if (is('array', options2.contextMenus)) {
	      options.contextMenus = ctxmenus2;
	    } else {
	      options.contextMenus = ctxmenus1;
	    } // mrege plugin
	
	
	    if (is('object', options2.plugin)) {
	      var plugin = options1.plugin || {};
	
	      for (var k in options2.plugin) {
	        var op1 = plugin[k] || {};
	        var op2 = options2.plugin[k] || {};
	        plugin[k] = _objectSpread({}, op1, op2);
	      }
	
	      options.plugin = plugin;
	    } // merge provider
	
	
	    if (is('object', options2.provider)) {
	      var provider = options1.provider || {};
	
	      for (var _k in options2.provider) {
	        var _op = provider[_k] || {};
	
	        var _op2 = options2.provider[_k] || {};
	
	        provider[_k] = _objectSpread({}, _op, _op2);
	      }
	
	      options.provider = provider;
	    }
	
	    return options;
	  } // 处理playerlist array
	
	
	  function formatPlaylist(playlist) {
	    // format playlist options
	    if (is('array', playlist)) {
	      var ret = [];
	      playlist.forEach(function (playitem) {
	        var item = {};
	        copyDefinedAttr(item, playitem, ['isLive', 'image', 'alwaysDisplayImage', 'isHideProgress', 'description', 'title', 'mediaid', 'defaultPlay', 'reloadAfterPausing', 'reloadAfterPausingTime', // 高亮的点
	        'highlights', 'playbackMessages']); // [{file: ''}]
	
	        if (is('string', playitem.file) && playitem.file !== '') {
	          item.sources = [{
	            file: playitem.file,
	            type: playitem.type,
	            mineType: playitem.mineType
	          }];
	          copyDefinedAttr(item.sources[0], playitem, ['type']);
	          ret.push(item); // [{sources: [{file: ''}]}]
	        } else if (is('array', playitem.sources) && is('object', playitem.sources[0]) && is('string', playitem.sources[0].file) && playitem.sources[0].file !== '') {
	          item.sources = [];
	          playitem.sources.forEach(function (sour, index) {
	            if (is('string', sour.file) && sour.file !== '') {
	              var source = {
	                file: sour.file,
	                index: index
	              };
	              copyDefinedAttr(source, sour, ['type', 'mineType', 'label', 'isTimeShift', 'defaultPlay', 'reloadAfterPausing', 'reloadAfterPausingTime', 'path', 'path_name']);
	              item.sources.push(source);
	            }
	          });
	          ret.push(item);
	        }
	      });
	
	      if (is('array', ret) && is('object', ret[0]) && is('array', ret[0].sources) && is('object', ret[0].sources[0]) && is('string', ret[0].sources[0].file) && ret[0].sources[0].file !== '') {
	        ret = ret.map(function (playlistItem) {
	          playlistItem.allSources = playlistItem.sources.map(function (source) {
	            return _objectSpread({}, source);
	          });
	          var availableSources = playlistItem.sources.filter(function (source) {
	            var file = source.file;
	            var absoluteFile = getAbsoluteUrl(file);
	            var fileType = getSourceType(absoluteFile);
	            var type = source.type || fileType;
	            var mineType = source.mineType || getMinetype(type);
	            var isLive = playlistItem.isLive;
	            var isTimeShift = playlistItem.isTimeShift;
	            var provider = chooseProvider({
	              type: type,
	              mineType: mineType,
	              url: file,
	              isLive: isLive,
	              isTimeShift: isTimeShift
	            }, []);
	            return !!provider;
	          });
	
	          if (availableSources.length !== 0) {
	            playlistItem.sources = availableSources;
	          }
	
	          return playlistItem;
	        });
	        return ret;
	      }
	    }
	  } // 处理playlist
	
	
	  function formatOptions(options) {
	    var exceptKeys = ['type', 'mineType', 'isLive', 'file', 'image', 'description', 'title', 'playlist', 'highlights'];
	    var ret = {}; // copy some options
	
	    for (var i in options) {
	      if (exceptKeys.indexOf(i) < 0 && options !== undefined) {
	        ret[i] = options[i];
	      }
	    } // format playlist
	
	
	    if (is('array', options.playlist)) {
	      ret.playlist = formatPlaylist(options.playlist);
	    } else if (is('string', options.file) && options.file) {
	      var listItem = {};
	      copyDefinedAttr(listItem, options, ['isLive', 'image', 'alwaysDisplayImage', 'description', 'isHideProgress', 'highlights']);
	      var sourceItem = {
	        file: options.file,
	        type: options.type,
	        mineType: options.mineType,
	        label: 'default',
	        isTimeShift: !!options.isTimeShift || false,
	        reloadAfterPausing: !!options.reloadAfterPausing,
	        reloadAfterPausingTime: options.reloadAfterPausingTime
	      };
	      listItem.sources = [sourceItem];
	      ret.playlist = [listItem];
	    }
	
	    return ret;
	  }
	
	  function copyDefinedAttr(target, source, attributes) {
	    attributes.forEach(function (attr) {
	      if (!is('undefined', source[attr])) {
	        target[attr] = source[attr];
	      }
	    });
	  }
	
	  function getDefaultOptions() {
	    return defaultOptions;
	  }
	
	  function setDefaultOptions(options) {
	    defaultOptions = mergeOptions(defaultOptions, formatOptions(options));
	  }
	
	  var play = 'mudu-icon-play';
	  var pause = 'mudu-icon-pause';
	  var volumeUp = 'mudu-icon-volume-up';
	  var volumeDown = 'mudu-icon-volume-down';
	  var volumeOff = 'mudu-icon-volume-off';
	  var full = 'mudu-icon-fullscreen';
	  var fullOff = 'mudu-icon-fullscreen-off';
	  var setting = 'mudu-icon-setting';
	  var loading = 'mudu-icon-load';
	  var check = 'mudu-icon-check';
	  var error = 'mudu-icon-error';
	  var iconReg = /mudu-icon-[\w-]+/;
	
	  var aspect = 'mudu-aspect';
	  var mask = 'mudu-mask';
	  var videoWrap = 'mudu-video-wrap';
	  var video = 'mudu-video';
	  var hideVideo = 'mudu-hide-video';
	  var logoLink = 'mudu-logo-link';
	  var logo = 'mudu-logo';
	  var videoTitle = 'mudu-video-title';
	  var danmaku = 'mudu-video-danmaku';
	  var subtitle = 'mudu-subtitle';
	  var subtitleItem = 'mudu-subtitle-item';
	  var bezel = 'mudu-bezel';
	  var baseLayer = 'mudu-base-layer';
	  var controllerWrap = 'mudu-controller-wrap';
	  var controllerMask = 'mudu-controller-mask';
	  var controllerBlank = 'mudu-controller-blank';
	  var bigPlayBtn = 'mudu-big-play-btn';
	  var controller = 'mudu-controller';
	  var icons = 'mudu-icons';
	  var iconsLeft = 'mudu-icons-left';
	  var icon = 'mudu-icon';
	  var switchText = 'mudu-switch-text';
	  var switchSpeed = 'mudu-switch-speed';
	  var switchQuality = 'mudu-switch-quality';
	  var switchPath = 'mudu-switch-path';
	  var volume = 'mudu-volume';
	  var volumeBarWrap = 'mudu-volume-bar-wrap';
	  var volumeBar = 'mudu-volume-bar';
	  var volumeBarInner = 'mudu-volume-bar-inner';
	  var thumb = 'mudu-thumb';
	  var time = 'mudu-time';
	  var ptime = 'mudu-ptime';
	  var dtime = 'mudu-dtime';
	  var barWrap = 'mudu-bar-wrap';
	  var barPreview = 'mudu-bar-preview';
	  var barPopup = 'mudu-bar-popup';
	  var barPopupText = 'mudu-bar-popup-text';
	  var barImg = 'mudu-bar-img';
	  var barTextWrap = 'mudu-bar-text-wrap';
	  var barText = 'mudu-bar-text';
	  var barTextTime = 'mudu-bar-text-time';
	  var barTextText = 'mudu-bar-text-text';
	  var barTime = 'mudu-bar-time';
	  var barTimeWrap = 'mudu-bar-time-wrap';
	  var bar = 'mudu-bar';
	  var loaded = 'mudu-loaded';
	  var played = 'mudu-played';
	  var highlight = 'mudu-highlight';
	  var dot = 'mudu-dot';
	  var panel = 'mudu-panel';
	  var liveBadge = 'mudu-live-badge';
	  var liveDot = 'mudu-live-dot';
	  var iconsRight = 'mudu-icons-right';
	  var bezelTrans = 'mudu-bezel-transition';
	  var hidden = 'hidden';
	  var flash = 'mudu-flash';
	  var flashTip = 'mudu-flash-tip';
	  var flashTipInner = 'mudu-flash-tip-inner';
	  var errorIcon = 'mudu-error-icon';
	  var errorText = 'mudu-error-text';
	  var errorWrap = 'mudu-error-wrap';
	  var errorInner = 'mudu-error-inner';
	  var recordRestrict360 = 'mudu-restrict-360'; // background
	
	  var background = 'mudu-background';
	  var alwaysDisplayBg = 'mudu-always-display-bg'; // watermark
	
	  var watermark = 'mudu-watermark'; // popup
	
	  var menuitem = 'mudu-menuitem';
	  var menuitemLabel = 'mudu-menuitem-label';
	  var contextMenuPanel = 'mudu-contextmenu-panel';
	  var panelMenu = 'mudu-panel-menu';
	  var menuitemContent = 'mudu-menuitem-label';
	  var playRatePanel = 'mudu-play-back-rate-panel';
	  var playRatePanelMobile = 'mudu-play-back-rate-panel-mobile';
	  var qualityWrap = 'mudu-quality-wrap';
	  var pathWrap = 'mudu-path-wrap';
	  var qualityMenu = 'mudu-quality-menu';
	  var qualityMenuItem = 'mudu-quality-menu-item';
	  var qualityMenuItemTip = 'mudu-quality-menu-item-tip';
	  var qualityItemName = 'mudu-quality-item-name';
	  var pathMulti = 'mudu-path-multi';
	  var qualityMenuItemWrap = 'mudu-quality-menu-item-wrap';
	  var pathSelectWrap = 'mudu-path-select-wrap';
	  var pathSelectMenu = 'mudu-path-select-menu';
	  var pathSelectMenuItem = 'mudu-path-select-menu-item'; // notice
	
	  var notice = 'mudu-notice'; // container
	
	  var live = 'mudu-live';
	  var playback = 'mudu-playback';
	  var base = 'mudu';
	  var fullscreen = 'mudu-fullscreen';
	  var aspectMode = 'mudu-aspect-mode';
	  var normalMode = 'mudu-normal-mode';
	  var hideController = 'mudu-hide-controller';
	  var hideTime = 'mudu-hide-time';
	  var stateIdle = 'mudu-state-idle';
	  var stateError = 'mudu-state-error';
	  var stretch = 'mudu-stretch';
	  var providerFlash = 'mudu-provider-flash';
	  var providerHtml5 = 'mudu-provider-html5';
	  var providerReady = 'mudu-provider-ready';
	  var skin = 'mudu-skin';
	  var mobile = 'mudu-mobile';
	  var flashDisabled = 'mudu-flash-disabled';
	  var hideEverything = 'mudu-hide-everything';
	  var hideSetting = 'mudu-hide-setting';
	  var flagDragging = 'mudu-flag-dragging';
	  var flagSmallPlayer = 'mudu-flag-small-player';
	  var durationValid = 'mudu-duration-valid';
	  var timeShift = 'mudu-time-shift';
	  var playbackRate = 'mudu-play-back-rate';
	  var hidePlaybackRate = 'mudu-play-back-rate-hide';
	  var showPlaybackRate = 'mudu-play-back-rate-show';
	  var vrMode = 'mudu-player-vr-mode';
	  var hideProgress = 'mudu-hide-progress';
	  var hideCustomControl = 'mudu-hide-custom-control'; // 表示当前播放的是时移视频，并且在观看直播，而不是时移回看
	
	  var timeShiftLive = 'mudu-time-shift-live'; // container reg
	
	  var stateReg = /mudu-state-\w+/;
	  var stretchReg = /mudu-stretch-\w+/;
	  var providerReg = /mudu-provider-\w+/;
	  var playrateReg = /mudu-play-back-rate-\w+/; // icon
	  var bezelIcon = 'mudu-bezel-icon';
	  var loadingIcon = 'mudu-loading-icon';
	  var extraLoadingIcon = 'mudu-extra-loading-icon';
	  var captionIcon = 'mudu-caption-icon';
	  var settingIcon = 'mudu-setting-icon';
	  var fullscreenIcon = 'mudu-fullscreen-icon';
	  var playIcon = 'mudu-play-icon';
	  var volumeIcon = 'mudu-volume-icon';
	  var customControlIcon = 'mudu-icon-custom-control'; // extra class
	
	  var hide = 'mudu-hide';
	  var active = 'mudu-active';
	  var reset = 'mudu-reset';
	
	  var loaders = {}; // url: {loader, isStyle}
	
	  var STATUS = {
	    NEW: 0,
	    LOADING: 1,
	    ERROR: 2,
	    COMPLETE: 3
	  };
	
	  var ScriptLoader =
	  /*#__PURE__*/
	  function (_EventEmitter) {
	    _inherits(ScriptLoader, _EventEmitter);
	
	    function ScriptLoader(url) {
	      var _this2;
	
	      var isStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      _classCallCheck(this, ScriptLoader);
	
	      _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ScriptLoader).call(this));
	      _this2.url = url;
	      _this2.isStyle = isStyle;
	      _this2.status = STATUS.NEW;
	      return _this2;
	    }
	
	    _createClass(ScriptLoader, [{
	      key: "getElement",
	      value: function getElement() {
	        if (this.isStyle) {
	          var link = document.createElement('link');
	          link.type = 'text/css';
	          link.rel = 'stylesheet';
	          link.href = this.url;
	          return link;
	        } else {
	          var scriptTag = document.createElement('script');
	          scriptTag.src = this.url;
	          return scriptTag;
	        }
	      }
	    }, {
	      key: "getStatus",
	      value: function getStatus() {
	        return this.status;
	      }
	    }, {
	      key: "load",
	      value: function load() {
	        var _this3 = this;
	
	        if (this.status !== STATUS.NEW) {
	          Promise.reject(new Error('loader.load can only call once'));
	        }
	
	        var sameLoader = loaders[this.url];
	
	        if (sameLoader && sameLoader.isStyle === this.isStyle) {
	          var status = sameLoader.loader.getStatus();
	
	          if (status === STATUS.COMPLETE) {
	            setTimeout(function () {
	              _this3.trigger('done');
	            }, 0);
	            return Promise.resolve();
	          }
	        }
	
	        var head = document.getElementsByTagName('head')[0] || document.documentElement;
	        var ele = this.getElement();
	
	        var _this = this;
	
	        return new Promise(function (resolve, reject) {
	          // `done`防止onload和onreadystatechange都被调用(ie9)
	          var done = false;
	
	          ele.onload = ele.onreadystatechange = function (evt) {
	            if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
	              ele.onload = ele.onreadystatechange = null;
	            }
	
	            done = true; // 在script中的js执行完后的事件循环中resolve, 保证脚本可用
	
	            setTimeout(function () {
	              _this.trigger('done');
	
	              _this.status = STATUS.COMPLETE;
	              resolve();
	            }, 0);
	          };
	
	          ele.onerror = function (evt) {
	            _this.trigger('error');
	
	            reject(evt);
	          };
	
	          head.insertBefore(ele, head.firstChild);
	          _this.status = STATUS.LOADING;
	          loaders[_this.url] = {
	            isStyle: _this.isStyle,
	            loader: _this
	          };
	        });
	      }
	    }]);
	
	    return ScriptLoader;
	  }(EventEmitter);
	
	  var INTERNAL_OPTION_MERGED = 'internal_option_merged';
	  var INTERNAL_DOM_INITED = 'internal_dom_inited';
	  var INTERNAL_MODEL_INITED = 'internal_model_inited';
	  var INTERNAL_PLUGIN_INITED = 'internal_plugin_inited';
	  var INTERNAL_PROVIDER_INITED = 'internal_provider_inited';
	  var INTERNAL_PROVIDER_REMOVED = 'internal_provider_removed';
	  var INTERNAL_PROVIDER_INIT = 'internal_plugin_init';
	  var INTERNAL_STATUS_FORMATED = 'internal_status_formated';
	  var INTERNAL_KEY_DOWN = 'internal_key_down';
	  var INTERNAL_STYLE_LOADED = 'internal_style_loaded';
	  var OUTER_CONTEXT_MENU_CLICK = 'contextMenuClick';
	  var OUTER_PLAY = 'play';
	  var OUTER_PAUSE = 'pause';
	  var OUTER_VIDEO_LAYER_CONTROL = 'videoLayerControl';
	  var OUTER_CONTROLS = 'controls';
	  var OUTER_CONTROLS_VISIBLE = 'controlsVisible';
	  var OUTER_FULLSCREEN = 'fullscreen';
	  var OUTER_COMPLETE = 'complete';
	  var OUTER_PLAYLIST_COMPLETE = 'playlistComplete';
	  var OUTER_PLAYLIST = 'playlist';
	  var OUTER_PLAYLIST_ITEM = 'playlistItem';
	  var OUTER_SWITCH_QUALITY = 'switchQuality';
	  var OUTER_TIME = 'time';
	  var OUTER_DURATION = 'duration';
	  var OUTER_RESIZE = 'resize';
	  var OUTER_BUFFER = 'buffer';
	  var OUTER_IDLE = 'idle';
	  var OUTER_BEFORE_PLAY = 'beforePlay';
	  var OUTER_MUTE = 'mute';
	  var OUTER_VOLUME = 'volume';
	  var OUTER_CAN_SEEK = 'canSeek';
	  var OUTER_SEEK = 'seek';
	  var OUTER_SEEKED = 'seeked';
	  var OUTER_ERROR = 'error';
	  var OUTER_TEXT_TRACK_CHANGE = 'textTrackChange';
	  var OUTER_TEXT_TRACK_ADD = 'textTrackAdd';
	  var OUTER_TEXT_TRACK_CUE_CHANGE = 'textTrackCueChange';
	  var OUTER_LIVE_END_DETECT = 'liveEndDetect';
	  var OUTER_TRTC_FALLBACK = 'trtc:fallback';
	  var OUTER_TRTC_AUTOPLAY_FAIL = 'trtc:autoplayFail';
	  var OUTER_XP2P_ROLLBACK = 'xp2p:rollback';
	  var PROVIDER_ENDED = 'ended';
	  var PROVIDER_BUFFER_CHANGE = 'bufferchange';
	  var PROVIDER_TIME_UPDATE = 'timeupdate';
	  var PROVIDER_DURATION = 'duration';
	  var PROVIDER_STAGE_CLICK = 'stageclick';
	  var PROVIDER_STAGE_DOUBLE_CLICK = 'stagedoubleclick';
	  var PROVIDER_PLAY = 'play';
	  var PROVIDER_PAUSE = 'pause';
	  var PROVIDER_MUTE = 'mute';
	  var PROVIDER_VOLUME = 'volume';
	  var PROVIDER_SEEKED = 'seeked';
	  var PROVIDER_SEEK = 'seek';
	  var PROVIDER_ERROR = 'error';
	  var PROVIDER_LOADEDDATA = 'loadeddata';
	  var PROVIDER_WAITING = 'waiting';
	  var PROVIDER_TEXTTRACKADD = 'texttrackadd';
	  var PROVIDER_TEXTTRACKCHANGE = 'texttrackchange';
	  var PROVIDER_CUECHANGE = 'cuechange';
	
	  function initDom() {
	    var _this = this;
	
	    var container = this._container;
	    var dom = this.dom;
	    classList(container).add(hideEverything); // load skin style
	
	    var skin$1 = this._config.skin;
	    var styleLoader = new ScriptLoader(skin$1.url, true);
	    styleLoader.load().then(function () {
	      classList(container).remove(hideEverything);
	
	      _this.trigger(INTERNAL_STYLE_LOADED);
	    }); // const skinname = this._config.skin.name
	
	    var domString = getDomString(this._status.localization, this._config.fileCdnPath);
	    container.innerHTML = domString;
	    classList(container).add(reset);
	    classList(container).add(base);
	    classList(container).add(hideSetting);
	    classList(container).add("".concat(skin, "-").concat(skin$1.name));
	    isMobile() && classList(container).add(mobile);
	    dom.container = container;
	    dom.baseLayer = container.querySelector(".".concat(baseLayer));
	    dom.aspect = container.querySelector(".".concat(aspect));
	    dom.fullscreen = container.querySelector(".".concat(fullscreenIcon));
	    dom.caption = container.querySelector(".".concat(captionIcon));
	    dom.video = container.querySelector('video');
	    dom.videoWrap = container.querySelector(".".concat(videoWrap));
	    dom.controllerWrap = container.querySelector(".".concat(controllerWrap));
	    dom.controller = container.querySelector(".".concat(controller));
	    dom.controllerMask = container.querySelector(".".concat(controllerMask));
	    dom.controllerBlank = container.querySelector(".".concat(controllerBlank));
	    dom.controllerRightIcons = container.querySelector(".".concat(iconsRight));
	    dom.leftPlayBtn = container.querySelector(".".concat(playIcon));
	    dom.volumeWrap = container.querySelector(".".concat(volume));
	    dom.volumeButton = container.querySelector(".".concat(volumeIcon));
	    dom.volumeBar = container.querySelector(".".concat(volumeBarInner));
	    dom.volumeBarWrap = container.querySelector(".".concat(volumeBar));
	    dom.volumeBarWrapWrap = container.querySelector(".".concat(volumeBarWrap));
	    dom.playedBar = container.querySelector(".".concat(played));
	    dom.loadedBar = container.querySelector(".".concat(loaded));
	    dom.playedBarWrap = container.querySelector(".".concat(barWrap));
	    dom.barPopup = container.querySelector(".".concat(barPopup));
	    dom.barImg = container.querySelector(".".concat(barImg));
	    dom.barTime = dom.playedBarTime = container.querySelector(".".concat(barTime));
	    dom.barText = container.querySelector(".".concat(barText));
	    dom.barTextTime = container.querySelector(".".concat(barTextTime));
	    dom.barTextText = container.querySelector(".".concat(barTextText));
	    dom.ptime = container.querySelector(".".concat(ptime));
	    dom.dtime = container.querySelector(".".concat(dtime));
	    dom.logoWrap = container.querySelector(".".concat(logo));
	    dom.logoImg = container.querySelector(".".concat(logo, " img"));
	    dom.logoLink = container.querySelector(".".concat(logoLink));
	    dom.bezelWrap = container.querySelector(".".concat(bezel));
	    dom.bezel = container.querySelector(".".concat(bezelIcon));
	    dom.background = container.querySelector(".".concat(background));
	    dom.watermark = container.querySelector(".".concat(watermark));
	    dom.title = container.querySelector(".".concat(videoTitle));
	    dom.settingBtn = container.querySelector(".".concat(settingIcon));
	    dom.errorWrap = container.querySelector(".".concat(errorWrap));
	    dom.errorText = container.querySelector(".".concat(errorText));
	    dom.highlight = container.querySelector(".".concat(highlight));
	    dom.flashTip = container.querySelector(".".concat(flashTip));
	    dom.flash = container.querySelector(".".concat(flash));
	    dom.notice = container.querySelector(".".concat(notice));
	    dom.switchQuality = container.querySelector(".".concat(switchQuality));
	    dom.switchPath = container.querySelector(".".concat(switchPath));
	    dom.bigPlayBtn = container.querySelector(".".concat(bigPlayBtn));
	    dom.recordRestrict360 = container.querySelector(".".concat(recordRestrict360));
	    dom.liveBadge = container.querySelector(".".concat(liveBadge));
	    dom.playbackRate = container.querySelector(".".concat(playbackRate));
	    dom.pathSelectWrap = container.querySelector(".".concat(pathSelectWrap));
	    this.trigger(INTERNAL_DOM_INITED);
	  }
	  function destroyDom() {
	    this._container.innerHTML = '';
	    classList(this._container).remove(/mudu-.*/);
	    classList(this._container).remove('mudu');
	  }
	
	  function getDomString(lang, fileCdnPath, renderLoadingString) {
	    /* prettier-ignore */
	    var dom = "<style>" + ".mudu.".concat(hideEverything, " {background: #000;}") + ".mudu.".concat(hideEverything, " div {display: none !important;}") + ".mudu.".concat(hideEverything, " span {display: none !important;}") + ".mudu.".concat(hideEverything, " button {display: none !important;}") + "@font-face{font-family:'mudu-icons';src:url(\"".concat(fileCdnPath, "/fonts/mudu-icons.eot?yyls80\");src:url(\"").concat(fileCdnPath, "/fonts/mudu-icons.eot?yyls80#iefix\") format(\"embedded-opentype\"),url(\"").concat(fileCdnPath, "/fonts/mudu-icons.ttf?yyls80\") format(\"truetype\"),url(\"").concat(fileCdnPath, "/fonts/mudu-icons.woff?yyls80\") format(\"woff\"),url(\"").concat(fileCdnPath, "/fonts/mudu-icons.svg?yyls80#mudu-icons\") format(\"svg\");font-weight:normal;font-style:normal}") + "</style>" + "<div class=\"".concat(reset, " ").concat(aspect, "\"></div>") + "<div class=\"".concat(reset, " ").concat(mask, "\"></div>") + "<div class=\"".concat(reset, " ").concat(videoWrap, "\">") + "<div class=\"".concat(reset, " ").concat(flash, "\"></div>") + "<div class=\"".concat(reset, " ").concat(background, "\"></div>") + "<div class=\"".concat(reset, " ").concat(watermark, "\"></div>") + "<div class=\"".concat(reset, " ").concat(bezel, "\">") + "<span class=\"".concat(reset, " ").concat(bezelIcon, "\"></span>") + "</div>" + "</div>" + "<div class=\"".concat(reset, " ").concat(baseLayer, "\"></div>") + "<div class=\"".concat(reset, " ").concat(logo, "\">") + "<a class=\"".concat(reset, " ").concat(logoLink, "\" target=\"_blank\"><img style=\"display: none;\" /></a>") + "</div>" + "<div class=\"".concat(reset, " ").concat(danmaku, "\"></div>") + "<div class=\"".concat(reset, " ").concat(errorWrap, "\">") + "<div class=\"".concat(reset, " ").concat(errorInner, "\">") + "<div class=\"".concat(reset, " ").concat(errorIcon, "\"><span class=\"").concat(reset, " ").concat(error, "\"></span></div>") + "<div class=\"".concat(reset, " ").concat(errorText, "\">There is some error: </div>") + "</div>" + "</div>" + "<div class=\"".concat(reset, " ").concat(controllerWrap, "\">") + "<div class=\"".concat(reset, " ").concat(controllerBlank, "\"></div>") + "<div class=\"".concat(reset, " ").concat(videoTitle, "\"></div>") + "<div class=\"".concat(reset, " ").concat(bigPlayBtn, "\">") + "<button type=\"button\" class=\"".concat(reset, " ").concat(icon, " ").concat(play, "\"></button>") + "</div>" + "<div class=\"".concat(subtitle, "\">") + "</div>" + "<div class=\"".concat(reset, " ").concat(controllerMask, "\"></div>") + "<div class=\"".concat(reset, " ").concat(controller, "\">") + // icons left
	    "<div class=\"".concat(reset, " ").concat(icons, " ").concat(iconsLeft, "\">") + // `<button type="button" class="${cssClass.reset} ${cssClass}-icon ${cssClass}-prev-icon"><-</button>` +
	    "<button type=\"button\" class=\"".concat(reset, " ").concat(icon, " ").concat(playIcon, "\">") + "</button>" + // `<button type="button" class="${cssClass.reset} ${cssClass}-icon ${cssClass}-next-icon">-></button>` +
	    "<div class=\"".concat(reset, " ").concat(volume, "\">") + "<button type=\"button\" class=\"".concat(reset, " ").concat(icon, " ").concat(volumeIcon, "\" mudu-tooltip placement=\"top\" tooltip-title=\"").concat(lang['Mute'], "\">") + "</button>" + "<div class=\"".concat(reset, " ").concat(volumeBarWrap, "\">") + "<div class=\"".concat(reset, " ").concat(volumeBar, "\">") + "<div class=\"".concat(reset, " ").concat(volumeBarInner, "\">") + "<span class=\"".concat(reset, " ").concat(thumb, "\" style=\"background: #b7daff;\">") + "</span>" + "</div>" + "</div>" + "</div>" + "</div>" + "<span class=\"".concat(reset, " ").concat(liveBadge, "\" mudu-tooltip placement=\"top\" tooltip-title=\"").concat(lang['Skip ahead to live broadcast'], "\">") + "<span class=\"".concat(reset, " ").concat(liveDot, "\"></span>") + "Live" + "</span>" + "<span class=\"".concat(reset, " ").concat(time, "\">") + "<span class=\"".concat(reset, " ").concat(ptime, "\"></span>") + " / " + "<span class=\"".concat(reset, " ").concat(dtime, "\"></span>") + "</span>" + "</div>" + // icons right
	    "<div class=\"".concat(reset, " ").concat(icons, " ").concat(iconsRight, "\">") + "<span role=\"button\" class=\"".concat(reset, " ").concat(switchText, " ").concat(switchPath, "\"></span>") + "<span role=\"button\" class=\"".concat(reset, " ").concat(switchText, " ").concat(switchQuality, "\"></span>") + "<span role=\"button\" class=\"".concat(reset, " ").concat(switchText, " ").concat(playbackRate, " ").concat(switchSpeed, "\"></span>") + "<button type=\"button\" class=\"".concat(reset, " ").concat(icon, " ").concat(captionIcon, "\"></button>") + "<button type=\"button\" class=\"".concat(reset, " ").concat(icon, " ").concat(settingIcon, " ").concat(setting, "\"></button>") + "<button type=\"button\" class=\"".concat(reset, " ").concat(icon, " ").concat(fullscreenIcon, "\" mudu-tooltip placement=\"top\" tooltip-title=\"").concat(lang['Full screen'], "\"></button>") + "<span type=\"button\" class=\"".concat(reset, " ").concat(icon, " ").concat(customControlIcon, "\"></span>") + "</div>" + "<div class=\"".concat(reset, " ").concat(barWrap, "\">") + "<div class=\"".concat(reset, " ").concat(barPopup, " ").concat(hidden, "\">") + "<div class=\"".concat(reset, " ").concat(barPreview, "\">") + "<div class=\"".concat(reset, " ").concat(barImg, "\"></div>") + "<div class=\"".concat(reset, " ").concat(barTimeWrap, "\">") + "<div class=\"".concat(reset, " ").concat(barTime, "\"></div>") + "</div>" + "</div>" + "<div class=\"".concat(reset, " ").concat(barTextWrap, "\">") + "<div class=\"".concat(reset, " ").concat(barText, "\">") + "<span class=\"".concat(reset, " ").concat(barTextTime, "\"></span>") + "<span class=\"".concat(reset, " ").concat(barTextText, "\"></span>") + "</div>" + "</div>" + "</div>" + "<div class=\"".concat(reset, " ").concat(bar, "\">") + "<div class=\"".concat(reset, " ").concat(loaded, "\"></div>") + "<div class=\"".concat(reset, " ").concat(played, "\" style=\"background: #f00;\">") + "<span class=\"".concat(reset, " ").concat(thumb, "\" style=\"background: #f00;\"></span>") + "</div>" + "<div class=\"".concat(reset, " ").concat(highlight, "\"></div>") + "</div>" + "</div>" + "</div>" + "</div>" + "<div class=\"".concat(reset, " ").concat(flashTip, "\">") + "<div class=\"".concat(reset, " ").concat(flashTipInner, "\"><a href=\"http://www.adobe.com/go/getflash\" target=\"_blank\">\u68C0\u6D4B\u5230\u60A8\u8FD8\u672A\u5B89\u88C5flash, \u8BF7\u70B9\u51FB\u8FD9\u91CC\u5B89\u88C5</a></div>") + "</div>" + "<div class=\"".concat(reset, " ").concat(notice, " ").concat(hide, "\"></div>") + "<div class=\"".concat(reset, " ").concat(recordRestrict360, " ").concat(hide, "\"></div>");
	    return dom;
	  }
	
	  function Delegator(proto, target) {
	    if (!(this instanceof Delegator)) return new Delegator(proto, target);
	    this.proto = proto;
	    this.target = target;
	  }
	
	  Delegator.prototype.method = function (name) {
	    var proto = this.proto;
	    var target = this.target;
	
	    proto[name] = function () {
	      if (isDebugMode()) {
	        console.log("[delegates]: (".concat(proto.constructor.name, " | ").concat(target.constructor.name, ").").concat(name, " --"), safeJSONStringify([].slice.call(arguments)));
	      } // for log
	
	
	      target.TAG === 'model' && this.trigger('delegate-model', {
	        fn: name,
	        args: [].slice.call(arguments)
	      });
	      return target[name].apply(target, arguments);
	    };
	
	    return this;
	  };
	
	  var Model =
	  /*#__PURE__*/
	  function () {
	    function Model(player) {
	      _classCallCheck(this, Model);
	
	      this.player = player;
	      this.lang = player._status.localization;
	      this.m_player_events = [];
	      this.m_dom_events = [];
	      this.m_provider_events = [];
	      this.m_removed = false;
	      this.TAG = 'model';
	    }
	    /**
	     * get provider instance
	     * @returns @link{Provider}
	     */
	
	
	    _createClass(Model, [{
	      key: "provider",
	      value: function provider() {
	        return this.player._provider && this.player._provider.instance;
	      }
	      /**
	       * 清除model时会调用该方法
	       */
	
	    }, {
	      key: "remove",
	      value: function remove() {
	        var _this = this;
	
	        this.m_removed = true;
	        this.m_player_events.forEach(function (v) {
	          return _this.player.off(v.evt, v.fn);
	        });
	        this.m_dom_events.forEach(function (v) {
	          return removeEventListener(v.ele, v.evt, v.fn);
	        });
	        this.m_provider_events.forEach(function (v) {
	          if (_this.provider()) {
	            _this.provider().off(v.evt, v.fn);
	          }
	        });
	      }
	    }, {
	      key: "onPlayer",
	      value: function onPlayer(evt, fn) {
	        this.player.on(evt, fn);
	        this.m_player_events.push({
	          evt: evt,
	          fn: fn
	        });
	      }
	    }, {
	      key: "oncePlayer",
	      value: function oncePlayer(evt, fn) {
	        this.player.once(evt, fn);
	        this.m_player_events.push({
	          evt: evt,
	          fn: fn
	        });
	      }
	    }, {
	      key: "onDom",
	      value: function onDom(ele, evt, fn) {
	        addEventListener(ele, evt, fn);
	
	        if (ele === this.player.dom.container) {
	          this.m_dom_events.push({
	            ele: ele,
	            evt: evt,
	            fn: fn
	          });
	        }
	      }
	    }, {
	      key: "onProvider",
	      value: function onProvider(evt, fn) {
	        if (this.provider()) {
	          this.provider().on(evt, fn);
	          this.m_provider_events.push({
	            evt: evt,
	            fn: fn
	          });
	        }
	      }
	    }, {
	      key: "onceProvider",
	      value: function onceProvider(evt, fn) {
	        if (this.provider()) {
	          this.provider().once(evt, fn);
	          this.m_provider_events.push({
	            evt: evt,
	            fn: fn
	          });
	        }
	      }
	    }]);
	
	    return Model;
	  }();
	
	  var fn = function () {
	    var val;
	    var fnMap = [['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror'], // New WebKit
	    ['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror'], // Old WebKit (Safari 5.1)
	    ['webkitRequestFullScreen', 'webkitCancelFullScreen', 'webkitCurrentFullScreenElement', 'webkitCancelFullScreen', 'webkitfullscreenchange', 'webkitfullscreenerror'], ['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror'], ['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError']];
	    var i = 0;
	    var l = fnMap.length;
	    var ret = {};
	
	    for (; i < l; i++) {
	      val = fnMap[i];
	
	      if (val && val[1] in document) {
	        for (i = 0; i < val.length; i++) {
	          ret[fnMap[0][i]] = val[i];
	        }
	
	        return ret;
	      }
	    }
	
	    return false;
	  }();
	
	  function requestFullscreen(ele) {
	    ele[fn.requestFullscreen]();
	  }
	  function exitFullscreen() {
	    document[fn.exitFullscreen]();
	  }
	  function isSupported() {
	    return Boolean(document[fn.fullscreenEnabled]);
	  }
	  function onChange(cb) {
	    addEventListener(document, fn.fullscreenchange, cb);
	  }
	  function offChange(cb) {
	    removeEventListener(document, fn.fullscreenchange, cb);
	  }
	  function getElement() {
	    return document[fn.fullscreenElement];
	  }
	
	  var defaultConfig = {
	    trigger: 'hover',
	    placement: 'top',
	    container: document.body,
	    distance: 10,
	    content: '',
	    getMaxHeight: function getMaxHeight() {
	      return 'none';
	    },
	    class: 'mudu-tooltip'
	  };
	  var hideLeft = '-20000px';
	  var events = new EventEmitter();
	  var tooltips = [];
	
	  function init() {
	    addEventListener(document, 'mouseover', function (e) {
	      var ele = e.target || e.srcElement;
	
	      if (isTooltipTrigger(ele)) {
	        events.trigger('mouseover', e, ele);
	      }
	    });
	    addEventListener(document, 'mouseout', function (e) {
	      var ele = e.target || e.srcElement;
	
	      if (isTooltipTrigger(ele)) {
	        events.trigger('mouseout', e, ele);
	      }
	    });
	    addEventListener(document, 'click', function (e) {
	      var ele = e.target || e.srcElement;
	
	      if (isAnyShow()) {
	        hideAll();
	        return;
	      }
	
	      if (isTooltipTrigger(ele)) {
	        events.trigger('click', e, ele);
	      }
	    });
	  }
	
	  function isAnyShow() {
	    return tooltips.filter(function (t) {
	      return t.isShow();
	    }).length > 0;
	  }
	
	  function isAnyClassShow(className) {
	    return tooltips.filter(function (t) {
	      return t.isShow() && t.getConfig().class === className;
	    }).length > 0;
	  }
	
	  function hideAll() {
	    tooltips.forEach(function (t) {
	      return t.hide();
	    });
	  }
	
	  function isTooltipTrigger(ele) {
	    return ele && ele.getAttribute('mudu-tooltip') === '';
	  }
	
	  function tooltip(ele) {
	    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    ele = typeof ele === 'string' && ele ? document.querySelector(ele) : ele;
	    config = _objectSpread({}, defaultConfig, config);
	    ele && ele.setAttribute('mudu-tooltip', '');
	    var tooltipEnable = true;
	    var tooltipDom = createTooltipDom();
	    updateContent(config.content);
	    var mouseover = events.on('mouseover', function (_, target) {
	      if (target !== ele) {
	        return;
	      }
	
	      if (config.trigger !== 'hover') {
	        return;
	      }
	
	      tooltipEnable && show();
	    });
	    var mouseout = events.on('mouseout', function (_, target) {
	      if (target !== ele) {
	        return;
	      }
	
	      if (config.trigger !== 'hover') {
	        return;
	      }
	
	      hide();
	    });
	    var click = events.on('click', function (_, target) {
	      if (target !== ele) {
	        return;
	      }
	
	      if (config.trigger !== 'click') {
	        return;
	      }
	
	      tooltipEnable && show();
	    });
	
	    var getConfig = function getConfig() {
	      return _objectSpread({}, config);
	    };
	
	    var ret = {
	      hide: hide,
	      isShow: isShow,
	      destroy: destroy,
	      getTooltipContainer: getTooltipContainer,
	      updateContent: updateContent,
	      show: show,
	      getConfig: getConfig,
	      disable: disable,
	      enable: enable
	    };
	    tooltips.push(ret);
	    return ret;
	
	    function disable() {
	      tooltipEnable = false;
	      hide();
	    }
	
	    function enable() {
	      tooltipEnable = true;
	    }
	
	    function createTooltipDom() {
	      var div = document.createElement('div');
	      config.container.appendChild(div);
	      div.setAttribute('class', 'mudu-reset ' + config.class);
	      addEventListener(div, 'click', function (e) {
	        config.wrapClick && config.wrapClick(e);
	        e.stopPropagation && e.stopPropagation();
	        e.cancelBubble = true;
	      });
	      div.style.cssText = "position: absolute; top: 0; left: ".concat(hideLeft, "; opacity: 0; visibility: hidden;");
	      return div;
	    }
	
	    function isShow() {
	      return tooltipDom && tooltipDom.style.left !== hideLeft;
	    }
	
	    function destroy() {
	      var idx = tooltips.indexOf(ret);
	
	      if (idx < 0) {
	        return;
	      }
	
	      events.off('mouseover', mouseover);
	      events.off('mouseout', mouseout);
	      events.off('click', click);
	      tooltipDom.parentElement.removeChild(tooltipDom);
	      ele && ele.removeAttribute('mudu-tooltip');
	      tooltips.splice(idx, 1);
	    }
	
	    function updateContent(ele) {
	      if (typeof ele === 'string') {
	        tooltipDom.innerHTML = ele;
	      }
	
	      if (_typeof(ele) === 'object') {
	        tooltipDom.innerHTML = '';
	        tooltipDom.appendChild(ele);
	      }
	    }
	
	    function show() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          left = _ref.left,
	          top = _ref.top;
	
	      updateMaxHeight();
	
	      if (left === undefined && top === undefined) {
	        if (config.placement === 'top') {
	          var containerRect = getBoundingClientRect(config.container);
	          var tooltipRect = getBoundingClientRect(tooltipDom);
	          var eleRect = getBoundingClientRect(ele);
	          var distance = config.distance;
	          left = eleRect.left + eleRect.width / 2 - tooltipRect.width / 2 - containerRect.left;
	          top = eleRect.top - tooltipRect.height - distance - containerRect.top;
	
	          if (left + tooltipRect.width > containerRect.right) {
	            // 右侧防止溢出
	            left = containerRect.right - tooltipRect.width;
	          }
	
	          if (left < 0) {
	            // 左侧防止溢出
	            left = containerRect.left;
	          }
	        }
	      }
	
	      tooltipDom.style.left = left + 'px';
	      tooltipDom.style.top = top + 'px';
	      tooltipDom.style.visibility = 'visible';
	      tooltipDom.style.opacity = 1;
	    }
	
	    function updateMaxHeight() {
	      var containerRect = getBoundingClientRect(config.container);
	      var maxHeight = config.getMaxHeight(containerRect);
	      tooltipDom.style.maxHeight = cssLength(maxHeight);
	    }
	
	    function getTooltipContainer() {
	      return tooltipDom;
	    }
	
	    function hide() {
	      if (tooltipDom) {
	        tooltipDom.style.left = hideLeft;
	        tooltipDom.style.opacity = 0;
	        tooltipDom.style.visibility = 'hidden';
	      }
	    }
	  }
	
	  tooltip.isAnyShow = isAnyShow;
	  tooltip.hideAll = hideAll;
	  tooltip.isAnyClassShow = isAnyClassShow;
	  init();
	
	  var Fullsreen =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(Fullsreen, _Model);
	
	    function Fullsreen(player) {
	      var _this;
	
	      _classCallCheck(this, Fullsreen);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Fullsreen).call(this, player));
	      _this.isFullscreen = false;
	
	      _this.subEvents();
	
	      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('getFullscreen').method('setFullscreen');
	      classList(_this.player.dom.fullscreen).add(full);
	      _this.fullTip = tooltip(_this.player.dom.fullscreen, {
	        content: getTooltipString(_this.lang['Full screen']),
	        container: _this.player.dom.container
	      });
	      return _this;
	    }
	
	    _createClass(Fullsreen, [{
	      key: "subEvents",
	      value: function subEvents() {
	        var _this2 = this;
	
	        this.onDom(this.player.dom.fullscreen, 'click', function () {
	          _this2.setFullscreen(!_this2.isFullscreen);
	        });
	        this.onPlayer(INTERNAL_PROVIDER_INITED, function () {
	          _this2.onProvider(PROVIDER_STAGE_DOUBLE_CLICK, function () {
	            _this2.setFullscreen(!_this2.isFullscreen);
	          });
	        });
	
	        this.handleFullscreenChange = function (e) {
	          var fullEle = getElement(); // 硬件全屏分:
	          // 1. 纯硬件全屏: 全屏元素为硬件元素即为null, 且isFullscreen状态不会变更
	          // 2. 微信硬件全屏: 全屏是video全屏
	          // 非硬件全屏: 全屏的时候是wrap全屏
	          // 硬件全屏不做全屏处理，全部交给系统去做
	
	          if (isMobile() && (!fullEle && !_this2.isFullscreen || fullEle && fullEle.nodeName === 'VIDEO')) {
	            return;
	          } // 全屏元素不是当前元素
	          // 分情况
	          // 1. 有全屏元素且相等且非全屏状态(开启全屏) + 无全屏元素且全屏状态(退出全屏)，则进行操作
	          // 2. 其余都不操作
	
	
	          if (fullEle && fullEle === _this2.player.dom.container && !_this2.isFullscreen || !fullEle && _this2.isFullscreen) {
	            _this2.isFullscreen = fullEle === _this2.player.dom.container;
	
	            _this2.onAfterFullScreen();
	          }
	        };
	
	        isSupported() && onChange(this.handleFullscreenChange);
	
	        if (!isMobile()) {
	          this.onDom(this.player.dom.videoWrap, 'dblclick', function () {
	            if (_this2.player._provider && _this2.player._provider.flash) {
	              return;
	            }
	
	            _this2.player.getControls() && _this2.toggle();
	          });
	        }
	      }
	    }, {
	      key: "onAfterFullScreen",
	      value: function onAfterFullScreen() {
	        var dom = this.player.dom;
	        this.player.trigger(OUTER_FULLSCREEN, {
	          type: OUTER_FULLSCREEN,
	          fullscreen: this.isFullscreen
	        });
	        classList(dom.container).toggle(fullscreen);
	        classList(dom.fullscreen).remove(iconReg);
	        classList(dom.fullscreen).add(this.isFullscreen ? fullOff : full);
	        this.fullTip.updateContent(getTooltipString(this.isFullscreen ? this.lang['Exit full screen'] : this.lang['Full screen']));
	      }
	    }, {
	      key: "toggle",
	      value: function toggle() {
	        this.setFullscreen(!this.getFullscreen());
	      }
	    }, {
	      key: "getFullscreen",
	      value: function getFullscreen() {
	        return this.isFullscreen;
	      }
	    }, {
	      key: "remove",
	      value: function remove() {
	        isSupported() && offChange(this.handleFullscreenChange);
	
	        _get(_getPrototypeOf(Fullsreen.prototype), "remove", this).call(this);
	      }
	    }, {
	      key: "setFullscreen",
	      value: function setFullscreen() {
	        var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	        var container = this.player.dom.container;
	        var isFullscreen = this.isFullscreen;
	        var videoElem = this.player.dom.container.querySelector(".".concat(video)); // VR使用中
	
	        var vrDom = this.player._config.extraProvider['vr'].use && this.player.dom.videoWrap.querySelector('canvas');
	        var vrProvider = this.player._extraProviders.vr;
	        var isVRInUse = vrProvider && vrDom;
	
	        if (isVRInUse || isSupported()) {
	          if (status) {
	            !isFullscreen && requestFullscreen(container);
	          } else {
	            isFullscreen && exitFullscreen();
	          }
	        } else {
	          if (isMobile() && videoElem.webkitSupportsFullscreen) {
	            if (status) {
	              videoElem.webkitEnterFullScreen();
	            } else {
	              videoElem.webkitExitFullScreen();
	            }
	          } else {
	            this.isFullscreen = status;
	            this.onAfterFullScreen();
	          }
	        }
	      }
	    }]);
	
	    return Fullsreen;
	  }(Model);
	
	  var getOverrideError = function getOverrideError() {
	    return new Error('method should be override');
	  };
	
	  var Provider =
	  /*#__PURE__*/
	  function (_EventEmitter) {
	    _inherits(Provider, _EventEmitter);
	
	    function Provider(player, option) {
	      var _this;
	
	      _classCallCheck(this, Provider);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Provider).call(this));
	      _this.player = player;
	      _this.option = option;
	      _this.p_player_events = [];
	      _this.p_dom_events = [];
	      _this.p_self_events = [];
	      _this.TAG = 'Provider';
	      return _this;
	    }
	
	    _createClass(Provider, [{
	      key: "loadFiles",
	      value: function loadFiles() {
	        return Promise.resolve();
	      }
	    }, {
	      key: "getMediaElement",
	      value: function getMediaElement() {}
	    }, {
	      key: "createMediaElement",
	      value: function createMediaElement() {}
	    }, {
	      key: "setup",
	      value: function setup() {
	        return Promise.reject(getOverrideError());
	      }
	    }, {
	      key: "remove",
	      value: function remove() {
	        var _this2 = this;
	
	        this.p_player_events.forEach(function (v) {
	          return _this2.player.off(v.evt, v.fn);
	        });
	        this.p_dom_events.forEach(function (v) {
	          return removeEventListener(v.ele, v.evt, v.fn);
	        });
	        this.p_self_events.forEach(function (v) {
	          return _this2.off(v.evt, v.fn);
	        });
	      }
	      /**
	       * 获取音量 Get volume
	       * @returns {number} the volume
	       * @memberof Provider
	       */
	
	    }, {
	      key: "getVolume",
	      value: function getVolume() {}
	      /**
	       * 设置音量 Set volume
	       * @param {number} volume range: 0 ~ 1
	       * @memberof Provider
	       */
	
	    }, {
	      key: "setVolume",
	      value: function setVolume() {}
	    }, {
	      key: "getMute",
	      value: function getMute() {}
	    }, {
	      key: "setMute",
	      value: function setMute() {}
	    }, {
	      key: "getWidth",
	      value: function getWidth() {
	        return -1;
	      }
	    }, {
	      key: "getHeight",
	      value: function getHeight() {
	        return -1;
	      }
	    }, {
	      key: "getMetrics",
	      value: function getMetrics() {
	        return {};
	      }
	    }, {
	      key: "getBuffer",
	      value: function getBuffer() {
	        return [];
	      }
	      /**
	       * 获取视频播放节点 Get video played position
	       * @returns {number} the player's played position
	       * @memberof Provider
	       */
	
	    }, {
	      key: "getCurrentTime",
	      value: function getCurrentTime() {}
	      /**
	       * 获取视频长度 Get video duration
	       * @returns {number} video duration in millisecond
	       * @memberof Provider
	       */
	
	    }, {
	      key: "getDuration",
	      value: function getDuration() {}
	      /**
	       * 设置视频拉伸方式 Set the video stretching style
	       * @param {string} style
	       * @memberof Provider
	       */
	
	    }, {
	      key: "setStretching",
	      value: function setStretching() {}
	      /**
	       * 获取视频拉伸方式 Get the video stretching style
	       * @returns {string} video stretching style
	       * @memberof Provider
	       */
	
	    }, {
	      key: "getStretching",
	      value: function getStretching() {}
	      /**
	       * 获取视频的metadata Get video metadata
	       * @returns {object}
	       * @memberof Provider
	       */
	
	    }, {
	      key: "getMetadata",
	      value: function getMetadata() {}
	      /**
	       * 播放视频 Play the video
	       * @memberof Provider
	       */
	
	    }, {
	      key: "play",
	      value: function play() {}
	      /**
	       * 暂停播放 Pause the video
	       * @memberof Provider
	       */
	
	    }, {
	      key: "pause",
	      value: function pause() {}
	      /**
	       * 跳转进度 Set played position
	       * @param {number} time position in millisecond
	       */
	
	    }, {
	      key: "seek",
	      value: function seek() {}
	      /**
	       * 获取播放速率
	       */
	
	    }, {
	      key: "getPlaybackRate",
	      value: function getPlaybackRate() {}
	      /**
	       * 设置播放速率
	       */
	
	    }, {
	      key: "setPlaybackRate",
	      value: function setPlaybackRate() {}
	      /**
	       * 获取字幕轨道
	       *
	       * @return
	       *
	       * [
	       *  {
	       *    language,
	       *    active,
	       *    kind,
	       *    cues: [],
	       *    activeCues: []
	       *  }
	       * ]
	       */
	
	    }, {
	      key: "getTextTracks",
	      value: function getTextTracks() {
	        return [];
	      }
	      /**
	       * 设置是否开启该轨道
	       * @param {*} enable
	       */
	
	    }, {
	      key: "setTextTrackActive",
	      value: function setTextTrackActive(enable) {} // event: cuechange, data: textTrack
	
	    }, {
	      key: "onPlayer",
	      value: function onPlayer(evt, fn) {
	        this.player.on(evt, fn);
	        this.p_player_events.push({
	          evt: evt,
	          fn: fn
	        });
	      }
	    }, {
	      key: "oncePlayer",
	      value: function oncePlayer(evt, fn) {
	        this.player.once(evt, fn);
	        this.p_player_events.push({
	          evt: evt,
	          fn: fn
	        });
	      }
	    }, {
	      key: "onDom",
	      value: function onDom(ele, evt, fn) {
	        var needRemove = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	        addEventListener(ele, evt, fn);
	        needRemove && this.p_dom_events.push({
	          ele: ele,
	          evt: evt,
	          fn: fn
	        });
	      }
	    }, {
	      key: "onSelf",
	      value: function onSelf(evt, fn) {
	        this.on(evt, fn);
	        this.p_self_events.push({
	          evt: evt,
	          fn: fn
	        });
	      }
	    }, {
	      key: "onceSelf",
	      value: function onceSelf(evt, fn) {
	        this.once(evt, fn);
	        this.p_self_events.push({
	          evt: evt,
	          fn: fn
	        });
	      }
	    }]);
	
	    return Provider;
	  }(EventEmitter);
	
	  Provider.defaultOptions = {};
	  Provider.canPlay = noop;
	  Provider.isSupported = noop;
	  Provider.isPlaybackRateSupported = noop;
	  Provider.isFlash = noop;
	  Provider.isHTML5 = noop;
	
	  var FLASH_MIME_TYPE = 'application/x-shockwave-flash';
	  var objIdArr = [];
	  var flashV = flashVersion();
	  var isIE$1 = isMSIE();
	  var webkit = getWebkitVersion();
	  function embedSWF(swfUrlStr, replaceElemIdStr, widthStr, heightStr, swfVersionStr, xiSwfUrlStr, flashvarsObj, parObj, attObj, callbackFn) {
	    var id = replaceElemIdStr;
	    var callbackObj = {
	      success: false,
	      id: id
	    };
	
	    if (!(webkit && webkit < 312) && swfUrlStr && replaceElemIdStr && widthStr && heightStr && swfVersionStr) {
	      setVisibility(id, false);
	
	      var onLoad = function onLoad() {
	        widthStr += '';
	        heightStr += '';
	        var att = {};
	
	        if (attObj && _typeof(attObj) === 'object') {
	          for (var i in attObj) {
	            att[i] = attObj[i];
	          }
	        }
	
	        att.data = swfUrlStr;
	        att.width = widthStr;
	        att.height = heightStr;
	        var par = {};
	
	        if (parObj && _typeof(parObj) === 'object') {
	          for (var j in parObj) {
	            par[j] = parObj[j];
	          }
	        }
	
	        if (flashvarsObj && _typeof(flashvarsObj) === 'object') {
	          for (var k in flashvarsObj) {
	            if (flashvarsObj.hasOwnProperty(k)) {
	              var key =  k;
	              var value =  flashvarsObj[k];
	
	              if (typeof par.flashvars !== 'undefined') {
	                par.flashvars += '&' + key + '=' + value;
	              } else {
	                par.flashvars = key + '=' + value;
	              }
	            }
	          }
	        } // flash 版本满足
	
	
	        if (hasPlayerVersion(swfVersionStr)) {
	          var obj = createSWF(att, par, replaceElemIdStr);
	
	          if (att.id === id) {
	            setVisibility(id, true);
	          }
	
	          callbackObj.success = true;
	          callbackObj.ref = obj;
	          callbackObj.id = obj.id;
	        } else {
	          setVisibility(id, true);
	        }
	
	        if (callbackFn) {
	          callbackFn(callbackObj);
	        }
	      };
	
	      onLoad(); // TODO 监听DomContentLoaded事件
	    } else if (callbackFn) {
	      callbackFn(callbackObj);
	    }
	  }
	
	  function setVisibility(id, isVisible) {
	    var v = isVisible ? 'visible' : 'hidden';
	    var el = document.getElementById(id);
	    el.style.visibility = v;
	  }
	  /* Flash Player and SWF content version matching
	    */
	
	
	  function hasPlayerVersion(rv) {
	    rv = parseFloat(rv);
	    return flashV >= rv;
	  }
	  /* Cross-browser dynamic SWF creaion
	    */
	
	
	  function createSWF(attObj, parObj, id) {
	    var r;
	    var el = document.getElementById(id);
	
	    if (webkit && webkit < 312) {
	      return r;
	    }
	
	    if (el) {
	      var o = isIE$1 ? document.createElement('div') : document.createElement('object');
	      var attr;
	      var attrLower;
	      var param;
	
	      if (typeof attObj.id === 'undefined') {
	        // if no 'id' is defined for the object element, it will inherit the 'id' from the fallback content
	        attObj.id = id;
	      } // Add params
	
	
	      for (param in parObj) {
	        // filter out prototype additions from other potential libraries and IE specific param element
	        if (parObj.hasOwnProperty(param) && param.toLowerCase() !== 'movie') {
	          createObjParam(o, param, parObj[param]);
	        }
	      } // Create IE object, complete with param nodes
	
	
	      if (isIE$1) {
	        o = createIeObject(attObj.data, o.innerHTML);
	      } // Add attributes to object
	
	
	      for (attr in attObj) {
	        if (attObj.hasOwnProperty(attr)) {
	          // filter out prototype additions from other potential libraries
	          attrLower = attr.toLowerCase(); // 'class' is an ECMA4 reserved keyword
	
	          if (attrLower === 'styleclass') {
	            o.setAttribute('class', attObj[attr]);
	          } else if (attrLower !== 'classid' && attrLower !== 'data') {
	            o.setAttribute(attr, attObj[attr]);
	          }
	        }
	      }
	
	      if (isIE$1) {
	        objIdArr[objIdArr.length] = attObj.id; // stored to fix object 'leaks' on unload (dynamic publishing only)
	      } else {
	        o.setAttribute('type', FLASH_MIME_TYPE);
	        o.setAttribute('data', attObj.data);
	      }
	
	      el.parentNode.replaceChild(o, el);
	      r = o;
	    }
	
	    return r;
	  }
	
	  function createIeObject(url, paramStr) {
	    var div = document.createElement('div');
	    div.innerHTML = "<object classid='clsid:D27CDB6E-AE6D-11cf-96B8-444553540000'><param name='movie' value='" + url + "'>" + paramStr + '</object>';
	    return div.firstChild;
	  }
	
	  function createObjParam(el, pName, pValue) {
	    var p = document.createElement('param');
	    p.setAttribute('name', pName);
	    p.setAttribute('value', pValue);
	    el.appendChild(p);
	  }
	
	  var Timer =
	  /*#__PURE__*/
	  function (_EventEmitter) {
	    _inherits(Timer, _EventEmitter);
	
	    function Timer(options) {
	      var _this;
	
	      _classCallCheck(this, Timer);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Timer).call(this));
	      _this.options = options || {};
	      _this.gap = +_this.options.gap || 1000;
	      _this.isRaf = !!_this.options.isRaf;
	      _this.task = null;
	      _this.dotTime = new Date().getTime();
	      return _this;
	    }
	
	    _createClass(Timer, [{
	      key: "start",
	      value: function start() {
	        this.trigger('start', {
	          options: this.options
	        });
	        this.stop();
	
	        this._startTimer();
	      }
	      /**
	       * 手动tick, 计算passed time并触发tick事件，然后重置dot time
	       */
	
	    }, {
	      key: "tick",
	      value: function tick() {
	        var duration = this._passedTime();
	
	        if (!this.task) {
	          return;
	        }
	
	        this._clearTimer();
	
	        if (duration > 0) {
	          this.trigger('tick', {
	            options: this.options,
	            duration: duration,
	            isStop: false
	          });
	        }
	
	        this._startTimer();
	      }
	    }, {
	      key: "stop",
	      value: function stop() {
	        var duration = this._passedTime();
	
	        if (!this.task) {
	          return;
	        }
	
	        this._clearTimer();
	
	        if (duration > 0) {
	          this.trigger('tick', {
	            options: this.options,
	            duration: duration,
	            isStop: true
	          });
	        }
	
	        this.trigger('stop', {
	          options: this.options
	        });
	      }
	    }, {
	      key: "_internalF",
	      value: function _internalF() {
	        var duration = this._passedTime();
	
	        if (duration > 0) {
	          this.trigger('tick', {
	            options: this.options,
	            duration: duration,
	            isStop: false
	          });
	        }
	
	        this._startTimer();
	      }
	    }, {
	      key: "_clearTimer",
	      value: function _clearTimer() {
	        if (this.isRaf) {
	          caf(this.task);
	        } else {
	          clearTimeout(this.task);
	        }
	
	        this.task = null;
	      }
	    }, {
	      key: "_startTimer",
	      value: function _startTimer() {
	        var _this2 = this;
	
	        if (this.isRaf) {
	          this.task = raf(function () {
	            return _this2._internalF();
	          });
	        } else {
	          // console.log('settimeout', this.gap)
	          this.task = setTimeout(function () {
	            return _this2._internalF();
	          }, this.gap);
	        }
	      }
	    }, {
	      key: "_passedTime",
	      value: function _passedTime() {
	        var now = new Date().getTime();
	        var passedTime = now - this.dotTime;
	        this.dotTime = now;
	        return passedTime;
	      }
	    }]);
	
	    return Timer;
	  }(EventEmitter);
	
	  function Cache() {
	    var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'muduPlayer';
	
	    if (!(this instanceof Cache)) {
	      return new Cache(storeKey);
	    }
	
	    this.storeKey = storeKey;
	  }
	
	  Cache.prototype.get = function (name) {
	    var data = this._getData();
	
	    return data[name];
	  };
	
	  Cache.prototype.set = function (name, value) {
	    var data = this._getData();
	
	    data[name] = value;
	
	    this._setData(data);
	  };
	
	  Cache.prototype._getData = function () {
	    var data = {};
	
	    try {
	      data = localStorage.getItem(this.storeKey);
	      data = JSON.parse(data);
	    } catch (err) {
	      data = {};
	      console.error('muduplayer: cannot read localstorage');
	    }
	
	    return data || {};
	  };
	
	  Cache.prototype._setData = function (data) {
	    try {
	      localStorage.setItem(this.storeKey, safeJSONStringify(data));
	    } catch (error) {
	      console.error('muduplayer: cannot set localstorage');
	    }
	  };
	
	  var FlashUtil =
	  /*#__PURE__*/
	  function (_EventEmitter) {
	    _inherits(FlashUtil, _EventEmitter);
	
	    function FlashUtil() {
	      _classCallCheck(this, FlashUtil);
	
	      return _possibleConstructorReturn(this, _getPrototypeOf(FlashUtil).apply(this, arguments));
	    }
	
	    _createClass(FlashUtil, [{
	      key: "onError",
	      value: function onError() {
	        this.trigger.apply(this, ['onError'].concat(Array.prototype.slice.call(arguments))); // console.log('flash onError', ...arguments)
	      }
	    }, {
	      key: "onEvent",
	      value: function onEvent() {
	        this.trigger.apply(this, ['onEvent'].concat(Array.prototype.slice.call(arguments))); // console.log('flash onEvent', [].slice.call(arguments))
	      }
	    }, {
	      key: "onReady",
	      value: function onReady() {
	        // console.log('flash onReady', [].slice.call(arguments))
	        this.trigger.apply(this, ['onReady'].concat(Array.prototype.slice.call(arguments)));
	      }
	    }]);
	
	    return FlashUtil;
	  }(EventEmitter); // muduPlayer.flashUtil.onError & muduPlayer.flashUtil.onEvent to subscribe ActionScript calling.
	
	
	  var flashUtil = new FlashUtil();
	
	  var Flash =
	  /*#__PURE__*/
	  function (_Provider) {
	    _inherits(Flash, _Provider);
	
	    function Flash(player, option) {
	      var _this;
	
	      _classCallCheck(this, Flash);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Flash).call(this, player, _objectSpread({}, Flash.defaultOptions, option)));
	      _this.object = null;
	      _this._prevPos = null;
	      _this.flashUtilListener = [];
	      _this._commandQueue = [];
	      _this.currentTimer = null;
	      _this.commandQueueTimer = null;
	      _this.lastVolume = Cache().get('volume');
	      window.muduPlayer = window.muduPlayer || {};
	      window.muduPlayer.flashUtil = window.muduPlayer.flashUtil || flashUtil;
	
	      _this.renderCustomTip();
	
	      _this.initCommandQueueTimer();
	
	      _this.removed = false; // this.onPlayer(events.INTERNAL_PROVIDER_REMOVED, () => {
	      //   console('flash provider removed')
	      //   this.remove()
	      // })
	
	      return _this;
	    }
	
	    _createClass(Flash, [{
	      key: "loadFiles",
	      value: function loadFiles() {
	        if (this.removed) {
	          return Promise.reject(new TypeError('flash provider removed'));
	        }
	
	        return _get(_getPrototypeOf(Flash.prototype), "loadFiles", this).call(this);
	      }
	    }, {
	      key: "getMediaElement",
	      value: function getMediaElement() {
	        return this.player.dom.videoWrap.querySelector('object');
	      }
	    }, {
	      key: "createMediaElement",
	      value: function createMediaElement() {
	        var _this2 = this;
	
	        this.id = this.player._config.containerId + '-flash';
	        this.player.dom.flash.id = this.id;
	        var flashVars = {
	          autoplay: false,
	          preload: this.player._config.preload,
	          hls_seekmode: 'ACCURATE',
	          debug: !true,
	          connectTimeout: this.option.connectTimeout || 3
	        };
	        var attributes = {
	          id: this.id,
	          name: this.id,
	          class: video,
	          // 需要直接加上style，否则safari上会加载多次swf导致播放失败
	          style: 'position: absolute; display: block; left: 0; right: 0; top: 0; bottom: 0; pointer-events:auto;'
	        };
	        var params = {
	          wmode: 'opaque',
	          allowScriptAccess: 'always',
	          bgcolor: '#000000'
	        };
	        embedSWF(this.player._config.fileCdnPath + '/mudu-player.swf', this.id, '100%', '100%', '10.3', '', flashVars, params, attributes, function (data) {
	          if (data.success === false) {
	            classList(_this2.player.dom.container).add(flashDisabled);
	          }
	        });
	        return this.getMediaElement();
	      }
	    }, {
	      key: "remove",
	      value: function remove() {
	        _get(_getPrototypeOf(Flash.prototype), "remove", this).call(this);
	
	        this.removed = true;
	        this.currentTimer && this.currentTimer.stop();
	        this.commandQueueTimer && this.commandQueueTimer.stop();
	        this.flashUtilListener.forEach(function (listener) {
	          return flashUtil.off(listener.event, listener.id);
	        });
	        this.triggerFlash('mudu_stop');
	        this.object = null;
	      }
	    }, {
	      key: "setup",
	      value: function setup(_ref) {
	        var _this3 = this;
	
	        var type = _ref.type,
	            absoluteFile = _ref.absoluteFile,
	            isLive = _ref.isLive;
	
	        if (this.removed) {
	          console.log('setup: plash provider removed');
	          return;
	        }
	
	        var handleOnReady = function handleOnReady() {
	          _this3.player._status.flashReady = true;
	          _this3.object = _this3.getMediaElement();
	          _this3.id = _this3.player._config.containerId + '-flash';
	          var safariCache = '';
	          var ts = new Date().getTime();
	
	          if (absoluteFile.indexOf('?') >= 0) {
	            safariCache = "&safari".concat(ts, "=").concat(ts);
	          } else {
	            safariCache = "?safari".concat(ts, "=").concat(ts);
	          }
	
	          if (type === 'rtmp') {
	            var parts = rtmpStreamToParts(absoluteFile);
	
	            _this3.triggerFlash('mudu_setProperty', 'rtmpConnection', parts.connection);
	
	            _this3.triggerFlash('mudu_setProperty', 'rtmpStream', parts.stream);
	          } else if (_this3.player._config.preload === 'auto') {
	            if (isSafari() && isLive) {
	              _this3.triggerFlash('mudu_src', absoluteFile + safariCache);
	            } else {
	              _this3.triggerFlash('mudu_src', absoluteFile);
	            }
	          } else {
	            _this3.oncePlayer('beforePlay', function () {
	              if (isSafari() && isLive) {
	                _this3.triggerFlash('mudu_src', absoluteFile + safariCache);
	              } else {
	                _this3.triggerFlash('mudu_src', absoluteFile);
	              }
	            });
	          }
	
	          _this3._subEvents();
	
	          _this3._updateCurrentTime();
	        };
	
	        if (this.player._status.flashReady) {
	          handleOnReady();
	          return Promise.resolve();
	        } else {
	          var promise = new Promise(function (resolve, reject) {
	            var isReady = false;
	            var id = flashUtil.on('onReady', function (id) {
	              if (id === _this3.id && _this3.object === null) {
	                isReady = true;
	                handleOnReady();
	                resolve();
	              }
	            });
	
	            _this3.flashUtilListener.push({
	              event: 'onReady',
	              id: id
	            });
	
	            isFF() && setTimeout(function () {
	              if (!isReady) {
	                classList(_this3.player.dom.container).add(flashDisabled);
	                reject(new Error(Flash.Error.NotAllowedError));
	              }
	            }, 5000);
	          });
	          return promise;
	        }
	      }
	    }, {
	      key: "initCommandQueueTimer",
	      value: function initCommandQueueTimer() {
	        var _this4 = this;
	
	        this.commandQueueTimer = new Timer({
	          gap: 200
	        });
	        this.commandQueueTimer.on('tick', function (_ref2) {
	          var isStop = _ref2.isStop;
	
	          if (isStop) {
	            return;
	          }
	
	          if (_this4._commandQueue.length === 0) {
	            _this4.commandQueueTimer.stop();
	          } else if (_this4._apiAvailable()) {
	            _this4._commandQueue.forEach(function (v) {
	              if (_this4.object[v.fn]) {
	                var _this4$object;
	
	                (_this4$object = _this4.object)[v.fn].apply(_this4$object, _toConsumableArray(v.args));
	              }
	            });
	
	            _this4._commandQueue = [];
	          }
	        });
	      }
	    }, {
	      key: "renderCustomTip",
	      value: function renderCustomTip() {
	        var tip = this.option.renderTip();
	        var flashTip = this.player.dom.flashTip;
	
	        var clearTip = function clearTip() {
	          flashTip.innerHTML = '';
	        };
	
	        if (typeof tip === 'string') {
	          clearTip();
	          flashTip.innerHTML = tip;
	        } // if tip is HTMLElement
	
	
	        if (_typeof(tip) === 'object') {
	          clearTip();
	          flashTip.appendChild(tip);
	        }
	      } // 因为有时候会出现this.object.fn is not a function see #19, 所以使用一个队列
	
	    }, {
	      key: "triggerFlash",
	      value: function triggerFlash(fnName) {
	        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        if (this.object && this.object[fnName]) {
	          var _this$object;
	
	          return (_this$object = this.object)[fnName].apply(_this$object, args);
	        } else {
	          this._commandQueue.push({
	            fn: fnName,
	            args: args
	          });
	
	          this.commandQueueTimer.start();
	        }
	      }
	    }, {
	      key: "_subEvents",
	      value: function _subEvents() {
	        var _this5 = this;
	
	        var id = flashUtil.on('onEvent', function (id, evt) {
	          if (id !== _this5.id || _this5.object === null) {
	            return;
	          } // console.log('flash event', id, evt)
	
	
	          _this5.trigger(evt);
	
	          switch (evt) {
	            case 'playing':
	              _this5.trigger('play');
	
	              break;
	
	            case 'durationchange':
	              _this5.trigger('duration');
	
	              break;
	
	            case 'volumechange':
	              var volume = _this5.getVolume();
	
	              _this5.trigger('volume', {
	                type: 'volume',
	                volume: volume
	              });
	
	              break;
	          }
	        });
	        var id2 = flashUtil.on('onError', function (id) {
	          for (var _len2 = arguments.length, others = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	            others[_key2 - 1] = arguments[_key2];
	          }
	
	          if (id !== _this5.id || _this5.object === null) {
	            return;
	          }
	
	          _this5.trigger(PROVIDER_ERROR, {
	            message: others.join(),
	            data: others,
	            fatal: true
	          });
	        });
	        this.flashUtilListener.push({
	          event: 'onEvent',
	          id: id
	        });
	        this.flashUtilListener.push({
	          event: 'onError',
	          id2: id2
	        });
	      }
	    }, {
	      key: "_updateCurrentTime",
	      value: function _updateCurrentTime() {
	        var _this6 = this;
	
	        this.currentTimer = new Timer({
	          gap: 500,
	          name: 'flash update time'
	        });
	        this.currentTimer.on('tick', function () {
	          if (_this6.object) {
	            var pos = _this6.getPosition();
	
	            if (pos !== _this6._prevPos) {
	              _this6.trigger('timeupdate');
	            }
	
	            _this6._prevPos = pos;
	          }
	        });
	        this.currentTimer.start();
	      }
	    }, {
	      key: "getWidth",
	      value: function getWidth() {
	        return this._get('videoWidth', -1);
	      }
	    }, {
	      key: "getHeight",
	      value: function getHeight() {
	        return this._get('videoHeight', -1);
	      }
	    }, {
	      key: "getMetrics",
	      value: function getMetrics() {
	        if (this._apiAvailable()) {
	          return {
	            videoHeight: this.getHeight(),
	            videoWidth: this.getWidth(),
	            fps: this.getFPS(),
	            bps: this.getBPS()
	          };
	        }
	
	        return {};
	      }
	    }, {
	      key: "getFPS",
	      value: function getFPS() {
	        return this._get('currentFPS', -1);
	      }
	    }, {
	      key: "getBPS",
	      value: function getBPS() {
	        return this._get('currentBPS', -1);
	      }
	    }, {
	      key: "getBuffer",
	      value: function getBuffer() {
	        if (this._apiAvailable()) {
	          var buffered = this._get('buffered', []);
	
	          if (buffered.length >= 1) {
	            var ret = buffered.map(function (part) {
	              return {
	                start: part[0],
	                end: part[1]
	              };
	            });
	            return ret;
	          }
	        }
	
	        return [];
	      }
	    }, {
	      key: "getVolume",
	      value: function getVolume() {
	        if (this._apiAvailable()) {
	          return this._get('volume');
	        }
	
	        return 1;
	      }
	    }, {
	      key: "setVolume",
	      value: function setVolume(volume) {
	        if (!this.object) {
	          return;
	        }
	
	        var muted = this.getMute();
	
	        if (is('number', volume)) {
	          if (volume < 0) {
	            volume = 0;
	          }
	
	          if (volume > 1) {
	            volume = 1;
	          } // this.object.mudu_setProperty('volume', volume)
	
	
	          this.triggerFlash('mudu_setProperty', 'volume', volume);
	
	          if (muted && volume > 0) {
	            this.setMute(false);
	          }
	
	          if (!muted && volume === 0) {
	            this.setMute(true);
	          }
	        }
	      }
	    }, {
	      key: "setMute",
	      value: function setMute() {
	        var mute = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        if (this._apiAvailable()) {
	          if (!mute && this.getVolume() === 0) {
	            this.setVolume(0.5);
	          }
	
	          this.object.mudu_setProperty('muted', !!mute);
	          this.trigger('mute', {
	            type: 'mute',
	            mute: !!mute
	          });
	        }
	      }
	    }, {
	      key: "getMute",
	      value: function getMute() {
	        if (this._apiAvailable()) {
	          return this._get('muted');
	        }
	
	        return false;
	      }
	    }, {
	      key: "setStretching",
	      value: function setStretching(stretching) {
	        if (!this._apiAvailable()) return;
	
	        switch (stretching) {
	          case 'none':
	          case 'contain':
	          case 'fill':
	          case 'cover':
	          case 'scale-down':
	            this.object.mudu_setProperty('stretching', stretching);
	            break;
	
	          default:
	            this.object.mudu_setProperty('stretching', 'contain');
	        }
	      }
	    }, {
	      key: "getStretching",
	      value: function getStretching() {
	        if (this._apiAvailable()) {
	          return this._get('stretching');
	        }
	
	        return 'contain';
	      }
	    }, {
	      key: "getPosition",
	      value: function getPosition() {
	        if (this._apiAvailable()) {
	          return this._get('currentTime') || 0;
	        }
	      }
	    }, {
	      key: "getDuration",
	      value: function getDuration() {
	        if (this._apiAvailable()) {
	          return this._get('duration');
	        }
	      }
	    }, {
	      key: "setStretch",
	      value: function setStretch() {}
	    }, {
	      key: "getMetadata",
	      value: function getMetadata() {}
	    }, {
	      key: "play",
	      value: function play() {
	        if (this.object) {
	          if (this._get) {
	            var ended = this._get('ended');
	
	            if (ended) {
	              this.object.mudu_play();
	              this.seek(0);
	            } else {
	              this.object.mudu_play();
	            }
	          } else {
	            this.triggerFlash('mudu_play');
	          }
	        }
	
	        return Promise.resolve();
	      }
	    }, {
	      key: "pause",
	      value: function pause() {
	        if (this.object) {
	          this.triggerFlash('mudu_pause');
	        }
	
	        return Promise.resolve();
	      }
	    }, {
	      key: "seek",
	      value: function seek(time) {
	        if (this._apiAvailable()) {
	          var prePosition = this._get('currentTime');
	
	          this.object.mudu_setProperty('currentTime', time);
	          this.trigger('seek', {
	            type: 'seek',
	            position: prePosition,
	            offset: time
	          });
	        }
	      }
	    }, {
	      key: "getPlaybackRate",
	      value: function getPlaybackRate() {
	        return 1;
	      }
	    }, {
	      key: "setPlaybackRate",
	      value: function setPlaybackRate() {}
	    }, {
	      key: "_apiAvailable",
	      value: function _apiAvailable() {
	        return this.object && this.object.mudu_getProperty;
	      }
	    }, {
	      key: "_get",
	      value: function _get(prop, defaultValue) {
	        try {
	          return this.object.mudu_getProperty(prop);
	        } catch (err) {
	          if (is('undefined', defaultValue)) {
	            throw err;
	          } else {
	            return defaultValue;
	          }
	        }
	      }
	    }]);
	
	    return Flash;
	  }(Provider);
	
	  Flash.types = ['flv', 'rtmp', 'hls', 'm3u8', 'mp4'];
	
	  Flash.canPlay = function (_ref3) {
	    var type = _ref3.type;
	    return Flash.types.indexOf(type) >= 0;
	  };
	
	  Flash.canPlayMineType = noop;
	
	  Flash.isSupported = function () {
	    return !isMobile();
	  };
	
	  Flash.isPlaybackRateSupported = function () {
	    return false;
	  };
	
	  Flash.isFlash = function (_) {
	    return true;
	  };
	
	  Flash.isHTML5 = function (_) {
	    return false;
	  };
	
	  Flash.version = "5.0.2-15";
	  Flash.defaultOptions = {
	    renderTip: noop
	  };
	  Flash.Error = {
	    NotAllowedError: 'Media element cannot be created, probably flash is not allowed'
	  };
	
	  var HTML5Provider =
	  /*#__PURE__*/
	  function (_Provider) {
	    _inherits(HTML5Provider, _Provider);
	
	    function HTML5Provider(player, option) {
	      var _this;
	
	      _classCallCheck(this, HTML5Provider);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(HTML5Provider).call(this, player, option));
	      _this._onVideoEvents = _this._onVideoEvents.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	      _this._onTextTracksAdd = _this._onTextTracksAdd.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	      _this._onTextTracksChange = _this._onTextTracksChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	      _this._onTextTracksRemove = _this._onTextTracksRemove.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	      _this._onTextTrackCueChange = _this._onTextTrackCueChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	      _this.TAG = 'HTML5Provider';
	      _this.video_error_report = true;
	      return _this;
	    }
	
	    _createClass(HTML5Provider, [{
	      key: "setup",
	      value: function setup(_ref) {
	        var _this2 = this;
	
	        var file = _ref.file,
	            image = _ref.image;
	
	        this._setupEvents();
	
	        this._duration = 0;
	        this.video.src = file; // 给vidoe加上黑色背景，覆盖部分安卓手机加载流时的默认播放按钮背景
	
	        var blackPng = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=';
	        this.video.setAttribute('poster', blackPng); // 用于修复某些移动设备需要seek后才能播放
	
	        this.oncePlayer('play', function () {
	          _this2.oncePlayer('canSeek', function () {
	            var shouldStartSeek = true;
	
	            _this2.oncePlayer('seek', function () {
	              shouldStartSeek = false;
	            });
	
	            _this2.oncePlayer('time', function (_ref2) {
	              var position = _ref2.position;
	
	              if (position !== 0) {
	                shouldStartSeek = false;
	              }
	            });
	
	            setTimeout(function () {
	              var pos = _this2.getPosition();
	
	              if (_this2.TAG === 'HTML5Provider' && shouldStartSeek && pos === 0) {
	                _this2.seek(0.01);
	              }
	            }, 50);
	          });
	        });
	      }
	    }, {
	      key: "getMediaElement",
	      value: function getMediaElement() {
	        var video = this.player.dom.videoWrap.querySelector('video'); // if current video has textTracks then we use another new video, coz video texttracks cannot be removed
	        // if current video has no texttrack, we reuse the video, coz a new video cannot autoplay in some browsers
	
	        if (video) {
	          var tts = video.textTracks;
	
	          if (tts && tts.length) {
	            try {
	              video.parentNode.removeChild(video);
	            } catch (err) {
	              console.error('remove video element error');
	            }
	
	            return null;
	          }
	        }
	
	        this.video = video;
	        return video;
	      }
	    }, {
	      key: "createMediaElement",
	      value: function createMediaElement() {
	        var media = document.createElement('video');
	        var preload = this.player._config.preload;
	        media.setAttribute('class', video);
	        media.setAttribute('preload', preload); // 设置loop会导致IOS息屏
	
	        if (isIOS()) {
	          delete this.player._config.videoAttributes.loop;
	        }
	
	        for (var attr in this.player._config.videoAttributes) {
	          var val = this.player._config.videoAttributes[attr];
	          media.setAttribute(attr, val);
	        }
	
	        this.video = media;
	        return media;
	      }
	    }, {
	      key: "play",
	      value: function play() {
	        if (this.video) {
	          this.video.setAttribute('preload', 'auto'); // if preload:none, some iPhone wechat need call video.play() to play
	
	          try {
	            var promise = this.video.play();
	
	            if (promise) {
	              return promise.catch(function (err) {
	                return console.warn(err);
	              });
	            }
	          } catch (error) {
	            throw new Error('player cannot play');
	          }
	        }
	
	        return Promise.resolve();
	      }
	    }, {
	      key: "pause",
	      value: function pause() {
	        if (this.video) {
	          this.video.pause();
	        }
	
	        return Promise.resolve();
	      }
	    }, {
	      key: "remove",
	      value: function remove() {
	        this._removeEvents();
	
	        if (this.video) {
	          // because video.textTracks cannot be removed
	          // when change hls master playlist, so remove it
	          try {
	            this.video.parentNode.removeChild(this.video);
	          } catch (err) {}
	
	          this.video = null;
	        }
	
	        _get(_getPrototypeOf(HTML5Provider.prototype), "remove", this).call(this);
	      }
	    }, {
	      key: "seek",
	      value: function seek(time) {
	        if (!this.video) {
	          return;
	        }
	
	        var prePosition = this.getPosition();
	        this.video.currentTime = time;
	        this.trigger('seek', {
	          type: 'seek',
	          position: prePosition,
	          offset: time
	        });
	      }
	    }, {
	      key: "getPlaybackRate",
	      value: function getPlaybackRate() {
	        if (this.video) {
	          return this.video.playbackRate;
	        }
	
	        return 1;
	      }
	    }, {
	      key: "setPlaybackRate",
	      value: function setPlaybackRate(playbackRate) {
	        if (this.video) {
	          this.video.playbackRate = playbackRate;
	          this.trigger('playbackrate', {
	            type: 'playbackrate',
	            playbackRate: playbackRate
	          });
	        }
	      }
	    }, {
	      key: "getDuration",
	      value: function getDuration() {
	        return this._duration;
	      }
	    }, {
	      key: "getPosition",
	      value: function getPosition() {
	        if (this.video) {
	          return this.video.currentTime;
	        }
	
	        return 0;
	      }
	    }, {
	      key: "getVolume",
	      value: function getVolume() {
	        if (!this.video) {
	          return 1;
	        }
	
	        if (this.getMute()) {
	          return 0;
	        }
	
	        return this.video.volume;
	      }
	    }, {
	      key: "getWidth",
	      value: function getWidth() {
	        if (!this.video) {
	          return -1;
	        }
	
	        return this.video.videoWidth;
	      }
	    }, {
	      key: "getHeight",
	      value: function getHeight() {
	        if (!this.video) {
	          return -1;
	        }
	
	        return this.video.videoHeight;
	      }
	    }, {
	      key: "setVolume",
	      value: function setVolume(volume) {
	        if (!this.video) {
	          return;
	        }
	
	        var muted = this.video.muted;
	
	        if (is('number', volume)) {
	          if (volume < 0) {
	            volume = 0;
	          }
	
	          if (volume > 1) {
	            volume = 1;
	          }
	
	          this.video.volume = volume;
	          this.trigger('volume', {
	            type: 'volume',
	            volume: volume
	          });
	
	          if (muted && volume > 0) {
	            this.setMute(false);
	          }
	
	          if (!muted && volume === 0) {
	            this.setMute(true);
	          }
	        }
	      }
	    }, {
	      key: "setMute",
	      value: function setMute() {
	        var muted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        if (!this.video) {
	          return;
	        }
	
	        this.video.muted = !!muted;
	        this.trigger('mute', {
	          type: 'mute',
	          mute: !!muted
	        });
	      }
	    }, {
	      key: "getMute",
	      value: function getMute() {
	        if (!this.video) {
	          return false;
	        }
	
	        return this.video.muted;
	      }
	    }, {
	      key: "setStretching",
	      value: function setStretching(stretching) {
	        if (!this.video) return;
	
	        switch (stretching) {
	          case 'none':
	          case 'contain':
	          case 'fill':
	          case 'cover':
	          case 'scale-down':
	            this.video.style.objectFit = stretching;
	            break;
	
	          default:
	            this.video.style.objectFit = 'contain';
	        }
	      }
	    }, {
	      key: "getStretching",
	      value: function getStretching() {
	        return this.video.style.objectFit;
	      }
	    }, {
	      key: "getBuffer",
	      value: function getBuffer() {
	        if (!this.video) {
	          return [];
	        }
	
	        var video = this.video;
	        var buffered = video.buffered;
	        var ret = [];
	
	        for (var i = 0; i < buffered.length; i++) {
	          ret.push({
	            start: buffered.start(i),
	            end: buffered.end(i)
	          });
	        }
	
	        return ret.sort(function (a, b) {
	          var diff = a.start - b.start;
	
	          if (diff) {
	            return diff;
	          } else {
	            return b.end - a.end;
	          }
	        });
	      }
	    }, {
	      key: "getMetrics",
	      value: function getMetrics() {
	        var video = this.video;
	        if (!video) return _get(_getPrototypeOf(HTML5Provider.prototype), "getMetrics", this).call(this);
	        return {
	          videoHeight: video.videoHeight,
	          videoWidth: video.videoWidth,
	          mozParsedFrames: video.mozParsedFrames,
	          mozDecodedFrames: video.mozDecodedFrames,
	          mozPresentedFrames: video.mozPresentedFrames,
	          mozPaintedFrames: video.mozPaintedFrames,
	          mozFrameDelay: video.mozFrameDelay,
	          mozHasAudio: video.mozHasAudio,
	          networkState: video.networkState,
	          msHorizontalMirror: video.msHorizontalMirror,
	          msInsertVideoEffect: video.msInsertVideoEffect,
	          msIsStereo3D: video.msIsStereo3D,
	          webkitAudioDecodedByteCount: video.webkitAudioDecodedByteCount,
	          webkitVideoDecodedByteCount: video.webkitVideoDecodedByteCount,
	          webkitDecodedFrameCount: video.webkitDecodedFrameCount,
	          webkitDroppedFrameCount: video.webkitDroppedFrameCount
	        };
	      }
	    }, {
	      key: "getTextTracks",
	      value: function getTextTracks() {
	        var _this3 = this;
	
	        if (!this.video) return [];
	        var tracks = [].slice.call(this.video.textTracks).map(function (track) {
	          _this3._addCustomTrack(track);
	
	          var ctrack = track.customTrack;
	          return ctrack;
	        });
	        return tracks;
	      }
	    }, {
	      key: "setTextTrackEnable",
	      value: function setTextTrackEnable(index) {
	        var tracks = this.video && this.video.textTracks;
	        var track = tracks && tracks[index];
	        if (!track) return;
	        if (!track.customTrack) this._addCustomTrack(track);
	        track.customTrack.mode = 'hidden'; // track.mode = 'hidden'
	
	        track.mode = 'hidden';
	      }
	    }, {
	      key: "setTextTrackDisable",
	      value: function setTextTrackDisable(index) {
	        var tracks = this.video && this.video.textTracks;
	        var track = tracks && tracks[index];
	        if (!track) return;
	        if (!track.customTrack) this._addCustomTrack(track);
	        track.customTrack.mode = 'disabled';
	        track.mode = 'disabled';
	      }
	    }, {
	      key: "getTextTrackCues",
	      value: function getTextTrackCues(index) {
	        var _this4 = this;
	
	        var tracks = this.video && this.video.textTracks;
	        var track = tracks && tracks[index];
	        if (!track) return;
	        var cues = [].slice.call(track.cues || []).map(function (v) {
	          _this4._addCustomCue(v);
	
	          return v.customCue;
	        });
	        return cues;
	      }
	    }, {
	      key: "getTextTrackActiveCues",
	      value: function getTextTrackActiveCues(index) {
	        var _this5 = this;
	
	        var tracks = this.video && this.video.textTracks;
	        var track = tracks && tracks[index];
	        if (!track) return;
	        var cues = [].slice.call(track.activeCues || []).map(function (v) {
	          _this5._addCustomCue(v);
	
	          return v.customCue;
	        });
	        return cues;
	      }
	    }, {
	      key: "_setupEvents",
	      value: function _setupEvents() {
	        var _this6 = this;
	
	        HTML5Provider.mediaEvents.forEach(function (name) {
	          addEventListener(_this6.video, name, _this6._onVideoEvents);
	        });
	
	        if (this.video.textTracks) {
	          addEventListener(this.video.textTracks, 'change', this._onTextTracksChange);
	          addEventListener(this.video.textTracks, 'addtrack', this._onTextTracksAdd);
	          addEventListener(this.video.textTracks, 'removetrack', this._onTextTracksRemove);
	        }
	      }
	    }, {
	      key: "_removeEvents",
	      value: function _removeEvents() {
	        var _this7 = this;
	
	        if (this.video) {
	          HTML5Provider.mediaEvents.forEach(function (name) {
	            removeEventListener(_this7.video, name, _this7._onVideoEvents);
	          });
	
	          for (var i = 0; i < this.video.textTracks.length; i++) {
	            removeEventListener(this.video.textTracks[i], 'cuechange', this._onTextTrackCueChange);
	          }
	
	          removeEventListener(this.video.textTracks, 'change', this._onTextTracksChange);
	          removeEventListener(this.video.textTracks, 'addtrack', this._onTextTracksAdd);
	          removeEventListener(this.video.textTracks, 'removetrack', this._onTextTracksRemove);
	        }
	      }
	    }, {
	      key: "_onTextTracksChange",
	      value: function _onTextTracksChange() {
	        if (!this.video) return;
	        this.trigger(PROVIDER_TEXTTRACKCHANGE, this.getTextTracks());
	      }
	    }, {
	      key: "_onTextTracksAdd",
	      value: function _onTextTracksAdd(event) {
	        if (!this.video) return; // 当track添加到textTracks中
	
	        var track = event.track;
	
	        this._addCustomTrack(track);
	
	        this.trigger(PROVIDER_TEXTTRACKADD, track.customTrack);
	        addEventListener(track, 'cuechange', this._onTextTrackCueChange);
	      }
	    }, {
	      key: "_onTextTracksRemove",
	      value: function _onTextTracksRemove(event) {// no method to remove a text track, so just not handle it
	      }
	    }, {
	      key: "_onTextTrackCueChange",
	      value: function _onTextTrackCueChange(event) {
	        if (!this.video) return;
	        var track = event.target;
	
	        var trackIndex = this._getIndexByTrack(track);
	
	        this.trigger(PROVIDER_CUECHANGE, {
	          cues: this.getTextTrackCues(trackIndex),
	          activeCues: this.getTextTrackActiveCues(trackIndex),
	          track: track.customTrack
	        });
	      }
	    }, {
	      key: "_getIndexByTrack",
	      value: function _getIndexByTrack(track) {
	        var tracks = this.video.textTracks;
	        var len = tracks.length;
	
	        for (var i = 0; i < len; i++) {
	          if (tracks[i] === track) return i;
	        }
	
	        return -1;
	      }
	    }, {
	      key: "_addCustomTrack",
	      value: function _addCustomTrack(track) {
	        track.customTrack = track.customTrack || {};
	        var ct = track.customTrack;
	        ct.id = track.id;
	        ct.kind = track.kind;
	        ct.label = track.label;
	        ct.language = track.language;
	        ct.mode = track.mode;
	      }
	    }, {
	      key: "_addCustomCue",
	      value: function _addCustomCue(cue) {
	        cue.customCue = cue.customCue || {};
	        var cu = cue.customCue;
	        cu.startTime = cue.startTime;
	        cu.endTime = cue.endTime;
	        cu.text = cue.text;
	      }
	    }, {
	      key: "_onVideoEvents",
	      value: function _onVideoEvents(event) {
	        var type = event.type;
	
	        switch (type) {
	          case 'error':
	            var error = this.video.error || {};
	            var message = error.message;
	            var code = error.code;
	            var networkState = this.video.networkState;
	
	            if (code === 3) {
	              // 解码错误，微信x5下直播会出现解码错误
	              if (this.TAG === 'HTML5Provider' && isX5Layer()) {
	                console.log('x5 layer error');
	                this.play();
	                return;
	              }
	            }
	
	            if (!message && networkState === 3) {
	              message = 'networkError';
	            }
	
	            this.video_error_report && this.trigger('error', {
	              message: message,
	              code: code,
	              networkState: networkState,
	              fatal: code > 1
	            });
	            break;
	
	          case 'playing':
	            this.trigger('play', event);
	            this.trigger(type, event);
	            break;
	
	          case 'durationchange':
	            if (this.video.duration !== 1) {
	              this._duration = this.video.duration;
	              this.trigger('duration');
	            }
	
	            this.trigger(type, event);
	            break;
	
	          default:
	            this.trigger(type, event);
	        }
	      }
	    }]);
	
	    return HTML5Provider;
	  }(Provider);
	
	  HTML5Provider.mediaEvents = ['abort', 'canplay', 'canplaythrough', 'durationchange', 'emptied', 'ended', 'error', 'loadeddata', 'loadedmetadata', 'loadstart', 'mozaudioavailable', 'pause', 'play', 'playing', 'progress', 'ratechange', 'seeked', 'seeking', 'stalled', 'suspend', 'timeupdate', 'volumechange', 'waiting'];
	
	  HTML5Provider.canPlay = function (_ref3) {
	    var mimeType = _ref3.mimeType;
	    var video = document.createElement('video');
	    return video.canPlayType(mimeType);
	  };
	
	  HTML5Provider.isSupported = function () {
	    return !isIE() || isIE() && browserVersion$1.major > 8;
	  };
	
	  HTML5Provider.isPlaybackRateSupported = function () {
	    return true;
	  };
	
	  HTML5Provider.isHTML5 = function (_) {
	    return true;
	  };
	
	  HTML5Provider.isFlash = function (_) {
	    return false;
	  };
	
	  HTML5Provider.version = "0.39.10";
	
	  var TcPlayerLite =
	  /*#__PURE__*/
	  function (_HTML5Provider) {
	    _inherits(TcPlayerLite, _HTML5Provider);
	
	    function TcPlayerLite(player, option) {
	      var _this;
	
	      _classCallCheck(this, TcPlayerLite);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(TcPlayerLite).call(this, player, option));
	      _this.player = player;
	      _this._onVideoEvents = _this._onVideoEvents.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	      _this.TAG = 'TcPlayerLiteProvider';
	      _this.video_error_report = true;
	      return _this;
	    }
	
	    _createClass(TcPlayerLite, [{
	      key: "loadFiles",
	      value: function loadFiles() {
	        var loader = new ScriptLoader(this.player._config.fileCdnPath + '/tc-player-lite.js');
	        return loader.load();
	      }
	    }, {
	      key: "setup",
	      value: function setup(data) {
	        var _this2 = this;
	
	        this._setupEvents();
	
	        this.onPlayer(INTERNAL_PROVIDER_INITED, function () {
	          if (!_this2.video) return;
	
	          if (isMobile() && isIOS()) {
	            _this2.onDom(_this2.video, 'webkitendfullscreen', function () {
	              _this2.tcPlayer && _this2.tcPlayer.pause();
	            });
	          }
	
	          _this2.onDom(_this2.video, 'pause', function () {
	            _this2.tcPlayer && _this2.tcPlayer.pause();
	          });
	        });
	        var config = this.player._config;
	        this.tcPlayer = new window.TcPlayer(this.player._container.id, {
	          webrtc: data.file,
	          autoplay: config.autoplay,
	          listener: function listener(obj) {
	            if (!_this2.video.srcObject && (obj.type === 'loadedmetadata' || obj.type === 'webrtcstatupdate')) {
	              // ios的微信上没有触发loadedmetadata  只能webrtcstatupdate来监听了
	              _this2.video.srcObject = obj.src.el.srcObject;
	              obj.src.owner.style.display = 'none';
	
	              _this2.play();
	            } // 其他trtc ERROR目前看来都是属于真正的ERROR 会导致播放器crash,走我们的error流程
	
	
	            if (obj.type === 'error') {
	              // 自动播放失败在 TRTC 看来是error ,在我们看来不是个问题,不能走我们的error,通过普通事件抛出
	              if (obj.detail.code === 2005) {
	                _this2.player.trigger(OUTER_TRTC_AUTOPLAY_FAIL, {
	                  message: obj.detail.reason,
	                  data: obj.detail
	                });
	              } else {
	                _this2.trigger(OUTER_ERROR, {
	                  message: obj.detail.reason,
	                  data: obj.detail,
	                  fatal: false
	                });
	              }
	            }
	          }
	        });
	      }
	    }, {
	      key: "getMediaElement",
	      value: function getMediaElement() {
	        return false;
	      }
	    }, {
	      key: "play",
	      value: function play() {
	        if (this.tcPlayer) {
	          this.video.setAttribute('preload', 'auto');
	
	          try {
	            this.tcPlayer.play();
	            var promise = this.video.play();
	
	            if (promise) {
	              return promise.catch(function (err) {
	                return console.warn(err);
	              });
	            }
	          } catch (error) {
	            throw new Error('player cannot play');
	          }
	        }
	
	        return Promise.resolve();
	      }
	    }, {
	      key: "pause",
	      value: function pause() {
	        if (this.tcPlayer) {
	          this.tcPlayer.pause();
	          this.video.pause();
	        }
	
	        return Promise.resolve();
	      }
	    }, {
	      key: "setVolume",
	      value: function setVolume(volume) {
	        if (!this.video) {
	          return;
	        }
	
	        var muted = this.video.muted;
	
	        if (is('number', volume)) {
	          if (volume < 0) {
	            volume = 0;
	          }
	
	          if (volume > 1) {
	            volume = 1;
	          }
	
	          this.video.volume = volume;
	          this.tcPlayer.volume(volume);
	          this.trigger('volume', {
	            type: 'volume',
	            volume: volume
	          });
	
	          if (muted && volume > 0) {
	            this.setMute(false);
	          }
	
	          if (!muted && volume === 0) {
	            this.setMute(true);
	          }
	        }
	      }
	    }, {
	      key: "setMute",
	      value: function setMute() {
	        var muted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        if (!this.video) {
	          return;
	        }
	
	        this.video.muted = !!muted;
	        this.tcPlayer.mute(!!muted);
	        this.trigger('mute', {
	          type: 'mute',
	          mute: !!muted
	        });
	      }
	    }, {
	      key: "getMute",
	      value: function getMute() {
	        if (!this.video) {
	          return false;
	        }
	
	        return this.video.muted;
	      }
	    }, {
	      key: "remove",
	      value: function remove() {
	        _get(_getPrototypeOf(TcPlayerLite.prototype), "remove", this).call(this);
	
	        if (this.tcPlayer) {
	          this.tcPlayer.destroy();
	        }
	      }
	    }]);
	
	    return TcPlayerLite;
	  }(HTML5Provider);
	
	  TcPlayerLite.type = ['webrtc'];
	
	  TcPlayerLite.canPlay = function (_ref) {
	    var type = _ref.type;
	    return TcPlayerLite.type.indexOf(type) > -1;
	  };
	
	  TcPlayerLite.isSupported = function () {
	    return window.RTCPeerConnection || window.webkitRTCPeerConnection || window.mozRTCPeerConnection;
	  };
	
	  TcPlayerLite.isFlash = function (_) {
	    return false;
	  };
	
	  TcPlayerLite.isHTML5 = function (_) {
	    return true;
	  };
	
	  function initProvider() {
	    var _this = this;
	
	    try {
	      destroyProvider.call(this);
	    } catch (err) {
	      console.error('destroy provider', err);
	    } // removeMediaDom.call(this)
	
	
	    console.log('initProvider');
	
	    var _getActive$call = getActive.call(this),
	        file = _getActive$call.file,
	        type = _getActive$call.type,
	        mineType = _getActive$call.mineType,
	        isLive = _getActive$call.isLive,
	        absoluteFile = _getActive$call.absoluteFile,
	        image = _getActive$call.image,
	        alwaysDisplayImage = _getActive$call.alwaysDisplayImage,
	        isTimeShift = _getActive$call.isTimeShift,
	        reloadAfterPausing = _getActive$call.reloadAfterPausing,
	        reloadAfterPausingTime = _getActive$call.reloadAfterPausingTime,
	        isHideProgress = _getActive$call.isHideProgress;
	
	    var convertedType = type;
	    var convertedUrl = file;
	    var convertedMineType = mineType; // 当不支持 trtc 时当前是劫持VIDEO的浏览器，如果设置了允许自动降级，则自动切换成 m3u8 流
	
	    if (type === 'webrtc' && this._config.trtcFallback) {
	      if (!TcPlayerLite.isSupported() || isUC() && isAndroid() || isMQQBrowser() && isAndroid()) {
	        convertedType = 'm3u8';
	        convertedUrl = covertWebrtcUrlToM3u8(file);
	        convertedMineType = getMinetype('m3u8');
	        this.trigger(OUTER_TRTC_FALLBACK, {
	          from: {
	            type: 'webrtc',
	            url: file
	          },
	          to: {
	            type: 'm3u8',
	            url: convertedUrl
	          },
	          mineType: getMinetype('m3u8')
	        });
	      }
	    }
	
	    var provider = chooseProvider({
	      type: convertedType,
	      mineType: convertedMineType,
	      url: convertedUrl,
	      isLive: isLive,
	      isTimeShift: isTimeShift
	    }, this._config.providerOrder);
	    console.log(convertedType);
	    console.log(convertedUrl);
	    console.log(convertedMineType);
	
	    if (!provider) {
	      var err = 'File type not supported';
	      this.trigger(OUTER_ERROR, {
	        message: err,
	        fatal: true,
	        errorId: genErrorId()
	      });
	      return Promise.reject(new TypeError(err));
	    }
	
	    var instance = new provider.Provider(this, this._config.provider[provider.name]);
	    this._provider = _objectSpread({}, provider, {
	      instance: instance
	    });
	    var self = this;
	    return instance.loadFiles().then(function appendMediaElement() {
	      if (instance.removed) {
	        return;
	      }
	
	      var prevMediaElement = instance.getMediaElement();
	
	      if (!prevMediaElement) {
	        var mediaElement = instance.createMediaElement();
	
	        if (!mediaElement) {
	          throw new Error(Flash.Error.NotAllowedError);
	        }
	
	        self.dom.videoWrap.insertBefore(mediaElement, self.dom.background);
	      }
	    }).then(function setupProvider() {
	      if (instance.removed) {
	        return;
	      }
	
	      console.log('instance setup');
	      return instance.setup({
	        isLive: isLive,
	        file: convertedUrl,
	        image: image,
	        absoluteFile: absoluteFile,
	        type: convertedType,
	        mineType: mineType
	      });
	    }).then(function () {
	      console.log('provider setup 成功  ');
	
	      _this.trigger(INTERNAL_PROVIDER_INITED, {
	        isLive: isLive,
	        file: file,
	        absoluteFile: absoluteFile,
	        type: type,
	        mineType: mineType,
	        image: image,
	        alwaysDisplayImage: alwaysDisplayImage,
	        isTimeShift: isTimeShift,
	        reloadAfterPausing: reloadAfterPausing,
	        reloadAfterPausingTime: reloadAfterPausingTime,
	        isHideProgress: isHideProgress
	      });
	    }).catch(function (err) {
	      console.error('provider setup 错误', err);
	
	      _this.trigger(OUTER_ERROR, {
	        error: err,
	        message: err.message,
	        column: err.columnNumber,
	        fileName: err.fileName,
	        lineNumber: err.lineNumber,
	        name: err.name,
	        stack: err.stack,
	        errorId: genErrorId()
	      });
	
	      throw err;
	    });
	  }
	  function destroyProvider() {
	    console.log('destroyProvider');
	    var instance = this._provider && this._provider.instance;
	
	    if (instance) {
	      this._provider = null;
	      instance.remove();
	      this.trigger(INTERNAL_PROVIDER_REMOVED);
	    }
	  }
	  /**
	   * 增加额外的provider：非视频流播放方式Provider。(目前只有使用vrProvider时使用这种方式)
	   * @param {string} providerName 已注册的provider name
	   */
	
	  function initExtraProvider() {
	    var _this2 = this;
	
	    try {
	      destroyExtraProvider.call(this);
	    } catch (err) {
	      console.error('destroy extra provider', err);
	    } // removeMediaDom.call(this)
	
	
	    console.log('add extra provider');
	
	    var _getActive$call2 = getActive.call(this),
	        file = _getActive$call2.file,
	        type = _getActive$call2.type,
	        mineType = _getActive$call2.mineType,
	        isLive = _getActive$call2.isLive,
	        absoluteFile = _getActive$call2.absoluteFile,
	        image = _getActive$call2.image,
	        isTimeShift = _getActive$call2.isTimeShift;
	
	    var supportedProviders = selectExtraProviders({
	      type: type,
	      mineType: mineType,
	      url: file,
	      isLive: isLive,
	      isTimeShift: isTimeShift
	    }, this._config);
	    Promise.all(supportedProviders.map(function (provider) {
	      if (!provider) {
	        var err = "".concat(provider.name, " cannot support file type");
	
	        _this2.trigger(OUTER_ERROR, {
	          message: err,
	          fatal: true,
	          errorId: genErrorId()
	        });
	
	        Promise.reject(new TypeError(err));
	      }
	
	      if (!_this2._config.extraProvider[provider.name].use) {
	        return;
	      }
	
	      var instance = new provider.Provider(_this2, _this2._config.extraProvider[provider.name]);
	      _this2._extraProviders[provider.name] = _objectSpread({}, provider, {
	        instance: instance
	      });
	      var self = _this2;
	      return instance.loadFiles().then(function appendMediaElement() {
	        var prevMediaElement = instance.getMediaElement();
	
	        if (!prevMediaElement) {
	          var mediaElement = instance.createMediaElement();
	
	          if (!mediaElement) {
	            throw new Error(Flash.Error.NotAllowedError);
	          }
	
	          self.dom.videoWrap.insertBefore(mediaElement, self.dom.background);
	        }
	      }).then(function setupProvider() {
	        console.log('instance setup');
	        return instance.setup({
	          isLive: isLive,
	          file: file,
	          image: image,
	          absoluteFile: absoluteFile,
	          type: type,
	          mineType: mineType
	        });
	      }).then(function () {
	        console.log('extra provider setup 成功  ');
	      }).catch(function (err) {
	        console.error('extra provider setup 错误', err);
	
	        _this2.trigger(OUTER_ERROR, {
	          error: err,
	          message: err.message,
	          column: err.columnNumber,
	          fileName: err.fileName,
	          lineNumber: err.lineNumber,
	          name: err.name,
	          stack: err.stack,
	          errorId: genErrorId()
	        });
	
	        throw err;
	      });
	    }));
	  }
	  function destroyExtraProvider() {
	    var _this3 = this;
	
	    console.log('destroyExtraProvider');
	    var extraProvidersArr = [];
	
	    for (var key in this._extraProviders) {
	      if (Object.prototype.hasOwnProperty.call(this._extraProviders, key)) {
	        extraProvidersArr.push(this._extraProviders[key]);
	      }
	    }
	
	    if (extraProvidersArr.length > 0) {
	      extraProvidersArr.forEach(function (provider, index) {
	        if (provider.instance) {
	          provider.instance.remove();
	          provider.removed = true;
	          delete _this3._extraProviders[provider.name];
	        }
	      });
	    }
	  }
	
	  var Video =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(Video, _Model);
	
	    function Video(player) {
	      var _this;
	
	      _classCallCheck(this, Video);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Video).call(this, player));
	      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('play').method('pause').method('toggle').method('getState').method('getPlaybackRate').method('setPlaybackRate');
	
	      _this.subEvents();
	
	      _this.setPlayBtnIcon(play);
	
	      _this.initPlayButton();
	
	      _this._lastPausedTimeStamp = 0;
	      return _this;
	    }
	
	    _createClass(Video, [{
	      key: "changeStateClass",
	      value: function changeStateClass() {
	        var state = this.getState();
	        classList(this.player.dom.container).remove(stateReg);
	        classList(this.player.dom.container).add("mudu-state-".concat(state));
	      }
	    }, {
	      key: "subEvents",
	      value: function subEvents() {
	        var _this2 = this;
	
	        this.onPlayer(INTERNAL_PROVIDER_INITED, function () {
	          _this2.subProvider();
	
	          classList(_this2.player.dom.container).add(stateIdle);
	        });
	        this.onPlayer(INTERNAL_PROVIDER_INIT, function () {
	          classList(_this2.player.dom.container).remove(stateReg);
	        });
	        this.onPlayer(INTERNAL_PROVIDER_REMOVED, function () {
	          _this2.player.timer.loading.stop();
	
	          classList(_this2.player.dom.container).remove(stateReg);
	          classList(_this2.player.dom.container).remove(providerReg);
	
	          _this2._triggerStateEvt(OUTER_IDLE, 'idle');
	
	          _this2.setPlayBtnIcon(play);
	
	          _this2.changeStateClass();
	        });
	        this.onPlayer('internal_buffer', function (status) {
	          if (status) {
	            if (_this2._isErrorState()) {
	              return;
	            }
	
	            _this2._triggerStateEvt('buffer', 'buffering');
	
	            _this2.changeStateClass();
	          } else {
	            // TODO: 检查video状态, 处理idle, pause, playing
	            _this2._triggerStateEvt('play', 'playing');
	
	            _this2.changeStateClass();
	          }
	        });
	        this.onPlayer(INTERNAL_KEY_DOWN, this._onInternalKeyDown.bind(this));
	      }
	    }, {
	      key: "subProvider",
	      value: function subProvider() {
	        var _this3 = this;
	
	        this.onProvider(PROVIDER_PLAY, function () {
	          _this3.player.timer.loading.start();
	
	          var prevState = _this3.getState();
	
	          if (_this3.getState() === 'playing') return;
	
	          _this3._triggerStateEvt(OUTER_PLAY, 'playing');
	
	          _this3.setPlayBtnIcon(pause);
	
	          prevState !== 'buffering' && prevState !== 'playing' && _this3.player.model.bezel.switch(play);
	
	          _this3.changeStateClass();
	        });
	        this.onProvider(PROVIDER_PAUSE, function () {
	          _this3._lastPausedTimeStamp = Date.now();
	
	          _this3.player.timer.loading.stop();
	
	          _this3._triggerStateEvt(PROVIDER_PAUSE, 'paused');
	
	          _this3.setPlayBtnIcon(play);
	
	          _this3.player.model.bezel.switch(pause);
	
	          !_this3._isErrorState() && _this3.changeStateClass();
	        });
	        this.onProvider(PROVIDER_ENDED, function () {
	          _this3.player.timer.loading.stop();
	
	          _this3._triggerStateEvt(OUTER_IDLE);
	
	          _this3.changeStateClass();
	        });
	        this.onProvider(PROVIDER_SEEKED, function () {
	          _this3.player.trigger(OUTER_SEEKED);
	        });
	        this.onProvider(PROVIDER_SEEK, function (data) {
	          _this3.player.trigger(OUTER_SEEK, data);
	        });
	        this.onProvider(PROVIDER_STAGE_CLICK, function () {
	          var tooltipVisible = tooltip.isAnyClassShow('mudu-popup');
	
	          if (tooltipVisible) {
	            tooltip.hideAll();
	          } else {
	            _this3.player.getControls() && _this3.player.toggle();
	          }
	        });
	      }
	    }, {
	      key: "_triggerStateEvt",
	      value: function _triggerStateEvt(type, newState) {
	        newState = newState || type;
	        var oldState = this.player._status.state;
	        this.player._status.state = newState;
	        this.player.trigger(type, {
	          type: type,
	          oldState: oldState,
	          newState: newState
	        });
	      }
	    }, {
	      key: "_isErrorState",
	      value: function _isErrorState() {
	        return classList(this.player.dom.container).contains(stateError);
	      }
	    }, {
	      key: "initPlayButton",
	      value: function initPlayButton() {
	        var _this4 = this;
	
	        this.onDom(this.player.dom.leftPlayBtn, 'click', function () {
	          _this4.player.toggle();
	        });
	        this.onDom(this.player.dom.bigPlayBtn, 'click', function () {
	          _this4.player.toggle();
	        });
	
	        if (!isMobile()) {
	          this.onDom(this.player.dom.videoWrap, 'click', function (e) {
	            if (_this4.player._provider && _this4.player._provider.flash) {
	              return;
	            }
	
	            var tooltipVisible = tooltip.isAnyClassShow('mudu-popup');
	            !tooltipVisible && _this4.player.getControls() && _this4.player.toggle();
	          });
	        }
	      }
	    }, {
	      key: "setPlayBtnIcon",
	      value: function setPlayBtnIcon(icon) {
	        var ele = this.player.dom.leftPlayBtn;
	        classList(ele).remove(iconReg);
	        classList(ele).add(icon);
	      }
	    }, {
	      key: "toggle",
	      value: function toggle() {
	        console.log(getActive.call(this.player));
	        var state = this.player._status.state;
	
	        if (state === 'paused' || state === 'idle') {
	          return this.play();
	        } else {
	          return this.pause();
	        }
	      }
	    }, {
	      key: "play",
	      value: function play() {
	        var _this5 = this;
	
	        var state = this.player._status.state;
	        var activeSource = getActive.call(this.player);
	        var reloadAfterPausing = activeSource.reloadAfterPausing,
	            reloadAfterPausingTime = activeSource.reloadAfterPausingTime;
	
	        if (reloadAfterPausing && this._lastPausedTimeStamp && state === 'paused') {
	          var now = Date.now();
	          reloadAfterPausingTime = is('undefined', reloadAfterPausingTime) ? 3000 : reloadAfterPausingTime;
	          var shouldReplay = now - this._lastPausedTimeStamp > reloadAfterPausingTime;
	
	          if (shouldReplay) {
	            this.player.replay();
	            return;
	          }
	        }
	
	        if (this.provider()) {
	          this.player.trigger(OUTER_BEFORE_PLAY, {
	            type: OUTER_BEFORE_PLAY
	          });
	          return this.provider().play();
	        } else {
	          return initProvider.call(this.player).then(function () {
	            initExtraProvider.call(_this5.player);
	
	            try {
	              _this5.play();
	            } catch (err) {
	              console.warn(err);
	            }
	          });
	        }
	      }
	    }, {
	      key: "pause",
	      value: function pause() {
	        if (this.provider()) {
	          return this.provider().pause();
	        }
	
	        return Promise.resolve();
	      }
	    }, {
	      key: "getPlaybackRate",
	      value: function getPlaybackRate() {
	        if (this.provider()) {
	          return this.provider().getPlaybackRate();
	        }
	
	        return 1;
	      }
	    }, {
	      key: "setPlaybackRate",
	      value: function setPlaybackRate(rate) {
	        if (this.provider()) {
	          return this.provider().setPlaybackRate(rate);
	        }
	      }
	    }, {
	      key: "getState",
	      value: function getState() {
	        return this.player._status.state;
	      }
	    }, {
	      key: "_onInternalKeyDown",
	      value: function _onInternalKeyDown(keyCode) {
	        var isLive = classList(this.player.dom.container).contains(live);
	        var isHideProgress = classList(this.player.dom.container).contains(hideProgress);
	        if (isLive || isHideProgress) return;
	        keyCode === 32 && this.toggle();
	      }
	    }]);
	
	    return Video;
	  }(Model);
	
	  var dom = {
	    nameMap: {
	      dragStart: isMobile() ? 'touchstart' : 'mousedown',
	      dragMove: isMobile() ? 'touchmove' : 'mousemove',
	      dragEnd: isMobile() ? 'touchend' : 'mouseup'
	    }
	  };
	
	  var Progress =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(Progress, _Model);
	
	    function Progress(player) {
	      var _this;
	
	      _classCallCheck(this, Progress);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Progress).call(this, player));
	      _this.player.dom.ptime.innerHTML = '00:00';
	      _this.prevDragX = null;
	      _this._latest10tsLength = [];
	      _this._lastDuration = 0;
	
	      _this.onPlayer(INTERNAL_PROVIDER_INITED, _this._onProviderInited.bind(_assertThisInitialized(_assertThisInitialized(_this))));
	
	      _this.onPlayer(INTERNAL_PROVIDER_REMOVED, _this._onProviderRemoved.bind(_assertThisInitialized(_assertThisInitialized(_this))));
	
	      _this.onPlayer(INTERNAL_KEY_DOWN, _this._onInternalKeyDown.bind(_assertThisInitialized(_assertThisInitialized(_this))));
	
	      _this.initPlayedBar();
	
	      _this.initTimeShiftSeek(); // this.liveBadgeTip = tooltip(player.dom.liveBadge, {
	      //   content: getTooltipString(this.lang['Skip ahead to live broadcast']),
	      //   container: this.player.dom.container
	      // })
	      // 产品说这个提示暂时不需要 先注释
	
	
	      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('seek').method('getPosition').method('getDuration').method('getBuffer').method('setProgressVisible').method('getProgressVisible');
	      return _this;
	    }
	
	    _createClass(Progress, [{
	      key: "setBarWidth",
	      value: function setBarWidth(percentage) {
	        this.player.dom.playedBar.style.width = cssLength(percentage);
	      }
	    }, {
	      key: "getBarWidth",
	      value: function getBarWidth() {
	        return parseFloat(this.player.dom.playedBar.style.width) / 100;
	      }
	    }, {
	      key: "getDuration",
	      value: function getDuration() {
	        if (!this.provider()) {
	          return 1;
	        }
	
	        return this.provider().getDuration();
	      }
	    }, {
	      key: "getPosition",
	      value: function getPosition() {
	        if (!this.provider()) {
	          return 0;
	        }
	
	        return this.provider().getPosition();
	      }
	    }, {
	      key: "getBufferPercentage",
	      value: function getBufferPercentage() {
	        if (!this.provider()) {
	          return 0;
	        }
	
	        var buffer = this.getBuffer();
	        var last = buffer.pop();
	        var lastEnd = last && last.end || 0;
	        var dura = this.getDuration();
	        var per = lastEnd / dura || 0;
	        return per;
	      }
	    }, {
	      key: "getBuffer",
	      value: function getBuffer() {
	        if (!this.provider()) return [];
	        return this.provider().getBuffer();
	      }
	    }, {
	      key: "seek",
	      value: function seek(time) {
	        if (!this.provider()) {
	          return;
	        }
	
	        this.provider().seek(time);
	        var duration = this.getDuration();
	        time = Math.max(time, 0);
	
	        if (duration) {
	          time = Math.min(time, duration);
	        }
	
	        this.setBarWidth(this.getPlayedBarPercentage(time));
	        this.player.dom.ptime.innerHTML = secondToTime(time);
	      }
	    }, {
	      key: "computeDragDirec",
	      value: function computeDragDirec(offset) {
	        if (this.prevDragX === null) {
	          this.prevDragX = offset;
	          return '';
	        }
	
	        var direc = offset > this.prevDragX ? 'right' : 'left';
	        this.prevDragX = offset;
	        return direc;
	      }
	    }, {
	      key: "initPlayedBar",
	      value: function initPlayedBar() {
	        var _this2 = this;
	
	        var thumbMove = function thumbMove(e) {
	          if (!_this2.getProgressVisible()) return;
	          classList(_this2.player.dom.container).add(flagDragging);
	          var offsetPx = (e.clientX || e.changedTouches[0].clientX) - getElementViewLeft(_this2.player.dom.playedBarWrap);
	
	          _this2.player.model.progressPopup.dragMove(offsetPx, _this2.computeDragDirec(offsetPx));
	
	          _this2.player.model.progressPopup.show();
	
	          var percentage = offsetPx / _this2.player.dom.playedBarWrap.clientWidth;
	          percentage = Math.max(percentage, 0);
	          percentage = Math.min(percentage, 1);
	
	          _this2.setBarWidth(percentage);
	
	          _this2.player.dom.ptime.innerHTML = secondToTime(percentage * _this2.getDuration());
	        };
	
	        var thumbUp = function thumbUp(e) {
	          _this2.prevDragX = null;
	
	          _this2.player.model.progressPopup.hide();
	
	          _this2.player.model.progressPopup.dragEnd();
	
	          _this2.player._status.dragging = false;
	
	          _this2.player.model.controls.setAutoHide();
	
	          removeEventListener(document, dom.nameMap.dragEnd, thumbUp);
	          removeEventListener(document, dom.nameMap.dragMove, thumbMove);
	
	          if (_this2.getProgressVisible()) {
	            var percentage = ((e.clientX || e.changedTouches[0].clientX) - getElementViewLeft(_this2.player.dom.playedBarWrap)) / _this2.player.dom.playedBarWrap.clientWidth;
	
	            percentage = Math.max(percentage, 0);
	            percentage = Math.min(percentage, 1);
	
	            _this2.setBarWidth(percentage);
	
	            _this2.seekByPercentage(percentage);
	          }
	        };
	
	        addEventListener(this.player.dom.playedBarWrap, dom.nameMap.dragStart, function () {
	          _this2.player._status.dragging = true;
	          addEventListener(document, dom.nameMap.dragMove, thumbMove);
	          addEventListener(document, dom.nameMap.dragEnd, thumbUp);
	        });
	      }
	    }, {
	      key: "initTimeShiftSeek",
	      value: function initTimeShiftSeek() {
	        var _this3 = this;
	
	        var badge = this.player.dom.liveBadge;
	        badge.addEventListener('click', function () {
	          _this3.seekTimeShiftLive();
	        });
	      }
	    }, {
	      key: "_onProviderInited",
	      value: function _onProviderInited(opts) {
	        var isLive = opts.isLive,
	            isTimeShift = opts.isTimeShift,
	            isHideProgress = opts.isHideProgress;
	        this.onProvider(PROVIDER_BUFFER_CHANGE, this._onBufferChange.bind(this));
	        this.onProvider(PROVIDER_DURATION, this._onDuration.bind(this));
	        this.onProvider(PROVIDER_TIME_UPDATE, this._onTimeUpdate.bind(this));
	        this.onProvider(PROVIDER_TIME_UPDATE, this._onBufferChange.bind(this)); // flash not trigger buffer change , so use timeupdate event to update buffer bar width
	
	        this.onceProvider(PROVIDER_LOADEDDATA, this._onLoadedData.bind(this));
	        classList(this.player.dom.container).add(hideTime);
	
	        if (isLive) {
	          classList(this.player.dom.container).add(live);
	          classList(this.player.dom.container).remove(playback);
	        } else {
	          classList(this.player.dom.container).remove(live);
	          classList(this.player.dom.container).add(playback);
	        }
	
	        if (isTimeShift) {
	          classList(this.player.dom.container).add(timeShift);
	        } else {
	          classList(this.player.dom.container).remove(timeShift);
	          classList(this.player.dom.container).remove(timeShiftLive);
	        }
	
	        this.setProgressVisible(!isHideProgress);
	        this._latest10tsLength = [];
	      }
	    }, {
	      key: "_onProviderRemoved",
	      value: function _onProviderRemoved() {
	        classList(this.player.dom.container).add(hideTime);
	      }
	    }, {
	      key: "_onBufferChange",
	      value: function _onBufferChange() {
	        var loadedBar = this.player.dom.loadedBar; // const percentage = this.getBufferPercentage()
	
	        var time = this.getBufferPercentage() * this.getDuration();
	        var percentage = this.getPlayedBarPercentage(time);
	        loadedBar.style.width = cssLength(percentage);
	      }
	    }, {
	      key: "_onDuration",
	      value: function _onDuration() {
	        var dtime = this.player.dom.dtime;
	        var duration = this.getDuration() || 0; // 设置duration显示
	
	        if (isCommonNumber(duration) && duration > 0) {
	          dtime.innerHTML = secondToTime(duration);
	          this.player.trigger(OUTER_DURATION, {
	            type: OUTER_DURATION,
	            duration: duration
	          });
	          classList(this.player.dom.container).remove(hideTime);
	          classList(this.player.dom.container).add(durationValid);
	        } // 时移时记录ts时间
	
	
	        var minTsDuration = 1; // 当duration变化小于1时，不判断为ts时间变化
	
	        var durationChangeLength = duration - this._lastDuration;
	
	        if (this._lastDuration !== 0) {
	          if (durationChangeLength >= minTsDuration) {
	            var latest10tsLength = this._latest10tsLength;
	            latest10tsLength.unshift(durationChangeLength);
	
	            if (latest10tsLength.length > 10) {
	              latest10tsLength.pop();
	            }
	          }
	        }
	
	        this._lastDuration = duration;
	
	        this._updateTimeShiftLiveBadge();
	      }
	    }, {
	      key: "_onTimeUpdate",
	      value: function _onTimeUpdate() {
	        var ptime = this.player.dom.ptime;
	        var position = this.getPosition(); // const percentage = position / (this.getDuration() || Infinity)
	
	        if (!this.player._status.dragging) {
	          // playedBar.style.width = cssLength(percentage)
	          this.setBarWidth(this.getPlayedBarPercentage(position));
	          ptime.innerHTML = secondToTime(this.getPosition());
	        }
	
	        this.player.trigger(OUTER_TIME, {
	          type: OUTER_TIME,
	          position: position
	        });
	
	        this._updateTimeShiftLiveBadge();
	      }
	    }, {
	      key: "_onLoadedData",
	      value: function _onLoadedData() {
	        var _this4 = this;
	
	        var dura = this.getDuration();
	
	        if (isCommonNumber(dura) && dura > 0) {
	          this.player.trigger(OUTER_CAN_SEEK);
	        } else {
	          this.onceProvider(PROVIDER_DURATION, function () {
	            _this4.player.trigger(OUTER_CAN_SEEK);
	          });
	        }
	      }
	    }, {
	      key: "_onInternalKeyDown",
	      value: function _onInternalKeyDown(keyCode) {
	        var isLive = this._isLive();
	
	        var isHideProgress = !this.getProgressVisible();
	        if (isLive || isHideProgress) return;
	
	        switch (keyCode) {
	          case 37:
	            this.seek(this.getPosition() - 5);
	            break;
	
	          case 39:
	            this.seek(this.getPosition() + 5);
	            break;
	        }
	      }
	    }, {
	      key: "_isLive",
	      value: function _isLive() {
	        return classList(this.player.dom.container).contains(live);
	      }
	    }, {
	      key: "_updateTimeShiftLiveBadge",
	      value: function _updateTimeShiftLiveBadge() {
	        var isTimeShiftLive = this.isTimeShiftLive();
	        var con = this.player.dom.container;
	
	        if (isTimeShiftLive) {
	          classList(con).add(timeShiftLive); // this.liveBadgeTip.disable()
	        } else {
	          classList(con).remove(timeShiftLive); // this.liveBadgeTip.enable()
	        }
	      }
	    }, {
	      key: "seekTimeShiftLive",
	      value: function seekTimeShiftLive() {
	        // 当用户在时移回看时，如果想要切到最新的直播就调用这个函数，函数跳到第二新的ts(像上取10的整数)/30s处(取更大值)播放，并表示live
	        if (!this.isTimeShift()) return;
	        var dura = this.getDuration();
	        var latest10tsLength = this._latest10tsLength;
	
	        if (latest10tsLength.length < 3) {
	          var time = dura - 20;
	
	          if (time > 0) {
	            this.seek(time);
	          }
	        } else {
	          var _time = dura - latest10tsLength[0] - latest10tsLength[1];
	
	          this.seek(_time);
	        }
	      }
	    }, {
	      key: "getPositionByPercentage",
	      value: function getPositionByPercentage(percentage) {
	        var dura = this.getDuration();
	
	        if (this.isTimeShift()) {
	          var gap = this.getTimeShiftGap();
	          return (gap - dura) * (1 - percentage);
	        } else {
	          if (!dura) {
	            return 0;
	          }
	
	          return percentage * dura;
	        }
	      }
	    }, {
	      key: "seekByPercentage",
	      value: function seekByPercentage(percentage) {
	        var time;
	        var dura = this.getDuration();
	
	        if (this.isTimeShift()) {
	          var gap = this.getTimeShiftGap();
	          time = (dura - gap) * percentage;
	        } else {
	          time = percentage * dura;
	        }
	
	        this.seek(time);
	      }
	    }, {
	      key: "isTimeShiftLive",
	      value: function isTimeShiftLive() {
	        var dura = this.getDuration();
	        var time = this.getPosition();
	        var latest10tsLength = this._latest10tsLength; // console.log('is time shift live', dura, time, latest10tsLength)
	
	        if (latest10tsLength.length < 3) {
	          // 如果ts记录小于3个，那么不足以判断，直接判断time和duration的差值是否小于30
	          return dura - time < 30;
	        } else {
	          // 如果ts记录大于3个，那么判断time和duration的差值是否大于最新的3个ts
	          var ts2dura = latest10tsLength[0] + latest10tsLength[1] + latest10tsLength[2];
	          return dura - time < ts2dura;
	        }
	      }
	    }, {
	      key: "isTimeShift",
	      value: function isTimeShift() {
	        var dura = this.getDuration();
	        var hasValidDuration = isCommonNumber(dura) && dura > 0;
	        var hasClass = classList(this.player.dom.container).contains(timeShift);
	        return hasValidDuration && hasClass;
	      }
	    }, {
	      key: "getTimeShiftGap",
	      value: function getTimeShiftGap() {
	        var latest10tsLength = this._latest10tsLength;
	        var dura = this.getDuration();
	        var time = this.getPosition();
	
	        if (latest10tsLength.length < 3) {
	          var ret = dura - time;
	
	          if (ret < 30) {
	            return 30 - ret;
	          }
	
	          return 30;
	        } else {
	          var ts2dura = latest10tsLength[0] + latest10tsLength[1] + latest10tsLength[2];
	          return ts2dura;
	        }
	      }
	    }, {
	      key: "getPlayedBarPercentage",
	      value: function getPlayedBarPercentage(time) {
	        var dura = this.getDuration();
	
	        if (this.isTimeShift()) {
	          var gap = this.getTimeShiftGap();
	          var per = time / (dura - gap);
	
	          if (per > 1) {
	            return 1;
	          } // console.log(time, gap, dura, per)
	
	
	          return per;
	        } else {
	          return time / dura;
	        }
	      }
	    }, {
	      key: "setProgressVisible",
	      value: function setProgressVisible(val) {
	        if (val) {
	          classList(this.player.dom.container).remove(hideProgress);
	        } else {
	          classList(this.player.dom.container).add(hideProgress);
	          this.player._status.dragging = false;
	        } // setProgressVisible 会覆盖 playlist 中所有的 isHideProgress 配置
	
	
	        var playlist = this.player._config.playlist;
	
	        if (playlist && playlist.length > 0) {
	          for (var i = 0; i < playlist.length; i++) {
	            playlist[i].isHideProgress = !val;
	          }
	        }
	      }
	    }, {
	      key: "getProgressVisible",
	      value: function getProgressVisible() {
	        return !this._isLive() && !classList(this.player.dom.container).contains(hideProgress);
	      }
	    }]);
	
	    return Progress;
	  }(Model);
	
	  var Controls =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(Controls, _Model);
	
	    function Controls(player) {
	      var _this;
	
	      _classCallCheck(this, Controls);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Controls).call(this, player));
	      _this.isMobile = isMobile();
	      _this.autoHideTimer = null;
	      _this._controlsVisible = !!player._config.controls;
	      _this._videoLayerControl = !!player._config.videoLayerControl;
	      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('setControls').method('getControls').method('setVideoLayerControl').method('getVideoLayerControl').method('setCustomControl');
	
	      _this.setControls(!!player._config.controls);
	
	      _this.setVideoLayerControl(!!player._config.videoLayerControl);
	
	      _this.setMobileToggle();
	
	      _this.setPcToggle();
	
	      _this.setCustomControl(player._config.customControl);
	
	      return _this;
	    }
	
	    _createClass(Controls, [{
	      key: "setPcToggle",
	      value: function setPcToggle() {
	        var _this2 = this;
	
	        if (this.isMobile) {
	          return;
	        }
	
	        var fautoHide = function fautoHide() {
	          _this2.show();
	
	          _this2.setAutoHide();
	        };
	
	        var handlePlay = function handlePlay(_ref) {
	          var oldState = _ref.oldState;
	          oldState !== 'buffering' && oldState !== 'playing' && fautoHide();
	        };
	
	        this.onDom(this.player.dom.container, 'mousemove', fautoHide);
	        this.onDom(this.player.dom.container, 'click', fautoHide);
	        this.onPlayer(OUTER_PLAY, handlePlay);
	        this.onPlayer(OUTER_PAUSE, fautoHide);
	      }
	    }, {
	      key: "setMobileToggle",
	      value: function setMobileToggle() {
	        var _this3 = this;
	
	        if (!this.isMobile) {
	          return;
	        }
	
	        var ftoggle = function ftoggle(e) {
	          e.stopPropagation();
	
	          _this3.toggle();
	        }; // use touchend instead of click:  in ios11, you cannot listen click event above a video element: https://github.com/videojs/video.js/issues/642
	
	
	        this.onDom(this.player.dom.videoWrap, 'click', ftoggle);
	        this.onPlayer(OUTER_PLAY, function () {
	          _this3.setAutoHide();
	        });
	      }
	    }, {
	      key: "setAutoHide",
	      value: function setAutoHide() {
	        var _this4 = this;
	
	        clearTimeout(this.autoHideTimer);
	        this.autoHideTimer = setTimeout(function () {
	          var name = _this4.isMobile ? "mudu-popup ".concat(mobile) : 'mudu-popup';
	
	          if (!tooltip.isAnyClassShow(name) && !_this4.player._status.dragging) {
	            _this4.hide();
	          }
	        }, 3000);
	      }
	    }, {
	      key: "show",
	      value: function show() {
	        classList(this.player.dom.container).remove(hideController);
	
	        this._triggerControlsVisible(this.getControls());
	      }
	    }, {
	      key: "hide",
	      value: function hide() {
	        var state = this.player.model.video.getState();
	
	        if (state === 'paused' || state === 'idle') {
	          return;
	        }
	
	        classList(this.player.dom.container).add(hideController);
	
	        this._triggerControlsVisible(false);
	      }
	    }, {
	      key: "isShow",
	      value: function isShow() {
	        return !classList(this.player.dom.container).contains(hideController);
	      }
	    }, {
	      key: "_triggerControlsVisible",
	      value: function _triggerControlsVisible(visible) {
	        if (visible === this._controlsVisible) return;
	        this._controlsVisible = visible;
	        this.player.trigger(OUTER_CONTROLS_VISIBLE, {
	          type: OUTER_CONTROLS_VISIBLE,
	          visible: this._controlsVisible
	        });
	      }
	    }, {
	      key: "toggle",
	      value: function toggle() {
	        var isShow = this.isShow();
	        isShow ? this.hide() : this.show();
	        this.setAutoHide();
	      }
	    }, {
	      key: "setVideoLayerControl",
	      value: function setVideoLayerControl() {
	        var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        if (isMobile()) {
	          return;
	        }
	
	        this._videoLayerControl = !!status; // status为true意味着不需要放置baseLayer来阻挡点击
	
	        var display = this._videoLayerControl ? 'none' : 'block';
	        this.player.dom.baseLayer.style.display = display;
	        this.player.trigger(OUTER_VIDEO_LAYER_CONTROL, {
	          type: OUTER_VIDEO_LAYER_CONTROL,
	          videoLayerControl: this._videoLayerControl
	        });
	      }
	    }, {
	      key: "setControls",
	      value: function setControls() {
	        var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	        this._showControls = !!status;
	        var display = this._showControls ? 'block' : 'none';
	        this.player.dom.controllerWrap.style.display = display;
	        this.player.trigger(OUTER_CONTROLS, {
	          type: OUTER_CONTROLS,
	          controls: this._showControls
	        });
	
	        this._triggerControlsVisible(this._showControls && this.isShow());
	      }
	      /**
	       * 设置外置control
	       * @param {HTMLElement} control
	       */
	
	    }, {
	      key: "setCustomControl",
	      value: function setCustomControl(control) {
	        this.customControl = control;
	        var customControlContainer = this.player.dom.controllerWrap.querySelector(".".concat(customControlIcon));
	        customControlContainer.innerHTML = null;
	
	        if (typeof this.customControl === 'string') {
	          customControlContainer.innerText = this.customControl;
	        } else if (_typeof(this.customControl) === 'object') {
	          customControlContainer.appendChild(this.customControl);
	        } else {
	          customControlContainer.innerText = this.customControl || '';
	        }
	
	        this.customControl ? classList(customControlContainer).remove(hideCustomControl) : classList(customControlContainer).add(hideCustomControl);
	      }
	    }, {
	      key: "getControls",
	      value: function getControls() {
	        return this._showControls;
	      }
	    }, {
	      key: "getVideoLayerControl",
	      value: function getVideoLayerControl() {
	        return this._videoLayerControl;
	      }
	    }, {
	      key: "remove",
	      value: function remove() {
	        _get(_getPrototypeOf(Controls.prototype), "remove", this).call(this);
	
	        clearTimeout(this.autoHideTimer);
	      }
	    }]);
	
	    return Controls;
	  }(Model);
	
	  var Volume =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(Volume, _Model);
	
	    function Volume(player) {
	      var _this;
	
	      _classCallCheck(this, Volume);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Volume).call(this, player));
	      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('getMute').method('setMute').method('getVolume').method('setVolume');
	
	      _this.initVolumeButton();
	
	      _this.subEvents();
	
	      _this.volumeTip = tooltip(_this.player.dom.volumeButton, {
	        content: '',
	        container: _this.player.dom.container
	      });
	
	      if (isMobile()) {
	        _this.player.dom.volumeWrap.style.display = 'none';
	      }
	
	      return _this;
	    }
	
	    _createClass(Volume, [{
	      key: "subEvents",
	      value: function subEvents() {
	        var _this2 = this;
	
	        this.onPlayer(INTERNAL_PROVIDER_INITED, function () {
	          _this2.subProviderEvents();
	
	          var volume = Cache().get('volume') || 1;
	          var mute = Cache().get('mute') || false;
	
	          if (isMobile()) {
	            _this2.setVolume(1);
	          } else {
	            _this2.setVolume(volume);
	
	            _this2.setMute(mute);
	          }
	        });
	        this.onPlayer(INTERNAL_KEY_DOWN, this._onInternalKeyDown.bind(this));
	      }
	    }, {
	      key: "updateTipText",
	      value: function updateTipText() {
	        var mute = this.getMute() ? this.lang['Unmute'] : this.lang['Mute'];
	        var str = getTooltipString(mute);
	        this.volumeTip.updateContent(str);
	      }
	    }, {
	      key: "subProviderEvents",
	      value: function subProviderEvents() {
	        var _this3 = this;
	
	        this.onProvider(PROVIDER_MUTE, function (data) {
	          _this3.player.trigger(OUTER_MUTE, data);
	
	          _this3.switchVolumeIcon();
	
	          _this3.setBarWidth(cssLength(_this3.getVolume()));
	
	          _this3.cacheVolume();
	
	          _this3.updateTipText();
	        });
	        this.onProvider(PROVIDER_VOLUME, function (data) {
	          _this3.player.trigger(OUTER_VOLUME, data);
	
	          _this3.switchVolumeIcon();
	
	          _this3.setBarWidth(cssLength(_this3.getVolume()));
	
	          _this3.cacheVolume();
	        });
	      }
	    }, {
	      key: "cacheVolume",
	      value: function cacheVolume() {
	        Cache().set('volume', this.getVolume());
	        Cache().set('mute', this.getMute());
	      }
	    }, {
	      key: "initVolumeButton",
	      value: function initVolumeButton() {
	        var _this4 = this;
	
	        this.setBarWidth('100%');
	        this.switchVolumeIcon();
	
	        var volumeMove = function volumeMove(event) {
	          var e = event || window.event;
	          var scaleRate = _this4.player._status.containerFontSize / 16;
	          var vWidth = 45 * scaleRate;
	          var percentage = ((e.clientX || e.changedTouches[0].clientX) - getElementViewLeft(_this4.player.dom.volumeBarWrap)) / vWidth;
	
	          _this4.setVolume(percentage);
	        };
	
	        var volumeUp = function volumeUp() {
	          removeEventListener(document, dom.nameMap.dragEnd, volumeUp);
	          removeEventListener(document, dom.nameMap.dragMove, volumeMove);
	        };
	
	        addEventListener(this.player.dom.volumeBarWrapWrap, 'click', function (event) {
	          var scaleRate = _this4.player._status.containerFontSize / 16;
	          var vWidth = 45 * scaleRate;
	          var e = event || window.event;
	          var percentage = ((e.clientX || e.changedTouches[0].clientX) - getElementViewLeft(_this4.player.dom.volumeBarWrap)) / vWidth;
	
	          _this4.player.setVolume(percentage);
	        });
	        addEventListener(this.player.dom.volumeBarWrapWrap, dom.nameMap.dragStart, function () {
	          addEventListener(document, dom.nameMap.dragMove, volumeMove);
	          addEventListener(document, dom.nameMap.dragEnd, volumeUp);
	        });
	        addEventListener(this.player.dom.volumeButton, 'click', function () {
	          _this4.setMute(!_this4.getMute());
	
	          raf(function () {
	            _this4.updateTipText();
	
	            _this4.volumeTip.show();
	          });
	        });
	      }
	    }, {
	      key: "getMute",
	      value: function getMute() {
	        if (!this.provider()) {
	          return false;
	        }
	
	        return this.provider().getMute();
	      }
	    }, {
	      key: "setMute",
	      value: function setMute() {
	        var muted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        if (!this.provider()) {
	          return;
	        }
	
	        if (!muted && this.getVolume() === 0) {
	          this.setVolume(0.5);
	        }
	
	        return this.provider().setMute(muted);
	      }
	    }, {
	      key: "getVolume",
	      value: function getVolume() {
	        if (!this.provider()) {
	          return 1;
	        }
	
	        return this.provider().getVolume();
	      }
	    }, {
	      key: "setVolume",
	      value: function setVolume(volume) {
	        if (!this.provider()) {
	          return;
	        }
	
	        this.provider().setVolume(volume);
	      }
	    }, {
	      key: "setBarWidth",
	      value: function setBarWidth(width) {
	        this.player.dom.volumeBar.style.width = width;
	      }
	    }, {
	      key: "switchVolumeIcon",
	      value: function switchVolumeIcon(icon) {
	        var iconWrap = this.player.dom.volumeButton;
	        classList(iconWrap).remove(iconReg);
	
	        if (icon) {
	          classList(iconWrap).add(icon);
	          return;
	        }
	
	        if (this.getVolume() >= 0.95) {
	          classList(iconWrap).add(volumeUp);
	        } else if (this.getVolume() > 0) {
	          classList(iconWrap).add(volumeDown);
	        } else {
	          classList(iconWrap).add(volumeOff);
	        }
	      }
	    }, {
	      key: "_onInternalKeyDown",
	      value: function _onInternalKeyDown(keyCode) {
	        switch (keyCode) {
	          case 38:
	            this.setVolume(this.getVolume() + 0.1);
	            break;
	
	          case 40:
	            this.setVolume(this.getVolume() - 0.1);
	            break;
	        }
	      }
	    }]);
	
	    return Volume;
	  }(Model);
	
	  var Playlist =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(Playlist, _Model);
	
	    function Playlist(player) {
	      var _this;
	
	      _classCallCheck(this, Playlist);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Playlist).call(this, player));
	      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('getPlaylist').method('getPlaylistItem').method('getPlaylistIndex').method('load').method('reload').method('next').method('prev').method('replay').method('setQuality').method('switchQuality').method('switchListItem').method('setRepeat').method('getRepeat');
	
	      _this._subEvent();
	
	      _this._retryStartTime = new Date();
	      _this._retryTimes = 0;
	      _this._retryTimer = null;
	
	      if (player._config.enableErrorRetry) {
	        _this.onPlayer('delegate-model', _this._onDelegateModel.bind(_assertThisInitialized(_assertThisInitialized(_this)))); // 监听外部调用的onError事件，用来重置重试次数和重试时间
	
	
	        _this.onPlayer(OUTER_ERROR, _this._onOuterError.bind(_assertThisInitialized(_assertThisInitialized(_this))));
	      }
	
	      return _this;
	    }
	
	    _createClass(Playlist, [{
	      key: "_onDelegateModel",
	      value: function _onDelegateModel(data) {
	        var fn = data.fn;
	
	        switch (fn) {
	          case 'load':
	          case 'reload':
	          case 'next':
	          case 'prev':
	          case 'replay':
	          case 'setQuality':
	          case 'switchQuality':
	          case 'switchListItem':
	            this._retryStartTime = new Date();
	            this._retryTimes = 0;
	            clearTimeout(this._retryTimer);
	        }
	      }
	    }, {
	      key: "_onOuterError",
	      value: function _onOuterError(error) {
	        var _this2 = this;
	
	        var fatal = error.fatal;
	        var _this$player$_config = this.player._config,
	            errorMaxRetry = _this$player$_config.errorMaxRetry,
	            errorMaxRetryTimeout = _this$player$_config.errorMaxRetryTimeout,
	            errorRetryDelay = _this$player$_config.errorRetryDelay;
	        var now = new Date();
	
	        if (fatal) {
	          if (errorMaxRetry > this._retryTimes || now.getTime() < this._retryStartTime.getTime() + errorMaxRetryTimeout) {
	            clearTimeout(this._retryTimer);
	            this._retryTimer = setTimeout(function () {
	              if (!_this2.m_removed) {
	                _this2._retryTimes++;
	
	                _this2.replay();
	              }
	            }, errorRetryDelay);
	          }
	        }
	      }
	    }, {
	      key: "_subEvent",
	      value: function _subEvent() {
	        var _this3 = this;
	
	        var player = this.player;
	        this.onPlayer(INTERNAL_PROVIDER_INITED, function () {
	          if (!player._provider) {
	            return;
	          }
	
	          var isHTML5 = player._provider.html5;
	          var container = player.dom.container;
	          classList(container).remove(providerReg);
	          classList(container).add(providerReady);
	
	          if (isHTML5) {
	            classList(container).add(providerHtml5);
	          } else {
	            classList(container).add(providerFlash);
	          }
	
	          _this3.onProvider(PROVIDER_ENDED, function () {
	            player.trigger(OUTER_COMPLETE);
	            var isPlaylistComplete = _this3.getPlaylistIndex() === _this3.getPlaylist().length - 1;
	
	            if (isPlaylistComplete) {
	              if (player._config.repeat) {
	                _this3.reload();
	              } else {
	                player.trigger(OUTER_PLAYLIST_COMPLETE);
	              }
	            } else {
	              _this3.next();
	            }
	          });
	        });
	      }
	    }, {
	      key: "load",
	      value: function load(playlist) {
	        var play = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	        delete options.playlist;
	        this.player._config = _objectSpread({}, this.player._config, options);
	        var pl = formatPlaylist(playlist);
	
	        if (pl) {
	          this.player._config.playlist = pl;
	          this.player.trigger(OUTER_PLAYLIST, {
	            type: OUTER_PLAYLIST,
	            playlist: pl
	          });
	          return this.reload(play);
	        } else {
	          return Promise.reject(new Error('muduPlayer().load(`playlist`): the format of `playlist` is illegel'));
	        }
	      }
	    }, {
	      key: "reload",
	      value: function reload() {
	        var _this4 = this;
	
	        var play = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	        setDefaultPlayItemSourceActive.call(this.player);
	        return initProvider.call(this.player).then(function () {
	          initExtraProvider.call(_this4.player);
	
	          try {
	            if (play) {
	              return _this4.player.play();
	            }
	          } catch (err) {
	            console.warn(err);
	          }
	        });
	      }
	    }, {
	      key: "replay",
	      value: function replay() {
	        var _this5 = this;
	
	        return initProvider.call(this.player).then(function () {
	          initExtraProvider.call(_this5.player);
	
	          try {
	            return _this5.player.play();
	          } catch (err) {
	            console.warn(err);
	          }
	        });
	      }
	    }, {
	      key: "switchListItem",
	      value: function switchListItem(itemIndex, sourceIndex) {
	        var _this6 = this;
	
	        if (!is('number', itemIndex)) {
	          return Promise.resolve(false);
	        }
	
	        var item = this.player._config.playlist[itemIndex];
	
	        if (!item) {
	          return Promise.resolve(false);
	        }
	
	        if (is('number', sourceIndex) & !item.sources[sourceIndex]) {
	          return Promise.resolve(false);
	        }
	
	        if (is('number', sourceIndex)) {
	          setActive.call(this.player, itemIndex, sourceIndex);
	        } else {
	          setDefaultPlayItemSourceActive.call(this.player, itemIndex);
	        }
	
	        this.player.trigger(OUTER_PLAYLIST_ITEM, {
	          type: OUTER_PLAYLIST_ITEM,
	          index: itemIndex,
	          item: this.getPlaylistItem(itemIndex)
	        });
	        return initProvider.call(this.player).then(function () {
	          return _this6.player.play();
	        }).then(function () {
	          return true;
	        });
	      }
	    }, {
	      key: "next",
	      value: function next() {
	        var idx = this.getPlaylistIndex() + 1;
	        return this.switchListItem(idx);
	      }
	    }, {
	      key: "prev",
	      value: function prev() {
	        var idx = this.getPlaylistIndex() - 1;
	        return this.switchListItem(idx);
	      }
	    }, {
	      key: "getPlaylist",
	      value: function getPlaylist() {
	        return this.player._config.playlist;
	      }
	    }, {
	      key: "getPlaylistItem",
	      value: function getPlaylistItem() {
	        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        return this.player._config.playlist[index];
	      }
	    }, {
	      key: "getPlaylistIndex",
	      value: function getPlaylistIndex() {
	        for (var i = 0; i < this.player._config.playlist.length; i++) {
	          var item = this.player._config.playlist[i];
	
	          if (item.active) {
	            return i;
	          }
	        }
	
	        return -1;
	      }
	    }, {
	      key: "setQualityActive",
	      value: function setQualityActive(qindex) {
	        var listIndex = this.getPlaylistIndex();
	        return setActive.call(this.player, listIndex, qindex);
	      }
	    }, {
	      key: "getQuality",
	      value: function getQuality(qindex) {
	        var listIndex = this.getPlaylistIndex();
	        var playlist = this.player._config.playlist;
	
	        for (var i = 0; i < playlist[listIndex].sources.length; i++) {
	          if (qindex === i) {
	            return playlist[listIndex].sources[i];
	          }
	        }
	      }
	    }, {
	      key: "setQuality",
	      value: function setQuality(qindex) {
	        console.warn('player.setQuality will be removed after v1.0.0, please use player.switchQuality instead');
	        return this.switchQuality(qindex);
	      }
	    }, {
	      key: "switchQuality",
	      value: function switchQuality(qindex) {
	        var quality = this.getQuality(qindex);
	
	        if (quality) {
	          this.setQualityActive(qindex);
	          this.player.trigger(OUTER_SWITCH_QUALITY, {
	            index: qindex,
	            item: quality
	          });
	          return this.replay();
	        }
	
	        return Promise.resolve();
	      }
	    }, {
	      key: "setRepeat",
	      value: function setRepeat(repeat) {
	        this.player._config.repeat = !!repeat;
	      }
	    }, {
	      key: "getRepeat",
	      value: function getRepeat() {
	        return this.player._config.repeat;
	      }
	    }, {
	      key: "remove",
	      value: function remove() {
	        _get(_getPrototypeOf(Playlist.prototype), "remove", this).call(this);
	
	        clearTimeout(this._retryTimer);
	      }
	    }]);
	
	    return Playlist;
	  }(Model);
	
	  var keyEventName = isFF() ? 'keyup' : 'keydown'; // to prevent space key on full/volume/play btn trigger a click event
	
	  var HotKeys =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(HotKeys, _Model);
	
	    function HotKeys(player) {
	      var _this;
	
	      _classCallCheck(this, HotKeys);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(HotKeys).call(this, player));
	
	      _this.subEvent();
	
	      return _this;
	    }
	
	    _createClass(HotKeys, [{
	      key: "subEvent",
	      value: function subEvent() {
	        var player = this.player;
	
	        this.onKeyUp = function (e) {
	          if (player._status.focus) {
	            var ele = document.activeElement;
	            var tag = ele.tagName.toUpperCase();
	            var editable = ele.getAttribute('contenteditable');
	
	            if (tag !== 'INPUT' && tag !== 'TEXTAREA' && editable !== '' && editable !== 'true') {
	              var event = e || window.event;
	
	              switch (event.keyCode) {
	                case 32:
	                case 37:
	                case 39:
	                case 38:
	                case 40:
	                  event.preventDefault();
	                  player.trigger(INTERNAL_KEY_DOWN, event.keyCode, event);
	              }
	            }
	          }
	        };
	
	        addEventListener(document, keyEventName, this.onKeyUp);
	      }
	    }, {
	      key: "remove",
	      value: function remove() {
	        removeEventListener(document, keyEventName, this.onKeyUp);
	      }
	    }]);
	
	    return HotKeys;
	  }(Model);
	
	  var Resize =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(Resize, _Model);
	
	    function Resize(player) {
	      var _this;
	
	      _classCallCheck(this, Resize);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Resize).call(this, player));
	      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('getWidth').method('getHeight').method('resize').method('getRect');
	
	      _this.setWidth();
	
	      _this.setHeight();
	
	      if (!_this.setAspect()) {
	        _this.setHeight();
	      }
	
	      return _this;
	    }
	
	    _createClass(Resize, [{
	      key: "getWidth",
	      value: function getWidth() {
	        return this.getRect().width;
	      }
	    }, {
	      key: "getHeight",
	      value: function getHeight() {
	        return this.getRect().height;
	      }
	    }, {
	      key: "getRect",
	      value: function getRect() {
	        return getBoundingClientRect(this.player.dom.container);
	      }
	    }, {
	      key: "resize",
	      value: function resize(width, height) {
	        width = this.setWidth(width);
	        height = this.setHeight(height);
	        this.removeAspect();
	        this.player.trigger(OUTER_RESIZE, {
	          type: OUTER_RESIZE,
	          width: width,
	          height: height
	        });
	      }
	    }, {
	      key: "setWidth",
	      value: function setWidth(width) {
	        var cssWidth = width = width || this.player._config.width;
	        this.player.dom.container.style.width = cssLength(cssWidth);
	        return width;
	      }
	    }, {
	      key: "setHeight",
	      value: function setHeight(height) {
	        var cssHeight = height = height || this.player._config.height;
	        this.player.dom.container.style.height = cssLength(cssHeight);
	        return height;
	      }
	    }, {
	      key: "setAspect",
	      value: function setAspect() {
	        var aspectratio = this.player._config.aspectratio;
	        var aspects = (aspectratio + '').split(':').map(function (v) {
	          return +v;
	        }).filter(function (v) {
	          return !!v && v > 0;
	        });
	
	        if (aspects.length === 2) {
	          var percentage = aspects[1] / aspects[0] * 100 + '%';
	          this.player.dom.aspect.style.paddingTop = percentage;
	          classList(this.player.dom.container).add(aspectMode);
	          this.setHeight('auto');
	          return true;
	        } else {
	          classList(this.player.dom.container).add(normalMode);
	        }
	
	        return false;
	      }
	    }, {
	      key: "removeAspect",
	      value: function removeAspect() {
	        this.player.dom.aspect.style.paddingTop = 0;
	        classList(this.player.dom.container).remove(aspectMode);
	      }
	    }]);
	
	    return Resize;
	  }(Model);
	
	  var Stretch =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(Stretch, _Model);
	
	    function Stretch(player) {
	      var _this;
	
	      _classCallCheck(this, Stretch);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Stretch).call(this, player));
	
	      _this.onPlayer(INTERNAL_PROVIDER_INITED, _this._onProviderInited.bind(_assertThisInitialized(_assertThisInitialized(_this))));
	
	      return _this;
	    }
	
	    _createClass(Stretch, [{
	      key: "_onProviderInited",
	      value: function _onProviderInited() {
	        var stretching = this.player._config.stretching;
	
	        if (this.provider()) {
	          this.provider().setStretching(stretching);
	        }
	      }
	    }]);
	
	    return Stretch;
	  }(Model);
	
	  var Logo =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(Logo, _Model);
	
	    function Logo(player) {
	      var _this;
	
	      _classCallCheck(this, Logo);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Logo).call(this, player));
	      _this._onImgLoad = _this._onImgLoad.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	      _this._onStyleLoaded = _this._onStyleLoaded.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	
	      _this.setLogoStyle();
	
	      _this.oncePlayer(INTERNAL_STYLE_LOADED, _this._onStyleLoaded);
	
	      return _this;
	    }
	
	    _createClass(Logo, [{
	      key: "_onStyleLoaded",
	      value: function _onStyleLoaded() {
	        this.setLogoVisible();
	      }
	    }, {
	      key: "_onImgLoad",
	      value: function _onImgLoad() {
	        var _this$player$dom = this.player.dom,
	            logoWrap = _this$player$dom.logoWrap,
	            logoImg = _this$player$dom.logoImg;
	        var imgRect = getBoundingClientRect(logoImg);
	        var containerRect = getBoundingClientRect(logoWrap);
	        var containerAspectRatio = containerRect.width / containerRect.height;
	        var imgNaturalAspectRatio = imgRect.width / imgRect.height;
	
	        if (containerAspectRatio > imgNaturalAspectRatio) {
	          logoImg.style.height = '100%';
	        } else {
	          logoImg.style.width = '100%';
	        }
	
	        logoImg.style.opacity = this.player._config.logo.opacity + '';
	      }
	    }, {
	      key: "setLogoVisible",
	      value: function setLogoVisible() {
	        var logo = this.player._config.logo;
	        var logoImg = this.player.dom.logoImg;
	        addEventListener(logoImg, 'load', this._onImgLoad);
	        logoImg.style.display = 'inline-block';
	        logoImg.src = logo.file;
	      }
	    }, {
	      key: "setLogoStyle",
	      value: function setLogoStyle() {
	        var logo = this.player._config.logo;
	        var _this$player$dom2 = this.player.dom,
	            logoWrap = _this$player$dom2.logoWrap,
	            logoImg = _this$player$dom2.logoImg,
	            logoLink = _this$player$dom2.logoLink;
	
	        if (!logo.file) {
	          return;
	        }
	
	        this.resetPosition();
	        logoWrap.style.width = cssLength(logo.width);
	        logoWrap.style.height = cssLength(logo.height);
	
	        if (logo.position !== 'control-bar') {
	          var direcs = logo.position.split('-');
	          direcs.forEach(function (direc) {
	            if (direc === 'top' || direc === 'bottom') {
	              logoWrap.style[direc] = cssLength(logo.marginh);
	            }
	
	            if (direc === 'left' || direc === 'right') {
	              logoWrap.style[direc] = cssLength(logo.marginw);
	            }
	          });
	          direcs.forEach(function (v) {
	            logoImg.style[v] = '0';
	          });
	        }
	
	        logoLink.href = logo.link ? logo.link : 'javascript:void(0);';
	        logoLink.target = logo.link ? '_blank' : '_self';
	        logoLink.style.cursor = logo.link ? 'pointer' : 'default';
	      }
	    }, {
	      key: "resetPosition",
	      value: function resetPosition() {
	        var dom = this.player.dom.logoWrap;
	        dom.style.cssText = 'position: absolute;';
	      }
	    }, {
	      key: "remove",
	      value: function remove() {
	        removeEventListener(this.player.dom.logoImg, 'load', this._onImgLoad);
	
	        _get(_getPrototypeOf(Logo.prototype), "remove", this).call(this);
	      }
	    }]);
	
	    return Logo;
	  }(Model);
	
	  var Focus =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(Focus, _Model);
	
	    function Focus(player) {
	      var _this;
	
	      _classCallCheck(this, Focus);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Focus).call(this, player));
	
	      _this.init();
	
	      return _this;
	    }
	
	    _createClass(Focus, [{
	      key: "init",
	      value: function init() {
	        var player = this.player;
	
	        this.setTrue = function () {
	          player._status.focus = true;
	        };
	
	        this.setFalse = function () {
	          player._status.focus = false;
	        };
	
	        addEventListener(document, 'click', this.setFalse, true);
	        addEventListener(player.dom.container, 'click', this.setTrue, true);
	      }
	    }, {
	      key: "remove",
	      value: function remove() {
	        removeEventListener(document, 'click', this.setFalse, true);
	        removeEventListener(this.player.dom.container, 'click', this.setTrue, true);
	      }
	    }]);
	
	    return Focus;
	  }(Model);
	
	  var Bezel =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(Bezel, _Model);
	
	    function Bezel(player) {
	      var _this;
	
	      _classCallCheck(this, Bezel);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Bezel).call(this, player));
	      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('setLoadingForced');
	      var bezel = _this.player.dom.bezel;
	      var bezelWrap = _this.player.dom.bezelWrap; // 自定义loading
	
	      var renderLoading = _this.player._config.renderLoading;
	
	      if (renderLoading) {
	        _this.renderLoadingString = typeof renderLoading === 'string' ? stringToDom(renderLoading) : renderLoading;
	        _this.renderLoadingString.className += "".concat(reset, " ").concat(extraLoadingIcon);
	        bezelWrap.appendChild(_this.renderLoadingString);
	      } else {
	        _this.renderLoadingString = stringToDom("<span class=\"".concat(reset, " ").concat(loadingIcon, " ").concat(loading, "\"></span>"));
	        bezelWrap.appendChild(_this.renderLoadingString);
	      }
	
	      _this.onDom(bezel, 'animationend', function () {
	        classList(bezel).remove(bezelTrans);
	      });
	
	      return _this;
	    }
	
	    _createClass(Bezel, [{
	      key: "setLoadingForced",
	      value: function setLoadingForced(isShow) {
	        this.renderLoadingString.style.display = isShow ? 'block' : '';
	      }
	    }, {
	      key: "switch",
	      value: function _switch(icon) {
	        var bezel = this.player.dom.bezel;
	        classList(bezel).remove(iconReg);
	        classList(bezel).add(icon);
	        classList(bezel).add(bezelTrans);
	      }
	    }]);
	
	    return Bezel;
	  }(Model);
	
	  var Background =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(Background, _Model);
	
	    function Background(player) {
	      var _this;
	
	      _classCallCheck(this, Background);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Background).call(this, player));
	      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('setImageDisplay');
	
	      _this.subEvents();
	
	      return _this;
	    }
	
	    _createClass(Background, [{
	      key: "setImageDisplay",
	      value: function setImageDisplay(type) {
	        var bg = this.player.dom.background;
	
	        switch (type) {
	          case 'show':
	            bg.style.display = 'block';
	            break;
	
	          case 'hidden':
	            bg.style.display = 'none';
	            break;
	
	          case 'auto':
	            bg.style.display = '';
	        }
	      }
	    }, {
	      key: "subEvents",
	      value: function subEvents() {
	        var _this2 = this;
	
	        this.onPlayer(INTERNAL_PROVIDER_INITED, function (_ref) {
	          var image = _ref.image,
	              alwaysDisplayImage = _ref.alwaysDisplayImage;
	          var bg = _this2.player.dom.background;
	          var container = _this2.player.dom.container;
	          classList(container).remove(stretchReg);
	          classList(container).add(stretch + '-' + _this2.player._config.stretching);
	
	          if (image) {
	            bg.style.backgroundImage = "url(".concat(image, ")");
	          } else {
	            bg.style.backgroundImage = 'none';
	          }
	
	          if (alwaysDisplayImage) {
	            classList(bg).add(alwaysDisplayBg);
	          } else {
	            classList(bg).remove(alwaysDisplayBg);
	          }
	        });
	      }
	    }]);
	
	    return Background;
	  }(Model);
	
	  var Dom =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(Dom, _Model);
	
	    function Dom(player) {
	      var _this;
	
	      _classCallCheck(this, Dom);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Dom).call(this, player));
	      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('appendRightControllerButton');
	      return _this;
	    }
	
	    _createClass(Dom, [{
	      key: "appendRightControllerButton",
	      value: function appendRightControllerButton(btn) {
	        if (btn instanceof window.HTMLElement) {
	          this.player.dom.controllerRightIcons.appendChild(btn);
	        }
	      }
	    }]);
	
	    return Dom;
	  }(Model);
	
	  var Title =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(Title, _Model);
	
	    function Title(player) {
	      var _this;
	
	      _classCallCheck(this, Title);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Title).call(this, player));
	
	      _this.onPlayer(INTERNAL_PROVIDER_INITED, function () {
	        var _getActive$call = getActive.call(player),
	            title = _getActive$call.title;
	
	        if (!title) {
	          player.dom.title.style.display = 'none';
	        } else {
	          player.dom.title.innerText = title;
	        }
	      });
	
	      return _this;
	    }
	
	    return Title;
	  }(Model);
	
	  var ContextMenu =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(ContextMenu, _Model);
	
	    function ContextMenu(player) {
	      var _this2;
	
	      _classCallCheck(this, ContextMenu);
	
	      _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ContextMenu).call(this, player));
	
	      if (_this2.player._config.contextMenus.length > 0) {
	        _this2.dom = null;
	
	        _this2.createDom();
	
	        _this2.tip = tooltip('', {
	          container: player.dom.container,
	          content: _this2.dom,
	          class: 'mudu-popup',
	          getMaxHeight: function getMaxHeight(_ref) {
	            var height = _ref.height;
	            return height;
	          }
	        });
	
	        _this2._subEvents();
	      }
	
	      return _this2;
	    }
	
	    _createClass(ContextMenu, [{
	      key: "generateDom",
	      value: function generateDom() {
	        this.createDom();
	      }
	    }, {
	      key: "_subEvents",
	      value: function _subEvents() {
	        var _this3 = this;
	
	        this.handleContextMenu = function (e) {
	          if (_this3.tip.isShow()) {
	            _this3.tip.hide();
	
	            return;
	          }
	
	          var style = _this3.getStyle(e);
	
	          if (style) {
	            tooltip.hideAll();
	
	            _this3.tip.show(style);
	
	            e.preventDefault && e.preventDefault();
	          }
	        };
	
	        this.onDom(this.player.dom.container, 'contextmenu', this.handleContextMenu);
	      }
	    }, {
	      key: "getStyle",
	      value: function getStyle(e) {
	        var containerRect = getBoundingClientRect(this.player.dom.container);
	        var panelRect = getBoundingClientRect(this.player.dom.container.querySelector(".".concat(panel)));
	
	        if (containerRect.width < panelRect.width || containerRect.height < panelRect.height) {
	          return;
	        }
	
	        var eLeft = e.clientX;
	        var eTop = e.clientY;
	        var maxTop = containerRect.height - panelRect.height;
	        var maxLeft = containerRect.width - panelRect.width;
	        var left = eLeft - containerRect.left;
	        var top = eTop - containerRect.top;
	        top = top > maxTop ? maxTop : top;
	        left = left > maxLeft ? maxLeft : left;
	        return {
	          left: left,
	          top: top
	        };
	      }
	    }, {
	      key: "createDom",
	      value: function createDom() {
	        var ctxMenus = this.player._config.contextMenus;
	        var menus = ctxMenus.map(function (v) {
	          var item = "<a class=\"".concat(reset, " ").concat(menuitem, "\" target=\"_blank\" menuKey=\"").concat(v.key, "\" menuText=\"").concat(v.text, "\">") + "<div class=\"".concat(reset, " ").concat(menuitemLabel, "\">").concat(v.text, "</div>") + "</a>";
	          return item;
	        });
	        var str = "<div class=\"".concat(reset, " ").concat(panel, " ").concat(contextMenuPanel, "\">") + "<div class=\"".concat(reset, " ").concat(panelMenu, "\">").concat(menus.join(''), "</div>") + "</div>";
	        var dom = stringToDom(str);
	        var items = dom.querySelectorAll(".".concat(menuitem));
	
	        var _this = this;
	
	        for (var i = 0; i < items.length; i++) {
	          items[i].onclick = function () {
	            var key = this.getAttribute('menuKey');
	            var text = this.getAttribute('menuText');
	
	            _this.tip.hide();
	
	            _this.player.trigger(OUTER_CONTEXT_MENU_CLICK, {
	              key: key,
	              text: text,
	              type: OUTER_CONTEXT_MENU_CLICK
	            });
	          };
	        }
	
	        this.dom = dom;
	      }
	    }]);
	
	    return ContextMenu;
	  }(Model);
	
	  var ProgressPopup =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(ProgressPopup, _Model);
	
	    function ProgressPopup(player) {
	      var _this;
	
	      _classCallCheck(this, ProgressPopup);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(ProgressPopup).call(this, player));
	      _this.highlights = [];
	      _this.autoHideTimer = null;
	
	      _this.subEvents();
	
	      return _this;
	    }
	
	    _createClass(ProgressPopup, [{
	      key: "subEvents",
	      value: function subEvents() {
	        var _this2 = this;
	
	        this.onPlayer(OUTER_DURATION, function () {
	          _this2.setHightLights();
	        });
	        this.onPlayer(INTERNAL_PROVIDER_REMOVED, function () {
	          _this2.clearHightLights();
	        });
	        this.onDom(this.player.dom.playedBarWrap, 'mousemove', function (e) {
	          _this2.show();
	
	          _this2.handleMouseMove(e);
	
	          isMobile() && _this2.setAutohide();
	        });
	
	        if (!isMobile()) {
	          this.onDom(this.player.dom.playedBarWrap, 'mouseenter', function (e) {
	            _this2.show();
	          });
	          this.onDom(this.player.dom.playedBarWrap, 'mouseleave', function (e) {
	            _this2.hide();
	          });
	          this.onDom(this.player.dom.playedBarWrap, 'mouseover', function (e) {
	            _this2.handleDotEnter(e);
	          });
	          this.onDom(this.player.dom.playedBarWrap, 'mouseout', function (e) {
	            _this2.handleDotLeave(e);
	          });
	        }
	      }
	    }, {
	      key: "setAutohide",
	      value: function setAutohide() {
	        var _this3 = this;
	
	        clearTimeout(this.autoHideTimer);
	        this.autoHideTimer = setTimeout(function () {
	          _this3.hide();
	        }, 300);
	      }
	    }, {
	      key: "handleMouseMove",
	      value: function handleMouseMove(e) {
	        var px = cumulativeOffset(this.player.dom.playedBarWrap).left;
	        var tx = (e.clientX || e.chhegdTouches[0].clientX) - px;
	
	        if (tx < 0 || tx > this.player.dom.playedBarWrap.offsetWidth) {
	          return;
	        }
	
	        this.move(tx);
	      }
	    }, {
	      key: "handleDotEnter",
	      value: function handleDotEnter(e) {
	        var ele = e.target || e.srcElement; // ie8: e.target undefined
	
	        if (ele && classList(ele).contains(dot)) {
	          var text = ele.getAttribute('text');
	          this.setDotActive(ele, true);
	          this.setPopText(text);
	          this.setPopTextVisible(true);
	          this.handleMouseMove(e);
	        }
	      }
	    }, {
	      key: "handleDotLeave",
	      value: function handleDotLeave(e) {
	        var ele = e.target || e.srcElement;
	
	        if (ele && classList(ele).contains(dot)) {
	          this.setDotActive(ele, false);
	          this.setPopText('');
	          this.setPopTextVisible(false);
	          this.handleMouseMove(e);
	        }
	      }
	    }, {
	      key: "setPopText",
	      value: function setPopText(text) {
	        this.player.dom.barTextText.innerHTML = text;
	      }
	    }, {
	      key: "setPopTextVisible",
	      value: function setPopTextVisible(visible) {
	        var cl = classList(this.player.dom.barPopup);
	        visible ? cl.add(barPopupText) : cl.remove(barPopupText);
	      }
	    }, {
	      key: "isPopTextVisible",
	      value: function isPopTextVisible() {
	        return classList(this.player.dom.barPopup).contains(barPopupText);
	      }
	    }, {
	      key: "setDotActive",
	      value: function setDotActive(dot, active$1) {
	        var cl = classList(dot);
	        active$1 ? cl.add(active) : cl.remove(active);
	      }
	    }, {
	      key: "show",
	      value: function show() {
	        classList(this.player.dom.barPopup).remove('hidden');
	      }
	    }, {
	      key: "hide",
	      value: function hide() {
	        classList(this.player.dom.barPopup).add('hidden');
	      }
	    }, {
	      key: "move",
	      value: function move(offsetPx) {
	        var dura = this.player.model.progress.getDuration();
	        var barWidth = this.player.dom.playedBarWrap.offsetWidth;
	
	        if (offsetPx < 0) {
	          offsetPx = 0;
	        }
	
	        if (offsetPx > barWidth) {
	          offsetPx = barWidth;
	        }
	
	        var percentage = offsetPx / barWidth;
	        var time = this.player.model.progress.getPositionByPercentage(percentage); // set content
	
	        var timeStr = secondToTime(time); // 当鼠标在控制条上时，显示现在的视频位置
	
	        this.player.dom.barTime.innerHTML = timeStr;
	        this.player.dom.barTextTime.innerHTML = timeStr; // classList(this.player.dom.barPopup).remove(cssClass.barPopupReg)
	
	        this.setPosition(false, this.isPopTextVisible(), offsetPx, barWidth);
	      }
	      /**
	       * call from model/controls
	       * @param {*} offsetPx
	       */
	
	    }, {
	      key: "dragMove",
	      value: function dragMove(offsetPx, direc) {
	        var _this4 = this;
	
	        var dot$1 = this.getDotFromDrag(offsetPx, direc);
	        var dotIdx = this.highlights.indexOf(dot$1);
	        var dotEles = this.player.dom.highlight.querySelectorAll(".".concat(dot));
	        var dotEle = dotEles[dotIdx];
	        [].slice.call(dotEles).forEach(function (v) {
	          return _this4.setDotActive(v, v === dotEle);
	        });
	
	        if (dotEle) {
	          this.setPopText(dot$1.text);
	          this.setPopTextVisible(true);
	        } else {
	          this.setPopText('');
	          this.setPopTextVisible(false);
	        }
	
	        this.move(offsetPx);
	      }
	    }, {
	      key: "dragEnd",
	      value: function dragEnd() {
	        var _this5 = this;
	
	        var dotEles = this.player.dom.highlight.querySelectorAll(".".concat(dot));
	        [].slice.call(dotEles).forEach(function (v) {
	          return _this5.setDotActive(v, false);
	        });
	      }
	    }, {
	      key: "getDotFromDrag",
	      value: function getDotFromDrag(offsetPx, direc) {
	        var barWidth = this.player.dom.playedBarWrap.offsetWidth;
	        var dotWidth = 6;
	        var dura = this.player.model.progress.getDuration();
	        var pos = offsetPx / barWidth * dura;
	        var posRadius = dotWidth / 2 / barWidth * dura;
	        var radiusLights = this.highlights.filter(function (v) {
	          return v.time > pos - posRadius && v.time < pos + posRadius;
	        });
	
	        if (radiusLights.length <= 1) {
	          return radiusLights[0];
	        }
	
	        if (direc === 'left') {
	          return radiusLights[0];
	        }
	
	        if (direc === 'right') {
	          return radiusLights.pop();
	        }
	
	        return radiusLights[0];
	      }
	    }, {
	      key: "setPosition",
	      value: function setPosition(hasImg, hasText, offsetPx, barWidth) {
	        var width;
	        var popWidth = 168 * this.player._status.containerFontSize / 16;
	
	        if (!hasImg && !hasText) {
	          width = this.player.dom.barTime.offsetWidth;
	        } else if (!hasImg && hasText) {
	          width = this.player.dom.barText.offsetWidth;
	        } else {
	          width = popWidth;
	        }
	
	        var minLeft = -(popWidth - width) / 2;
	        var maxLeft = barWidth - (popWidth / 2 + width / 2);
	        var left = offsetPx - popWidth / 2;
	
	        if (left < minLeft) {
	          left = minLeft;
	        }
	
	        if (left > maxLeft) {
	          left = maxLeft;
	        }
	
	        this.player.dom.barPopup.style.left = "".concat(left, "px");
	      }
	    }, {
	      key: "setHightLights",
	      value: function setHightLights() {
	        var _getActive$call = getActive.call(this.player),
	            highlights = _getActive$call.highlights;
	
	        var hightDom = this.player.dom.highlight;
	        var dura = this.player.model.progress.getDuration();
	        this.highlights = is('array', highlights) ? highlights : [];
	        this.highlights = this.highlights.slice().sort(function (dot1, dot2) {
	          return dot1.time >= dot2.time;
	        });
	        var dots = this.highlights.map(function (d) {
	          var left = d.time / dura;
	          return "<div class=\"".concat(reset, " ").concat(dot, "\" text=\"").concat(d.text, "\" style=\"left: ").concat(cssLength(left), "\"></div>");
	        });
	        hightDom.innerHTML = dots.join('');
	      }
	    }, {
	      key: "clearHightLights",
	      value: function clearHightLights() {
	        this.player.dom.highlight.innerHTML = '';
	        this.highlights = [];
	      }
	    }]);
	
	    return ProgressPopup;
	  }(Model);
	
	  var Error$1 =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(Error, _Model);
	
	    function Error(player) {
	      var _this;
	
	      _classCallCheck(this, Error);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Error).call(this, player));
	      _this._tryDom = _this.geneTryDom();
	      _this.renderError = is('function', _this.player._config.renderError) ? _this.player._config.renderError : _this.defaultRenderError.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	
	      _this.onPlayer(INTERNAL_PROVIDER_INITED, function () {
	        _this.onProvider(PROVIDER_ERROR, function (data) {
	          data.message = "provider_".concat(_this.player._provider.name, "_").concat(data.message);
	          data.errorId = genErrorId();
	          _this.player._status.state = 'error';
	
	          _this.player.trigger(OUTER_ERROR, data);
	        });
	      });
	
	      _this.onPlayer(OUTER_ERROR, function (data) {
	        var error = {
	          errorId: data.errorId,
	          message: _this.filterErrorMsg(data.message),
	          detail: data.message
	        };
	
	        if (data.fatal) {
	          var errorDom = _this.renderError(error);
	
	          if (!errorDom || !is('string', errorDom) && !(errorDom instanceof HTMLElement)) {
	            errorDom = _this.defaultRenderError(error);
	          }
	
	          if (is('string', errorDom)) {
	            _this.player.dom.errorWrap.innerHTML = errorDom;
	          } else {
	            _this.player.dom.errorWrap.innerHTML = '';
	
	            _this.player.dom.errorWrap.appendChild(errorDom);
	          }
	
	          classList(_this.player.dom.container).add(stateError);
	        }
	      });
	
	      return _this;
	    }
	
	    _createClass(Error, [{
	      key: "geneTryDom",
	      value: function geneTryDom() {
	        var _this2 = this;
	
	        var a = "<a href=\"javascript:void(0)\" action=\"reload\" style=\"color: blue;\">".concat(this.lang['Reload'], "</a>");
	        var str = "<div>".concat(this.lang['You can try'], " ").concat(a, "</div>");
	        var dom = stringToDom(str);
	
	        dom.onclick = function (e) {
	          e = e || window.event;
	          var ele = e.target || e.srcElement;
	
	          if (ele.getAttribute('action') === 'reload') {
	            _this2.player.replay();
	          }
	        };
	
	        return dom;
	      }
	    }, {
	      key: "defaultRenderError",
	      value: function defaultRenderError(_ref) {
	        var message = _ref.message,
	            detail = _ref.detail,
	            errorId = _ref.errorId;
	        var errorInner$1 = "<div class=\"".concat(reset, " ").concat(errorInner, "\">") + "<div class=\"".concat(reset, " ").concat(errorIcon, "\"><span class=\"").concat(reset, " ").concat(error, "\"></span></div>") + "<div class=\"".concat(reset, " ").concat(errorText, "\">") + "<div>".concat(message, "(").concat(errorId, ")</div>") + "</div>" + "</div>";
	        var errorInnerDom = stringToDom(errorInner$1);
	        errorInnerDom.querySelector(".".concat(errorText)).appendChild(this._tryDom);
	        return errorInnerDom;
	      }
	    }, {
	      key: "filterErrorMsg",
	      value: function filterErrorMsg(msg) {
	        if (!msg) {
	          return this.lang['Unknown Error'];
	        }
	
	        var lmsg = msg.toLowerCase();
	
	        var ht = function ht(sub) {
	          return lmsg.indexOf(sub) >= 0;
	        };
	
	        if (ht('network')) {
	          return this.lang['Network Error'];
	        }
	
	        if (ht('media') || ht('parse') || ht('demux') || ht('remux') || ht('decode')) {
	          return this.lang['Media Error'];
	        }
	
	        return msg;
	      }
	    }, {
	      key: "hideError",
	      value: function hideError() {
	        classList(this.player.dom.container).remove(stateError);
	      }
	    }]);
	
	    return Error;
	  }(Model);
	
	  var Notice =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(Notice, _Model);
	
	    function Notice(player) {
	      var _this;
	
	      _classCallCheck(this, Notice);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Notice).call(this, player));
	      _this.nt = _this.player.dom.notice;
	      _this._t = null;
	      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('notice');
	      return _this;
	    }
	
	    _createClass(Notice, [{
	      key: "notice",
	      value: function notice(text) {
	        var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;
	        this.setContent(text);
	
	        if (time > 0) {
	          this.autoHide(time);
	        }
	      }
	    }, {
	      key: "hide",
	      value: function hide() {
	        this.setVisible(false);
	      }
	    }, {
	      key: "show",
	      value: function show() {
	        this.setVisible(true);
	      }
	    }, {
	      key: "autoHide",
	      value: function autoHide(time) {
	        var _this2 = this;
	
	        this.show();
	
	        if (this._t) {
	          clearTimeout(this._t);
	          this._t = null;
	        }
	
	        setTimeout(function () {
	          return _this2.hide();
	        }, time);
	      }
	    }, {
	      key: "setContent",
	      value: function setContent(text) {
	        this.nt.innerHTML = text;
	      }
	    }, {
	      key: "setVisible",
	      value: function setVisible(visible) {
	        visible ? classList(this.nt).remove(hide) : classList(this.nt).add(hide);
	      }
	    }, {
	      key: "remove",
	      value: function remove() {
	        _get(_getPrototypeOf(Notice.prototype), "remove", this).call(this);
	
	        this._t && clearTimeout(this._t);
	      }
	    }]);
	
	    return Notice;
	  }(Model);
	
	  var QualitySwitch =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(QualitySwitch, _Model);
	
	    function QualitySwitch(player) {
	      var _this;
	
	      _classCallCheck(this, QualitySwitch);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(QualitySwitch).call(this, player));
	      _this.isMobile = isMobile();
	
	      _this.onPlayer(INTERNAL_PROVIDER_INITED, function () {
	        _this.onProviderInited(player);
	      });
	
	      return _this;
	    }
	
	    _createClass(QualitySwitch, [{
	      key: "onProviderInited",
	      value: function onProviderInited() {
	        var sources = getActiveSources.call(this.player);
	        var activeSource = this.getActiveSource(sources);
	        var pathList = this.getPathListBySources(sources);
	        this.init();
	
	        if (sources.length > 1) {
	          if (this.isMobile) {
	            this.initMobile(pathList, sources, activeSource);
	          } else {
	            this.initQuality(pathList, sources, activeSource); // pathList.length > 0 && this.initPath(sources, activeSource)
	          }
	        }
	      }
	    }, {
	      key: "init",
	      value: function init() {
	        if (this.mobilePopup) {
	          this.mobilePopup.destroy();
	        }
	
	        if (this.qsPopup) {
	          this.qsPopup.destroy();
	        }
	
	        if (this.psPopup) {
	          this.psPopup.destroy();
	        } // this.player.dom.switchPath.innerHTML = ''
	
	
	        this.player.dom.switchPath.style.display = 'none';
	        this.player.dom.switchQuality.innerHTML = '';
	      }
	    }, {
	      key: "initMobile",
	      value: function initMobile(pathList, sources, activeSource) {
	        var _this$player$dom = this.player.dom,
	            container = _this$player$dom.container,
	            switchQuality = _this$player$dom.switchQuality;
	        var activePathSources = this.getSourcesByPath(activeSource.path, sources);
	        var dom = this.createMobileMenuitem(activePathSources, pathList, activeSource.path);
	        this.mobilePopup = this.createTooltip(container, switchQuality, dom);
	        dom.addEventListener('click', this.mobilePopup.hide);
	        this.addEventClick(dom.querySelectorAll('[type="path"]'), this.switchPath);
	        this.addEventClick(dom.querySelectorAll('[type="quality"]'), this.switchQuality);
	
	        if (activeSource) {
	          this.player.dom.switchQuality.innerHTML = activePathSources.length > 1 ? activeSource.label : activeSource.path_name;
	        }
	      }
	    }, {
	      key: "initQuality",
	      value: function initQuality(pathList, sources, activeSource) {
	        var _this$player$dom2 = this.player.dom,
	            container = _this$player$dom2.container,
	            switchQuality = _this$player$dom2.switchQuality;
	        var activePathSources = this.getSourcesByPath(activeSource.path, sources);
	        var dom = this.createQualityMenuitem(activePathSources, pathList, activeSource);
	        this.addEventClick(dom.querySelectorAll('[type="quality"]'), this.switchQuality);
	        this.addEventClick(dom.querySelectorAll('[type="path"]'), this.switchPath);
	        var pathSelectWrap$1 = dom.querySelector(".".concat(pathSelectWrap));
	        var pathSelectMenu$1 = dom.querySelector(".".concat(pathSelectMenu));
	        this.qsPopup = this.createTooltip(container, switchQuality, dom, function () {
	          pathSelectMenu$1 && (pathSelectMenu$1.style.visibility = 'hidden');
	        });
	        addEventListener(pathSelectWrap$1, 'click', function (e) {
	          var visibility = 'hidden';
	
	          if (pathSelectMenu$1.style.visibility !== 'visible') {
	            var maxHeight = getBoundingClientRect(dom).height - 48;
	            pathSelectMenu$1.style.maxHeight = cssLength(maxHeight);
	            visibility = 'visible';
	          }
	
	          pathSelectMenu$1.style.visibility = visibility;
	          e.stopPropagation && e.stopPropagation();
	          e.cancelBubble = true;
	        });
	        addEventListener(document, 'click', function (e) {
	          pathSelectMenu$1.style.visibility = 'hidden';
	        });
	
	        if (activeSource) {
	          this.player.dom.switchQuality.innerHTML = activePathSources.length > 1 ? activeSource.label : activeSource.path_name;
	        }
	      }
	    }, {
	      key: "initPath",
	      value: function initPath(sources, activeSource) {
	        var _this$player$dom3 = this.player.dom,
	            container = _this$player$dom3.container,
	            switchPath = _this$player$dom3.switchPath;
	        var pathList = this.getPathListBySources(sources);
	        var dom = this.createPathMenuitem(activeSource.path, pathList);
	        this.addEventClick(dom.querySelectorAll('[type="path"]'), this.switchPath);
	        this.psPopup = this.createTooltip(container, switchPath, dom);
	
	        if (activeSource) {
	          this.player.dom.switchPath.innerHTML = activeSource.path_name;
	        }
	      }
	    }, {
	      key: "addEventClick",
	      value: function addEventClick(dom, callback) {
	        var _this2 = this;
	
	        dom.forEach(function (menuitem) {
	          menuitem.onclick = function () {
	            return callback.call(_this2, menuitem);
	          };
	        });
	      }
	    }, {
	      key: "getActiveSource",
	      value: function getActiveSource(sources) {
	        return sources.filter(function (source) {
	          return source.active;
	        })[0];
	      }
	    }, {
	      key: "switchQuality",
	      value: function switchQuality(menuitem) {
	        this.isMobile ? this.mobilePopup.hide() : this.qsPopup.hide();
	
	        if (classList(menuitem).contains(active)) {
	          return;
	        }
	
	        var index = Number(menuitem.getAttribute('value'));
	        this.player.switchQuality(index);
	      }
	    }, {
	      key: "switchPath",
	      value: function switchPath(menuitem) {
	        if (classList(menuitem).contains(active)) {
	          return;
	        }
	
	        var sources = getActiveSources.call(this.player);
	        var path = menuitem.getAttribute('value');
	        var activeSource = this.getActiveSource(sources);
	        var pathSources = sources.filter(function (source) {
	          return source.path === path;
	        });
	        var source = pathSources.find(function (source) {
	          return source.label === activeSource.label;
	        });
	
	        if (!source) {
	          source = pathSources[0]; // 使用此线路的第一个源地址
	        }
	
	        this.player.switchQuality(Number(source.index));
	        this.isMobile ? this.mobilePopup.hide() : this.qsPopup.hide();
	      }
	    }, {
	      key: "getSourcesByPath",
	      value: function getSourcesByPath(path, sources) {
	        return sources.filter(function (source) {
	          return source.path === path;
	        });
	      }
	    }, {
	      key: "getPathListBySources",
	      value: function getPathListBySources(sources) {
	        var sourceList = sources.filter(function (item) {
	          return item.path && item.path_name;
	        });
	        var list = [];
	        sourceList.forEach(function (source) {
	          var isRepeat = list.findIndex(function (item) {
	            return item.path === source.path;
	          }) > -1;
	
	          if (!isRepeat) {
	            list.push({
	              path: source.path,
	              path_name: source.path_name
	            });
	          }
	        });
	        return list;
	      }
	    }, {
	      key: "createMobileMenuitem",
	      value: function createMobileMenuitem(activeSources, pathList, activePath) {
	        var _this3 = this;
	
	        var pathMenu = pathList.map(function (path, i) {
	          return "<div class=\"".concat(qualityMenuItem, " ").concat(activePath === path.path ? active : '', "\" type=\"path\" value=\"").concat(path.path, "\">\n         ").concat(i === 0 ? "<div class=\"".concat(reset, " ").concat(qualityMenuItemTip, "\">").concat(_this3.lang['Line'], "</div>") : '', "\n         <span class=\"").concat(qualityItemName, "\">").concat(path.path_name, "</span>\n       </div>");
	        }).join('');
	        var qualityMenu$1 = activeSources.map(function (source, i) {
	          return "<div class=\"".concat(qualityMenuItem, " ").concat(source.active ? active : '', "\" type=\"quality\" value=\"").concat(source.index, "\">\n        ").concat(i === 0 ? "<div class=\"".concat(reset, " ").concat(qualityMenuItemTip, "\">").concat(_this3.lang['Quality'], "</div>") : '', "\n         <span class=\"").concat(qualityItemName, "\">").concat(source.label, "</span>\n       </div>");
	        }).join('');
	        var str = "<div class=\"".concat(qualityWrap, "\">\n                   <div class=\"").concat(qualityMenu, "\">\n                    <div style=\"display: ").concat(pathList.length > 1 ? 'flex' : 'none', "\">\n                       <div class=\"").concat(qualityMenuItemWrap, "\">").concat(pathMenu, "</div>\n                     </div>\n                     <div style=\"display: ").concat(activeSources.length > 1 ? 'flex' : 'none', "\">\n                       <div class=\"").concat(qualityMenuItemWrap, "\">").concat(qualityMenu$1, "</div>\n                     </div>\n                   </div>\n                 </div>");
	        return stringToDom(str);
	      }
	    }, {
	      key: "createQualityMenuitem",
	      value: function createQualityMenuitem(activeSources, pathList, activeSource) {
	        var str = '';
	        var pathStr = '';
	
	        if (activeSources.length > 1 && pathList.length > 1) {
	          str = activeSources.map(function (source) {
	            return "<div class=\"".concat(qualityMenuItem, " ").concat(source.active ? active : '', "\" type=\"quality\" value=\"").concat(source.index, "\">\n           <span class=\"").concat(qualityItemName, "\">").concat(source.label, "</span>\n         </div>");
	          }).join('');
	          pathStr = pathList.map(function (path) {
	            return "<div title=\"".concat(path.path_name, "\" class=\"").concat(pathSelectMenuItem, " ").concat(activeSource.path === path.path ? active : '', "\" type=\"path\" value=\"").concat(path.path, "\">").concat(path.path_name, "</div>");
	          }).join('');
	        } else if (pathList.length > 1 && activeSources.length <= 1) {
	          str = pathList.map(function (path) {
	            return "<div class=\"".concat(qualityMenuItem, " ").concat(activeSource.path === path.path ? active : '', "\" type=\"path\" value=\"").concat(path.path, "\">\n           <span class=\"").concat(qualityItemName, "\">").concat(path.path_name, "</span>\n         </div>");
	          }).join('');
	        } else {
	          str = activeSources.map(function (source) {
	            return "<div class=\"".concat(qualityMenuItem, " ").concat(source.active ? active : '', "\" type=\"quality\" value=\"").concat(source.index, "\">\n           <span class=\"").concat(qualityItemName, "\">").concat(source.label, "</span>\n         </div>");
	          }).join('');
	        }
	
	        var res = "<div class=\"".concat(qualityWrap, "\">\n      <div class=\"").concat(pathSelectWrap, "\" style=\"display: ").concat(pathList.length > 1 && activeSources.length > 1 ? 'block' : 'none', "\">\n        <div>\n          ").concat(activeSource.path_name, "\n          <span></span>\n        </div>\n        <div class=\"").concat(reset, " ").concat(pathSelectMenu, "\">\n          ").concat(pathStr, "\n        </div>\n      </div>\n      <div class=\"").concat(qualityMenu, "\">").concat(str, "</div>\n    </div>");
	        return stringToDom(res);
	      }
	    }, {
	      key: "createPathMenuitem",
	      value: function createPathMenuitem(activePath, pathList) {
	        var isTwoColumns = pathList.length > 4 && !this.mobile;
	        var str = pathList.map(function (path) {
	          return "<div title=\"".concat(path.path_name, "\" class=\"").concat(qualityMenuItem, " ").concat(activePath === path.path ? active : '', "\" type=\"path\" value=\"").concat(path.path, "\">\n         <span class=\"").concat(qualityItemName, "\">").concat(path.path_name, "</span>\n       </div>");
	        }).join('');
	        return stringToDom("<div class=\"".concat(pathWrap, " ").concat(isTwoColumns ? pathMulti : '', "\">\n                                <div class=\"").concat(qualityMenu, "\">").concat(str, "</div>\n                              </div>"));
	      }
	    }, {
	      key: "createTooltip",
	      value: function createTooltip(container, ele, content, wrapClick) {
	        var _this4 = this;
	
	        var tip = tooltip(ele, {
	          trigger: 'click',
	          content: content,
	          container: container,
	          distance: 0,
	          class: this.isMobile ? "mudu-popup ".concat(mobile) : 'mudu-popup',
	          getMaxHeight: function getMaxHeight(_ref) {
	            var height = _ref.height;
	            return _this4.isMobile ? height : height - 70; // 移动端全屏不能限制高度
	          },
	          wrapClick: wrapClick
	        });
	        this.onPlayer(INTERNAL_PROVIDER_REMOVED, tip.destroy);
	        return tip;
	      }
	    }]);
	
	    return QualitySwitch;
	  }(Model);
	
	  var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	  function createCommonjsModule(fn, module) {
	  	return module = { exports: {} }, fn(module, module.exports), module.exports;
	  }
	
	  var win;
	
	  if (typeof window !== "undefined") {
	      win = window;
	  } else if (typeof commonjsGlobal !== "undefined") {
	      win = commonjsGlobal;
	  } else if (typeof self !== "undefined"){
	      win = self;
	  } else {
	      win = {};
	  }
	
	  var window_1 = win;
	
	  var isFunction_1 = isFunction;
	
	  var toString = Object.prototype.toString;
	
	  function isFunction (fn) {
	    var string = toString.call(fn);
	    return string === '[object Function]' ||
	      (typeof fn === 'function' && string !== '[object RegExp]') ||
	      (typeof window !== 'undefined' &&
	       // IE8 and below
	       (fn === window.setTimeout ||
	        fn === window.alert ||
	        fn === window.confirm ||
	        fn === window.prompt))
	  }
	
	  var trim_1 = createCommonjsModule(function (module, exports) {
	  exports = module.exports = trim;
	
	  function trim(str){
	    return str.replace(/^\s*|\s*$/g, '');
	  }
	
	  exports.left = function(str){
	    return str.replace(/^\s*/, '');
	  };
	
	  exports.right = function(str){
	    return str.replace(/\s*$/, '');
	  };
	  });
	  var trim_2 = trim_1.left;
	  var trim_3 = trim_1.right;
	
	  var fnToStr = Function.prototype.toString;
	
	  var constructorRegex = /^\s*class\b/;
	  var isES6ClassFn = function isES6ClassFunction(value) {
	  	try {
	  		var fnStr = fnToStr.call(value);
	  		return constructorRegex.test(fnStr);
	  	} catch (e) {
	  		return false; // not a function
	  	}
	  };
	
	  var tryFunctionObject = function tryFunctionToStr(value) {
	  	try {
	  		if (isES6ClassFn(value)) { return false; }
	  		fnToStr.call(value);
	  		return true;
	  	} catch (e) {
	  		return false;
	  	}
	  };
	  var toStr = Object.prototype.toString;
	  var fnClass = '[object Function]';
	  var genClass = '[object GeneratorFunction]';
	  var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	  var isCallable = function isCallable(value) {
	  	if (!value) { return false; }
	  	if (typeof value !== 'function' && typeof value !== 'object') { return false; }
	  	if (typeof value === 'function' && !value.prototype) { return true; }
	  	if (hasToStringTag) { return tryFunctionObject(value); }
	  	if (isES6ClassFn(value)) { return false; }
	  	var strClass = toStr.call(value);
	  	return strClass === fnClass || strClass === genClass;
	  };
	
	  var toStr$1 = Object.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	  var forEachArray = function forEachArray(array, iterator, receiver) {
	      for (var i = 0, len = array.length; i < len; i++) {
	          if (hasOwnProperty.call(array, i)) {
	              if (receiver == null) {
	                  iterator(array[i], i, array);
	              } else {
	                  iterator.call(receiver, array[i], i, array);
	              }
	          }
	      }
	  };
	
	  var forEachString = function forEachString(string, iterator, receiver) {
	      for (var i = 0, len = string.length; i < len; i++) {
	          // no such thing as a sparse string.
	          if (receiver == null) {
	              iterator(string.charAt(i), i, string);
	          } else {
	              iterator.call(receiver, string.charAt(i), i, string);
	          }
	      }
	  };
	
	  var forEachObject = function forEachObject(object, iterator, receiver) {
	      for (var k in object) {
	          if (hasOwnProperty.call(object, k)) {
	              if (receiver == null) {
	                  iterator(object[k], k, object);
	              } else {
	                  iterator.call(receiver, object[k], k, object);
	              }
	          }
	      }
	  };
	
	  var forEach = function forEach(list, iterator, thisArg) {
	      if (!isCallable(iterator)) {
	          throw new TypeError('iterator must be a function');
	      }
	
	      var receiver;
	      if (arguments.length >= 3) {
	          receiver = thisArg;
	      }
	
	      if (toStr$1.call(list) === '[object Array]') {
	          forEachArray(list, iterator, receiver);
	      } else if (typeof list === 'string') {
	          forEachString(list, iterator, receiver);
	      } else {
	          forEachObject(list, iterator, receiver);
	      }
	  };
	
	  var forEach_1 = forEach;
	
	  var isArray = function(arg) {
	        return Object.prototype.toString.call(arg) === '[object Array]';
	      };
	
	  var parseHeaders = function (headers) {
	    if (!headers)
	      return {}
	
	    var result = {};
	
	    forEach_1(
	        trim_1(headers).split('\n')
	      , function (row) {
	          var index = row.indexOf(':')
	            , key = trim_1(row.slice(0, index)).toLowerCase()
	            , value = trim_1(row.slice(index + 1));
	
	          if (typeof(result[key]) === 'undefined') {
	            result[key] = value;
	          } else if (isArray(result[key])) {
	            result[key].push(value);
	          } else {
	            result[key] = [ result[key], value ];
	          }
	        }
	    );
	
	    return result
	  };
	
	  var immutable = extend;
	
	  var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
	
	  function extend() {
	      var target = {};
	
	      for (var i = 0; i < arguments.length; i++) {
	          var source = arguments[i];
	
	          for (var key in source) {
	              if (hasOwnProperty$1.call(source, key)) {
	                  target[key] = source[key];
	              }
	          }
	      }
	
	      return target
	  }
	
	  var xhr = createXHR;
	  // Allow use of default import syntax in TypeScript
	  var default_1 = createXHR;
	  createXHR.XMLHttpRequest = window_1.XMLHttpRequest || noop$1;
	  createXHR.XDomainRequest = "withCredentials" in (new createXHR.XMLHttpRequest()) ? createXHR.XMLHttpRequest : window_1.XDomainRequest;
	
	  forEachArray$1(["get", "put", "post", "patch", "head", "delete"], function(method) {
	      createXHR[method === "delete" ? "del" : method] = function(uri, options, callback) {
	          options = initParams(uri, options, callback);
	          options.method = method.toUpperCase();
	          return _createXHR(options)
	      };
	  });
	
	  function forEachArray$1(array, iterator) {
	      for (var i = 0; i < array.length; i++) {
	          iterator(array[i]);
	      }
	  }
	
	  function isEmpty(obj){
	      for(var i in obj){
	          if(obj.hasOwnProperty(i)) return false
	      }
	      return true
	  }
	
	  function initParams(uri, options, callback) {
	      var params = uri;
	
	      if (isFunction_1(options)) {
	          callback = options;
	          if (typeof uri === "string") {
	              params = {uri:uri};
	          }
	      } else {
	          params = immutable(options, {uri: uri});
	      }
	
	      params.callback = callback;
	      return params
	  }
	
	  function createXHR(uri, options, callback) {
	      options = initParams(uri, options, callback);
	      return _createXHR(options)
	  }
	
	  function _createXHR(options) {
	      if(typeof options.callback === "undefined"){
	          throw new Error("callback argument missing")
	      }
	
	      var called = false;
	      var callback = function cbOnce(err, response, body){
	          if(!called){
	              called = true;
	              options.callback(err, response, body);
	          }
	      };
	
	      function readystatechange() {
	          if (xhr.readyState === 4) {
	              setTimeout(loadFunc, 0);
	          }
	      }
	
	      function getBody() {
	          // Chrome with requestType=blob throws errors arround when even testing access to responseText
	          var body = undefined;
	
	          if (xhr.response) {
	              body = xhr.response;
	          } else {
	              body = xhr.responseText || getXml(xhr);
	          }
	
	          if (isJson) {
	              try {
	                  body = JSON.parse(body);
	              } catch (e) {}
	          }
	
	          return body
	      }
	
	      function errorFunc(evt) {
	          clearTimeout(timeoutTimer);
	          if(!(evt instanceof Error)){
	              evt = new Error("" + (evt || "Unknown XMLHttpRequest Error") );
	          }
	          evt.statusCode = 0;
	          return callback(evt, failureResponse)
	      }
	
	      // will load the data & process the response in a special response object
	      function loadFunc() {
	          if (aborted) return
	          var status;
	          clearTimeout(timeoutTimer);
	          if(options.useXDR && xhr.status===undefined) {
	              //IE8 CORS GET successful response doesn't have a status field, but body is fine
	              status = 200;
	          } else {
	              status = (xhr.status === 1223 ? 204 : xhr.status);
	          }
	          var response = failureResponse;
	          var err = null;
	
	          if (status !== 0){
	              response = {
	                  body: getBody(),
	                  statusCode: status,
	                  method: method,
	                  headers: {},
	                  url: uri,
	                  rawRequest: xhr
	              };
	              if(xhr.getAllResponseHeaders){ //remember xhr can in fact be XDR for CORS in IE
	                  response.headers = parseHeaders(xhr.getAllResponseHeaders());
	              }
	          } else {
	              err = new Error("Internal XMLHttpRequest Error");
	          }
	          return callback(err, response, response.body)
	      }
	
	      var xhr = options.xhr || null;
	
	      if (!xhr) {
	          if (options.cors || options.useXDR) {
	              xhr = new createXHR.XDomainRequest();
	          }else {
	              xhr = new createXHR.XMLHttpRequest();
	          }
	      }
	
	      var key;
	      var aborted;
	      var uri = xhr.url = options.uri || options.url;
	      var method = xhr.method = options.method || "GET";
	      var body = options.body || options.data;
	      var headers = xhr.headers = options.headers || {};
	      var sync = !!options.sync;
	      var isJson = false;
	      var timeoutTimer;
	      var failureResponse = {
	          body: undefined,
	          headers: {},
	          statusCode: 0,
	          method: method,
	          url: uri,
	          rawRequest: xhr
	      };
	
	      if ("json" in options && options.json !== false) {
	          isJson = true;
	          headers["accept"] || headers["Accept"] || (headers["Accept"] = "application/json"); //Don't override existing accept header declared by user
	          if (method !== "GET" && method !== "HEAD") {
	              headers["content-type"] || headers["Content-Type"] || (headers["Content-Type"] = "application/json"); //Don't override existing accept header declared by user
	              body = JSON.stringify(options.json === true ? body : options.json);
	          }
	      }
	
	      xhr.onreadystatechange = readystatechange;
	      xhr.onload = loadFunc;
	      xhr.onerror = errorFunc;
	      // IE9 must have onprogress be set to a unique function.
	      xhr.onprogress = function () {
	          // IE must die
	      };
	      xhr.onabort = function(){
	          aborted = true;
	      };
	      xhr.ontimeout = errorFunc;
	      xhr.open(method, uri, !sync, options.username, options.password);
	      //has to be after open
	      if(!sync) {
	          xhr.withCredentials = !!options.withCredentials;
	      }
	      // Cannot set timeout with sync request
	      // not setting timeout on the xhr object, because of old webkits etc. not handling that correctly
	      // both npm's request and jquery 1.x use this kind of timeout, so this is being consistent
	      if (!sync && options.timeout > 0 ) {
	          timeoutTimer = setTimeout(function(){
	              if (aborted) return
	              aborted = true;//IE9 may still call readystatechange
	              xhr.abort("timeout");
	              var e = new Error("XMLHttpRequest timeout");
	              e.code = "ETIMEDOUT";
	              errorFunc(e);
	          }, options.timeout );
	      }
	
	      if (xhr.setRequestHeader) {
	          for(key in headers){
	              if(headers.hasOwnProperty(key)){
	                  xhr.setRequestHeader(key, headers[key]);
	              }
	          }
	      } else if (options.headers && !isEmpty(options.headers)) {
	          throw new Error("Headers cannot be set on an XDomainRequest object")
	      }
	
	      if ("responseType" in options) {
	          xhr.responseType = options.responseType;
	      }
	
	      if ("beforeSend" in options &&
	          typeof options.beforeSend === "function"
	      ) {
	          options.beforeSend(xhr);
	      }
	
	      // Microsoft Edge browser sends "undefined" when send is called with undefined value.
	      // XMLHttpRequest spec says to pass null as body to indicate no body
	      // See https://github.com/naugtur/xhr/issues/100.
	      xhr.send(body || null);
	
	      return xhr
	
	
	  }
	
	  function getXml(xhr) {
	      // xhr.responseXML will throw Exception "InvalidStateError" or "DOMException"
	      // See https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/responseXML.
	      try {
	          if (xhr.responseType === "document") {
	              return xhr.responseXML
	          }
	          var firefoxBugTakenEffect = xhr.responseXML && xhr.responseXML.documentElement.nodeName === "parsererror";
	          if (xhr.responseType === "" && !firefoxBugTakenEffect) {
	              return xhr.responseXML
	          }
	      } catch (e) {}
	
	      return null
	  }
	
	  function noop$1() {}
	  xhr.default = default_1;
	
	  function postLog(url, json) {
	    var time = rfc3339nano();
	    var keys = objectKeys(json);
	    var kv = {
	      time: time
	    };
	    keys.forEach(function (k) {
	      kv[k] = safeJSONStringify(json[k]);
	    });
	
	    try {
	      xhr({
	        url: url + '?time=' + decodeURIComponent(time),
	        method: 'POST',
	        body: safeJSONStringify(kv),
	        headers: {
	          'Content-Type': 'application/json'
	        }
	      }, noop);
	    } catch (err) {}
	  }
	  function postPerf(perfUrl, json) {
	    var queryString = urlStringify(_objectSpread({}, json, {
	      time: rfc3339nano()
	    }));
	    xhr("".concat(perfUrl, "?").concat(queryString), noop);
	  }
	
	  /**
	   * when play, starts recording
	   * when pause, records once and stops recording, and calcs once
	   */
	
	  var Perf =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(Perf, _Model);
	
	    function Perf(player) {
	      var _this;
	
	      _classCallCheck(this, Perf);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Perf).call(this, player));
	      _this.perfLogUrl = player._config.perfLogUrl;
	      _this.buffer_records = [];
	      _this.metric_records = [];
	      _this.provider_is_html5 = false;
	      _this.provider_name = '';
	      _this.stream_url = '';
	      _this.perf_id = '';
	      _this.perf_paused = true;
	      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('getMediaHeight').method('getMediaWidth').method('getMetrics');
	      if (!_this.perfLogUrl) return _possibleConstructorReturn(_this, _assertThisInitialized(_assertThisInitialized(_this))); // if perfLogUrl isn't set, do not caculate
	
	      if (isX5Layer()) return _possibleConstructorReturn(_this, _assertThisInitialized(_assertThisInitialized(_this))); // in x5 kernel, video.webkitVideoxxxx always 0
	      // if (isIE() && browserVersion.major < 9) return this // in ie<10, post with application/json not allowed
	
	      _this.calcTimer = new Timer({
	        gap: 3000
	      });
	      _this.recordTimer = new Timer({
	        gap: 800
	      });
	
	      _this.onPlayer(INTERNAL_PROVIDER_INITED, _this._onProviderInited.bind(_assertThisInitialized(_assertThisInitialized(_this))));
	
	      _this.onPlayer(INTERNAL_PROVIDER_REMOVED, _this._onProviderRemoved.bind(_assertThisInitialized(_assertThisInitialized(_this))));
	
	      _this.recordTimer.on('tick', _this._onRecordTimerTick.bind(_assertThisInitialized(_assertThisInitialized(_this))));
	
	      _this.recordTimer.on('start', _this._onRecordTimerTick.bind(_assertThisInitialized(_assertThisInitialized(_this))));
	
	      _this.calcTimer.on('tick', _this._onCalcTimerTick.bind(_assertThisInitialized(_assertThisInitialized(_this))));
	
	      return _this;
	    }
	
	    _createClass(Perf, [{
	      key: "remove",
	      value: function remove() {
	        _get(_getPrototypeOf(Perf.prototype), "remove", this).call(this);
	
	        this.recordTimer && this.recordTimer.stop();
	        this.calcTimer && this.calcTimer.stop();
	      }
	    }, {
	      key: "getMediaHeight",
	      value: function getMediaHeight() {
	        if (!this.provider()) return -1;
	        return this.provider().getHeight();
	      }
	    }, {
	      key: "getMeidaWidth",
	      value: function getMeidaWidth() {
	        if (!this.provider()) return -1;
	        return this.provider().getWidth();
	      }
	    }, {
	      key: "getMetrics",
	      value: function getMetrics() {
	        if (!this.provider()) return null;
	        return this.provider().getMetrics();
	      }
	    }, {
	      key: "recordMetrics",
	      value: function recordMetrics() {
	        this.metric_records.push(_objectSpread({
	          time: this._getTs(),
	          pos: this.player.model.progress.getPosition()
	        }, this.getMetrics()));
	      }
	    }, {
	      key: "calcBufferTimes",
	      value: function calcBufferTimes() {
	        var ts = this._getTs();
	
	        var last3sRecords = this.buffer_records.filter(function (item) {
	          return item.time >= ts - 3000 && item.time < ts;
	        });
	        this.buffer_records = this.buffer_records.filter(function (item) {
	          return item.time < ts - 30000;
	        }); // clear history before 30s from now
	
	        return {
	          times: last3sRecords.filter(function (r) {
	            return r.type === 'waiting';
	          }).length,
	          records: last3sRecords
	        };
	      }
	    }, {
	      key: "calcBuffer",
	      value: function calcBuffer() {
	        var buffer = this.player.model.progress.getBuffer();
	        var length = buffer.reduce(function (l, bf) {
	          return l + (bf.end - bf.start);
	        }, 0);
	        return {
	          buffer: buffer,
	          length: length
	        };
	      }
	    }, {
	      key: "calcMetrics",
	      value: function calcMetrics() {
	        var ts = this._getTs();
	
	        var last3sRecords = this.metric_records.filter(function (item) {
	          return item.time >= ts - 3000 && item.time <= ts;
	        });
	        this.metric_records = this.metric_records.filter(function (item) {
	          return item.time < ts - 3000;
	        });
	        if (last3sRecords.length === 0) return;
	        var type;
	        var metric = {};
	        var firstMetric = last3sRecords[0];
	
	        if (!is('undefined', firstMetric.fps)) {
	          type = 'flash';
	          metric = this._calcFlashMetrics(last3sRecords);
	        } else if (!is('undefined', firstMetric.mozParsedFrames)) {
	          type = 'moz';
	          metric = this._calcMozMetrics(last3sRecords);
	        } else if (!is('undefined', firstMetric.webkitAudioDecodedByteCount)) {
	          type = 'webkit';
	          metric = this._calcWebkitMetrics(last3sRecords);
	        } else {
	          type = 'other';
	        }
	
	        return _objectSpread({}, metric, {
	          type: type,
	          records: last3sRecords
	        });
	      }
	    }, {
	      key: "_calcFlashMetrics",
	      value: function _calcFlashMetrics(records) {
	        var metric = {
	          fps: 0,
	          bps: 0
	        };
	        var fpsArr = records.map(function (re) {
	          return re.fps;
	        }).filter(function (fps) {
	          return fps > 0;
	        }); // remove fps <= 0
	
	        var bpsArr = records.map(function (re) {
	          return re.bps;
	        }).filter(function (bps) {
	          return bps > 0;
	        });
	        var fpsLen = fpsArr.length;
	        var bpsLen = bpsArr.length;
	        fpsArr.forEach(function (fps) {
	          metric.fps += fps / fpsLen;
	        });
	        bpsArr.forEach(function (bps) {
	          metric.bps += bps / bpsLen;
	        });
	        return metric;
	      }
	    }, {
	      key: "_calcWebkitMetrics",
	      value: function _calcWebkitMetrics(records) {
	        var metric = {
	          fps: 0,
	          bps: 0,
	          decodedFps: 0,
	          droppedFps: 0,
	          audioBps: 0,
	          videoBps: 0,
	          recordsLength: records.length
	        };
	
	        if (records.length === 1) {
	          // one record cant calc
	          return metric;
	        }
	
	        var formatRecords = records.map(function (_, i, arr) {
	          if (i === 0) {
	            return {
	              time: 0
	            };
	          }
	
	          return {
	            time: arr[i].time - arr[i - 1].time,
	            audioDecodedBytes: arr[i].webkitAudioDecodedByteCount - arr[i - 1].webkitAudioDecodedByteCount,
	            videoDecodedBytes: arr[i].webkitVideoDecodedByteCount - arr[i - 1].webkitVideoDecodedByteCount,
	            decodedFrames: arr[i].webkitDecodedFrameCount - arr[i - 1].webkitDecodedFrameCount,
	            droppedFrames: arr[i].webkitDroppedFrameCount - arr[i - 1].webkitDroppedFrameCount
	          };
	        }).filter(function (re) {
	          return re.time !== 0;
	        });
	        var metricArr = formatRecords.map(function (re) {
	          var time = re.time / 1000;
	          var me = {
	            decodedFps: re.decodedFrames / time,
	            droppedFps: re.droppedFrames / time,
	            audioBps: re.audioDecodedBytes / time,
	            videoBps: re.videoDecodedBytes / time,
	            time: time
	          };
	          me.fps = me.decodedFps + me.droppedFps;
	          me.bps = me.audioBps + me.videoBps;
	          return me;
	        });
	        var fullTime = metricArr.reduce(function (ft, me) {
	          return ft + me.time;
	        }, 0);
	        metricArr.forEach(function (me) {
	          metric.decodedFps = me.decodedFps * me.time / fullTime + metric.decodedFps;
	          metric.droppedFps = me.droppedFps * me.time / fullTime + metric.droppedFps;
	          metric.audioBps = me.audioBps * me.time / fullTime + metric.audioBps;
	          metric.videoBps = me.videoBps * me.time / fullTime + metric.videoBps;
	        });
	        metric.fps = metric.decodedFps + metric.droppedFps;
	        metric.bps = metric.audioBps + metric.videoBps;
	        return metric;
	      }
	    }, {
	      key: "_calcMozMetrics",
	      value: function _calcMozMetrics(records) {
	        var metric = {
	          fps: 0,
	          parsedFps: 0,
	          decodedFps: 0,
	          presentedFps: 0,
	          paintedFps: 0,
	          recordsLength: records.length
	        };
	
	        if (records.length === 1) {
	          // one record cant calc
	          return metric;
	        }
	
	        var formatRecords = records.map(function (_, i, arr) {
	          if (i === 0) {
	            return {
	              time: 0
	            };
	          }
	
	          return {
	            time: arr[i].time - arr[i - 1].time,
	            parsedFrames: arr[i].mozParsedFrames - arr[i - 1].mozParsedFrames,
	            decodedFrames: arr[i].mozDecodedFrames - arr[i - 1].mozDecodedFrames,
	            presentedFrames: arr[i].mozPresentedFrames - arr[i - 1].mozPresentedFrames,
	            paintedFrames: arr[i].mozPaintedFrames - arr[i - 1].mozPaintedFrames
	          };
	        }).filter(function (re) {
	          return re.time !== 0;
	        });
	        var metricArr = formatRecords.map(function (re) {
	          var time = re.time / 1000;
	          var me = {
	            parsedFps: re.parsedFrames / time,
	            decodedFps: re.decodedFrames / time,
	            presentedFps: re.presentedFrames / time,
	            paintedFps: re.paintedFrames / time,
	            time: time
	          };
	          me.fps = me.parsedFps;
	          return me;
	        });
	        var fullTime = metricArr.reduce(function (ft, me) {
	          return ft + me.time;
	        }, 0);
	        metricArr.forEach(function (me) {
	          metric.parsedFps = me.parsedFps * me.time / fullTime + metric.parsedFps;
	          metric.decodedFps = me.decodedFps * me.time / fullTime + metric.decodedFps;
	          metric.presentedFps = me.presentedFps * me.time / fullTime + metric.presentedFps;
	          metric.paintedFps = me.paintedFps * me.time / fullTime + metric.paintedFps;
	        });
	        metric.fps = metric.parsedFps;
	        return metric;
	      }
	    }, {
	      key: "_onProviderInited",
	      value: function _onProviderInited(_ref) {
	        var file = _ref.file;
	        this.stream_url = file;
	        this.provider_is_html5 = this.player._provider.html5;
	        this.provider_name = this.player._provider.name;
	        this.perf_id = this.player._status.uniqId + '_' + randomString(2);
	        this.buffer_records = [];
	        this.metric_records = [];
	        this.onProvider(PROVIDER_WAITING, this._onWaiting.bind(this));
	        this.onProvider(PROVIDER_PLAY, this._onPlay.bind(this));
	        this.onProvider(PROVIDER_PAUSE, this._onPause.bind(this));
	      }
	    }, {
	      key: "_onProviderRemoved",
	      value: function _onProviderRemoved() {
	        this.stream_url = '';
	        this.provider_name = '';
	        this.buffer_records = [];
	        this.metric_records = [];
	        this.calcTimer && this.calcTimer.stop();
	        this.recordTimer && this.recordTimer.stop();
	      }
	    }, {
	      key: "_onCalcTimerTick",
	      value: function _onCalcTimerTick(_ref2) {
	        var isStop = _ref2.isStop,
	            duration = _ref2.duration;
	
	        if (isStop) {
	          return;
	        }
	
	        var metrics = this.calcMetrics();
	
	        if (!metrics) {
	          return;
	        }
	
	        var bfTimes = this.calcBufferTimes();
	        var bf = this.calcBuffer();
	        var firstMetricRecord = metrics.records[0];
	        var lastMetricRecord = metrics.records[metrics.records.length - 1];
	        var record_pos = firstMetricRecord && firstMetricRecord.pos; // eslint-disable-line
	
	        var record_time = lastMetricRecord && lastMetricRecord.pos - firstMetricRecord.pos; // eslint-disable-line
	
	        var json = {
	          fps: metrics.fps,
	          bps: metrics.bps,
	          waiting_times: bfTimes.times,
	          buffer_length: bf.length,
	          decoded_fps: is('number', metrics.decodedFps) ? metrics.decodedFps : -1,
	          dropped_fps: is('number', metrics.droppedFps) ? metrics.droppedFps : -1,
	          audio_bps: is('number', metrics.audioBps) ? metrics.audioBps : -1,
	          video_bps: is('number', metrics.videoBps) ? metrics.videoBps : -1,
	          records_count: metrics.records.length,
	          record_pos: record_pos,
	          record_time: record_time,
	          metric_type: metrics.type,
	          buffer_detail: JSON.stringify(bf.buffer),
	          metrics_detail: JSON.stringify(metrics),
	          stream_url: this.stream_url,
	          metric_id: this.perf_id,
	          user_agent: navigator.userAgent,
	          refer: window.location.href
	        };
	        postPerf(this.perfLogUrl, json);
	      }
	    }, {
	      key: "_onRecordTimerTick",
	      value: function _onRecordTimerTick(_ref3) {
	        var isStop = _ref3.isStop;
	        !isStop && this.recordMetrics();
	      }
	    }, {
	      key: "_onWaiting",
	      value: function _onWaiting() {
	        this.buffer_records.push({
	          type: 'waiting',
	          pos: this.player.model.progress.getPosition(),
	          time: this._getTs()
	        });
	      }
	    }, {
	      key: "_onPlay",
	      value: function _onPlay() {
	        this.buffer_records.push({
	          type: 'play',
	          pos: this.player.model.progress.getPosition(),
	          time: this._getTs()
	        });
	        this.recordTimer.start();
	        this.calcTimer.start();
	      }
	    }, {
	      key: "_onPause",
	      value: function _onPause() {
	        this.recordTimer.tick();
	        this.recordTimer.stop();
	        this.calcTimer.tick();
	        this.calcTimer.stop();
	      }
	    }, {
	      key: "_getTs",
	      value: function _getTs() {
	        return new Date().getTime();
	      }
	    }]);
	
	    return Perf;
	  }(Model);
	
	  var TextTrack =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(TextTrack, _Model);
	
	    function TextTrack(player) {
	      var _this;
	
	      _classCallCheck(this, TextTrack);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(TextTrack).call(this, player));
	
	      _this.onPlayer(INTERNAL_PROVIDER_INITED, _this._onProviderInited.bind(_assertThisInitialized(_assertThisInitialized(_this))));
	
	      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('getTextTracks').method('setTextTrackEnable').method('setTextTrackDisable').method('getTextTrackCues').method('getTextTrackActiveCues');
	      return _this;
	    }
	    /**
	     * 获取所有的字幕轨道
	     */
	
	
	    _createClass(TextTrack, [{
	      key: "getTextTracks",
	      value: function getTextTracks() {
	        if (this.provider()) {
	          return this.provider().getTextTracks();
	        }
	
	        return [];
	      }
	      /**
	       * 获取轨道中所有的字幕
	       * @param {*} index
	       */
	
	    }, {
	      key: "getTextTrackCues",
	      value: function getTextTrackCues() {
	        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        if (this.provider()) return this.provider().getTextTrackCues(index);
	        return [];
	      }
	      /**
	       * 获取轨道应该显示的字幕
	       * @param {Number} index
	       */
	
	    }, {
	      key: "getTextTrackActiveCues",
	      value: function getTextTrackActiveCues() {
	        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        if (this.provider()) return this.provider().getTextTrackActiveCues(index);
	        return [];
	      }
	      /**
	       * 启用索引为index的字幕轨道，启用之后如果该轨道字幕变化，会触发cuechange事件
	       * @param {*} index
	       */
	
	    }, {
	      key: "setTextTrackEnable",
	      value: function setTextTrackEnable() {
	        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	        if (this.provider()) {
	          return this.provider().setTextTrackEnable(index);
	        }
	      }
	      /**
	       * 禁用索引为index的字幕轨道，禁用之后如果该轨道字幕变化，不会触发cuechange事件
	       * @param {*} index
	       */
	
	    }, {
	      key: "setTextTrackDisable",
	      value: function setTextTrackDisable() {
	        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	        if (this.provider()) {
	          return this.provider().setTextTrackDisable(index);
	        }
	      }
	    }, {
	      key: "_onProviderInited",
	      value: function _onProviderInited() {
	        if (!this.player._config.textTrackDisable) {
	          this.onProvider(PROVIDER_TEXTTRACKADD, this._onTexttrackAdd.bind(this));
	          this.onProvider(PROVIDER_TEXTTRACKCHANGE, this._onTexttrackChange.bind(this));
	          this.onProvider(PROVIDER_CUECHANGE, this._onCueChange.bind(this));
	        }
	      }
	    }, {
	      key: "_onCueChange",
	      value: function _onCueChange(_ref) {
	        var track = _ref.track,
	            cues = _ref.cues,
	            activeCues = _ref.activeCues;
	        this.player.trigger(OUTER_TEXT_TRACK_CUE_CHANGE, {
	          track: track,
	          cues: cues,
	          activeCues: activeCues,
	          type: OUTER_TEXT_TRACK_CUE_CHANGE
	        });
	      }
	    }, {
	      key: "_onTexttrackAdd",
	      value: function _onTexttrackAdd(track) {
	        this.player.trigger(OUTER_TEXT_TRACK_ADD, {
	          track: track,
	          type: OUTER_TEXT_TRACK_ADD
	        });
	      }
	    }, {
	      key: "_onTexttrackChange",
	      value: function _onTexttrackChange(tracks) {
	        this.player.trigger(OUTER_TEXT_TRACK_CHANGE, {
	          tracks: tracks,
	          type: OUTER_TEXT_TRACK_CHANGE
	        });
	      }
	    }]);
	
	    return TextTrack;
	  }(Model);
	
	  var Subtitle =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(Subtitle, _Model);
	
	    function Subtitle(player) {
	      var _this;
	
	      _classCallCheck(this, Subtitle);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Subtitle).call(this, player));
	      _this._fontSize = 0;
	      _this._borderRadius = 0;
	      _this._subtitleTrackIdx = -1; // 自动选择一个，选择之后就设置成track的索引
	
	      _this._showSubtitles = player._config.showSubtitle;
	      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('getShowSubtitle').method('setShowSubtitle').method('setShowingTextTrackIndex').method('getShowingTextTrackIndex');
	
	      _this.onPlayer(INTERNAL_PROVIDER_REMOVED, _this._onProviderRemoved.bind(_assertThisInitialized(_assertThisInitialized(_this))));
	
	      _this.onPlayer(OUTER_TEXT_TRACK_ADD, _this._onTextTrackAdd.bind(_assertThisInitialized(_assertThisInitialized(_this))));
	
	      _this.onPlayer(OUTER_TEXT_TRACK_CUE_CHANGE, _this._onCueChange.bind(_assertThisInitialized(_assertThisInitialized(_this))));
	
	      return _this;
	    }
	    /**
	     * 设置是否显示字幕
	     * @param {*} show
	     */
	
	
	    _createClass(Subtitle, [{
	      key: "setShowSubtitle",
	      value: function setShowSubtitle(show) {
	        show = !!show;
	
	        if (show && !this._isShowingSubtitles()) {
	          // 如果设置显示，但是当前没有显示字幕，那么显示一个
	          this._showRandomSubtitle();
	        }
	
	        if (!show && this._isShowingSubtitles()) {
	          // 如果设置不显示，但是当前有字幕在显示，那么关闭当前显示的字幕
	          this._clearShowingCues();
	
	          this._subtitleTrackIdx = -1;
	        }
	
	        this._showSubtitles = show;
	      }
	      /**
	       * 获取当前是否显示字幕
	       */
	
	    }, {
	      key: "getShowSubtitle",
	      value: function getShowSubtitle() {
	        return this._showSubtitles;
	      }
	      /**
	       * 设置显示该字幕轨道
	       * 将textTrack中索引为index的轨道显示到播放器上，仅能显示(captions/subtitles)
	       * 如果当前getSubtitles()返回false, 则还需要setSubtitles(true)
	       *
	       * @param {*} index
	       */
	
	    }, {
	      key: "setShowingTextTrackIndex",
	      value: function setShowingTextTrackIndex() {
	        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        var tracks = this.player.model.textTrack.getTextTracks();
	        var track = tracks[index];
	        if (index === this._subtitleTrackIdx) return;
	
	        if (track) {
	          // 禁用其他track, 因为如果有多个track enable，只有一个track能发出cueChange事件
	          if (this._subtitleTrackIdx >= 0) this.player.model.textTrack.setTextTrackDisable(this._subtitleTrackIdx);
	          this._subtitleTrackIdx = index; // index 仅在这里修改
	
	          this.player.model.textTrack.setTextTrackEnable(index); // 如果设置显示该轨道，但是轨道没启用，那么启用该轨道
	        }
	      }
	    }, {
	      key: "getShowingTextTrackIndex",
	      value: function getShowingTextTrackIndex() {
	        return this._subtitleTrackIdx;
	      }
	    }, {
	      key: "_onCueChange",
	      value: function _onCueChange(_ref) {
	        var track = _ref.track,
	            activeCues = _ref.activeCues;
	        var tracks = this.player.model.textTrack.getTextTracks();
	        var index = tracks.indexOf(track);
	
	        if (index === this._subtitleTrackIdx) {
	          this._showActiveCues(activeCues);
	        }
	      }
	    }, {
	      key: "_onTextTrackAdd",
	      value: function _onTextTrackAdd(_ref2) {
	        var track = _ref2.track;
	
	        if (this._showSubtitles && this._subtitleTrackIdx === -1) {
	          // 如果当前设置显示了字幕，但是没有一个可显示的，那么显示一个
	          this._showRandomSubtitle();
	        }
	      }
	      /**
	       * 设置显示中的字幕的字体大小和边框弧度
	       */
	
	    }, {
	      key: "_updateSubtitleStyle",
	      value: function _updateSubtitleStyle() {
	        var _this2 = this;
	
	        var subtitles = [].slice.call(document.querySelectorAll(".".concat(subtitleItem)));
	        subtitles.forEach(function (sub) {
	          sub.style.fontSize = _this2._fontSize + 'px';
	          sub.style.borderRadius = _this2._borderRadius + 'px';
	        });
	      }
	    }, {
	      key: "_onProviderRemoved",
	      value: function _onProviderRemoved() {
	        this._clearShowingCues();
	
	        this._subtitleTrackIdx = -1;
	      }
	      /**
	       * 当前是否正在显示字幕
	       */
	
	    }, {
	      key: "_isShowingSubtitles",
	      value: function _isShowingSubtitles() {
	        return this._showSubtitles && this._subtitleTrackIdx !== -1;
	      }
	      /**
	       * 选择一个subtitle或者caption track
	       */
	
	    }, {
	      key: "_selectSubtitleTrack",
	      value: function _selectSubtitleTrack() {
	        var tracks = this.player.model.textTrack.getTextTracks();
	        var firstSubtitle;
	        var firstHiddenSubtitle; // hidden通常是m3u8 manifest 设为default的subtitle
	
	        for (var i = 0; i < tracks.length; i++) {
	          if (tracks[i].kind === 'subtitles' || tracks[i].kind === 'captions') {
	            if (!firstSubtitle) {
	              firstSubtitle = {
	                index: i,
	                track: tracks[i]
	              };
	            }
	
	            if (tracks[i].mode === 'hidden' && !firstHiddenSubtitle) {
	              firstHiddenSubtitle = {
	                index: i,
	                track: tracks[i]
	              };
	            }
	          }
	        }
	
	        return firstHiddenSubtitle || firstSubtitle || {
	          index: -1,
	          track: null
	        };
	      }
	      /**
	       * 删除显示中的字幕
	       */
	
	    }, {
	      key: "_clearShowingCues",
	      value: function _clearShowingCues() {
	        var subtitleWrap = document.querySelector(".".concat(subtitle));
	        subtitleWrap.innerHTML = '';
	      }
	    }, {
	      key: "_showActiveCues",
	      value: function _showActiveCues(cues) {
	        if (!cues.length) return this._clearShowingCues();
	        cues.sort(function (c1, c2) {
	          var diff = c1.startTime - c2.startTime;
	
	          if (diff) {
	            return diff;
	          } else {
	            return c2.endTime - c1.endTime;
	          }
	        });
	        var style = "font-size: ".concat(this._fontSize, "px; border-radius: ").concat(this._borderRadius, "px");
	        var spans = cues.map(function (cue) {
	          var span = "<span class=\"".concat(subtitleItem, "\" style=\"").concat(style, "\">&nbsp;").concat(cue.text, "&nbsp;</span>");
	          return span;
	        });
	        var subtitleWrap = document.querySelector(".".concat(subtitle));
	        subtitleWrap.innerHTML = spans.join('<br>');
	      }
	      /**
	       * 根据播放器宽度来设置字幕的字体大小和边框弧度
	       * @param {*} playerWidth
	       */
	
	    }, {
	      key: "_setSubtitleSize",
	      value: function _setSubtitleSize(playerWidth) {
	        var borderRadiusMultiple = 0.003125;
	        var fontSizeMultiple = 0.025;
	        var minFontSize = 14;
	        var maxFontSize = 40;
	        var minBorderRadius = 1.5;
	        this._fontSize = Math.max(playerWidth * fontSizeMultiple, minFontSize);
	        this._fontSize = Math.min(this._fontSize, maxFontSize);
	        this._borderRadius = Math.max(playerWidth * borderRadiusMultiple, minBorderRadius);
	      }
	      /**
	       * 找到一个captions/subtitles 并显示它
	       */
	
	    }, {
	      key: "_showRandomSubtitle",
	      value: function _showRandomSubtitle() {
	        var _this$_selectSubtitle = this._selectSubtitleTrack(),
	            index = _this$_selectSubtitle.index;
	
	        if (index === -1) {
	          return false;
	        }
	
	        this.setShowingTextTrackIndex(index, true);
	        return true;
	      }
	    }]);
	
	    return Subtitle;
	  }(Model);
	
	  var OUTER_MYUN_SYNC_AVAILABLE = 'myunSyncAvailable';
	  var OUTER_MYUN_SYNC_MESSAGE = 'myunSyncMessage';
	
	  var MyunSync =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(MyunSync, _Model);
	
	    function MyunSync(player) {
	      var _this;
	
	      _classCallCheck(this, MyunSync);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(MyunSync).call(this, player)); // 当前目睹云同步是否可用
	
	      _this._available = false; // 目睹云同步时的track label对应m3u8 master里的name
	
	      _this._textTrackLabel = player._config.myunSyncTextTrackLabel; // 当前用于同步的字幕轨道
	
	      _this._myunSyncTrack = null; // 最新的同步信息
	
	      _this._myunMsgCue = null;
	
	      _this.onPlayer(INTERNAL_PROVIDER_REMOVED, _this._onProviderRemoved.bind(_assertThisInitialized(_assertThisInitialized(_this))));
	
	      _this.onPlayer(OUTER_TEXT_TRACK_ADD, _this._onTextTrackAdd.bind(_assertThisInitialized(_assertThisInitialized(_this))));
	
	      _this.onPlayer(OUTER_TEXT_TRACK_CUE_CHANGE, _this._onCueChange.bind(_assertThisInitialized(_assertThisInitialized(_this))));
	
	      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('getMyunSyncAvailable');
	      return _this;
	    }
	
	    _createClass(MyunSync, [{
	      key: "getMyunSyncAvailable",
	      value: function getMyunSyncAvailable() {
	        return this._available;
	      }
	    }, {
	      key: "_onProviderRemoved",
	      value: function _onProviderRemoved() {
	        this._myunSyncTrack = null;
	        this._available = false;
	        this._myunMsgCue = null;
	        this.player.trigger(OUTER_MYUN_SYNC_AVAILABLE, {
	          type: OUTER_MYUN_SYNC_AVAILABLE,
	          available: false
	        });
	      }
	    }, {
	      key: "_onTextTrackAdd",
	      value: function _onTextTrackAdd(_ref) {
	        var track = _ref.track;
	
	        if (track.label === this._textTrackLabel && track.kind === 'subtitles') {
	          var tracks = this.player.model.textTrack.getTextTracks();
	          var idx = tracks.indexOf(track);
	          this.player.model.textTrack.setTextTrackEnable(idx);
	          this._myunSyncTrack = track;
	          this._available = true;
	          this.player.trigger(OUTER_MYUN_SYNC_AVAILABLE, {
	            type: OUTER_MYUN_SYNC_AVAILABLE,
	            available: true
	          });
	        }
	      }
	    }, {
	      key: "_onCueChange",
	      value: function _onCueChange(_ref2) {
	        var _this2 = this;
	
	        var activeCues = _ref2.activeCues,
	            cues = _ref2.cues,
	            track = _ref2.track;
	        var cue = {};
	        if (track !== this._myunSyncTrack) return;
	
	        if (activeCues.length !== 0) {
	          cue = activeCues.pop();
	        } else if (isIOS()) {
	          // ios可能出现startTime和endTime一样的情况  此时activeCues长度为0
	          var currentTime = Math.floor(this.player._container.querySelector('video').currentTime);
	          cue = cues.find(function (cue) {
	            return currentTime === Math.floor(cue.startTime);
	          });
	          if (!cue || cue.startTime !== cue.endTime) return;
	        } else {
	          return;
	        }
	
	        if (cue === this._myunMsgCue) return; // 如果是同一个就不触发了
	
	        this._myunMsgCue = cue; // 后端的webvtt消息格式改过 兼容
	
	        var textList = JSON.parse(cue.text);
	
	        if (Array.isArray(textList) && textList[0].ts_ms && textList[0].content) {
	          textList.forEach(function (text) {
	            setTimeout(function () {
	              return _this2.player.trigger(OUTER_MYUN_SYNC_MESSAGE, {
	                type: OUTER_MYUN_SYNC_MESSAGE,
	                message: text.content || ''
	              });
	            }, text.ts_ms);
	          });
	        } else {
	          this.player.trigger(OUTER_MYUN_SYNC_MESSAGE, {
	            type: OUTER_MYUN_SYNC_MESSAGE,
	            message: cue.text,
	            cue: cue,
	            cues: cues
	          });
	        }
	      }
	    }]);
	
	    return MyunSync;
	  }(Model);
	
	  var orientation = {
	    isAvailable: function isAvailable() {
	      return !!(window.screen && window.screen.orientation);
	    },
	    lock: function lock(orientationLockType) {
	      var prom = window.screen.orientation.lock(orientationLockType);
	      return prom;
	    },
	    unlock: function unlock() {
	      window.screen.orientation.unlock();
	    },
	    getType: function getType() {
	      return window.screen.orientation.type;
	    },
	    getAngle: function getAngle() {
	      return window.screen.orientation.angle;
	    },
	    getOrientationObj: function getOrientationObj() {
	      return window.screen.orientation;
	    }
	  };
	
	  /**
	   * Orientation api还处于WIP状态，很多浏览器不支持，并且api可能被修改
	   */
	
	  var Orientation =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(Orientation, _Model);
	
	    function Orientation(player) {
	      var _this;
	
	      _classCallCheck(this, Orientation);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Orientation).call(this, player));
	      _this._onFullscreen = _this._onFullscreen.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	      _this._available = orientation.isAvailable();
	
	      if (_this._available) {
	        _this.onPlayer(OUTER_FULLSCREEN, _this._onFullscreen);
	      }
	
	      return _this;
	    }
	
	    _createClass(Orientation, [{
	      key: "_onFullscreen",
	      value: function _onFullscreen(_ref) {
	        var fullscreen = _ref.fullscreen;
	
	        if (fullscreen) {
	          if (this.provider()) {
	            var videoWidth = this.provider().getWidth();
	            var videoHeight = this.provider().getHeight();
	            var screenAspect = getScrenAspect();
	            var lockType = '';
	
	            if (videoWidth && videoHeight) {
	              var videoRatio = videoWidth / videoHeight;
	              var screenRatio = screenAspect.width / screenAspect.height;
	
	              if (videoRatio > screenRatio) {
	                lockType = 'landscape';
	              } else {
	                lockType = 'portrait';
	              }
	
	              orientation.lock(lockType).catch(noop);
	            }
	          }
	        } else {
	          orientation.unlock();
	        }
	      }
	    }]);
	
	    return Orientation;
	  }(Model);
	
	  var RecordRestrict =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(RecordRestrict, _Model);
	
	    function RecordRestrict(player) {
	      var _this;
	
	      _classCallCheck(this, RecordRestrict);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(RecordRestrict).call(this, player));
	      _this._is360loneWindow = false;
	      _this._timer = 0;
	      var _360loneStrict = player._config.recordRestrict.enable360LoneWindowCloseStream;
	
	      var shouldListen = _360loneStrict && (isChrome() || isIE());
	
	      shouldListen && _this.oncePlayer(INTERNAL_PROVIDER_INITED, function () {
	        player.timer.raf.on('tick', function (_ref) {
	          var isStop = _ref.isStop;
	
	          if (!isStop) {
	            _this._onTimerTick();
	          }
	        });
	      });
	      return _this;
	    }
	
	    _createClass(RecordRestrict, [{
	      key: "_onTimerTick",
	      value: function _onTimerTick() {
	        var _this2 = this;
	
	        var is360loneWindow = this._detect360loneWindow();
	
	        var player = this.player;
	
	        if (this._is360loneWindow !== is360loneWindow) {
	          this._is360loneWindow = is360loneWindow;
	
	          if (this._is360loneWindow) {
	            clearTimeout(this._timer);
	            this._timer = setTimeout(function () {
	              _this2._showRecordRestrict360();
	
	              player.stop();
	
	              _this2._removeProviderElement();
	            }, 20);
	          } else {
	            this._hideRecordREstrict360();
	          }
	        }
	
	        if (this._is360loneWindow) {
	          player.dom.controllerWrap.style.display = 'none';
	        }
	      }
	    }, {
	      key: "_showRecordRestrict360",
	      value: function _showRecordRestrict360() {
	        var dom = this.player.dom.recordRestrict360;
	        var styleText = 'position:absolute;top:0;left:0;right:0;bottom:0;background-color:#000;z-index:9999;';
	        var browserCompatiableStyle = isIE() ? '' : 'top:50%;margin-top:-0.75em;';
	        dom.setAttribute('style', styleText);
	        dom.innerHTML = "<div class=\"".concat(reset, "\" style=\"position:absolute;").concat(browserCompatiableStyle, "width:100%;text-align:center;color:#fff;font-size:1.25em;line-height:1.5em;\">\u89C6\u9891\u7981\u6B62\u5728\u5C0F\u7A97\u53E3\u64AD\u653E\uFF0C\u8BF7\u9000\u51FA\u5C0F\u7A97\u540E\u5237\u65B0\u9875\u9762\u7EE7\u7EED\u89C2\u770B</div>");
	      }
	    }, {
	      key: "_hideRecordREstrict360",
	      value: function _hideRecordREstrict360() {
	        var dom = this.player.dom.recordRestrict360;
	        dom.setAttribute('style', '');
	      }
	    }, {
	      key: "_detect360loneWindow",
	      value: function _detect360loneWindow() {
	        var provider = this.player._provider;
	        var dom = this.player.dom;
	        var container = dom.container;
	
	        if (provider) {
	          if (provider.html5) {
	            // 360小窗会给div加上 visibility:hidden opacity:0 但是播放器不会
	            var div = container.querySelector('div');
	            var styleAttr = div.getAttribute('style') || '';
	            var is360loneWindow = styleAttr.indexOf('visibility:hidden') >= 0 && styleAttr.indexOf('opacity:0') >= 0;
	            return is360loneWindow;
	          } else if (provider.flash) {
	            var flash = document.querySelector('object');
	            var width = flash.style.width; // 360小窗会给object标签加上width，但是播放器不会
	
	            return !!width;
	          }
	        } // 如果不存在provider，那就返回之前的状态
	
	
	        return this._is360loneWindow;
	      }
	    }, {
	      key: "_removeProviderElement",
	      value: function _removeProviderElement() {
	        var videoWrap = this.player.dom.videoWrap;
	        var video = videoWrap.querySelector('video');
	        var object = videoWrap.querySelector('object');
	
	        if (video) {
	          videoWrap.removeChild(video);
	        }
	
	        if (object) {
	          videoWrap.removeChild(object);
	        }
	      }
	    }, {
	      key: "remove",
	      value: function remove() {
	        clearTimeout(this._timer);
	
	        _get(_getPrototypeOf(RecordRestrict.prototype), "remove", this).call(this);
	      }
	    }]);
	
	    return RecordRestrict;
	  }(Model);
	
	  var LiveEndDetect =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(LiveEndDetect, _Model);
	
	    function LiveEndDetect(player) {
	      var _this;
	
	      _classCallCheck(this, LiveEndDetect);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(LiveEndDetect).call(this, player));
	      _this._enableDetect = false;
	      _this._isLive = false;
	      _this._streamType = '';
	      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('setLiveEndDetect').method('getLiveEndDetect');
	
	      _this.onPlayer(INTERNAL_PROVIDER_INITED, _this._onProviderInit.bind(_assertThisInitialized(_assertThisInitialized(_this))));
	
	      _this.onPlayer(OUTER_IDLE, _this._onIdle.bind(_assertThisInitialized(_assertThisInitialized(_this))));
	
	      _this.onPlayer(OUTER_ERROR, _this._onError.bind(_assertThisInitialized(_assertThisInitialized(_this))));
	
	      _this.onPlayer(OUTER_BUFFER, _this._onBuffer.bind(_assertThisInitialized(_assertThisInitialized(_this)))); // time事件比较频繁，所以是x5才监听
	
	
	      isX5Layer() && _this.onPlayer(OUTER_TIME, _this._onTime.bind(_assertThisInitialized(_assertThisInitialized(_this))));
	      return _this;
	    }
	
	    _createClass(LiveEndDetect, [{
	      key: "setLiveEndDetect",
	      value: function setLiveEndDetect(enable) {
	        this._enableDetect = !!enable;
	      }
	    }, {
	      key: "getLiveEndDetect",
	      value: function getLiveEndDetect() {
	        return this._enableDetect;
	      }
	    }, {
	      key: "_onProviderInit",
	      value: function _onProviderInit(_ref) {
	        var isLive = _ref.isLive,
	            type = _ref.type;
	        this._isLive = isLive;
	        this._streamType = type;
	      }
	    }, {
	      key: "_shouldDetect",
	      value: function _shouldDetect(streamType) {
	        if (streamType) {
	          return this._enableDetect && this._isLive && this._streamType === streamType;
	        }
	
	        return this._enableDetect && this._isLive;
	      }
	    }, {
	      key: "_triggerEvt",
	      value: function _triggerEvt() {
	        this.player.trigger(OUTER_LIVE_END_DETECT, {
	          type: OUTER_LIVE_END_DETECT,
	          liveEnd: true
	        });
	      }
	    }, {
	      key: "_onIdle",
	      value: function _onIdle() {
	        // flv/hls 断流会idle
	        (this._shouldDetect('flv') || this._shouldDetect('hls') || this._shouldDetect('m3u8')) && this._triggerEvt();
	      }
	    }, {
	      key: "_onError",
	      value: function _onError(_ref2) {
	        var fatal = _ref2.fatal;
	        // hls.js/flash
	        (this._shouldDetect('m3u8') || this._shouldDetect('hls')) && fatal && this._triggerEvt();
	      }
	    }, {
	      key: "_onBuffer",
	      value: function _onBuffer() {
	        // rtmp, mobile hls
	        (this._shouldDetect('rtmp') || this._shouldDetect('hls') || this._shouldDetect('m3u8')) && this._triggerEvt();
	      }
	    }, {
	      key: "_onTime",
	      value: function _onTime(_ref3) {
	        var position = _ref3.position;
	        // x5
	        this._shouldDetect('') && this._triggerEvt();
	      }
	    }]);
	
	    return LiveEndDetect;
	  }(Model);
	
	  var PlaybackMessage =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(PlaybackMessage, _Model);
	
	    function PlaybackMessage(player) {
	      var _this;
	
	      _classCallCheck(this, PlaybackMessage);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(PlaybackMessage).call(this, player));
	
	      _this.onPlayer(INTERNAL_PROVIDER_INITED, _this._onProviderInited.bind(_assertThisInitialized(_assertThisInitialized(_this))));
	
	      _this.onPlayer(INTERNAL_PROVIDER_REMOVED, _this._onProviderRemoved.bind(_assertThisInitialized(_assertThisInitialized(_this))));
	
	      _this.msgList = null;
	      _this.lastMsgIdx = -2;
	      return _this;
	    }
	
	    _createClass(PlaybackMessage, [{
	      key: "_onTick",
	      value: function _onTick() {
	        if (!this.msgList) {
	          return;
	        }
	
	        var pos = this.player.model.progress.getPosition();
	        var idx;
	
	        for (var i = 0; i < this.msgList.length; i++) {
	          var msg = this.msgList[i];
	
	          if (pos < msg.time) {
	            idx = i - 1;
	            break;
	          }
	        }
	
	        if (idx === undefined) {
	          idx = this.msgList.length - 1;
	        }
	
	        if (idx !== this.lastMsgIdx) {
	          this.lastMsgIdx = idx;
	          this.player.trigger('playbackMessage', {
	            type: 'playbackMessage',
	            prev: this.msgList[idx] || null,
	            next: this.msgList[idx + 1] || null
	          });
	        }
	      }
	    }, {
	      key: "_onProviderInited",
	      value: function _onProviderInited() {
	        var activeSource = getActive.call(this.player);
	        this.msgList = is('array', activeSource.playbackMessages) ? activeSource.playbackMessages : null;
	
	        if (this.msgList) {
	          this.msgList.sort(function (msg1, msg2) {
	            return msg1.time - msg2.time;
	          });
	        }
	      }
	    }, {
	      key: "_onProviderRemoved",
	      value: function _onProviderRemoved() {
	        this.msgList = null;
	        this.lastMsgIdx = -2;
	      }
	    }]);
	
	    return PlaybackMessage;
	  }(Model);
	
	  var PlayBackRate =
	  /*#__PURE__*/
	  function (_Modal) {
	    _inherits(PlayBackRate, _Modal);
	
	    function PlayBackRate(player) {
	      var _this2;
	
	      _classCallCheck(this, PlayBackRate);
	
	      _this2 = _possibleConstructorReturn(this, _getPrototypeOf(PlayBackRate).call(this, player));
	      _this2.isMobile = isMobile();
	      _this2.dom = null;
	
	      _this2.createDom();
	
	      _this2._playbackRate = 1;
	      _this2._init = null;
	
	      _this2.setPlaybackRates(player._config.playbackRates);
	
	      _this2.onPlayer(INTERNAL_PROVIDER_INITED, function () {
	        _this2._init !== null && (_this2._init = true);
	
	        _this2.initPlaybackRates();
	      });
	
	      _this2.onPlayer(INTERNAL_PROVIDER_REMOVED, function () {
	        _this2.resetState();
	      }); //  保留已选择的倍速播放 _init字段避免暂停后播放触发setPlaybackRate事件 
	
	
	      _this2.onPlayer(OUTER_BEFORE_PLAY, function () {
	        _this2._init && _this2.player.setPlaybackRate(_this2._playbackRate);
	        _this2._init = false;
	      });
	
	      _this2.qsPopup = tooltip(player.dom.playbackRate, {
	        trigger: 'click',
	        content: _this2.dom,
	        container: player.dom.container,
	        class: _this2.isMobile ? "mudu-popup ".concat(mobile) : 'mudu-popup',
	        getMaxHeight: function getMaxHeight(_ref) {
	          var height = _ref.height;
	          return _this2.isMobile ? height : height - 70;
	        }
	      });
	
	      _this2.qsPopup.show();
	
	      _this2.dom.addEventListener('click', _this2.qsPopup.hide);
	
	      Delegator(_this2.player, _assertThisInitialized(_assertThisInitialized(_this2))).method('setPlaybackRates').method('switchPlaybackRate');
	      return _this2;
	    }
	
	    _createClass(PlayBackRate, [{
	      key: "setPlaybackRates",
	      value: function setPlaybackRates(playbackRates) {
	        if (!is('array', playbackRates)) playbackRates = [];
	        this.rateList = playbackRates;
	        this.playbackRatesLabel = this.player._config.playbackRatesLabel || this.lang.Speed;
	        var isIdle = this.player.getState() === 'idle';
	
	        if (!isIdle) {
	          if (!this._init) {
	            this._playbackRate = 1;
	            setActiveRate.call(this.player, 'null');
	            this.player.setPlaybackRate(this._playbackRate);
	          }
	
	          this.initPlaybackRates();
	        }
	      }
	    }, {
	      key: "switchPlaybackRate",
	      value: function switchPlaybackRate(playbackRate) {
	        var state = this.player.getState();
	        if (state === 'idle' || state === 'error' || this.rateList.length <= 0) return;
	        var index = this.rateList.findIndex(function (item) {
	          return playbackRate === item.playbackRate;
	        });
	
	        if (index !== -1) {
	          var items = this.dom.querySelectorAll('[type="value"]');
	          this.handlePlaybackRate(index, items);
	        }
	      }
	    }, {
	      key: "handlePlaybackRate",
	      value: function handlePlaybackRate(i, items) {
	        this._playbackRate = this.rateList[i].playbackRate * 1;
	        this.player.setPlaybackRate(this._playbackRate);
	        setActiveRate.call(this.player, i);
	        this.player.dom.playbackRate.innerHTML = this.rateList[i].label;
	        this.rateList.map(function (rate, index) {
	          classList(items[index]).remove(active);
	          classList(items[index]).add(index === i ? active : '');
	        });
	        this.qsPopup.hide();
	      }
	    }, {
	      key: "createDom",
	      value: function createDom() {
	        /* prettier-ignore */
	        var menu = "<div class=\"".concat(this.isMobile ? playRatePanelMobile : '', "\">\n      <div class=\"").concat(reset, " ").concat(panel, " ").concat(playRatePanel, "\">\n        <div class=\"").concat(reset, " ").concat(panelMenu, "\"></div>\n      </div>\n    </div>");
	        this.dom = stringToDom(menu);
	      }
	    }, {
	      key: "initPlaybackRates",
	      value: function initPlaybackRates() {
	        this.resetState();
	        this.updateRateItem();
	        this.updateControlRate();
	        this.updateSwitchText();
	      }
	    }, {
	      key: "resetState",
	      value: function resetState() {
	        // this.player.setPlaybackRate(1)
	        // setActiveRate.call(this.player, 3); // 清空选中记录
	        this.qsPopup.hide();
	      }
	    }, {
	      key: "updateControlRate",
	      value: function updateControlRate() {
	        var len = this.rateList.length;
	        var isLive = getActive.call(this.player).isLive;
	        var container = this.player.dom.container; // 以下三种状态不支持倍速播放
	        // 1. 直播状态下 2.没有配置倍速播放  3.不支持倍速播放的播放器(flash)
	
	        var hide = isLive || len < 1 || !this.player._provider || !this.player._provider.isPlaybackRateSupported;
	        classList(container).remove(playrateReg);
	        classList(container).add(hide ? hidePlaybackRate : showPlaybackRate);
	      }
	    }, {
	      key: "updateSwitchText",
	      value: function updateSwitchText() {
	        var activeRate = this.rateList.filter(function (v) {
	          return v.active;
	        })[0];
	
	        if (activeRate) {
	          this.player.dom.playbackRate.innerHTML = activeRate.label;
	        } else {
	          this.player.dom.playbackRate.innerHTML = this.playbackRatesLabel;
	        }
	      }
	    }, {
	      key: "updateRateItem",
	      value: function updateRateItem() {
	        var _this3 = this;
	
	        var itemStr = this.rateList.map(function (v, i) {
	          return "<div class=\"".concat(reset, " ").concat(menuitem, "\" type=\"value\" value=\"").concat(i, "\" data-content-before=").concat(_this3.playbackRatesLabel, ">\n          <div class=\"").concat(reset, " ").concat(menuitemContent, "\">").concat(v.label, "</div>\n          </div>");
	        }).join('');
	        this.dom.querySelector(".".concat(playRatePanel)).innerHTML = itemStr;
	        var items = this.dom.querySelectorAll('[type="value"]');
	
	        var _this = this;
	
	        var _loop = function _loop(i) {
	          var item = items[i];
	          var rate = _this.rateList[i].playbackRate;
	
	          item.onclick = function () {
	            _this.handlePlaybackRate(i, items); // _this._playbackRate = rate*1
	            // _this.player.setPlaybackRate(_this._playbackRate);
	            // setActiveRate.call(_this.player, i);
	            // _this.player.dom.playbackRate.innerHTML = _this.rateList[i].label;
	            // _this.rateList.map((rate, index) => {
	            //   classList(items[index]).remove(cssClass.active);
	            //   classList(items[index]).add(index === i ? cssClass.active : '');
	            // });
	            // _this.qsPopup.hide();
	
	          };
	
	          classList(item).add(rate === _this._playbackRate ? active : ''); // 默认播放倍速playbackrate是正常速度1
	          // item.querySelector(`.${cssClass.menuitemLabel}`).innerHTML = rate === 1
	          //   ? `<span class="${cssClass.reset} ${icons.check}"></span>`
	          //   : ''
	        };
	
	        for (var i = 0; i < items.length; i++) {
	          _loop(i);
	        }
	      }
	    }]);
	
	    return PlayBackRate;
	  }(Model);
	
	  /**
	   * object-fit 算法实现
	   */
	  // Cover
	  function cover(containerSize, elementSize) {
	    var containerRatio = containerSize.width / containerSize.height;
	    var elementRatio = elementSize.width / elementSize.height;
	    var width, height;
	
	    if (containerRatio > elementRatio) {
	      width = containerSize.width;
	      height = containerSize.width / elementRatio;
	    } else {
	      width = containerSize.height * elementRatio;
	      height = containerSize.height;
	    }
	
	    return {
	      width: width,
	      height: height
	    };
	  } // Contain
	
	  function contain(containerSize, elementSize) {
	    var containerRatio = containerSize.width / containerSize.height;
	    var elementRatio = elementSize.width / elementSize.height;
	    var width, height;
	
	    if (containerRatio < elementRatio) {
	      width = containerSize.width;
	      height = containerSize.width / elementRatio;
	    } else {
	      width = containerSize.height * elementRatio;
	      height = containerSize.height;
	    }
	
	    return {
	      width: width,
	      height: height
	    };
	  } // Fill
	
	  function fill(containerSize) {
	    return containerSize;
	  } // None
	
	  function none(elementSize) {
	    return elementSize;
	  } // ScaleDown
	
	  function scaleDown(containerSize, elementSize) {
	    if (elementSize.width > containerSize.width || elementSize.height > containerSize.height) {
	      return contain(containerSize, elementSize);
	    } else {
	      return none(containerSize);
	    }
	  }
	
	  var eventEmitter = new EventEmitter();
	
	  function getDefaultOptions$1() {
	    return {
	      designWidth: 750,
	      // fontSize、marinXXX 等一些需要像素值的属性以多宽为基准，缩放时它们会自适应
	      type: 'text',
	      // 水印类型，接受 'text' | 'image'
	      data: '',
	      // 水印内容，type 为 'text' 时接受一个字符串，type 为 'image' 时接受一个 Image 或 一个 Image 地址
	      placement: 'repeat',
	      // 水印放置规则，接受 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right' |'repeat' | 'random'
	      opacity: 0.5,
	      // 透明度
	      fontSize: 16,
	      // 文字大小（type 为 'text' 时生效）
	      fontFamily: 'PingFang SC',
	      // 字体类型（type 为 'text' 时生效）
	      color: '#FFFFFF',
	      // 文字颜色（type 为 'text' 时生效）
	      rotate: -25,
	      // 右边距（placement 为 'repeat' 时生效）
	      marginTop: 8,
	      // 上边距（placement 为 'top-left'、'top-right' 时生效）
	      marginRight: 8,
	      // 右边距（placement 为 'top-right'、'bottom-right' 时生效）
	      marginBottom: 8,
	      // 下边距（placement 为 'bottom-left'、'bottom-right' 时生效）
	      marginLeft: 8,
	      // 左边距（placement 为 'left-bop'、'bottom-left' 时生效）
	      // 每个 repeat 元素的大小（placement 为 'repeat' 时有效）
	      cellSize: {
	        width: 250,
	        height: 140.625
	      },
	      imageSize: null,
	      // 图片元素大小（type 为 'image' 时有效）
	      autoRandom: 5 * 1000 // 多久自动随机一次位置，0 表示不自动随机（placement 为 'random' 时生效）
	
	    };
	  } // video 标签拿 videoWidth、videoHeight 是有延迟的，
	  // chrome 上 onloadedmetadata 触发后就能拿到，但 ios 上要晚点才行，android 上甚至要更晚
	
	
	  function ensureMetrics(player, cb) {
	    var timer = null;
	
	    var check = function check() {
	      var metrics = player.getMetrics() || {};
	
	      if (metrics.videoWidth > 1 && metrics.videoWidth > 1) {
	        cb(metrics);
	      } else {
	        timer = setTimeout(check, 100);
	      }
	    };
	
	    check();
	    return function () {
	      return timer && clearTimeout(timer);
	    };
	  }
	
	  var Watermark =
	  /*#__PURE__*/
	  function (_Model) {
	    _inherits(Watermark, _Model);
	
	    function Watermark(player) {
	      var _this;
	
	      _classCallCheck(this, Watermark);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Watermark).call(this, player));
	      _this.config = _this.player._config;
	      _this.container = _this.player.dom.watermark;
	      _this.watermarkTimers = [];
	      Delegator(_this.player, _assertThisInitialized(_assertThisInitialized(_this))).method('setWatermark').method('clearWatermark');
	
	      _this.subEvents();
	
	      return _this;
	    }
	
	    _createClass(Watermark, [{
	      key: "handleResize",
	      value: function handleResize() {
	        if (!this.player.dom) return;
	        var wrap = this.player.dom.container;
	        var content = this.player.dom.watermark;
	        var wrapSize = {
	          width: wrap.offsetWidth,
	          height: wrap.offsetHeight
	        };
	        var contentSize = {
	          width: content.offsetWidth,
	          height: content.offsetHeight
	        };
	        var expectedSize;
	
	        switch (this.config.stretching) {
	          case 'contain':
	            expectedSize = contain(wrapSize, contentSize);
	            break;
	
	          case 'cover':
	            expectedSize = cover(wrapSize, contentSize);
	            break;
	
	          case 'fill':
	            expectedSize = fill(wrapSize);
	            break;
	
	          case 'none':
	            expectedSize = none(contentSize);
	            break;
	
	          case 'scale-down':
	            expectedSize = scaleDown(wrapSize, contentSize);
	            break;
	        }
	
	        var sx = expectedSize.width / contentSize.width;
	        var sy = expectedSize.height / contentSize.height;
	        setStyle(content, {
	          transform: "scale(".concat(sx, ", ").concat(sy === sx ? sx : sy, ") translate(-50%, -50%)"),
	          color: '#fff'
	        });
	      }
	    }, {
	      key: "subEvents",
	      value: function subEvents() {
	        var _this2 = this;
	
	        this.removeResizeEventListener = onResize(this.player.dom.container, function () {
	          _this2.handleResize();
	        });
	        this.onPlayer(INTERNAL_PROVIDER_REMOVED, function () {
	          _this2.clearWatermark();
	
	          _this2.w = _this2.h = 0;
	        });
	        this.onPlayer(INTERNAL_PROVIDER_INITED, function () {
	          _this2.player.off(OUTER_PLAY, _this2.outerPlayEventListener);
	
	          _this2.outerPlayEventListener = _this2.player.once(OUTER_PLAY, function () {
	            _this2.cancelEnsureMetrics && _this2.cancelEnsureMetrics();
	            _this2.cancelEnsureMetrics = ensureMetrics(_this2.player, function (_ref) {
	              var videoWidth = _ref.videoWidth,
	                  videoHeight = _ref.videoHeight;
	              _this2.w = videoWidth;
	              _this2.h = videoHeight;
	
	              _this2.setWatermark();
	            });
	          });
	        });
	      }
	    }, {
	      key: "setWatermark",
	      value: function setWatermark() {
	        var watermark = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.config.watermark;
	        this.config.watermark = watermark; // 有宽高直接画，没宽高则等测量完毕再画
	
	        if (this.w > 1 && this.h > 1) {
	          setStyle(this.container, {
	            width: this.w + 'px',
	            height: this.h + 'px'
	          });
	          this.handleResize();
	          if (is('function', watermark)) return this.customRender(watermark);
	          if (is('object', watermark)) watermark = [watermark];
	
	          if (is('array', watermark)) {
	            this.clearWatermark();
	            this.render(watermark);
	          }
	        }
	      }
	    }, {
	      key: "render",
	      value: function render(optsArr) {
	        for (var i = 0; i < optsArr.length; i++) {
	          // 合并配置
	          var opts = this.resolveOptions(optsArr[i]);
	
	          switch (opts.placement) {
	            case 'top-left':
	              this.genTopLeft(opts);
	              break;
	
	            case 'top-right':
	              this.genTopRight(opts);
	              break;
	
	            case 'bottom-left':
	              this.genBottomLeft(opts);
	              break;
	
	            case 'bottom-right':
	              this.genBottomRight(opts);
	              break;
	
	            case 'repeat':
	              this.genRepeat(opts);
	              break;
	
	            case 'random':
	              this.genRandom(opts);
	              break;
	          }
	        }
	      }
	    }, {
	      key: "customRender",
	      value: function customRender(fn) {
	        var _this3 = this;
	
	        var promise = fn();
	
	        if (promise && promise.then) {
	          promise.then(function (dom) {
	            if (dom && dom instanceof HTMLElement) {
	              _this3.clearWatermark();
	
	              _this3.container.appendChild(dom);
	            }
	          });
	        }
	      }
	    }, {
	      key: "clearWatermark",
	      value: function clearWatermark() {
	        this.container.innerHTML = '';
	
	        while (this.watermarkTimers.length) {
	          clearInterval(this.watermarkTimers.pop());
	        }
	      }
	    }, {
	      key: "resolveOptions",
	      value: function resolveOptions(opts) {
	        opts = JSON.parse(JSON.stringify(opts));
	
	        var mergedOpts = _objectSpread({}, getDefaultOptions$1(), opts);
	
	        var scale = this.w / mergedOpts.designWidth;
	        mergedOpts['fontSize'] *= scale;
	        mergedOpts['marginTop'] *= scale;
	        mergedOpts['marginRight'] *= scale;
	        mergedOpts['marginBottom'] *= scale;
	        mergedOpts['marginLeft'] *= scale;
	        mergedOpts['cellSize']['width'] *= scale;
	        mergedOpts['cellSize']['height'] *= scale;
	
	        if (mergedOpts['imageSize']) {
	          if (is('number', mergedOpts['imageSize']['width'])) {
	            mergedOpts['imageSize']['width'] *= scale;
	          }
	
	          if (is('number', mergedOpts['imageSize']['height'])) {
	            mergedOpts['imageSize']['height'] *= scale;
	          }
	        } else {
	          mergedOpts['imageSize'] = {
	            width: 'auto',
	            height: 'auto'
	          };
	        }
	
	        return mergedOpts;
	      } // 随机
	
	    }, {
	      key: "genRandom",
	      value: function genRandom(opts) {
	        var _this4 = this;
	
	        var el = this.resolveElement(opts);
	
	        var upsetPos = function upsetPos() {
	          setStyle(el, {
	            top: clamp(random(0, _this4.h), 0, _this4.h - el.offsetHeight) + 'px',
	            left: clamp(random(0, _this4.w), 0, _this4.w - el.offsetWidth) + 'px'
	          });
	        };
	
	        var handle = function handle() {
	          if (opts.autoRandom > 0) {
	            var timer = setInterval(function () {
	              upsetPos();
	            }, opts.autoRandom);
	
	            _this4.watermarkTimers.push(timer);
	          }
	
	          upsetPos();
	        };
	
	        if (opts.type === 'image') {
	          el.onload = function () {
	            handle();
	          };
	        } else {
	          handle();
	        }
	
	        this.container.appendChild(el);
	      } // 左上角
	
	    }, {
	      key: "genTopLeft",
	      value: function genTopLeft(opts) {
	        var el = this.resolveElement(opts);
	        setStyle(el, {
	          top: opts.marginTop + 'px',
	          left: opts.marginLeft + 'px'
	        });
	        this.container.appendChild(el);
	      } // 右上角
	
	    }, {
	      key: "genTopRight",
	      value: function genTopRight(opts) {
	        var el = this.resolveElement(opts);
	        setStyle(el, {
	          top: opts.marginTop + 'px',
	          right: opts.marginRight + 'px'
	        });
	        this.container.appendChild(el);
	      } // 左下角
	
	    }, {
	      key: "genBottomLeft",
	      value: function genBottomLeft(opts) {
	        var el = this.resolveElement(opts);
	        setStyle(el, {
	          bottom: opts.marginBottom + 'px',
	          left: opts.marginLeft + 'px'
	        });
	        this.container.appendChild(el);
	      } // 右下角
	
	    }, {
	      key: "genBottomRight",
	      value: function genBottomRight(opts) {
	        var el = this.resolveElement(opts);
	        setStyle(el, {
	          bottom: opts.marginBottom + 'px',
	          right: opts.marginRight + 'px'
	        });
	        this.container.appendChild(el);
	      } // 平铺
	
	    }, {
	      key: "genRepeat",
	      value: function genRepeat(opts) {
	        var cellWidth = opts.cellSize.width;
	        var cellHeight = opts.cellSize.height;
	
	        for (var row = 0; row < this.w / cellWidth; row++) {
	          for (var col = 0; col < this.h / cellHeight; col++) {
	            var cellWrap = document.createElement('div');
	            classList(cellWrap).add('mudu-watermark-cell-wrap');
	            var el = this.resolveElement(opts);
	            setStyle(cellWrap, {
	              top: col * cellHeight + 'px',
	              left: row * cellWidth + 'px',
	              width: cellWidth + 'px',
	              height: cellHeight + 'px',
	              transform: "rotate(".concat(opts.rotate, "deg)")
	            });
	            cellWrap.appendChild(el);
	            this.container.appendChild(cellWrap);
	          }
	        }
	      }
	    }, {
	      key: "resolveElement",
	      value: function resolveElement(opts) {
	        if (opts.type === 'text') {
	          return this.resolveTextElement(opts);
	        } else if (opts.type === 'image') {
	          return this.resolveImageElement(opts);
	        }
	      }
	    }, {
	      key: "resolveTextElement",
	      value: function resolveTextElement(opts) {
	        var el = document.createElement('span');
	        el.innerHTML = opts.data;
	        setStyle(el, {
	          fontFamily: opts.fontFamily,
	          fontSize: opts.fontSize + 'px',
	          color: opts.color,
	          opacity: opts.opacity
	        });
	        classList(el).add('mudu-watermark-text');
	        return el;
	      }
	    }, {
	      key: "resolveImageElement",
	      value: function resolveImageElement(opts) {
	        var el = document.createElement('img'); // el.crossOrigin = 'Anonymous'
	
	        el.src = opts.data;
	        setStyle(el, {
	          opacity: opts.opacity,
	          width: opts.imageSize.width + 'px',
	          height: opts.imageSize.height + 'px'
	        });
	        classList(el).add('mudu-watermark-image');
	        return el;
	      }
	    }, {
	      key: "remove",
	      value: function remove() {
	        this.clearWatermark();
	        this.removeResizeEventListener && this.removeResizeEventListener();
	      }
	    }]);
	
	    return Watermark;
	  }(Model);
	
	  function initModel() {
	    this.model.fullscreen = new Fullsreen(this);
	    this.model.video = new Video(this);
	    this.model.progress = new Progress(this);
	    this.model.controls = new Controls(this);
	    this.model.volume = new Volume(this);
	    this.model.playlist = new Playlist(this);
	    this.model.hotkeys = new HotKeys(this);
	    this.model.resize = new Resize(this);
	    this.model.stretch = new Stretch(this);
	    this.model.logo = new Logo(this);
	    this.model.focus = new Focus(this);
	    this.model.bezel = new Bezel(this);
	    this.model.background = new Background(this);
	    this.model.dom = new Dom(this);
	    this.model.title = new Title(this);
	    this.model.contextMenu = new ContextMenu(this);
	    this.model.error = new Error$1(this);
	    this.model.progressPopup = new ProgressPopup(this);
	    this.model.notice = new Notice(this);
	    this.model.qualitySwitch = new QualitySwitch(this);
	    this.model.perf = new Perf(this);
	    this.model.textTrack = new TextTrack(this);
	    this.model.subtitle = new Subtitle(this);
	    this.model.myunSync = new MyunSync(this);
	    this.model.orientation = new Orientation(this);
	    this.model.recordRestrict = new RecordRestrict(this);
	    this.model.liveEndDetect = new LiveEndDetect(this);
	    this.model.playbackMessage = new PlaybackMessage(this);
	    this.model.playbackRate = new PlayBackRate(this);
	    this.model.watermark = new Watermark(this);
	    this.trigger(INTERNAL_MODEL_INITED);
	  }
	  function destroyModel() {
	    for (var i in this.model) {
	      this.model[i].remove();
	    }
	  }
	
	  function initTimer() {
	    var _this = this;
	
	    this.timer = {};
	    var bufferDetectGap = this._config.bufferDetectGap;
	
	    if (!is('number', bufferDetectGap) || isNaN(bufferDetectGap) || bufferDetectGap <= 0) {
	      bufferDetectGap = 200;
	    }
	
	    this.timer.loading = new Timer({
	      type: 'loading',
	      gap: bufferDetectGap
	    });
	    this.timer.raf = new Timer({
	      type: 'raf',
	      isRaf: true
	    }); // loading timer
	
	    var lastPlayPos = 0;
	    var currentPlayPos = 0;
	    var bufferingDetected = false;
	    this.timer.loading.on('tick', function (_ref) {
	      var isStop = _ref.isStop;
	
	      if (isStop) {
	        return;
	      }
	
	      currentPlayPos = _this.model.progress.getPosition();
	
	      var state = _this.model.video.getState();
	
	      var isPlaying = state === 'playing' || state === 'buffering';
	
	      if (!bufferingDetected && currentPlayPos === lastPlayPos && isPlaying) {
	        var dura = _this.getDuration(); // X5内核的特殊情况
	
	
	        if (!isX5Layer() && isNumber(dura) && dura > 0) {
	          bufferingDetected = true;
	
	          _this.trigger('internal_buffer', true);
	        }
	      }
	
	      if (bufferingDetected && currentPlayPos > lastPlayPos && isPlaying) {
	        bufferingDetected = false;
	
	        _this.trigger('internal_buffer', false);
	      }
	
	      lastPlayPos = currentPlayPos;
	    });
	    var lastWidth = -1;
	    this.timer.raf.on('tick', function (_ref2) {
	      var isStop = _ref2.isStop;
	
	      if (isStop) {
	        return;
	      }
	
	      var width = _this.model.resize.getWidth();
	
	      var hasSmall = classList(_this.dom.container).contains(flagSmallPlayer);
	
	      if (width < 350) {
	        !hasSmall && classList(_this.dom.container).add(flagSmallPlayer);
	      } else {
	        hasSmall && classList(_this.dom.container).remove(flagSmallPlayer);
	      }
	
	      if (lastWidth !== width) {
	        _this.model.subtitle._setSubtitleSize(width);
	
	        _this.model.subtitle._updateSubtitleStyle();
	      }
	
	      lastWidth = width;
	      var fontSize = +getComputedStyle(_this.dom.container).fontSize.replace(/[^\d]+/, '');
	      _this._status.containerFontSize = fontSize < 16 ? 16 : fontSize;
	
	      _this.model.playbackMessage._onTick();
	    });
	    this.timer.raf.start();
	  }
	  function destroyTimer() {
	    this.timer.loading.stop();
	    this.timer.raf.stop();
	  }
	
	  var plugins = {};
	  function registerPlugin(name, Plugin) {
	    if (plugins[name]) {
	      console.warn("provider [".concat(name, "] is existed, so it will not be register twice, you can change a name and retry"));
	      return;
	    }
	
	    plugins[name] = {
	      name: name,
	      Plugin: Plugin
	    };
	    setDefaultOptions({
	      plugin: _defineProperty({}, name, Plugin.defaultOptions)
	    });
	  }
	  function getPlugins() {
	    return plugins;
	  }
	  function getPlugin(name) {
	    return plugins[name] || null;
	  }
	
	  function initPlugins() {
	    var plugins = getPlugins();
	
	    for (var name in plugins) {
	      var p = plugins[name];
	
	      if (p.Plugin.isSupported()) {
	        this.plugin[name] = new p.Plugin(this, this._config.plugin[name]);
	      }
	    }
	
	    this.trigger(INTERNAL_PLUGIN_INITED);
	  }
	  function destroyPlugins() {
	    if (this.plugin) {
	      for (var name in this.plugin) {
	        this.plugin[name] && this.plugin[name].remove();
	      }
	    }
	  }
	
	  var Player =
	  /*#__PURE__*/
	  function (_EventEmitter) {
	    _inherits(Player, _EventEmitter);
	
	    function Player(containerId) {
	      var _this;
	
	      _classCallCheck(this, Player);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Player).call(this));
	      _this._container = document.getElementById(containerId);
	
	      _this.formatState();
	
	      return _this;
	    }
	
	    _createClass(Player, [{
	      key: "formatState",
	      value: function formatState() {
	        // config
	        this._config = {};
	        this._config.containerId = this._container.id; // running status
	
	        this._status = {
	          uniqId: genPlayerUniqId(),
	          state: 'idle',
	          focus: false,
	          isSetuped: false,
	          flashReady: false,
	          dragging: false,
	          index: '',
	          containerFontSize: 16 // provider
	
	        };
	        this._provider = null;
	        this._extraProviders = {}; // plugin
	
	        this.plugin = {};
	        this.dom = {};
	        this.timer = {};
	        this.model = {};
	      }
	    }, {
	      key: "getUniqId",
	      value: function getUniqId() {
	        return this._status.uniqId;
	      } // isLoad 是判断是否来自playlist.js 的load操作 去除部分警告和trigger
	
	    }, {
	      key: "setup",
	      value: function setup(options) {
	        var _this2 = this;
	
	        var isLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        isDebugMode() && console.log('[setup]', options); // 如果之前进行过setup，那么就remove一次
	
	        if (this._status && this._status.isSetuped && !this._container.querySelector(videoWrap)) {
	          this.remove();
	          !isLoad && console.warn('muduPlayer().setup(): please don`t setup twice');
	        }
	
	        this.formatState();
	        var formatedOptions = formatOptions(options); // console.log(options)
	
	        var mergedOptions = mergeOptions(getDefaultOptions(), formatedOptions);
	        this._config = _objectSpread({}, this._config, mergedOptions); // console.log(mergedOptions, getDefaultOptions(), formatedOptions)
	
	        if (this._config.uniqId) {
	          this._status.uniqId = this._config.uniqId;
	        }
	
	        initPlugins.call(this);
	        !isLoad && this.trigger(INTERNAL_OPTION_MERGED);
	
	        if (!is('array', this._config.playlist) && !isLoad) {
	          throw new Error('setup(options): ' + 'you should give me a video url to play, through' + ' `options.file` or `options.playlist` array');
	        } // localization
	
	
	        this._status.lang = chooseLanguage(this._config.language, this._config.localization);
	        this._status.localization = this._config.localization[this._status.lang];
	        this._status.isSetuped = true;
	        !isLoad && this.trigger(INTERNAL_STATUS_FORMATED);
	        !isLoad && this.trigger('setup');
	        initDom.call(this);
	        initModel.call(this);
	        initTimer.call(this);
	        setDefaultPlayItemSourceActive.call(this);
	        var autoplay = this._config.autoplay;
	        return initProvider.call(this).then(function () {
	          initExtraProvider.call(_this2);
	
	          if (autoplay) {
	            try {
	              _this2.play();
	            } catch (err) {
	              console.warn(err);
	            }
	          }
	
	          return Promise.resolve();
	        });
	      }
	    }, {
	      key: "remove",
	      value: function remove() {
	        isDebugMode() && console.log('[remove]'); // 如果没有进行setup，那么就直接return，不进行remove
	
	        if (!this._status || !this._status.isSetuped) {
	          return;
	        }
	
	        destroyTimer.call(this);
	        destroyModel.call(this);
	        destroyPlugins.call(this);
	        destroyProvider.call(this);
	        destroyDom.call(this);
	        this._config = null;
	        this._status = null;
	        this._provider = null;
	        this.dom = null;
	        this.timer = null;
	        this.model = null; // 移除model/provider/plugin监听的事件
	
	        this.trigger('remove'); // 移除用户监听的事件
	        // this.clear()
	      }
	    }, {
	      key: "stop",
	      value: function stop() {
	        isDebugMode() && console.log('[stop]');
	        destroyProvider.call(this);
	      }
	    }]);
	
	    return Player;
	  }(EventEmitter);
	
	  var Dash =
	  /*#__PURE__*/
	  function (_HTML5Provider) {
	    _inherits(Dash, _HTML5Provider);
	
	    function Dash(player, option) {
	      var _this;
	
	      _classCallCheck(this, Dash);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Dash).call(this, player, option));
	      _this.video_error_report = false; // disable HTML5Provider error report
	
	      _this.TAG = 'DashjsProvider';
	      return _this;
	    }
	
	    _createClass(Dash, [{
	      key: "loadFiles",
	      value: function loadFiles() {
	        var loader = new ScriptLoader(this.player._config.fileCdnPath + '/dash.js');
	        return loader.load();
	      }
	    }, {
	      key: "setup",
	      value: function setup(_ref) {
	        var _this2 = this;
	
	        var file = _ref.file;
	
	        _get(_getPrototypeOf(Dash.prototype), "setup", this).call(this, {
	          file: file
	        });
	
	        this.file = file;
	
	        if (this.player._config.preload === 'auto') {
	          this.loadDash();
	        } else {
	          this.oncePlayer('beforePlay', function () {
	            return _this2.loadDash();
	          });
	        }
	      }
	    }, {
	      key: "loadDash",
	      value: function loadDash() {
	        this.dashPlayer = window.dashjs.MediaPlayer().create();
	        this.dashPlayer.initialize(this.video, this.file, false);
	      }
	    }, {
	      key: "remove",
	      value: function remove() {
	        _get(_getPrototypeOf(Dash.prototype), "remove", this).call(this);
	
	        if (this.dashPlayer) {
	          this.dashPlayer.reset();
	        }
	      }
	    }]);
	
	    return Dash;
	  }(HTML5Provider);
	
	  Dash.formats = {
	    'application/dash+xml': 'dash'
	  };
	  Dash.types = ['mpd', 'dash'];
	
	  Dash.canPlay = function (_ref2) {
	    var type = _ref2.type;
	
	    if (Dash.types.indexOf(type) >= 0) {
	      return 'maybe';
	    }
	
	    return '';
	  };
	
	  Dash.isSupported = function () {
	    var mediaSource = window.MediaSource || window.WebKitMediaSource;
	    var sourceBuffer = window.SourceBuffer || window.WebKitSourceBuffer;
	    var isTypeSupported = mediaSource && typeof mediaSource.isTypeSupported === 'function' && mediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'); // if SourceBuffer is exposed ensure its API is valid
	    // safari and old version of Chrome doe not expose SourceBuffer globally so checking SourceBuffer.prototype is impossible
	
	    var sourceBufferValidAPI = !sourceBuffer || sourceBuffer.prototype && typeof sourceBuffer.prototype.appendBuffer === 'function' && typeof sourceBuffer.prototype.remove === 'function';
	    return !!isTypeSupported && !!sourceBufferValidAPI;
	  };
	
	  Dash.isFlash = function (_) {
	    return false;
	  };
	
	  Dash.isHTML5 = function (_) {
	    return true;
	  };
	
	  Dash.HlsP2pisPlaybackRateSupported = function () {
	    return true;
	  };
	
	  Dash.isPlaybackRateSupported = function () {
	    return true;
	  };
	
	  Dash.version = "2.9.0";
	
	  var Flvjs =
	  /*#__PURE__*/
	  function (_HTML5Provider) {
	    _inherits(Flvjs, _HTML5Provider);
	
	    function Flvjs(player, option) {
	      var _this;
	
	      _classCallCheck(this, Flvjs);
	
	      option = option || {};
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Flvjs).call(this, player, option));
	      _this.video_error_report = false; // disable HTML5Provider error report
	
	      _this.TAG = 'FlvjsProvider';
	      return _this;
	    }
	
	    _createClass(Flvjs, [{
	      key: "loadFiles",
	      value: function loadFiles() {
	        var loader = new ScriptLoader(this.player._config.fileCdnPath + '/flv.js');
	        return loader.load();
	      }
	    }, {
	      key: "setup",
	      value: function setup(_ref) {
	        var _this2 = this;
	
	        var file = _ref.file,
	            isLive = _ref.isLive;
	
	        _get(_getPrototypeOf(Flvjs.prototype), "setup", this).call(this, {
	          file: file
	        });
	
	        this.onFlvError = function (type, details, other) {
	          var message = "".concat(type, "_").concat(details);
	
	          if (type === window.flvjs.ErrorTypes.NETWORK_ERROR) {
	            if (other.code) {
	              message += "_".concat(other.code);
	            }
	
	            if (other.msg) {
	              message += "_".concat(other.msg);
	            }
	          }
	
	          _this2.trigger(PROVIDER_ERROR, {
	            message: message,
	            details: details,
	            fatal: true,
	            data: {
	              type: type,
	              details: details,
	              other: other
	            }
	          });
	        };
	
	        var flvConfig = this.option['flv.js'] || {};
	        this.flvPlayer = window.flvjs.createPlayer({
	          type: 'flv',
	          url: file,
	          isLive: !!isLive
	        }, flvConfig);
	        this.flvPlayer.attachMediaElement(this.getMediaElement());
	        this.flvPlayer.on(window.flvjs.Events.ERROR, this.onFlvError);
	
	        if (this.player._config.preload === 'auto') {
	          this.flvPlayer.load();
	        } else {
	          this.oncePlayer('beforePlay', function () {
	            return _this2.flvPlayer.load();
	          });
	        }
	      }
	    }, {
	      key: "remove",
	      value: function remove() {
	        _get(_getPrototypeOf(Flvjs.prototype), "remove", this).call(this);
	
	        if (this.flvPlayer) {
	          this.flvPlayer.off(window.flvjs.Events.ERROR, this.onFlvError);
	          this.flvPlayer.detachMediaElement();
	          this.flvPlayer.destroy();
	        }
	      }
	    }]);
	
	    return Flvjs;
	  }(HTML5Provider);
	
	  Flvjs.formats = {
	    'video/flv': 'FLV',
	    'video/x-flv': 'FLV'
	  };
	
	  Flvjs.canPlay = function (_ref2) {
	    var type = _ref2.type,
	        isLive = _ref2.isLive;
	
	    if (type === 'flv' && (!isLive || isLive && Flvjs.isLiveSupported())) {
	      return 'maybe';
	    }
	
	    return '';
	  };
	
	  Flvjs.canPlaySource = function () {};
	
	  Flvjs.isSupported = function () {
	    return window.MediaSource && window.MediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"');
	  };
	
	  Flvjs.isLiveSupported = function () {
	    var env = getEnvor();
	    var browser = env.browser; // https://github.com/Bilibili/flv.js/blob/master/src/io/fetch-stream-loader.js#L32
	    // https://github.com/Bilibili/flv.js/blob/master/docs/livestream.md#compatibility
	
	    try {
	      var isWorkWellEdge = browser.msedge && (browser.version.major > 15 || browser.version.major === 15 && browser.version.minor >= 15048);
	      var browserNotBlacklisted = browser.msedge ? isWorkWellEdge : true;
	      return window.fetch && window.ReadableStream && browserNotBlacklisted;
	    } catch (e) {
	      return false;
	    }
	  };
	
	  Flvjs.isFlash = function (_) {
	    return false;
	  };
	
	  Flvjs.isHTML5 = function (_) {
	    return true;
	  };
	
	  Flvjs.HlsP2pisPlaybackRateSupported = function () {
	    return true;
	  };
	
	  Flvjs.isPlaybackRateSupported = function () {
	    return true;
	  };
	
	  Flvjs.version = "1.4.2";
	
	  function getHlsCustom() {
	    var XHRLoader =
	    /*#__PURE__*/
	    function (_window$Hls$DefaultCo) {
	      _inherits(XHRLoader, _window$Hls$DefaultCo);
	
	      function XHRLoader() {
	        _classCallCheck(this, XHRLoader);
	
	        return _possibleConstructorReturn(this, _getPrototypeOf(XHRLoader).apply(this, arguments));
	      }
	
	      _createClass(XHRLoader, [{
	        key: "loadInternal",
	        value: function loadInternal() {
	          var xhr;
	          var context = this.context;
	          xhr = this.loader = new window.XMLHttpRequest();
	          var stats = this.stats;
	          stats.tfirst = 0;
	          stats.loaded = 0;
	          var xhrSetup = this.xhrSetup;
	          var requestUrl = window.location.protocol === 'https:' ? context.url.replace(/^http:/, 'https:') : context.url;
	
	          try {
	            if (xhrSetup) {
	              try {
	                xhrSetup(xhr, requestUrl);
	              } catch (e) {
	                // fix xhrSetup: (xhr, url) => {xhr.setRequestHeader("Content-Language", "test");}
	                // not working, as xhr.setRequestHeader expects xhr.readyState === OPEN
	                xhr.open('GET', requestUrl, true);
	                xhrSetup(xhr, requestUrl);
	              }
	            }
	
	            if (!xhr.readyState) {
	              xhr.open('GET', requestUrl, true);
	            }
	          } catch (e) {
	            // IE11 throws an exception on xhr.open if attempting to access an HTTP resource over HTTPS
	            this.callbacks.onError({
	              code: xhr.status,
	              text: e.message
	            }, context, xhr);
	            return;
	          }
	
	          if (context.rangeEnd) {
	            xhr.setRequestHeader('Range', 'bytes=' + context.rangeStart + '-' + (context.rangeEnd - 1));
	          }
	
	          xhr.onreadystatechange = this.readystatechange.bind(this);
	          xhr.onprogress = this.loadprogress.bind(this);
	          xhr.responseType = context.responseType; // setup timeout before we perform request
	
	          this.requestTimeout = window.setTimeout(this.loadtimeout.bind(this), this.config.timeout);
	          xhr.send();
	        }
	      }]);
	
	      return XHRLoader;
	    }(window.Hls.DefaultConfig.loader);
	
	    return {
	      XHRLoader: XHRLoader
	    };
	  }
	
	  var Hlsjs =
	  /*#__PURE__*/
	  function (_HTML5Provider) {
	    _inherits(Hlsjs, _HTML5Provider);
	
	    function Hlsjs(player, option) {
	      var _this;
	
	      _classCallCheck(this, Hlsjs);
	
	      option = option || {};
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Hlsjs).call(this, player, option));
	      _this.onHlsError = _this.onHlsError.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	      _this.option = option;
	      _this.video_error_report = false; // disable HTML5Provider error report
	
	      _this.onPlayer('buffer', _this._onPlayerBuffer.bind(_assertThisInitialized(_assertThisInitialized(_this))));
	
	      _this.TAG = 'HlsjsProvider';
	      return _this;
	    }
	
	    _createClass(Hlsjs, [{
	      key: "loadFiles",
	      value: function loadFiles() {
	        var loader = new ScriptLoader(this.player._config.fileCdnPath + '/hls.js');
	        return loader.load();
	      }
	    }, {
	      key: "setup",
	      value: function setup(data) {
	        var _this2 = this;
	
	        var file = data.file;
	
	        _get(_getPrototypeOf(Hlsjs.prototype), "setup", this).call(this, data);
	
	        this.file = file;
	
	        if (this.player._config.preload === 'auto') {
	          this.loadHls();
	        } else {
	          this.oncePlayer(OUTER_BEFORE_PLAY, function () {
	            return _this2.loadHls();
	          });
	        }
	      }
	    }, {
	      key: "play",
	      value: function play() {
	        var state = this.player.getState();
	        var pos = this.getPosition();
	
	        if (state === 'idle' && pos > 0) {
	          // hls not trigger end event, manually replay it https://github.com/video-dev/hls.js/issues/1599
	          this.seek(0);
	        }
	
	        return _get(_getPrototypeOf(Hlsjs.prototype), "play", this).call(this);
	      }
	    }, {
	      key: "loadHls",
	      value: function loadHls() {
	        var _getHlsCustom = getHlsCustom(),
	            XHRLoader = _getHlsCustom.XHRLoader;
	
	        var defaultConfig = {
	          fLoader: XHRLoader
	        };
	
	        var config = _objectSpread({}, this.option['hls.js'] || {}, defaultConfig);
	
	        var hlsPlayer = this.hlsPlayer = new window.Hls(config);
	        hlsPlayer.subtitleDisplay = false; // 设置字幕默认不显示
	
	        hlsPlayer.loadSource(this.file);
	        hlsPlayer.attachMedia(this.video);
	        hlsPlayer.on(window.Hls.Events.ERROR, this.onHlsError);
	      }
	    }, {
	      key: "onHlsError",
	      value: function onHlsError(_, data) {
	        var type = data.type,
	            details = data.details,
	            fatal = data.fatal;
	        var message = "".concat(type, "_").concat(details);
	        var notHandleDetails = [window.Hls.ErrorDetails.BUFFER_STALLED_ERROR, window.Hls.ErrorDetails.BUFFER_NUDGE_ON_STALL];
	
	        if (notHandleDetails.indexOf(details) !== -1) {
	          return;
	        }
	
	        if (type === window.Hls.ErrorTypes.NETWORK_ERROR) {
	          var ntDetail = data.networkDetails;
	
	          if (ntDetail) {
	            if (ntDetail.status) {
	              message += "_".concat(ntDetail.status);
	            }
	
	            if (ntDetail.statusText) {
	              message += "_".concat(ntDetail.statusText);
	            }
	          }
	        }
	
	        this.trigger(PROVIDER_ERROR, {
	          message: message,
	          fatal: fatal,
	          details: details,
	          data: data
	        });
	      }
	    }, {
	      key: "remove",
	      value: function remove() {
	        _get(_getPrototypeOf(Hlsjs.prototype), "remove", this).call(this);
	
	        if (this.hlsPlayer) {
	          this.hlsPlayer.off(window.Hls.Events.ERROR, this.onHlsError);
	          this.hlsPlayer.detachMedia();
	          this.hlsPlayer.destroy();
	        }
	      }
	    }, {
	      key: "_onPlayerBuffer",
	      value: function _onPlayerBuffer(_ref) {
	        var oldState = _ref.oldState;
	
	        // subscribe buffer event to avoid hls.js bug: https://github.com/video-dev/hls.js/issues/1599
	        if (oldState === 'playing') {
	          var pos = this.getPosition();
	          var dura = this.getDuration();
	
	          if (dura - pos < 1 && pos > 0 && dura > 2) {
	            // '2' use to avoid dura not ready(parsing m3u8 file not done), why not '1', `1` in x5 is fucked
	            this.pause();
	            this.trigger('ended'); // manully trigger ended event to remove buffer
	          }
	        }
	      }
	    }]);
	
	    return Hlsjs;
	  }(HTML5Provider);
	
	  Hlsjs.formats = {
	    'application/vnd.apple.mpegurl': 'hls'
	  };
	  Hlsjs.type = ['m3u8', 'hls'];
	
	  Hlsjs.canPlay = function (_ref2) {
	    var type = _ref2.type,
	        isTimeShift = _ref2.isTimeShift;
	
	    if (isTimeShift && isX5Layer()) {
	      return false;
	    }
	
	    return Hlsjs.type.indexOf(type) >= 0;
	  };
	
	  Hlsjs.isHlsSupported = function () {
	    var mediaSource = window.MediaSource || window.WebKitMediaSource;
	    var sourceBuffer = window.SourceBuffer || window.WebKitSourceBuffer;
	    var isTypeSupported = mediaSource && typeof mediaSource.isTypeSupported === 'function' && mediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'); // if SourceBuffer is exposed ensure its API is valid
	    // safari and old version of Chrome doe not expose SourceBuffer globally so checking SourceBuffer.prototype is impossible
	
	    var sourceBufferValidAPI = !sourceBuffer || sourceBuffer.prototype && typeof sourceBuffer.prototype.appendBuffer === 'function' && typeof sourceBuffer.prototype.remove === 'function';
	    return !!isTypeSupported && !!sourceBufferValidAPI;
	  };
	
	  Hlsjs.isSupported = function () {
	    return Hlsjs.isHlsSupported();
	  };
	
	  Hlsjs.isFlash = function (_) {
	    return false;
	  };
	
	  Hlsjs.isHTML5 = function (_) {
	    return true;
	  };
	
	  Hlsjs.HlsP2pisPlaybackRateSupported = function () {
	    return true;
	  };
	
	  Hlsjs.isPlaybackRateSupported = function () {
	    return true;
	  };
	
	  Hlsjs.version = "0.12.4";
	
	  var HlsPeer5 =
	  /*#__PURE__*/
	  function (_HTML5Provider) {
	    _inherits(HlsPeer5, _HTML5Provider);
	
	    function HlsPeer5(player, option) {
	      var _this;
	
	      _classCallCheck(this, HlsPeer5);
	
	      option = option || {};
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(HlsPeer5).call(this, player, option));
	      _this.onHlsError = _this.onHlsError.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	      _this.option = option;
	      _this.video_error_report = false; // disable HTML5Provider error report
	
	      _this.onPlayer('buffer', _this._onPlayerBuffer.bind(_assertThisInitialized(_assertThisInitialized(_this))));
	
	      _this.TAG = 'HlsPeer5Provider';
	      return _this;
	    }
	
	    _createClass(HlsPeer5, [{
	      key: "loadFiles",
	      value: function loadFiles() {
	        var customID = this.option.customID;
	        var peer5 = new ScriptLoader("https://static.mudu.tv/peer5/peer5.js?id=".concat(customID)).load();
	        var plugin = new ScriptLoader('https://static.mudu.tv/peer5/peer5.hlsjs.loader.js').load();
	        var hls = new ScriptLoader(this.player._config.fileCdnPath + '/hls.js').load();
	        return Promise.all([peer5, plugin, hls]);
	      }
	    }, {
	      key: "setup",
	      value: function setup(data) {
	        var _this2 = this;
	
	        var file = data.file;
	
	        _get(_getPrototypeOf(HlsPeer5.prototype), "setup", this).call(this, data);
	
	        this.file = file;
	
	        if (this.player._config.preload === 'auto') {
	          this.loadHls();
	        } else {
	          this.oncePlayer(OUTER_BEFORE_PLAY, function () {
	            return _this2.loadHls();
	          });
	        }
	      }
	    }, {
	      key: "play",
	      value: function play() {
	        var state = this.player.getState();
	        var pos = this.getPosition();
	
	        if (state === 'idle' && pos > 0) {
	          // hls not trigger end event, manually replay it https://github.com/video-dev/hls.js/issues/1599
	          this.seek(0);
	        }
	
	        return _get(_getPrototypeOf(HlsPeer5.prototype), "play", this).call(this);
	      }
	    }, {
	      key: "loadHls",
	      value: function loadHls() {
	        var defaultConfig = {
	          fLoader: window.peer5 && window.peer5.HlsJsFragmentLoader,
	          pLoader: window.peer5 && window.peer5.HlsJsPlaylistLoader
	        };
	
	        var config = _objectSpread({}, this.option['hls.js'] || {}, defaultConfig);
	
	        var hlsPlayer = this.hlsPlayer = new window.Hls(config);
	        hlsPlayer.subtitleDisplay = false; // 设置字幕默认不显示
	
	        hlsPlayer.loadSource(this.file);
	        hlsPlayer.attachMedia(this.video);
	        hlsPlayer.on(window.Hls.Events.ERROR, this.onHlsError);
	      }
	    }, {
	      key: "onHlsError",
	      value: function onHlsError(_, data) {
	        var type = data.type,
	            details = data.details,
	            fatal = data.fatal;
	        var message = "".concat(type, "_").concat(details);
	        var notHandleDetails = [window.Hls.ErrorDetails.BUFFER_STALLED_ERROR, window.Hls.ErrorDetails.BUFFER_NUDGE_ON_STALL];
	
	        if (notHandleDetails.indexOf(details) !== -1) {
	          return;
	        }
	
	        if (type === window.Hls.ErrorTypes.NETWORK_ERROR) {
	          var ntDetail = data.networkDetails;
	
	          if (ntDetail) {
	            if (ntDetail.status) {
	              message += "_".concat(ntDetail.status);
	            }
	
	            if (ntDetail.statusText) {
	              message += "_".concat(ntDetail.statusText);
	            }
	          }
	        }
	
	        this.trigger(PROVIDER_ERROR, {
	          message: message,
	          fatal: fatal,
	          details: details,
	          data: data
	        });
	      }
	    }, {
	      key: "remove",
	      value: function remove() {
	        _get(_getPrototypeOf(HlsPeer5.prototype), "remove", this).call(this);
	
	        if (this.hlsPlayer) {
	          this.hlsPlayer.off(window.Hls.Events.ERROR, this.onHlsError);
	          this.hlsPlayer.detachMedia();
	          this.hlsPlayer.destroy();
	        }
	      }
	    }, {
	      key: "_onPlayerBuffer",
	      value: function _onPlayerBuffer(_ref) {
	        var oldState = _ref.oldState;
	
	        // subscribe buffer event to avoid hls.js bug: https://github.com/video-dev/hls.js/issues/1599
	        if (oldState === 'playing') {
	          var pos = this.getPosition();
	          var dura = this.getDuration();
	
	          if (dura - pos < 1 && pos > 0 && dura > 2) {
	            // '2' use to avoid dura not ready(parsing m3u8 file not done), why not '1', `1` in x5 is fucked
	            this.pause();
	            this.trigger('ended'); // manully trigger ended event to remove buffer
	          }
	        }
	      }
	    }]);
	
	    return HlsPeer5;
	  }(HTML5Provider);
	
	  HlsPeer5.formats = {
	    'application/vnd.apple.mpegurl': 'hls'
	  };
	  HlsPeer5.type = ['m3u8', 'hls'];
	
	  HlsPeer5.canPlay = function (_ref2) {
	    var type = _ref2.type,
	        isTimeShift = _ref2.isTimeShift;
	
	    if (isTimeShift && isX5Layer()) {
	      return false;
	    }
	
	    return HlsPeer5.type.indexOf(type) >= 0;
	  };
	
	  HlsPeer5.isHlsPeer5Supported = function () {
	    var mediaSource = window.MediaSource || window.WebKitMediaSource;
	    var sourceBuffer = window.SourceBuffer || window.WebKitSourceBuffer;
	    var isTypeSupported = mediaSource && typeof mediaSource.isTypeSupported === 'function' && mediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'); // if SourceBuffer is exposed ensure its API is valid
	    // safari and old version of Chrome doe not expose SourceBuffer globally so checking SourceBuffer.prototype is impossible
	
	    var sourceBufferValidAPI = !sourceBuffer || sourceBuffer.prototype && typeof sourceBuffer.prototype.appendBuffer === 'function' && typeof sourceBuffer.prototype.remove === 'function';
	    return !!isTypeSupported && !!sourceBufferValidAPI;
	  };
	
	  HlsPeer5.isSupported = function () {
	    return HlsPeer5.isHlsPeer5Supported();
	  };
	
	  HlsPeer5.isFlash = function (_) {
	    return false;
	  };
	
	  HlsPeer5.isHTML5 = function (_) {
	    return true;
	  };
	
	  HlsPeer5.HlsP2pisPlaybackRateSupported = function () {
	    return true;
	  };
	
	  HlsPeer5.isPlaybackRateSupported = function () {
	    return true;
	  };
	
	  HlsPeer5.version = "0.12.4";
	
	  var videoId = 'mudu-player-video-hls-p2p';
	
	  var HlsXP2P =
	  /*#__PURE__*/
	  function (_HTML5Provider) {
	    _inherits(HlsXP2P, _HTML5Provider);
	
	    function HlsXP2P(player, option) {
	      var _this;
	
	      _classCallCheck(this, HlsXP2P);
	
	      option = option || {};
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(HlsXP2P).call(this, player, option));
	      _this.onHlsError = _this.onHlsError.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	      _this.video_error_report = false; // disable HTML5Provider error report
	
	      _this.onPlayer('buffer', _this._onPlayerBuffer.bind(_assertThisInitialized(_assertThisInitialized(_this))));
	
	      _this.TAG = 'HlsXP2PProvider';
	      return _this;
	    }
	
	    _createClass(HlsXP2P, [{
	      key: "loadFiles",
	      value: function loadFiles() {
	        var xp2p = new ScriptLoader(this.player._config.fileCdnPath + '/hlsp2p.min.js').load();
	        var hls = new ScriptLoader(this.player._config.fileCdnPath + '/hls.js').load();
	        return Promise.all([xp2p, hls]);
	      }
	    }, {
	      key: "setup",
	      value: function setup(data) {
	        var _this2 = this;
	
	        this.destroyHlsp2p();
	        var file = data.file,
	            isLive = data.isLive;
	
	        _get(_getPrototypeOf(HlsXP2P.prototype), "setup", this).call(this, data);
	
	        this.file = file;
	        this._videoType = isLive ? 'LIVE' : 'VOD';
	
	        if (this.player._config.preload === 'auto') {
	          this.loadHls();
	        } else {
	          this.oncePlayer(OUTER_BEFORE_PLAY, function () {
	            return _this2.loadHls();
	          });
	        }
	      }
	    }, {
	      key: "play",
	      value: function play() {
	        var state = this.player.getState();
	        var pos = this.getPosition();
	
	        if (state === 'idle' && pos > 0) {
	          // hls not trigger end event, manually replay it https://github.com/video-dev/hls.js/issues/1599
	          this.seek(0);
	        }
	
	        return _get(_getPrototypeOf(HlsXP2P.prototype), "play", this).call(this);
	      }
	    }, {
	      key: "loadHls",
	      value: function loadHls() {
	        var config = _objectSpread({}, this.option['hls.js'] || {});
	
	        var hlsPlayer = this.hlsPlayer = new window.Hls({
	          config: config
	        });
	        hlsPlayer.subtitleDisplay = false; // 设置字幕默认不显示
	
	        hlsPlayer.loadSource(this.file);
	        hlsPlayer.attachMedia(this.video);
	        this.video.id = videoId;
	        hlsPlayer.on(window.Hls.Events.ERROR, this.onHlsError);
	        this.initHLSP2P();
	      }
	    }, {
	      key: "initHLSP2P",
	      value: function initHLSP2P() {
	        var _this3 = this;
	
	        if (!window.HLSP2P.isSupported()) {
	          return;
	        }
	
	        var _this$option = this.option,
	            xp2pAppId = _this$option.xp2pAppId,
	            cloudAppId = _this$option.cloudAppId,
	            channelId = _this$option.channelId,
	            _this$option$enableMu = _this$option.enableMultiArea,
	            enableMultiArea = _this$option$enableMu === void 0 ? true : _this$option$enableMu;
	        var domain = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/.exec(this.file)[0];
	        var config = {
	          // 如下为必传参数
	          videoId: videoId,
	          // 特别注意是<video>的id, 这里需要跟据实际情况修改
	          videoType: this._videoType,
	          // 'LIVE' 或者 'VOD'
	          url: this.file,
	          // 这里要替换为实际的url
	          channelId: channelId,
	          // 如没有自定义channelId, 则不用传入channelId
	          domain: domain,
	          xp2pAppId: xp2pAppId,
	          // 此处为demo示例, 需要要根据邮件填写
	          cloudAppId: cloudAppId,
	          // 此处为demo示例, 这里要根据邮件填写
	          enableLocalNetworkShare: true,
	          // 默认false, 是否开启内网P2P
	          enableMultiArea: enableMultiArea,
	          // 是否开启地域隔离策略
	          p2pStartDelay: 1000 //// 默认15000,单位ms, 延迟多久启动P2P, 这里可以改成1000(延迟1s)
	
	        };
	        this.hlsp2p = window.HLSP2P.create(this.hlsPlayer, config); // 监听SDK播放失败事件
	
	        this.hlsp2p.on(window.HLSP2P.Events.Rollback, function (_ref) {
	          var reason = _ref.reason;
	          console.warn("p2p \u56DE\u9000 destroy, reason: ".concat(reason)); // 需销毁sdk
	
	          _this3.hlsp2p.destroy();
	
	          _this3.player.trigger(OUTER_XP2P_ROLLBACK, reason);
	        });
	        this.hlsp2p.on('log', function (msg) {
	          _this3.player.trigger('hlsp2pMsg', msg);
	        });
	      }
	    }, {
	      key: "onHlsError",
	      value: function onHlsError(_, data) {
	        var type = data.type,
	            details = data.details,
	            fatal = data.fatal;
	        var message = "".concat(type, "_").concat(details);
	        var notHandleDetails = [window.Hls.ErrorDetails.BUFFER_STALLED_ERROR, window.Hls.ErrorDetails.BUFFER_NUDGE_ON_STALL];
	
	        if (notHandleDetails.indexOf(details) !== -1) {
	          return;
	        }
	
	        if (type === window.Hls.ErrorTypes.NETWORK_ERROR) {
	          var ntDetail = data.networkDetails;
	
	          if (ntDetail) {
	            if (ntDetail.status) {
	              message += "_".concat(ntDetail.status);
	            }
	
	            if (ntDetail.statusText) {
	              message += "_".concat(ntDetail.statusText);
	            }
	          }
	        }
	
	        this.trigger(PROVIDER_ERROR, {
	          message: message,
	          fatal: fatal,
	          details: details,
	          data: data
	        });
	      }
	    }, {
	      key: "remove",
	      value: function remove() {
	        _get(_getPrototypeOf(HlsXP2P.prototype), "remove", this).call(this);
	
	        if (this.hlsPlayer) {
	          this.hlsPlayer.off(window.Hls.Events.ERROR, this.onHlsError);
	          this.hlsPlayer.detachMedia();
	          this.hlsPlayer.destroy();
	          this.hlsPlayer = null;
	        }
	
	        this.destroyHlsp2p();
	      }
	    }, {
	      key: "destroyHlsp2p",
	      value: function destroyHlsp2p() {
	        if (this.hlsp2p) {
	          this.hlsp2p.destroy();
	          this.hlsp2p = null;
	        }
	      }
	    }, {
	      key: "_onPlayerBuffer",
	      value: function _onPlayerBuffer(_ref2) {
	        var oldState = _ref2.oldState;
	
	        // subscribe buffer event to avoid hls.js bug: https://github.com/video-dev/hls.js/issues/1599
	        if (oldState === 'playing') {
	          var pos = this.getPosition();
	          var dura = this.getDuration();
	
	          if (dura - pos < 1 && pos > 0 && dura > 2) {
	            // '2' use to avoid dura not ready(parsing m3u8 file not done), why not '1', `1` in x5 is fucked
	            this.pause();
	            this.trigger('ended'); // manully trigger ended event to remove buffer
	          }
	        }
	      }
	    }]);
	
	    return HlsXP2P;
	  }(HTML5Provider);
	
	  HlsXP2P.formats = {
	    'application/vnd.apple.mpegurl': 'hls'
	  };
	  HlsXP2P.type = ['m3u8', 'hls'];
	
	  HlsXP2P.canPlay = function (_ref3) {
	    var type = _ref3.type,
	        isTimeShift = _ref3.isTimeShift;
	
	    if (isTimeShift && isX5Layer()) {
	      return false;
	    }
	
	    return HlsXP2P.type.indexOf(type) >= 0;
	  };
	
	  HlsXP2P.isHlsSupported = function () {
	    var mediaSource = window.MediaSource || window.WebKitMediaSource;
	    var sourceBuffer = window.SourceBuffer || window.WebKitSourceBuffer;
	    var isTypeSupported = mediaSource && typeof mediaSource.isTypeSupported === 'function' && mediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'); // if SourceBuffer is exposed ensure its API is valid
	    // safari and old version of Chrome doe not expose SourceBuffer globally so checking SourceBuffer.prototype is impossible
	
	    var sourceBufferValidAPI = !sourceBuffer || sourceBuffer.prototype && typeof sourceBuffer.prototype.appendBuffer === 'function' && typeof sourceBuffer.prototype.remove === 'function';
	    return !!isTypeSupported && !!sourceBufferValidAPI;
	  };
	
	  HlsXP2P.isXP2pSupported = function () {
	    return supportMSEH264Playback() && supportP2P() && supportES() && supportCrypto();
	
	    function supportES() {
	      return !(!window.Array.from || !window.Array.prototype.find);
	    }
	
	    function supportCrypto() {
	      return !!window.crypto;
	    }
	
	    function supportMSEH264Playback() {
	      return !(!window.MediaSource || !window.MediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'));
	    }
	
	    function supportP2P() {
	      return supportWebSocket() && supportDataType() && supportObjectURL() && supportRTCPeerConnection() && supportDataChannel();
	    }
	
	    function supportWebSocket() {
	      return !!('WebSocket' in window || 'MozWebSocket' in window);
	    }
	
	    function supportDataType() {
	      return !('undefined' == typeof ArrayBuffer || 'undefined' == typeof Uint8Array || 'undefined' == typeof Uint16Array || 'undefined' == typeof Uint32Array || 'undefined' == typeof DataView);
	    }
	
	    function supportObjectURL() {
	      return 'URL' in window && 'createObjectURL' in URL;
	    }
	
	    function supportRTCPeerConnection() {
	      return !!window.RTCPeerConnection || !!(window.webkitRTCPeerConnection || window.mozRTCPeerConnection || window.msRTCPeerConnection || window.oRTCPeerConnection);
	    }
	
	    function supportDataChannel() {
	      var e = window.RTCPeerConnection || window.msRTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
	      return function () {
	        var t = false;
	
	        try {
	          var r = new e(null);
	          t = 'createDataChannel' in r, r.close(), r = null;
	        } catch (e) {}
	
	        return t;
	      }();
	    }
	  };
	
	  HlsXP2P.isSupported = function () {
	    return HlsXP2P.isHlsSupported() && HlsXP2P.isXP2pSupported;
	  };
	
	  HlsXP2P.isFlash = function (_) {
	    return false;
	  };
	
	  HlsXP2P.isHTML5 = function (_) {
	    return true;
	  };
	
	  HlsXP2P.HlsP2pisPlaybackRateSupported = function () {
	    return true;
	  };
	
	  HlsXP2P.isPlaybackRateSupported = function () {
	    return true;
	  };
	
	  HlsXP2P.version = "0.12.4";
	
	  var Plugin =
	  /*#__PURE__*/
	  function (_EventEmitter) {
	    _inherits(Plugin, _EventEmitter);
	
	    function Plugin(player, option) {
	      var _this;
	
	      _classCallCheck(this, Plugin);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Plugin).call(this));
	      _this.player = player;
	      _this.p_player_events = [];
	      _this.p_dom_events = [];
	      _this.option = option;
	      return _this;
	    }
	
	    _createClass(Plugin, [{
	      key: "onPlayer",
	      value: function onPlayer(evt, fn) {
	        this.player.on(evt, fn);
	        this.p_player_events.push({
	          evt: evt,
	          fn: fn
	        });
	      }
	    }, {
	      key: "oncePlayer",
	      value: function oncePlayer(evt, fn) {
	        this.player.once(evt, fn);
	        this.p_player_events.push({
	          evt: evt,
	          fn: fn
	        });
	      }
	    }, {
	      key: "onDom",
	      value: function onDom(ele, evt, fn) {
	        var needRemove = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	        addEventListener(ele, evt, fn);
	        needRemove && this.p_dom_events.push({
	          ele: ele,
	          evt: evt,
	          fn: fn
	        });
	      }
	    }, {
	      key: "remove",
	      value: function remove() {
	        var _this2 = this;
	
	        this.p_player_events.forEach(function (v) {
	          return _this2.player.off(v.evt, v.fn);
	        });
	        this.p_dom_events.forEach(function (v) {
	          return removeEventListener(v.ele, v.evt, v.fn);
	        });
	      }
	    }]);
	
	    return Plugin;
	  }(EventEmitter);
	
	  Plugin.isSupported = returnFalse;
	  Plugin.defaultOptions = {};
	
	  /**
	   * 弹幕插件
	   */
	
	  var DanmakuPlugin =
	  /*#__PURE__*/
	  function (_Plugin) {
	    _inherits(DanmakuPlugin, _Plugin);
	
	    function DanmakuPlugin(player, option) {
	      var _this;
	
	      _classCallCheck(this, DanmakuPlugin);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(DanmakuPlugin).call(this, player, option));
	      _this.removeResizeListener = null;
	      return _this;
	    }
	
	    _createClass(DanmakuPlugin, [{
	      key: "init",
	      value: function init() {
	        var _this2 = this;
	
	        var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        var loader = new ScriptLoader(this.player._config.fileCdnPath + '/danmaku.js');
	        return loader.load().then(function () {
	          var dom = _this2.player.dom.container.querySelector(".".concat(danmaku));
	
	          var danmaku$1 = new window.Danmaku(_objectSpread({
	            container: dom
	          }, opt));
	          Delegator(_this2, danmaku$1).method('resize').method('show').method('hide').method('destroy').method('clear');
	          _this2.danmaku = danmaku$1;
	
	          var visibility = _this2.getCompaVisibility();
	
	          var handleResize = function handleResize() {
	            if (is('function', _this2.resize)) {
	              _this2.resize();
	            }
	          };
	
	          var handleVisiblity = function handleVisiblity() {
	            _this2.danmaku.clear();
	
	            _this2.disableSend = document[visibility.hidden];
	          };
	
	          _this2.onPlayer('play', function () {
	            danmaku$1.paused = false;
	          });
	
	          _this2.onPlayer('pause', function () {
	            danmaku$1.paused = true;
	          });
	
	          _this2.onPlayer('resize', handleResize);
	
	          _this2.onDom(window, 'resize', handleResize);
	
	          _this2.removeResizeListener = onResize(dom, handleResize);
	          visibility && _this2.onDom(document, visibility.visibilitychange, handleVisiblity);
	          return danmaku$1;
	        });
	      }
	    }, {
	      key: "emit",
	      value: function emit(d) {
	        if (!this.disableSend) {
	          this.danmaku.emit(d);
	        }
	      }
	    }, {
	      key: "getCompaVisibility",
	      value: function getCompaVisibility() {
	        if (!is('undefined', document.hidden)) {
	          return {
	            hidden: 'hidden',
	            visibilitychange: 'visibilitychange'
	          };
	        }
	
	        if (!is('undefined', document.msHidden)) {
	          return {
	            hidden: 'msHidden',
	            visibilitychange: 'msvisibilitychange'
	          };
	        }
	
	        if (!is('undefined', document.webkitHidden)) {
	          return {
	            hidden: 'webkitHidden',
	            visibilitychange: 'webkitvisibilitychange'
	          };
	        }
	      }
	    }, {
	      key: "setSpeed",
	      value: function setSpeed(speed) {
	        if (this.danmaku) {
	          this.danmaku.speed = speed;
	        }
	      }
	    }, {
	      key: "remove",
	      value: function remove() {
	        _get(_getPrototypeOf(DanmakuPlugin.prototype), "remove", this).call(this);
	
	        this.removeResizeListener && this.removeResizeListener();
	
	        if (is('function', this.destroy)) {
	          this.destroy();
	        }
	      }
	    }]);
	
	    return DanmakuPlugin;
	  }(Plugin);
	
	  DanmakuPlugin.isSupported = function () {
	    var env = getEnvor();
	    var isIE8 = env.browser.msie && env.browser.version.major === 8;
	    return !isIE8;
	  };
	
	  /**
	   * 播放计时插件
	   */
	
	  var Tick =
	  /*#__PURE__*/
	  function (_Plugin) {
	    _inherits(Tick, _Plugin);
	
	    function Tick(player, option) {
	      var _this;
	
	      _classCallCheck(this, Tick);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Tick).call(this, player, option));
	      _this.timer = new Timer(_objectSpread({}, option, {
	        gap: _this.option.gap || 60 * 1000
	      }));
	
	      _this.timer.on('tick', function (data) {
	        _this.trigger('tick', data);
	      });
	
	      _this.onPlayer('play', function () {
	        _this.timer.start();
	      });
	
	      _this.onPlayer('pause', function () {
	        _this.timer.stop();
	      });
	
	      _this.onPlayer('idle', function () {
	        _this.timer.stop();
	      });
	
	      _this.onPlayer('complete', function () {
	        _this.timer.stop();
	      });
	
	      _this.onDom(document, 'visibilitychange', function () {
	        _this.timer.tick();
	      });
	
	      _this.onDom(window, 'pagehide', function () {
	        _this.timer.tick();
	      });
	
	      _this.onDom(window, 'unload', function () {
	        _this.timer.tick();
	      });
	
	      _this.onDom(window, 'beforeunload', function () {
	        _this.timer.tick();
	      });
	
	      if (is('function', _this.option.onTick)) {
	        _this.on('tick', _this.option.onTick);
	      }
	
	      return _this;
	    }
	
	    _createClass(Tick, [{
	      key: "remove",
	      value: function remove() {
	        _get(_getPrototypeOf(Tick.prototype), "remove", this).call(this);
	
	        this.timer.stop();
	      }
	    }]);
	
	    return Tick;
	  }(Plugin);
	
	  Tick.isSupported = returnTrue;
	
	  /**
	   * 弹幕插件
	   */
	
	  var MuduDanmakuPlugin =
	  /*#__PURE__*/
	  function (_Plugin) {
	    _inherits(MuduDanmakuPlugin, _Plugin);
	
	    function MuduDanmakuPlugin(player, option) {
	      var _this;
	
	      _classCallCheck(this, MuduDanmakuPlugin);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(MuduDanmakuPlugin).call(this, player, option));
	      _this.removeResizeListener = null;
	      return _this;
	    }
	
	    _createClass(MuduDanmakuPlugin, [{
	      key: "init",
	      value: function init() {
	        var _this2 = this;
	
	        var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        console.log('init');
	        var loader = new ScriptLoader(this.player._config.fileCdnPath + '/danmaku-plugin.min.js');
	        return loader.load().then(function () {
	          var dom = _this2.player.dom.container.querySelector(".".concat(danmaku));
	
	          var danmaku$1 = new window.MuduDanmaku(dom, opt);
	          Delegator(_this2, danmaku$1).method('resize').method('emit').method('destroy').method('clear').method('setSpeed').method('setRange');
	          _this2.danmaku = danmaku$1;
	
	          var handleResize = function handleResize() {
	            if (is('function', _this2.resize)) {
	              _this2.resize();
	            }
	          };
	
	          _this2.onPlayer('resize', handleResize);
	
	          _this2.onDom(window, 'resize', handleResize);
	
	          _this2.removeResizeListener = onResize(dom, handleResize);
	          return danmaku$1;
	        });
	      }
	    }, {
	      key: "emit",
	      value: function emit(content) {
	        console.log('emit');
	        this.danmaku.emit(content);
	      }
	    }, {
	      key: "remove",
	      value: function remove() {
	        _get(_getPrototypeOf(MuduDanmakuPlugin.prototype), "remove", this).call(this);
	
	        this.removeResizeListener && this.removeResizeListener();
	
	        if (is('function', this.destroy)) {
	          this.destroy();
	        }
	      }
	    }]);
	
	    return MuduDanmakuPlugin;
	  }(Plugin);
	
	  MuduDanmakuPlugin.isSupported = function () {
	    var env = getEnvor();
	    var isIE10 = env.browser.msie && env.browser.version.major === 10;
	    return !isIE10;
	  };
	
	  var toggleSelection = function () {
	    var selection = document.getSelection();
	    if (!selection.rangeCount) {
	      return function () {};
	    }
	    var active = document.activeElement;
	
	    var ranges = [];
	    for (var i = 0; i < selection.rangeCount; i++) {
	      ranges.push(selection.getRangeAt(i));
	    }
	
	    switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
	      case 'INPUT':
	      case 'TEXTAREA':
	        active.blur();
	        break;
	
	      default:
	        active = null;
	        break;
	    }
	
	    selection.removeAllRanges();
	    return function () {
	      selection.type === 'Caret' &&
	      selection.removeAllRanges();
	
	      if (!selection.rangeCount) {
	        ranges.forEach(function(range) {
	          selection.addRange(range);
	        });
	      }
	
	      active &&
	      active.focus();
	    };
	  };
	
	  var defaultMessage = 'Copy to clipboard: #{key}, Enter';
	
	  function format(message) {
	    var copyKey = (/mac os x/i.test(navigator.userAgent) ? '⌘' : 'Ctrl') + '+C';
	    return message.replace(/#{\s*key\s*}/g, copyKey);
	  }
	
	  function copy(text, options) {
	    var debug, message, reselectPrevious, range, selection, mark, success = false;
	    if (!options) { options = {}; }
	    debug = options.debug || false;
	    try {
	      reselectPrevious = toggleSelection();
	
	      range = document.createRange();
	      selection = document.getSelection();
	
	      mark = document.createElement('span');
	      mark.textContent = text;
	      // reset user styles for span element
	      mark.style.all = 'unset';
	      // prevents scrolling to the end of the page
	      mark.style.position = 'fixed';
	      mark.style.top = 0;
	      mark.style.clip = 'rect(0, 0, 0, 0)';
	      // used to preserve spaces and line breaks
	      mark.style.whiteSpace = 'pre';
	      // do not inherit user-select (it may be `none`)
	      mark.style.webkitUserSelect = 'text';
	      mark.style.MozUserSelect = 'text';
	      mark.style.msUserSelect = 'text';
	      mark.style.userSelect = 'text';
	
	      document.body.appendChild(mark);
	
	      range.selectNode(mark);
	      selection.addRange(range);
	
	      var successful = document.execCommand('copy');
	      if (!successful) {
	        throw new Error('copy command was unsuccessful');
	      }
	      success = true;
	    } catch (err) {
	      debug && console.error('unable to copy using execCommand: ', err);
	      debug && console.warn('trying IE specific stuff');
	      try {
	        window.clipboardData.setData('text', text);
	        success = true;
	      } catch (err) {
	        debug && console.error('unable to copy using clipboardData: ', err);
	        debug && console.error('falling back to prompt');
	        message = format('message' in options ? options.message : defaultMessage);
	        window.prompt(message, text);
	      }
	    } finally {
	      if (selection) {
	        if (typeof selection.removeRange == 'function') {
	          selection.removeRange(range);
	        } else {
	          selection.removeAllRanges();
	        }
	      }
	
	      if (mark) {
	        document.body.removeChild(mark);
	      }
	      reselectPrevious();
	    }
	
	    return success;
	  }
	
	  var copyToClipboard = copy;
	
	  var LogPlugin =
	  /*#__PURE__*/
	  function (_Plugin) {
	    _inherits(LogPlugin, _Plugin);
	
	    function LogPlugin(player, option) {
	      var _this;
	
	      _classCallCheck(this, LogPlugin);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(LogPlugin).call(this, player, option));
	      _this.logs = [];
	      _this.errorLogUrl = player._config.errorLogUrl; // this.onPlayer(events.INTERNAL_STATUS_FORMATED, () => {
	      //   this.player._config.contextMenus.unshift(
	      //     {
	      //       key: 'copy-log',
	      //       text: this.player._status.localization['Copy debug info']
	      //     },
	      //     {
	      //       key: 'upload-log',
	      //       text: this.player._status.localization['Upload debug info']
	      //     }
	      //   )
	      // })
	
	      _this.onPlayer(OUTER_CONTEXT_MENU_CLICK, function (_ref) {
	        var key = _ref.key;
	
	        if (key === 'copy-log') {
	          _this.copyLog();
	        }
	
	        if (key === 'upload-log') {
	          _this.uploadLog();
	        }
	      });
	
	      _this.onPlayer('all', function (event) {
	        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        var ts = rfc3339nano();
	
	        _this.logs.push({
	          type: event,
	          time: ts,
	          args: args
	        });
	      });
	
	      _this.onPlayer('error', function (error) {
	        var otherInfo = _this.getOtherInfo();
	
	        otherInfo.errorId = error.errorId;
	        otherInfo.error = error; // 'flash not allowed' error do not upload
	
	        if (error.message === Flash.Error.NotAllowedError) {
	          if (_this.player._provider && _this.player._provider.flash) {
	            return;
	          }
	        }
	
	        _this.uploadError(otherInfo);
	      });
	
	      return _this;
	    }
	
	    _createClass(LogPlugin, [{
	      key: "copyLog",
	      value: function copyLog() {
	        var debugInfo = this.getDebugInfo();
	        copyToClipboard(JSON.stringify(debugInfo));
	        this.player.model.bezel.switch(check);
	      }
	    }, {
	      key: "uploadLog",
	      value: function uploadLog() {
	        var url = this.errorLogUrl;
	        var debugInfo = this.getDebugInfo();
	        url && postLog(url, debugInfo);
	        this.player.model.bezel.switch(check);
	      }
	    }, {
	      key: "uploadError",
	      value: function uploadError(err) {
	        var url = this.errorLogUrl;
	        url && postLog(url, err);
	      }
	    }, {
	      key: "filterLog",
	      value: function filterLog() {
	        // remove extra time event [time, time, ..., time] => [time, time]
	        var logs = [];
	        this.logs.forEach(function (v, i, arr) {
	          var pre = arr[i - 1];
	          var next = arr[i + 1];
	
	          if (v.type === 'time' && pre && pre.type === 'time' && next && next.type === 'time') {
	            return;
	          }
	
	          logs.push(v);
	        });
	        this.logs = logs;
	        return logs;
	      }
	    }, {
	      key: "getDebugInfo",
	      value: function getDebugInfo() {
	        var log = this.filterLog();
	        var info = this.getOtherInfo();
	        info.log = log;
	        return info;
	      }
	    }, {
	      key: "getOtherInfo",
	      value: function getOtherInfo() {
	        var status = _objectSpread({}, this.player._status, {
	          localization: ''
	        });
	
	        var config = this.player._config;
	        var env = getEnvor();
	        var provider = {};
	
	        if (this.player._provider) {
	          provider.name = this.player._provider.name;
	        }
	
	        var plugins = objectKeys(this.player.plugin);
	        var container = document.getElementById(this.player._config.containerId);
	        var html = container && container.outerHTML;
	        var info = {
	          uniqId: status.uniqId,
	          status: status,
	          config: config,
	          env: env,
	          provider: provider,
	          plugins: plugins,
	          ua: navigator.userAgent,
	          version: "0.39.10",
	          url: window.location.href,
	          documentTitle: document.title,
	          html: html,
	          cookie: document.cookie
	        };
	        return info;
	      }
	    }]);
	
	    return LogPlugin;
	  }(Plugin);
	
	  LogPlugin.isSupported = returnTrue;
	  LogPlugin.defaultOptions = {};
	
	  var VRProvider =
	  /*#__PURE__*/
	  function (_HTML5Provider) {
	    _inherits(VRProvider, _HTML5Provider);
	
	    function VRProvider(player, option) {
	      var _this;
	
	      _classCallCheck(this, VRProvider);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(VRProvider).call(this, player, option));
	      _this.player = player;
	      _this.option = option;
	      _this.TAG = 'vrProvider';
	      _this.inited = false;
	      _this.isFullscreen = false;
	      return _this;
	    }
	
	    _createClass(VRProvider, [{
	      key: "loadFiles",
	      value: function loadFiles() {
	        // let loader = new ScriptLoader('https://localhost:9000/mudu-vr-player.umd.js')
	        var loader = new ScriptLoader('https://static.mudu.tv/mudu-vr-player/v0.1.0/mudu-vr-player.umd.js');
	        return loader.load();
	      }
	    }, {
	      key: "setup",
	      value: function setup() {
	        if (this.inited) {
	          this.destroy();
	        }
	
	        this.initVRPlayer();
	      }
	    }, {
	      key: "initVRPlayer",
	      value: function initVRPlayer() {
	        var _this2 = this;
	
	        this.inited = true;
	        this.containerElem = this.player.dom.videoWrap;
	        this.videoElem = this.player.dom.videoWrap.querySelector('video');
	        this.containerElem.classList.add(vrMode);
	        this.vrPlayer = new window.muduVRPlayer.VRPlayer(this.containerElem, this.videoElem, _objectSpread({}, this.option, {
	          onSuccess: function onSuccess() {
	            return _this2._onVRInitSuccess();
	          }
	        }));
	        this.subEvents();
	      }
	    }, {
	      key: "destroy",
	      value: function destroy() {
	        this.vrPlayer.destroy();
	        this.inited = false;
	      }
	    }, {
	      key: "subEvents",
	      value: function subEvents() {
	        var _this3 = this;
	
	        this.onDom(this.containerElem, 'click', function (e) {
	          e.stopPropagation();
	        });
	        this.onDom(window, 'resize', function () {
	          _this3.vrPlayer.resize();
	        });
	        this.onPlayer(OUTER_FULLSCREEN, function (e) {
	          setTimeout(function () {
	            _this3.vrPlayer.resize(_this3.containerElem.clientWidth, _this3.containerElem.clientHeight);
	          }, 0);
	        });
	        this.oncePlayer(INTERNAL_PROVIDER_REMOVED, function (e) {
	          _this3.destroy();
	        });
	      }
	    }, {
	      key: "_onVRInitSuccess",
	      value: function _onVRInitSuccess() {
	        this.videoElem.classList.add(hideVideo);
	        document.body.appendChild(this.videoElem);
	
	        if (typeof this.option.onSuccess === 'function') {
	          this.option.onSuccess();
	        }
	      }
	    }]);
	
	    return VRProvider;
	  }(HTML5Provider);
	
	  VRProvider.isSupported = function () {
	    return true;
	  };
	
	  VRProvider.defaultOptions = {
	    projection: 'sphere'
	  };
	
	  VRProvider.canPlay = function (type) {
	    // console.log('vr: play type', type)
	    if (type === 'flash') {
	      return false;
	    }
	
	    return true;
	  };
	
	  VRProvider.isLiveSupported = function () {
	    // console.log('vr is live supported')
	    return true;
	  };
	
	  var index$2 = 0; // eslint-disable-line
	
	  var instances = {};
	
	  function muduPlayer(containerId) {
	    var container = document.getElementById(containerId);
	
	    if (!container) {
	      throw new Error("muduPlayer(container): container should be an id of a div in the body, but not found");
	    }
	
	    if (instances[containerId]) {
	      if (instances[containerId]._status) {
	        return instances[containerId];
	      }
	    }
	
	    index$2++;
	    var player = new Player(containerId);
	    instances[containerId] = player;
	    player._status.index = index$2;
	    return player;
	  }
	
	  muduPlayer.VERSION = "0.39.10";
	  muduPlayer.setDefaultOptions = setDefaultOptions;
	  muduPlayer.getDefaultOptions = getDefaultOptions;
	  muduPlayer.registerProvider = registerProvider;
	  muduPlayer.registerExtraProvider = registerExtraProvider;
	  muduPlayer.getProvider = getProvider;
	  muduPlayer.getExtraProvider = getExtraProvider;
	  muduPlayer.getProviders = getProviders;
	  muduPlayer.getExtraProviders = getExtraProviders;
	  muduPlayer.chooseProvider = chooseProvider;
	  muduPlayer.registerPlugin = registerPlugin;
	  muduPlayer.getPlugin = getPlugin;
	  muduPlayer.getPlugins = getPlugins;
	  muduPlayer.utils = {
	    formatPlaylist: formatPlaylist,
	    Timer: Timer,
	    ScriptLoader: ScriptLoader,
	    browser: browser$1,
	    Cache: Cache,
	    delegates: Delegator
	  };
	  muduPlayer.registerExtraProvider('vr', VRProvider);
	  muduPlayer.registerProvider('html5', HTML5Provider);
	  muduPlayer.registerProvider('dash', Dash);
	  muduPlayer.registerProvider('flvjs', Flvjs);
	  muduPlayer.registerProvider('hlsjs', Hlsjs);
	  muduPlayer.registerProvider('hlsPeer5', HlsPeer5);
	  muduPlayer.registerProvider('tcPlayerLite', TcPlayerLite);
	  muduPlayer.registerProvider('flash', Flash); // 已经不支持了 放到最后
	
	  muduPlayer.registerProvider('hlsXp2p', HlsXP2P); // muduPlayer.registerProvider('hlsjs-p2p', HlsjsP2pProvider)
	
	  muduPlayer.registerPlugin('plugin', Plugin); // muduPlayer.registerPlugin('x5', X5Plugin)
	
	  muduPlayer.registerPlugin('tick', Tick);
	  muduPlayer.registerPlugin('danmaku', DanmakuPlugin);
	  muduPlayer.registerPlugin('muduDanmaku', MuduDanmakuPlugin); // muduPlayer.registerPlugin('googleAnalysis', GoogleAnalysisPlugin)
	  // muduPlayer.registerPlugin('memorizePosition', MemorizePositionPlugin)
	
	  muduPlayer.registerPlugin('log', LogPlugin);
	
	  return muduPlayer;
	
	})));
	//# sourceMappingURL=mudu-player.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 116 */
/***/ function(module, exports) {

	
	/**
	 * Expose `Delegator`.
	 */
	
	module.exports = Delegator;
	
	/**
	 * Initialize a delegator.
	 *
	 * @param {Object} proto
	 * @param {String} target
	 * @api public
	 */
	
	function Delegator(proto, target) {
	  if (!(this instanceof Delegator)) return new Delegator(proto, target);
	  this.proto = proto;
	  this.target = target;
	  this.methods = [];
	  this.getters = [];
	  this.setters = [];
	  this.fluents = [];
	}
	
	/**
	 * Delegate method `name`.
	 *
	 * @param {String} name
	 * @return {Delegator} self
	 * @api public
	 */
	
	Delegator.prototype.method = function(name){
	  var proto = this.proto;
	  var target = this.target;
	  this.methods.push(name);
	
	  proto[name] = function(){
	    return this[target][name].apply(this[target], arguments);
	  };
	
	  return this;
	};
	
	/**
	 * Delegator accessor `name`.
	 *
	 * @param {String} name
	 * @return {Delegator} self
	 * @api public
	 */
	
	Delegator.prototype.access = function(name){
	  return this.getter(name).setter(name);
	};
	
	/**
	 * Delegator getter `name`.
	 *
	 * @param {String} name
	 * @return {Delegator} self
	 * @api public
	 */
	
	Delegator.prototype.getter = function(name){
	  var proto = this.proto;
	  var target = this.target;
	  this.getters.push(name);
	
	  proto.__defineGetter__(name, function(){
	    return this[target][name];
	  });
	
	  return this;
	};
	
	/**
	 * Delegator setter `name`.
	 *
	 * @param {String} name
	 * @return {Delegator} self
	 * @api public
	 */
	
	Delegator.prototype.setter = function(name){
	  var proto = this.proto;
	  var target = this.target;
	  this.setters.push(name);
	
	  proto.__defineSetter__(name, function(val){
	    return this[target][name] = val;
	  });
	
	  return this;
	};
	
	/**
	 * Delegator fluent accessor
	 *
	 * @param {String} name
	 * @return {Delegator} self
	 * @api public
	 */
	
	Delegator.prototype.fluent = function (name) {
	  var proto = this.proto;
	  var target = this.target;
	  this.fluents.push(name);
	
	  proto[name] = function(val){
	    if ('undefined' != typeof val) {
	      this[target][name] = val;
	      return this;
	    } else {
	      return this[target][name];
	    }
	  };
	
	  return this;
	};


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	// production
	var API_DOMAIN = 'https://mudu.tv';
	var AUTH_DOMAIN = 'https://mudu.tv';
	var API_DOMAIN_V2 = 'https://liveapi.mudu.tv';
	
	/**
	 * 定制功能，7.25下线
	 * 定制用户的uin，强行将回放视频的打点数据用于所有回放视频播放
	 */
	var customForceBookmarkUin = [];
	
	switch (window.MUDU_SERVER_ENV) {
	    case 'TEST':
	        API_DOMAIN = 'https://test.mudu.tv';
	        AUTH_DOMAIN = 'https://test.mudu.tv';
	        API_DOMAIN_V2 = 'https://testsvc-3.mudu.tv';
	        break;
	    case 'UAT':
	        API_DOMAIN = 'https://mdl-live.uat.mudu.tv/';
	        AUTH_DOMAIN = 'https://mdl-live.uat.mudu.tv/';
	        API_DOMAIN_V2 = 'https://mdl-liveapi.uat.mudu.tv';
	        break;
	    case 'TX_PROD':
	    case 'PROD':
	    default:
	        API_DOMAIN = 'https://mudu.tv';
	        AUTH_DOMAIN = 'https://mudu.tv';
	        API_DOMAIN_V2 = 'https://liveapi.mudu.tv';
	}
	
	var BASE_INFO_URL = API_DOMAIN + '/?c=activity&a=ajaxActBaseInfo';
	
	var SIGNUP_SENDSMS_URL = API_DOMAIN + '/?c=activity&a=ajaxSendPhoneVerify';
	var SIGNUP_SUBMIT_URL = API_DOMAIN + '/?c=activity&a=ajaxSaveSignupRecord';
	
	// var TOPIC_GET_SINGLE_TOPIC_URL = `${API_DOMAIN}/?c=activity&a=ajaxGetSingleTopic`;
	var TOPIC_GET_REPLY_URL = API_DOMAIN + '/?c=activity&a=ajaxGetReplies';
	var TOPIC_GET_URL = API_DOMAIN + '/?c=activity&a=ajaxGetTopics';
	var TOPIC_CREATE_URL = API_DOMAIN + '/?c=activity&a=ajaxCreateTopic';
	
	var SOCIAL_LOGIN_URL = API_DOMAIN + '/?c=sociallogin&a=sdklogin';
	var RELATIVE_SOCIAL_LOGIN_URL = '/?c=sociallogin&a=sdklogin';
	
	var REDPACK_STATUS_URL = API_DOMAIN + '/?c=activity&a=ajaxGetRedpackStatus';
	var REDPACK_RECORD_URL = API_DOMAIN + '/?c=activity&a=ajaxGetRedpackRecord';
	var REDPACK_SNATCH_URL = API_DOMAIN + '/?c=activity&a=ajaxSnatchRedpack';
	
	var CASH_DONATE_DETAIL_URL = API_DOMAIN + '/?c=user&a=ajaxGetDonateMessage';
	var GIFT_DETAIL_URL = API_DOMAIN + '/activity.php?a=AjaxGiftDetail';
	var DONATE_URL = API_DOMAIN + '/user.php?a=donate';
	var RELATIVE_DONATE_URL = '/user.php?a=donate';
	var FREE_GIFT_DONATE_URL = API_DOMAIN + '/user.php?a=ajaxFreePropDonate';
	
	var PPT_GET_IMG_BY_PAGE_URL = API_DOMAIN + '/?c=document&a=ajaxGetPageImage';
	
	// 用户授权 
	var USER_AUTH_START_SESSION = AUTH_DOMAIN + '/user/api/session/start'; // 使用时尾部拼:actHashId
	var USER_AUTH_GET_USER_INFO = AUTH_DOMAIN + '/user/api/user_info/'; // 去掉了 不需要了
	var USER_AUTH_ANONYMOUS = AUTH_DOMAIN + '/user/api/login/anonymous'; // 匿名登录替换了新接口
	var USER_AUTH_LOGIN_BY_OTHER = AUTH_DOMAIN + '/user/api/login_by_other';
	
	var SOCIAL_LOGIN_TYPE_ARRAY = ['qq', 'weibo', 'weixin', 'openweixin', 'mingdao', 'weimob'];
	
	var COMMENT_IMAGE_NUM_REG = /<img src='\/assets\/activity\/images\/face\/(\d+)\.png' width='18' height='18'\/>/g;
	var COMMENT_TEXT_REG = /\[em_([0-9]*)\]/g;
	
	var STREAM_MULTI_RATE = {
	    'origin': '原片',
	    '480p': '标清',
	    '720p': '高清'
	};
	
	var MENU_TYPE = {
	    DOC: 9,
	    CHAT: 1
	};
	
	module.exports = {
	    customForceBookmarkUin: customForceBookmarkUin,
	    API_DOMAIN: API_DOMAIN,
	    API_DOMAIN_V2: API_DOMAIN_V2,
	    BASE_INFO_URL: BASE_INFO_URL,
	    MENU_TYPE: MENU_TYPE,
	
	    SIGNUP_SENDSMS_URL: SIGNUP_SENDSMS_URL,
	    SIGNUP_SUBMIT_URL: SIGNUP_SUBMIT_URL,
	
	    // TOPIC_GET_SINGLE_TOPIC_URL,
	    TOPIC_GET_REPLY_URL: TOPIC_GET_REPLY_URL,
	    TOPIC_GET_URL: TOPIC_GET_URL,
	    TOPIC_CREATE_URL: TOPIC_CREATE_URL,
	    SOCIAL_LOGIN_URL: SOCIAL_LOGIN_URL,
	    RELATIVE_SOCIAL_LOGIN_URL: RELATIVE_SOCIAL_LOGIN_URL,
	    REDPACK_STATUS_URL: REDPACK_STATUS_URL,
	    REDPACK_RECORD_URL: REDPACK_RECORD_URL,
	    REDPACK_SNATCH_URL: REDPACK_SNATCH_URL,
	    CASH_DONATE_DETAIL_URL: CASH_DONATE_DETAIL_URL,
	    GIFT_DETAIL_URL: GIFT_DETAIL_URL,
	    DONATE_URL: DONATE_URL,
	    RELATIVE_DONATE_URL: RELATIVE_DONATE_URL,
	    FREE_GIFT_DONATE_URL: FREE_GIFT_DONATE_URL,
	    PPT_GET_IMG_BY_PAGE_URL: PPT_GET_IMG_BY_PAGE_URL,
	
	    COMMENT_IMAGE_NUM_REG: COMMENT_IMAGE_NUM_REG,
	    COMMENT_TEXT_REG: COMMENT_TEXT_REG,
	
	    SOCIAL_LOGIN_TYPE_ARRAY: SOCIAL_LOGIN_TYPE_ARRAY,
	
	    AUTH_DOMAIN: AUTH_DOMAIN,
	    USER_AUTH_START_SESSION: USER_AUTH_START_SESSION,
	    USER_AUTH_GET_USER_INFO: USER_AUTH_GET_USER_INFO,
	    USER_AUTH_ANONYMOUS: USER_AUTH_ANONYMOUS,
	    USER_AUTH_LOGIN_BY_OTHER: USER_AUTH_LOGIN_BY_OTHER,
	    STREAM_MULTI_RATE: STREAM_MULTI_RATE
	};


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	(function(){
	  var crypt = __webpack_require__(119),
	      utf8 = __webpack_require__(120).utf8,
	      isBuffer = __webpack_require__(121),
	      bin = __webpack_require__(120).bin,
	
	  // The core
	  md5 = function (message, options) {
	    // Convert to byte array
	    if (message.constructor == String)
	      if (options && options.encoding === 'binary')
	        message = bin.stringToBytes(message);
	      else
	        message = utf8.stringToBytes(message);
	    else if (isBuffer(message))
	      message = Array.prototype.slice.call(message, 0);
	    else if (!Array.isArray(message) && message.constructor !== Uint8Array)
	      message = message.toString();
	    // else, assume byte array already
	
	    var m = crypt.bytesToWords(message),
	        l = message.length * 8,
	        a =  1732584193,
	        b = -271733879,
	        c = -1732584194,
	        d =  271733878;
	
	    // Swap endian
	    for (var i = 0; i < m.length; i++) {
	      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
	             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
	    }
	
	    // Padding
	    m[l >>> 5] |= 0x80 << (l % 32);
	    m[(((l + 64) >>> 9) << 4) + 14] = l;
	
	    // Method shortcuts
	    var FF = md5._ff,
	        GG = md5._gg,
	        HH = md5._hh,
	        II = md5._ii;
	
	    for (var i = 0; i < m.length; i += 16) {
	
	      var aa = a,
	          bb = b,
	          cc = c,
	          dd = d;
	
	      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
	      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
	      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
	      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
	      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
	      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
	      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
	      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
	      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
	      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
	      c = FF(c, d, a, b, m[i+10], 17, -42063);
	      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
	      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
	      d = FF(d, a, b, c, m[i+13], 12, -40341101);
	      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
	      b = FF(b, c, d, a, m[i+15], 22,  1236535329);
	
	      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
	      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
	      c = GG(c, d, a, b, m[i+11], 14,  643717713);
	      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
	      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
	      d = GG(d, a, b, c, m[i+10],  9,  38016083);
	      c = GG(c, d, a, b, m[i+15], 14, -660478335);
	      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
	      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
	      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
	      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
	      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
	      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
	      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
	      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
	      b = GG(b, c, d, a, m[i+12], 20, -1926607734);
	
	      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
	      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
	      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
	      b = HH(b, c, d, a, m[i+14], 23, -35309556);
	      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
	      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
	      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
	      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
	      a = HH(a, b, c, d, m[i+13],  4,  681279174);
	      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
	      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
	      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
	      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
	      d = HH(d, a, b, c, m[i+12], 11, -421815835);
	      c = HH(c, d, a, b, m[i+15], 16,  530742520);
	      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);
	
	      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
	      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
	      c = II(c, d, a, b, m[i+14], 15, -1416354905);
	      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
	      a = II(a, b, c, d, m[i+12],  6,  1700485571);
	      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
	      c = II(c, d, a, b, m[i+10], 15, -1051523);
	      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
	      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
	      d = II(d, a, b, c, m[i+15], 10, -30611744);
	      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
	      b = II(b, c, d, a, m[i+13], 21,  1309151649);
	      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
	      d = II(d, a, b, c, m[i+11], 10, -1120210379);
	      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
	      b = II(b, c, d, a, m[i+ 9], 21, -343485551);
	
	      a = (a + aa) >>> 0;
	      b = (b + bb) >>> 0;
	      c = (c + cc) >>> 0;
	      d = (d + dd) >>> 0;
	    }
	
	    return crypt.endian([a, b, c, d]);
	  };
	
	  // Auxiliary functions
	  md5._ff  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._gg  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._hh  = function (a, b, c, d, x, s, t) {
	    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._ii  = function (a, b, c, d, x, s, t) {
	    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	
	  // Package private blocksize
	  md5._blocksize = 16;
	  md5._digestsize = 16;
	
	  module.exports = function (message, options) {
	    if (message === undefined || message === null)
	      throw new Error('Illegal argument ' + message);
	
	    var digestbytes = crypt.wordsToBytes(md5(message, options));
	    return options && options.asBytes ? digestbytes :
	        options && options.asString ? bin.bytesToString(digestbytes) :
	        crypt.bytesToHex(digestbytes);
	  };
	
	})();


/***/ },
/* 119 */
/***/ function(module, exports) {

	(function() {
	  var base64map
	      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
	
	  crypt = {
	    // Bit-wise rotation left
	    rotl: function(n, b) {
	      return (n << b) | (n >>> (32 - b));
	    },
	
	    // Bit-wise rotation right
	    rotr: function(n, b) {
	      return (n << (32 - b)) | (n >>> b);
	    },
	
	    // Swap big-endian to little-endian and vice versa
	    endian: function(n) {
	      // If number given, swap endian
	      if (n.constructor == Number) {
	        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
	      }
	
	      // Else, assume array and swap all items
	      for (var i = 0; i < n.length; i++)
	        n[i] = crypt.endian(n[i]);
	      return n;
	    },
	
	    // Generate an array of any length of random bytes
	    randomBytes: function(n) {
	      for (var bytes = []; n > 0; n--)
	        bytes.push(Math.floor(Math.random() * 256));
	      return bytes;
	    },
	
	    // Convert a byte array to big-endian 32-bit words
	    bytesToWords: function(bytes) {
	      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
	        words[b >>> 5] |= bytes[i] << (24 - b % 32);
	      return words;
	    },
	
	    // Convert big-endian 32-bit words to a byte array
	    wordsToBytes: function(words) {
	      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
	        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a hex string
	    bytesToHex: function(bytes) {
	      for (var hex = [], i = 0; i < bytes.length; i++) {
	        hex.push((bytes[i] >>> 4).toString(16));
	        hex.push((bytes[i] & 0xF).toString(16));
	      }
	      return hex.join('');
	    },
	
	    // Convert a hex string to a byte array
	    hexToBytes: function(hex) {
	      for (var bytes = [], c = 0; c < hex.length; c += 2)
	        bytes.push(parseInt(hex.substr(c, 2), 16));
	      return bytes;
	    },
	
	    // Convert a byte array to a base-64 string
	    bytesToBase64: function(bytes) {
	      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
	        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
	        for (var j = 0; j < 4; j++)
	          if (i * 8 + j * 6 <= bytes.length * 8)
	            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
	          else
	            base64.push('=');
	      }
	      return base64.join('');
	    },
	
	    // Convert a base-64 string to a byte array
	    base64ToBytes: function(base64) {
	      // Remove non-base-64 characters
	      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');
	
	      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
	          imod4 = ++i % 4) {
	        if (imod4 == 0) continue;
	        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
	            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
	            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
	      }
	      return bytes;
	    }
	  };
	
	  module.exports = crypt;
	})();


/***/ },
/* 120 */
/***/ function(module, exports) {

	var charenc = {
	  // UTF-8 encoding
	  utf8: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
	    }
	  },
	
	  // Binary encoding
	  bin: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      for (var bytes = [], i = 0; i < str.length; i++)
	        bytes.push(str.charCodeAt(i) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      for (var str = [], i = 0; i < bytes.length; i++)
	        str.push(String.fromCharCode(bytes[i]));
	      return str.join('');
	    }
	  }
	};
	
	module.exports = charenc;


/***/ },
/* 121 */
/***/ function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {if(!global["_scope"]) global["_scope"] = {};
	module.exports = global["_scope"]["Timer"] = __webpack_require__(123);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	var _extends2 = __webpack_require__(103);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(110);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(111);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	// this is a timer component which can be used as a timer passed watcher and notifier
	module.exports = function () {
	    function Timer() {
	        var _this = this;
	
	        var topic = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Timer.TimePassed';
	        var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        (0, _classCallCheck3["default"])(this, Timer);
	
	        this.param = param;
	        this.task = null;
	        this.topic = topic;
	        this.dotTime = new Date().getTime();
	        this.uuid = _scope.Utils.Guid();
	
	        _scope.MsgBus.On('timer.stop', function (cb) {
	            // 外部关闭当前计时器, 处理用户多次new Player产生的多次计费
	            if (typeof cb === 'function' && cb(_this)) {
	                _this.stop();
	            }
	        });
	    }
	
	    (0, _createClass3["default"])(Timer, [{
	        key: 'start',
	        value: function start() {
	            this.stop();
	            (function (self) {
	                self.task = setTimeout(function t() {
	                    var duration = self._passedTime();
	                    if (duration > 0) {
	                        _scope.MsgBus.Pub(self.topic, (0, _extends3["default"])({}, self.param, { duration: duration }));
	                    }
	                    self.task = setTimeout(t, self.param.timegap || _scope.Utils.GetRandomNum(10, 60) * 1000);
	                }, self.param.timegap || _scope.Utils.GetRandomNum(60, 10) * 1000);
	            })(this);
	        }
	    }, {
	        key: 'stop',
	        value: function stop() {
	            if (!this.task) {
	                this._passedTime();
	                return;
	            }
	            clearTimeout(this.task);
	            this.task = null;
	            var duration = this._passedTime();
	            if (duration > 0) {
	                _scope.MsgBus.Pub(this.topic, (0, _extends3["default"])({}, this.param, { duration: duration }));
	            }
	        }
	    }, {
	        key: '_passedTime',
	        value: function _passedTime() {
	            var passedTime = new Date().getTime() - this.dotTime;
	            this.dotTime = new Date().getTime();
	            return parseInt(passedTime / 1000);
	        }
	    }]);
	    return Timer;
	}();


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {if(!global["_scope"]) global["_scope"] = {};
	module.exports = global["_scope"]["DB"] = __webpack_require__(125);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	var _classCallCheck2 = __webpack_require__(110);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(111);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * 数据中心
	 * 解决全局数据共享问题
	 */
	var DB = function () {
	    function DB() {
	        (0, _classCallCheck3["default"])(this, DB);
	
	        this.datas = {};
	    }
	
	    (0, _createClass3["default"])(DB, [{
	        key: 'Set',
	        value: function Set(key, value) {
	            var _this = this;
	
	            var expire = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	            var dataNode = { key: key, value: value, expire: expire };
	            this.datas[key] = dataNode;
	            if (expire > 0) {
	                setTimeout(function () {
	                    _scope.MsgBus.Pub('Data.Timeout.' + key, dataNode);
	                    _this.Del(key);
	                }, expire * 1000);
	            }
	            _scope.MsgBus.Pub('Data.Set.' + key, dataNode);
	        }
	    }, {
	        key: 'Get',
	        value: function Get(key) {
	            var defaultVal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
	            if (typeof this.datas[key] === 'undefined') {
	                return defaultVal;
	            }
	            return this.datas[key]['value'];
	        }
	    }, {
	        key: 'Del',
	        value: function Del(key) {
	            if (typeof this.datas[key] === 'undefined') {
	                return;
	            }
	            _scope.MsgBus.Pub('Data.Del.' + key, this.datas[key]);
	            delete this.datas[key];
	            this.datas[key] = undefined;
	        }
	    }]);
	    return DB;
	}();
	
	module.exports = new DB();


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {if(!global["_scope"]) global["_scope"] = {};
	module.exports = global["_scope"]["Feature"] = __webpack_require__(127);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	module.exports = {
	    Room: function Room(obj, cb) {
	        _scope.MsgBus.Sub('SendObj.Room', function (data) {
	            obj.Room = data;
	            if (typeof cb === 'function') {
	                cb(data);
	            }
	        });
	    },
	
	    User: function User(obj, cb) {
	        _scope.MsgBus.Sub('SendObj.User', function (data) {
	            obj.User = data;
	            if (typeof cb === 'function') {
	                cb(data);
	            }
	        });
	    },
	
	    Comment: function Comment(obj, cb) {
	        _scope.MsgBus.Sub('SendObj.Comment', function (data) {
	            obj.Comment = data;
	            if (typeof cb === 'function') {
	                cb(data);
	            }
	        });
	    },
	
	    LuckyDraw: function LuckyDraw(obj, cb) {
	        _scope.MsgBus.Sub('SendObj.LuckyDraw', function (data) {
	            obj.LuckyDraw = data;
	            if (typeof cb === 'function') {
	                cb(data);
	            }
	        });
	    },
	
	    PPT: function PPT(obj, cb) {
	        _scope.MsgBus.Sub('SendObj.PPT', function (data) {
	            obj.PPT = data;
	            if (typeof cb === 'function') {
	                cb(data);
	            }
	        });
	    },
	
	    Vote: function Vote(obj, cb) {
	        _scope.MsgBus.Sub('SendObj.Vote', function (data) {
	            obj.Vote = data;
	            if (typeof cb === 'function') {
	                cb(data);
	            }
	        });
	    },
	
	    Barrage: function Barrage(obj, cb) {
	        _scope.MsgBus.Sub('SendObj.Barrage', function (data) {
	            obj.Barrage = data;
	            if (typeof cb === 'function') {
	                cb(data);
	            }
	        });
	    },
	
	    Signup: function Signup(obj, cb) {
	        _scope.MsgBus.Sub('SendObj.Signup', function (data) {
	            obj.Signup = data;
	            if (typeof cb === 'function') {
	                cb(data);
	            }
	        });
	    },
	
	    Topic: function Topic(obj, cb) {
	        _scope.MsgBus.Sub('SendObj.Topic', function (data) {
	            obj.Topic = data;
	            if (typeof cb === 'function') {
	                cb(data);
	            }
	        });
	    },
	
	    Redpack: function Redpack(obj, cb) {
	        _scope.MsgBus.Sub('SendObj.Redpack', function (data) {
	            obj.Redpack = data;
	            if (typeof cb === 'function') {
	                cb(data);
	            }
	        });
	    },
	
	    Reward: function Reward(obj, cb) {
	        _scope.MsgBus.Sub('SendObj.Reward', function (data) {
	            obj.Reward = data;
	            if (typeof cb === 'function') {
	                cb(data);
	            }
	        });
	    },
	    Signin: function Signin(obj, cb) {
	        _scope.MsgBus.Sub('SendObj.Signin', function (data) {
	            obj.Signin = data;
	            if (typeof cb === 'function') {
	                cb(data);
	            }
	        });
	    },
	    Appointment: function Appointment(obj, cb) {
	        _scope.MsgBus.Sub('SendObj.Appointment', function (data) {
	            obj.Appointment = data;
	            if (typeof cb === 'function') {
	                cb(data);
	            }
	        });
	    },
	    Notice: function Notice(obj, cb) {
	        _scope.MsgBus.Sub('SendObj.Notice', function (data) {
	            obj.Notice = data;
	            if (typeof cb === 'function') {
	                cb(data);
	            }
	        });
	    },
	    EventBus: function EventBus(obj) {
	        var _namespace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	        if (_namespace != '') {
	            _namespace = _namespace + '.';
	        }
	        obj.On = function (_topic, _cb) {
	            return _scope.MsgBus.Sub(_namespace + _topic, _cb);
	        };
	
	        obj.Off = function (_key) {
	            _scope.MsgBus.UnSub(_key);
	        };
	
	        obj.Fire = function (_topic, _data) {
	            _scope.MsgBus.Pub(_namespace + _topic, _data);
	        };
	    }
	};


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {if(!global["_scope"]) global["_scope"] = {};
	module.exports = global["_scope"]["Room"] = __webpack_require__(129);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	var _promise = __webpack_require__(83);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _assign = __webpack_require__(104);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _toConsumableArray2 = __webpack_require__(130);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _keys = __webpack_require__(135);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(103);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(139);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(110);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(111);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _version = __webpack_require__(141);
	
	var _version2 = _interopRequireDefault(_version);
	
	var _im = __webpack_require__(142);
	
	var _actErrcode = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	// this is api of mudu live page
	// var browser = require('../../helper/browser');
	var config = __webpack_require__(117);
	var tracker = __webpack_require__(145);
	var md5 = __webpack_require__(118);
	// 观看地址定制0:关闭 1:仅内网 2仅海外 3根据ip切换
	var CustomizedAddressType = {
	    INTRANET_ONLY: 1,
	    OVERSEA_ONLY: 2,
	    AUTO_SWITCH_BY_IP: 3,
	    NULL: 0
	};
	
	var versionTag = '#MDLSDK' + _version2["default"];
	
	module.exports = function () {
	    function Room(param) {
	        (0, _classCallCheck3["default"])(this, Room);
	
	        _scope.Feature.EventBus(this);
	        _scope.Feature.User(this);
	        _scope.Feature.Comment(this);
	        _scope.Feature.LuckyDraw(this);
	        _scope.Feature.PPT(this);
	        _scope.Feature.Barrage(this);
	        _scope.Feature.Vote(this);
	        _scope.Feature.Signup(this);
	        _scope.Feature.Topic(this);
	        _scope.Feature.Redpack(this);
	        _scope.Feature.Reward(this);
	        _scope.Feature.Signin(this);
	        _scope.Feature.Appointment(this);
	        _scope.Feature.Notice(this);
	        this.act_id = param.roomId;
	        this.actHashId = param.roomHashId;
	
	        this.tracker = tracker(function () {
	            _scope.MsgBus.Pub('Tracker.Init.Over');
	        });
	        _scope.DB.Set('Room', this);
	        this._msgbusDestroy();
	        _scope.MsgBus.OnMultiOnce(['Room.StreamUpdate.Over', 'Room.TrailerUpdate.Over'], function () {
	            _scope.MsgBus.Pub('Room.Init.Over');
	        });
	
	        this.mapStreamToPlaylistItem = {}; // 流id到直播playlistItem的映射对象
	        this.mapStreamToTrailerItems = {}; // 流id到回放视频（单个）的映射
	        this.mainStream = ''; // 主流id
	        this.allStreams = []; // 所有流数据列表（流id、名称、推流状态）
	
	        // 兼容老数据
	        this.originMainStream = {}; // 原始流数据，默认记录主流
	    }
	
	    (0, _createClass3["default"])(Room, [{
	        key: '_msgbusDestroy',
	        value: function _msgbusDestroy() {
	            var _this = this;
	
	            this.destroyKey = _scope.MsgBus.Sub('Destroy', function () {
	                _scope.MsgBus.UnSubAll('User.WatchTime');
	
	                _this.allStreams.forEach(function (stream) {
	                    rop.Remove('stream-event-' + stream);
	                });
	                _scope.MsgBus.UnSubAll('Room.StreamEvent');
	                _scope.MsgBus.UnSubAll('Room.ViewNumChanged');
	
	                _scope.MsgBus.UnSubAll('Room.Init.Error');
	                _scope.MsgBus.UnSubAll('SendObj.PPT');
	                _scope.MsgBus.UnSubAll('SendObj.Signup');
	                _scope.MsgBus.UnSubAll('SendObj.Signin');
	                _scope.MsgBus.UnSubAll('SendObj.Topic');
	                _scope.MsgBus.UnSubAll('SendObj.Reward');
	                _scope.MsgBus.UnSubAll('SendObj.Comment');
	                _scope.MsgBus.UnSubAll('Room.Init.Over');
	                _scope.MsgBus.UnSubAll('Room.StreamUpdate.Over');
	                _scope.MsgBus.UnSubAll('Room.TrailerUpdate.Over');
	                _scope.MsgBus.UnSubAll('User.Offline');
	
	                _this._destroy();
	
	                _scope.MsgBus.UnSub(_this.destroyKey);
	            });
	        }
	    }, {
	        key: '_startSeesion',
	        value: function _startSeesion(actHashId, projectId) {
	            var _this2 = this;
	
	            var data = {
	                project_id: projectId,
	                //referer: (document.referrer || '').split('/').slice(0, 3).join('/'), // 仅保留协议 域名 端口,
	                screen_resolution: (window.screen.width || 0) + 'x' + (window.screen.height || 0),
	                language: (navigator.language || '').toLowerCase().substr(0, 2),
	                from_label: this.tracker.getOrigintype(),
	                from_value: '',
	                location: window.location.href + versionTag,
	                service_provider: '',
	                title: this.name,
	                page: this.tracker.getPage()
	            };
	            Fetcher.Post(config.USER_AUTH_START_SESSION + '?act_id=' + actHashId, (0, _stringify2["default"])(data), function (res, code) {
	
	                if (code === 403) {
	                    _this2._login_by_anonymous(actHashId);
	                } else {
	                    res = JSON.parse(res);
	                    var newUser = {
	                        session_id: res.session_id,
	                        token: res.token,
	                        user: res.user
	                    };
	                    _this2._updateUserAuth(newUser);
	                    _this2._updateUserPhone(newUser);
	                }
	            }, (0, _extends3["default"])({
	                'Content-Type': 'application/json'
	            }, this._tokenHeader));
	        }
	        // 更新用户身份信息，token、session
	
	    }, {
	        key: '_updateUserAuth',
	        value: function _updateUserAuth(authInfo) {
	            if (authInfo.token) {
	                this._tokenHeader = {
	                    authorization: 'Bearer ' + authInfo.token
	                };
	            }
	            if (authInfo.session_id) {
	                this._sessionHeader = {
	                    MUDUTVSESSIONID: authInfo.session_id
	                };
	            }
	            _scope.DB.Set('requestHeader', { session: this._sessionHeader, token: this._tokenHeader });
	        }
	        // session start之后获取当前用户绑定的手机号
	
	    }, {
	        key: '_updateUserPhone',
	        value: function _updateUserPhone(newUser) {
	            // 只有assign的用户才会有手机号
	            var updatePhoneParam = {
	                act_id: this.actHashId,
	                event: 'assign',
	                session_id: newUser.session_id
	            };
	            Fetcher.Post(config.API_DOMAIN + '/user/api/should_update_useract_phone', (0, _stringify2["default"])(updatePhoneParam), function (res) {
	                var phone = '';
	                try {
	                    var data = JSON.parse(res);
	                    if (data.errcode === 1000) {
	                        phone = data.phone;
	                    }
	                } catch (error) {
	                    console.error(error);
	                }
	                _scope.MsgBus.Pub('User.StartSeesionSuccess', (0, _extends3["default"])({}, newUser, { user: (0, _extends3["default"])({}, newUser.user, { phone: phone }) }));
	            }, (0, _extends3["default"])({
	                'Content-Type': 'application/json'
	            }, this._tokenHeader));
	        }
	    }, {
	        key: '_login_by_anonymous',
	        value: function _login_by_anonymous(actHashId) {
	            var _this3 = this;
	
	            // 请求匿名身份
	            var data = (0, _stringify2["default"])({
	                nick: _scope.Utils.GetCookie('user') || '',
	                avatar: _scope.Utils.GetCookie('avatar') || '',
	                session_data: {
	                    screen_resolution: (window.screen.width || 0) + 'x' + (window.screen.height || 0),
	                    language: (navigator.language || '').toLowerCase().substr(0, 2),
	                    from_label: this.tracker.getOrigintype(),
	                    from_value: '',
	                    title: this.name,
	                    page: this.tracker.getPage()
	                }
	            });
	            Fetcher.Post(config.USER_AUTH_ANONYMOUS + '?act_id=' + actHashId, data, function (res) {
	                res = JSON.parse(res);
	                var userObj = {
	                    session_id: res.session_id,
	                    token: res.token,
	                    user: res.user
	                };
	                _this3._updateUserAuth(userObj);
	                _this3._updateUserPhone(userObj);
	            }, {
	                'Content-Type': 'application/json'
	            });
	        }
	    }, {
	        key: '_subEvent',
	        value: function _subEvent() {
	            var _this4 = this;
	
	            var self = this;
	
	            function pickPptUrl(position, urls) {
	                for (var i = 0; i < urls.length; i++) {
	                    var item = urls[i];
	                    var nextItem = urls[i + 1];
	                    if (item.position <= position && (!nextItem || nextItem.position > position)) {
	                        return item.url;
	                    }
	                }
	                return '';
	            }
	
	            //监听事件
	            _scope.MsgBus.Sub('User.Offline', function () {
	                if (_this4.restartingSession) {
	                    return;
	                }
	                // 用户心跳掉线，重新session/start
	                _this4._startSeesion(_this4.actHashId, _this4.projectId);
	                _this4.restartingSession = true;
	            });
	            _scope.MsgBus.Sub('User.WatchTime', function (data) {
	                _this4.WatchTime(data);
	            });
	            _scope.MsgBus.Sub('Player.pptTimer', function (data) {
	                if (!self.trailer || !self.trailer.m3u8) {
	                    return;
	                }
	                var playSourceList = data.getPlayFile();
	                if (playSourceList.filter(function (v) {
	                    return v.file.replace('s://', '://') === self.trailer.m3u8.replace('s://', '://');
	                })[0]) {
	                    var position = data.getPosition();
	                    var url = pickPptUrl(position, self.trailer.ppt_list);
	                    if (url && url !== self.trailer.currentUrl) {
	                        self.trailer.currentUrl = url;
	                        _scope.MsgBus.Pub('PPT.trailer.changed', {
	                            currentUrl: url,
	                            open: self.trailer.open,
	                            player: data.player,
	                            position: position
	                        });
	                    }
	                }
	            });
	            _scope.MsgBus.Sub('Room.TrailerUpdate.Over', function () {
	                var currentStream = _this4.mainStream;
	                // 没有主流标记，且当前频道只有一个流画面，那么就用当前流
	                if (!_this4.mainStream && (0, _keys2["default"])(_this4.mapStreamToTrailerItems).length === 1) {
	                    currentStream = (0, _keys2["default"])(_this4.mapStreamToTrailerItems)[0];
	                }
	                if (!currentStream) {
	                    return;
	                }
	                _this4._getTrailerPPtList(_this4.mapStreamToTrailerItems[currentStream].video_id);
	            });
	
	            // rop消息转发
	            // (function (self) {
	            //     rop.On('stream-event-' + self.stream, function (data) {
	            //         var obj = JSON.parse(data);
	            //         if (obj.stream != self.stream) {
	            //             return;
	            //         }
	            //         self.live_status = obj.event;
	            //         _scope.MsgBus.Pub('Room.StreamEvent', data);
	            //     });
	
	            // })(this);
	        }
	    }, {
	        key: 'Init',
	        value: function Init() {
	            // this._setSocialUser();
	            this.platform = function () {
	                var userAgentInfo = navigator.userAgent;
	                var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
	                var flag = 'pc';
	                for (var v = 0; v < Agents.length; v++) {
	                    if (userAgentInfo.indexOf(Agents[v]) > 0) {
	                        flag = 'mobile';
	                        break;
	                    }
	                }
	                return flag;
	            }();
	
	            this.InitData();
	        }
	    }, {
	        key: 'WatchTime',
	        value: function WatchTime(param) {
	            var time = param.duration || 0;
	            var activeFile = '';
	
	            // 获取当前播放器信息
	            // 判断 当前是直播流 且 已经断流的情况为invalid
	            try {
	                if ('function' === typeof param.getPlayer) {
	                    var player = param.getPlayer();
	                    if (player && 'function' === typeof player.getPlaylist) {
	                        var list = player.getPlaylist();
	                        if (list && list instanceof Array) {
	                            var activeItem = list.filter(function (v) {
	                                return v.active;
	                            })[0];
	                            if (activeItem) {
	                                activeFile = (activeItem.sources || []).filter(function (v) {
	                                    return v.active;
	                                })[0].file || '';
	                                var isInLiveAddress = [].concat((0, _toConsumableArray3["default"])(this.internal), (0, _toConsumableArray3["default"])(this.intranet), (0, _toConsumableArray3["default"])(this.oversea)).map(function (v) {
	                                    return v.address;
	                                }).indexOf(activeFile) !== -1;
	
	                                if (this.live_status === 0 && activeFile && isInLiveAddress) {
	                                    return;
	                                }
	                            }
	                        }
	                    }
	                }
	            } catch (e) {} /** */
	
	            // 防止修改系统时间等方式造成的数据异常
	            if (time < 0) {
	                time = 0;
	            } else if (time > 70) {
	                time = 70;
	            }
	
	            // tracker
	            if (this.tracker && 'function' === typeof this.tracker.triggerEvent) {
	                this.tracker.triggerEvent({
	                    category: 'video',
	                    action: this.live_status ? 'live_watch_time' : 'vod_watch_time',
	                    value: time || 0,
	                    label: activeFile
	                });
	            }
	        }
	    }, {
	        key: 'InitData',
	        value: function InitData() {
	            var _this5 = this;
	
	            var idParam = this.actHashId ? '&act_hash_id=' + this.actHashId : '&id=' + this.act_id;
	            var url = config.BASE_INFO_URL + idParam + '&url=' + encodeURIComponent(location.href.replace(location.hash, ''));
	            try {
	                Fetcher.Get(url, function (data, code) {
	                    if (code != 200) {
	                        _scope.MsgBus.Pub('Room.Init.Over');
	                        _scope.MsgBus.Pub('Room.Init.Error', code);
	                    } else {
	
	                        var jsonObj = JSON.parse(data);
	                        var arrearsStatus = jsonObj.status || ''; // 频道的errCode
	                        var actErrorType = (0, _actErrcode.parseActErrorCode)(arrearsStatus, jsonObj.delayType);
	
	                        // 用户欠费状态
	                        _scope.DB.Set('User.Arrears.Status', {
	                            code: arrearsStatus,
	                            hasLiveErrcode: actErrorType.hasLiveErrcode,
	                            hasTrailerErrcode: actErrorType.hasTrailerErrcode
	                        });
	                        _this5.act_id = jsonObj.act.id;
	                        _this5.server_timestamp = jsonObj.timestamp;
	                        _this5.name = jsonObj.act.name;
	                        _this5.stream = jsonObj.act.stream;
	                        _this5.fee_status = jsonObj.act.fee_status;
	                        _this5.limit_status = jsonObj.act.limit_status;
	                        _this5.live_status = jsonObj.act.live_status;
	                        _this5.share_url = jsonObj.shareUrl;
	                        _this5.view_num = jsonObj.viewNum; // 按照倍率配置计算之后的人数
	                        _this5.lastUpdateViewNumAt = Date.now(); // 最后一次更新人数的时间
	                        _this5.view_num_basic = jsonObj.act.view_num_basic; // 基础人数
	                        _this5.view_num_multiple = jsonObj.act.view_num_multiple; // 倍数
	                        _this5.view_num_type = jsonObj.act.view_num_type; // 0关闭 1累计 2实时
	                        if (_this5.view_num_type > 0) {
	                            setTimeout(function () {
	                                _this5.RefreshViewNum();
	                            }, 60 * 1000);
	                        }
	                        _this5.total_view_num = jsonObj.act.analysis.total_visit_num;
	                        _this5.rtmp_play_addr = jsonObj.rtmp_play_addr;
	                        _this5.isoversea = jsonObj.internal === 0;
	                        _this5.privacy_policy = jsonObj.privacy_policy; // 隐私政策
	                        // console.log('baseInfo', jsonObj);
	                        _this5.has_multi_stream_line = false; // 是否有多个线路或分辨率可提供切换
	                        _this5.isListLiving = false; // 是否频道在使用列表直播
	                        _this5.listLiveAddress = ''; // 列表直播拉流地址
	
	                        // this.trailer = Object.assign(jsonObj.trailer[0] || {m3u8: '', open: 0, trailer_img: ''}, {ppt_list: [], currentUrl: ''});
	                        _this5.trailer = (0, _assign2["default"])(jsonObj.trailer[0] || { draggable: true, triple_speed: true, open: false }, { ppt_list: [], currentUrl: '' });
	                        _this5.trailerList = {};
	
	                        _this5.live_img = jsonObj.live_img || jsonObj.console_setting_image || 'https://static.mudu.tv/assets/livecoverimg.jpg';
	                        _this5.banners = jsonObj.act.banners || [];
	                        _this5.theme = jsonObj.act.theme || 'default';
	                        _this5.themes = jsonObj.act.themes || [];
	                        _this5.uin = jsonObj.act.uin;
	                        // 版本定制内容: 强行使用回放打点，2022.7.25下线
	                        _this5.isCustomForceHighlight = config.customForceBookmarkUin.indexOf(_this5.uin) !== -1;
	                        _this5.countdown = jsonObj.countdown;
	                        _this5.actHashId = jsonObj.actHashId;
	                        _this5.domain = jsonObj.domain ? 'http://' + jsonObj.domain : 'http://mudu.tv';
	                        _this5.projectId = jsonObj.projectId;
	
	                        if (Object.prototype.toString.call(jsonObj.dingdingIsvConfig) === '[object Object]') {
	                            _this5.dingdingIsvConfig = jsonObj.dingdingIsvConfig;
	                        }
	
	                        _scope.DB.Set('socialAuthConfig', {
	                            isSetType: {
	                                issetQq: jsonObj.issetQq,
	                                issetWeibo: jsonObj.issetWeibo,
	                                issetWeixin: jsonObj.issetWeixin
	                            },
	                            oauth2AppIdConfig: jsonObj.oauth2AppIdConfig
	                        });
	                        // baseinfo 完成调用startsession
	                        _this5.tracker.setPage(jsonObj.actHashId);
	                        _scope.MsgBus.Sub('User.AssignLoginByOther', function (data) {
	                            _this5._updateUserAuth({ token: data.token });
	                            _this5._startSeesion(jsonObj.actHashId, jsonObj.projectId);
	                        });
	                        _this5._startSeesion(jsonObj.actHashId, jsonObj.projectId);
	                        _scope.MsgBus.Sub('User.StartSeesionSuccess', function (userInfo) {
	                            _this5.restartingSession = false;
	                            // 监听到StartSeesionSuccess成功以后再去获取其他信息
	                            _this5._fetchMenus();
	                            _this5._setThemeImgUrlAbsolute();
	                            _this5._setLiveImgAbsolute();
	                            _this5._subEvent();
	                            _this5._getVideoTrailerInfo();
	                            _this5._updateListLiveConfig(!!jsonObj.act.list_live_status);
	                            // 初始化im连接(只初始化，不连接)
	                            (0, _im.createIMClient)({ userToken: userInfo.token, actHashId: _this5.actHashId });
	                            // start session 之后更新流水 property
	                            _this5.tracker.updateProperties({
	                                name: userInfo.user.nick,
	                                third_id: userInfo.user.assign_id,
	                                avatar: userInfo.user.avatar,
	                                outer_id: userInfo.user.outer_id
	                            });
	
	                            // 文档
	                            // 如果已经初始化过，unsub topic之后重新初始化
	                            if (_this5.PPT) {
	                                _this5.PPT.UnSubPPTTopics();
	                            }
	                            _scope.MsgBus.Pub('SendObj.PPT', new _scope.PPT({
	                                act_id: jsonObj.act.id,
	                                config: jsonObj.act.slides,
	                                actHashId: jsonObj.actHashId,
	                                tracker: _this5.tracker
	                            }));
	                            // 投票
	                            if (_this5.Vote) {
	                                _this5.Vote.UnSubVoteTopics();
	                            }
	                            _scope.MsgBus.Pub('SendObj.Vote', new _scope.Vote({
	                                act_id: jsonObj.act.id,
	                                vote: jsonObj.vote,
	                                tracker: _this5.tracker
	                            }));
	                            // 问卷
	                            if (_this5.Signup) {
	                                _this5.Signup.UnSubSignTopics();
	                            }
	                            _scope.MsgBus.Pub('SendObj.Signup', new _scope.Signup({
	                                tracker: _this5.tracker,
	                                actHashId: jsonObj.actHashId,
	                                privacyUrl: _this5.privacy_policy
	                            }));
	                            // 签到
	                            if (_this5.Signin) {
	                                _this5.Signin.UnSubSigninTopic();
	                            }
	                            _scope.MsgBus.Pub('SendObj.Signin', new _scope.Signin({
	                                actHashId: jsonObj.actHashId
	                            }));
	                            // 话题互动
	                            if (_this5.Topic) {
	                                _this5.Topic.UnSubTopics();
	                            }
	                            _scope.MsgBus.Pub('SendObj.Topic', new _scope.Topic({
	                                act_id: jsonObj.act.id,
	                                topic_visitor_publish: jsonObj.act.topic_visitor_publish,
	                                topic_needs_check: jsonObj.act.topic_needs_check,
	                                topic_allow_reply: jsonObj.act.topic_allow_reply,
	                                topic_count_num: jsonObj.topicNum,
	                                tracker: _this5.tracker
	                            }));
	                            // 预约
	                            _scope.MsgBus.Pub('SendObj.Appointment', new _scope.Appointment(jsonObj.actHashId));
	                            // 公告
	                            _scope.MsgBus.Pub('SendObj.Notice', new _scope.Notice(jsonObj.actHashId));
	                            // 打赏
	                            if (_this5.Reward) {
	                                _this5.Reward.UnSubRewardTopics();
	                            }
	                            _scope.MsgBus.Pub('SendObj.Reward', new _scope.Reward({ jsonObj: jsonObj, Room: _this5 }));
	                            // 聊天
	                            if (_this5.Comment) {
	                                _this5.Comment.UnSubCommentsTopic();
	                            }
	                            _scope.MsgBus.Pub('SendObj.Comment', new _scope.Comment({ jsonObj: jsonObj, Room: _this5 }));
	                            _this5._getStreamAddress();
	                        });
	                    }
	                });
	            } catch (err) {
	                _scope.MsgBus.Pub('Room.Init.Over');
	                _scope.MsgBus.Pub('Room.Init.Error', err);
	            }
	        }
	
	        // 内：更新列表直播配置
	
	    }, {
	        key: '_updateListLiveConfig',
	        value: function _updateListLiveConfig(isLiving) {
	            var _this6 = this;
	
	            this.isListLiving = isLiving;
	            this.listLiveAddress = '';
	
	            // 开启状态就更新一下列表直播拉流地址
	            if (this.isListLiving) {
	                Fetcher.Get(config.API_DOMAIN + '/activity/v1/watch/' + this.actHashId + '/list_live/addr', function (resp) {
	                    var res = JSON.parse(resp);
	                    if (res.errcode === 1000) {
	                        _this6.listLiveAddress = res.data.address;
	                    }
	
	                    _scope.DB.Set('listLiveConfig', {
	                        isLiving: _this6.isListLiving,
	                        address: _this6.listLiveAddress
	                    });
	                    _scope.MsgBus.Pub('Room.ListLiveConfig', {
	                        inUse: _this6.isListLiving,
	                        address: _this6.listLiveAddress
	                    });
	                }, this._tokenHeader);
	            } else {
	                _scope.DB.Set('listLiveConfig', {
	                    isLiving: this.isListLiving,
	                    address: this.listLiveAddress
	                });
	                _scope.MsgBus.Pub('Room.ListLiveConfig', {
	                    inUse: this.isListLiving,
	                    address: this.listLiveAddress
	                });
	            }
	        }
	    }, {
	        key: '_setThemeImgUrlAbsolute',
	        value: function _setThemeImgUrlAbsolute() {
	            this.themes = this.themes.map(function (v) {
	                v.banner = _scope.Utils.GetAbsoluteUrl({ url: v.banner, domain: 'mudu.tv' });
	                v.cover_img = _scope.Utils.GetAbsoluteUrl({ url: v.cover_img, domain: 'mudu.tv' });
	                return v;
	            });
	        }
	    }, {
	        key: '_setLiveImgAbsolute',
	        value: function _setLiveImgAbsolute() {
	            this.live_img = _scope.Utils.GetAbsoluteUrl({ url: this.live_img, domain: 'mudu.tv' });
	        }
	    }, {
	        key: '_destroy',
	        value: function _destroy() {
	            clearTimeout(this._refreshViewNumTimer);
	            clearInterval(this._userOnlineTimer);
	            this.tracker.destroy();
	        }
	    }, {
	        key: '_getVideoTrailerInfo',
	        value: function _getVideoTrailerInfo() {
	            var _this7 = this;
	
	            var _self = this;
	            if (!this.actHashId) return;
	            var nowTimeStamp = Date.parse(new Date().toString()) / 1000;
	
	            Fetcher.Get(config.API_DOMAIN + '/videos/view/act/' + this.actHashId + '/playback?timestamp=' + nowTimeStamp, function (data) {
	                var res = JSON.parse(data);
	                if (res.errcode !== 1000) {
	                    (0, _assign2["default"])(_self.trailer, {
	                        draggable: true,
	                        stream_name: '',
	                        triple_speed: true,
	                        video_from: 1,
	                        videos: [],
	                        ppt_list: []
	                    });
	                    return;
	                }
	                var playbackList = res.data.playback_list;
	                // 处理多流回放
	                var allTrailerList = playbackList.map(function (playback) {
	                    // 当且仅当设置为单个视频回放，且回放视频存在（自动回放可能存在视频还未生成的情况）时，设置open=true
	                    var isOpen = playback.video_from === 1 && Array.isArray(playback.videos) && playback.videos.length;
	                    var trailerItem = {
	                        triple_speed: playback.triple_speed,
	                        draggable: playback.draggable,
	                        stream_id: playback.stream_name,
	                        open: isOpen,
	                        video_id: isOpen ? playback.videos[0].video_id : '',
	                        trailer_img: isOpen ? playback.videos[0].video_thumb : '',
	                        resolution: isOpen ? playback.videos[0].resolution : '',
	                        ppt_list: [],
	                        bookmarks: [],
	                        m3u8: ''
	                    };
	                    _this7.mapStreamToTrailerItems[playback.stream_name] = trailerItem;
	                    return trailerItem;
	                });
	
	                // 使用第一路回放数据：当单流频道，直接设置默认值
	                _this7.trailer = allTrailerList[0];
	
	                // 有设置回放的直播画面获取回放视频
	                var allOpenedTrailerStream = (0, _keys2["default"])(_this7.mapStreamToTrailerItems).filter(function (stream) {
	                    return _this7.mapStreamToTrailerItems[stream].open;
	                });
	                if (allOpenedTrailerStream.length) {
	                    _promise2["default"].all(allOpenedTrailerStream.map(function (stream) {
	                        var trailerInfo = _this7.mapStreamToTrailerItems[stream];
	                        return _this7._getVideoInfo(trailerInfo.video_id, trailerInfo.resolution);
	                    })).then(function (resArr) {
	                        for (var index in resArr) {
	                            _this7.mapStreamToTrailerItems[allOpenedTrailerStream[index]].m3u8 = resArr[index].url || '';
	                            _this7.mapStreamToTrailerItems[allOpenedTrailerStream[index]].bookmarks = resArr[index].bookmarks;
	                            // 更新默认线路回放
	                            if (_this7.trailer.stream_id === _this7.mapStreamToTrailerItems[allOpenedTrailerStream[index]].stream_id) {
	                                _this7.trailer = _this7.mapStreamToTrailerItems[allOpenedTrailerStream[index]];
	                            }
	                        }
	                        // 定制逻辑，强制使用回放视频的打点信息
	                        if (_this7.isCustomForceHighlight) {
	                            _scope.DB.Set('CUSTOM_FORCE_HIGHLIGHT', _this7.trailer.bookmarks || []);
	                        }
	
	                        _scope.DB.Set('trailerInfo', _this7.trailer); // 将回看信息保存在DB中
	
	                        _scope.MsgBus.Pub('Room.TrailerUpdate.Over');
	                    })["catch"](function () {
	                        _this7.trailer.open = false;
	                        _scope.MsgBus.Pub('Room.TrailerUpdate.Over');
	                    });
	                    return;
	                }
	
	                _scope.MsgBus.Pub('Room.TrailerUpdate.Over');
	            }, (0, _extends3["default"])({}, this._tokenHeader, {
	                sign: md5(this._tokenHeader.authorization.split(' ')[1] + nowTimeStamp)
	            }));
	        }
	    }, {
	        key: '_getVideoInfo',
	        value: function _getVideoInfo(video_id, resolution) {
	            var _this8 = this;
	
	            return new _promise2["default"](function (resolve, reject) {
	                if (!video_id) {
	                    return;
	                }
	                var nowTimeStamp = Date.parse(new Date().toString()) / 1000;
	                return Fetcher.Get(config.API_DOMAIN + '/videos/view/act/' + _this8.actHashId + '/video?video_id=' + video_id + '&timestamp=' + nowTimeStamp + '&resolution=' + (resolution || ''), function (data) {
	                    var res = JSON.parse(data);
	                    if (res.errcode === 1000) {
	                        // return res.data;
	                        resolve(res.data);
	                    } else {
	                        reject('error');
	                    }
	                }, (0, _extends3["default"])({
	                    sign: md5(_this8._tokenHeader.authorization.split(' ')[1] + nowTimeStamp)
	                }, _this8._tokenHeader));
	            });
	        }
	    }, {
	        key: '_getTrailerPPtList',
	        value: function _getTrailerPPtList(video_id) {
	            var self = this;
	            if (!video_id) return;
	
	            Fetcher.Get(config.API_DOMAIN + '/?c=activity&a=ajaxgetvideoslides&video_id=' + video_id, function (data) {
	                var res = JSON.parse(data);
	                if (res.status === 'n') {
	                    return;
	                }
	                if (res.status === 'y') {
	                    self.trailer.ppt_list = res.data || [];
	                }
	            }, this._tokenHeader);
	        }
	
	        /**
	         * 内部：解析直播流地址
	         */
	
	    }, {
	        key: '_getStreamAddress',
	        value: function _getStreamAddress() {
	            var _this9 = this;
	
	            var url = config.API_DOMAIN + '/activity/v2/' + this.actHashId + '/videos';
	
	            Fetcher.Get(url, function (data, code) {
	                try {
	                    data = JSON.parse(data);
	                    if (code !== 200) {
	                        throw new Error(code);
	                    }
	
	                    if (data.errcode !== 1000) {
	                        throw new Error(data.errcode);
	                    }
	                    var streamViews = data.data || []; //所有流
	
	
	                    _this9.allStreams = streamViews.map(function (stream) {
	                        var playlistItem = _this9._formatPlaylistItem(stream);
	                        _this9.mapStreamToPlaylistItem[stream.stream] = playlistItem;
	                        return {
	                            stream_id: stream.stream,
	                            name: stream.name,
	                            live_status: !!stream.live_status,
	                            is_main: !!stream.is_main
	                        };
	                    });
	
	                    // const currentStreamView = streamViews.filter(v => v.is_main === 1)[0]; // 主流
	
	
	                    _scope.DB.Set('liveAddrList', [_this9.mapStreamToPlaylistItem[_this9.mainStream]]); // 将流地址保存在DB中
	                    _scope.DB.Set('mainStream', _this9.mainStream);
	                    _scope.DB.Set('mapStreamToPlaylistItem', _this9.mapStreamToPlaylistItem);
	
	                    _scope.MsgBus.Pub('Room.StreamUpdate.Over');
	
	                    _this9._subAllStreamStatus();
	                    _this9._subListLiveStatus();
	                } catch (err) {
	                    _scope.MsgBus.Pub('Room.Init.Over');
	                    _scope.MsgBus.Pub('Room.Init.Error', err);
	                }
	            }, this._tokenHeader);
	        }
	
	        // 监听每一条线路的live status变更
	
	    }, {
	        key: '_subAllStreamStatus',
	        value: function _subAllStreamStatus() {
	            var _this10 = this;
	
	            this.allStreams.forEach(function (stream, index) {
	                rop.On('stream-event-' + stream.stream_id, function (data) {
	                    var obj = JSON.parse(data);
	                    // 主流状态更新到频道直播状态
	                    if (obj.stream === _this10.mainStream) {
	                        _this10.live_status = obj.event;
	                    }
	                    // 更新此路流的状态
	                    _this10.allStreams[index].live_status = !!obj.event;
	                    _scope.MsgBus.Pub('Room.StreamEvent', data);
	                });
	            });
	        }
	
	        // 监听列表直播开关状态
	
	    }, {
	        key: '_subListLiveStatus',
	        value: function _subListLiveStatus() {
	            var _this11 = this;
	
	            // 列表直播开启同时会收到stream-event消息，不需要额外提醒用户开始直播
	            rop.On('list-live-' + this.actHashId, function (msg) {
	                try {
	                    var data = JSON.parse(msg);
	                    _this11._updateListLiveConfig(!!data.status);
	                } catch (error) {
	                    console.error(error);
	                }
	            });
	        }
	
	        // 转成播放器要的playlist格式
	
	    }, {
	        key: '_formatPlaylistItem',
	        value: function _formatPlaylistItem(streamItem) {
	            var liveItem = {};
	            switch (streamItem.customized_address) {
	                case CustomizedAddressType.INTRANET_ONLY:
	                    // 仅内网，用内网地址
	                    liveItem = streamItem.intranet;
	                    break;
	                case CustomizedAddressType.OVERSEA_ONLY:
	                    // 仅海外，用海外地址
	                    liveItem = streamItem.oversea;
	                    break;
	                case CustomizedAddressType.AUTO_SWITCH_BY_IP:
	                    // 根据IP切换，内网地址有用内网，否则海外地址有用海外
	                    if (streamItem.intranet.sign_list.length > 0) {
	                        liveItem = streamItem.intranet;
	                    } else if (!!this.isoversea && streamItem.oversea.sign_list.length > 0) {
	                        liveItem = streamItem.oversea;
	                    } else {
	                        liveItem = streamItem.internal;
	                    }
	                    break;
	                case CustomizedAddressType.NULL: // 仅公网（默认）
	                default:
	                    liveItem = streamItem.internal;
	            }
	
	            var sources = [];
	            var firstUsefulPlayAddr = ''; // 记录第一路可用线路（非空）
	            liveItem.sign_list.forEach(function (signList, signIndex) {
	                signList.resolutions.forEach(function (v, idx) {
	                    var path = signList.line_name || '';
	                    var label = v.resolution || '';
	                    switch (v.resolution) {
	                        case 'origin':
	                            label = '原画';
	                            break;
	                        case 'fhd':
	                            label = '1080P';
	                            break;
	                        case 'hd':
	                            label = '720P';
	                            break;
	                        case 'sd':
	                            label = '480P';
	                            break;
	                        default:
	                    }
	                    sources.push({
	                        file: v.pull_address,
	                        label: label,
	                        path: path,
	                        path_name: path,
	                        defaultPlay: signIndex === 0 && idx === 0
	                    });
	                    if (v.pull_address && !firstUsefulPlayAddr) {
	                        firstUsefulPlayAddr = v.pull_address;
	                    }
	                });
	            });
	
	            // 记录主线路
	            if (streamItem.is_main) {
	                this.mainStream = streamItem.stream;
	                this.hls_play_addr = firstUsefulPlayAddr;
	                this.originMainStream = liveItem;
	                this.has_multi_stream_line = sources.length > 1;
	                this.live_status = streamItem.live_status;
	            }
	
	            return {
	                isLive: true,
	                image: this.live_img,
	                is_main: !!streamItem.is_main,
	                title: streamItem.name,
	                sources: sources
	            };
	        }
	
	        // type是1，刷新累计观看人数
	
	    }, {
	        key: '_refreshChannelPV',
	        value: function _refreshChannelPV() {
	            var _this12 = this;
	
	            var pvUrl = config.API_DOMAIN + '/analytics/api/activity/upv?page=/activity/' + this.actHashId + '&time=' + Date.now();
	            return new _promise2["default"](function (resolve, reject) {
	                _this12.lastUpdateViewNumAt = Date.now();
	                Fetcher.Get(pvUrl, function (resp) {
	                    var res = JSON.parse(resp);
	                    if (res.errcode == 1000) {
	                        // 计算显示人数 type 0/1/2 0表示不显示，1显示累计人数，2显示真实人数
	                        var multiple = _this12.view_num_multiple <= 0 ? 1 : _this12.view_num_multiple;
	                        _this12.view_num = _this12.view_num_basic + res.pv * multiple;
	                        _scope.MsgBus.Pub('Room.ViewNumChanged', _this12.view_num);
	
	                        resolve({ view_num: _this12.view_num });
	                    } else {
	                        reject(res);
	                    }
	                }, _this12._tokenHeader);
	            });
	        }
	
	        // type是2，刷新在线人数
	
	    }, {
	        key: '_refreshChannelUV',
	        value: function _refreshChannelUV() {
	            var _this13 = this;
	
	            var uvUrl = config.API_DOMAIN + '/datareport/api/concurrent?project_id=' + this.projectId + '&act_id=' + this.actHashId + '&time=' + Date.now();
	            this.lastUpdateViewNumAt = Date.now();
	            return new _promise2["default"](function (resolve, reject) {
	                Fetcher.Get(uvUrl, function (resp) {
	                    var res = JSON.parse(resp);
	                    if (res.errcode == 1000) {
	                        // 计算显示人数 type 0/1/2 0表示不显示，1显示累计人数，2显示真实人数
	                        var multiple = _this13.view_num_multiple <= 0 ? 1 : _this13.view_num_multiple;
	                        _this13.view_num = _this13.view_num_basic + res.count * multiple;
	                        _scope.MsgBus.Pub('Room.ViewNumChanged', _this13.view_num);
	
	                        resolve({ view_num: _this13.view_num });
	                    } else {
	                        reject(res);
	                    }
	                }, _this13._tokenHeader);
	            });
	        }
	
	        // -------内部接口结束---------
	
	
	        // （多流）获取流地址列表
	
	    }, {
	        key: 'GetStreamList',
	        value: function GetStreamList() {
	            return this.allStreams;
	        }
	
	        //获取浏览量
	
	    }, {
	        key: 'RefreshViewNum',
	        value: function RefreshViewNum() {
	            var _this14 = this;
	
	            // 5s之内不更新
	            if (Date.now() - this.lastUpdateViewNumAt < 5 * 1000) {
	                return _promise2["default"].resolve({ view_num: this.view_num });
	            }
	
	            clearTimeout(this._refreshViewNumTimer);
	            // 保持持续更新
	            if (this.view_num_type > 0) {
	                this._refreshViewNumTimer = setTimeout(function () {
	                    _this14.RefreshViewNum();
	                }, 60 * 1000);
	            }
	
	            // 从接口刷新
	            switch (this.view_num_type) {
	                // type === 1，刷新累计观看人数
	                case 1:
	                    return this._refreshChannelPV();
	                // type === 2，刷新在线人数
	                case 2:
	                    return this._refreshChannelUV();
	                case 0:
	                    return _promise2["default"].resolve({ view_num: 0 });
	                default:
	                    return _promise2["default"].resolve({ view_num: this.view_num });
	            }
	        }
	
	        // 获取页面浏览量
	
	    }, {
	        key: 'GetViewNum',
	        value: function GetViewNum() {
	            // 超过30s，即时返回当前数据并触发一次更新
	            if (Date.now() - this.lastUpdateViewNumAt >= 30 * 1000) {
	                this.RefreshViewNum();
	            }
	            return this.view_num;
	        }
	    }, {
	        key: 'GetName',
	        value: function GetName() {
	            return this.name;
	        }
	    }, {
	        key: 'GetStream',
	        value: function GetStream() {
	            return this.stream;
	        }
	    }, {
	        key: 'GetShareUrl',
	        value: function GetShareUrl() {
	            return this.share_url;
	        }
	    }, {
	        key: 'GetLiveImage',
	        value: function GetLiveImage() {
	            return this.live_img;
	        }
	    }, {
	        key: 'GetId',
	        value: function GetId() {
	            return this.act_id;
	        }
	    }, {
	        key: 'GetLiveStatus',
	        value: function GetLiveStatus() {
	            return this.live_status;
	        }
	    }, {
	        key: 'GetMenus',
	        value: function GetMenus() {
	            return this.menus;
	        }
	    }, {
	        key: '_fetchMenuVideo',
	        value: function _fetchMenuVideo(id, menus) {
	            var _self = this;
	            var getVideoUrl = config.API_DOMAIN_V2 + '/v2/micro-act/view/menu/videos?act_id=' + this.actHashId + '&menu_id=' + id;
	            Fetcher.Get(getVideoUrl, function (res) {
	                res = JSON.parse(res);
	                if (res.errcode === 1000) {
	                    _self.menus = menus.map(function (item) {
	                        if (item.menu_id == id) {
	                            var newVideos = res.data ? res.data.videos : [];
	                            // 为video列表添加vid字段(api中不暴露)
	                            // newVideos.map(v => { v.vid = v.video_id;});
	                            item.videos = newVideos;
	                        }
	                        return item;
	                    });
	                }
	            }, (0, _extends3["default"])({ 'Content-Type': 'application/json' }, _self._sessionHeader, self._tokenHeader));
	        }
	    }, {
	        key: '_fetchMenus',
	        value: function _fetchMenus() {
	            var _self = this;
	            // 获取自定义菜单
	            var getMenuUrl = config.API_DOMAIN_V2 + '/v2/micro-act/view/menus?act_id=' + this.actHashId;
	            Fetcher.Get(getMenuUrl, function (res) {
	                res = JSON.parse(res);
	                if (res.errcode === 1000) {
	                    _self.menus = res.menus;
	                    res.menus && res.menus.map(function (item) {
	                        if (item.type == 3) {
	                            _self._fetchMenuVideo(item.menu_id, res.menus);
	                        }
	                    });
	                } else {
	                    _self.menus = [];
	                }
	            }, (0, _extends3["default"])({ 'Content-Type': 'application/json' }, _self._sessionHeader, self._tokenHeader));
	        }
	
	        // 广告栏
	
	    }, {
	        key: 'GetBanners',
	        value: function GetBanners() {
	            return this.banners;
	        }
	
	        // 获取当前使用的主题
	
	    }, {
	        key: 'GetActiveTheme',
	        value: function GetActiveTheme() {
	            return this.theme;
	        }
	
	        // 获取主题配置数组
	
	    }, {
	        key: 'GetThemes',
	        value: function GetThemes() {
	            return this.themes;
	        }
	
	        // 获取倒计时
	
	    }, {
	        key: 'GetCountdown',
	        value: function GetCountdown() {
	            if (!this.countdown) {
	                return {
	                    server_timestamp: this.server_timestamp
	                };
	            } else {
	
	                return (0, _extends3["default"])({}, this.countdown, { server_timestamp: this.server_timestamp });
	            }
	        }
	
	        // 返回列表直播当前配置
	
	    }, {
	        key: 'GetListLiveConfig',
	        value: function GetListLiveConfig() {
	            return {
	                inUse: this.isListLiving,
	                address: this.listLiveAddress
	            };
	        }
	
	        /**
	         * ———————————— 👇预备废弃接口 ————————————
	         * 废弃接口需要通知客户更改，暂保持原有返回值，之后根据产品协商预备下线
	         */
	
	        /**
	         * 获取直播流地址（主流）
	         */
	
	    }, {
	        key: 'GetPlayAddr',
	        value: function GetPlayAddr() {
	            // TODO: 后期隐藏返回值
	            // eslint-disable-next-line no-console
	            // console.warn('GetPlayAddr()接口已废弃，不再返回流地址。如需播放直播流直接在player参数中指定isLive为true即可。');
	            return this.hls_play_addr;
	        }
	
	        /**
	         * 获取流地址
	         * @param {string} streamType 流类型
	         */
	
	    }, {
	        key: 'GetPlayAddrList',
	        value: function GetPlayAddrList(stream_id) {
	            // TODO: 后期隐藏返回值
	            // eslint-disable-next-line no-console
	            // console.warn('GetPlayAddrList()接口已废弃，不再返回流地址。如需播放直播流直接在player参数中指定isLive为true即可。');
	            if (stream_id) {
	                var playlistItem = this.mapStreamToPlaylistItem[stream_id];
	                if (playlistItem) {
	                    return [playlistItem];
	                }
	            }
	            return [this.mapStreamToPlaylistItem[this.mainStream]];
	        }
	
	        /**
	         * 是否有多线路多分辨率
	         */
	
	    }, {
	        key: 'HasMultiStreamLine',
	        value: function HasMultiStreamLine() {
	            // TODO: 后期隐藏返回值
	            // eslint-disable-next-line no-console
	            // console.warn('HasMultiStreamLine()接口已废弃，始终返回false。如已指定播放器参数isLive为true，sdk将在加载Player时自动适配加载多分辨率线路配置。');
	            return this.has_multi_stream_line;
	        }
	
	        /**
	         * 获取直播间playlist(默认返回主流，有流id返回对应item)，直接用于播放器
	         */
	
	    }, {
	        key: 'GetPlayList',
	        value: function GetPlayList() {
	            // TODO: 后期隐藏返回值
	            // eslint-disable-next-line no-console
	            // console.warn('GetPlayList()接口已废弃，不再返回各个线路地址。isLive配置为true的情况下，sdk会根据后台配置自动适配选择合适的线路播放。');
	            return this.originMainStream;
	        }
	
	        /**
	         * 获取海外播放地址
	         */
	
	    }, {
	        key: 'GetOverseaPlayList',
	        value: function GetOverseaPlayList() {
	            // 海外线路选择已在解析时处理，此处直接返回最终直播地址
	            // TODO: 后期隐藏返回值
	            // eslint-disable-next-line no-console
	            // console.warn('GetOverseaPlayList()接口已废弃，不再返回海外线路地址。isLive配置为true的情况下，sdk会根据后台配置自动适配选择合适的线路播放。');
	            return [this.mapStreamToPlaylistItem[this.mainStream]];
	        }
	
	        /**
	         * 获取回放视频配置
	         * 仅对单个回放视频生效，默认返回主流线路
	         */
	
	    }, {
	        key: 'GetTrailer',
	        value: function GetTrailer(stream_id) {
	            // TODO: 后期隐藏返回值
	            // eslint-disable-next-line no-console
	            // console.warn('GetTrailer()接口已废弃，不再返回点播视频地址。如需播放点播直接在player参数中指定isLive为false，同时src传空值（null|undefined|\'\',或不传）即可。');
	            var trailerInfo = this.trailer || {};
	            var checkedStreamId = stream_id || this.mainStream;
	
	            // 如果传入值和mainStream都没有，不再重新赋值
	            if (checkedStreamId) {
	                trailerInfo = this.mapStreamToTrailerItems[checkedStreamId] || this.mapStreamToTrailerItems[this.mainStream] || {};
	            }
	
	            return (0, _extends3["default"])({}, trailerInfo, {
	                m3u8: trailerInfo.m3u8 || '',
	                open: !!trailerInfo.open,
	                trailer_img: trailerInfo.trailer_img || '',
	                draggable: trailerInfo.draggable || false,
	                triple_speed: trailerInfo.triple_speed || false,
	                resolution: trailerInfo.resolution || ''
	            });
	        }
	
	        // 获取单个视频信息
	
	    }, {
	        key: 'GetVideoInfo',
	        value: function GetVideoInfo(video_id) {
	            // TODO: 后期隐藏返回值
	            // eslint-disable-next-line no-console
	            // console.warn('GetVideoInfo()接口即将被废弃，下个版本迭代中将不再返回此video_id下的视频信息。如需播放直接在player参数中指定isLive为false，并传入video_id即可');
	            return this._getVideoInfo(video_id);
	        }
	
	        /**
	         * 获取直播间地址列表 暂时未使用
	         */
	
	    }, {
	        key: 'GetRoomAddrList',
	        value: function GetRoomAddrList() {
	            return {};
	        }
	    }]);
	    return Room;
	}();


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(131);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(132), __esModule: true };

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(75);
	__webpack_require__(133);
	module.exports = __webpack_require__(42).Array.from;


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(43);
	var $export = __webpack_require__(40);
	var toObject = __webpack_require__(74);
	var call = __webpack_require__(89);
	var isArrayIter = __webpack_require__(90);
	var toLength = __webpack_require__(63);
	var createProperty = __webpack_require__(134);
	var getIterFn = __webpack_require__(82);
	
	$export($export.S + $export.F * !__webpack_require__(100)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(46);
	var createDesc = __webpack_require__(54);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(136), __esModule: true };

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(137);
	module.exports = __webpack_require__(42).Object.keys;


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(74);
	var $keys = __webpack_require__(60);
	
	__webpack_require__(138)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(40);
	var core = __webpack_require__(42);
	var fails = __webpack_require__(51);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(140), __esModule: true };

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(42);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	module.exports = ("1.26.8");


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createIMClient = createIMClient;
	
	var _imMessager = __webpack_require__(143);
	
	var _imMessager2 = _interopRequireDefault(_imMessager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function createIMClient(_ref) {
	  var userToken = _ref.userToken,
	      actHashId = _ref.actHashId;
	
	  var imClientParam = {
	    host: window.IM_SERVER,
	    accessToken: 'Token=' + userToken,
	    roomId: actHashId,
	    connectType: 'auth_go_im',
	    maxReconnectTimes: 20,
	    reconnectDelay: 5 * 1000,
	    heartbeatInterval: 30 * 1000,
	    connectWhenManual: true
	  };
	
	  if (window.imClient && window.imClient && typeof window.imClient.close === 'function') {
	    try {
	      imClient.close();
	    } catch (error) {
	      // close error
	    }
	  }
	  window.imClient = new _imMessager2["default"](imClientParam);
	
	  // 监听im连接自身状态事件
	  this.imClient.onClient('ready', function () {
	    return console.log('im client: ready');
	  });
	  this.imClient.onClient('connect', function () {
	    return console.log('im client: connect');
	  });
	  this.imClient.onClient('error', function (err) {
	    return console.error('im client error:', err);
	  });
	  this.imClient.onClient('close', function (close) {
	    return console.warn('im client close:', close);
	  });
	}


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	// MDL IM SDK  v.1.1.7  Copyright ©️ mudu.com
	!function(t,e){ true?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e((t="undefined"!=typeof globalThis?globalThis:t||self).MDIMClient={})}(this,function(h){"use strict";var e=function(){return(e=Object.assign||function(t){for(var e,n=1,s=arguments.length;n<s;n++)for(var o in e=arguments[n])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};h.ClientEvent=void 0,(i=h.ClientEvent||(h.ClientEvent={})).connect="connect",i.ready="ready",i.error="error",i.heartbeat="heartbeat",i.close="close",i.reconnecting="reconnecting",h.Status=void 0,(i=h.Status||(h.Status={})).UNREADY="UNREADY",i.READY="READY",i.CLOSED="CLOSED",h.ConnectType=void 0,(i=h.ConnectType||(h.ConnectType={})).NATS="nats",i.GO_IM="go_im",i.AUTH_GO_IM="auth_go_im";var o,u=16,n=(t.prototype.validateConfig=function(){return this.config.host?this.config.roomId?!(!this.config.accessToken&&this.config.connectType===h.ConnectType.AUTH_GO_IM&&(console.error("MDIMCLient error: Param 'accessToken' is missing"),1)):(console.error("MDIMCLient error: Param 'roomId' is missing"),!1):(console.error("MDIMCLient error: Param 'host' is missing"),!1)},t.prototype.connect=function(){try{this.socket=new WebSocket(this.config.host),this.socket.binaryType="arraybuffer"}catch(t){console.error("MDIMCLient error:",t)}this.socket.onopen=this.onOpen.bind(this),this.socket.onmessage=this.onMessage.bind(this),this.socket.onclose=this.onClose.bind(this),this.socket.onerror=this.onError.bind(this)},t.prototype.onOpen=function(t){this.pubClientEvent(h.ClientEvent.connect,t),this.auth()},t.prototype.onClose=function(t){var e=this;this.destroyed||(this.pubClientEvent(h.ClientEvent.close,t),clearTimeout(this.hearbeatTimer),(0<this.lastReconnectTimes||-1===this.config.maxReconnectTimes)&&(this.reconnectTimer=window.setTimeout(function(){e.pubClientEvent(h.ClientEvent.reconnecting),e.connect(),e.lastReconnectTimes--},this.config.reconnectDelay)))},t.prototype.onError=function(t){this.pubClientEvent(h.ClientEvent.error,t),this.socket.close()},t.prototype.auth=function(){var t={access_token:this.config.accessToken,room_id:this.config.roomId,events:[],platform:this.config.platform,name:this.config.name||"",avatar:this.config.avatar||"",extra:this.config.extra||""},e=new ArrayBuffer(u),n=new DataView(e,0),t=this.textEncoder.encode(JSON.stringify(t));n.setInt32(0,u+t.byteLength),n.setInt16(4,u),n.setInt16(6,1),n.setInt32(8,7),n.setInt32(12,1),this.socket.send(this.mergeArrayBuffer(e,t))},t.prototype.onMessage=function(t){var e,n=this,s=t.data,o=new DataView(s,0);o.getInt32(0),o.getInt16(4),o.getInt16(6);t=o.getInt32(8);switch(o.getInt32(12),t){case 8:this.status=h.Status.READY,this.startHeartBeat(),this.sidMap.forEach(function(t,e){n.subscribe(e,t)}),this.pubClientEvent(h.ClientEvent.ready),this.lastReconnectTimes=this.config.maxReconnectTimes;break;case 3:this.pubClientEvent(h.ClientEvent.heartbeat);break;case 9:for(var i=u;i<s.byteLength;){var c=o.getInt32(i),r=o.getInt16(i+4),r=(o.getInt16(i+6),o.getInt32(i+8),o.getInt32(i+12),this.textDecoder.decode(s.slice(i+r,i+c)));try{var a=null===(e=JSON.parse(r))||void 0===e?void 0:e.event;Date.now(),this.pubEvent(a,r)}catch(t){console.error("parse message error:",r)}i+=c}}},t.prototype.pubEvent=function(t,e){Object.values(this.eventSubs.get(t)||{}).forEach(function(t){"function"==typeof t&&t(e)})},t.prototype.startHeartBeat=function(){var t=this;this.status!==h.Status.CLOSED&&(this.heartBeat(),this.hearbeatTimer=window.setTimeout(function(){t.startHeartBeat()},this.config.heartbeatInterval))},t.prototype.heartBeat=function(){var t=new ArrayBuffer(u),e=new DataView(t,0);e.setInt32(0,u),e.setInt16(4,u),e.setInt16(6,1),e.setInt32(8,2),e.setInt32(12,1),this.socket.send(t)},t.prototype.subscribe=function(t,e){var n;this.sidMap.has(t)||this.sidMap.set(t,e),this.status===h.Status.READY&&(n=JSON.stringify({access_token:this.config.accessToken,room_id:this.config.roomId,events:[t]}),e=new ArrayBuffer(u),t=new DataView(e,0),n=this.textEncoder.encode(n),t.setInt32(0,u+n.byteLength),t.setInt16(4,u),t.setInt16(6,1),t.setInt32(8,18),t.setInt32(12,1),this.socket.send(this.mergeArrayBuffer(e,n)))},t.prototype.unsubEvent=function(t,e){delete this.eventSubs.get(t)[e],null!==(e=Object.keys(this.eventSubs.get(t)))&&void 0!==e&&e.length||(this.sidMap.get(t),this.sidMap.delete(t))},t.prototype.mergeArrayBuffer=function(t,e){var n=new Uint8Array(t),s=new Uint8Array(e),e=new Uint8Array(t.byteLength+e.byteLength);return e.set(n,0),e.set(s,t.byteLength),e.buffer},t.prototype.pubClientEvent=function(t,e){Object.values(this.clientEventSubs.get(t)||{}).forEach(function(t){"function"==typeof t&&t(e)})},t.prototype.manualConnect=function(){this.config.connectWhenManual&&!this.socket&&this.connect()},t.prototype.on=function(t,e){var n,s=this,o=this.nextSubId++;return this.eventSubs.has(t)?this.eventSubs.get(t)[o]=e:(this.eventSubs.set(t,((n={})[o]=e,n)),this.subscribe(t,o)),function(){s.unsubEvent(t,o)}},t.prototype.onClient=function(t,e){var n=String(Date.now());this.clientEventSubs.has(t)?this.clientEventSubs.get(t)[n]=e:this.clientEventSubs.set(t,((t={})[n]=e,t))},t.prototype.removeEvent=function(t){this.eventSubs.has(t)&&this.eventSubs.delete(t)},t.prototype.close=function(){this.destroyed=!0,clearTimeout(this.reconnectTimer),clearTimeout(this.hearbeatTimer),this.socket.close()},t.prototype.getStatus=function(){return this.socket.CLOSED?h.Status.CLOSED:this.status},t);function t(t){this.nextSubId=1,this.clientEventSubs=new Map,this.eventSubs=new Map,this.sidMap=new Map,this.textEncoder=new TextEncoder,this.textDecoder=new TextDecoder,this.destroyed=!1,this.config={host:t.host,accessToken:t.accessToken,roomId:t.roomId,maxReconnectTimes:+t.maxReconnectTimes||10,platform:t.platform||"pc",reconnectDelay:+t.reconnectDelay||2e3,heartbeatInterval:+t.heartbeatInterval||3e4,extra:t.extra||"",connectWhenManual:!!t.connectWhenManual,connectType:t.connectType||h.ConnectType.GO_IM},this.lastReconnectTimes=this.config.maxReconnectTimes,this.validateConfig()&&!this.config.connectWhenManual&&this.connect()}(i=o=o||{}).PING="PING",i.CONNECT="CONNECT",i.SUB="SUB",i.PONG="PONG",i.MSG="MSG",i.ERR="-ERR",i.INFO="INFO",i.UNSUB="UNSUB",i.UNKNOWN="unknown";var s=(r.prototype.validateConfig=function(){return!!this.config.host||(console.error("MDIMCLient error: Param 'host' is missing"),!1)},r.prototype.connect=function(){try{this.socket=new WebSocket(this.config.host),this.socket.binaryType="blob"}catch(t){console.error("MDIMCLient error:",t)}this.socket.onopen=this.onOpen.bind(this),this.socket.onmessage=this.onMessage.bind(this),this.socket.onclose=this.onClose.bind(this),this.socket.onerror=this.onError.bind(this)},r.prototype.onOpen=function(t){var e=this;this.pubClientEvent(h.ClientEvent.connect,t),this.socket.send("CONNECT ".concat(JSON.stringify({lang:"node",version:"0.6.8",verbose:!1,pedantic:!1})," \r\n")),setTimeout(function(){e.startHeartBeat()},200)},r.prototype.onClose=function(t){this.destroyed||(this.pubClientEvent(h.ClientEvent.close,t),this.status=h.Status.CLOSED,this.reconnect())},r.prototype.onError=function(t){this.pubClientEvent(h.ClientEvent.error,t);try{this.reconnect(),this.socket.close()}catch(t){this.status=h.Status.CLOSED}},r.prototype.reconnect=function(){var t=this;clearTimeout(this.heartbeatTimer),this.reconnectTimer||(0<this.lastReconnectTimes||-1===this.config.maxReconnectTimes)&&(this.reconnectTimer=window.setTimeout(function(){t.reconnectTimer=0,t.pubClientEvent(h.ClientEvent.reconnecting),t.status=h.Status.UNREADY,t.connect(),t.lastReconnectTimes--},this.config.reconnectDelay))},r.prototype.onMessage=function(t){t.data;var e=this.parseMessage(t),t=e.eventType,n=e.eventName,s=e.msg;switch(t){case o.PONG:clearTimeout(this.heartbearTimeoutTimer),this.pubClientEvent(h.ClientEvent.heartbeat),this.status!==h.Status.READY&&(this.status=h.Status.READY,this.pubClientEvent(h.ClientEvent.ready),this.batchSub(this.sidMap));break;case o.MSG:this.pubEvent(n,s)}},r.prototype.parseMessage=function(t){var e=t.data.split(" "),n=Object.values(o).find(function(t){return t===e[0].replace(/\r\n/g,"")})||o.UNKNOWN,t=t.data.replace(/^.*\r\n/g,"").trim();return{eventType:n,eventName:(null==e?void 0:e[1])||"",msg:t}},r.prototype.startHeartBeat=function(){var t=this;this.status!==h.Status.CLOSED&&(this.heartBeat(),this.heartbeatTimer=window.setTimeout(function(){t.startHeartBeat()},this.config.heartbeatInterval))},r.prototype.heartBeat=function(){var t=this;try{this.socket.send("PING\r\n")}catch(t){}this.heartbearTimeoutTimer=window.setTimeout(function(){t.socket.close(),t.status=h.Status.CLOSED,t.reconnect()},this.heartbeatTimeout)},r.prototype.subscribe=function(t,e){this.sidMap.set(t,e),this.status===h.Status.READY&&this.socket.send("".concat(o.SUB," ").concat(t," ").concat(e," \r\n"))},r.prototype.batchSub=function(t){var n=this,s="";t.forEach(function(t,e){n.sidMap.set(e,t),n.status===h.Status.READY&&(s+="".concat(o.SUB," ").concat(e," ").concat(t," \r\n"))}),this.status===h.Status.READY&&this.socket.send(s)},r.prototype.pubClientEvent=function(t,e){Object.values(this.clientEventSubs.get(t)||{}).forEach(function(t){"function"==typeof t&&t(e)})},r.prototype.pubEvent=function(t,e){Object.values(this.eventSubs.get(t)||{}).forEach(function(t){"function"==typeof t&&t(e)})},r.prototype.unsubEvent=function(t,e){"number"==typeof e&&delete this.eventSubs.get(t)[e],"boolean"==typeof e&&e&&this.eventSubs.delete(t),null!==(e=Object.keys(this.eventSubs.get(t)))&&void 0!==e&&e.length||(e=this.sidMap.get(t),this.socket.send("".concat(o.UNSUB," ").concat(e,"\r\n")),this.sidMap.delete(t),this.eventSubs.delete(t))},r.prototype.manualConnect=function(){this.config.connectWhenManual&&!this.socket&&this.connect()},r.prototype.on=function(t,e){var n,s=this,o=this.nextSubId++;return this.eventSubs.has(t)?this.eventSubs.get(t)[o]=e:(this.eventSubs.set(t,((n={})[o]=e,n)),this.subscribe(t,o)),/\.$|\.\./.test(t)&&console.warn("不合法的订阅topic，可能会引起socket连接异常close(1006):",t),function(){s.unsubEvent(t,o)}},r.prototype.onClient=function(t,e){var n=String(Date.now());this.clientEventSubs.has(t)?this.clientEventSubs.get(t)[n]=e:this.clientEventSubs.set(t,((t={})[n]=e,t))},r.prototype.removeEvent=function(t){this.unsubEvent(t,!0)},r.prototype.close=function(){this.destroyed=!0,clearTimeout(this.reconnectTimer),clearTimeout(this.heartbeatTimer),this.socket.close()},r.prototype.getStatus=function(){return this.socket.CLOSED?h.Status.CLOSED:this.status},r),i=(c.prototype.initClient=function(t){if(!t||!t.host)throw"MDIMCLient error: Param 'host' is missing!";switch(t.connectType){case h.ConnectType.AUTH_GO_IM:case h.ConnectType.GO_IM:this.client=new n(t);break;case h.ConnectType.NATS:this.client=new s(t);break;default:this.client=new s(e(e({},t),{connectType:h.ConnectType.NATS}))}},c.prototype.manualConnect=function(){this.client.manualConnect()},c.prototype.onClient=function(t,e){this.client.onClient(t,e)},c.prototype.on=function(t,e){return this.client.on(t,e)},c.prototype.removeEvent=function(t){this.client.removeEvent(t)},c.prototype.close=function(){this.client.close()},c.prototype.getStatus=function(){return this.client.getStatus()},c);function c(t){this.initClient(t)}function r(t){this.nextSubId=1,this.status=h.Status.UNREADY,this.heartbeatTimeout=1e3,this.clientEventSubs=new Map,this.eventSubs=new Map,this.sidMap=new Map,this.destroyed=!1,this.config={host:t.host,maxReconnectTimes:+t.maxReconnectTimes||10,reconnectDelay:+t.reconnectDelay||2e3,heartbeatInterval:+t.heartbeatInterval||3e4,connectWhenManual:!!t.connectWhenManual,connectType:h.ConnectType.NATS},this.lastReconnectTimes=this.config.maxReconnectTimes,this.validateConfig()&&!this.config.connectWhenManual&&this.connect()}h.default=i,Object.defineProperty(h,"__esModule",{value:!0})});


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseActErrorCode = parseActErrorCode;
	/**
	 * 频道延时类型
	 */
	var ActDelayType = {
	    NORMAL: 1, // 普通
	    LOW_DELAY: 2 // 低延时
	};
	
	var ActErrorCode = {
	    /**
	    * 账户欠费（只限制低延时以外的资源）
	    */
	    BILL_NOT_PAID: 101,
	    /**
	    * 试用用户：超并发 (限制所有)
	    */
	    TRIAL_USER_CONCURRENT_ERROR: 102,
	    /**
	    * 其他用户：超并发（限制所有）
	    */
	    USER_CONCURRENT_ERROR: 103,
	    /**
	    * 频道消费达到上限（限制所有）
	    */
	    ACT_OVER_BUDGET: 104,
	    /**
	    * 观看时长达到上线（只限制低延时以外的资源）
	    */
	    WATCH_TIME_OVER_BUDGET: 105,
	    /**
	    * 用户不存在（单独出现，限制所有）
	    */
	    USER_NOT_EXIST: 106,
	    /**
	    * 拉流流量达到上限（只限制低延时以外资源）
	    */
	    DATA_FLOW_OVER_BUDGET: 107,
	    /**
	    * 低延时资源无（只限制低延时资源）
	    */
	    LOW_DELAY_SOURCE_RUN_OUT: 108
	};
	
	// 会阻止观看直播的错误码
	var preventLiveCodes = [ActErrorCode.BILL_NOT_PAID, ActErrorCode.TRIAL_USER_CONCURRENT_ERROR, ActErrorCode.USER_CONCURRENT_ERROR, ActErrorCode.ACT_OVER_BUDGET, ActErrorCode.WATCH_TIME_OVER_BUDGET, ActErrorCode.USER_NOT_EXIST, ActErrorCode.DATA_FLOW_OVER_BUDGET];
	// 会阻止观看回放的错误码
	var preventTrailerCodes = [ActErrorCode.BILL_NOT_PAID, ActErrorCode.TRIAL_USER_CONCURRENT_ERROR, ActErrorCode.USER_CONCURRENT_ERROR, ActErrorCode.ACT_OVER_BUDGET, ActErrorCode.WATCH_TIME_OVER_BUDGET, ActErrorCode.USER_NOT_EXIST, ActErrorCode.DATA_FLOW_OVER_BUDGET];
	// 会阻止观看低延时直播的错误码
	var preventLowDelayLiveCodes = [ActErrorCode.TRIAL_USER_CONCURRENT_ERROR, ActErrorCode.USER_CONCURRENT_ERROR, ActErrorCode.ACT_OVER_BUDGET, ActErrorCode.USER_NOT_EXIST, ActErrorCode.LOW_DELAY_SOURCE_RUN_OUT];
	
	function parseActErrorCode(errcodeStr, actDelayType) {
	    var codes = errcodeStr.split(',').filter(function (v) {
	        return !!v;
	    }).map(function (v) {
	        return +v;
	    });
	    // 普通直播
	    var normalLive = false;
	    // 低延时直播
	    var lowDelayLive = false;
	    var trailer = false;
	
	    // 有错误码
	    if (codes.length) {
	        codes.forEach(function (code) {
	            if (preventLiveCodes.includes(code)) {
	                normalLive = true;
	            }
	            if (preventTrailerCodes.includes(code)) {
	                trailer = true;
	            }
	            if (preventLowDelayLiveCodes.includes(code)) {
	                lowDelayLive = true;
	            }
	        });
	    }
	
	    // 根据频道类型选择live错误码
	    var live = false;
	    switch (actDelayType) {
	        case ActDelayType.LOW_DELAY:
	            live = lowDelayLive;
	            break;
	        case ActDelayType.NORMAL:
	        default:
	            live = normalLive;
	    }
	
	    return {
	        hasLiveErrcode: live,
	        hasTrailerErrcode: trailer
	    };
	}


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	var _extends2 = __webpack_require__(103);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(139);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _config = __webpack_require__(117);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	module.exports = function (scb) {
	    return new Tracker(scb);
	};
	
	function Tracker(scb) {
	
	    var projectId,
	        // 数据分析项目id int
	    visitorId,
	        page,
	        _keepOnlineTimer,
	        hasSendExitEvent,
	        hasInited,
	        _actHashId,
	        _hasTriggerLeaveEvent = false,
	        _leaveEventArr = [],
	        _isInReEntryPage = false,
	        _ReEntryCbArr = [],
	        properties = {},
	        _page_view_id = 0,
	        _name = '',
	        _deviceType = isMobile() ? 'mobile' : 'pc',
	        _avatar = '',
	        _session_id = '';
	
	    var API_UPDATE_VISITOR_PROPERTIES = _config2["default"].API_DOMAIN + '/m/api/visitor-event-tracking/v1/activity/visitor/properties',
	        // 设置观众属性 这里替换了新接口
	    API_ON_PAGE_VIEW = _config2["default"].API_DOMAIN + '/analytics/api/on_page_view',
	        // 这个接口没用了 去掉
	    API_ONLINE = _config2["default"].API_DOMAIN + '/m/api/visitor-event-tracking/v1/activity/visitor/page_online',
	        // 在线打点 替换了新接口
	    API_ON_PAGE_EXIT = _config2["default"].API_DOMAIN + '/user/api/logout',
	        // 离开页面 后面拼接acthashid
	    API_ON_PAGE_EVENT = _config2["default"].API_DOMAIN + '/m/api/visitor-event-tracking/v1/activity/visitor/page_event'; // 数据上报 替换了新接口
	
	    return {
	        keepOnlineTimeGap: 20 * 1000,
	        init: function init(newProjectId, newVisitorId, newPage, actHashId) {
	            this.setProjectId(newProjectId);
	            this.setVisitorId(newVisitorId);
	            this.setPage(newPage);
	            _actHashId = actHashId;
	            'function' === typeof scb && scb();
	        },
	        setProjectId: function setProjectId(newProjectId) {
	            projectId = +newProjectId;
	        },
	        getProjectId: function getProjectId() {
	            return projectId;
	        },
	        setSessionId: function setSessionId(id) {
	            _session_id = id;
	        },
	        getSessionId: function getSessionId() {
	            return _session_id;
	        },
	        setProperties: function setProperties(param) {
	            properties = param;
	        },
	        getProperties: function getProperties() {
	            return properties;
	        },
	        setPage: function setPage(newPage) {
	            var pref = '/activity/';
	            if (newPage.indexOf(pref) === 0) {
	                page = newPage;
	            } else {
	                page = pref + newPage;
	                // eslint-disable-next-line
	                console && console.warn && console.warn('data tracker needs page param as "/activity/${actHashId}"');
	            }
	        },
	        getPage: function getPage() {
	            return page;
	        },
	        setVisitorId: function setVisitorId(newVisitorId) {
	            visitorId = '' + newVisitorId;
	        },
	        getVisitorId: function getVisitorId() {
	            return visitorId;
	        },
	        startDataTracker: function startDataTracker(properties, session_id) {
	            var _self = this;
	            properties = !properties ? {} : properties;
	            this.setSessionId(session_id);
	            this.setProperties(properties);
	            this.updateProperties(properties);
	            this.keepOnlineTimer();
	            // 挂载window事件
	            [{
	                target: window,
	                event: 'beforeunload',
	                cb: function cb() {
	                    _self.triggerOnLeaveEvent();
	                    _self.keepOnline(true);
	                    _self.leavePage();
	                }
	            }, {
	                target: window,
	                event: 'unload',
	                cb: function cb() {
	                    _self.triggerOnLeaveEvent();
	                    _self.keepOnline(true);
	                    _self.leavePage();
	                }
	            }, {
	                target: window,
	                event: 'pagehide',
	                cb: function cb() {
	                    console.log('hide: 心跳一次');
	                    _self.keepOnline();
	                }
	            }, {
	                target: document,
	                event: 'visibilitychange',
	                cb: function cb() {
	                    console.log('visibilitychange: 心跳一次');
	                    _self.keepOnline();
	                }
	            }].forEach(function (v) {
	                addEvent(v.target, v.event, v.cb);
	            });
	            hasInited = true;
	            _self.updateUserPhone(properties.phone);
	
	            //_self.shouldUpdateUseractPhone();
	            var referVisitorId = getParams().referVisitorId || '';
	            if (referVisitorId) {
	                _self.triggerEvent({
	                    category: 'interact',
	                    action: 'share',
	                    label: getOrigintype(),
	                    value: getParams().referVisitorId || '',
	                    session_id: session_id
	                });
	            }
	        },
	        getParams: getParams,
	        getOrigintype: getOrigintype,
	        get_cookie: get_cookie,
	        updateProperties: function updateProperties(properties) {
	            var _self = this;
	            properties = !properties ? {} : properties;
	            if (properties.name) {
	                _name = properties.name;
	            }
	            if (properties.avatar) {
	                _avatar = properties.avatar;
	            }
	            update_visitor_properties({
	                properties: properties,
	                session_id: _self.getSessionId()
	            });
	        },
	        updateUserPhone: function updateUserPhone(phone) {
	            if (!phone) {
	                return;
	            }
	            this.triggerEvent({
	                category: 'interact',
	                action: 'phone',
	                label: (0, _stringify2["default"])({ phone: phone, is_verified: false }),
	                session_id: this.getSessionId()
	            });
	        },
	
	        /**
	         * keep online 定时器
	         */
	        keepOnlineTimer: function keepOnlineTimer() {
	            var _self = this;
	
	            clearTimeout(_keepOnlineTimer);
	
	            _keepOnlineTimer = setTimeout(function () {
	                !hasSendExitEvent && _self.keepOnline();
	                _self.keepOnlineTimer();
	            }, _self.keepOnlineTimeGap);
	        },
	        keepOnline: function keepOnline(sync) {
	            var _self = this;
	            var data = {
	                project_id: +_self.getProjectId(),
	                page: '' + _self.getPage(),
	                visitor_id: '' + _self.getVisitorId(),
	                name: '' + _name,
	                avator: '' + _avatar,
	                device: '' + _deviceType,
	                session_id: _self.getSessionId()
	            };
	            !hasSendExitEvent && keep_online(data, !sync);
	        },
	        triggerOnLeaveEvent: function triggerOnLeaveEvent() {
	            if (_hasTriggerLeaveEvent) {
	                return;
	            }
	            for (var i = 0; i < _leaveEventArr.length; i++) {
	                if ('function' === typeof _leaveEventArr[i]) {
	                    _leaveEventArr[i]();
	                }
	            }
	            _hasTriggerLeaveEvent = true;
	        },
	        /**
	         * 
	         * @param {*} fn or fn[]
	         */
	        onLeave: function onLeave(fn) {
	            if ('function' === typeof fn) {
	                _leaveEventArr.push(fn);
	            } else if (fn instanceof Array) {
	                for (var i = 0; i < fn.length; i++) {
	                    if ('function' === typeof fn[i]) {
	                        _leaveEventArr.push(fn[i]);
	                    }
	                }
	            }
	        },
	        onLeaveCancel: function onLeaveCancel(fn) {
	            _leaveEventArr = _leaveEventArr.filter(function (v) {
	                return v !== fn;
	            });
	        },
	        leavePage: function leavePage() {
	            if (hasSendExitEvent) {
	                return;
	            }
	            var _self = this;
	            var data = {
	                // project_id: +(_self.getProjectId()),
	                page: '' + _self.getPage(),
	                page_view_id: _page_view_id,
	                session_id: _self.getSessionId()
	            };
	            on_page_exit(data);
	            hasSendExitEvent = true;
	        },
	        /**
	         * project_id 项目id int
	            page 页面key string 
	            category 事件分类 string
	            action 事件key string
	            label 事件标签 string
	            value 事件值（int）
	         * @param {*} data 
	         */
	        triggerEvent: function triggerEvent(data, opt) {
	            var successCallback = 'function' === typeof opt ? opt : opt && 'function' === typeof opt.success ? opt.success : undefined;
	            var async = opt && 'undefined' !== typeof opt.async ? opt.async : true;
	            if (!hasInited || hasSendExitEvent) {
	                return;
	            }
	            var _self = this;
	            var project_id = typeof data.project_id === 'undefined' ? _self.getProjectId() : data.project_id;
	            var page = typeof data.page === 'undefined' ? _self.getPage() : data.page;
	            var value = typeof data.value === 'undefined' ? 1 : data.value;
	            var sessionId = typeof data.session_id === 'undefined' ? this.getSessionId() : data.session_id;
	            sendEvent({
	                project_id: project_id,
	                page: page,
	                category: data.category,
	                action: data.action,
	                label: data.label || '',
	                value: value,
	                session_id: sessionId
	            }, {
	                async: async,
	                success: successCallback
	            });
	        },
	        destroy: function destroy() {
	            if (_keepOnlineTimer) {
	                clearInterval(_keepOnlineTimer);
	            }
	            var _self = this;
	            _self.triggerOnLeaveEvent();
	            _self.keepOnline();
	            _self.leavePage();
	        }
	    };
	
	    /**
	     * project_id 数据分析项目id int
	        visitor_id 访客id string
	        properties 访客自定义属性 object
	     * @param {*} data 
	     */
	    function update_visitor_properties(data) {
	        ajax(API_UPDATE_VISITOR_PROPERTIES + '?act_id=' + _actHashId, {
	            method: 'PUT',
	            data: data
	        });
	    }
	
	    /**
	     * 进入页面
	     * @param {*} data 
	     */
	    function on_page_view(data, opt) {
	        ajax(API_ON_PAGE_VIEW, {
	            method: 'POST',
	            data: {
	                project_id: +data.project_id, // int
	                location: window.location.href,
	                title: document.title,
	                page: '' + data.page
	            },
	            async: opt && 'undefined' !== opt.async ? opt.async : true,
	            success: function success(res) {
	                try {
	                    var data = JSON.parse(res);
	                    if (data.errcode === 1000) {
	                        _page_view_id = data.page_view_id;
	                    }
	                } catch (e) {/**/}
	                typeof opt === 'function' && opt(res);
	                opt && 'function' === typeof opt.success && opt.success(res);
	            }
	        });
	    }
	
	    function reEntryPage(cb) {
	        _ReEntryCbArr.push(cb);
	        if (_isInReEntryPage) {
	            return;
	        }
	        _isInReEntryPage = true;
	        on_page_view({
	            project_id: projectId,
	            page: page
	        }, {
	            async: false,
	            success: function success() {
	                for (var i = 0; i < _ReEntryCbArr.length; i++) {
	                    var item_cb = _ReEntryCbArr[i];
	                    'function' === typeof item_cb && item_cb();
	                }
	                _ReEntryCbArr = [];
	                _isInReEntryPage = false;
	            }
	        });
	    }
	
	    /**
	     * 定时刷新
	     * @param {*} data 
	     */
	    function keep_online(data, async) {
	        // 网络断线，计时器保持但心跳不发出，避免堆积报错
	        if (typeof window.navigator.onLine !== 'undefined' && !window.navigator.onLine) {
	            return;
	        }
	        ajax(API_ONLINE + '?act_id=' + _actHashId, {
	            method: 'POST',
	            data: {
	                name: data.name,
	                visitor_id: data.visitor_id,
	                avator: data.avator,
	                device: data.device,
	                page: data.page,
	                session_id: data.session_id
	            },
	            async: async,
	            success: function success(d) {
	                try {
	                    if ('string' === typeof d) {
	                        d = JSON.parse(d);
	                    }
	                } catch (e) {
	                    d = d || '';
	                }
	                switch (d.errcode) {
	                    case 1000:
	                        // 成功
	                        break;
	                    case 6403:
	                        // 用户已登出：心跳断了
	                        if (typeof window.navigator.onLine !== 'undefined' && window.navigator.onLine) {
	                            clearTimeout(_keepOnlineTimer);
	                            _scope.MsgBus.Pub('User.Offline', { errcode: d.errcode });
	                        }
	                        break;
	                    default:
	                    // 其他错误
	                }
	            }
	        });
	    }
	
	    /**
	     * 离开事件 同步请求
	     * @param {*} data 
	     */
	    function on_page_exit(data) {
	        ajax(API_ON_PAGE_EXIT + '?act_id=' + _actHashId, {
	            method: 'POST',
	            data: data,
	            async: false
	        });
	    }
	
	    function sendEvent(data, opt) {
	        ajax(API_ON_PAGE_EVENT + '?act_id=' + _actHashId, {
	            method: 'POST',
	            data: {
	                page: '' + data.page,
	                category: '' + data.category,
	                action: '' + data.action,
	                label: '' + data.label,
	                value: +data.value,
	                from_value: '',
	                session_id: data.session_id
	            },
	            success: function success(d) {
	                try {
	                    if ('string' === typeof d) {
	                        d = JSON.parse(d);
	                    }
	                } catch (e) {
	                    d = d || '';
	                }
	                if (d.errcode === 1634) {
	                    reEntryPage(function () {
	                        sendEvent(data, opt);
	                    });
	                    return;
	                }
	                'function' === typeof opt.success && opt.success();
	            },
	            async: opt.async
	        });
	    }
	
	    function getOrigintype() {
	        var ref = document.referrer;
	        var refererHost = (ref.split('/')[2] || '').split(':')[0];
	        var currentHost = window.location.host;
	        var params = getParams();
	        var ua = navigator.userAgent.toLowerCase();
	        if (ua.indexOf('dingtalk') !== -1) {
	            refererHost = 'dingding';
	        }
	        var origin = params.from || '';
	        var queryStringChannel = params.channel || '';
	        if (origin === '') {
	            if (refererHost.indexOf('weibo.com') !== -1) {
	                origin = 'weibo';
	            } else if (refererHost.indexOf('qq.com') !== -1) {
	                origin = 'qq';
	            } else if (refererHost.indexOf('dingding') !== -1) {
	                origin = 'dingding';
	            } else if (refererHost === currentHost) {
	                origin = 'direct';
	            } else if (refererHost) {
	                origin = refererHost;
	            } else {
	                origin = 'direct';
	            }
	        }
	        if (queryStringChannel === 'invite_card') {
	            origin = 'invite_card';
	        }
	        return origin;
	    }
	
	    function getParams() {
	        var ret = {};
	        var seg = window.location.search.replace(/^\?/, '').split('&').filter(function (v) {
	            if (v !== '' && v.indexOf('=')) {
	                return true;
	            }
	        });
	        seg.forEach(function (element) {
	            var idx = element.indexOf('=');
	            var key = element.substring(0, idx);
	            var val = element.substring(idx + 1);
	            ret[key] = val;
	        });
	        return ret;
	    }
	
	    /**
	     * 封装绑定事件
	     * @param {*} elem 
	     * @param {*} type 
	     * @param {*} handler 
	     */
	    function addEvent(elem, type, handler) {
	        if (window.addEventListener) {
	            // eslint-disable-next-line
	            addEvent = function addEvent(elem, type, handler) {
	                elem.addEventListener(type, handler, false);
	            };
	        } else if (window.attachEvent) {
	            // eslint-disable-next-line
	            addEvent = function addEvent(elem, type, handler) {
	                elem.attachEvent('on' + type, handler);
	            };
	        }
	
	        addEvent(elem, type, handler);
	    }
	
	    function get_cookie(name) {
	        var arr = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'));
	        if (arr != null) {
	            return unescape(arr[2]);
	        } else {
	            return null;
	        }
	    }
	
	    /**
	     * 设置当日零点过期的cookie
	     * @param {*} name 
	     * @param {*} value 
	     */
	    // function set_cookie(name, value) {
	    //     var curDate = new Date();
	
	    //     //当前时间戳
	    //     var curTamp = curDate.getTime();
	
	    //     //当日凌晨的时间戳,减去一毫秒是为了防止后续得到的时间不会达到00:00:00的状态
	    //     var curWeeHours = new Date(curDate.toLocaleDateString()).getTime() - 1;
	
	    //     //当日已经过去的时间（毫秒）
	    //     var passedTamp = curTamp - curWeeHours;
	
	    //     //当日剩余时间
	    //     var leftTamp = 24 * 60 * 60 * 1000 - passedTamp;
	    //     var leftTime = new Date();
	    //     leftTime.setTime(leftTamp + curTamp);
	    //     //创建cookie
	    //     document.cookie = name + '=' + escape(value + ',') + ';expires=' + leftTime.toGMTString();
	    // }
	
	    //两个参数，一个是cookie的名子，一个是值
	    function SetCookie(name, value) {
	        // eslint-disable-line
	        var Days = 30; //此 cookie 将被保存 30 天
	        var exp = new Date(); //new Date("December 31, 9998");
	        exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
	        document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + exp.toGMTString() + ';path=/';
	    }
	
	    /**
	     * 封装的ajax
	     * @param {*} url 
	     * @param {*} option 
	     */
	    function ajax(url, option) {
	        // 没有get请求，直接写死post
	        if (option.method == 'POST') {
	            Fetcher.Post(url, (0, _stringify2["default"])(option.data), function (data) {
	                try {
	                    typeof option.success === 'function' && option.success(data);
	                } catch (e) {
	                    typeof option.fail === 'function' && option.fail(data);
	                }
	                typeof option.complete === 'function' && option.complete(data);
	            }, (0, _extends3["default"])({
	                'User-Agent': navigator.userAgent,
	                'Referer': document.referrer,
	                'Content-Type': 'application/json'
	            }, _scope.DB.Get('requestHeader').token));
	        } else if (option.method == 'PUT') {
	            Fetcher.Put(url, (0, _stringify2["default"])(option.data), function (data) {
	                try {
	                    typeof option.success === 'function' && option.success(data);
	                } catch (e) {
	                    typeof option.fail === 'function' && option.fail(data);
	                }
	                typeof option.complete === 'function' && option.complete(data);
	            }, (0, _extends3["default"])({
	                'User-Agent': navigator.userAgent,
	                'Referer': document.referrer,
	                'Content-Type': 'application/json'
	            }, _scope.DB.Get('requestHeader').token));
	        }
	    }
	
	    function isMobile() {
	        return (/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent)
	        );
	    }
	}


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {if(!global["_scope"]) global["_scope"] = {};
	module.exports = global["_scope"]["User"] = __webpack_require__(147);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	var _extends2 = __webpack_require__(103);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(139);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(148);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _classCallCheck2 = __webpack_require__(110);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(111);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var config = __webpack_require__(117);
	var browser = __webpack_require__(15);
	var dingding = __webpack_require__(164);
	
	var User = function () {
	    function User() {
	        (0, _classCallCheck3["default"])(this, User);
	
	        _scope.Feature.EventBus(this);
	        _scope.Feature.Room(this);
	        // this.user = param.name || _scope.Utils.GetCookie('user') || '匿名网友';
	        // this.avatar = param.avatar || _scope.Utils.GetCookie('avatar') || 'https://mudu.tv/assets/img/avatar.png';
	        // this.id = param.id || _scope.Utils.GetCookie('visitorId') || new Date().getTime() + '' + _scope.Utils.GetRandomNum(1000, 9999) + 'sdk';
	        // this._SetCookie(this.user, this.avatar, this.id);
	
	        this._listenStartSessionSuccess();
	        this._listenUpdateUserInfo();
	        this._msgbusDestroy();
	    }
	
	    (0, _createClass3["default"])(User, [{
	        key: '_msgbusDestroy',
	        value: function _msgbusDestroy() {
	            var _this = this;
	
	            this.destroyKey = _scope.MsgBus.On('Destroy', function () {
	                _scope.MsgBus.UnSubAll('User.Registered');
	                _scope.MsgBus.UnSubAll('User.Assigned');
	                _scope.MsgBus.UnSub(_this.destroyKey);
	            });
	        }
	    }, {
	        key: '_listenUpdateUserInfo',
	        value: function _listenUpdateUserInfo() {
	            var _this2 = this;
	
	            _scope.MsgBus.Sub('User.Update', function () {
	                _this2._getUserInfo(function (userInfo) {
	                    _this2.Room.tracker.updateProperties({
	                        name: userInfo.user.nick,
	                        third_id: userInfo.user.assign_id,
	                        avatar: userInfo.user.avatar,
	                        outer_id: userInfo.user.outer_id
	                    });
	                    _scope.MsgBus.Pub('User.Update.Over', userInfo);
	                });
	            });
	        }
	    }, {
	        key: '_listenStartSessionSuccess',
	        value: function _listenStartSessionSuccess() {
	            var _this3 = this;
	
	            _scope.MsgBus.Sub('User.StartSeesionSuccess', function (userInfo) {
	                _this3._dealUserInfo(userInfo, function (userInfo) {
	                    var _Room = _this3.Room,
	                        actHashId = _Room.actHashId,
	                        projectId = _Room.projectId;
	
	                    _this3.Room.tracker.init(projectId, userInfo.user.id, actHashId, actHashId);
	                    _this3.Room.tracker.startDataTracker({
	                        name: userInfo.user.nick,
	                        third_id: userInfo.user.assign_id,
	                        avatar: userInfo.user.avatar,
	                        outer_id: userInfo.user.outer_id,
	                        phone: userInfo.user.phone
	                    }, userInfo.session_id);
	                    _this3._PubInitUserOver();
	                });
	            });
	        }
	    }, {
	        key: '_PubInitUserOver',
	        value: function _PubInitUserOver() {
	            _scope.MsgBus.Pub('User.Init.Over');
	        }
	    }, {
	        key: '_getUserInfo',
	        value: function _getUserInfo(cb) {
	            var _this4 = this;
	
	            var url = config.USER_AUTH_GET_USER_INFO + this.Room.actHashId;
	            Fetcher.Get(url, function (res) {
	                try {
	                    _this4._dealUserInfo(JSON.parse(res), cb);
	                } catch (err) {
	                    _scope.MsgBus.Pub('User.Init.Error', err);
	                    _scope.MsgBus.Pub('Room.Init.Error', err);
	                }
	            });
	        }
	    }, {
	        key: '_dealUserInfo',
	        value: function _dealUserInfo() {
	            var userInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            var cb = arguments[1];
	
	            if ((typeof userInfo === 'undefined' ? 'undefined' : (0, _typeof3["default"])(userInfo)) !== 'object') return;
	            try {
	                this.user = userInfo.user;
	                this.avatar = userInfo.user.avatar;
	                this.id = userInfo.user.id;
	
	                _scope.DB.Set('UserInfo', userInfo.user);
	
	                _scope.DB.Set('User', this);
	                _scope.MsgBus.Pub('User.Assigned', this);
	
	                typeof cb === 'function' && cb(userInfo);
	            } catch (e) {
	                console.warn('user info err', e); // eslint-disable-line
	            }
	        }
	
	        // 身份赋予接口 对外
	
	    }, {
	        key: 'Assign',
	        value: function Assign(name, avatar, assignId, cb) {
	            // 避免属性undefined报错
	            this._Assign({
	                name: name || '',
	                avatar: avatar || '',
	                assignId: assignId || Date.now(),
	                type: 'assign'
	            }, cb);
	        }
	
	        // 身份赋予接口 对外 参数使用object
	
	    }, {
	        key: 'AssignInfo',
	        value: function AssignInfo(assignUserInfo, cb) {
	            this._Assign({
	                name: assignUserInfo.name || '',
	                avatar: assignUserInfo.avatar || '',
	                assignId: assignUserInfo.assignId || Date.now(),
	                phone: assignUserInfo.phone || '',
	                type: 'assign'
	            }, cb);
	        }
	
	        // 身份赋予接口 自用
	
	    }, {
	        key: '_Assign',
	        value: function _Assign(assignUserInfo, cb) {
	            if (!this.id) {
	                // User 初始化 未完成
	                console.warn(' fetch userinfo not completed '); // eslint-disable-line
	                return;
	            }
	
	            this.Regist(assignUserInfo.name, assignUserInfo.avatar, assignUserInfo.assignId, assignUserInfo.type, cb, assignUserInfo.phone);
	        }
	    }, {
	        key: 'Regist',
	        value: function Regist(name, avatar, id) {
	            var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'assign';
	            var cb = arguments[4];
	            var phone = arguments[5];
	
	            var _self = this;
	            var uin = this.Room.uin;
	
	            if (!this.Room) {
	                return;
	            }
	
	            // Assign前先登出匿名账号
	            Fetcher.Post(config.API_DOMAIN + '/user/api/logout?act_id=' + _self.Room.actHashId, (0, _stringify2["default"])({
	                session_id: _self.Room.tracker.getSessionId()
	            }), function () {
	                // 登出后使用assign login
	                var url = config.USER_AUTH_LOGIN_BY_OTHER;
	                Fetcher.Post(url, (0, _stringify2["default"])({
	                    act_id: _self.Room.actHashId,
	                    type: type,
	                    user_id: uin + '_' + id,
	                    avatar: avatar,
	                    nick: name,
	                    phone: phone
	                }), function (data) {
	                    data = JSON.parse(data);
	                    var cbData = {};
	                    var isSuccess = data.errcode === 1000;
	                    cbData.status = isSuccess ? 'y' : 'n';
	                    cbData.info = data.msg;
	                    // cbData.flag = data.Flag;
	                    if (isSuccess) {
	                        // 重新获取 用户 信息
	                        _scope.MsgBus.Pub('User.Registered', (0, _stringify2["default"])(cbData));
	                        _scope.MsgBus.Pub('User.AssignLoginByOther', (0, _extends3["default"])({}, cbData, { token: data.token }));
	                        var cbIsCalled = false;
	                        _scope.MsgBus.Sub('User.StartSeesionSuccess', function (userInfo) {
	                            _self.Room.tracker.updateProperties({
	                                name: userInfo.user.nick,
	                                third_id: userInfo.user.assign_id,
	                                avatar: userInfo.user.avatar,
	                                outer_id: userInfo.user.outer_id
	                            });
	                            if (cbIsCalled) {
	                                return;
	                            }
	                            cbIsCalled = true;
	                            typeof cb === 'function' && cb(userInfo);
	                        });
	                    }
	                }, {
	                    'User-Agent': navigator.userAgent,
	                    'Referer': document.referrer,
	                    'Content-Type': 'application/json'
	                });
	            }, {
	                'User-Agent': navigator.userAgent,
	                'Referer': document.referrer,
	                'Content-Type': 'application/json'
	            });
	        }
	
	        // _SetCookie(name,avatar,id) {
	        //     _scope.Utils.SetCookie('user', name);
	        //     _scope.Utils.SetCookie('avatar', avatar);
	        //     _scope.Utils.SetCookie('visitorId', id);
	        //     _scope.MsgBus.Pub('User.Assigned', this);
	        //     _scope.DB.Set('User', this);
	        // }
	
	    }, {
	        key: 'GetUser',
	        value: function GetUser() {
	            var UserInfo = _scope.DB.Get('UserInfo');
	            return {
	                name: UserInfo.nick,
	                avatar: UserInfo.avatar,
	                phone: UserInfo.phone,
	                id: UserInfo.id,
	                assign_id: UserInfo.assign_id,
	                hash_id: UserInfo.hash_id,
	                outer_id: UserInfo.outer_id
	            };
	        }
	    }, {
	        key: 'SocialLogin',
	        value: function SocialLogin(loginType) {
	            var socialAuthConfig = _scope.DB.Get('socialAuthConfig');
	            if (!socialAuthConfig) return;
	            var _socialAuthConfig$isS = socialAuthConfig.isSetType,
	                issetQq = _socialAuthConfig$isS.issetQq,
	                issetWeibo = _socialAuthConfig$isS.issetWeibo,
	                _socialAuthConfig$oau = socialAuthConfig.oauth2AppIdConfig,
	                qq_appid = _socialAuthConfig$oau.qq_appid,
	                weibo_appid = _socialAuthConfig$oau.weibo_appid,
	                weixin_mp_appid = _socialAuthConfig$oau.weixin_mp_appid;
	
	            var _scope$DB$Get = _scope.DB.Get('UserInfo'),
	                wx_union_id = _scope$DB$Get.wx_union_id,
	                qq_open_id = _scope$DB$Get.qq_open_id,
	                wb_open_id = _scope$DB$Get.wb_open_id;
	
	            loginType = _scope.Utils.GetPrimarySocialLoginType(loginType);
	
	            // 已经授权过的情况
	            if (loginType == 'weixin' && wx_union_id) {
	                return;
	            } else if (loginType == 'qq' && qq_open_id) {
	                return;
	            } else if (loginType == 'weibo' && wb_open_id) {
	                return;
	            }
	
	            var appid = '';
	            if (loginType == 'weixin') {
	                appid = weixin_mp_appid;
	            } else if (loginType == 'qq' && issetQq) {
	                appid = qq_appid;
	            } else if (loginType == 'weibo' && issetWeibo) {
	                appid = weibo_appid;
	            }
	
	            var referer = encodeURIComponent(window.location.href);
	            var url = config.AUTH_DOMAIN + '/user/api/sociallogin/' + loginType + '/' + appid + '?referer=' + referer;
	            window.location.href = url;
	        }
	    }, {
	        key: 'WechatLogin',
	        value: function WechatLogin() {
	            var relogin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	            if (_scope.DB.Get('UserInfo').wx_union_id && !relogin) {
	                return false;
	            }
	
	            if (!browser.isWechat()) {
	                return false;
	            }
	
	            var referer = encodeURIComponent(window.location.href);
	            var url = this.Room.domain + config.RELATIVE_SOCIAL_LOGIN_URL + '&loginType=weixin&referer=' + referer;
	            window.location.href = url;
	        }
	    }, {
	        key: 'IsWechatLogined',
	        value: function IsWechatLogined() {
	            return browser.isWechat() && !!_scope.DB.Get('UserInfo').wx_union_id;
	        }
	    }, {
	        key: 'DingdingLogin',
	        value: function DingdingLogin() {
	            var _this5 = this;
	
	            if (!this.Room.dingdingIsvConfig) {
	                return false;
	            }
	            if (_scope.DB.Get('UserInfo').dingding_open_id) {
	                // 用户 是否 已经 钉钉 授权 过
	                return false;
	            }
	            if (!browser.isDingding()) {
	                return false;
	            }
	            if (typeof dd === 'undefined') {
	                return false;
	            }
	            dingding.init(this.Room.dingdingIsvConfig, function () {
	                return dingding.login(_this5.Room.dingdingIsvConfig.corpId, function (_ref) {
	                    var id = _ref.id,
	                        user = _ref.user,
	                        avatar = _ref.avatar;
	
	                    _this5._Assign(user, avatar, id, 'dingding');
	                });
	            });
	        }
	    }]);
	    return User;
	}();
	
	module.exports = User;


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(149);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(152);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(150), __esModule: true };

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(75);
	__webpack_require__(29);
	module.exports = __webpack_require__(151).f('iterator');


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(72);


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(153), __esModule: true };

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(154);
	__webpack_require__(85);
	__webpack_require__(162);
	__webpack_require__(163);
	module.exports = __webpack_require__(42).Symbol;


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(41);
	var has = __webpack_require__(56);
	var DESCRIPTORS = __webpack_require__(50);
	var $export = __webpack_require__(40);
	var redefine = __webpack_require__(55);
	var META = __webpack_require__(155).KEY;
	var $fails = __webpack_require__(51);
	var shared = __webpack_require__(67);
	var setToStringTag = __webpack_require__(71);
	var uid = __webpack_require__(68);
	var wks = __webpack_require__(72);
	var wksExt = __webpack_require__(151);
	var wksDefine = __webpack_require__(156);
	var enumKeys = __webpack_require__(157);
	var isArray = __webpack_require__(158);
	var anObject = __webpack_require__(47);
	var toIObject = __webpack_require__(34);
	var toPrimitive = __webpack_require__(53);
	var createDesc = __webpack_require__(54);
	var _create = __webpack_require__(58);
	var gOPNExt = __webpack_require__(159);
	var $GOPD = __webpack_require__(161);
	var $DP = __webpack_require__(46);
	var $keys = __webpack_require__(60);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(160).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(109).f = $propertyIsEnumerable;
	  __webpack_require__(108).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(39)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    replacer = args[1];
	    if (typeof replacer == 'function') $replacer = replacer;
	    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
	      if ($replacer) value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(45)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(68)('meta');
	var isObject = __webpack_require__(48);
	var has = __webpack_require__(56);
	var setDesc = __webpack_require__(46).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(51)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(41);
	var core = __webpack_require__(42);
	var LIBRARY = __webpack_require__(39);
	var wksExt = __webpack_require__(151);
	var defineProperty = __webpack_require__(46).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(60);
	var gOPS = __webpack_require__(108);
	var pIE = __webpack_require__(109);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(36);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(34);
	var gOPN = __webpack_require__(160).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(61);
	var hiddenKeys = __webpack_require__(69).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(109);
	var createDesc = __webpack_require__(54);
	var toIObject = __webpack_require__(34);
	var toPrimitive = __webpack_require__(53);
	var has = __webpack_require__(56);
	var IE8_DOM_DEFINE = __webpack_require__(49);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(50) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(156)('asyncIterator');


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(156)('observable');


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	var _typeof2 = __webpack_require__(148);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var browser = __webpack_require__(15);
	
	var isInstalled = browser.isDingding() && (typeof dd === 'undefined' ? 'undefined' : (0, _typeof3["default"])(dd)) == 'object';
	var JSAPI_LIST = ['device.notification', 'biz.contact.choose', 'biz.contact.complexChoose', 'biz.user.get', 'biz.util.openLink', 'biz.navigation', 'biz.alipay.pay'];
	var notInstallResponse = { status: 'n', flag: 101, info: '未引入dingding sdk' };
	var ding = window.dd;
	// var dingLogo = '//mudu.tv/assets/img/index/dingding.png';
	var GET_USER_INFO_URL = 'http://mudu.tv/dingding.php?a=ajaxGetUserInfo';
	
	exports.init = function (obj, cb) {
	    if (!isInstalled) {
	        return notInstallResponse;
	    }
	    ding.config({
	        agentId: obj.agentId,
	        corpId: obj.corpId,
	        timeStamp: obj.timeStamp,
	        nonceStr: obj.nonceStr,
	        signature: obj.signature,
	        jsApiList: JSAPI_LIST
	    });
	    ding.ready(function () {
	        typeof cb === 'function' && cb();
	    });
	    ding.error(function (err) {
	        // eslint-disable-next-line
	        console.warn(err);
	    });
	};
	
	exports.login = function (corpId, cb) {
	    getAuthCode(corpId, function (code) {
	        var data = { code: code, corpId: corpId };
	        Fetcher.PostForm(GET_USER_INFO_URL, data, function (res) {
	            res = JSON.parse(res);
	            if (res.status == 'y') {
	                var detail = res.data.detail || {};
	                // setUserInfo({id: detail.userid, user: detail.name, avatar: detail.avatar});
	                typeof cb === 'function' && cb({
	                    id: detail.userid,
	                    user: detail.name,
	                    avatar: detail.avatar
	                });
	            } else {
	                // utils.SetCookie('openId', '');
	            }
	        });
	    });
	};
	
	// function setUserInfo ({id, user, avatar}) {
	//     id && utils.SetCookie('visitorId', 'dingding' + id);
	//     id && utils.SetCookie('openId', id);
	//     user && utils.SetCookie('user', user);
	//     avatar && utils.SetCookie('avatar', avatar);
	// }
	
	function getAuthCode(corpId, cb) {
	    ding.ready(function () {
	        ding.runtime.permission.requestAuthCode({
	            corpId: corpId,
	            onSuccess: function onSuccess(res) {
	                cb(res.code);
	            },
	            onFail: function onFail(err) {
	                // eslint-disable-next-line
	                console.warn(err);
	            }
	        });
	    });
	}


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {if(!global["_scope"]) global["_scope"] = {};
	module.exports = global["_scope"]["Comment"] = __webpack_require__(166);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	var _stringify = __webpack_require__(139);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(103);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(110);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(111);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var config = __webpack_require__(117);
	
	var newCmtCodeMap = {
	    1000: [100, '发送成功'],
	    4920: [101, '管理员关闭聊天功能'],
	    4923: [102, '该用户被禁言'],
	    4921: [104, '不允许匿名聊天'],
	    4915: [105, '聊天消息长度错误'],
	    4906: [106, '频繁发送'],
	    4907: [107, '发送聊天内容中包含敏感词'],
	    4935: [135, '系统不允许观众使用匿名身份'],
	    4936: [136, '昵称中包含敏感词'],
	    103: [103, '其他错误，发送失败']
	};
	
	var defaultAnonymousCommentConfig = {
	    allowed: false,
	    inUse: false,
	    nickname: '匿名观众',
	    avatar: 'https://static.mudu.tv/assets/anonymized-user-avatar.png'
	};
	
	var Comment = function () {
	    function Comment(_ref) {
	        var _this = this;
	
	        var jsonObj = _ref.jsonObj,
	            Room = _ref.Room;
	        (0, _classCallCheck3["default"])(this, Comment);
	
	        this.act_id = jsonObj.act.id;
	        this.actHashId = jsonObj.actHashId;
	
	        this.Room = Room;
	
	        // 聊天匿名身份配置
	        this.anonymousCommentConfig = defaultAnonymousCommentConfig;
	
	        this.initComment();
	
	        this._msgbusDestroy();
	
	        _scope.MsgBus.OnMultiOnce(['Comment.GetConfig.Over', 'Comment.GetCount.Over'], function () {
	            _this.initCommentOver();
	        });
	    }
	
	    (0, _createClass3["default"])(Comment, [{
	        key: 'initComment',
	        value: function initComment() {
	            var _self = this,
	                initConfUrl = config.API_DOMAIN + '/comments/api/activities/' + this.actHashId + '/config',
	                initCmtCountUrl = config.API_DOMAIN + '/comments/api/activities/' + this.actHashId + '/comments/count?reviewed=1';
	
	            var requestHeaders = _scope.DB.Get('requestHeader');
	
	            // 获取评论的初始化配置
	            Fetcher.Get(initConfUrl, function (res) {
	                try {
	                    res = JSON.parse(res);
	                    if (res.errcode === 1000) {
	                        var data = res.data;
	                        _self.allow_publish = data["public"];
	                        _self.allow_anonymous = data.allow_anonymous;
	                        _self.needs_check = data.comment_review;
	                        _self.auto_push = !data.danmu_review;
	                        _self.anonymous_users_enabled = data.anonymous_users_enabled;
	                        _self.anonymousCommentConfig.allowed = data.anonymous_users_enabled;
	                    } else {
	                        throw new Error(res.errcode);
	                    }
	
	                    _scope.MsgBus.Pub('Comment.GetConfig.Over');
	                } catch (err) {
	                    _scope.MsgBus.Pub('Comment.Init.Over');
	                    _scope.MsgBus.Pub('Comment.Init.Error', err);
	                    _scope.MsgBus.Pub('Room.Init.Error', err);
	                }
	            }, (0, _extends3["default"])({ 'Content-Type': 'application/json' }, requestHeaders.token));
	
	            // 获取初始化时的评论条数
	            Fetcher.Get(initCmtCountUrl, function (res) {
	                try {
	                    var data = JSON.parse(res);
	                    if (data.errcode === 1000) {
	                        _self.SetCount(data.total);
	                    } else {
	                        throw new Error(data.errcode);
	                    }
	
	                    _scope.MsgBus.Pub('Comment.GetCount.Over');
	                } catch (err) {
	                    _scope.MsgBus.Pub('Comment.Init.Over');
	                    _scope.MsgBus.Pub('Comment.Init.Error', err);
	                    _scope.MsgBus.Pub('Room.Init.Error', err);
	                }
	            }, (0, _extends3["default"])({ 'Content-Type': 'application/json' }, requestHeaders.token));
	        }
	    }, {
	        key: 'initCommentOver',
	        value: function initCommentOver() {
	            this._ropOnVisitorMute();
	            this._ropMsg();
	            _scope.MsgBus.Pub('Comment.Init.Over');
	        }
	    }, {
	        key: '_msgbusDestroy',
	        value: function _msgbusDestroy() {
	            var _this2 = this;
	
	            this.destroyKey = _scope.MsgBus.On('Destroy', function () {
	                _scope.MsgBus.UnSubAll('User.Mute');
	                _scope.MsgBus.UnSubAll('Comment.Top');
	                _scope.MsgBus.UnSubAll('Comment.New');
	                _scope.MsgBus.UnSubAll('Comment.Delete');
	                _scope.MsgBus.UnSubAll('Comment.AllowPublish');
	                _scope.MsgBus.UnSubAll('Barrage.New');
	                _scope.MsgBus.UnSub('Destroy', _this2.destroyKey);
	                _this2.UnSubCommentsTopic();
	            });
	        }
	    }, {
	        key: 'UnSubCommentsTopic',
	        value: function UnSubCommentsTopic() {
	            this.unsubAct && this.unsubAct();
	            this.unsubComment && this.unsubComment();
	        }
	    }, {
	        key: '_ropMsg',
	        value: function _ropMsg() {
	            var _this3 = this;
	
	            this.unsubComment = nats.on('mudu.comments.' + this.actHashId, function (msg) {
	                var data = JSON.parse(msg);
	                if (data.action) {
	                    // comment新标准：有action的格式
	                    _this3._parseMsgWithAction(data);
	                } else if (data.type) {
	                    _this3._parseMsgWithType(data);
	                }
	            });
	        }
	    }, {
	        key: '_parseMsgWithAction',
	        value: function _parseMsgWithAction(data) {
	            var actions = data.action.split(',');
	            if (!actions) {
	                return;
	            }
	            var res = data.content;
	            // 弹幕
	            if (actions.indexOf('danmu') !== -1) {
	                // 弹幕过滤掉大表情
	                if (!this.hasNewEmotion(res.message)) {
	                    this._updateDealDanmu(data);
	                }
	            }
	            // 高亮弹幕
	            if (actions.indexOf('highlight') !== -1) {
	                this._updateDealDanmu(data, true);
	            }
	            // 聊天消息
	            if (actions.indexOf('comment') !== -1) {
	                // 是聊天消息且审核没有通过
	                if (res && (res.msg_type === 10 || res.msg_type === 11) && res.priority === 0) return;
	                this._updateNewCmt(res);
	            }
	        }
	    }, {
	        key: '_parseMsgWithType',
	        value: function _parseMsgWithType(res) {
	            var data = res.data,
	                type = res.type;
	
	            switch (type) {
	                case 'config':
	                    // 配置升级
	                    this._updateConfig(data);
	                    break;
	                case 'top': // 新置顶
	                case 'canceltop':
	                    // 新置顶
	                    this._updateNewTop(data);
	                    break;
	                case 'top_new':
	                    this._updateNewCmt(data);
	                    this._updateNewTop(data);
	                    break;
	                case 'delete':
	                    this._handleDelete(data);
	                    break;
	                case 'reply':
	                    this._updateNewReply(data);
	                    break;
	                case 'deletereply':
	                    this._handleDeleteReply(data);
	                    break;
	                default:
	                    break;
	            }
	        }
	
	        /**
	         * 检查是否有新大表情
	         */
	
	    }, {
	        key: 'hasNewEmotion',
	        value: function hasNewEmotion(str) {
	            // 新GIF表情
	            var emNewGifReg = new RegExp(/\[em_new_gif_([^]+)\]/g);
	            // 新png表情
	            var emNewPngReg = new RegExp(/\[em_new_png_([^]+)\]/g);
	            return emNewGifReg.test(str) || emNewPngReg.test(str);
	        }
	    }, {
	        key: '_ropOnVisitorMute',
	        value: function _ropOnVisitorMute() {
	            this.unsubAct = nats.on('mudu.activities.' + this.actHashId, function (data) {
	                data = JSON.parse(data);
	                var type = data.type;
	                if (type === 'ban' || type === 'remban') {
	                    data = data.data;
	                    var _data = {};
	                    _data.visitorId = data.user_id;
	                    _data.isSelf = data.user_id == _scope.DB.Get('UserInfo').hash_id;
	                    _data.user = data.username;
	                    _data.mute = type === 'ban';
	                    _scope.MsgBus.Pub('User.Mute', _data);
	                }
	            });
	        }
	    }, {
	        key: '_resolveMsg',
	        value: function _resolveMsg(msg, msg_type) {
	
	            if (50 === msg_type) {
	                // 图片
	                msg = '<div class="comment-img"><img src="' + msg + '" /></div>';
	            } else if (42 === msg_type) {
	                // 现金打赏
	                var amount = JSON.parse(msg).amount;
	                msg = '<span style="color: red">打赏 ' + amount + '元</span>';
	            } else if (41 === msg_type || 40 === msg_type) {
	                // 道具打赏
	                var obj = JSON.parse(msg),
	                    src = obj.src,
	                    number = obj.number;
	                msg = "<span style='color: red'>送出 <img class='gift_img' style='width: 2rem;height: 2rem;vertical-align: middle;' src='" + src + "'/> 发生的，数量 " + number + "</span>"; // eslint-disable-line
	            } else if (22 === msg_type) {
	                // 竞答红包
	                var _obj = JSON.parse(msg),
	                    hashId = _obj.id;
	                msg = '<div data-id="' + hashId + '" data-name="参与竞答领取红包！" class="rop-qa-redpack"><img src="https://static.mudu.tv/assets/redpack/qa-envelope.png"/><p>参与竞答领取红包！</p><span>点击答题</span></div>';
	            } else if (21 === msg_type) {
	                // 口令红包
	                var _obj2 = JSON.parse(msg),
	                    _hashId = _obj2.id,
	                    name = _obj2.name,
	                    type = _obj2.type;
	                msg = '<div data-id="' + _hashId + '" data-name="官方" data-type="' + type + '" class="rop-word-redpack"><img src="//mudu.tv/assets/img/console/envelope.png"/><p>' + name + '</p></div>';
	            } else if (20 === msg_type) {
	                // 普通红包
	                var _obj3 = JSON.parse(msg),
	                    _hashId2 = _obj3.id,
	                    _name = _obj3.name,
	                    _type = _obj3.type;
	                msg = '<div data-id="' + _hashId2 + '" data-type="' + _type + '" data-name="官方" data-wishes="' + _name + '" class="envelope-rop-wrap"><img src="//mudu.tv/assets/img/console/envelope.png"/><p>' + _name + '</p><span>查看红包</span></div>';
	            }
	
	            return msg;
	        }
	    }, {
	        key: '_resolveCmt',
	        value: function _resolveCmt(cmt) {
	            var ret = (0, _extends3["default"])({}, cmt);
	            try {
	                var dateline = ret.dateline;
	                if ('string' === typeof dateline) {
	                    ret.dateline = parseInt(new Date(dateline).getTime() / 1000);
	                }
	            } catch (e) {/** */}
	            var res = {
	                id: ret.id,
	                visitor_id: ret.user_id,
	                username: ret.username,
	                title: ret.title,
	                is_admin: ret.is_admin ? 1 : 0,
	                dateline: ret.dateline,
	                checked: ret.priority !== 0 ? 1 : 0,
	                pushed: ret.is_pushed ? 1 : 0,
	                avatar: ret.avatar === '/assets/img/avatar.png' ? 'https://static.mudu.tv/index/avatar.png' : ret.avatar,
	                top: ret.priority >= 100 ? 1 : 0,
	                // origin_msg: ret.message,
	                priority: ret.priority,
	                message: ret.message,
	                msg_type: ret.msg_type,
	                reply_count: ret.reply_count || 0,
	                replies: ret.replys || [],
	                replys: ret.replys || []
	            }; //msg_type = ret.msg_type, msg = ret.message;
	
	            // 表情图片替换成文字
	            // ret.message = ret.message.replace(config.COMMENT_IMAGE_NUM_REG, (str, p1) => {
	            //     return p1 ? `[em_${p1}]` : str;
	            // });
	
	            // res.message = this._resolveMsg(msg, msg_type);
	            return res;
	        }
	    }, {
	        key: 'GetAllowPublish',
	        value: function GetAllowPublish() {
	            return this.allow_publish;
	        }
	    }, {
	        key: 'GetNeedsCheck',
	        value: function GetNeedsCheck() {
	            return this.needs_check;
	        }
	    }, {
	        key: 'GetAllowAnonymous',
	        value: function GetAllowAnonymous() {
	            return this.allow_anonymous;
	        }
	    }, {
	        key: 'GetAutoPush',
	        value: function GetAutoPush() {
	            return this.auto_push;
	        }
	
	        //发送评论接口
	
	    }, {
	        key: 'Send',
	        value: function Send(msg, cb) {
	            var _self = this;
	            var url = config.API_DOMAIN + '/comments/api/activities/' + this.actHashId + '/comment';
	            var param = {
	                message: msg
	            };
	            if (this.anonymousCommentConfig.allowed && this.anonymousCommentConfig.inUse) {
	                param.avatar = this.anonymousCommentConfig.avatar || defaultAnonymousCommentConfig.avatar;
	                param.msg_type = 11;
	                param.username = this.anonymousCommentConfig.nickname || defaultAnonymousCommentConfig.nickname;
	            }
	            var requestHeaders = _scope.DB.Get('requestHeader');
	            var callback = function callback(data) {
	                data = JSON.parse(data);
	                var cbData = {};
	                cbData.status = data.errcode === 1000 ? 'y' : 'n';
	                var infoArr = newCmtCodeMap[data.errcode] || [103, '发送失败!'];
	                cbData.flag = infoArr[0];
	                cbData.info = infoArr[1];
	                cbData.hasBadWord = data.errcode === 4907;
	                typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
	
	                // cmt tracker
	                var tracker = _self.Room.tracker;
	                if (tracker && 'function' === typeof tracker.triggerEvent) {
	                    tracker.triggerEvent({
	                        category: 'interact',
	                        action: 'comment',
	                        label: msg
	                    });
	                }
	            };
	            Fetcher.Post(url, (0, _stringify2["default"])(param), callback, (0, _extends3["default"])({ 'Content-Type': 'application/json' }, requestHeaders.token, requestHeaders.session));
	        }
	
	        //获取评论接口，dataId如果为0则获取最新一页
	
	    }, {
	        key: 'Get',
	        value: function Get() {
	            var dataId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	            var cb = arguments[1];
	
	            var self = this;
	
	            if (dataId > this.page || dataId < 0 || typeof dataId !== 'number') {
	                console.warn('page index err'); // eslint-disable-line
	                return;
	            } else if (dataId == 0) {
	                dataId = this.page;
	            }
	
	            var requestHeaders = _scope.DB.Get('requestHeader');
	
	            var url = config.API_DOMAIN + '/comments/api/activities/' + this.actHashId + '/comments?page_index=' + dataId;
	
	            var callback = function callback(res) {
	                res = JSON.parse(res);
	                var data = res.data;
	                var cbData = {};
	                if (res.errcode === 1000) {
	                    cbData = {
	                        status: 'y',
	                        info: '评论获取成功',
	                        data: {
	                            page: +dataId,
	                            comments: data.map(function (v) {
	                                return self._resolveCmt(v);
	                            })
	                        }
	                    };
	                } else {
	                    cbData = {
	                        status: 'n',
	                        info: '没有更多评论！',
	                        data: {
	                            comments: []
	                        }
	                    };
	                }
	
	                typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
	            };
	            Fetcher.Get(url, callback, requestHeaders.token);
	        }
	    }, {
	        key: 'SetCount',
	        value: function SetCount(count) {
	            this.count = count;
	            this.page = Math.ceil(count / 20);
	        }
	    }, {
	        key: 'GetPage',
	        value: function GetPage() {
	            return this.page;
	        }
	    }, {
	        key: 'GetAnonymousCommentConfig',
	        value: function GetAnonymousCommentConfig() {
	            return this.anonymousCommentConfig;
	        }
	
	        // 设置匿名配置
	
	    }, {
	        key: 'SetAnonymousCommentConfig',
	        value: function SetAnonymousCommentConfig(param, cb) {
	            var _this4 = this;
	
	            var newConfig = (0, _extends3["default"])({}, this.anonymousCommentConfig, param);
	            var callbackFunc = function callbackFunc(result, cb) {
	                try {
	                    if (typeof cb === 'function') {
	                        cb(result);
	                    }
	                } catch (error) {
	                    console.error();
	                }
	            };
	
	            if (newConfig.nickname.length > 60) {
	                callbackFunc((0, _stringify2["default"])({
	                    status: 'n',
	                    errcode: 1406
	                }), cb);
	                return;
	            } else if (!this.anonymous_users_enabled) {
	                callbackFunc((0, _stringify2["default"])({
	                    status: 'n',
	                    errcode: 4935
	                }), cb);
	                return;
	            }
	
	            this._checkSensitiveWords(newConfig.nickname, function (checkResult) {
	                if (checkResult.sensitive) {
	                    callbackFunc((0, _stringify2["default"])({
	                        status: 'n',
	                        errcode: 4936
	                    }), cb);
	                } else {
	                    _this4.anonymousCommentConfig = newConfig;
	                    callbackFunc((0, _stringify2["default"])({
	                        status: 'y',
	                        errcode: 1000
	                    }), cb);
	                }
	            });
	        }
	
	        // 检查敏感词
	
	    }, {
	        key: '_checkSensitiveWords',
	        value: function _checkSensitiveWords(string, callback) {
	            var requestHeaders = _scope.DB.Get('requestHeader');
	            Fetcher.Post(
	            // url
	            config.API_DOMAIN + '/senswords/api/users/' + this.Room.uin + '/nick/sensword',
	            // 请求参数
	            (0, _stringify2["default"])({ word: string }),
	            // 回调
	            function (result) {
	                var res = JSON.parse(result);
	                callback(res);
	            },
	            // header
	            (0, _extends3["default"])({ 'Content-Type': 'application/json' }, requestHeaders.token));
	        }
	    }, {
	        key: '_updateConfig',
	        value: function _updateConfig(data) {
	            var allow_anonymous = data.allow_anonymous,
	                comment_review = data.comment_review,
	                danmu_review = data.danmu_review;
	
	            this.allow_anonymous = allow_anonymous;
	            this.needs_check = comment_review;
	            this.auto_push = !danmu_review;
	            // const last_allow_publish = this.allow_publish;
	            this.allow_publish = data["public"];
	            this.anonymous_users_enabled = data.anonymous_users_enabled;
	            this.anonymousCommentConfig.allowed = data.anonymous_users_enabled;
	            _scope.MsgBus.Pub('Comment.config', data);
	        }
	    }, {
	        key: '_updateDealDanmu',
	        value: function _updateDealDanmu(data) {
	            var highlight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	            var content = data.content;
	
	            var res = {
	                visitor_id: content.user_id,
	                text: content.message,
	                msg_type: content.msg_type,
	                stime: new Date().getTime(),
	                high: highlight ? '1' : '0'
	            };
	            _scope.MsgBus.Pub('Barrage.New', (0, _stringify2["default"])(res));
	        }
	    }, {
	        key: '_updateNewCmt',
	        value: function _updateNewCmt(data) {
	            var newCmt = this._resolveCmt(data);
	            _scope.MsgBus.Pub('Comment.New', (0, _stringify2["default"])(newCmt));
	        }
	    }, {
	        key: '_updateNewTop',
	        value: function _updateNewTop(data) {
	            var newCmt = this._resolveCmt(data);
	            _scope.MsgBus.Pub('Comment.Top', (0, _stringify2["default"])(newCmt));
	        }
	    }, {
	        key: '_handleDelete',
	        value: function _handleDelete(data) {
	            var newCmt = this._resolveCmt(data);
	            _scope.MsgBus.Pub('Comment.Delete', (0, _stringify2["default"])(newCmt));
	        }
	    }, {
	        key: '_updateNewReply',
	        value: function _updateNewReply(data) {
	            _scope.MsgBus.Pub('Comment.Reply.New', (0, _stringify2["default"])(data));
	        }
	    }, {
	        key: '_handleDeleteReply',
	        value: function _handleDeleteReply(data) {
	            _scope.MsgBus.Pub('Comment.Reply.Delete', (0, _stringify2["default"])(data));
	        }
	    }]);
	    return Comment;
	}();
	
	module.exports = Comment;


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {if(!global["_scope"]) global["_scope"] = {};
	module.exports = global["_scope"]["LuckyDraw"] = __webpack_require__(168);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	var _stringify = __webpack_require__(139);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(110);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(111);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _config = __webpack_require__(117);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var LuckyDraw = function () {
	    function LuckyDraw() {
	        var _this = this;
	
	        (0, _classCallCheck3["default"])(this, LuckyDraw);
	
	        _scope.Feature.EventBus(this);
	
	        _scope.Feature.Room(this);
	
	        _scope.MsgBus.On('Room.Init.Over', function () {
	            _this._sub();
	        });
	
	        this._msgbusDestroy();
	    }
	
	    (0, _createClass3["default"])(LuckyDraw, [{
	        key: '_msgbusDestroy',
	        value: function _msgbusDestroy() {
	            var _this2 = this;
	
	            this.destroyKey = _scope.MsgBus.On('Destroy', function () {
	                _scope.MsgBus.UnSubAll('LuckyDraw.Open');
	
	                _scope.MsgBus.UnSub('Destroy', _this2.destroyKey);
	
	                // remove nats listener
	                _this2.unsubEvents();
	            });
	        }
	
	        //获取抽奖信息
	
	    }, {
	        key: 'Get',
	        value: function Get(cb) {
	            var id = this.Room.GetId();
	            var url = _config2["default"].API_DOMAIN + ('/activity/' + id + '/getLuckyDrawInfo');
	            var callback = function callback(data) {
	                data = JSON.parse(data);
	                var cbData = {};
	                cbData.status = data.status;
	                cbData.flag = data.flag;
	                cbData.info = data.msg;
	                cbData.data = data.data;
	                typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
	            };
	            Fetcher.Post(url, {}, callback, {
	                'Content-Type': 'application/json'
	            });
	        }
	
	        //抽奖报名
	
	    }, {
	        key: 'SignUp',
	        value: function SignUp(obj, cb) {
	            var _self = this;
	            var id = this.Room.GetId();
	            var url = _config2["default"].API_DOMAIN + ('/activity/' + id + '/setLuckyDrawSignUp');
	            var param = {
	                uname: obj.userName,
	                phone_voucher: obj.voucher,
	                custom_voucher: obj.custom_voucher,
	                custom_field: obj.custom_field
	            };
	            var callback = function callback(data) {
	                data = JSON.parse(data);
	                var cbData = {};
	                cbData.status = data.status;
	                cbData.info = data.msg;
	                cbData.flag = data.flag;
	                typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
	
	                var tracker = _self.Room.tracker;
	                if (tracker && 'function' === typeof tracker.triggerEvent && data.status === 'y') {
	                    tracker.triggerEvent({
	                        category: 'interact',
	                        action: 'lucky_draw'
	                    });
	
	                    var phone = obj.voucher;
	                    if (phone && /^[0-9-+]+$/.test(phone)) {
	                        tracker.triggerEvent({
	                            category: 'interact',
	                            action: 'phone',
	                            label: (0, _stringify2["default"])({ phone: phone, is_verified: false })
	                        });
	                    }
	                }
	            };
	            Fetcher.Post(url, (0, _stringify2["default"])(param), callback, {
	                'Content-Type': 'application/json'
	            });
	        }
	
	        //获取最近一次抽奖结果信息
	
	    }, {
	        key: 'Result',
	        value: function Result(cb) {
	            var _self = this;
	            var id = this.Room.GetId();
	            var url = _config2["default"].API_DOMAIN + ('/activity/' + id + '/getLuckyDrawResult/v2');
	            var callback = function callback(data) {
	                data = JSON.parse(data);
	                var cbData = {};
	                cbData.status = data.status;
	                cbData.flag = data.flag;
	                cbData.info = data.msg;
	                try {
	                    // 格式化适配数据（兼容上个版本的数据结构）
	                    var tempData = data.status === 'y' && data.data.length > 0 ? data.data[0] : {};
	                    tempData.uptime_timestamp = tempData.uptime_timestamp || 0;
	                    tempData.service_timestamp = tempData.service_timestamp || 0;
	                    // 观看页提交地址按钮变成不可编辑状态的时间戳 30分钟
	                    tempData.disable_edit_time = tempData.uptime_timestamp + (Math.round(Date.now() / 1000) - tempData.service_timestamp) + 1800;
	                    // 奖品名称
	                    tempData.remark = tempData.award_name;
	                    delete tempData.award_name;
	                    cbData.data = tempData;
	
	                    // 根据中奖记录id获取抽奖结果中奖名单（这么麻烦都是为了兼容上个版本的数据结构）
	                    _self._GetLuckyDrawLuckyInfo(cbData.data.ld_record_id, function (res) {
	                        res = JSON.parse(res);
	                        cbData.data.luckers = res.data || [];
	                        cbData.data.luckers.map(function (item) {
	                            item.voucher = item.phone_voucher;
	                            item.remark = cbData.data.remark || '';
	                            return item;
	                        });
	                        typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
	                    });
	                } catch (error) {
	                    cbData.data = {};
	                    typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
	                }
	            };
	            Fetcher.Get(url, callback);
	        }
	
	        //获取历史中奖信息
	
	    }, {
	        key: 'GetAllResult',
	        value: function GetAllResult(cb) {
	            var _self = this;
	            var id = this.Room.GetId();
	            var url = _config2["default"].API_DOMAIN + ('/activity/' + id + '/getLuckyDrawResult/v2');
	            var callback = function callback(data) {
	                data = JSON.parse(data);
	                var cbData = {};
	                try {
	                    cbData.status = data.status;
	                    cbData.flag = data.flag;
	                    cbData.info = data.msg;
	                    cbData.data = data.data || [];
	                    // 客户端时间戳
	                    var clientTime = Math.round(Date.now() / 1000);
	                    // 中奖记录id集合 ‘,’ 隔开
	                    var recordIds = '';
	                    // 格式化适配数据（兼容上个版本的数据结构）
	                    cbData.data.map(function (lottery) {
	                        lottery.uptime = _self._formatTime(lottery.uptime_timestamp);
	                        // 观看页提交地址按钮变成不可编辑状态的时间戳 30分钟
	                        lottery.disable_edit_time = lottery.uptime_timestamp + (clientTime - lottery.service_timestamp) + 1800;
	                        // 奖品名称
	                        lottery.remark = lottery.award_name;
	                        delete lottery.award_name;
	                        // 默认的中奖名单
	                        lottery.list = [];
	                        // 收集中奖记录id集合
	                        recordIds = recordIds + lottery.ld_record_id + ',';
	                        return lottery;
	                    });
	
	                    // 根据中奖记录id集合获取所有抽奖结果对应的中奖名单
	                    if (recordIds.length > 1) {
	                        recordIds = recordIds.substring(0, recordIds.length - 1);
	                        // 一次性发起收集所有中奖记录对应的中奖名单（这么麻烦都是为了兼容上个版本的数据结构）
	                        _self._GetLuckyDrawLuckyInfoList(recordIds, function (res) {
	                            res = JSON.parse(res);
	                            cbData.data.map(function (lottery) {
	                                // 数据结构：{'ld_record_id': '中奖名单'}
	                                lottery.list = res.data && res.data[lottery.ld_record_id] || [];
	                                lottery.list.map(function (item) {
	                                    item.voucher = item.phone_voucher;
	                                    return item;
	                                });
	                                return lottery;
	                            });
	                            typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
	                        });
	                    } else {
	                        typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
	                    }
	                } catch (error) {
	                    cbData.data = [];
	                    typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
	                }
	            };
	            Fetcher.Get(url, callback);
	        }
	
	        /**
	         * 获取已填写的收货地址
	         * @param {string} recordId 抽奖记录id
	         * @param {function} cb 回调函数
	         */
	
	    }, {
	        key: 'GetAddress',
	        value: function GetAddress(recordId, cb) {
	            var id = this.Room.GetId();
	            var url = _config2["default"].API_DOMAIN + ('/activity/' + id + '/getLuckyDrawAddress?ld_record_id=' + recordId);
	            var callback = function callback(data) {
	                data = JSON.parse(data);
	                var cbData = {};
	                cbData.status = data.status;
	                cbData.flag = data.flag;
	                cbData.info = data.msg;
	                cbData.data = data.data;
	                typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
	            };
	            Fetcher.Get(url, callback);
	        }
	
	        /**
	         * 设置收货地址
	         * @param {*} address 发送的提交地址
	         * @param {string} recordId 抽奖记录id
	         * @param {*} cb 回调函数
	         */
	
	    }, {
	        key: 'SetAddress',
	        value: function SetAddress(address, recordId, cb) {
	            var id = this.Room.GetId();
	            var url = _config2["default"].API_DOMAIN + ('/activity/' + id + '/setLuckyDrawAddress');
	            var param = {
	                ld_record_id: recordId,
	                address: address
	            };
	            var callback = function callback(data) {
	                data = JSON.parse(data);
	                var cbData = {};
	                cbData.status = data.status;
	                cbData.flag = data.flag;
	                cbData.info = data.msg;
	                typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
	            };
	            Fetcher.Post(url, (0, _stringify2["default"])(param), callback, {
	                'Content-Type': 'application/json'
	            });
	        }
	    }, {
	        key: '_sub',
	        value: function _sub() {
	            var _this3 = this;
	
	            var actId = this.Room.GetId();
	
	            // 监听事件
	            this.unsubEvents = nats.on('lucky_draw_' + actId, function (data) {
	                var jsonObj = JSON.parse(data);
	
	                switch (jsonObj.type) {
	                    case 'open_lucky_draw':
	                        // 开奖
	                        _this3.Result(function (data) {
	                            _scope.MsgBus.Pub('LuckyDraw.Open', data);
	                        });
	                        break;
	                    case 'lucky_draw_save':
	                        // 保存抽奖（开启抽奖功能）
	                        console.log('lucky draw change:', data);
	                        _scope.MsgBus.Pub('LuckyDraw.ConfigChange', data);
	                        break;
	                    default:
	                        console.log('有一个抽奖事件');
	                }
	            });
	        }
	
	        /**
	         * 根据抽奖记录id获取抽奖结果中奖名单
	         * @param {string} recordId 抽奖记录id
	         * @param {function} cb 回调函数
	         */
	
	    }, {
	        key: '_GetLuckyDrawLuckyInfo',
	        value: function _GetLuckyDrawLuckyInfo(recordId, cb) {
	            var id = this.Room.GetId();
	            var url = _config2["default"].API_DOMAIN + ('/activity/' + id + '/getLuckyDrawLuckyInfo?ld_record_id=' + recordId);
	            var callback = function callback(data) {
	                data = JSON.parse(data);
	                var cbData = {};
	                cbData.status = data.status;
	                cbData.flag = data.flag;
	                cbData.info = data.msg;
	                cbData.data = data.data || [];
	                typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
	            };
	            Fetcher.Get(url, callback);
	        }
	
	        /**
	         * 根据中奖记录id集合获取所有抽奖结果对应的中奖名单
	         * 后端专门提供的一个接口用来兼容之前的获取历史中奖信息接口
	         * @param {string} recordIds 记录id集合 通过''拼接 不能包含空格
	         * @param {function} cb 回调函数
	         */
	
	    }, {
	        key: '_GetLuckyDrawLuckyInfoList',
	        value: function _GetLuckyDrawLuckyInfoList(recordIds, cb) {
	            var id = this.Room.GetId();
	            var url = _config2["default"].API_DOMAIN + ('/activity/' + id + '/getLuckyDrawLuckyInfoList?ld_record_ids=' + recordIds);
	            var callback = function callback(data) {
	                data = JSON.parse(data);
	                var cbData = {};
	                cbData.status = data.status;
	                cbData.flag = data.flag;
	                cbData.info = data.msg;
	                cbData.data = data.data || {};
	                typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
	            };
	            Fetcher.Get(url, callback);
	        }
	
	        // 将时间戳格式化成字符串
	
	    }, {
	        key: '_formatTime',
	        value: function _formatTime(time) {
	            var date = new Date(time * 1000);
	            var year = date.getFullYear();
	            var month = (date.getMonth() + 1).toString().padStart(2, '0');
	            var day = date.getDate().toString().padStart(2, '0');
	            var hour = date.getHours().toString().padStart(2, '0');
	            var minute = date.getMinutes().toString().padStart(2, '0');
	            var second = date.getSeconds().toString().padStart(2, '0');
	            return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
	        }
	    }, {
	        key: '_formatResult',
	        value: function _formatResult(data) {
	            var arr = [];
	            var lastLuckyDrawItem = null;
	            data.map(function (n) {
	                if (!lastLuckyDrawItem || n.uptime !== lastLuckyDrawItem.uptime) {
	                    lastLuckyDrawItem = {
	                        remark: n.remark,
	                        uptime: n.uptime,
	                        list: [{
	                            uname: n.uname,
	                            voucher: n.phone_voucher,
	                            custom_voucher: n.custom_voucher
	                        }]
	                    };
	                    arr.push(lastLuckyDrawItem);
	                } else {
	                    lastLuckyDrawItem.list.push({
	                        uname: n.uname,
	                        voucher: n.phone_voucher,
	                        custom_voucher: n.custom_voucher
	                    });
	                }
	            });
	            return arr;
	        }
	    }]);
	    return LuckyDraw;
	}();
	
	module.exports = LuckyDraw;


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {if(!global["_scope"]) global["_scope"] = {};
	module.exports = global["_scope"]["PPT"] = __webpack_require__(170);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	var _assign = __webpack_require__(104);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(139);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(110);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(111);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var config = __webpack_require__(117);
	
	module.exports = function () {
	    function PPT() {
	        var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        (0, _classCallCheck3["default"])(this, PPT);
	
	        _scope.Feature.EventBus(this);
	
	        param.config = param.config || {};
	
	        // var hasCurrentDoc = typeof param.config.current_doc === 'object';
	
	        this.id = param.act_id;
	        this.config = {
	            current_doc: '', // docId hash string
	            current_page: 0,
	            is_turn_page: false,
	            name: '',
	            open: false,
	            url: '',
	            total_page: 0,
	            images: []
	        };
	        this.actHashId = param.actHashId;
	
	        this.isPptInfoInited = false;
	        this.isPptConfigInited = false;
	        this.isPptInited = false;
	
	        this._fetchInitPptData(this._listenInitOver.bind(this, 'isPptInfoInited'));
	        this._fetchPptSwitcher();
	        this._fetchConfigPptData(this._listenInitOver.bind(this, 'isPptConfigInited'));
	        this._ropPptChange();
	
	        this._msgbusDestroy();
	    }
	
	    (0, _createClass3["default"])(PPT, [{
	        key: '_listenInitOver',
	        value: function _listenInitOver(param) {
	            if (param === 'isPptInfoInited' || param === 'isPptConfigInited') {
	                this[param] = true;
	
	                if (this.isPptInfoInited && this.isPptConfigInited) {
	                    this.isPptInited = true;
	                    _scope.MsgBus.Pub('PPT.Inited.Over');
	                }
	            }
	        }
	    }, {
	        key: '_fetchInitPptData',
	        value: function _fetchInitPptData(cb) {
	            var _self = this;
	            var actHashId = this.actHashId;
	            var url = config.API_DOMAIN + '/docs/api/activities/' + actHashId + '/documents/now?time=' + new Date().getTime();
	            Fetcher.Get(url, function (data, code) {
	                try {
	                    data = JSON.parse(data);
	                    if (code !== 200) {
	                        console.log('fetch ppt info failed.'); // eslint-disable-line
	                        throw new Error(code);
	                    }
	
	                    if (data.errcode !== 1000) {
	                        console.log('something wrong with ppt info.'); // eslint-disable-line
	                        throw new Error(data.errcode);
	                    }
	                    _self.config.current_doc = data.doc_id;
	                    _self.config.current_page = data.index;
	                    _self.config.url = (data.images[data.index] ? data.images[data.index].url : '') || '';
	                    _self.config.total_page = data.images.length;
	                    _self.config.images = data.images;
	                    typeof cb === 'function' && cb();
	                } catch (err) {
	                    typeof cb === 'function' && cb();
	                    _scope.MsgBus.Pub('PPT.Init.Error', err);
	                    _scope.MsgBus.Pub('Room.Init.Error', err);
	                }
	            });
	        }
	    }, {
	        key: '_fetchPptSwitcher',
	        value: function _fetchPptSwitcher() {
	            var _self = this;
	            var actHashId = this.actHashId;
	            var url = config.API_DOMAIN_V2 + '/v2/micro-act/view/module_switch?module_id=' + config.MENU_TYPE.DOC + '&act_id=' + actHashId;
	            Fetcher.Get(url, function (data, code) {
	                try {
	                    data = JSON.parse(data);
	                    if (code !== 200) {
	                        console.log('fetch ppt switcher failed.'); // eslint-disable-line
	                        throw new Error(code);
	                    }
	                    if (data.errcode !== 1000) {
	                        console.log('something wrong with ppt switcher.'); // eslint-disable-line
	                        throw new Error(data.errcode);
	                    }
	                    _self.config.open = data.is_open;
	                } catch (err) {
	                    _scope.MsgBus.Pub('PPT.Init.Error', err);
	                }
	            }, _scope.DB.Get('requestHeader').session);
	        }
	    }, {
	        key: '_fetchConfigPptData',
	        value: function _fetchConfigPptData(cb) {
	            var _self = this;
	            var actHashId = this.actHashId;
	            var url = config.API_DOMAIN + '/docs/api/activities/' + actHashId + '/config';
	            Fetcher.Get(url, function (data, code) {
	                try {
	                    data = JSON.parse(data);
	                    if (code !== 200) {
	                        console.log('fetch ppt config failed.'); // eslint-disable-line
	                        throw new Error(code);
	                    }
	                    if (data.errcode !== 1000) {
	                        console.log('something wrong with ppt config.'); // eslint-disable-line
	                        throw new Error(data.errcode);
	                    }
	                    _self.config.name = data.name;
	                    _self.config.is_turn_page = data.turn;
	                    // _self.config.open = data.open;
	                    typeof cb === 'function' && cb();
	                } catch (err) {
	                    typeof cb === 'function' && cb();
	                    _scope.MsgBus.Pub('PPT.Init.Error', err);
	                    _scope.MsgBus.Pub('Room.Init.Error', err);
	                }
	            });
	        }
	    }, {
	        key: '_ropPptChange',
	        value: function _ropPptChange() {
	            var _self = this;
	            var actHashId = this.actHashId;
	            rop.On('app.mududoc.sync.' + actHashId, function (data) {
	                data = JSON.parse(data);
	                if (data.type === 'config') {
	                    _self._handleConfigChange(data);
	                } else if (data.type === 'doc') {
	                    _self._handleDocChange(data);
	                }
	            });
	            rop.On('mudu.menu.' + actHashId, function (data) {
	                data = JSON.parse(data);
	                if (data.type === 'menu.switch') {
	                    switch (data.data.menu_type) {
	                        case config.MENU_TYPE.DOC:
	                            _self.config.open = data.data.is_turn_on;
	                            var res = {
	                                open: data.data.is_turn_on ? 1 : 0
	                            };
	                            if (res.open === 1) {
	                                res.page = _self.config.current_page + 1;
	                                res.total_page = _self.config.total_page;
	                                res.url = _self.config.url;
	                            }
	                            _scope.MsgBus.Pub('PPT.IsOpen', (0, _stringify2["default"])(res));
	                            break;
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'UnSubPPTTopics',
	        value: function UnSubPPTTopics() {
	            rop.Remove('app.mududoc.sync.' + this.actHashId);
	            rop.Remove('mudu.menu.' + this.actHashId);
	        }
	    }, {
	        key: '_handleDocChange',
	        value: function _handleDocChange() {
	            var newDoc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            var _self = this;
	            var config = this.config;
	            if (!newDoc.url) {
	                this.config = (0, _assign2["default"])({}, config, {
	                    current_doc: '', // docId hash string
	                    current_page: 0,
	                    name: '',
	                    url: '',
	                    total_page: 0,
	                    images: []
	                });
	                _scope.MsgBus.Pub('PPT.Doc.delete');
	            } else if (newDoc.docid === this.config.current_doc) {
	                // 同一文档
	                this.config.current_page = newDoc.index;
	                this.config.url = newDoc.url;
	                var res = {
	                    page: newDoc.index + 1,
	                    url: newDoc.url,
	                    total_page: config.total_page
	                };
	                _scope.MsgBus.Pub('PPT.Changed', (0, _stringify2["default"])(res));
	            } else {
	                this._fetchInitPptData(function () {
	                    var _config = _self.config;
	                    var res2 = {
	                        page: _config.current_page + 1,
	                        url: _config.url,
	                        total_page: _config.total_page
	                    };
	                    _scope.MsgBus.Pub('PPT.Changed', (0, _stringify2["default"])(res2));
	                });
	            }
	        }
	    }, {
	        key: '_handleConfigChange',
	        value: function _handleConfigChange() {
	            var newConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            this.config.name = newConfig.name;
	            var config = this.config;
	            if (newConfig.turn !== config.is_turn_page) {
	                this.config.is_turn_page = newConfig.turn;
	                var res2 = {
	                    is_turn_page: newConfig.turn ? 1 : 0,
	                    current_page: config.current_page + 1,
	                    total_page: config.total_page,
	                    url: config.url
	                };
	                _scope.MsgBus.Pub('PPT.AllowTurnPage', (0, _stringify2["default"])(res2));
	            }
	        }
	    }, {
	        key: '_msgbusDestroy',
	        value: function _msgbusDestroy() {
	            var _this = this;
	
	            this.destroyKey = _scope.MsgBus.On('Destroy', function () {
	                rop.Remove('app.mududoc.sync.' + _this.actHashId);
	                rop.Remove('mudu.menu.' + _this.actHashId);
	
	                _scope.MsgBus.UnSubAll('PPT.Changed');
	                _scope.MsgBus.UnSubAll('PPT.Doc.delete');
	                _scope.MsgBus.UnSubAll('PPT.IsOpen');
	                _scope.MsgBus.UnSubAll('PPT.AllowTurnPage');
	
	                _scope.MsgBus.UnSub(_this.destroyKey);
	            });
	        }
	
	        // 获取当前ppt地址
	
	    }, {
	        key: 'GetUrl',
	        value: function GetUrl() {
	            return this.config.url;
	        }
	
	        // 获取ppt是否打开
	
	    }, {
	        key: 'IsOpen',
	        value: function IsOpen() {
	            return this.config.open;
	        }
	
	        // 获取ppt的名称
	
	    }, {
	        key: 'GetName',
	        value: function GetName() {
	            return this.config.name || '';
	        }
	
	        // 获取用户是否能翻页
	
	    }, {
	        key: 'GetAllowTurnPage',
	        value: function GetAllowTurnPage() {
	            return this.config.is_turn_page;
	        }
	
	        // 获取当前页
	
	    }, {
	        key: 'GetCurrentPage',
	        value: function GetCurrentPage() {
	            return this.config.current_page + 1;
	        }
	
	        // 获取总页数
	
	    }, {
	        key: 'GetTotalPage',
	        value: function GetTotalPage() {
	            return this.config.total_page;
	        }
	
	        // 根据页码获取图片url
	
	    }, {
	        key: 'GetPageImgUrl',
	        value: function GetPageImgUrl(page, cb) {
	            var dealedPage = +page - 1;
	            var obj = this.config.images[dealedPage];
	            var url = (obj ? obj.url : '') || '';
	            typeof cb === 'function' && cb(url);
	        }
	    }]);
	    return PPT;
	}();


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {if(!global["_scope"]) global["_scope"] = {};
	module.exports = global["_scope"]["Barrage"] = __webpack_require__(172);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	var _classCallCheck2 = __webpack_require__(110);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(111);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	module.exports = function () {
	    function Barrage() {
	        (0, _classCallCheck3["default"])(this, Barrage);
	
	        _scope.Feature.EventBus(this);
	
	        // _scope.Feature.Room(this, () => {
	        //     rop.On('comment-stream-' + this.Room.act_id, function (data) {
	        //         _scope.MsgBus.Pub('Barrage.New', data);
	        //     });
	        // });
	
	        // this.destroyKey = _scope.MsgBus.Sub('Destroy', () => {
	        //     rop.Remove('comment-stream-' + this.Room.act_id);
	        //     _scope.MsgBus.UnSubAll('Barrage.New');
	        //     _scope.MsgBus.UnSub(this.destroyKey);
	        // });
	    }
	
	    (0, _createClass3["default"])(Barrage, [{
	        key: "Placeholder",
	        value: function Placeholder() {}
	    }]);
	    return Barrage;
	}();


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {if(!global["_scope"]) global["_scope"] = {};
	module.exports = global["_scope"]["Vote"] = __webpack_require__(174);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	var _stringify = __webpack_require__(139);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(110);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(111);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _config = __webpack_require__(117);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	module.exports = function () {
	    function Vote(param) {
	        var _this = this;
	
	        (0, _classCallCheck3["default"])(this, Vote);
	
	        _scope.Feature.EventBus(this);
	
	        this.act_id = param.act_id;
	        this.vote = param.vote;
	        this.tracker = param.tracker;
	        param.vote && (this.vote_id = param.vote.id);
	
	        rop.On('vote_' + this.act_id, function (data) {
	            var jsonObj = JSON.parse(data);
	            _this.vote_id = jsonObj.vote_id;
	            _this.vote = jsonObj;
	
	            if (jsonObj.type === 0) {
	                _scope.MsgBus.Pub('Vote.Changed', (0, _stringify2["default"])({ status: 'n', info: '无投票信息', flag: 101 }));
	                return;
	            }
	
	            _this.Get(function (info) {
	                _scope.MsgBus.Pub('Vote.Changed', info);
	            });
	        });
	
	        this._msgbusDestroy();
	    }
	
	    (0, _createClass3["default"])(Vote, [{
	        key: '_msgbusDestroy',
	        value: function _msgbusDestroy() {
	            var _this2 = this;
	
	            this.destroyKey = _scope.MsgBus.On('Destroy', function () {
	                rop.Remove('vote_' + _this2.act_id);
	
	                _scope.MsgBus.UnSubAll('Vote.Changed');
	                _scope.MsgBus.UnSub(_this2.destroyKey);
	            });
	        }
	    }, {
	        key: 'UnSubVoteTopics',
	        value: function UnSubVoteTopics() {
	            rop.Remove('vote_' + this.act_id);
	        }
	
	        // 获取最新投票信息
	
	    }, {
	        key: 'Get',
	        value: function Get(cb) {
	            var url = _config2["default"].API_DOMAIN + '/?c=activity&a=ajaxGetActVote';
	            var param = { vote_id: this.vote_id };
	
	            if (!this.vote_id) {
	                cb((0, _stringify2["default"])({ status: 'n', info: '无投票信息', flag: 101 }));
	                return;
	            }
	
	            var callback = function callback(data) {
	                data = JSON.parse(data);
	                var cbData = {};
	                cbData.status = data.status;
	                cbData.data = data.vote;
	                cbData.info = '获取成功';
	                typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
	            };
	            Fetcher.PostForm(url, param, callback);
	        }
	
	        // 进行投票
	
	    }, {
	        key: 'Vote',
	        value: function Vote(answer, cb) {
	            var _self = this;
	            var url = _config2["default"].API_DOMAIN + '/?c=activity&a=ajaxVote';
	            var param = {
	                vote: (0, _stringify2["default"])(answer),
	                act_id: this.act_id
	            };
	
	            var callback = function callback(data) {
	                data = JSON.parse(data);
	                var cbData = {};
	                cbData.status = data.status;
	                cbData.flag = data.Flag;
	                cbData.info = data.msg;
	                typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
	
	                // tracker vote
	                var tracker = _self.tracker;
	                if (data.status === 'y' && tracker && 'function' === typeof tracker.triggerEvent) {
	                    tracker.triggerEvent({
	                        category: 'interact',
	                        action: 'vote'
	                    });
	                }
	            };
	
	            Fetcher.PostForm(url, param, callback);
	        }
	    }]);
	    return Vote;
	}();


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {if(!global["_scope"]) global["_scope"] = {};
	module.exports = global["_scope"]["Signup"] = __webpack_require__(176);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	var _stringify = __webpack_require__(139);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(110);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(111);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _config = __webpack_require__(117);
	
	var _captcha = __webpack_require__(177);
	
	var _browser = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var Signup = function () {
	    function Signup(_ref) {
	        var actHashId = _ref.actHashId,
	            tracker = _ref.tracker,
	            privacyUrl = _ref.privacyUrl;
	        (0, _classCallCheck3["default"])(this, Signup);
	
	        _scope.Feature.EventBus(this);
	
	        this.actHashId = actHashId;
	        this.tracker = tracker;
	        this.smsTimer = null;
	        this.privacyUrl = privacyUrl;
	        this.config = null;
	        this._rop();
	        this._msgbusDestroy();
	    }
	
	    (0, _createClass3["default"])(Signup, [{
	        key: '_rop',
	        value: function _rop() {
	            rop.On('mudu.questionnaire.live.' + this.actHashId, function (dataStr) {
	                var _JSON$parse = JSON.parse(dataStr),
	                    type = _JSON$parse.type,
	                    data = _JSON$parse.data;
	
	                switch (type) {
	                    case 'question.status':
	                        // 使用状态更新
	                        _scope.MsgBus.Pub('Signup.Status.Change', (0, _stringify2["default"])(data));
	                        break;
	                    default:
	                        break;
	                }
	            });
	        }
	    }, {
	        key: '_msgbusDestroy',
	        value: function _msgbusDestroy() {
	            var _this = this;
	
	            this.destroyKey = _scope.MsgBus.Sub('Destroy', function () {
	                rop.Remove('mudu.questionnaire.live.' + _this.actHashId);
	                _scope.MsgBus.UnSubAll('Signup.Status.Change');
	
	                _scope.MsgBus.UnSub(_this.destroyKey);
	            });
	        }
	
	        /**
	         * 停止监听ws消息
	         */
	
	    }, {
	        key: 'UnSubSignTopics',
	        value: function UnSubSignTopics() {
	            rop.Remove('mudu.questionnaire.live.' + this.actHashId);
	        }
	
	        /**
	         * 获取当前正在使用的问卷(包含前置问卷和内置问卷)
	         */
	
	    }, {
	        key: 'GetUsingSignup',
	        value: function GetUsingSignup(cb) {
	            var _self = this;
	            Fetcher.Get(_config.API_DOMAIN + '/questionnaire/api/v1/activities/' + this.actHashId + '/source/live/question', function (data) {
	                data = JSON.parse(data);
	                if (data.errcode === 1000) {
	                    data.page_before = _self._formatSignupArr(data.page_before);
	                    data.page_in = _self._formatSignupArr(data.page_in);
	                    // add pricacy_url to every signup
	                    if (data.page_before) {
	                        data.page_before = data.page_before.map(function (question) {
	                            question.privacy_url = _self.privacyUrl;
	                            return question;
	                        });
	                    }
	                    if (data.page_in) {
	                        data.page_in = data.page_in.map(function (question) {
	                            question.privacy_url = _self.privacyUrl;
	                            return question;
	                        });
	                    }
	                }
	
	                typeof cb === 'function' && cb((0, _stringify2["default"])(data));
	            }, {
	                'Content-Type': 'application/json'
	            });
	        }
	
	        /**
	         * 提交问卷 答案
	         * @param {*} param0 { signupId code columns }
	         * @param {*} cb 回调函数
	         */
	
	    }, {
	        key: 'SubmitSingup',
	        value: function SubmitSingup(_ref2, cb) {
	            var signupId = _ref2.signupId,
	                code = _ref2.code,
	                columns = _ref2.columns;
	
	            if (typeof signupId !== 'string' && !signupId) {
	                // eslint-disable-next-line
	                console.warn('SubmitSingup 传入的参数 signupId 不是有效string值');
	                return;
	            } else if (!columns || Object.prototype.toString.call(columns) !== '[object Array]' || columns.length === 0) {
	                // eslint-disable-next-line
	                console.warn('SubmitSingup 传入的参数 columns 不是有效值');
	                return;
	            }
	            var _self = this;
	            var phone = '';
	            var nickname = '';
	            columns = columns.map(function (v) {
	                if (v.type === 'phone') {
	                    phone = v.text;
	                } else if (v.type === 'nickname') {
	                    nickname = v.text;
	                }
	                if (v.type === 'question' | v.type === 'questionAnswer') {
	                    return {
	                        type: v.type,
	                        name: v.name,
	                        value: (v.selects || []).join(',') + '||' + (v.text || '')
	                    };
	                } else {
	                    return {
	                        type: v.type,
	                        name: v.name,
	                        value: v.text
	                    };
	                }
	            });
	            Fetcher.Post(_config.API_DOMAIN + '/questionnaire/api/v1/activities/' + this.actHashId + '/source/live/' + signupId, (0, _stringify2["default"])({
	                columns: columns, verify_code: code || ''
	            }), function (data) {
	                typeof cb === 'function' && cb(data);
	                var tracker = _self.tracker;
	                data = JSON.parse(data);
	                if (data.errcode === 1000 && tracker && 'function' === typeof tracker.triggerEvent) {
	                    tracker.triggerEvent({
	                        category: 'interact',
	                        action: 'sign_up'
	                    });
	                    if (phone) {
	                        tracker.triggerEvent({
	                            category: 'interact',
	                            action: 'phone',
	                            label: (0, _stringify2["default"])({ phone: phone, is_verified: false })
	                        });
	                    }
	                    if (nickname) {
	                        _scope.MsgBus.Pub('User.Update');
	                    }
	                }
	            }, {
	                'Content-Type': 'application/json'
	            });
	        }
	
	        /**
	         * 初始化 阿里人机验证
	         * @param {*} param0 
	         */
	
	    }, {
	        key: 'InitCaptcha',
	        value: function InitCaptcha(parmas) {
	            var isH5 = parmas.isH5,
	                width = parmas.width,
	                height = parmas.height,
	                success = parmas.success,
	                fail = parmas.fail,
	                renderTo = parmas.renderTo;
	
	            if (typeof isH5 !== 'boolean' && typeof isH5 !== 'undefined') {
	                // eslint-disable-next-line
	                console.warn('resetCaptcha 传入的参数 isH5 不是boolean值');
	                fail && fail();
	                return;
	            } else if (typeof width !== 'number' || typeof height !== 'number') {
	                // eslint-disable-next-line
	                console.warn('resetCaptcha 传入的参数 width或height 不是number值');
	                fail && fail();
	                return;
	            } else if (typeof success !== 'function') {
	                // eslint-disable-next-line
	                console.warn('resetCaptcha 传入的参数 success 不是function');
	                fail && fail();
	                return;
	            } else if (typeof renderTo !== 'string' && /^#/.test(renderTo)) {
	                // eslint-disable-next-line
	                console.warn('resetCaptcha 传入的参数 renderTo 不正确，应当形如：#yourDomId');
	                fail && fail();
	                return;
	            }
	
	            isH5 = typeof isH5 === 'undefined' ? _browser.isMobile : isH5;
	
	            var _self = this;
	            (0, _captcha.initCaptcha)(parmas, function (resetCaptcha) {
	                _self.ResetCaptcha = resetCaptcha;
	            });
	        }
	
	        // 重置阿里人机校验 会被覆盖重写
	
	    }, {
	        key: 'ResetCaptcha',
	        value: function ResetCaptcha() {
	            // eslint-disable-next-line
	            console.warn('ResetCaptcha 调用出错，请先调用InitCaptcha');
	        }
	    }, {
	        key: '_formatConfig',
	        value: function _formatConfig() {
	            this._hasBeenRemovedLog('_formatConfig');
	        }
	    }, {
	        key: '_formatSignupArr',
	        value: function _formatSignupArr(signupArr) {
	            if (Object.prototype.toString.call(signupArr) === '[object Array]') {
	                return signupArr.map(function (v) {
	                    v.pic.indexOf('http') != 0 && (v.pic = '//mudu.tv' + v.pic);
	                    return v;
	                });
	            }
	            return signupArr;
	        }
	    }, {
	        key: '_startTimer',
	        value: function _startTimer() {
	            var self = this;
	            this.smsTimer = setTimeout(function () {
	                self._clearTimer();
	            }, 50000);
	        }
	    }, {
	        key: '_clearTimer',
	        value: function _clearTimer() {
	            clearTimeout(this.smsTimer);
	            this.smsTimer = null;
	        }
	    }, {
	        key: 'GetConfig',
	        value: function GetConfig() {
	            this._hasBeenRemovedLog('GetConfig');
	            return this.config;
	        }
	    }, {
	        key: 'SendSmsRequest',
	        value: function SendSmsRequest(_ref3, cb) {
	            var signupId = _ref3.signupId,
	                sig = _ref3.sig,
	                sessionId = _ref3.sessionId,
	                token = _ref3.token,
	                phone_number = _ref3.phone_number,
	                isH5 = _ref3.isH5;
	
	            if (typeof signupId !== 'string' && !signupId) {
	                // eslint-disable-next-line
	                console.warn('SendSmsRequest 传入的参数 signupId 不能为空');
	                return;
	            } else if (!sig || !sessionId || !token || typeof isH5 !== 'boolean' && typeof isH5 !== 'undefined') {
	                // eslint-disable-next-line
	                console.warn('SendSmsRequest 传入的参数 sig、sessionId、token、isH5 不能为空或类型不匹配');
	                return;
	            } else if (!phone_number || typeof phone_number !== 'string') {
	                // eslint-disable-next-line
	                console.warn('SendSmsRequest 传入的参数 phone_number 不能为空或类型不匹配');
	                return;
	            } else if (this.timer) {
	                typeof cb === 'function' && cb({
	                    errcode: 5699,
	                    msg: '短信发送频率过高'
	                });
	            }
	
	            isH5 = typeof isH5 === 'undefined' ? _browser.isMobile : isH5;
	            var _self = this;
	            Fetcher.Post(_config.API_DOMAIN + '/questionnaire/api/v1/activities/' + this.actHashId + '/source/live/' + signupId + '/auth_code', (0, _stringify2["default"])({
	                sig: sig, sessionId: sessionId, token: token, phone_number: phone_number, scene: isH5 ? 'ic_message_h5' : 'ic_message'
	            }), function (data) {
	                // eslint-disable-next-line
	                console.log('----->', data);
	                if (data.errcode !== 1000) {
	                    _self._clearTimer();
	                }
	                typeof cb === 'function' && cb(data);
	            }, {
	                'Content-Type': 'application/json'
	            });
	        }
	    }, {
	        key: 'SendSms',
	        value: function SendSms() {
	            this._hasBeenRemovedLog('SendSms');
	        }
	    }, {
	        key: 'Submit',
	        value: function Submit() {
	            this._hasBeenRemovedLog('Submit');
	        }
	    }, {
	        key: '_hasBeenRemovedLog',
	        value: function _hasBeenRemovedLog(fnName) {
	            // eslint-disable-next-line
	            console.warn('您当前使用的' + (fnName || '') + '方法已经被移除，详情参见：http://mudu.tv/api/v1/WEB_SDK/COMPONENT/SIGNUP.html');
	        }
	    }]);
	    return Signup;
	}();
	
	module.exports = Signup;


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	function loadScript(url, callback) {
	    var script = document.createElement('script');
	    script.type = 'text/javascript';
	    if (script.readyState) {
	        //IE
	        script.onreadystatechange = function () {
	            if (script.readyState == 'loaded' || script.readyState == 'complete') {
	                script.onreadystatechange = null;
	                callback();
	            }
	        };
	    } else {
	        //Others
	        script.onload = function () {
	            callback();
	        };
	    }
	    script.src = url;
	    document.getElementsByTagName('head')[0].appendChild(script);
	}
	
	function loadScriptArr(urlArr, callback) {
	    var len = urlArr.length;
	    if (len === 0) {
	        typeof callback === 'function' && callback();
	        return;
	    }
	    var loadedCount = 0;
	    urlArr.map(function (v) {
	        loadScript(v, function () {
	            if (++loadedCount === len) {
	                typeof callback === 'function' && callback();
	            }
	        });
	    });
	}
	
	function loadCaptchaScripts(isH5, callback) {
	    var urlArr = [];
	    if (isH5) {
	        urlArr.push('//g.alicdn.com/mtb/lib-flexible/0.3.4/??flexible_css.js,flexible.js');
	    }
	    urlArr.push('//g.alicdn.com/sd/smartCaptcha/0.0.4/index.js', '//g.alicdn.com/sd/nvc/1.1.112/guide.js', '//g.alicdn.com/sd/quizCaptcha/0.0.1/index.js');
	
	    loadScriptArr(urlArr, callback);
	}
	
	function initCaptcha(_ref, resetReceiver) {
	    var isH5 = _ref.isH5,
	        width = _ref.width,
	        height = _ref.height,
	        _success = _ref.success,
	        _fail = _ref.fail,
	        renderTo = _ref.renderTo;
	
	    window.NVC_Opt = {
	        //应用类型标识。它和使用场景标识（scene字段）一起决定了智能验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
	        appkey: 'FFFF0N000000000076F1',
	        //使用场景标识。它和应用类型标识（appkey字段）一起决定了智能验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的scene值，请务必正确填写。
	        scene: isH5 ? 'ic_message_h5' : 'ic_message',
	        //声明二次验证需要渲染的目标元素ID。
	        renderTo: renderTo,
	        //当唤醒刮刮卡验证作为二次验证时，配置需要刮出的两个elements的图片资源。
	        elements: ['//img.alicdn.com/tfs/TB17cwllsLJ8KJjy0FnXXcFDpXa-50-74.png', '//img.alicdn.com/tfs/TB17cwllsLJ8KJjy0FnXXcFDpXa-50-74.png'],
	        //当唤醒刮刮卡验证作为二次验证时，配置刮动时的背景图像（自动应用平铺填充的方式）。
	        bg_back_prepared: '//img.alicdn.com/tps/TB1skE5SFXXXXb3XXXXXXXXXXXX-100-80.png',
	        //当唤醒刮刮卡验证作为二次验证时，配置刮动时的前景图像（仅支持base64数据流）。
	        bg_front: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABQCAMAAADY1yDdAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURefk5w+ruswAAAAfSURBVFjD7cExAQAAAMKg9U9tCU+gAAAAAAAAAIC3AR+QAAFPlUGoAAAAAElFTkSuQmCC',
	        //当唤醒刮刮卡验证作为二次验证时，配置验证通过时显示的图标资源。
	        obj_ok: '//img.alicdn.com/tfs/TB1rmyTltfJ8KJjy0FeXXXKEXXa-50-74.png',
	        //当唤醒刮刮卡验证作为二次验证时，配置验证通过时显示的背景图像（自动应用平铺填充的方式）。
	        bg_back_pass: '//img.alicdn.com/tfs/TB1KDxCSVXXXXasXFXXXXXXXXXX-100-80.png',
	        //当唤醒刮刮卡验证作为二次验证时，配置验证失败或异常时显示的图标资源。
	        obj_error: '//img.alicdn.com/tfs/TB1q9yTltfJ8KJjy0FeXXXKEXXa-50-74.png',
	        //当唤醒刮刮卡验证作为二次验证时，配置验证失败或异常时显示的背景图像（自动应用平铺填充的方式）。
	        bg_back_fail: '//img.alicdn.com/tfs/TB1w2oOSFXXXXb4XpXXXXXXXXXX-100-80.png',
	        //当唤醒刮刮卡验证作为二次验证时，用于自定义文案。详细配置方法请参见自定义文案文档。
	        upLang: { 'cn': {
	                _ggk_guide: '请摁住鼠标左键，刮出两面盾牌',
	                _ggk_success: '恭喜您成功刮出盾牌<br/>继续下一步操作吧',
	                _ggk_loading: '加载中',
	                _ggk_fail: ['呀，盾牌不见了<br/>请', 'javascript:noCaptcha.reset()', '再来一次', '或', 'http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN', '反馈问题'],
	                _ggk_action_timeout: ['我等得太久啦<br/>请', 'javascript:noCaptcha.reset()', '再来一次', '或', 'http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN', '反馈问题'],
	                _ggk_net_err: ['网络实在不给力<br/>请', 'javascript:noCaptcha.reset()', '再来一次', '或', 'http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN', '反馈问题'],
	                _ggk_too_fast: ['您刮得太快啦<br/>请', 'javascript:noCaptcha.reset()', '再来一次', '或', 'http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN', '反馈问题']
	            }
	        }
	    };
	    loadCaptchaScripts(isH5, function () {
	        // eslint-disable-next-line
	        var ic = new smartCaptcha({
	            //声明智能验证需要渲染的目标元素ID。
	            renderTo: renderTo,
	            //智能验证组件的宽度。
	            width: width,
	            //智能验证组件的高度。
	            height: height,
	            //智能验证组件初始状态文案。
	            default_txt: '点击按钮开始智能验证',
	            //智能验证组件验证通过状态文案。
	            success_txt: '验证成功',
	            //智能验证组件验证失败（拦截）状态文案。
	            fail_txt: '验证失败，请在此点击按钮刷新',
	            //智能验证组件验证中状态文案。
	            scaning_txt: '智能检测中',
	            //前端智能验证通过时会触发该回调参数。您可以在该回调参数中将请求标识（token）、会话ID（sessionid）、签名串（sig）字段记录下来，随业务请求一同发送至您的服务端调用验签。
	            success: function success(data) {
	                _success && _success({
	                    token: window.NVC_Opt.token,
	                    sessionId: data.sessionId,
	                    sig: data.sig
	                });
	            },
	            fail: function fail() {
	                _fail && _fail();
	            }
	        });
	        ic.init();
	        typeof resetReceiver === 'function' && resetReceiver(ic.reset.bind(ic));
	    });
	}
	
	module.exports = {
	    initCaptcha: initCaptcha
	};


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {if(!global["_scope"]) global["_scope"] = {};
	module.exports = global["_scope"]["Signin"] = __webpack_require__(179);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	var _extends2 = __webpack_require__(103);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(139);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(110);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(111);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _config = __webpack_require__(117);
	
	var _jquery = __webpack_require__(11);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var Signin = function () {
	    function Signin(_ref) {
	        var actHashId = _ref.actHashId;
	        (0, _classCallCheck3["default"])(this, Signin);
	
	        _scope.Feature.EventBus(this);
	
	        this.actHashId = actHashId;
	        this._rop();
	        this._msgbusDestroy();
	    }
	
	    (0, _createClass3["default"])(Signin, [{
	        key: '_rop',
	        value: function _rop() {
	            var _this = this;
	
	            this.unsubComment = nats.on('mudu.comments.' + this.actHashId, function (dataStr) {
	                var _JSON$parse = JSON.parse(dataStr),
	                    action = _JSON$parse.action,
	                    service_type = _JSON$parse.service_type,
	                    content = _JSON$parse.content;
	
	                if (service_type === 'sign') {
	                    if (action === 'config') {
	                        _this.Get();
	                    } else if (action === 'close') {
	                        var hash_id = content.hash_id,
	                            is_open = content.is_open,
	                            is_forced = content.is_forced,
	                            start_at = content.start_at,
	                            end_at = content.end_at,
	                            now_time = content.now_time;
	
	                        var res = {
	                            id: hash_id,
	                            is_open: is_open,
	                            is_forced: is_forced,
	                            is_sign: is_open,
	                            start_time: start_at,
	                            end_time: end_at,
	                            server_time: now_time
	                        };
	                        var response = {
	                            errcode: 1000,
	                            msg: 'ok',
	                            data: res
	                        };
	                        _scope.MsgBus.Pub('Signin.Close', (0, _stringify2["default"])(response));
	                    }
	                }
	            });
	        }
	    }, {
	        key: '_msgbusDestroy',
	        value: function _msgbusDestroy() {
	            var _this2 = this;
	
	            this.destroyKey = _scope.MsgBus.Sub('Destroy', function () {
	                // rop.Remove('mudu.comments.' + this.actHashId);
	                _this2.unsubComment();
	
	                _scope.MsgBus.UnSub(_this2.destroyKey);
	            });
	        }
	    }, {
	        key: 'UnSubSigninTopic',
	        value: function UnSubSigninTopic() {
	            // rop.Remove('mudu.comments.' + this.actHashId);
	            this.unsubComment();
	        }
	        /**
	        * 初始化获取签到配置 
	        */
	
	    }, {
	        key: 'Get',
	        value: function Get(callback) {
	            try {
	                var url = _config.API_DOMAIN_V2 + '/v2/watch/' + this.actHashId + '/interact/signup/view/config';
	                Fetcher.Get(url, function (data) {
	                    data = JSON.parse(data);
	                    // console.log(data,'----api');
	                    if (data.errcode === 1000) {
	                        var res = (0, _extends3["default"])({}, data.data, { is_sign: data.is_sign });
	                        var response = {
	                            errcode: data.errcode,
	                            msg: data.msg,
	                            data: res
	                        };
	                        _scope.MsgBus.Pub('Signin.Config', (0, _stringify2["default"])(response));
	                        callback && callback((0, _stringify2["default"])(response));
	                    }
	                }, _scope.DB.Get('requestHeader').session);
	            } catch (e) {
	                var res = { 'errcode': -1, msg: '获取签到配置,稍后再试!' };
	                callback && callback((0, _stringify2["default"])(res));
	            }
	        }
	        /**
	        * 签到动作
	        */
	
	    }, {
	        key: 'Send',
	        value: function Send(signId, callback) {
	            try {
	                var url = _config.API_DOMAIN_V2 + '/v2/watch/' + this.actHashId + '/interact/signup/watch/sign?id=' + signId;
	                Fetcher.Post(url, {}, function (data) {
	                    data = JSON.parse(data);
	                    // console.log(data,'---send---');
	                    if (data.errcode === 1000) {
	                        _scope.MsgBus.Pub('Signin.Result', (0, _stringify2["default"])(data));
	                        callback && callback((0, _stringify2["default"])(data));
	                        return;
	                    }
	                    _scope.MsgBus.Pub('Signin.Result', (0, _stringify2["default"])(data));
	                }, (0, _extends3["default"])({ 'Content-Type': 'application/x-www-form-urlencoded' }, _scope.DB.Get('requestHeader').session));
	            } catch (e) {
	                var res = { 'errcode': -1, msg: '签到失败,稍后再试!' };
	                callback && callback((0, _stringify2["default"])(res));
	            }
	        }
	
	        // 签到签 要登陆（使用身份赋予获取用户登陆信息）
	
	    }, {
	        key: 'Assign',
	        value: function Assign() {
	            (0, _jquery2["default"])('#assign-username-btn').on('click', function () {
	                // const username = $('#assign-username').val();
	                // Mudu.Room.User.Assign(username || '新身份websdk', 'https://myun-hw-s3.myun.tv/melj80jz/lg4xz3x2/IMG_2839.jpg', String(Date.now()), user => {
	                //     // console.log('user assign cb:', user);
	                // });
	            });
	        }
	    }]);
	    return Signin;
	}();
	
	module.exports = Signin;


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {if(!global["_scope"]) global["_scope"] = {};
	module.exports = global["_scope"]["Topic"] = __webpack_require__(181);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	var _assign = __webpack_require__(104);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _typeof2 = __webpack_require__(148);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _stringify = __webpack_require__(139);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(110);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(111);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var config = __webpack_require__(117);
	
	var topicCodeMap = {
	    100: '发送成功',
	    102: '管理员禁止发布话题',
	    103: '该用户被禁言',
	    104: '不允许匿名发表话题',
	    105: '内容和图片不能同时为空',
	    106: '管理员禁止回复'
	};
	
	var defaultOption = {
	    'topicType': '1' // 獲取已審核內容
	};
	
	var pageSizeWhenFetchTopicList = 10;
	
	var Topic = function () {
	    function Topic(_ref) {
	        var act_id = _ref.act_id,
	            topic_visitor_publish = _ref.topic_visitor_publish,
	            topic_needs_check = _ref.topic_needs_check,
	            topic_allow_reply = _ref.topic_allow_reply,
	            topic_count_num = _ref.topic_count_num,
	            tracker = _ref.tracker;
	        (0, _classCallCheck3["default"])(this, Topic);
	
	        _scope.Feature.EventBus(this);
	
	        this.topic_visitor_publish = !!topic_visitor_publish;
	        this.topic_needs_check = !!topic_needs_check;
	        this.topic_allow_reply = !!topic_allow_reply;
	        this.act_id = act_id;
	        this.tracker = tracker;
	
	        this.SetCount(topic_count_num || 0);
	
	        this._rop();
	        this._msgbusDestroy();
	    }
	
	    (0, _createClass3["default"])(Topic, [{
	        key: '_rop',
	        value: function _rop() {
	            var _this = this;
	
	            rop.On('topic-' + this.act_id, function (data) {
	                _scope.MsgBus.Pub('Topic.New', (0, _stringify2["default"])(_this._filterTopicReplies(JSON.parse(data))));
	            });
	
	            rop.On('topic_set_top_' + this.act_id, function (data) {
	                _scope.MsgBus.Pub('Topic.Top', (0, _stringify2["default"])(_this._filterTopicReplies(JSON.parse(data))));
	            });
	
	            rop.On('topic_allow_reply_' + this.act_id, function (data) {
	                var status = JSON.parse(data).status;
	                _this.topic_allow_reply = !!status;
	                _scope.MsgBus.Pub('Topic.AllowReply', _this.topic_allow_reply);
	            });
	
	            rop.On('topic_visitor_publish_' + this.act_id, function (data) {
	                var status = JSON.parse(data).status;
	                _this.topic_visitor_publish = !!status;
	                _scope.MsgBus.Pub('Topic.AllowPublish', _this.topic_visitor_publish);
	            });
	
	            rop.On('topic_needs_check_' + this.act_id, function (data) {
	                var status = JSON.parse(data).status;
	                _this.topic_needs_check = !!status;
	                _scope.MsgBus.Pub('Topic.NeedsCheck', _this.topic_needs_check);
	            });
	
	            rop.On('topic-reply-' + this.act_id, function (data) {
	                _scope.MsgBus.Pub('Topic.Reply.New', data);
	            });
	
	            rop.On('topic_del_' + this.act_id, function (data) {
	                _scope.MsgBus.Pub('Topic.Delete', data);
	            });
	        }
	    }, {
	        key: '_msgbusDestroy',
	        value: function _msgbusDestroy() {
	            var _this2 = this;
	
	            this.destroyKey = _scope.MsgBus.On('Destroy', function () {
	                rop.Remove('topic-' + _this2.act_id);
	                _scope.MsgBus.UnSubAll('Topic.New');
	                rop.Remove('topic_set_top_' + _this2.act_id);
	                _scope.MsgBus.UnSubAll('Topic.Top');
	                rop.Remove('topic_allow_reply_' + _this2.act_id);
	                _scope.MsgBus.UnSubAll('Topic.AllowReply');
	                rop.Remove('topic_visitor_publish_' + _this2.act_id);
	                _scope.MsgBus.UnSubAll('Topic.AllowPublish');
	                rop.Remove('topic_needs_check_' + _this2.act_id);
	                _scope.MsgBus.UnSubAll('Topic.NeedsCheck');
	                rop.Remove('topic-reply-' + _this2.act_id);
	                _scope.MsgBus.UnSubAll('Topic.Reply.New');
	                rop.Remove('topic_del_' + _this2.act_id);
	                _scope.MsgBus.UnSubAll('Topic.Delete');
	
	                _scope.MsgBus.UnSub('Destroy', _this2.destroyKey);
	            });
	        }
	    }, {
	        key: 'UnSubTopics',
	        value: function UnSubTopics() {
	            rop.Remove('topic-' + this.act_id);
	            rop.Remove('topic_set_top_' + this.act_id);
	            rop.Remove('topic_allow_reply_' + this.act_id);
	            rop.Remove('topic_visitor_publish_' + this.act_id);
	            rop.Remove('topic_needs_check_' + this.act_id);
	            rop.Remove('topic-reply-' + this.act_id);
	            rop.Remove('topic_del_' + this.act_id);
	        }
	    }, {
	        key: '_filterTopicReplies',
	        value: function _filterTopicReplies(topic) {
	            var selfVisitorId = _scope.DB.Get('UserInfo').id;
	            topic.replies = (topic.replies || []).filter(function (v) {
	                return !(!v.checked && selfVisitorId != v.visitor_id);
	            });
	            return topic;
	        }
	    }, {
	        key: 'SendTopic',
	        value: function SendTopic() {
	            var _this3 = this;
	
	            var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            var cb = arguments[1];
	
	            if (!obj.msg && (!obj.images || !obj.images.length)) {
	                return;
	            }
	            obj.msg = obj.msg || '';
	            obj.images = obj.images || [];
	
	            var url = config.API_DOMAIN + '/activity/' + this.act_id + '/setTopic';
	            var param = {
	                // visitor_id:  _scope.Utils.GetCookie('visitorId'),
	                // avatar:  _scope.Utils.GetCookie('avatar'),
	                // username:  _scope.Utils.GetCookie('user'),
	                images: obj.images.join(','),
	                message: obj.msg
	            };
	            var callback = function callback(response) {
	                var res = JSON.parse(response);
	                if (typeof cb === 'function') {
	                    cb((0, _stringify2["default"])({
	                        status: res.status,
	                        flag: res.flag,
	                        info: topicCodeMap[res.flag] || '',
	                        hasBadWord: res.hasBadWord,
	                        word: res.word,
	                        topicNeedsChecked: res.topicNeedsChecked
	                    }));
	                }
	                var tracker = _this3.tracker;
	                if (tracker && 'function' === typeof tracker.triggerEvent && res.flag == 100) {
	                    tracker.triggerEvent({
	                        category: 'interact',
	                        action: 'topic'
	                    });
	                }
	            };
	            Fetcher.Post(url, (0, _stringify2["default"])(param), callback, { 'Content-Type': 'application/json' });
	        }
	    }, {
	        key: 'SendReply',
	        value: function SendReply() {
	            var _this4 = this;
	
	            var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            var cb = arguments[1];
	
	            if (!obj.topicId || !obj.msg) {
	                return;
	            }
	            var url = config.API_DOMAIN + '/activity/' + this.act_id + '/setTopic';
	            var param = {
	                belong_to: +obj.topicId,
	                // visitor_id:  _scope.Utils.GetCookie('visitorId'),
	                // avatar:  _scope.Utils.GetCookie('avatar'),
	                // username:  _scope.Utils.GetCookie('user'),
	                message: obj.msg
	            };
	            var callback = function callback(response) {
	                var res = JSON.parse(response);
	                if (typeof cb === 'function') {
	                    cb((0, _stringify2["default"])({
	                        status: res.status,
	                        flag: res.flag,
	                        info: topicCodeMap[res.flag] || '',
	                        hasBadWord: res.hasBadWord,
	                        word: res.word,
	                        topicNeedsChecked: res.topicNeedsChecked
	                    }));
	                }
	                var tracker = _this4.tracker;
	                if (tracker && 'function' === typeof tracker.triggerEvent && res.flag == 100) {
	                    tracker.triggerEvent({
	                        category: 'interact',
	                        action: 'topic'
	                    });
	                }
	            };
	            Fetcher.Post(url, (0, _stringify2["default"])(param), callback, { 'Content-Type': 'application/json' });
	        }
	    }, {
	        key: 'Get',
	        value: function Get(pageId, options, cb) {
	            cb = typeof options === 'function' ? options : cb;
	            options = (typeof options === 'undefined' ? 'undefined' : (0, _typeof3["default"])(options)) === 'object' ? (0, _assign2["default"])({}, defaultOption, options) : defaultOption;
	            this._get(pageId, options, cb);
	        }
	    }, {
	        key: '_get',
	        value: function _get(pageId, options, cb) {
	            var _this5 = this;
	
	            if (!+pageId) {
	                return;
	            }
	            var url = config.API_DOMAIN + '/activity/' + this.act_id + '/getTopic';
	
	            var param = {
	                topicType: options.topicType, //'1'已审核；'0'未审核；'all'全部
	                pageSize: pageSizeWhenFetchTopicList,
	                pageIndex: +pageId || 1
	            };
	
	            var callback = function callback(response) {
	                var res = JSON.parse(response);
	                if (Object.prototype.toString.call(res.topics) === '[object Array]') {
	                    res.topics = res.topics.map(function (v) {
	                        return _this5._filterTopicReplies(v);
	                    });
	                }
	                if (typeof cb === 'function') {
	                    cb((0, _stringify2["default"])(res));
	                }
	            };
	            Fetcher.Post(url, (0, _stringify2["default"])(param), callback, { 'Content-Type': 'application/json' });
	        }
	    }, {
	        key: 'GetAllowReply',
	        value: function GetAllowReply() {
	            return this.topic_allow_reply;
	        }
	    }, {
	        key: 'GetAllowPublish',
	        value: function GetAllowPublish() {
	            return this.topic_visitor_publish;
	        }
	    }, {
	        key: 'GetNeedsCheck',
	        value: function GetNeedsCheck() {
	            return this.topic_needs_check;
	        }
	    }, {
	        key: 'SetCount',
	        value: function SetCount(count) {
	            this.count = count;
	            this.page = Math.ceil(count / pageSizeWhenFetchTopicList);
	        }
	    }, {
	        key: 'GetPage',
	        value: function GetPage() {
	            return this.page;
	        }
	    }]);
	    return Topic;
	}();
	
	module.exports = Topic;


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {if(!global["_scope"]) global["_scope"] = {};
	module.exports = global["_scope"]["Redpack"] = __webpack_require__(183);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	var _stringify = __webpack_require__(139);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(110);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(111);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var config = __webpack_require__(117);
	var browser = __webpack_require__(15);
	
	var Redpack = function () {
	    function Redpack() {
	        (0, _classCallCheck3["default"])(this, Redpack);
	
	        _scope.Feature.Room(this);
	        _scope.Feature.EventBus(this);
	    }
	
	    (0, _createClass3["default"])(Redpack, [{
	        key: '_canSnatch',
	        value: function _canSnatch(type) {
	            if (type == 1) {
	                if (!browser.isMobileWechat()) {
	                    return {
	                        status: 'n',
	                        flag: 101,
	                        info: '当前红包为微信红包，只有在手机微信中才能抢红包'
	                    };
	                }
	                if (!_scope.Utils.GetCookie('openId')) {
	                    return {
	                        status: 'n',
	                        flag: 102,
	                        info: '当前红包为微信红包，需要先进行微信登录才能抢红包'
	                    };
	                }
	                return {
	                    status: 'y',
	                    flag: 100,
	                    info: '当前红包可抢'
	                };
	            }
	            if (type == 2) {
	                if (!browser.isDingding()) {
	                    return {
	                        status: 'n',
	                        flag: 103,
	                        info: '当前红包为钉钉红包，只有在钉钉中才能抢红包'
	                    };
	                }
	
	                if (!_scope.Utils.GetCookie('openId')) {
	                    return {
	                        status: 'n',
	                        flag: 104,
	                        info: '当前红包为钉钉红包，需要先进行钉钉登录才能抢红包'
	                    };
	                }
	
	                return {
	                    status: 'y',
	                    flag: 100,
	                    info: '当前红包可抢'
	                };
	            }
	
	            return {
	                status: 'n',
	                flag: 105,
	                info: '红包类型未知'
	            };
	        }
	    }, {
	        key: 'GetRedpackStatus',
	        value: function GetRedpackStatus(hashid, cb) {
	            var openId = _scope.Utils.GetCookie('openId');
	            var param = { openId: openId, redpackHashid: hashid };
	            var callback = function callback(data) {
	                data = JSON.parse(data);
	                var cbData = { status: data.status, flag: data.flag, info: data.msg, data: { amount: data.amount, snatched: data.snatched } };
	                typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
	            };
	            Fetcher.PostForm(config.REDPACK_STATUS_URL, param, callback);
	        }
	    }, {
	        key: 'GetRedpackRecord',
	        value: function GetRedpackRecord(hashid, cb) {
	            var param = { redpackHashid: hashid };
	            var callback = function callback(data) {
	                data = JSON.parse(data);
	                var cbData = { status: data.status, flag: data.flag, info: data.msg, data: { redpack: data.redpack, snatch_list: data.data } };
	                typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
	            };
	            Fetcher.PostForm(config.REDPACK_RECORD_URL, param, callback);
	        }
	    }, {
	        key: 'SnatchRedpack',
	        value: function SnatchRedpack(hashid, cb) {
	            var param = {
	                redpackHashid: hashid,
	                snatcherOpenId: _scope.Utils.GetCookie('openId'),
	                snatcherAvatar: _scope.Utils.GetCookie('avatar'),
	                snatcherName: _scope.Utils.GetCookie('user')
	            };
	            var callback = function callback(data) {
	                data = JSON.parse(data);
	                var cbData = { status: data.status, flag: data.flag, info: data.msg, data: { amount: data.amount, redpack_id: data.redpack_id } };
	                typeof cb === 'function' && cb((0, _stringify2["default"])(cbData));
	            };
	            Fetcher.PostForm(config.REDPACK_SNATCH_URL, param, callback);
	        }
	    }, {
	        key: 'ParseRedpackComment',
	        value: function ParseRedpackComment(comment) {
	            var div = document.createElement('div');
	            div.innerHTML = comment.message;
	            var envoDom = div.getElementsByTagName('div')[0];
	            if (!envoDom) {
	                return { status: 'n', flag: 101, info: '当前评论不是红包评论' };
	            }
	            var id = envoDom.getAttribute('data-id');
	            var type = +envoDom.getAttribute('data-type');
	            var wishes = envoDom.getAttribute('data-wishes');
	            var name = envoDom.getAttribute('data-name');
	            if (!id) {
	                return { status: 'n', flag: 102, info: '找不到红包hashid' };
	            }
	            var canSnatch = this._canSnatch(type);
	            return {
	                status: 'y',
	                flag: 100,
	                info: '解析红包信息成功',
	                data: {
	                    redpack: {
	                        type: type, wishes: wishes, name: name,
	                        hashid: id
	                    },
	                    can_snatch: canSnatch
	                }
	            };
	        }
	    }]);
	    return Redpack;
	}();
	
	module.exports = Redpack;


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {if(!global["_scope"]) global["_scope"] = {};
	module.exports = global["_scope"]["Reward"] = __webpack_require__(185);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	var _extends2 = __webpack_require__(103);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(139);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(110);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(111);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var browser = __webpack_require__(15);
	var config = __webpack_require__(117);
	
	var Reward = function () {
	    function Reward(_ref) {
	        var jsonObj = _ref.jsonObj,
	            Room = _ref.Room;
	        (0, _classCallCheck3["default"])(this, Reward);
	
	        this.donateTimes = +jsonObj.donateTimes || 0;
	        this.cash_donate_id = jsonObj.act.cash_donate_id;
	        this.donate_type = jsonObj.act.donate_type;
	        this.reward_config = jsonObj.act.gift_config;
	        this.gifts = jsonObj.act.gifts || [];
	        this.cash_config = { id: this.cash_donate_id };
	        this.cash_record_list = [];
	        this.act_id = jsonObj.act.id;
	        this.freeGiftLock = false;
	
	        this.Room = Room;
	
	        this.isSetType = [];
	        jsonObj.issetNetbank && this.isSetType.push('netbank');
	        jsonObj.issetAlipay && this.isSetType.push('alipay');
	        jsonObj.issetWeixinPay && this.isSetType.push('weixin');
	
	        this._getCashConfig();
	        this._ropOnCashDonateMessage();
	        this._ropOnGiftDonateMessage();
	        this._ropOnGiftSend();
	        this._msgbusDestroy();
	    }
	
	    (0, _createClass3["default"])(Reward, [{
	        key: '_msgbusDestroy',
	        value: function _msgbusDestroy() {
	            var _this = this;
	
	            this.destroyKey = _scope.MsgBus.On('Destroy', function () {
	                _scope.MsgBus.UnSubAll('Reward.CashConfig.Changed');
	                _scope.MsgBus.UnSubAll('Reward.CashRecord.Changed');
	
	                rop.Remove('cash_donate_' + _this.cash_donate_id);
	                _scope.MsgBus.UnSubAll('Reward.CashPay.Result');
	
	                rop.Remove('cash_PropPay_' + _this.act_id);
	                _scope.MsgBus.UnSubAll('Reward.GiftPay.Result');
	
	                _this.gifts.map(function (v) {
	                    rop.Remove('act_gift_send_' + v.id);
	                });
	                _scope.MsgBus.UnSubAll('Reward.Gift.Sended');
	                _scope.MsgBus.UnSubAll('Reward.GiftFree.Result');
	
	                _scope.MsgBus.UnSub(_this.destroyKey);
	            });
	        }
	    }, {
	        key: '_objToArray',
	        value: function _objToArray(obj) {
	            var ret = [];
	            if (!obj) {
	                return ret;
	            }
	            for (var key in obj) {
	                ret.push(obj[key]);
	            }
	            return ret;
	        }
	    }, {
	        key: '_getCashConfig',
	        value: function _getCashConfig() {
	            var _this2 = this;
	
	            if (this.cash_donate_id) {
	                var data = { donateId: this.cash_donate_id };
	                Fetcher.PostForm(config.CASH_DONATE_DETAIL_URL, data, function (res) {
	                    res = JSON.parse(res);
	                    _this2.cash_config.accounce_image = res.accounce_image;
	                    _this2.cash_config.accounce_word = res.accounce_word;
	                    _this2.cash_config.lowest = res.lowest;
	                    _this2.cash_config.showAmount = res.showAmount;
	                    _this2.cash_config.totalSum = res.totalSum;
	                    _this2.cash_config.userNum = res.userNum;
	                    _this2.cash_record_list = _this2._objToArray(res.detail);
	
	                    _scope.MsgBus.Pub('Reward.CashConfig.Changed', JSON.parse((0, _stringify2["default"])(_this2.cash_config)));
	                    _scope.MsgBus.Pub('Reward.CashRecord.Changed', JSON.parse((0, _stringify2["default"])(_this2.cash_record_list)));
	                });
	            }
	        }
	    }, {
	        key: '_ropOnCashDonateMessage',
	        value: function _ropOnCashDonateMessage() {
	            var _this3 = this;
	
	            if (this.cash_donate_id) {
	                rop.On('cash_donate_' + this.cash_donate_id, function (data) {
	                    data = JSON.parse(data);
	
	                    if (data.tradeId && data.visitorId == _scope.DB.Get('UserInfo').id) {
	                        _scope.MsgBus.Pub('Reward.CashPay.Result', { status: 'y', flag: 100, info: '支付成功' });
	                    }
	
	                    _this3._getCashConfig();
	                });
	            }
	        }
	    }, {
	        key: '_ropOnGiftDonateMessage',
	        value: function _ropOnGiftDonateMessage() {
	            // 用户礼物打赏成功或失败
	            rop.On('cash_PropPay_' + this.act_id, function (data) {
	                data = JSON.parse(data);
	
	                // tradeId存在才是付费打赏，否则是免费打赏
	                if (data.tradeId && data.visitorId == _scope.DB.Get('UserInfo').id) {
	                    _scope.MsgBus.Pub('Reward.GiftPay.Result', { status: 'y', flag: 100, info: '支付成功' });
	                }
	            });
	        }
	    }, {
	        key: '_ropOnGiftSend',
	        value: function _ropOnGiftSend() {
	            var _this4 = this;
	
	            this.gifts.map(function (v, i) {
	                // 监听是否有人送礼物
	                rop.On('act_gift_send_' + v.id, function (data) {
	                    data = JSON.parse(data);
	
	                    // 打赏次数+1
	                    _this4.donateTimes++;
	                    _this4.gifts[i].recv_times++;
	                    _this4.gifts[i].recv_num = +_this4.gifts[i].recv_num + +data.num;
	
	                    _scope.MsgBus.Pub('Reward.Gift.Sended', { gift_id: v.id, num: +data.num });
	                });
	            });
	        }
	    }, {
	        key: '_getCashDonateUrl',
	        value: function _getCashDonateUrl(obj) {
	            // var userInfo = _scope.DB.Get('UserInfo');
	            // var user = userInfo.user;
	            // var avatar = userInfo.avatar;
	            // var visitorId = userInfo.id;
	            var url = this.Room.domain + config.RELATIVE_DONATE_URL + '&channel=' + obj.payType + '&donate_id=' + obj.donate_id + '&donate_num=' + obj.donate_num + '&act_id=' + this.act_id + ('&t=' + new Date().getTime());
	
	            obj.payType == 'weixin' && !browser.isMobile() && (url += '&payType=native');
	
	            url += '&phone=' + (obj.phone || '');
	            return url;
	        }
	    }, {
	        key: '_getGiftDonateUrl',
	        value: function _getGiftDonateUrl(obj) {
	            // var userInfo = _scope.DB.Get('UserInfo');
	            // var user = userInfo.user;
	            // var avatar = userInfo.avatar;
	            // var visitorId = userInfo.id;
	            var url = this.Room.domain + config.RELATIVE_DONATE_URL + '&channel=' + obj.payType + '&gift_id=' + obj.gift_id + '&num=' + obj.num + '&act_id=' + this.act_id + ('&t=' + new Date().getTime() + '&referer=' + encodeURIComponent(window.location.href));
	
	            obj.payType == 'weixin' && !browser.isMobile() && (url += '&payType=native');
	
	            url += '&phone=' + (obj.phone || '');
	
	            return url;
	        }
	
	        // 根据不同的url和paytype做不同的处理：调用原生支付、跳转支付等等
	
	    }, {
	        key: '_resolvePayUrl',
	        value: function _resolvePayUrl(url, payType, evt) {
	            // console.log(url, payType, evt);
	            if (!browser.isMobile()) {
	                // pc端
	
	                if (payType == 'weixin') {
	                    // 微信扫码支付，不做处理
	                } else {
	                    // 支付宝、银联链接跳转支付
	                    window.open(url);
	                }
	            } else {
	                // 移动端
	
	                if (payType == 'weixin' && browser.isWechat()) {
	                    // 微信原生支付
	                    if (!_scope.Utils.GetCookie('openId')) {
	                        _scope.MsgBus.Pub(evt, { status: 'n', flag: 101, info: '微信支付找不到openId, 请先进行微信登录或者使用扫码支付替代', data: { url: url + '&payType=native' } });
	                    } else {
	                        this._resolveWeixinPay(url, evt);
	                    }
	                }
	
	                if (payType == 'alipay') {
	                    if (browser.isDingding()) {
	                        // 钉钉支付宝原生支付
	                        this._resolveDingdingAlipay(url, evt);
	                    } else {
	                        // 非钉钉的支付宝支付: 链接跳转
	                        window.open(url);
	                    }
	                }
	            }
	
	            return url;
	        }
	    }, {
	        key: '_resolveDingdingAlipay',
	        value: function _resolveDingdingAlipay(url, evt) {
	            Fetcher.Get(url + '&payType=native&type=mobile', function (res) {
	                dd.biz.alipay.pay({
	                    data: res,
	                    onSuccess: function onSuccess() {
	                        _scope.MsgBus.Pub(evt, { status: 'y', flag: 100, info: '支付成功' });
	                    },
	                    onFail: function onFail(err) {
	                        _scope.MsgBus.Pub(evt, { status: 'n', flag: 103, info: '钉钉支付宝原生支付失败', data: { error: err } });
	                    }
	                });
	            });
	        }
	    }, {
	        key: '_resolveWeixinPay',
	        value: function _resolveWeixinPay(url, evt) {
	            var _this5 = this;
	
	            Fetcher.Get(url, function (res) {
	                res = JSON.parse(res);
	                if (typeof WeixinJSBridge == 'undefined') {
	                    var cb = function cb() {
	                        return _this5._resolveWeixinPaySdk(res, url, evt);
	                    };
	                    if (document.addEventListener) {
	                        document.addEventListener('WeixinJSBridgeReady', cb, false);
	                    } else {
	                        document.attachEvent('WeixinJSBridgeReady', cb);
	                        document.attachEvent('onWeixinJSBridgeReady', cb);
	                    }
	                } else {
	                    _this5._resolveWeixinPaySdk(res, url, evt);
	                }
	            });
	        }
	    }, {
	        key: '_resolveWeixinPaySdk',
	        value: function _resolveWeixinPaySdk(weixinConfigJson, url, evt) {
	            WeixinJSBridge.invoke('getBrandWCPayRequest', (0, _extends3["default"])({}, weixinConfigJson, { timeStamp: weixinConfigJson.timeStamp + '' }), function (res) {
	                if (res.err_msg == 'get_brand_wcpay_request:ok') {
	                    _scope.MsgBus.Pub(evt, { status: 'y', flag: 100, info: '支付成功' });
	                } else {
	                    _scope.MsgBus.Pub(evt, { status: 'n', flag: 102, info: '微信支付失败，您可以使用二维码进行微信支付', data: { url: url, error: res } });
	                }
	            });
	        }
	    }, {
	        key: '_findGiftById',
	        value: function _findGiftById(gift_id) {
	            var ret = null;
	            this.gifts.map(function (v) {
	                if (v.id == gift_id) {
	                    ret = v;
	                }
	            });
	            return ret;
	        }
	
	        /**
	         * 停止监听ws消息
	         */
	
	    }, {
	        key: 'UnSubRewardTopics',
	        value: function UnSubRewardTopics() {
	            rop.Remove('cash_PropPay_' + this.act_id);
	            rop.Remove('cash_donate_' + this.cash_donate_id);
	        }
	    }, {
	        key: 'GetAvailablePayTypes',
	        value: function GetAvailablePayTypes() {
	            if (browser.isMobileWechat()) {
	                // 手机微信
	                if (this.isSetType.indexOf('weixin')) {
	                    return ['weixin'];
	                } else {
	                    return [];
	                }
	            }
	
	            if (browser.isMobile()) {
	                // 手机其他浏览器
	                if (this.isSetType.indexOf('alipay')) {
	                    return ['alipay'];
	                } else {
	                    return [];
	                }
	            }
	
	            if (browser.isWechat()) {
	                // pc微信
	                if (this.isSetType.indexOf('weixin')) {
	                    return ['weixin'];
	                } else {
	                    return [];
	                }
	            }
	
	            // pc其他浏览器
	            return this.isSetType;
	        }
	    }, {
	        key: 'GetRewardType',
	        value: function GetRewardType() {
	            return this.donate_type;
	        }
	    }, {
	        key: 'GetRewardConfig',
	        value: function GetRewardConfig() {
	            return this.reward_config;
	        }
	    }, {
	        key: 'GetCashConfig',
	        value: function GetCashConfig() {
	            return this.cash_config;
	        }
	    }, {
	        key: 'GetGiftConfig',
	        value: function GetGiftConfig() {
	            return { gifts: this.gifts };
	        }
	    }, {
	        key: 'GetCashRecords',
	        value: function GetCashRecords() {
	            return this.cash_record_list;
	        }
	    }, {
	        key: 'GetGiftRankList',
	        value: function GetGiftRankList(gift_id, cb) {
	            if (!+gift_id) {
	                return;
	            }
	            var url = config.GIFT_DETAIL_URL + '&num=50&gift_id=' + gift_id;
	            Fetcher.Get(url, function (res) {
	                res = JSON.parse(res);
	                cb(res.data);
	            });
	        }
	    }, {
	        key: 'CashReward',
	        value: function CashReward(obj) {
	            obj = obj || {};
	            var num = +obj.num || 0;
	            var payType = obj.payType;
	            var phone = obj.phone;
	            var donate_id = obj.donate_id || this.cash_donate_id;
	            var num_limit = +this.cash_config.lowest || 0.01;
	
	            if (this.donate_type == 1) {
	                return { status: 'n', flag: 101, info: '当前打赏配置为道具打赏' };
	            }
	            if (this.GetAvailablePayTypes().indexOf(payType) < 0) {
	                return { status: 'n', flag: 103, info: '当前支付方式不可用' };
	            }
	            if (num < num_limit) {
	                return { status: 'n', flag: 102, info: '\u6253\u8D4F\u91D1\u989D\u4E0D\u80FD\u5C0F\u4E8E' + num_limit };
	            }
	            var url = this._getCashDonateUrl({ payType: payType, donate_id: donate_id, donate_num: num, phone: phone });
	
	            this._resolvePayUrl(url, payType, 'Reward.CashPay.Result');
	
	            if (payType == 'weixin' && !browser.isMobile()) {
	                return { status: 'y', flag: 100, info: '微信打赏中，请显示图片', data: { url: url, eventKey: 'Reward.CashPay.Result' } };
	            }
	
	            return { status: 'y', flag: 100, info: '支付中，请等待结果', data: { eventKey: 'Reward.CashPay.Result' } };
	        }
	    }, {
	        key: 'GiftReward',
	        value: function GiftReward(obj) {
	            var _this6 = this;
	
	            obj = obj || {};
	            var gift_id = +obj.gift_id || 0;
	            var payType = obj.payType;
	            var phone = obj.phone || '';
	            var num = Math.round(obj.num) || 1;
	            var gift = this._findGiftById(gift_id);
	
	            if (this.donate_type == 2) {
	                return { status: 'n', flag: 101, info: '当前打赏配置为现金打赏' };
	            }
	
	            if (!gift_id) {
	                return { status: 'n', flag: 102, info: 'gift_id不能为空' };
	            }
	
	            if (!gift) {
	                return { status: 'n', flag: 104, info: '\u627E\u4E0D\u5230gift_id\u4E3A' + gift_id + '\u7684\u9053\u5177' };
	            }
	
	            if (this.GetAvailablePayTypes().indexOf(payType) < 0 && +gift.price > 0) {
	                return { status: 'n', flag: 103, info: '当前支付方式不可用' };
	            }
	
	            if (+gift.price == 0) {
	                if (this.freeGiftLock) {
	                    return { status: 'n', flag: 105, info: '免费打赏频率过高' };
	                }
	
	                this.freeGiftLock = true;
	                // 免费打赏有3s的间隔，防止刷礼物
	                setTimeout(function () {
	                    return _this6.freeGiftLock = false;
	                }, 3000);
	
	                this._freeGiftReward({ num: num, gift_id: gift_id, phone: phone });
	                return { status: 'y', flag: 100, info: '免费打赏中', data: { eventKey: 'Reward.GiftFree.Result' } };
	            }
	
	            var url = this._getGiftDonateUrl({ payType: payType, gift_id: gift_id, phone: phone, num: num });
	
	            this._resolvePayUrl(url, payType, 'Reward.GiftPay.Result');
	
	            if (payType == 'weixin' && !browser.isMobile()) {
	                return { status: 'y', flag: 100, info: '微信打赏中，请显示图片', data: { url: url, eventKey: 'Reward.GiftPay.Result' } };
	            }
	
	            return { status: 'y', flag: 100, info: '支付中，请等待结果', data: { eventKey: 'Reward.GiftPay.Result' } };
	        }
	    }, {
	        key: '_freeGiftReward',
	        value: function _freeGiftReward(obj) {
	            var data = {
	                act_id: this.act_id,
	                num: obj.num,
	                gift_id: obj.gift_id,
	                name: _scope.Utils.GetCookie('user'),
	                avatar: _scope.Utils.GetCookie('avatar'),
	                phone: obj.phone
	            };
	            Fetcher.PostForm(config.FREE_GIFT_DONATE_URL, data, function (res) {
	                res = JSON.parse(res);
	                _scope.MsgBus.Pub('Reward.GiftFree.Result', (0, _stringify2["default"])({ status: res.status, flag: res.flag, info: res.msg }));
	            });
	        }
	    }]);
	    return Reward;
	}();
	
	module.exports = Reward;


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {if(!global["_scope"]) global["_scope"] = {};
	module.exports = global["_scope"]["Appointment"] = __webpack_require__(187);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	var _stringify = __webpack_require__(139);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(103);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(110);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(111);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _config = __webpack_require__(117);
	
	var _captcha = __webpack_require__(177);
	
	var _browser = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/* eslint-disable no-console */
	/* eslint-disable indent */
	var Appointment = function () {
	  function Appointment(actHashId) {
	    (0, _classCallCheck3["default"])(this, Appointment);
	
	    // 频道id
	    this.actHashId = actHashId;
	    // 记录人机验证的渲染目标元素ID
	    this.renderTo = '';
	    // 阿里人机验证数据存储
	    this.captchaData = {
	      token: '',
	      session_id: '',
	      sig: ''
	    };
	    // 是否已订阅服务端im消息
	    this.hasSubIMMsg = false;
	  }
	
	  /**
	   * 发起预约变更的事实消息监听
	   */
	
	
	  (0, _createClass3["default"])(Appointment, [{
	    key: '_subAppointmentChange',
	    value: function _subAppointmentChange() {
	      // 目前只有预约使用im连接，用户注册预约模块监听时再连接
	      imClient.manualConnect();
	      imClient.on('appointment', function (msg) {
	        _scope.MsgBus.Pub('Appointment.Change', msg);
	      });
	    }
	
	    /**
	     * 发起预约变更的事实消息监听
	     * 一般在点击预约前就发起当前预约变更监听
	     * @param {Function} cb 预约变更的回调
	     */
	
	  }, {
	    key: 'AddAppointmentChangeListening',
	    value: function AddAppointmentChangeListening(cb) {
	      if (!this.hasSubIMMsg) {
	        this._subAppointmentChange();
	        this.hasSubIMMsg = true;
	      }
	      _scope.MsgBus.On('Appointment.Change', function (res) {
	        var data = JSON.parse(res);
	        typeof cb === 'function' && cb(data);
	      });
	    }
	
	    /**
	     * 发起初始化阿里人机验证
	     * 请在点击预约前发起初始化阿里人机验证
	     * @param {string} renderTo 声明智能验证需要渲染的目标元素ID。
	     * @param {number} width 智能验证组件的宽度。
	     * @param {number} height 智能验证组件的高度。
	     */
	
	  }, {
	    key: 'InitCaptcha',
	    value: function InitCaptcha(renderTo, width, height) {
	      var _this = this;
	
	      if (!this._isSingleCaptcha(renderTo)) return;
	      var params = {
	        width: width,
	        height: height,
	        renderTo: renderTo,
	        isH5: (0, _browser.isMobile)(),
	        success: function success(res) {
	          res = res || {};
	          _this.captchaData.sig = res.sig || '';
	          _this.captchaData.token = res.token || '';
	          _this.captchaData.session_id = res.sessionId || '';
	          console.log('阿里人机验证获取到的数据:', _this.captchaData);
	        },
	        fail: function fail() {
	          _this._resetCaptchaData();
	        }
	      };
	      (0, _captcha.initCaptcha)(params, function (resetCaptcha) {
	        _this.ResetCaptcha = resetCaptcha;
	      });
	    }
	
	    /**
	     * 点击预约
	     * @param {number} appointmentId 预约id
	     * @param {string} phone 手机号
	     * @param {Function} cb 预约后回调
	     */
	
	  }, {
	    key: 'SubmitAppointmentInfo',
	    value: function SubmitAppointmentInfo(appointmentId, phone, cb) {
	      var _this2 = this;
	
	      // 如果没有人机验证通过，则不发起预约
	      if (!this.captchaData.session_id || !this.captchaData.token || !this.captchaData.sig) {
	        console.warn('没有通过人机验证，请先人机验证通过后再发起预约');
	        return;
	      }
	      var url = _config.API_DOMAIN_V2 + ('/v2/watch/' + this.actHashId + '/micro-act/view/appointment/point');
	      var params = (0, _extends3["default"])({
	        phone: phone,
	        appointment_id: Number(appointmentId),
	        scene: (0, _browser.isMobile)() ? 'ic_message_h5' : 'ic_message'
	      }, this.captchaData);
	      console.log('点击预约发送的参数:', params);
	      var callback = function callback(res) {
	        _this2.ResetCaptcha();
	        _this2._resetCaptchaData();
	        var cbData = JSON.parse(res);
	        typeof cb === 'function' && cb(cbData);
	      };
	      Fetcher.Post(url, (0, _stringify2["default"])(params), callback, (0, _extends3["default"])({
	        'Content-Type': 'application/json'
	      }, _scope.DB.Get('requestHeader').session));
	    }
	
	    /**
	     * 获取观看页预约信息
	     * @param {Function} cb 预览信息回调
	     */
	
	  }, {
	    key: 'GetAppointmentInfo',
	    value: function GetAppointmentInfo(cb) {
	      var url = _config.API_DOMAIN_V2 + '/v2/watch/' + this.actHashId + '/micro-act/view/appointment/info';
	      Fetcher.Get(url, function (res) {
	        var cbData = JSON.parse(res);
	        typeof cb === 'function' && cb(cbData);
	      }, _scope.DB.Get('requestHeader').session);
	    }
	
	    // 重置阿里人机校验 会被覆盖重写
	
	  }, {
	    key: 'ResetCaptcha',
	    value: function ResetCaptcha() {
	      console.warn('ResetCaptcha 调用出错，请先调用InitCaptcha');
	    }
	
	    /**
	     * 重置阿里人机验证数据存储
	     */
	
	  }, {
	    key: '_resetCaptchaData',
	    value: function _resetCaptchaData() {
	      this.captchaData.sig = '';
	      this.captchaData.token = '';
	      this.captchaData.session_id = '';
	    }
	
	    /**
	     * 判断是否已经初始化了人机验证
	     * @param {string} renderTo 声明智能验证需要渲染的目标元素ID。
	     * @returns 是否已经初始化了人机验证
	     */
	
	  }, {
	    key: '_isSingleCaptcha',
	    value: function _isSingleCaptcha(renderTo) {
	      if (!this.renderTo || this.renderTo === renderTo) {
	        this.renderTo = renderTo;
	        return true;
	      } else {
	        console.warn('同一个环境目前只允许初始化一个人机验证');
	        return true;
	      }
	    }
	  }]);
	  return Appointment;
	}();
	
	module.exports = Appointment;


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {if(!global["_scope"]) global["_scope"] = {};
	module.exports = global["_scope"]["Notice"] = __webpack_require__(189);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	var _classCallCheck2 = __webpack_require__(110);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(111);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _config = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var Notice = function () {
	    function Notice(actHashId) {
	        (0, _classCallCheck3["default"])(this, Notice);
	
	        this.actHashId = actHashId;
	
	        this._Sub();
	        this._msgbusDestroy();
	    }
	
	    (0, _createClass3["default"])(Notice, [{
	        key: 'Get',
	        value: function Get(cb) {
	            Fetcher.Get(_config.API_DOMAIN_V2 + '/v2/micro-act/view/announcement?act_id=' + this.actHashId, function (res) {
	                var cbData = JSON.parse(res);
	                typeof cb === 'function' && cb(cbData);
	            });
	        }
	    }, {
	        key: '_Sub',
	        value: function _Sub() {
	            this.unsubNotice = nats.on('mudu.activities.' + this.actHashId, function (message) {
	                var msg = JSON.parse(message);
	                if (msg.type && msg.type === 'activities.Announcement') {
	                    _scope.MsgBus.Pub('Notice.Change', msg.data);
	                }
	            });
	        }
	    }, {
	        key: '_msgbusDestroy',
	        value: function _msgbusDestroy() {
	            var _this = this;
	
	            this.destroyKey = _scope.MsgBus.On('Destroy', function () {
	                _scope.MsgBus.UnSub('Destroy', _this.destroyKey);
	                _this.unsubNotice();
	            });
	        }
	    }]);
	    return Notice;
	}(); /**
	      * 公告组件
	      */
	
	
	module.exports = Notice;


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var shim = __webpack_require__(1);
	var sham = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createNatsClient = createNatsClient;
	
	var _imMessager = __webpack_require__(143);
	
	var _imMessager2 = _interopRequireDefault(_imMessager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function createNatsClient() {
	  var imClientParam = {
	    host: window.NAT_SERVERS[0],
	    connectType: 'nats',
	    maxReconnectTimes: 20,
	    reconnectDelay: 5 * 1000,
	    heartbeatInterval: 20 * 1000
	  };
	
	  if (window.nats && window.nats.close && typeof window.nats.close === 'function') {
	    try {
	      nats.close();
	    } catch (error) {
	      // close error
	    }
	  }
	  window.nats = new _imMessager2["default"](imClientParam);
	
	  // 监听nats连接自身状态事件
	  this.nats.onClient('ready', function () {
	    return console.log('nats client: ready');
	  });
	  this.nats.onClient('connect', function () {
	    return console.log('nats client: connect');
	  });
	  this.nats.onClient('error', function (err) {
	    return console.error('nats client error:', err);
	  });
	  this.nats.onClient('close', function (close) {
	    return console.warn('nats client close:', close);
	  });
	}


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["rop"] = __webpack_require__(192);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(193)

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {!function(t){function e(r){if(n[r])return n[r].exports;var i=n[r]={exports:{},id:r,loaded:!1};return t[r].call(i.exports,i,i.exports,e),i.loaded=!0,i.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){var r=(n(1),n(2),n(3));window.messager||(window.messager=new r),t.exports=window.messager},function(t,e,n){var r,i;!function(o,s){"use strict";r=s,i="function"==typeof r?r.call(e,n,e,t):r,!(void 0!==i&&(t.exports=i))}(this,function(){var t,e,n=Array,r=n.prototype,i=Object,o=i.prototype,s=Function,a=s.prototype,c=String,u=c.prototype,h=Number,f=h.prototype,l=r.slice,p=r.splice,d=r.push,v=r.unshift,y=r.concat,g=r.join,b=a.call,w=a.apply,m=Math.max,_=Math.min,S=o.toString,E="function"==typeof Symbol&&"symbol"==typeof Symbol.toStringTag,O=Function.prototype.toString,T=/^\s*class /,k=function(t){try{var e=O.call(t),n=e.replace(/\/\/.*\n/g,""),r=n.replace(/\/\*[.\s\S]*\*\//g,""),i=r.replace(/\n/gm," ").replace(/ {2}/g," ");return T.test(i)}catch(o){return!1}},C=function(t){try{return!k(t)&&(O.call(t),!0)}catch(e){return!1}},j="[object Function]",x="[object GeneratorFunction]",t=function(t){if(!t)return!1;if("function"!=typeof t&&"object"!=typeof t)return!1;if(E)return C(t);if(k(t))return!1;var e=S.call(t);return e===j||e===x},B=RegExp.prototype.exec,A=function(t){try{return B.call(t),!0}catch(e){return!1}},I="[object RegExp]";e=function(t){return"object"==typeof t&&(E?A(t):S.call(t)===I)};var R,M=String.prototype.valueOf,N=function(t){try{return M.call(t),!0}catch(e){return!1}},U="[object String]";R=function(t){return"string"==typeof t||"object"==typeof t&&(E?N(t):S.call(t)===U)};var P=i.defineProperty&&function(){try{var t={};i.defineProperty(t,"x",{enumerable:!1,value:t});for(var e in t)return!1;return t.x===t}catch(n){return!1}}(),D=function(t){var e;return e=P?function(t,e,n,r){!r&&e in t||i.defineProperty(t,e,{configurable:!0,enumerable:!1,writable:!0,value:n})}:function(t,e,n,r){!r&&e in t||(t[e]=n)},function(n,r,i){for(var o in r)t.call(r,o)&&e(n,o,r[o],i)}}(o.hasOwnProperty),L=function(t){var e=typeof t;return null===t||"object"!==e&&"function"!==e},W=h.isNaN||function(t){return t!==t},F={ToInteger:function(t){var e=+t;return W(e)?e=0:0!==e&&e!==1/0&&e!==-(1/0)&&(e=(e>0||-1)*Math.floor(Math.abs(e))),e},ToPrimitive:function(e){var n,r,i;if(L(e))return e;if(r=e.valueOf,t(r)&&(n=r.call(e),L(n)))return n;if(i=e.toString,t(i)&&(n=i.call(e),L(n)))return n;throw new TypeError},ToObject:function(t){if(null==t)throw new TypeError("can't convert "+t+" to object");return i(t)},ToUint32:function(t){return t>>>0}},z=function(){};D(a,{bind:function(e){var n=this;if(!t(n))throw new TypeError("Function.prototype.bind called on incompatible "+n);for(var r,o=l.call(arguments,1),a=function(){if(this instanceof r){var t=w.call(n,this,y.call(o,l.call(arguments)));return i(t)===t?t:this}return w.call(n,e,y.call(o,l.call(arguments)))},c=m(0,n.length-o.length),u=[],h=0;h<c;h++)d.call(u,"$"+h);return r=s("binder","return function ("+g.call(u,",")+"){ return binder.apply(this, arguments); }")(a),n.prototype&&(z.prototype=n.prototype,r.prototype=new z,z.prototype=null),r}});var q=b.bind(o.hasOwnProperty),Y=b.bind(o.toString),$=b.bind(l),X=w.bind(l),J=b.bind(u.slice),G=b.bind(u.split),V=b.bind(u.indexOf),H=b.bind(d),K=b.bind(o.propertyIsEnumerable),Z=b.bind(r.sort),Q=n.isArray||function(t){return"[object Array]"===Y(t)},tt=1!==[].unshift(0);D(r,{unshift:function(){return v.apply(this,arguments),this.length}},tt),D(n,{isArray:Q});var et=i("a"),nt="a"!==et[0]||!(0 in et),rt=function(t){var e=!0,n=!0,r=!1;if(t)try{t.call("foo",function(t,n,r){"object"!=typeof r&&(e=!1)}),t.call([1],function(){"use strict";n="string"==typeof this},"x")}catch(i){r=!0}return!!t&&!r&&e&&n};D(r,{forEach:function(e){var n,r=F.ToObject(this),i=nt&&R(this)?G(this,""):r,o=-1,s=F.ToUint32(i.length);if(arguments.length>1&&(n=arguments[1]),!t(e))throw new TypeError("Array.prototype.forEach callback must be a function");for(;++o<s;)o in i&&("undefined"==typeof n?e(i[o],o,r):e.call(n,i[o],o,r))}},!rt(r.forEach)),D(r,{map:function(e){var r,i=F.ToObject(this),o=nt&&R(this)?G(this,""):i,s=F.ToUint32(o.length),a=n(s);if(arguments.length>1&&(r=arguments[1]),!t(e))throw new TypeError("Array.prototype.map callback must be a function");for(var c=0;c<s;c++)c in o&&("undefined"==typeof r?a[c]=e(o[c],c,i):a[c]=e.call(r,o[c],c,i));return a}},!rt(r.map)),D(r,{filter:function(e){var n,r,i=F.ToObject(this),o=nt&&R(this)?G(this,""):i,s=F.ToUint32(o.length),a=[];if(arguments.length>1&&(r=arguments[1]),!t(e))throw new TypeError("Array.prototype.filter callback must be a function");for(var c=0;c<s;c++)c in o&&(n=o[c],("undefined"==typeof r?e(n,c,i):e.call(r,n,c,i))&&H(a,n));return a}},!rt(r.filter)),D(r,{every:function(e){var n,r=F.ToObject(this),i=nt&&R(this)?G(this,""):r,o=F.ToUint32(i.length);if(arguments.length>1&&(n=arguments[1]),!t(e))throw new TypeError("Array.prototype.every callback must be a function");for(var s=0;s<o;s++)if(s in i&&!("undefined"==typeof n?e(i[s],s,r):e.call(n,i[s],s,r)))return!1;return!0}},!rt(r.every)),D(r,{some:function(e){var n,r=F.ToObject(this),i=nt&&R(this)?G(this,""):r,o=F.ToUint32(i.length);if(arguments.length>1&&(n=arguments[1]),!t(e))throw new TypeError("Array.prototype.some callback must be a function");for(var s=0;s<o;s++)if(s in i&&("undefined"==typeof n?e(i[s],s,r):e.call(n,i[s],s,r)))return!0;return!1}},!rt(r.some));var it=!1;r.reduce&&(it="object"==typeof r.reduce.call("es5",function(t,e,n,r){return r})),D(r,{reduce:function(e){var n=F.ToObject(this),r=nt&&R(this)?G(this,""):n,i=F.ToUint32(r.length);if(!t(e))throw new TypeError("Array.prototype.reduce callback must be a function");if(0===i&&1===arguments.length)throw new TypeError("reduce of empty array with no initial value");var o,s=0;if(arguments.length>=2)o=arguments[1];else for(;;){if(s in r){o=r[s++];break}if(++s>=i)throw new TypeError("reduce of empty array with no initial value")}for(;s<i;s++)s in r&&(o=e(o,r[s],s,n));return o}},!it);var ot=!1;r.reduceRight&&(ot="object"==typeof r.reduceRight.call("es5",function(t,e,n,r){return r})),D(r,{reduceRight:function(e){var n=F.ToObject(this),r=nt&&R(this)?G(this,""):n,i=F.ToUint32(r.length);if(!t(e))throw new TypeError("Array.prototype.reduceRight callback must be a function");if(0===i&&1===arguments.length)throw new TypeError("reduceRight of empty array with no initial value");var o,s=i-1;if(arguments.length>=2)o=arguments[1];else for(;;){if(s in r){o=r[s--];break}if(--s<0)throw new TypeError("reduceRight of empty array with no initial value")}if(s<0)return o;do s in r&&(o=e(o,r[s],s,n));while(s--);return o}},!ot);var st=r.indexOf&&[0,1].indexOf(1,2)!==-1;D(r,{indexOf:function(t){var e=nt&&R(this)?G(this,""):F.ToObject(this),n=F.ToUint32(e.length);if(0===n)return-1;var r=0;for(arguments.length>1&&(r=F.ToInteger(arguments[1])),r=r>=0?r:m(0,n+r);r<n;r++)if(r in e&&e[r]===t)return r;return-1}},st);var at=r.lastIndexOf&&[0,1].lastIndexOf(0,-3)!==-1;D(r,{lastIndexOf:function(t){var e=nt&&R(this)?G(this,""):F.ToObject(this),n=F.ToUint32(e.length);if(0===n)return-1;var r=n-1;for(arguments.length>1&&(r=_(r,F.ToInteger(arguments[1]))),r=r>=0?r:n-Math.abs(r);r>=0;r--)if(r in e&&t===e[r])return r;return-1}},at);var ct=function(){var t=[1,2],e=t.splice();return 2===t.length&&Q(e)&&0===e.length}();D(r,{splice:function(t,e){return 0===arguments.length?[]:p.apply(this,arguments)}},!ct);var ut=function(){var t={};return r.splice.call(t,0,0,1),1===t.length}();D(r,{splice:function(t,e){if(0===arguments.length)return[];var n=arguments;return this.length=m(F.ToInteger(this.length),0),arguments.length>0&&"number"!=typeof e&&(n=$(arguments),n.length<2?H(n,this.length-t):n[1]=F.ToInteger(e)),p.apply(this,n)}},!ut);var ht=function(){var t=new n(1e5);return t[8]="x",t.splice(1,1),7===t.indexOf("x")}(),ft=function(){var t=256,e=[];return e[t]="a",e.splice(t+1,0,"b"),"a"===e[t]}();D(r,{splice:function(t,e){for(var n,r=F.ToObject(this),i=[],o=F.ToUint32(r.length),s=F.ToInteger(t),a=s<0?m(o+s,0):_(s,o),u=_(m(F.ToInteger(e),0),o-a),h=0;h<u;)n=c(a+h),q(r,n)&&(i[h]=r[n]),h+=1;var f,l=$(arguments,2),p=l.length;if(p<u){h=a;for(var d=o-u;h<d;)n=c(h+u),f=c(h+p),q(r,n)?r[f]=r[n]:delete r[f],h+=1;h=o;for(var v=o-u+p;h>v;)delete r[h-1],h-=1}else if(p>u)for(h=o-u;h>a;)n=c(h+u-1),f=c(h+p-1),q(r,n)?r[f]=r[n]:delete r[f],h-=1;h=a;for(var y=0;y<l.length;++y)r[h]=l[y],h+=1;return r.length=o-u+p,i}},!ht||!ft);var lt,pt=r.join;try{lt="1,2,3"!==Array.prototype.join.call("123",",")}catch(dt){lt=!0}lt&&D(r,{join:function(t){var e="undefined"==typeof t?",":t;return pt.call(R(this)?G(this,""):this,e)}},lt);var vt="1,2"!==[1,2].join(void 0);vt&&D(r,{join:function(t){var e="undefined"==typeof t?",":t;return pt.call(this,e)}},vt);var yt=function(t){for(var e=F.ToObject(this),n=F.ToUint32(e.length),r=0;r<arguments.length;)e[n+r]=arguments[r],r+=1;return e.length=n+r,n+r},gt=function(){var t={},e=Array.prototype.push.call(t,void 0);return 1!==e||1!==t.length||"undefined"!=typeof t[0]||!q(t,0)}();D(r,{push:function(t){return Q(this)?d.apply(this,arguments):yt.apply(this,arguments)}},gt);var bt=function(){var t=[],e=t.push(void 0);return 1!==e||1!==t.length||"undefined"!=typeof t[0]||!q(t,0)}();D(r,{push:yt},bt),D(r,{slice:function(t,e){var n=R(this)?G(this,""):this;return X(n,arguments)}},nt);var wt=function(){try{return[1,2].sort(null),[1,2].sort({}),!0}catch(t){}return!1}(),mt=function(){try{return[1,2].sort(/a/),!1}catch(t){}return!0}(),_t=function(){try{return[1,2].sort(void 0),!0}catch(t){}return!1}();D(r,{sort:function(e){if("undefined"==typeof e)return Z(this);if(!t(e))throw new TypeError("Array.prototype.sort callback must be a function");return Z(this,e)}},wt||!_t||!mt);var St=!K({toString:null},"toString"),Et=K(function(){},"prototype"),Ot=!q("x","0"),Tt=function(t){var e=t.constructor;return e&&e.prototype===t},kt={$window:!0,$console:!0,$parent:!0,$self:!0,$frame:!0,$frames:!0,$frameElement:!0,$webkitIndexedDB:!0,$webkitStorageInfo:!0,$external:!0},Ct=function(){if("undefined"==typeof window)return!1;for(var t in window)try{!kt["$"+t]&&q(window,t)&&null!==window[t]&&"object"==typeof window[t]&&Tt(window[t])}catch(e){return!0}return!1}(),jt=function(t){if("undefined"==typeof window||!Ct)return Tt(t);try{return Tt(t)}catch(e){return!1}},xt=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"],Bt=xt.length,At=function(t){return"[object Arguments]"===Y(t)},It=function(e){return null!==e&&"object"==typeof e&&"number"==typeof e.length&&e.length>=0&&!Q(e)&&t(e.callee)},Rt=At(arguments)?At:It;D(i,{keys:function(e){var n=t(e),r=Rt(e),i=null!==e&&"object"==typeof e,o=i&&R(e);if(!i&&!n&&!r)throw new TypeError("Object.keys called on a non-object");var s=[],a=Et&&n;if(o&&Ot||r)for(var u=0;u<e.length;++u)H(s,c(u));if(!r)for(var h in e)a&&"prototype"===h||!q(e,h)||H(s,c(h));if(St)for(var f=jt(e),l=0;l<Bt;l++){var p=xt[l];f&&"constructor"===p||!q(e,p)||H(s,p)}return s}});var Mt=i.keys&&function(){return 2===i.keys(arguments).length}(1,2),Nt=i.keys&&function(){var t=i.keys(arguments);return 1!==arguments.length||1!==t.length||1!==t[0]}(1),Ut=i.keys;D(i,{keys:function(t){return Ut(Rt(t)?$(t):t)}},!Mt||Nt);var Pt,Dt,Lt=0!==new Date(-0xc782b5b342b24).getUTCMonth(),Wt=new Date(-0x55d318d56a724),Ft=new Date(14496624e5),zt="Mon, 01 Jan -45875 11:59:59 GMT"!==Wt.toUTCString(),qt=Wt.getTimezoneOffset();qt<-720?(Pt="Tue Jan 02 -45875"!==Wt.toDateString(),Dt=!/^Thu Dec 10 2015 \d\d:\d\d:\d\d GMT[-\+]\d\d\d\d(?: |$)/.test(Ft.toString())):(Pt="Mon Jan 01 -45875"!==Wt.toDateString(),Dt=!/^Wed Dec 09 2015 \d\d:\d\d:\d\d GMT[-\+]\d\d\d\d(?: |$)/.test(Ft.toString()));var Yt=b.bind(Date.prototype.getFullYear),$t=b.bind(Date.prototype.getMonth),Xt=b.bind(Date.prototype.getDate),Jt=b.bind(Date.prototype.getUTCFullYear),Gt=b.bind(Date.prototype.getUTCMonth),Vt=b.bind(Date.prototype.getUTCDate),Ht=b.bind(Date.prototype.getUTCDay),Kt=b.bind(Date.prototype.getUTCHours),Zt=b.bind(Date.prototype.getUTCMinutes),Qt=b.bind(Date.prototype.getUTCSeconds),te=b.bind(Date.prototype.getUTCMilliseconds),ee=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],ne=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],re=function(t,e){return Xt(new Date(e,t,0))};D(Date.prototype,{getFullYear:function(){if(!(this&&this instanceof Date))throw new TypeError("this is not a Date object.");var t=Yt(this);return t<0&&$t(this)>11?t+1:t},getMonth:function(){if(!(this&&this instanceof Date))throw new TypeError("this is not a Date object.");var t=Yt(this),e=$t(this);return t<0&&e>11?0:e},getDate:function(){if(!(this&&this instanceof Date))throw new TypeError("this is not a Date object.");var t=Yt(this),e=$t(this),n=Xt(this);if(t<0&&e>11){if(12===e)return n;var r=re(0,t+1);return r-n+1}return n},getUTCFullYear:function(){if(!(this&&this instanceof Date))throw new TypeError("this is not a Date object.");var t=Jt(this);return t<0&&Gt(this)>11?t+1:t},getUTCMonth:function(){if(!(this&&this instanceof Date))throw new TypeError("this is not a Date object.");var t=Jt(this),e=Gt(this);return t<0&&e>11?0:e},getUTCDate:function(){if(!(this&&this instanceof Date))throw new TypeError("this is not a Date object.");var t=Jt(this),e=Gt(this),n=Vt(this);if(t<0&&e>11){if(12===e)return n;var r=re(0,t+1);return r-n+1}return n}},Lt),D(Date.prototype,{toUTCString:function(){if(!(this&&this instanceof Date))throw new TypeError("this is not a Date object.");var t=Ht(this),e=Vt(this),n=Gt(this),r=Jt(this),i=Kt(this),o=Zt(this),s=Qt(this);return ee[t]+", "+(e<10?"0"+e:e)+" "+ne[n]+" "+r+" "+(i<10?"0"+i:i)+":"+(o<10?"0"+o:o)+":"+(s<10?"0"+s:s)+" GMT"}},Lt||zt),D(Date.prototype,{toDateString:function(){if(!(this&&this instanceof Date))throw new TypeError("this is not a Date object.");var t=this.getDay(),e=this.getDate(),n=this.getMonth(),r=this.getFullYear();return ee[t]+" "+ne[n]+" "+(e<10?"0"+e:e)+" "+r}},Lt||Pt),(Lt||Dt)&&(Date.prototype.toString=function(){if(!(this&&this instanceof Date))throw new TypeError("this is not a Date object.");var t=this.getDay(),e=this.getDate(),n=this.getMonth(),r=this.getFullYear(),i=this.getHours(),o=this.getMinutes(),s=this.getSeconds(),a=this.getTimezoneOffset(),c=Math.floor(Math.abs(a)/60),u=Math.floor(Math.abs(a)%60);return ee[t]+" "+ne[n]+" "+(e<10?"0"+e:e)+" "+r+" "+(i<10?"0"+i:i)+":"+(o<10?"0"+o:o)+":"+(s<10?"0"+s:s)+" GMT"+(a>0?"-":"+")+(c<10?"0"+c:c)+(u<10?"0"+u:u)},P&&i.defineProperty(Date.prototype,"toString",{configurable:!0,enumerable:!1,writable:!0}));var ie=-621987552e5,oe="-000001",se=Date.prototype.toISOString&&new Date(ie).toISOString().indexOf(oe)===-1,ae=Date.prototype.toISOString&&"1969-12-31T23:59:59.999Z"!==new Date(-1).toISOString(),ce=b.bind(Date.prototype.getTime);D(Date.prototype,{toISOString:function(){if(!isFinite(this)||!isFinite(ce(this)))throw new RangeError("Date.prototype.toISOString called on non-finite value.");var t=Jt(this),e=Gt(this);t+=Math.floor(e/12),e=(e%12+12)%12;var n=[e+1,Vt(this),Kt(this),Zt(this),Qt(this)];t=(t<0?"-":t>9999?"+":"")+J("00000"+Math.abs(t),0<=t&&t<=9999?-4:-6);for(var r=0;r<n.length;++r)n[r]=J("00"+n[r],-2);return t+"-"+$(n,0,2).join("-")+"T"+$(n,2).join(":")+"."+J("000"+te(this),-3)+"Z"}},se||ae);var ue=function(){try{return Date.prototype.toJSON&&null===new Date(NaN).toJSON()&&new Date(ie).toJSON().indexOf(oe)!==-1&&Date.prototype.toJSON.call({toISOString:function(){return!0}})}catch(t){return!1}}();ue||(Date.prototype.toJSON=function(e){var n=i(this),r=F.ToPrimitive(n);if("number"==typeof r&&!isFinite(r))return null;var o=n.toISOString;if(!t(o))throw new TypeError("toISOString property is not callable");return o.call(n)});var he=1e15===Date.parse("+033658-09-27T01:46:40.000Z"),fe=!isNaN(Date.parse("2012-04-04T24:00:00.500Z"))||!isNaN(Date.parse("2012-11-31T23:59:59.000Z"))||!isNaN(Date.parse("2012-12-31T23:59:60.000Z")),le=isNaN(Date.parse("2000-01-01T00:00:00.000Z"));if(le||fe||!he){var pe=Math.pow(2,31)-1,de=W(new Date(1970,0,1,0,0,0,pe+1).getTime());Date=function(t){var e=function(n,r,i,o,s,a,u){var h,f=arguments.length;if(this instanceof t){var l=a,p=u;if(de&&f>=7&&u>pe){var d=Math.floor(u/pe)*pe,v=Math.floor(d/1e3);l+=v,p-=1e3*v}h=1===f&&c(n)===n?new t(e.parse(n)):f>=7?new t(n,r,i,o,s,l,p):f>=6?new t(n,r,i,o,s,l):f>=5?new t(n,r,i,o,s):f>=4?new t(n,r,i,o):f>=3?new t(n,r,i):f>=2?new t(n,r):f>=1?new t(n instanceof t?+n:n):new t}else h=t.apply(this,arguments);return L(h)||D(h,{constructor:e},!0),h},n=new RegExp("^(\\d{4}|[+-]\\d{6})(?:-(\\d{2})(?:-(\\d{2})(?:T(\\d{2}):(\\d{2})(?::(\\d{2})(?:(\\.\\d{1,}))?)?(Z|(?:([-+])(\\d{2}):(\\d{2})))?)?)?)?$"),r=[0,31,59,90,120,151,181,212,243,273,304,334,365],i=function(t,e){var n=e>1?1:0;return r[e]+Math.floor((t-1969+n)/4)-Math.floor((t-1901+n)/100)+Math.floor((t-1601+n)/400)+365*(t-1970)},o=function(e){var n=0,r=e;if(de&&r>pe){var i=Math.floor(r/pe)*pe,o=Math.floor(i/1e3);n+=o,r-=1e3*o}return h(new t(1970,0,1,0,0,n,r))};for(var s in t)q(t,s)&&(e[s]=t[s]);D(e,{now:t.now,UTC:t.UTC},!0),e.prototype=t.prototype,D(e.prototype,{constructor:e},!0);var a=function(e){var r=n.exec(e);if(r){var s,a=h(r[1]),c=h(r[2]||1)-1,u=h(r[3]||1)-1,f=h(r[4]||0),l=h(r[5]||0),p=h(r[6]||0),d=Math.floor(1e3*h(r[7]||0)),v=Boolean(r[4]&&!r[8]),y="-"===r[9]?1:-1,g=h(r[10]||0),b=h(r[11]||0),w=l>0||p>0||d>0;return f<(w?24:25)&&l<60&&p<60&&d<1e3&&c>-1&&c<12&&g<24&&b<60&&u>-1&&u<i(a,c+1)-i(a,c)&&(s=60*(24*(i(a,c)+u)+f+g*y),s=1e3*(60*(s+l+b*y)+p)+d,v&&(s=o(s)),-864e13<=s&&s<=864e13)?s:NaN}return t.parse.apply(this,arguments)};return D(e,{parse:a}),e}(Date)}Date.now||(Date.now=function(){return(new Date).getTime()});var ve=f.toFixed&&("0.000"!==8e-5.toFixed(3)||"1"!==.9.toFixed(0)||"1.25"!==1.255.toFixed(2)||"1000000000000000128"!==(0xde0b6b3a7640080).toFixed(0)),ye={base:1e7,size:6,data:[0,0,0,0,0,0],multiply:function(t,e){for(var n=-1,r=e;++n<ye.size;)r+=t*ye.data[n],ye.data[n]=r%ye.base,r=Math.floor(r/ye.base)},divide:function(t){for(var e=ye.size,n=0;--e>=0;)n+=ye.data[e],ye.data[e]=Math.floor(n/t),n=n%t*ye.base},numToString:function(){for(var t=ye.size,e="";--t>=0;)if(""!==e||0===t||0!==ye.data[t]){var n=c(ye.data[t]);""===e?e=n:e+=J("0000000",0,7-n.length)+n}return e},pow:function Ue(t,e,n){return 0===e?n:e%2===1?Ue(t,e-1,n*t):Ue(t*t,e/2,n)},log:function(t){for(var e=0,n=t;n>=4096;)e+=12,n/=4096;for(;n>=2;)e+=1,n/=2;return e}},ge=function(t){var e,n,r,i,o,s,a,u;if(e=h(t),e=W(e)?0:Math.floor(e),e<0||e>20)throw new RangeError("Number.toFixed called with invalid number of decimals");if(n=h(this),W(n))return"NaN";if(n<=-1e21||n>=1e21)return c(n);if(r="",n<0&&(r="-",n=-n),i="0",n>1e-21)if(o=ye.log(n*ye.pow(2,69,1))-69,s=o<0?n*ye.pow(2,-o,1):n/ye.pow(2,o,1),s*=4503599627370496,o=52-o,o>0){for(ye.multiply(0,s),a=e;a>=7;)ye.multiply(1e7,0),a-=7;for(ye.multiply(ye.pow(10,a,1),0),a=o-1;a>=23;)ye.divide(1<<23),a-=23;ye.divide(1<<a),ye.multiply(1,1),ye.divide(2),i=ye.numToString()}else ye.multiply(0,s),ye.multiply(1<<-o,0),i=ye.numToString()+J("0.00000000000000000000",2,2+e);return e>0?(u=i.length,i=u<=e?r+J("0.0000000000000000000",0,e-u+2)+i:r+J(i,0,u-e)+"."+J(i,u-e)):i=r+i,i};D(f,{toFixed:ge},ve);var be=function(){try{return"1"===1..toPrecision(void 0)}catch(t){return!0}}(),we=f.toPrecision;D(f,{toPrecision:function(t){return"undefined"==typeof t?we.call(this):we.call(this,t)}},be),2!=="ab".split(/(?:ab)*/).length||4!==".".split(/(.?)(.?)/).length||"t"==="tesst".split(/(s)*/)[1]||4!=="test".split(/(?:)/,-1).length||"".split(/.?/).length||".".split(/()()/).length>1?!function(){var t="undefined"==typeof/()??/.exec("")[1],n=Math.pow(2,32)-1;u.split=function(r,i){var o=String(this);if("undefined"==typeof r&&0===i)return[];if(!e(r))return G(this,r,i);var s,a,c,u,h=[],f=(r.ignoreCase?"i":"")+(r.multiline?"m":"")+(r.unicode?"u":"")+(r.sticky?"y":""),l=0,p=new RegExp(r.source,f+"g");t||(s=new RegExp("^"+p.source+"$(?!\\s)",f));var v="undefined"==typeof i?n:F.ToUint32(i);for(a=p.exec(o);a&&(c=a.index+a[0].length,!(c>l&&(H(h,J(o,l,a.index)),!t&&a.length>1&&a[0].replace(s,function(){for(var t=1;t<arguments.length-2;t++)"undefined"==typeof arguments[t]&&(a[t]=void 0)}),a.length>1&&a.index<o.length&&d.apply(h,$(a,1)),u=a[0].length,l=c,h.length>=v)));)p.lastIndex===a.index&&p.lastIndex++,a=p.exec(o);return l===o.length?!u&&p.test("")||H(h,""):H(h,J(o,l)),h.length>v?$(h,0,v):h}}():"0".split(void 0,0).length&&(u.split=function(t,e){return"undefined"==typeof t&&0===e?[]:G(this,t,e)});var me=u.replace,_e=function(){var t=[];return"x".replace(/x(.)?/g,function(e,n){H(t,n)}),1===t.length&&"undefined"==typeof t[0]}();_e||(u.replace=function(n,r){var i=t(r),o=e(n)&&/\)[*?]/.test(n.source);if(i&&o){var s=function(t){var e=arguments.length,i=n.lastIndex;n.lastIndex=0;var o=n.exec(t)||[];return n.lastIndex=i,H(o,arguments[e-2],arguments[e-1]),r.apply(this,o)};return me.call(this,n,s)}return me.call(this,n,r)});var Se=u.substr,Ee="".substr&&"b"!=="0b".substr(-1);D(u,{substr:function(t,e){var n=t;return t<0&&(n=m(this.length+t,0)),Se.call(this,n,e)}},Ee);var Oe="\t\n\x0B\f\r   ᠎             　\u2028\u2029\ufeff",Te="​",ke="["+Oe+"]",Ce=new RegExp("^"+ke+ke+"*"),je=new RegExp(ke+ke+"*$"),xe=u.trim&&(Oe.trim()||!Te.trim());D(u,{trim:function(){if("undefined"==typeof this||null===this)throw new TypeError("can't convert "+this+" to object");return c(this).replace(Ce,"").replace(je,"")}},xe);var Be=b.bind(String.prototype.trim),Ae=u.lastIndexOf&&"abcあい".lastIndexOf("あい",2)!==-1;D(u,{lastIndexOf:function(t){if("undefined"==typeof this||null===this)throw new TypeError("can't convert "+this+" to object");for(var e=c(this),n=c(t),r=arguments.length>1?h(arguments[1]):NaN,i=W(r)?1/0:F.ToInteger(r),o=_(m(i,0),e.length),s=n.length,a=o+s;a>0;){a=m(0,a-s);var u=V(J(e,a,o+s),n);if(u!==-1)return a+u}return-1}},Ae);var Ie=u.lastIndexOf;if(D(u,{lastIndexOf:function(t){return Ie.apply(this,arguments)}},1!==u.lastIndexOf.length),8===parseInt(Oe+"08")&&22===parseInt(Oe+"0x16")||(parseInt=function(t){var e=/^[\-+]?0[xX]/;return function(n,r){var i=Be(String(n)),o=h(r)||(e.test(i)?16:10);return t(i,o)}}(parseInt)),1/parseFloat("-0")!==-(1/0)&&(parseFloat=function(t){return function(e){var n=Be(String(e)),r=t(n);return 0===r&&"-"===J(n,0,1)?-0:r}}(parseFloat)),"RangeError: test"!==String(new RangeError("test"))){var Re=function(){if("undefined"==typeof this||null===this)throw new TypeError("can't convert "+this+" to object");var t=this.name;"undefined"==typeof t?t="Error":"string"!=typeof t&&(t=c(t));var e=this.message;return"undefined"==typeof e?e="":"string"!=typeof e&&(e=c(e)),t?e?t+": "+e:t:e};Error.prototype.toString=Re}if(P){var Me=function(t,e){if(K(t,e)){var n=Object.getOwnPropertyDescriptor(t,e);n.configurable&&(n.enumerable=!1,Object.defineProperty(t,e,n))}};Me(Error.prototype,"message"),""!==Error.prototype.message&&(Error.prototype.message=""),Me(Error.prototype,"name")}if("/a/gim"!==String(/a/gim)){var Ne=function(){var t="/"+this.source+"/";return this.global&&(t+="g"),this.ignoreCase&&(t+="i"),this.multiline&&(t+="m"),t};RegExp.prototype.toString=Ne}})},function(t,e,n){var r,i;!function(o,s){"use strict";r=s,i="function"==typeof r?r.call(e,n,e,t):r,!(void 0!==i&&(t.exports=i))}(this,function(){var t,e,n,r,i=Function.call,o=Object.prototype,s=i.bind(o.hasOwnProperty),a=i.bind(o.propertyIsEnumerable),c=i.bind(o.toString),u=s(o,"__defineGetter__");u&&(t=i.bind(o.__defineGetter__),e=i.bind(o.__defineSetter__),n=i.bind(o.__lookupGetter__),r=i.bind(o.__lookupSetter__));var h=function(t){return null==t||"object"!=typeof t&&"function"!=typeof t};Object.getPrototypeOf||(Object.getPrototypeOf=function(t){var e=t.__proto__;return e||null===e?e:"[object Function]"===c(t.constructor)?t.constructor.prototype:t instanceof Object?o:null});var f=function(t){try{return t.sentinel=0,0===Object.getOwnPropertyDescriptor(t,"sentinel").value}catch(e){return!1}};if(Object.defineProperty){var l=f({}),p="undefined"==typeof document||f(document.createElement("div"));if(!p||!l)var d=Object.getOwnPropertyDescriptor}if(!Object.getOwnPropertyDescriptor||d){var v="Object.getOwnPropertyDescriptor called on a non-object: ";Object.getOwnPropertyDescriptor=function(t,e){if(h(t))throw new TypeError(v+t);if(d)try{return d.call(Object,t,e)}catch(i){}var c;if(!s(t,e))return c;if(c={enumerable:a(t,e),configurable:!0},u){var f=t.__proto__,l=t!==o;l&&(t.__proto__=o);var p=n(t,e),y=r(t,e);if(l&&(t.__proto__=f),p||y)return p&&(c.get=p),y&&(c.set=y),c}return c.value=t[e],c.writable=!0,c}}if(Object.getOwnPropertyNames||(Object.getOwnPropertyNames=function(t){return Object.keys(t)}),!Object.create){var y,g=!({__proto__:null}instanceof Object),b=function(){if(!document.domain)return!1;try{return!!new ActiveXObject("htmlfile")}catch(t){return!1}},w=function(){var t,e;e=new ActiveXObject("htmlfile");var n="script";return e.write("<"+n+"></"+n+">"),e.close(),t=e.parentWindow.Object.prototype,e=null,t},m=function(){var t,e=document.createElement("iframe"),n=document.body||document.documentElement;return e.style.display="none",n.appendChild(e),e.src="javascript:",t=e.contentWindow.Object.prototype,n.removeChild(e),e=null,t};y=g||"undefined"==typeof document?function(){return{__proto__:null}}:function(){var t=b()?w():m();delete t.constructor,delete t.hasOwnProperty,delete t.propertyIsEnumerable,delete t.isPrototypeOf,delete t.toLocaleString,delete t.toString,delete t.valueOf;var e=function(){};return e.prototype=t,y=function(){return new e},new e},Object.create=function(t,e){var n,r=function(){};if(null===t)n=y();else{if(null!==t&&h(t))throw new TypeError("Object prototype may only be an Object or null");r.prototype=t,n=new r,n.__proto__=t}return void 0!==e&&Object.defineProperties(n,e),n}}var _=function(t){try{return Object.defineProperty(t,"sentinel",{}),"sentinel"in t}catch(e){return!1}};if(Object.defineProperty){var S=_({}),E="undefined"==typeof document||_(document.createElement("div"));if(!S||!E)var O=Object.defineProperty,T=Object.defineProperties}if(!Object.defineProperty||O){var k="Property description must be an object: ",C="Object.defineProperty called on non-object: ",j="getters & setters can not be defined on this javascript engine";Object.defineProperty=function(i,s,a){if(h(i))throw new TypeError(C+i);if(h(a))throw new TypeError(k+a);if(O)try{return O.call(Object,i,s,a)}catch(c){}if("value"in a)if(u&&(n(i,s)||r(i,s))){var f=i.__proto__;i.__proto__=o,delete i[s],i[s]=a.value,i.__proto__=f}else i[s]=a.value;else{var l="get"in a,p="set"in a;if(!u&&(l||p))throw new TypeError(j);l&&t(i,s,a.get),p&&e(i,s,a.set)}return i}}Object.defineProperties&&!T||(Object.defineProperties=function(t,e){if(T)try{return T.call(Object,t,e)}catch(n){}return Object.keys(e).forEach(function(n){"__proto__"!==n&&Object.defineProperty(t,n,e[n])}),t}),Object.seal||(Object.seal=function(t){if(Object(t)!==t)throw new TypeError("Object.seal can only be called on Objects.");return t}),Object.freeze||(Object.freeze=function(t){if(Object(t)!==t)throw new TypeError("Object.freeze can only be called on Objects.");return t});try{Object.freeze(function(){})}catch(x){Object.freeze=function(t){return function(e){return"function"==typeof e?e:t(e)}}(Object.freeze)}Object.preventExtensions||(Object.preventExtensions=function(t){if(Object(t)!==t)throw new TypeError("Object.preventExtensions can only be called on Objects.");return t}),Object.isSealed||(Object.isSealed=function(t){if(Object(t)!==t)throw new TypeError("Object.isSealed can only be called on Objects.");return!1}),Object.isFrozen||(Object.isFrozen=function(t){if(Object(t)!==t)throw new TypeError("Object.isFrozen can only be called on Objects.");return!1}),Object.isExtensible||(Object.isExtensible=function(t){if(Object(t)!==t)throw new TypeError("Object.isExtensible can only be called on Objects.");for(var e="";s(t,e);)e+="?";t[e]=!0;var n=s(t,e);return delete t[e],n})})},function(t,e,n){function r(t,e){var n,r="0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(""),i=[];if(e=e||r.length,t)for(n=0;n<t;n++)i[n]=r[0|Math.random()*e];else{var o;for(i[8]=i[13]=i[18]=i[23]="-",i[14]="4",n=0;n<36;n++)i[n]||(o=0|16*Math.random(),i[n]=r[19==n?3&o|8:o])}return i.join("")}n(1),n(2);"undefined"==typeof window.WEB_SOCKET_DEBUG&&(window.WEB_SOCKET_DEBUG=!0),"undefined"==typeof window.WEB_SOCKET_SWF_LOCATION&&(window.WEB_SOCKET_SWF_LOCATION="https://static.mudu.tv/fetcher/WebSocketMainInsecure.swf"),"undefined"==typeof window.crypto&&(window.crypto=n(4)),window.crypto.randomBytes=function(t){return r(t,16)},window.WebSocket||window.MozWebSocket?window.WS_FEATURE="inner":(window.swfobject=n(65),n(66),window.WS_FEATURE="outer"),window.NATS=n(67),t.exports=n(80)},function(t,e,n){(function(r){function i(){var t=[].slice.call(arguments).join(" ");throw new Error([t,"we accept pull requests","http://github.com/dominictarr/crypto-browserify"].join("\n"))}function o(t,e){for(var n in t)e(t[n],n)}var s=n(9);e.createHash=n(11),e.createHmac=n(24),e.randomBytes=function(t,e){if(!e||!e.call)return new r(s(t));try{e.call(this,void 0,new r(s(t)))}catch(n){e(n)}},e.getHashes=function(){return["sha1","sha256","sha512","md5","rmd160"]};var a=n(25)(e);e.pbkdf2=a.pbkdf2,e.pbkdf2Sync=a.pbkdf2Sync,n(27)(e,t.exports),o(["createCredentials","createSign","createVerify","createDiffieHellman"],function(t){e[t]=function(){i("sorry,",t,"is not implemented yet")}})}).call(e,n(5).Buffer)},function(t,e,n){(function(t){/*!
		 * The buffer module from node.js, for the browser.
		 *
		 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
		 * @license  MIT
		 */
	"use strict";function r(){try{var t=new Uint8Array(1);return t.__proto__={__proto__:Uint8Array.prototype,foo:function(){return 42}},42===t.foo()&&"function"==typeof t.subarray&&0===t.subarray(1,1).byteLength}catch(e){return!1}}function i(){return s.TYPED_ARRAY_SUPPORT?2147483647:1073741823}function o(t,e){if(i()<e)throw new RangeError("Invalid typed array length");return s.TYPED_ARRAY_SUPPORT?(t=new Uint8Array(e),t.__proto__=s.prototype):(null===t&&(t=new s(e)),t.length=e),t}function s(t,e,n){if(!(s.TYPED_ARRAY_SUPPORT||this instanceof s))return new s(t,e,n);if("number"==typeof t){if("string"==typeof e)throw new Error("If encoding is specified then the first argument must be a string");return h(this,t)}return a(this,t,e,n)}function a(t,e,n,r){if("number"==typeof e)throw new TypeError('"value" argument must not be a number');return"undefined"!=typeof ArrayBuffer&&e instanceof ArrayBuffer?p(t,e,n,r):"string"==typeof e?f(t,e,n):d(t,e)}function c(t){if("number"!=typeof t)throw new TypeError('"size" argument must be a number');if(t<0)throw new RangeError('"size" argument must not be negative')}function u(t,e,n,r){return c(e),e<=0?o(t,e):void 0!==n?"string"==typeof r?o(t,e).fill(n,r):o(t,e).fill(n):o(t,e)}function h(t,e){if(c(e),t=o(t,e<0?0:0|v(e)),!s.TYPED_ARRAY_SUPPORT)for(var n=0;n<e;++n)t[n]=0;return t}function f(t,e,n){if("string"==typeof n&&""!==n||(n="utf8"),!s.isEncoding(n))throw new TypeError('"encoding" must be a valid string encoding');var r=0|g(e,n);t=o(t,r);var i=t.write(e,n);return i!==r&&(t=t.slice(0,i)),t}function l(t,e){var n=e.length<0?0:0|v(e.length);t=o(t,n);for(var r=0;r<n;r+=1)t[r]=255&e[r];return t}function p(t,e,n,r){if(e.byteLength,n<0||e.byteLength<n)throw new RangeError("'offset' is out of bounds");if(e.byteLength<n+(r||0))throw new RangeError("'length' is out of bounds");return e=void 0===n&&void 0===r?new Uint8Array(e):void 0===r?new Uint8Array(e,n):new Uint8Array(e,n,r),s.TYPED_ARRAY_SUPPORT?(t=e,t.__proto__=s.prototype):t=l(t,e),t}function d(t,e){if(s.isBuffer(e)){var n=0|v(e.length);return t=o(t,n),0===t.length?t:(e.copy(t,0,0,n),t)}if(e){if("undefined"!=typeof ArrayBuffer&&e.buffer instanceof ArrayBuffer||"length"in e)return"number"!=typeof e.length||H(e.length)?o(t,0):l(t,e);if("Buffer"===e.type&&Q(e.data))return l(t,e.data)}throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")}function v(t){if(t>=i())throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+i().toString(16)+" bytes");return 0|t}function y(t){return+t!=t&&(t=0),s.alloc(+t)}function g(t,e){if(s.isBuffer(t))return t.length;if("undefined"!=typeof ArrayBuffer&&"function"==typeof ArrayBuffer.isView&&(ArrayBuffer.isView(t)||t instanceof ArrayBuffer))return t.byteLength;"string"!=typeof t&&(t=""+t);var n=t.length;if(0===n)return 0;for(var r=!1;;)switch(e){case"ascii":case"latin1":case"binary":return n;case"utf8":case"utf-8":case void 0:return $(t).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*n;case"hex":return n>>>1;case"base64":return G(t).length;default:if(r)return $(t).length;e=(""+e).toLowerCase(),r=!0}}function b(t,e,n){var r=!1;if((void 0===e||e<0)&&(e=0),e>this.length)return"";if((void 0===n||n>this.length)&&(n=this.length),n<=0)return"";if(n>>>=0,e>>>=0,n<=e)return"";for(t||(t="utf8");;)switch(t){case"hex":return R(this,e,n);case"utf8":case"utf-8":return x(this,e,n);case"ascii":return A(this,e,n);case"latin1":case"binary":return I(this,e,n);case"base64":return j(this,e,n);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return M(this,e,n);default:if(r)throw new TypeError("Unknown encoding: "+t);t=(t+"").toLowerCase(),r=!0}}function w(t,e,n){var r=t[e];t[e]=t[n],t[n]=r}function m(t,e,n,r,i){if(0===t.length)return-1;if("string"==typeof n?(r=n,n=0):n>2147483647?n=2147483647:n<-2147483648&&(n=-2147483648),n=+n,isNaN(n)&&(n=i?0:t.length-1),n<0&&(n=t.length+n),n>=t.length){if(i)return-1;n=t.length-1}else if(n<0){if(!i)return-1;n=0}if("string"==typeof e&&(e=s.from(e,r)),s.isBuffer(e))return 0===e.length?-1:_(t,e,n,r,i);if("number"==typeof e)return e&=255,s.TYPED_ARRAY_SUPPORT&&"function"==typeof Uint8Array.prototype.indexOf?i?Uint8Array.prototype.indexOf.call(t,e,n):Uint8Array.prototype.lastIndexOf.call(t,e,n):_(t,[e],n,r,i);throw new TypeError("val must be string, number or Buffer")}function _(t,e,n,r,i){function o(t,e){return 1===s?t[e]:t.readUInt16BE(e*s)}var s=1,a=t.length,c=e.length;if(void 0!==r&&(r=String(r).toLowerCase(),"ucs2"===r||"ucs-2"===r||"utf16le"===r||"utf-16le"===r)){if(t.length<2||e.length<2)return-1;s=2,a/=2,c/=2,n/=2}var u;if(i){var h=-1;for(u=n;u<a;u++)if(o(t,u)===o(e,h===-1?0:u-h)){if(h===-1&&(h=u),u-h+1===c)return h*s}else h!==-1&&(u-=u-h),h=-1}else for(n+c>a&&(n=a-c),u=n;u>=0;u--){for(var f=!0,l=0;l<c;l++)if(o(t,u+l)!==o(e,l)){f=!1;break}if(f)return u}return-1}function S(t,e,n,r){n=Number(n)||0;var i=t.length-n;r?(r=Number(r),r>i&&(r=i)):r=i;var o=e.length;if(o%2!==0)throw new TypeError("Invalid hex string");r>o/2&&(r=o/2);for(var s=0;s<r;++s){var a=parseInt(e.substr(2*s,2),16);if(isNaN(a))return s;t[n+s]=a}return s}function E(t,e,n,r){return V($(e,t.length-n),t,n,r)}function O(t,e,n,r){return V(X(e),t,n,r)}function T(t,e,n,r){return O(t,e,n,r)}function k(t,e,n,r){return V(G(e),t,n,r)}function C(t,e,n,r){return V(J(e,t.length-n),t,n,r)}function j(t,e,n){return 0===e&&n===t.length?K.fromByteArray(t):K.fromByteArray(t.slice(e,n))}function x(t,e,n){n=Math.min(t.length,n);for(var r=[],i=e;i<n;){var o=t[i],s=null,a=o>239?4:o>223?3:o>191?2:1;if(i+a<=n){var c,u,h,f;switch(a){case 1:o<128&&(s=o);break;case 2:c=t[i+1],128===(192&c)&&(f=(31&o)<<6|63&c,f>127&&(s=f));break;case 3:c=t[i+1],u=t[i+2],128===(192&c)&&128===(192&u)&&(f=(15&o)<<12|(63&c)<<6|63&u,f>2047&&(f<55296||f>57343)&&(s=f));break;case 4:c=t[i+1],u=t[i+2],h=t[i+3],128===(192&c)&&128===(192&u)&&128===(192&h)&&(f=(15&o)<<18|(63&c)<<12|(63&u)<<6|63&h,f>65535&&f<1114112&&(s=f))}}null===s?(s=65533,a=1):s>65535&&(s-=65536,r.push(s>>>10&1023|55296),s=56320|1023&s),r.push(s),i+=a}return B(r)}function B(t){var e=t.length;if(e<=tt)return String.fromCharCode.apply(String,t);for(var n="",r=0;r<e;)n+=String.fromCharCode.apply(String,t.slice(r,r+=tt));return n}function A(t,e,n){var r="";n=Math.min(t.length,n);for(var i=e;i<n;++i)r+=String.fromCharCode(127&t[i]);return r}function I(t,e,n){var r="";n=Math.min(t.length,n);for(var i=e;i<n;++i)r+=String.fromCharCode(t[i]);return r}function R(t,e,n){var r=t.length;(!e||e<0)&&(e=0),(!n||n<0||n>r)&&(n=r);for(var i="",o=e;o<n;++o)i+=Y(t[o]);return i}function M(t,e,n){for(var r=t.slice(e,n),i="",o=0;o<r.length;o+=2)i+=String.fromCharCode(r[o]+256*r[o+1]);return i}function N(t,e,n){if(t%1!==0||t<0)throw new RangeError("offset is not uint");if(t+e>n)throw new RangeError("Trying to access beyond buffer length")}function U(t,e,n,r,i,o){if(!s.isBuffer(t))throw new TypeError('"buffer" argument must be a Buffer instance');if(e>i||e<o)throw new RangeError('"value" argument is out of bounds');if(n+r>t.length)throw new RangeError("Index out of range")}function P(t,e,n,r){e<0&&(e=65535+e+1);for(var i=0,o=Math.min(t.length-n,2);i<o;++i)t[n+i]=(e&255<<8*(r?i:1-i))>>>8*(r?i:1-i)}function D(t,e,n,r){e<0&&(e=4294967295+e+1);for(var i=0,o=Math.min(t.length-n,4);i<o;++i)t[n+i]=e>>>8*(r?i:3-i)&255}function L(t,e,n,r,i,o){if(n+r>t.length)throw new RangeError("Index out of range");if(n<0)throw new RangeError("Index out of range")}function W(t,e,n,r,i){return i||L(t,e,n,4,3.4028234663852886e38,-3.4028234663852886e38),Z.write(t,e,n,r,23,4),n+4}function F(t,e,n,r,i){return i||L(t,e,n,8,1.7976931348623157e308,-1.7976931348623157e308),Z.write(t,e,n,r,52,8),n+8}function z(t){if(t=q(t).replace(et,""),t.length<2)return"";for(;t.length%4!==0;)t+="=";return t}function q(t){return t.trim?t.trim():t.replace(/^\s+|\s+$/g,"")}function Y(t){return t<16?"0"+t.toString(16):t.toString(16)}function $(t,e){e=e||1/0;for(var n,r=t.length,i=null,o=[],s=0;s<r;++s){if(n=t.charCodeAt(s),n>55295&&n<57344){if(!i){if(n>56319){(e-=3)>-1&&o.push(239,191,189);continue}if(s+1===r){(e-=3)>-1&&o.push(239,191,189);continue}i=n;continue}if(n<56320){(e-=3)>-1&&o.push(239,191,189),i=n;continue}n=(i-55296<<10|n-56320)+65536}else i&&(e-=3)>-1&&o.push(239,191,189);if(i=null,n<128){if((e-=1)<0)break;o.push(n)}else if(n<2048){if((e-=2)<0)break;o.push(n>>6|192,63&n|128)}else if(n<65536){if((e-=3)<0)break;o.push(n>>12|224,n>>6&63|128,63&n|128)}else{if(!(n<1114112))throw new Error("Invalid code point");if((e-=4)<0)break;o.push(n>>18|240,n>>12&63|128,n>>6&63|128,63&n|128)}}return o}function X(t){for(var e=[],n=0;n<t.length;++n)e.push(255&t.charCodeAt(n));return e}function J(t,e){for(var n,r,i,o=[],s=0;s<t.length&&!((e-=2)<0);++s)n=t.charCodeAt(s),r=n>>8,i=n%256,o.push(i),o.push(r);return o}function G(t){return K.toByteArray(z(t))}function V(t,e,n,r){for(var i=0;i<r&&!(i+n>=e.length||i>=t.length);++i)e[i+n]=t[i];return i}function H(t){return t!==t}var K=n(6),Z=n(7),Q=n(8);e.Buffer=s,e.SlowBuffer=y,e.INSPECT_MAX_BYTES=50,s.TYPED_ARRAY_SUPPORT=void 0!==t.TYPED_ARRAY_SUPPORT?t.TYPED_ARRAY_SUPPORT:r(),e.kMaxLength=i(),s.poolSize=8192,s._augment=function(t){return t.__proto__=s.prototype,t},s.from=function(t,e,n){return a(null,t,e,n)},s.TYPED_ARRAY_SUPPORT&&(s.prototype.__proto__=Uint8Array.prototype,s.__proto__=Uint8Array,"undefined"!=typeof Symbol&&Symbol.species&&s[Symbol.species]===s&&Object.defineProperty(s,Symbol.species,{value:null,configurable:!0})),s.alloc=function(t,e,n){return u(null,t,e,n)},s.allocUnsafe=function(t){return h(null,t)},s.allocUnsafeSlow=function(t){return h(null,t)},s.isBuffer=function(t){return!(null==t||!t._isBuffer)},s.compare=function(t,e){if(!s.isBuffer(t)||!s.isBuffer(e))throw new TypeError("Arguments must be Buffers");if(t===e)return 0;for(var n=t.length,r=e.length,i=0,o=Math.min(n,r);i<o;++i)if(t[i]!==e[i]){n=t[i],r=e[i];break}return n<r?-1:r<n?1:0},s.isEncoding=function(t){switch(String(t).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},s.concat=function(t,e){if(!Q(t))throw new TypeError('"list" argument must be an Array of Buffers');if(0===t.length)return s.alloc(0);var n;if(void 0===e)for(e=0,n=0;n<t.length;++n)e+=t[n].length;var r=s.allocUnsafe(e),i=0;for(n=0;n<t.length;++n){var o=t[n];if(!s.isBuffer(o))throw new TypeError('"list" argument must be an Array of Buffers');o.copy(r,i),i+=o.length}return r},s.byteLength=g,s.prototype._isBuffer=!0,s.prototype.swap16=function(){var t=this.length;if(t%2!==0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var e=0;e<t;e+=2)w(this,e,e+1);return this},s.prototype.swap32=function(){var t=this.length;if(t%4!==0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var e=0;e<t;e+=4)w(this,e,e+3),w(this,e+1,e+2);return this},s.prototype.swap64=function(){var t=this.length;if(t%8!==0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var e=0;e<t;e+=8)w(this,e,e+7),w(this,e+1,e+6),w(this,e+2,e+5),w(this,e+3,e+4);return this},s.prototype.toString=function(){var t=0|this.length;return 0===t?"":0===arguments.length?x(this,0,t):b.apply(this,arguments)},s.prototype.equals=function(t){if(!s.isBuffer(t))throw new TypeError("Argument must be a Buffer");return this===t||0===s.compare(this,t)},s.prototype.inspect=function(){var t="",n=e.INSPECT_MAX_BYTES;return this.length>0&&(t=this.toString("hex",0,n).match(/.{2}/g).join(" "),this.length>n&&(t+=" ... ")),"<Buffer "+t+">"},s.prototype.compare=function(t,e,n,r,i){if(!s.isBuffer(t))throw new TypeError("Argument must be a Buffer");if(void 0===e&&(e=0),void 0===n&&(n=t?t.length:0),void 0===r&&(r=0),void 0===i&&(i=this.length),e<0||n>t.length||r<0||i>this.length)throw new RangeError("out of range index");if(r>=i&&e>=n)return 0;if(r>=i)return-1;if(e>=n)return 1;if(e>>>=0,n>>>=0,r>>>=0,i>>>=0,this===t)return 0;for(var o=i-r,a=n-e,c=Math.min(o,a),u=this.slice(r,i),h=t.slice(e,n),f=0;f<c;++f)if(u[f]!==h[f]){o=u[f],a=h[f];break}return o<a?-1:a<o?1:0},s.prototype.includes=function(t,e,n){return this.indexOf(t,e,n)!==-1},s.prototype.indexOf=function(t,e,n){return m(this,t,e,n,!0)},s.prototype.lastIndexOf=function(t,e,n){return m(this,t,e,n,!1)},s.prototype.write=function(t,e,n,r){if(void 0===e)r="utf8",n=this.length,e=0;else if(void 0===n&&"string"==typeof e)r=e,n=this.length,e=0;else{if(!isFinite(e))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");e|=0,isFinite(n)?(n|=0,void 0===r&&(r="utf8")):(r=n,n=void 0)}var i=this.length-e;if((void 0===n||n>i)&&(n=i),t.length>0&&(n<0||e<0)||e>this.length)throw new RangeError("Attempt to write outside buffer bounds");r||(r="utf8");for(var o=!1;;)switch(r){case"hex":return S(this,t,e,n);case"utf8":case"utf-8":return E(this,t,e,n);case"ascii":return O(this,t,e,n);case"latin1":case"binary":return T(this,t,e,n);case"base64":return k(this,t,e,n);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return C(this,t,e,n);default:if(o)throw new TypeError("Unknown encoding: "+r);r=(""+r).toLowerCase(),o=!0}},s.prototype.toJSON=function(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};var tt=4096;s.prototype.slice=function(t,e){var n=this.length;t=~~t,e=void 0===e?n:~~e,t<0?(t+=n,t<0&&(t=0)):t>n&&(t=n),e<0?(e+=n,e<0&&(e=0)):e>n&&(e=n),e<t&&(e=t);var r;if(s.TYPED_ARRAY_SUPPORT)r=this.subarray(t,e),r.__proto__=s.prototype;else{var i=e-t;r=new s(i,void 0);for(var o=0;o<i;++o)r[o]=this[o+t]}return r},s.prototype.readUIntLE=function(t,e,n){t|=0,e|=0,n||N(t,e,this.length);for(var r=this[t],i=1,o=0;++o<e&&(i*=256);)r+=this[t+o]*i;return r},s.prototype.readUIntBE=function(t,e,n){t|=0,e|=0,n||N(t,e,this.length);for(var r=this[t+--e],i=1;e>0&&(i*=256);)r+=this[t+--e]*i;return r},s.prototype.readUInt8=function(t,e){return e||N(t,1,this.length),this[t]},s.prototype.readUInt16LE=function(t,e){return e||N(t,2,this.length),this[t]|this[t+1]<<8},s.prototype.readUInt16BE=function(t,e){return e||N(t,2,this.length),this[t]<<8|this[t+1]},s.prototype.readUInt32LE=function(t,e){return e||N(t,4,this.length),(this[t]|this[t+1]<<8|this[t+2]<<16)+16777216*this[t+3]},s.prototype.readUInt32BE=function(t,e){return e||N(t,4,this.length),16777216*this[t]+(this[t+1]<<16|this[t+2]<<8|this[t+3])},s.prototype.readIntLE=function(t,e,n){t|=0,e|=0,n||N(t,e,this.length);for(var r=this[t],i=1,o=0;++o<e&&(i*=256);)r+=this[t+o]*i;return i*=128,r>=i&&(r-=Math.pow(2,8*e)),r},s.prototype.readIntBE=function(t,e,n){t|=0,e|=0,n||N(t,e,this.length);for(var r=e,i=1,o=this[t+--r];r>0&&(i*=256);)o+=this[t+--r]*i;return i*=128,o>=i&&(o-=Math.pow(2,8*e)),o},s.prototype.readInt8=function(t,e){return e||N(t,1,this.length),128&this[t]?(255-this[t]+1)*-1:this[t]},s.prototype.readInt16LE=function(t,e){e||N(t,2,this.length);var n=this[t]|this[t+1]<<8;return 32768&n?4294901760|n:n},s.prototype.readInt16BE=function(t,e){e||N(t,2,this.length);var n=this[t+1]|this[t]<<8;return 32768&n?4294901760|n:n},s.prototype.readInt32LE=function(t,e){return e||N(t,4,this.length),this[t]|this[t+1]<<8|this[t+2]<<16|this[t+3]<<24},s.prototype.readInt32BE=function(t,e){return e||N(t,4,this.length),this[t]<<24|this[t+1]<<16|this[t+2]<<8|this[t+3]},s.prototype.readFloatLE=function(t,e){return e||N(t,4,this.length),Z.read(this,t,!0,23,4)},s.prototype.readFloatBE=function(t,e){return e||N(t,4,this.length),Z.read(this,t,!1,23,4)},s.prototype.readDoubleLE=function(t,e){return e||N(t,8,this.length),Z.read(this,t,!0,52,8)},s.prototype.readDoubleBE=function(t,e){return e||N(t,8,this.length),Z.read(this,t,!1,52,8)},s.prototype.writeUIntLE=function(t,e,n,r){if(t=+t,e|=0,n|=0,!r){var i=Math.pow(2,8*n)-1;U(this,t,e,n,i,0)}var o=1,s=0;for(this[e]=255&t;++s<n&&(o*=256);)this[e+s]=t/o&255;return e+n},s.prototype.writeUIntBE=function(t,e,n,r){if(t=+t,e|=0,n|=0,!r){var i=Math.pow(2,8*n)-1;U(this,t,e,n,i,0)}var o=n-1,s=1;for(this[e+o]=255&t;--o>=0&&(s*=256);)this[e+o]=t/s&255;return e+n},s.prototype.writeUInt8=function(t,e,n){return t=+t,e|=0,n||U(this,t,e,1,255,0),s.TYPED_ARRAY_SUPPORT||(t=Math.floor(t)),this[e]=255&t,e+1},s.prototype.writeUInt16LE=function(t,e,n){return t=+t,e|=0,n||U(this,t,e,2,65535,0),s.TYPED_ARRAY_SUPPORT?(this[e]=255&t,this[e+1]=t>>>8):P(this,t,e,!0),e+2},s.prototype.writeUInt16BE=function(t,e,n){return t=+t,e|=0,n||U(this,t,e,2,65535,0),s.TYPED_ARRAY_SUPPORT?(this[e]=t>>>8,this[e+1]=255&t):P(this,t,e,!1),e+2},s.prototype.writeUInt32LE=function(t,e,n){return t=+t,e|=0,n||U(this,t,e,4,4294967295,0),s.TYPED_ARRAY_SUPPORT?(this[e+3]=t>>>24,this[e+2]=t>>>16,this[e+1]=t>>>8,this[e]=255&t):D(this,t,e,!0),e+4},s.prototype.writeUInt32BE=function(t,e,n){return t=+t,e|=0,n||U(this,t,e,4,4294967295,0),s.TYPED_ARRAY_SUPPORT?(this[e]=t>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t):D(this,t,e,!1),e+4},s.prototype.writeIntLE=function(t,e,n,r){if(t=+t,e|=0,!r){var i=Math.pow(2,8*n-1);U(this,t,e,n,i-1,-i)}var o=0,s=1,a=0;for(this[e]=255&t;++o<n&&(s*=256);)t<0&&0===a&&0!==this[e+o-1]&&(a=1),this[e+o]=(t/s>>0)-a&255;return e+n},s.prototype.writeIntBE=function(t,e,n,r){if(t=+t,e|=0,!r){var i=Math.pow(2,8*n-1);U(this,t,e,n,i-1,-i)}var o=n-1,s=1,a=0;for(this[e+o]=255&t;--o>=0&&(s*=256);)t<0&&0===a&&0!==this[e+o+1]&&(a=1),this[e+o]=(t/s>>0)-a&255;return e+n},s.prototype.writeInt8=function(t,e,n){return t=+t,e|=0,n||U(this,t,e,1,127,-128),s.TYPED_ARRAY_SUPPORT||(t=Math.floor(t)),t<0&&(t=255+t+1),this[e]=255&t,e+1},s.prototype.writeInt16LE=function(t,e,n){return t=+t,e|=0,n||U(this,t,e,2,32767,-32768),s.TYPED_ARRAY_SUPPORT?(this[e]=255&t,this[e+1]=t>>>8):P(this,t,e,!0),e+2},s.prototype.writeInt16BE=function(t,e,n){return t=+t,e|=0,n||U(this,t,e,2,32767,-32768),s.TYPED_ARRAY_SUPPORT?(this[e]=t>>>8,this[e+1]=255&t):P(this,t,e,!1),e+2},s.prototype.writeInt32LE=function(t,e,n){return t=+t,e|=0,n||U(this,t,e,4,2147483647,-2147483648),s.TYPED_ARRAY_SUPPORT?(this[e]=255&t,this[e+1]=t>>>8,this[e+2]=t>>>16,this[e+3]=t>>>24):D(this,t,e,!0),e+4},s.prototype.writeInt32BE=function(t,e,n){return t=+t,e|=0,n||U(this,t,e,4,2147483647,-2147483648),t<0&&(t=4294967295+t+1),s.TYPED_ARRAY_SUPPORT?(this[e]=t>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t):D(this,t,e,!1),e+4},s.prototype.writeFloatLE=function(t,e,n){return W(this,t,e,!0,n)},s.prototype.writeFloatBE=function(t,e,n){return W(this,t,e,!1,n)},s.prototype.writeDoubleLE=function(t,e,n){return F(this,t,e,!0,n)},s.prototype.writeDoubleBE=function(t,e,n){return F(this,t,e,!1,n)},s.prototype.copy=function(t,e,n,r){if(n||(n=0),r||0===r||(r=this.length),e>=t.length&&(e=t.length),e||(e=0),r>0&&r<n&&(r=n),r===n)return 0;if(0===t.length||0===this.length)return 0;if(e<0)throw new RangeError("targetStart out of bounds");if(n<0||n>=this.length)throw new RangeError("sourceStart out of bounds");if(r<0)throw new RangeError("sourceEnd out of bounds");r>this.length&&(r=this.length),t.length-e<r-n&&(r=t.length-e+n);var i,o=r-n;if(this===t&&n<e&&e<r)for(i=o-1;i>=0;--i)t[i+e]=this[i+n];else if(o<1e3||!s.TYPED_ARRAY_SUPPORT)for(i=0;i<o;++i)t[i+e]=this[i+n];else Uint8Array.prototype.set.call(t,this.subarray(n,n+o),e);return o},s.prototype.fill=function(t,e,n,r){if("string"==typeof t){if("string"==typeof e?(r=e,e=0,n=this.length):"string"==typeof n&&(r=n,n=this.length),1===t.length){var i=t.charCodeAt(0);i<256&&(t=i)}if(void 0!==r&&"string"!=typeof r)throw new TypeError("encoding must be a string");if("string"==typeof r&&!s.isEncoding(r))throw new TypeError("Unknown encoding: "+r)}else"number"==typeof t&&(t&=255);if(e<0||this.length<e||this.length<n)throw new RangeError("Out of range index");if(n<=e)return this;e>>>=0,n=void 0===n?this.length:n>>>0,t||(t=0);var o;if("number"==typeof t)for(o=e;o<n;++o)this[o]=t;else{var a=s.isBuffer(t)?t:$(new s(t,r).toString()),c=a.length;for(o=0;o<n-e;++o)this[o+e]=a[o%c]}return this};var et=/[^+\/0-9A-Za-z-_]/g}).call(e,function(){return this}())},function(t,e){"use strict";function n(t){var e=t.length;if(e%4>0)throw new Error("Invalid string. Length must be a multiple of 4");return"="===t[e-2]?2:"="===t[e-1]?1:0}function r(t){return 3*t.length/4-n(t)}function i(t){var e,r,i,o,s,a=t.length;o=n(t),s=new h(3*a/4-o),r=o>0?a-4:a;var c=0;for(e=0;e<r;e+=4)i=u[t.charCodeAt(e)]<<18|u[t.charCodeAt(e+1)]<<12|u[t.charCodeAt(e+2)]<<6|u[t.charCodeAt(e+3)],s[c++]=i>>16&255,s[c++]=i>>8&255,s[c++]=255&i;return 2===o?(i=u[t.charCodeAt(e)]<<2|u[t.charCodeAt(e+1)]>>4,s[c++]=255&i):1===o&&(i=u[t.charCodeAt(e)]<<10|u[t.charCodeAt(e+1)]<<4|u[t.charCodeAt(e+2)]>>2,s[c++]=i>>8&255,s[c++]=255&i),s}function o(t){return c[t>>18&63]+c[t>>12&63]+c[t>>6&63]+c[63&t]}function s(t,e,n){for(var r,i=[],s=e;s<n;s+=3)r=(t[s]<<16)+(t[s+1]<<8)+t[s+2],i.push(o(r));return i.join("")}function a(t){for(var e,n=t.length,r=n%3,i="",o=[],a=16383,u=0,h=n-r;u<h;u+=a)o.push(s(t,u,u+a>h?h:u+a));return 1===r?(e=t[n-1],i+=c[e>>2],i+=c[e<<4&63],i+="=="):2===r&&(e=(t[n-2]<<8)+t[n-1],i+=c[e>>10],i+=c[e>>4&63],i+=c[e<<2&63],i+="="),o.push(i),o.join("")}e.byteLength=r,e.toByteArray=i,e.fromByteArray=a;for(var c=[],u=[],h="undefined"!=typeof Uint8Array?Uint8Array:Array,f="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",l=0,p=f.length;l<p;++l)c[l]=f[l],u[f.charCodeAt(l)]=l;u["-".charCodeAt(0)]=62,u["_".charCodeAt(0)]=63},function(t,e){e.read=function(t,e,n,r,i){var o,s,a=8*i-r-1,c=(1<<a)-1,u=c>>1,h=-7,f=n?i-1:0,l=n?-1:1,p=t[e+f];for(f+=l,o=p&(1<<-h)-1,p>>=-h,h+=a;h>0;o=256*o+t[e+f],f+=l,h-=8);for(s=o&(1<<-h)-1,o>>=-h,h+=r;h>0;s=256*s+t[e+f],f+=l,h-=8);if(0===o)o=1-u;else{if(o===c)return s?NaN:(p?-1:1)*(1/0);s+=Math.pow(2,r),o-=u}return(p?-1:1)*s*Math.pow(2,o-r)},e.write=function(t,e,n,r,i,o){var s,a,c,u=8*o-i-1,h=(1<<u)-1,f=h>>1,l=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,p=r?0:o-1,d=r?1:-1,v=e<0||0===e&&1/e<0?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(a=isNaN(e)?1:0,s=h):(s=Math.floor(Math.log(e)/Math.LN2),e*(c=Math.pow(2,-s))<1&&(s--,c*=2),e+=s+f>=1?l/c:l*Math.pow(2,1-f),e*c>=2&&(s++,c/=2),s+f>=h?(a=0,s=h):s+f>=1?(a=(e*c-1)*Math.pow(2,i),s+=f):(a=e*Math.pow(2,f-1)*Math.pow(2,i),s=0));i>=8;t[n+p]=255&a,p+=d,a/=256,i-=8);for(s=s<<i|a,u+=i;u>0;t[n+p]=255&s,p+=d,s/=256,u-=8);t[n+p-d]|=128*v}},function(t,e){var n={}.toString;t.exports=Array.isArray||function(t){return"[object Array]"==n.call(t)}},function(t,e,n){(function(e,r){!function(){var i=("undefined"==typeof window?e:window)||{};_crypto=i.crypto||i.msCrypto||n(10),t.exports=function(t){if(_crypto.getRandomValues){var e=new r(t);return _crypto.getRandomValues(e),e}if(_crypto.randomBytes)return _crypto.randomBytes(t);throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11")}}()}).call(e,function(){return this}(),n(5).Buffer)},function(t,e){},function(t,e,n){(function(e){function r(t){return function(){var n=[],r={update:function(t,r){return e.isBuffer(t)||(t=new e(t,r)),n.push(t),this},digest:function(r){var i=e.concat(n),o=t(i);return n=null,r?o.toString(r):o}};return r}}var i=n(12),o=r(n(21)),s=r(n(23));t.exports=function(t){return"md5"===t?new o:"rmd160"===t?new s:i(t)}}).call(e,n(5).Buffer)},function(t,e,n){var e=t.exports=function(t){var n=e[t];if(!n)throw new Error(t+" is not supported (we accept pull requests)");return new n},r=n(5).Buffer,i=n(13)(r);e.sha1=n(14)(r,i),e.sha256=n(19)(r,i),e.sha512=n(20)(r,i)},function(t,e){t.exports=function(t){function e(e,n){this._block=new t(e),this._finalSize=n,this._blockSize=e,this._len=0,this._s=0}return e.prototype.init=function(){this._s=0,this._len=0},e.prototype.update=function(e,n){"string"==typeof e&&(n=n||"utf8",e=new t(e,n));for(var r=this._len+=e.length,i=this._s=this._s||0,o=0,s=this._block;i<r;){for(var a=Math.min(e.length,o+this._blockSize-i%this._blockSize),c=a-o,u=0;u<c;u++)s[i%this._blockSize+u]=e[u+o];i+=c,o+=c,i%this._blockSize===0&&this._update(s)}return this._s=i,this},e.prototype.digest=function(t){var e=8*this._len;this._block[this._len%this._blockSize]=128,this._block.fill(0,this._len%this._blockSize+1),e%(8*this._blockSize)>=8*this._finalSize&&(this._update(this._block),this._block.fill(0)),this._block.writeInt32BE(e,this._blockSize-4);var n=this._update(this._block)||this._hash();return t?n.toString(t):n},e.prototype._update=function(){throw new Error("_update must be implemented by subclass")},e}},function(t,e,n){var r=n(15).inherits;t.exports=function(t,e){function n(){return d.length?d.pop().init():this instanceof n?(this._w=p,e.call(this,64,56),this._h=null,void this.init()):new n}function i(t,e,n,r){return t<20?e&n|~e&r:t<40?e^n^r:t<60?e&n|e&r|n&r:e^n^r}function o(t){return t<20?1518500249:t<40?1859775393:t<60?-1894007588:-899497514}function s(t,e){return t+e|0}function a(t,e){return t<<e|t>>>32-e}var c=0,u=4,h=8,f=12,l=16,p=new("undefined"==typeof Int32Array?Array:Int32Array)(80),d=[];return r(n,e),n.prototype.init=function(){return this._a=1732584193,this._b=4023233417,this._c=2562383102,this._d=271733878,this._e=3285377520,e.prototype.init.call(this),this},n.prototype._POOL=d,n.prototype._update=function(t){var e,n,r,c,u,h,f,l,p,d;e=h=this._a,n=f=this._b,r=l=this._c,c=p=this._d,u=d=this._e;for(var v=this._w,y=0;y<80;y++){var g=v[y]=y<16?t.readInt32BE(4*y):a(v[y-3]^v[y-8]^v[y-14]^v[y-16],1),b=s(s(a(e,5),i(y,n,r,c)),s(s(u,g),o(y)));u=c,c=r,r=a(n,30),n=e,e=b}this._a=s(e,h),this._b=s(n,f),this._c=s(r,l),this._d=s(c,p),this._e=s(u,d)},n.prototype._hash=function(){d.length<100&&d.push(this);var e=new t(20);return e.writeInt32BE(0|this._a,c),e.writeInt32BE(0|this._b,u),e.writeInt32BE(0|this._c,h),e.writeInt32BE(0|this._d,f),e.writeInt32BE(0|this._e,l),e},n}},function(t,e,n){(function(t,r){function i(t,n){var r={seen:[],stylize:s};return arguments.length>=3&&(r.depth=arguments[2]),arguments.length>=4&&(r.colors=arguments[3]),v(n)?r.showHidden=n:n&&e._extend(r,n),_(r.showHidden)&&(r.showHidden=!1),_(r.depth)&&(r.depth=2),_(r.colors)&&(r.colors=!1),_(r.customInspect)&&(r.customInspect=!0),r.colors&&(r.stylize=o),c(r,t,r.depth)}function o(t,e){var n=i.styles[e];return n?"["+i.colors[n][0]+"m"+t+"["+i.colors[n][1]+"m":t}function s(t,e){return t}function a(t){var e={};return t.forEach(function(t,n){e[t]=!0}),e}function c(t,n,r){if(t.customInspect&&n&&k(n.inspect)&&n.inspect!==e.inspect&&(!n.constructor||n.constructor.prototype!==n)){var i=n.inspect(r,t);return w(i)||(i=c(t,i,r)),i}var o=u(t,n);if(o)return o;var s=Object.keys(n),v=a(s);if(t.showHidden&&(s=Object.getOwnPropertyNames(n)),T(n)&&(s.indexOf("message")>=0||s.indexOf("description")>=0))return h(n);if(0===s.length){if(k(n)){var y=n.name?": "+n.name:"";return t.stylize("[Function"+y+"]","special")}if(S(n))return t.stylize(RegExp.prototype.toString.call(n),"regexp");if(O(n))return t.stylize(Date.prototype.toString.call(n),"date");if(T(n))return h(n)}var g="",b=!1,m=["{","}"];if(d(n)&&(b=!0,m=["[","]"]),k(n)){var _=n.name?": "+n.name:"";g=" [Function"+_+"]"}if(S(n)&&(g=" "+RegExp.prototype.toString.call(n)),O(n)&&(g=" "+Date.prototype.toUTCString.call(n)),T(n)&&(g=" "+h(n)),0===s.length&&(!b||0==n.length))return m[0]+g+m[1];if(r<0)return S(n)?t.stylize(RegExp.prototype.toString.call(n),"regexp"):t.stylize("[Object]","special");t.seen.push(n);var E;return E=b?f(t,n,r,v,s):s.map(function(e){return l(t,n,r,v,e,b)}),t.seen.pop(),p(E,g,m)}function u(t,e){if(_(e))return t.stylize("undefined","undefined");if(w(e)){var n="'"+JSON.stringify(e).replace(/^"|"$/g,"").replace(/'/g,"\\'").replace(/\\"/g,'"')+"'";return t.stylize(n,"string")}return b(e)?t.stylize(""+e,"number"):v(e)?t.stylize(""+e,"boolean"):y(e)?t.stylize("null","null"):void 0}function h(t){return"["+Error.prototype.toString.call(t)+"]"}function f(t,e,n,r,i){for(var o=[],s=0,a=e.length;s<a;++s)A(e,String(s))?o.push(l(t,e,n,r,String(s),!0)):o.push("");return i.forEach(function(i){i.match(/^\d+$/)||o.push(l(t,e,n,r,i,!0))}),o}function l(t,e,n,r,i,o){var s,a,u;if(u=Object.getOwnPropertyDescriptor(e,i)||{value:e[i]},u.get?a=u.set?t.stylize("[Getter/Setter]","special"):t.stylize("[Getter]","special"):u.set&&(a=t.stylize("[Setter]","special")),A(r,i)||(s="["+i+"]"),a||(t.seen.indexOf(u.value)<0?(a=y(n)?c(t,u.value,null):c(t,u.value,n-1),a.indexOf("\n")>-1&&(a=o?a.split("\n").map(function(t){return"  "+t}).join("\n").substr(2):"\n"+a.split("\n").map(function(t){return"   "+t}).join("\n"))):a=t.stylize("[Circular]","special")),_(s)){if(o&&i.match(/^\d+$/))return a;s=JSON.stringify(""+i),s.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)?(s=s.substr(1,s.length-2),s=t.stylize(s,"name")):(s=s.replace(/'/g,"\\'").replace(/\\"/g,'"').replace(/(^"|"$)/g,"'"),s=t.stylize(s,"string"))}return s+": "+a}function p(t,e,n){var r=0,i=t.reduce(function(t,e){return r++,e.indexOf("\n")>=0&&r++,t+e.replace(/\u001b\[\d\d?m/g,"").length+1},0);return i>60?n[0]+(""===e?"":e+"\n ")+" "+t.join(",\n  ")+" "+n[1]:n[0]+e+" "+t.join(", ")+" "+n[1]}function d(t){return Array.isArray(t)}function v(t){return"boolean"==typeof t}function y(t){return null===t}function g(t){return null==t}function b(t){return"number"==typeof t}function w(t){return"string"==typeof t}function m(t){return"symbol"==typeof t}function _(t){return void 0===t}function S(t){return E(t)&&"[object RegExp]"===j(t)}function E(t){return"object"==typeof t&&null!==t}function O(t){return E(t)&&"[object Date]"===j(t)}function T(t){return E(t)&&("[object Error]"===j(t)||t instanceof Error)}function k(t){return"function"==typeof t}function C(t){return null===t||"boolean"==typeof t||"number"==typeof t||"string"==typeof t||"symbol"==typeof t||"undefined"==typeof t}function j(t){return Object.prototype.toString.call(t)}function x(t){return t<10?"0"+t.toString(10):t.toString(10)}function B(){var t=new Date,e=[x(t.getHours()),x(t.getMinutes()),x(t.getSeconds())].join(":");return[t.getDate(),N[t.getMonth()],e].join(" ")}function A(t,e){return Object.prototype.hasOwnProperty.call(t,e)}var I=/%[sdj%]/g;e.format=function(t){if(!w(t)){for(var e=[],n=0;n<arguments.length;n++)e.push(i(arguments[n]));return e.join(" ")}for(var n=1,r=arguments,o=r.length,s=String(t).replace(I,function(t){if("%%"===t)return"%";if(n>=o)return t;switch(t){case"%s":return String(r[n++]);case"%d":return Number(r[n++]);case"%j":try{return JSON.stringify(r[n++])}catch(e){return"[Circular]"}default:return t}}),a=r[n];n<o;a=r[++n])s+=y(a)||!E(a)?" "+a:" "+i(a);return s},e.deprecate=function(n,i){function o(){if(!s){if(r.throwDeprecation)throw new Error(i);r.traceDeprecation?console.trace(i):console.error(i),s=!0}return n.apply(this,arguments)}if(_(t.process))return function(){return e.deprecate(n,i).apply(this,arguments)};if(r.noDeprecation===!0)return n;var s=!1;return o};var R,M={};e.debuglog=function(t){if(_(R)&&(R=r.env.NODE_DEBUG||""),t=t.toUpperCase(),!M[t])if(new RegExp("\\b"+t+"\\b","i").test(R)){var n=r.pid;M[t]=function(){var r=e.format.apply(e,arguments);console.error("%s %d: %s",t,n,r)}}else M[t]=function(){};return M[t]},e.inspect=i,i.colors={bold:[1,22],italic:[3,23],underline:[4,24],inverse:[7,27],white:[37,39],grey:[90,39],black:[30,39],blue:[34,39],cyan:[36,39],green:[32,39],magenta:[35,39],red:[31,39],yellow:[33,39]},i.styles={special:"cyan",number:"yellow","boolean":"yellow",undefined:"grey","null":"bold",string:"green",date:"magenta",regexp:"red"},e.isArray=d,e.isBoolean=v,e.isNull=y,e.isNullOrUndefined=g,e.isNumber=b,e.isString=w,e.isSymbol=m,e.isUndefined=_,e.isRegExp=S,e.isObject=E,e.isDate=O,e.isError=T,e.isFunction=k,e.isPrimitive=C,e.isBuffer=n(17);var N=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];e.log=function(){console.log("%s - %s",B(),e.format.apply(e,arguments))},e.inherits=n(18),e._extend=function(t,e){if(!e||!E(e))return t;for(var n=Object.keys(e),r=n.length;r--;)t[n[r]]=e[n[r]];return t}}).call(e,function(){return this}(),n(16))},function(t,e){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function i(t){if(h===setTimeout)return setTimeout(t,0);if((h===n||!h)&&setTimeout)return h=setTimeout,setTimeout(t,0);try{return h(t,0)}catch(e){try{return h.call(null,t,0);
	}catch(e){return h.call(this,t,0)}}}function o(t){if(f===clearTimeout)return clearTimeout(t);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(t);try{return f(t)}catch(e){try{return f.call(null,t)}catch(e){return f.call(this,t)}}}function s(){v&&p&&(v=!1,p.length?d=p.concat(d):y=-1,d.length&&a())}function a(){if(!v){var t=i(s);v=!0;for(var e=d.length;e;){for(p=d,d=[];++y<e;)p&&p[y].run();y=-1,e=d.length}p=null,v=!1,o(t)}}function c(t,e){this.fun=t,this.array=e}function u(){}var h,f,l=t.exports={};!function(){try{h="function"==typeof setTimeout?setTimeout:n}catch(t){h=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(t){f=r}}();var p,d=[],v=!1,y=-1;l.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];d.push(new c(t,e)),1!==d.length||v||i(a)},c.prototype.run=function(){this.fun.apply(null,this.array)},l.title="browser",l.browser=!0,l.env={},l.argv=[],l.version="",l.versions={},l.on=u,l.addListener=u,l.once=u,l.off=u,l.removeListener=u,l.removeAllListeners=u,l.emit=u,l.prependListener=u,l.prependOnceListener=u,l.listeners=function(t){return[]},l.binding=function(t){throw new Error("process.binding is not supported")},l.cwd=function(){return"/"},l.chdir=function(t){throw new Error("process.chdir is not supported")},l.umask=function(){return 0}},function(t,e){t.exports=function(t){return t&&"object"==typeof t&&"function"==typeof t.copy&&"function"==typeof t.fill&&"function"==typeof t.readUInt8}},function(t,e){"function"==typeof Object.create?t.exports=function(t,e){t.super_=e,t.prototype=Object.create(e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}})}:t.exports=function(t,e){t.super_=e;var n=function(){};n.prototype=e.prototype,t.prototype=new n,t.prototype.constructor=t}},function(t,e,n){var r=n(15).inherits;t.exports=function(t,e){function n(){this.init(),this._w=p,e.call(this,64,56)}function i(t,e){return t>>>e|t<<32-e}function o(t,e){return t>>>e}function s(t,e,n){return t&e^~t&n}function a(t,e,n){return t&e^t&n^e&n}function c(t){return i(t,2)^i(t,13)^i(t,22)}function u(t){return i(t,6)^i(t,11)^i(t,25)}function h(t){return i(t,7)^i(t,18)^o(t,3)}function f(t){return i(t,17)^i(t,19)^o(t,10)}var l=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298],p=new Array(64);return r(n,e),n.prototype.init=function(){return this._a=1779033703,this._b=-1150833019,this._c=1013904242,this._d=-1521486534,this._e=1359893119,this._f=-1694144372,this._g=528734635,this._h=1541459225,this._len=this._s=0,this},n.prototype._update=function(t){var e,n,r,i,o,p,d,v,y,g,b=this._w;e=0|this._a,n=0|this._b,r=0|this._c,i=0|this._d,o=0|this._e,p=0|this._f,d=0|this._g,v=0|this._h;for(var w=0;w<64;w++){var m=b[w]=w<16?t.readInt32BE(4*w):f(b[w-2])+b[w-7]+h(b[w-15])+b[w-16];y=v+u(o)+s(o,p,d)+l[w]+m,g=c(e)+a(e,n,r),v=d,d=p,p=o,o=i+y,i=r,r=n,n=e,e=y+g}this._a=e+this._a|0,this._b=n+this._b|0,this._c=r+this._c|0,this._d=i+this._d|0,this._e=o+this._e|0,this._f=p+this._f|0,this._g=d+this._g|0,this._h=v+this._h|0},n.prototype._hash=function(){var e=new t(32);return e.writeInt32BE(this._a,0),e.writeInt32BE(this._b,4),e.writeInt32BE(this._c,8),e.writeInt32BE(this._d,12),e.writeInt32BE(this._e,16),e.writeInt32BE(this._f,20),e.writeInt32BE(this._g,24),e.writeInt32BE(this._h,28),e},n}},function(t,e,n){var r=n(15).inherits;t.exports=function(t,e){function n(){this.init(),this._w=c,e.call(this,128,112)}function i(t,e,n){return t>>>n|e<<32-n}function o(t,e,n){return t&e^~t&n}function s(t,e,n){return t&e^t&n^e&n}var a=[1116352408,3609767458,1899447441,602891725,3049323471,3964484399,3921009573,2173295548,961987163,4081628472,1508970993,3053834265,2453635748,2937671579,2870763221,3664609560,3624381080,2734883394,310598401,1164996542,607225278,1323610764,1426881987,3590304994,1925078388,4068182383,2162078206,991336113,2614888103,633803317,3248222580,3479774868,3835390401,2666613458,4022224774,944711139,264347078,2341262773,604807628,2007800933,770255983,1495990901,1249150122,1856431235,1555081692,3175218132,1996064986,2198950837,2554220882,3999719339,2821834349,766784016,2952996808,2566594879,3210313671,3203337956,3336571891,1034457026,3584528711,2466948901,113926993,3758326383,338241895,168717936,666307205,1188179964,773529912,1546045734,1294757372,1522805485,1396182291,2643833823,1695183700,2343527390,1986661051,1014477480,2177026350,1206759142,2456956037,344077627,2730485921,1290863460,2820302411,3158454273,3259730800,3505952657,3345764771,106217008,3516065817,3606008344,3600352804,1432725776,4094571909,1467031594,275423344,851169720,430227734,3100823752,506948616,1363258195,659060556,3750685593,883997877,3785050280,958139571,3318307427,1322822218,3812723403,1537002063,2003034995,1747873779,3602036899,1955562222,1575990012,2024104815,1125592928,2227730452,2716904306,2361852424,442776044,2428436474,593698344,2756734187,3733110249,3204031479,2999351573,3329325298,3815920427,3391569614,3928383900,3515267271,566280711,3940187606,3454069534,4118630271,4000239992,116418474,1914138554,174292421,2731055270,289380356,3203993006,460393269,320620315,685471733,587496836,852142971,1086792851,1017036298,365543100,1126000580,2618297676,1288033470,3409855158,1501505948,4234509866,1607167915,987167468,1816402316,1246189591],c=new Array(160);return r(n,e),n.prototype.init=function(){return this._a=1779033703,this._b=-1150833019,this._c=1013904242,this._d=-1521486534,this._e=1359893119,this._f=-1694144372,this._g=528734635,this._h=1541459225,this._al=-205731576,this._bl=-2067093701,this._cl=-23791573,this._dl=1595750129,this._el=-1377402159,this._fl=725511199,this._gl=-79577749,this._hl=327033209,this._len=this._s=0,this},n.prototype._update=function(t){var e,n,r,c,u,h,f,l,p,d,v,y,g,b,w,m,_=this._w;e=0|this._a,n=0|this._b,r=0|this._c,c=0|this._d,u=0|this._e,h=0|this._f,f=0|this._g,l=0|this._h,p=0|this._al,d=0|this._bl,v=0|this._cl,y=0|this._dl,g=0|this._el,b=0|this._fl,w=0|this._gl,m=0|this._hl;for(var S=0;S<80;S++){var E,O,T=2*S;if(S<16)E=_[T]=t.readInt32BE(4*T),O=_[T+1]=t.readInt32BE(4*T+4);else{var k=_[T-30],C=_[T-30+1],j=i(k,C,1)^i(k,C,8)^k>>>7,x=i(C,k,1)^i(C,k,8)^i(C,k,7);k=_[T-4],C=_[T-4+1];var B=i(k,C,19)^i(C,k,29)^k>>>6,A=i(C,k,19)^i(k,C,29)^i(C,k,6),I=_[T-14],R=_[T-14+1],M=_[T-32],N=_[T-32+1];O=x+R,E=j+I+(O>>>0<x>>>0?1:0),O+=A,E=E+B+(O>>>0<A>>>0?1:0),O+=N,E=E+M+(O>>>0<N>>>0?1:0),_[T]=E,_[T+1]=O}var U=s(e,n,r),P=s(p,d,v),D=i(e,p,28)^i(p,e,2)^i(p,e,7),L=i(p,e,28)^i(e,p,2)^i(e,p,7),W=i(u,g,14)^i(u,g,18)^i(g,u,9),F=i(g,u,14)^i(g,u,18)^i(u,g,9),z=a[T],q=a[T+1],Y=o(u,h,f),$=o(g,b,w),X=m+F,J=l+W+(X>>>0<m>>>0?1:0);X+=$,J=J+Y+(X>>>0<$>>>0?1:0),X+=q,J=J+z+(X>>>0<q>>>0?1:0),X+=O,J=J+E+(X>>>0<O>>>0?1:0);var G=L+P,V=D+U+(G>>>0<L>>>0?1:0);l=f,m=w,f=h,w=b,h=u,b=g,g=y+X|0,u=c+J+(g>>>0<y>>>0?1:0)|0,c=r,y=v,r=n,v=d,n=e,d=p,p=X+G|0,e=J+V+(p>>>0<X>>>0?1:0)|0}this._al=this._al+p|0,this._bl=this._bl+d|0,this._cl=this._cl+v|0,this._dl=this._dl+y|0,this._el=this._el+g|0,this._fl=this._fl+b|0,this._gl=this._gl+w|0,this._hl=this._hl+m|0,this._a=this._a+e+(this._al>>>0<p>>>0?1:0)|0,this._b=this._b+n+(this._bl>>>0<d>>>0?1:0)|0,this._c=this._c+r+(this._cl>>>0<v>>>0?1:0)|0,this._d=this._d+c+(this._dl>>>0<y>>>0?1:0)|0,this._e=this._e+u+(this._el>>>0<g>>>0?1:0)|0,this._f=this._f+h+(this._fl>>>0<b>>>0?1:0)|0,this._g=this._g+f+(this._gl>>>0<w>>>0?1:0)|0,this._h=this._h+l+(this._hl>>>0<m>>>0?1:0)|0},n.prototype._hash=function(){function e(t,e,r){n.writeInt32BE(t,r),n.writeInt32BE(e,r+4)}var n=new t(64);return e(this._a,this._al,0),e(this._b,this._bl,8),e(this._c,this._cl,16),e(this._d,this._dl,24),e(this._e,this._el,32),e(this._f,this._fl,40),e(this._g,this._gl,48),e(this._h,this._hl,56),n},n}},function(t,e,n){function r(t,e){t[e>>5]|=128<<e%32,t[(e+64>>>9<<4)+14]=e;for(var n=1732584193,r=-271733879,i=-1732584194,h=271733878,f=0;f<t.length;f+=16){var l=n,p=r,d=i,v=h;n=o(n,r,i,h,t[f+0],7,-680876936),h=o(h,n,r,i,t[f+1],12,-389564586),i=o(i,h,n,r,t[f+2],17,606105819),r=o(r,i,h,n,t[f+3],22,-1044525330),n=o(n,r,i,h,t[f+4],7,-176418897),h=o(h,n,r,i,t[f+5],12,1200080426),i=o(i,h,n,r,t[f+6],17,-1473231341),r=o(r,i,h,n,t[f+7],22,-45705983),n=o(n,r,i,h,t[f+8],7,1770035416),h=o(h,n,r,i,t[f+9],12,-1958414417),i=o(i,h,n,r,t[f+10],17,-42063),r=o(r,i,h,n,t[f+11],22,-1990404162),n=o(n,r,i,h,t[f+12],7,1804603682),h=o(h,n,r,i,t[f+13],12,-40341101),i=o(i,h,n,r,t[f+14],17,-1502002290),r=o(r,i,h,n,t[f+15],22,1236535329),n=s(n,r,i,h,t[f+1],5,-165796510),h=s(h,n,r,i,t[f+6],9,-1069501632),i=s(i,h,n,r,t[f+11],14,643717713),r=s(r,i,h,n,t[f+0],20,-373897302),n=s(n,r,i,h,t[f+5],5,-701558691),h=s(h,n,r,i,t[f+10],9,38016083),i=s(i,h,n,r,t[f+15],14,-660478335),r=s(r,i,h,n,t[f+4],20,-405537848),n=s(n,r,i,h,t[f+9],5,568446438),h=s(h,n,r,i,t[f+14],9,-1019803690),i=s(i,h,n,r,t[f+3],14,-187363961),r=s(r,i,h,n,t[f+8],20,1163531501),n=s(n,r,i,h,t[f+13],5,-1444681467),h=s(h,n,r,i,t[f+2],9,-51403784),i=s(i,h,n,r,t[f+7],14,1735328473),r=s(r,i,h,n,t[f+12],20,-1926607734),n=a(n,r,i,h,t[f+5],4,-378558),h=a(h,n,r,i,t[f+8],11,-2022574463),i=a(i,h,n,r,t[f+11],16,1839030562),r=a(r,i,h,n,t[f+14],23,-35309556),n=a(n,r,i,h,t[f+1],4,-1530992060),h=a(h,n,r,i,t[f+4],11,1272893353),i=a(i,h,n,r,t[f+7],16,-155497632),r=a(r,i,h,n,t[f+10],23,-1094730640),n=a(n,r,i,h,t[f+13],4,681279174),h=a(h,n,r,i,t[f+0],11,-358537222),i=a(i,h,n,r,t[f+3],16,-722521979),r=a(r,i,h,n,t[f+6],23,76029189),n=a(n,r,i,h,t[f+9],4,-640364487),h=a(h,n,r,i,t[f+12],11,-421815835),i=a(i,h,n,r,t[f+15],16,530742520),r=a(r,i,h,n,t[f+2],23,-995338651),n=c(n,r,i,h,t[f+0],6,-198630844),h=c(h,n,r,i,t[f+7],10,1126891415),i=c(i,h,n,r,t[f+14],15,-1416354905),r=c(r,i,h,n,t[f+5],21,-57434055),n=c(n,r,i,h,t[f+12],6,1700485571),h=c(h,n,r,i,t[f+3],10,-1894986606),i=c(i,h,n,r,t[f+10],15,-1051523),r=c(r,i,h,n,t[f+1],21,-2054922799),n=c(n,r,i,h,t[f+8],6,1873313359),h=c(h,n,r,i,t[f+15],10,-30611744),i=c(i,h,n,r,t[f+6],15,-1560198380),r=c(r,i,h,n,t[f+13],21,1309151649),n=c(n,r,i,h,t[f+4],6,-145523070),h=c(h,n,r,i,t[f+11],10,-1120210379),i=c(i,h,n,r,t[f+2],15,718787259),r=c(r,i,h,n,t[f+9],21,-343485551),n=u(n,l),r=u(r,p),i=u(i,d),h=u(h,v)}return Array(n,r,i,h)}function i(t,e,n,r,i,o){return u(h(u(u(e,t),u(r,o)),i),n)}function o(t,e,n,r,o,s,a){return i(e&n|~e&r,t,e,o,s,a)}function s(t,e,n,r,o,s,a){return i(e&r|n&~r,t,e,o,s,a)}function a(t,e,n,r,o,s,a){return i(e^n^r,t,e,o,s,a)}function c(t,e,n,r,o,s,a){return i(n^(e|~r),t,e,o,s,a)}function u(t,e){var n=(65535&t)+(65535&e),r=(t>>16)+(e>>16)+(n>>16);return r<<16|65535&n}function h(t,e){return t<<e|t>>>32-e}var f=n(22);t.exports=function(t){return f.hash(t,r,16)}},function(t,e,n){(function(e){function n(t,n){if(t.length%o!==0){var r=t.length+(o-t.length%o);t=e.concat([t,s],r)}for(var i=[],a=n?t.readInt32BE:t.readInt32LE,c=0;c<t.length;c+=o)i.push(a.call(t,c));return i}function r(t,n,r){for(var i=new e(n),o=r?i.writeInt32BE:i.writeInt32LE,s=0;s<t.length;s++)o.call(i,t[s],4*s,!0);return i}function i(t,i,o,s){e.isBuffer(t)||(t=new e(t));var c=i(n(t,s),t.length*a);return r(c,o,s)}var o=4,s=new e(o);s.fill(0);var a=8;t.exports={hash:i}}).call(e,n(5).Buffer)},function(t,e,n){(function(e){function n(t,e,n){return t^e^n}function r(t,e,n){return t&e|~t&n}function i(t,e,n){return(t|~e)^n}function o(t,e,n){return t&n|e&~n}function s(t,e,n){return t^(e|~n)}function a(t,e){return t<<e|t>>>32-e}function c(t){var n=[1732584193,4023233417,2562383102,271733878,3285377520];"string"==typeof t&&(t=new e(t,"utf8"));var r=v(t),i=8*t.length,o=8*t.length;r[i>>>5]|=128<<24-i%32,r[(i+64>>>9<<4)+14]=16711935&(o<<8|o>>>24)|4278255360&(o<<24|o>>>8);for(var s=0;s<r.length;s+=16)g(n,r,s);for(var s=0;s<5;s++){var a=n[s];n[s]=16711935&(a<<8|a>>>24)|4278255360&(a<<24|a>>>8)}var c=y(n);return new e(c)}t.exports=c;/** @preserve
		(c) 2012 by Cédric Mesnil. All rights reserved.
		
		Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
		
		    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
		    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
		
		THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
		*/
	var u=[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,7,4,13,1,10,6,15,3,12,0,9,5,2,14,11,8,3,10,14,4,9,15,8,1,2,7,0,6,13,11,5,12,1,9,11,10,0,8,12,4,13,3,7,15,14,5,6,2,4,0,5,9,7,12,2,10,14,1,3,8,11,6,15,13],h=[5,14,7,0,9,2,11,4,13,6,15,8,1,10,3,12,6,11,3,7,0,13,5,10,14,15,8,12,4,9,1,2,15,5,1,3,7,14,6,9,11,8,12,2,10,0,4,13,8,6,4,1,3,11,15,0,5,12,2,13,9,7,10,14,12,15,10,4,1,5,8,7,6,2,13,14,0,3,9,11],f=[11,14,15,12,5,8,7,9,11,13,14,15,6,7,9,8,7,6,8,13,11,9,7,15,7,12,15,9,11,7,13,12,11,13,6,7,14,9,13,15,14,8,13,6,5,12,7,5,11,12,14,15,14,15,9,8,9,14,5,6,8,6,5,12,9,15,5,11,6,8,13,12,5,12,13,14,11,8,5,6],l=[8,9,9,11,13,15,15,5,7,7,8,11,14,14,12,6,9,13,15,7,12,8,9,11,7,7,12,7,6,15,13,11,9,7,15,11,8,6,6,14,12,13,5,14,13,13,7,5,15,5,8,11,14,14,6,14,6,9,12,9,12,5,15,8,8,5,12,9,12,5,14,6,8,13,6,5,15,13,11,11],p=[0,1518500249,1859775393,2400959708,2840853838],d=[1352829926,1548603684,1836072691,2053994217,0],v=function(t){for(var e=[],n=0,r=0;n<t.length;n++,r+=8)e[r>>>5]|=t[n]<<24-r%32;return e},y=function(t){for(var e=[],n=0;n<32*t.length;n+=8)e.push(t[n>>>5]>>>24-n%32&255);return e},g=function(t,e,c){for(var v=0;v<16;v++){var y=c+v,g=e[y];e[y]=16711935&(g<<8|g>>>24)|4278255360&(g<<24|g>>>8)}var b,w,m,_,S,E,O,T,k,C;E=b=t[0],O=w=t[1],T=m=t[2],k=_=t[3],C=S=t[4];for(var j,v=0;v<80;v+=1)j=b+e[c+u[v]]|0,j+=v<16?n(w,m,_)+p[0]:v<32?r(w,m,_)+p[1]:v<48?i(w,m,_)+p[2]:v<64?o(w,m,_)+p[3]:s(w,m,_)+p[4],j|=0,j=a(j,f[v]),j=j+S|0,b=S,S=_,_=a(m,10),m=w,w=j,j=E+e[c+h[v]]|0,j+=v<16?s(O,T,k)+d[0]:v<32?o(O,T,k)+d[1]:v<48?i(O,T,k)+d[2]:v<64?r(O,T,k)+d[3]:n(O,T,k)+d[4],j|=0,j=a(j,l[v]),j=j+C|0,E=C,C=k,k=a(T,10),T=O,O=j;j=t[1]+m+k|0,t[1]=t[2]+_+C|0,t[2]=t[3]+S+E|0,t[3]=t[4]+b+O|0,t[4]=t[0]+w+T|0,t[0]=j}}).call(e,n(5).Buffer)},function(t,e,n){(function(e){function r(t,n){if(!(this instanceof r))return new r(t,n);this._opad=c,this._alg=t;var s="sha512"===t?128:64;n=this._key=e.isBuffer(n)?n:new e(n),n.length>s?n=i(t).update(n).digest():n.length<s&&(n=e.concat([n,o],s));for(var a=this._ipad=new e(s),c=this._opad=new e(s),u=0;u<s;u++)a[u]=54^n[u],c[u]=92^n[u];this._hash=i(t).update(a)}var i=n(11),o=new e(128);o.fill(0),t.exports=r,r.prototype.update=function(t,e){return this._hash.update(t,e),this},r.prototype.digest=function(t){var e=this._hash.digest();return i(this._alg).update(this._opad).update(e).digest(t)}}).call(e,n(5).Buffer)},function(t,e,n){var r=n(26);t.exports=function(t,e){e=e||{};var n=r(t);return e.pbkdf2=n.pbkdf2,e.pbkdf2Sync=n.pbkdf2Sync,e}},function(t,e,n){(function(e){t.exports=function(t){function n(t,e,n,i,o,s){if("function"==typeof o&&(s=o,o=void 0),"function"!=typeof s)throw new Error("No callback provided to pbkdf2");setTimeout(function(){var a;try{a=r(t,e,n,i,o)}catch(c){return s(c)}s(void 0,a)})}function r(n,r,i,o,s){if("number"!=typeof i)throw new TypeError("Iterations not a number");if(i<0)throw new TypeError("Bad iterations");if("number"!=typeof o)throw new TypeError("Key length not a number");if(o<0)throw new TypeError("Bad key length");s=s||"sha1",e.isBuffer(n)||(n=new e(n)),e.isBuffer(r)||(r=new e(r));var a,c,u,h=1,f=new e(o),l=new e(r.length+4);r.copy(l,0,0,r.length);for(var p=1;p<=h;p++){l.writeUInt32BE(p,r.length);var d=t.createHmac(s,n).update(l).digest();if(!a&&(a=d.length,u=new e(a),h=Math.ceil(o/a),c=o-(h-1)*a,o>(Math.pow(2,32)-1)*a))throw new TypeError("keylen exceeds maximum length");d.copy(u,0,0,a);for(var v=1;v<i;v++){d=t.createHmac(s,n).update(d).digest();for(var y=0;y<a;y++)u[y]^=d[y]}var g=(p-1)*a,b=p==h?c:a;u.copy(f,g,0,b)}return f}return{pbkdf2:n,pbkdf2Sync:r}}}).call(e,n(5).Buffer)},function(t,e,n){t.exports=function(t,e){function r(){return Object.keys(s)}e=e||{};var i=n(28)(t);e.createCipher=i.createCipher,e.createCipheriv=i.createCipheriv;var o=n(64)(t);e.createDecipher=o.createDecipher,e.createDecipheriv=o.createDecipheriv;var s=n(55);e.listCiphers=r}},function(t,e,n){(function(e){function r(t,n,a){return this instanceof r?(s.call(this),this._cache=new i,this._cipher=new o.AES(n),this._prev=new e(a.length),a.copy(this._prev),void(this._mode=t)):new r(t,n,a)}function i(){return this instanceof i?void(this.cache=new e("")):new i}var o=n(29),s=n(30),a=n(33),c=n(55),u=n(56),h=n(57);a(r,s),r.prototype._transform=function(t,e,n){this._cache.add(t);for(var r,i;r=this._cache.get();)i=this._mode.encrypt(this,r),this.push(i);n()},r.prototype._flush=function(t){var e=this._cache.flush();this.push(this._mode.encrypt(this,e)),this._cipher.scrub(),t()},i.prototype.add=function(t){this.cache=e.concat([this.cache,t])},i.prototype.get=function(){if(this.cache.length>15){var t=this.cache.slice(0,16);return this.cache=this.cache.slice(16),t}return null},i.prototype.flush=function(){for(var t=16-this.cache.length,n=new e(t),r=-1;++r<t;)n.writeUInt8(t,r);var i=e.concat([this.cache,n]);return i};var f={ECB:n(58),CBC:n(59),CFB:n(61),OFB:n(62),CTR:n(63)};t.exports=function(t){function n(t,n,i){var o=c[t];if(!o)throw new TypeError("invalid suite type");if("string"==typeof i&&(i=new e(i)),"string"==typeof n&&(n=new e(n)),n.length!==o.key/8)throw new TypeError("invalid key length "+n.length);if(i.length!==o.iv)throw new TypeError("invalid iv length "+i.length);return"stream"===o.type?new h(f[o.mode],n,i):new r(f[o.mode],n,i)}function i(e,r){var i=c[e];if(!i)throw new TypeError("invalid suite type");var o=u(t,r,i.key,i.iv);return n(e,o.key,o.iv)}return{createCipher:i,createCipheriv:n}}}).call(e,n(5).Buffer)},function(t,e,n){(function(t){function n(t){var e,n;return e=t>a||t<0?(n=Math.abs(t)%a,t<0?a-n:n):t}function r(t){var e,n,r;for(e=n=0,r=t.length;0<=r?n<r:n>r;e=0<=r?++n:--n)t[e]=0;return!1}function i(){var t;this.SBOX=[],this.INV_SBOX=[],this.SUB_MIX=function(){var e,n;for(n=[],t=e=0;e<4;t=++e)n.push([]);return n}(),this.INV_SUB_MIX=function(){var e,n;for(n=[],t=e=0;e<4;t=++e)n.push([]);return n}(),this.init(),this.RCON=[0,1,2,4,8,16,32,64,128,27,54]}function o(t){for(var e=t.length/4,n=new Array(e),r=-1;++r<e;)n[r]=t.readUInt32BE(4*r);return n}function s(t){this._key=o(t),this._doReset()}var a=Math.pow(2,32);i.prototype.init=function(){var t,e,n,r,i,o,s,a,c,u;for(t=function(){var t,n;for(n=[],e=t=0;t<256;e=++t)e<128?n.push(e<<1):n.push(e<<1^283);return n}(),i=0,c=0,e=u=0;u<256;e=++u)n=c^c<<1^c<<2^c<<3^c<<4,n=n>>>8^255&n^99,this.SBOX[i]=n,this.INV_SBOX[n]=i,o=t[i],s=t[o],a=t[s],r=257*t[n]^16843008*n,this.SUB_MIX[0][i]=r<<24|r>>>8,this.SUB_MIX[1][i]=r<<16|r>>>16,this.SUB_MIX[2][i]=r<<8|r>>>24,this.SUB_MIX[3][i]=r,r=16843009*a^65537*s^257*o^16843008*i,this.INV_SUB_MIX[0][n]=r<<24|r>>>8,this.INV_SUB_MIX[1][n]=r<<16|r>>>16,this.INV_SUB_MIX[2][n]=r<<8|r>>>24,this.INV_SUB_MIX[3][n]=r,0===i?i=c=1:(i=o^t[t[t[a^o]]],c^=t[t[c]]);return!0};var c=new i;s.blockSize=16,s.prototype.blockSize=s.blockSize,s.keySize=32,s.prototype.keySize=s.keySize,s.ivSize=s.blockSize,s.prototype.ivSize=s.ivSize,s.prototype._doReset=function(){var t,e,n,r,i,o,s,a;for(n=this._key,e=n.length,this._nRounds=e+6,i=4*(this._nRounds+1),this._keySchedule=[],r=s=0;0<=i?s<i:s>i;r=0<=i?++s:--s)this._keySchedule[r]=r<e?n[r]:(o=this._keySchedule[r-1],r%e===0?(o=o<<8|o>>>24,o=c.SBOX[o>>>24]<<24|c.SBOX[o>>>16&255]<<16|c.SBOX[o>>>8&255]<<8|c.SBOX[255&o],o^=c.RCON[r/e|0]<<24):e>6&&r%e===4?o=c.SBOX[o>>>24]<<24|c.SBOX[o>>>16&255]<<16|c.SBOX[o>>>8&255]<<8|c.SBOX[255&o]:void 0,this._keySchedule[r-e]^o);for(this._invKeySchedule=[],t=a=0;0<=i?a<i:a>i;t=0<=i?++a:--a)r=i-t,o=this._keySchedule[r-(t%4?0:4)],this._invKeySchedule[t]=t<4||r<=4?o:c.INV_SUB_MIX[0][c.SBOX[o>>>24]]^c.INV_SUB_MIX[1][c.SBOX[o>>>16&255]]^c.INV_SUB_MIX[2][c.SBOX[o>>>8&255]]^c.INV_SUB_MIX[3][c.SBOX[255&o]];return!0},s.prototype.encryptBlock=function(e){e=o(new t(e));var n=this._doCryptBlock(e,this._keySchedule,c.SUB_MIX,c.SBOX),r=new t(16);return r.writeUInt32BE(n[0],0),r.writeUInt32BE(n[1],4),r.writeUInt32BE(n[2],8),r.writeUInt32BE(n[3],12),r},s.prototype.decryptBlock=function(e){e=o(new t(e));var n=[e[3],e[1]];e[1]=n[0],e[3]=n[1];var r=this._doCryptBlock(e,this._invKeySchedule,c.INV_SUB_MIX,c.INV_SBOX),i=new t(16);return i.writeUInt32BE(r[0],0),i.writeUInt32BE(r[3],4),i.writeUInt32BE(r[2],8),i.writeUInt32BE(r[1],12),i},s.prototype.scrub=function(){r(this._keySchedule),r(this._invKeySchedule),r(this._key)},s.prototype._doCryptBlock=function(t,e,r,i){var o,s,a,c,u,h,f,l,p,d,v,y;for(a=t[0]^e[0],c=t[1]^e[1],u=t[2]^e[2],h=t[3]^e[3],o=4,s=v=1,y=this._nRounds;1<=y?v<y:v>y;s=1<=y?++v:--v)f=r[0][a>>>24]^r[1][c>>>16&255]^r[2][u>>>8&255]^r[3][255&h]^e[o++],l=r[0][c>>>24]^r[1][u>>>16&255]^r[2][h>>>8&255]^r[3][255&a]^e[o++],p=r[0][u>>>24]^r[1][h>>>16&255]^r[2][a>>>8&255]^r[3][255&c]^e[o++],d=r[0][h>>>24]^r[1][a>>>16&255]^r[2][c>>>8&255]^r[3][255&u]^e[o++],a=f,c=l,u=p,h=d;return f=(i[a>>>24]<<24|i[c>>>16&255]<<16|i[u>>>8&255]<<8|i[255&h])^e[o++],l=(i[c>>>24]<<24|i[u>>>16&255]<<16|i[h>>>8&255]<<8|i[255&a])^e[o++],p=(i[u>>>24]<<24|i[h>>>16&255]<<16|i[a>>>8&255]<<8|i[255&c])^e[o++],d=(i[h>>>24]<<24|i[a>>>16&255]<<16|i[c>>>8&255]<<8|i[255&u])^e[o++],[n(f),n(l),n(p),n(d)]},e.AES=s}).call(e,n(5).Buffer)},function(t,e,n){(function(e){function r(){i.call(this)}var i=n(31).Transform,o=n(33);t.exports=r,o(r,i),r.prototype.update=function(t,n,r){this.write(t,n);for(var i,o=new e("");i=this.read();)o=e.concat([o,i]);return r&&(o=o.toString(r)),o},r.prototype["final"]=function(t){this.end();for(var n,r=new e("");n=this.read();)r=e.concat([r,n]);return t&&(r=r.toString(t)),r}}).call(e,n(5).Buffer)},function(t,e,n){function r(){i.call(this)}t.exports=r;var i=n(32).EventEmitter,o=n(33);o(r,i),r.Readable=n(34),r.Writable=n(51),r.Duplex=n(52),r.Transform=n(53),r.PassThrough=n(54),r.Stream=r,r.prototype.pipe=function(t,e){function n(e){t.writable&&!1===t.write(e)&&u.pause&&u.pause()}function r(){u.readable&&u.resume&&u.resume()}function o(){h||(h=!0,t.end())}function s(){h||(h=!0,"function"==typeof t.destroy&&t.destroy())}function a(t){if(c(),0===i.listenerCount(this,"error"))throw t}function c(){u.removeListener("data",n),t.removeListener("drain",r),u.removeListener("end",o),u.removeListener("close",s),u.removeListener("error",a),t.removeListener("error",a),u.removeListener("end",c),u.removeListener("close",c),t.removeListener("close",c)}var u=this;u.on("data",n),t.on("drain",r),t._isStdio||e&&e.end===!1||(u.on("end",o),u.on("close",s));var h=!1;return u.on("error",a),t.on("error",a),u.on("end",c),u.on("close",c),t.on("close",c),t.emit("pipe",u),t}},function(t,e){function n(){this._events=this._events||{},this._maxListeners=this._maxListeners||void 0}function r(t){return"function"==typeof t}function i(t){return"number"==typeof t}function o(t){return"object"==typeof t&&null!==t}function s(t){return void 0===t}t.exports=n,n.EventEmitter=n,n.prototype._events=void 0,n.prototype._maxListeners=void 0,n.defaultMaxListeners=10,n.prototype.setMaxListeners=function(t){if(!i(t)||t<0||isNaN(t))throw TypeError("n must be a positive number");return this._maxListeners=t,this},n.prototype.emit=function(t){var e,n,i,a,c,u;if(this._events||(this._events={}),"error"===t&&(!this._events.error||o(this._events.error)&&!this._events.error.length)){if(e=arguments[1],e instanceof Error)throw e;var h=new Error('Uncaught, unspecified "error" event. ('+e+")");throw h.context=e,h}if(n=this._events[t],s(n))return!1;if(r(n))switch(arguments.length){case 1:n.call(this);break;case 2:n.call(this,arguments[1]);break;case 3:n.call(this,arguments[1],arguments[2]);break;default:a=Array.prototype.slice.call(arguments,1),n.apply(this,a)}else if(o(n))for(a=Array.prototype.slice.call(arguments,1),u=n.slice(),i=u.length,c=0;c<i;c++)u[c].apply(this,a);return!0},n.prototype.addListener=function(t,e){var i;if(!r(e))throw TypeError("listener must be a function");return this._events||(this._events={}),this._events.newListener&&this.emit("newListener",t,r(e.listener)?e.listener:e),this._events[t]?o(this._events[t])?this._events[t].push(e):this._events[t]=[this._events[t],e]:this._events[t]=e,o(this._events[t])&&!this._events[t].warned&&(i=s(this._maxListeners)?n.defaultMaxListeners:this._maxListeners,i&&i>0&&this._events[t].length>i&&(this._events[t].warned=!0,console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.",this._events[t].length),"function"==typeof console.trace&&console.trace())),this},n.prototype.on=n.prototype.addListener,n.prototype.once=function(t,e){function n(){this.removeListener(t,n),i||(i=!0,e.apply(this,arguments))}if(!r(e))throw TypeError("listener must be a function");var i=!1;return n.listener=e,this.on(t,n),this},n.prototype.removeListener=function(t,e){var n,i,s,a;if(!r(e))throw TypeError("listener must be a function");if(!this._events||!this._events[t])return this;if(n=this._events[t],s=n.length,i=-1,n===e||r(n.listener)&&n.listener===e)delete this._events[t],this._events.removeListener&&this.emit("removeListener",t,e);else if(o(n)){for(a=s;a-- >0;)if(n[a]===e||n[a].listener&&n[a].listener===e){i=a;break}if(i<0)return this;1===n.length?(n.length=0,delete this._events[t]):n.splice(i,1),this._events.removeListener&&this.emit("removeListener",t,e)}return this},n.prototype.removeAllListeners=function(t){var e,n;if(!this._events)return this;if(!this._events.removeListener)return 0===arguments.length?this._events={}:this._events[t]&&delete this._events[t],this;if(0===arguments.length){for(e in this._events)"removeListener"!==e&&this.removeAllListeners(e);return this.removeAllListeners("removeListener"),this._events={},this}if(n=this._events[t],r(n))this.removeListener(t,n);else if(n)for(;n.length;)this.removeListener(t,n[n.length-1]);return delete this._events[t],this},n.prototype.listeners=function(t){var e;return e=this._events&&this._events[t]?r(this._events[t])?[this._events[t]]:this._events[t].slice():[]},n.prototype.listenerCount=function(t){if(this._events){var e=this._events[t];if(r(e))return 1;if(e)return e.length}return 0},n.listenerCount=function(t,e){return t.listenerCount(e)}},function(t,e){"function"==typeof Object.create?t.exports=function(t,e){t.super_=e,t.prototype=Object.create(e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}})}:t.exports=function(t,e){t.super_=e;var n=function(){};n.prototype=e.prototype,t.prototype=new n,t.prototype.constructor=t}},function(t,e,n){e=t.exports=n(35),e.Stream=e,e.Readable=e,e.Writable=n(43),e.Duplex=n(42),e.Transform=n(49),e.PassThrough=n(50)},function(t,e,n){(function(e){"use strict";function r(t,e,n){return"function"==typeof t.prependListener?t.prependListener(e,n):void(t._events&&t._events[e]?B(t._events[e])?t._events[e].unshift(n):t._events[e]=[n,t._events[e]]:t.on(e,n))}function i(t,e){j=j||n(42),t=t||{},this.objectMode=!!t.objectMode,e instanceof j&&(this.objectMode=this.objectMode||!!t.readableObjectMode);var r=t.highWaterMark,i=this.objectMode?16:16384;this.highWaterMark=r||0===r?r:i,this.highWaterMark=~~this.highWaterMark,this.buffer=new D,this.length=0,this.pipes=null,this.pipesCount=0,this.flowing=null,this.ended=!1,this.endEmitted=!1,this.reading=!1,this.sync=!0,this.needReadable=!1,this.emittedReadable=!1,this.readableListening=!1,this.resumeScheduled=!1,this.defaultEncoding=t.defaultEncoding||"utf8",this.ranOut=!1,this.awaitDrain=0,this.readingMore=!1,this.decoder=null,this.encoding=null,t.encoding&&(P||(P=n(47).StringDecoder),this.decoder=new P(t.encoding),this.encoding=t.encoding)}function o(t){return j=j||n(42),this instanceof o?(this._readableState=new i(t,this),this.readable=!0,t&&"function"==typeof t.read&&(this._read=t.read),void I.call(this)):new o(t)}function s(t,e,n,r,i){var o=h(e,n);if(o)t.emit("error",o);else if(null===n)e.reading=!1,f(t,e);else if(e.objectMode||n&&n.length>0)if(e.ended&&!i){var s=new Error("stream.push() after EOF");t.emit("error",s)}else if(e.endEmitted&&i){var c=new Error("stream.unshift() after end event");t.emit("error",c)}else{var u;!e.decoder||i||r||(n=e.decoder.write(n),u=!e.objectMode&&0===n.length),i||(e.reading=!1),u||(e.flowing&&0===e.length&&!e.sync?(t.emit("data",n),t.read(0)):(e.length+=e.objectMode?1:n.length,i?e.buffer.unshift(n):e.buffer.push(n),e.needReadable&&l(t))),d(t,e)}else i||(e.reading=!1);return a(e)}function a(t){return!t.ended&&(t.needReadable||t.length<t.highWaterMark||0===t.length)}function c(t){return t>=W?t=W:(t--,t|=t>>>1,t|=t>>>2,t|=t>>>4,t|=t>>>8,t|=t>>>16,t++),t}function u(t,e){return t<=0||0===e.length&&e.ended?0:e.objectMode?1:t!==t?e.flowing&&e.length?e.buffer.head.data.length:e.length:(t>e.highWaterMark&&(e.highWaterMark=c(t)),t<=e.length?t:e.ended?e.length:(e.needReadable=!0,0))}function h(t,e){var n=null;return R.isBuffer(e)||"string"==typeof e||null===e||void 0===e||t.objectMode||(n=new TypeError("Invalid non-string/buffer chunk")),n}function f(t,e){if(!e.ended){if(e.decoder){var n=e.decoder.end();n&&n.length&&(e.buffer.push(n),e.length+=e.objectMode?1:n.length)}e.ended=!0,l(t)}}function l(t){var e=t._readableState;e.needReadable=!1,e.emittedReadable||(U("emitReadable",e.flowing),e.emittedReadable=!0,e.sync?x(p,t):p(t))}function p(t){U("emit readable"),t.emit("readable"),m(t)}function d(t,e){e.readingMore||(e.readingMore=!0,x(v,t,e))}function v(t,e){for(var n=e.length;!e.reading&&!e.flowing&&!e.ended&&e.length<e.highWaterMark&&(U("maybeReadMore read 0"),t.read(0),n!==e.length);)n=e.length;e.readingMore=!1}function y(t){return function(){var e=t._readableState;U("pipeOnDrain",e.awaitDrain),e.awaitDrain&&e.awaitDrain--,0===e.awaitDrain&&A(t,"data")&&(e.flowing=!0,m(t))}}function g(t){U("readable nexttick read 0"),t.read(0)}function b(t,e){e.resumeScheduled||(e.resumeScheduled=!0,x(w,t,e))}function w(t,e){e.reading||(U("resume read 0"),t.read(0)),e.resumeScheduled=!1,e.awaitDrain=0,t.emit("resume"),m(t),e.flowing&&!e.reading&&t.read(0)}function m(t){var e=t._readableState;for(U("flow",e.flowing);e.flowing&&null!==t.read(););}function _(t,e){if(0===e.length)return null;var n;return e.objectMode?n=e.buffer.shift():!t||t>=e.length?(n=e.decoder?e.buffer.join(""):1===e.buffer.length?e.buffer.head.data:e.buffer.concat(e.length),e.buffer.clear()):n=S(t,e.buffer,e.decoder),n}function S(t,e,n){var r;return t<e.head.data.length?(r=e.head.data.slice(0,t),e.head.data=e.head.data.slice(t)):r=t===e.head.data.length?e.shift():n?E(t,e):O(t,e),r}function E(t,e){var n=e.head,r=1,i=n.data;for(t-=i.length;n=n.next;){var o=n.data,s=t>o.length?o.length:t;if(i+=s===o.length?o:o.slice(0,t),t-=s,0===t){s===o.length?(++r,n.next?e.head=n.next:e.head=e.tail=null):(e.head=n,n.data=o.slice(s));break}++r}return e.length-=r,i}function O(t,e){var n=R.allocUnsafe(t),r=e.head,i=1;for(r.data.copy(n),t-=r.data.length;r=r.next;){var o=r.data,s=t>o.length?o.length:t;if(o.copy(n,n.length-t,0,s),t-=s,0===t){s===o.length?(++i,r.next?e.head=r.next:e.head=e.tail=null):(e.head=r,r.data=o.slice(s));break}++i}return e.length-=i,n}function T(t){var e=t._readableState;if(e.length>0)throw new Error('"endReadable()" called on non-empty stream');e.endEmitted||(e.ended=!0,x(k,e,t))}function k(t,e){t.endEmitted||0!==t.length||(t.endEmitted=!0,e.readable=!1,e.emit("end"))}function C(t,e){for(var n=0,r=t.length;n<r;n++)if(t[n]===e)return n;return-1}t.exports=o;var j,x=n(36),B=n(8);o.ReadableState=i;var A=(n(32).EventEmitter,function(t,e){return t.listeners(e).length}),I=n(37),R=n(38).Buffer,M=n(39);M.inherits=n(33);var N=n(40),U=void 0;U=N&&N.debuglog?N.debuglog("stream"):function(){};var P,D=n(41);M.inherits(o,I);var L=["error","close","destroy","pause","resume"];o.prototype.push=function(t,e){var n=this._readableState;return n.objectMode||"string"!=typeof t||(e=e||n.defaultEncoding,e!==n.encoding&&(t=R.from(t,e),e="")),s(this,n,t,e,!1)},o.prototype.unshift=function(t){var e=this._readableState;return s(this,e,t,"",!0)},o.prototype.isPaused=function(){return this._readableState.flowing===!1},o.prototype.setEncoding=function(t){return P||(P=n(47).StringDecoder),this._readableState.decoder=new P(t),this._readableState.encoding=t,this};var W=8388608;o.prototype.read=function(t){U("read",t),t=parseInt(t,10);var e=this._readableState,n=t;if(0!==t&&(e.emittedReadable=!1),0===t&&e.needReadable&&(e.length>=e.highWaterMark||e.ended))return U("read: emitReadable",e.length,e.ended),0===e.length&&e.ended?T(this):l(this),null;if(t=u(t,e),0===t&&e.ended)return 0===e.length&&T(this),null;var r=e.needReadable;U("need readable",r),(0===e.length||e.length-t<e.highWaterMark)&&(r=!0,U("length less than watermark",r)),e.ended||e.reading?(r=!1,U("reading or ended",r)):r&&(U("do read"),e.reading=!0,e.sync=!0,0===e.length&&(e.needReadable=!0),this._read(e.highWaterMark),e.sync=!1,e.reading||(t=u(n,e)));var i;return i=t>0?_(t,e):null,null===i?(e.needReadable=!0,t=0):e.length-=t,0===e.length&&(e.ended||(e.needReadable=!0),n!==t&&e.ended&&T(this)),null!==i&&this.emit("data",i),i},o.prototype._read=function(t){this.emit("error",new Error("_read() is not implemented"))},o.prototype.pipe=function(t,n){function i(t){U("onunpipe"),t===l&&s()}function o(){U("onend"),t.end()}function s(){U("cleanup"),t.removeListener("close",u),t.removeListener("finish",h),t.removeListener("drain",g),t.removeListener("error",c),t.removeListener("unpipe",i),l.removeListener("end",o),l.removeListener("end",f),l.removeListener("data",a),b=!0,!p.awaitDrain||t._writableState&&!t._writableState.needDrain||g()}function a(e){U("ondata"),w=!1;var n=t.write(e);!1!==n||w||((1===p.pipesCount&&p.pipes===t||p.pipesCount>1&&C(p.pipes,t)!==-1)&&!b&&(U("false write response, pause",l._readableState.awaitDrain),l._readableState.awaitDrain++,w=!0),l.pause())}function c(e){U("onerror",e),f(),t.removeListener("error",c),0===A(t,"error")&&t.emit("error",e)}function u(){t.removeListener("finish",h),f()}function h(){U("onfinish"),t.removeListener("close",u),f()}function f(){U("unpipe"),l.unpipe(t)}var l=this,p=this._readableState;switch(p.pipesCount){case 0:p.pipes=t;break;case 1:p.pipes=[p.pipes,t];break;default:p.pipes.push(t)}p.pipesCount+=1,U("pipe count=%d opts=%j",p.pipesCount,n);var d=(!n||n.end!==!1)&&t!==e.stdout&&t!==e.stderr,v=d?o:f;p.endEmitted?x(v):l.once("end",v),t.on("unpipe",i);var g=y(l);t.on("drain",g);var b=!1,w=!1;return l.on("data",a),r(t,"error",c),t.once("close",u),t.once("finish",h),t.emit("pipe",l),p.flowing||(U("pipe resume"),l.resume()),t},o.prototype.unpipe=function(t){var e=this._readableState;if(0===e.pipesCount)return this;if(1===e.pipesCount)return t&&t!==e.pipes?this:(t||(t=e.pipes),e.pipes=null,e.pipesCount=0,e.flowing=!1,t&&t.emit("unpipe",this),this);if(!t){var n=e.pipes,r=e.pipesCount;e.pipes=null,e.pipesCount=0,e.flowing=!1;for(var i=0;i<r;i++)n[i].emit("unpipe",this);return this}var o=C(e.pipes,t);return o===-1?this:(e.pipes.splice(o,1),e.pipesCount-=1,1===e.pipesCount&&(e.pipes=e.pipes[0]),t.emit("unpipe",this),this)},o.prototype.on=function(t,e){var n=I.prototype.on.call(this,t,e);if("data"===t)this._readableState.flowing!==!1&&this.resume();else if("readable"===t){var r=this._readableState;r.endEmitted||r.readableListening||(r.readableListening=r.needReadable=!0,r.emittedReadable=!1,r.reading?r.length&&l(this,r):x(g,this))}return n},o.prototype.addListener=o.prototype.on,o.prototype.resume=function(){var t=this._readableState;return t.flowing||(U("resume"),t.flowing=!0,b(this,t)),this},o.prototype.pause=function(){return U("call pause flowing=%j",this._readableState.flowing),!1!==this._readableState.flowing&&(U("pause"),this._readableState.flowing=!1,this.emit("pause")),this},o.prototype.wrap=function(t){var e=this._readableState,n=!1,r=this;t.on("end",function(){if(U("wrapped end"),e.decoder&&!e.ended){var t=e.decoder.end();t&&t.length&&r.push(t)}r.push(null)}),t.on("data",function(i){if(U("wrapped data"),e.decoder&&(i=e.decoder.write(i)),(!e.objectMode||null!==i&&void 0!==i)&&(e.objectMode||i&&i.length)){var o=r.push(i);o||(n=!0,t.pause())}});for(var i in t)void 0===this[i]&&"function"==typeof t[i]&&(this[i]=function(e){return function(){return t[e].apply(t,arguments)}}(i));for(var o=0;o<L.length;o++)t.on(L[o],r.emit.bind(r,L[o]));return r._read=function(e){U("wrapped _read",e),n&&(n=!1,t.resume())},r},o._fromList=_}).call(e,n(16))},function(t,e,n){(function(e){"use strict";function n(t,n,r,i){if("function"!=typeof t)throw new TypeError('"callback" argument must be a function');var o,s,a=arguments.length;switch(a){case 0:case 1:return e.nextTick(t);case 2:return e.nextTick(function(){t.call(null,n)});case 3:return e.nextTick(function(){t.call(null,n,r)});case 4:return e.nextTick(function(){t.call(null,n,r,i)});default:for(o=new Array(a-1),s=0;s<o.length;)o[s++]=arguments[s];return e.nextTick(function(){t.apply(null,o)})}}!e.version||0===e.version.indexOf("v0.")||0===e.version.indexOf("v1.")&&0!==e.version.indexOf("v1.8.")?t.exports=n:t.exports=e.nextTick}).call(e,n(16))},function(t,e,n){t.exports=n(32).EventEmitter},function(t,e,n){t.exports=n(5)},function(t,e,n){(function(t){function n(t){return Array.isArray?Array.isArray(t):"[object Array]"===y(t)}function r(t){return"boolean"==typeof t}function i(t){return null===t}function o(t){return null==t}function s(t){return"number"==typeof t}function a(t){return"string"==typeof t}function c(t){return"symbol"==typeof t}function u(t){return void 0===t}function h(t){return"[object RegExp]"===y(t)}function f(t){return"object"==typeof t&&null!==t}function l(t){return"[object Date]"===y(t)}function p(t){return"[object Error]"===y(t)||t instanceof Error}function d(t){return"function"==typeof t}function v(t){return null===t||"boolean"==typeof t||"number"==typeof t||"string"==typeof t||"symbol"==typeof t||"undefined"==typeof t}function y(t){return Object.prototype.toString.call(t)}e.isArray=n,e.isBoolean=r,e.isNull=i,e.isNullOrUndefined=o,e.isNumber=s,e.isString=a,e.isSymbol=c,e.isUndefined=u,e.isRegExp=h,e.isObject=f,e.isDate=l,e.isError=p,e.isFunction=d,e.isPrimitive=v,e.isBuffer=t.isBuffer}).call(e,n(5).Buffer)},function(t,e){},function(t,e,n){"use strict";function r(){this.head=null,this.tail=null,this.length=0}var i=n(38).Buffer;t.exports=r,r.prototype.push=function(t){var e={data:t,next:null};this.length>0?this.tail.next=e:this.head=e,this.tail=e,++this.length},r.prototype.unshift=function(t){var e={data:t,next:this.head};0===this.length&&(this.tail=e),this.head=e,++this.length},r.prototype.shift=function(){if(0!==this.length){var t=this.head.data;return 1===this.length?this.head=this.tail=null:this.head=this.head.next,--this.length,t}},r.prototype.clear=function(){this.head=this.tail=null,this.length=0},r.prototype.join=function(t){if(0===this.length)return"";for(var e=this.head,n=""+e.data;e=e.next;)n+=t+e.data;return n},r.prototype.concat=function(t){if(0===this.length)return i.alloc(0);if(1===this.length)return this.head.data;for(var e=i.allocUnsafe(t>>>0),n=this.head,r=0;n;)n.data.copy(e,r),r+=n.data.length,n=n.next;return e}},function(t,e,n){"use strict";function r(t){return this instanceof r?(u.call(this,t),h.call(this,t),t&&t.readable===!1&&(this.readable=!1),t&&t.writable===!1&&(this.writable=!1),this.allowHalfOpen=!0,t&&t.allowHalfOpen===!1&&(this.allowHalfOpen=!1),void this.once("end",i)):new r(t)}function i(){this.allowHalfOpen||this._writableState.ended||a(o,this)}function o(t){t.end()}var s=Object.keys||function(t){var e=[];for(var n in t)e.push(n);return e};t.exports=r;var a=n(36),c=n(39);c.inherits=n(33);var u=n(35),h=n(43);c.inherits(r,u);for(var f=s(h.prototype),l=0;l<f.length;l++){var p=f[l];r.prototype[p]||(r.prototype[p]=h.prototype[p])}},function(t,e,n){(function(e,r){"use strict";function i(){}function o(t,e,n){this.chunk=t,this.encoding=e,this.callback=n,this.next=null}function s(t,e){O=O||n(42),t=t||{},this.objectMode=!!t.objectMode,e instanceof O&&(this.objectMode=this.objectMode||!!t.writableObjectMode);var r=t.highWaterMark,i=this.objectMode?16:16384;this.highWaterMark=r||0===r?r:i,this.highWaterMark=~~this.highWaterMark,this.needDrain=!1,this.ending=!1,this.ended=!1,this.finished=!1;var o=t.decodeStrings===!1;this.decodeStrings=!o,this.defaultEncoding=t.defaultEncoding||"utf8",this.length=0,this.writing=!1,this.corked=0,this.sync=!0,this.bufferProcessing=!1,this.onwrite=function(t){v(e,t)},this.writecb=null,this.writelen=0,this.bufferedRequest=null,this.lastBufferedRequest=null,this.pendingcb=0,this.prefinished=!1,this.errorEmitted=!1,this.bufferedRequestCount=0,this.corkedRequestsFree=new E(this)}function a(t){return O=O||n(42),A.call(a,this)||this instanceof O?(this._writableState=new s(t,this),this.writable=!0,t&&("function"==typeof t.write&&(this._write=t.write),"function"==typeof t.writev&&(this._writev=t.writev)),void x.call(this)):new a(t)}function c(t,e){var n=new Error("write after end");t.emit("error",n),T(e,n)}function u(t,e,n,r){var i=!0,o=!1;return null===n?o=new TypeError("May not write null values to stream"):"string"==typeof n||void 0===n||e.objectMode||(o=new TypeError("Invalid non-string/buffer chunk")),o&&(t.emit("error",o),T(r,o),i=!1),i}function h(t,e,n){return t.objectMode||t.decodeStrings===!1||"string"!=typeof e||(e=B.from(e,n)),e}function f(t,e,n,r,i,s){n||(r=h(e,r,i),B.isBuffer(r)&&(i="buffer"));var a=e.objectMode?1:r.length;e.length+=a;var c=e.length<e.highWaterMark;if(c||(e.needDrain=!0),e.writing||e.corked){var u=e.lastBufferedRequest;e.lastBufferedRequest=new o(r,i,s),u?u.next=e.lastBufferedRequest:e.bufferedRequest=e.lastBufferedRequest,e.bufferedRequestCount+=1}else l(t,e,!1,a,r,i,s);return c}function l(t,e,n,r,i,o,s){e.writelen=r,e.writecb=s,e.writing=!0,e.sync=!0,n?t._writev(i,e.onwrite):t._write(i,o,e.onwrite),e.sync=!1}function p(t,e,n,r,i){--e.pendingcb,n?T(i,r):i(r),t._writableState.errorEmitted=!0,t.emit("error",r)}function d(t){t.writing=!1,t.writecb=null,t.length-=t.writelen,t.writelen=0}function v(t,e){var n=t._writableState,r=n.sync,i=n.writecb;if(d(n),e)p(t,n,r,e,i);else{var o=w(n);o||n.corked||n.bufferProcessing||!n.bufferedRequest||b(t,n),r?k(y,t,n,o,i):y(t,n,o,i)}}function y(t,e,n,r){n||g(t,e),e.pendingcb--,r(),_(t,e)}function g(t,e){0===e.length&&e.needDrain&&(e.needDrain=!1,t.emit("drain"))}function b(t,e){e.bufferProcessing=!0;var n=e.bufferedRequest;if(t._writev&&n&&n.next){var r=e.bufferedRequestCount,i=new Array(r),o=e.corkedRequestsFree;o.entry=n;for(var s=0;n;)i[s]=n,n=n.next,s+=1;l(t,e,!0,e.length,i,"",o.finish),e.pendingcb++,e.lastBufferedRequest=null,o.next?(e.corkedRequestsFree=o.next,o.next=null):e.corkedRequestsFree=new E(e)}else{for(;n;){var a=n.chunk,c=n.encoding,u=n.callback,h=e.objectMode?1:a.length;if(l(t,e,!1,h,a,c,u),n=n.next,e.writing)break}null===n&&(e.lastBufferedRequest=null)}e.bufferedRequestCount=0,e.bufferedRequest=n,e.bufferProcessing=!1}function w(t){return t.ending&&0===t.length&&null===t.bufferedRequest&&!t.finished&&!t.writing}function m(t,e){e.prefinished||(e.prefinished=!0,t.emit("prefinish"))}function _(t,e){var n=w(e);return n&&(0===e.pendingcb?(m(t,e),e.finished=!0,t.emit("finish")):m(t,e)),n}function S(t,e,n){e.ending=!0,_(t,e),n&&(e.finished?T(n):t.once("finish",n)),e.ended=!0,t.writable=!1}function E(t){var e=this;this.next=null,this.entry=null,this.finish=function(n){var r=e.entry;for(e.entry=null;r;){var i=r.callback;t.pendingcb--,i(n),r=r.next}t.corkedRequestsFree?t.corkedRequestsFree.next=e:t.corkedRequestsFree=e}}t.exports=a;var O,T=n(36),k=!e.browser&&["v0.10","v0.9."].indexOf(e.version.slice(0,5))>-1?r:T;a.WritableState=s;var C=n(39);C.inherits=n(33);var j={deprecate:n(46)},x=n(37),B=n(38).Buffer;C.inherits(a,x),s.prototype.getBuffer=function(){for(var t=this.bufferedRequest,e=[];t;)e.push(t),t=t.next;return e},function(){try{Object.defineProperty(s.prototype,"buffer",{get:j.deprecate(function(){return this.getBuffer()},"_writableState.buffer is deprecated. Use _writableState.getBuffer instead.")})}catch(t){}}();var A;"function"==typeof Symbol&&Symbol.hasInstance&&"function"==typeof Function.prototype[Symbol.hasInstance]?(A=Function.prototype[Symbol.hasInstance],Object.defineProperty(a,Symbol.hasInstance,{value:function(t){return!!A.call(this,t)||t&&t._writableState instanceof s}})):A=function(t){return t instanceof this},a.prototype.pipe=function(){this.emit("error",new Error("Cannot pipe, not readable"))},a.prototype.write=function(t,e,n){
	var r=this._writableState,o=!1,s=B.isBuffer(t);return"function"==typeof e&&(n=e,e=null),s?e="buffer":e||(e=r.defaultEncoding),"function"!=typeof n&&(n=i),r.ended?c(this,n):(s||u(this,r,t,n))&&(r.pendingcb++,o=f(this,r,s,t,e,n)),o},a.prototype.cork=function(){var t=this._writableState;t.corked++},a.prototype.uncork=function(){var t=this._writableState;t.corked&&(t.corked--,t.writing||t.corked||t.finished||t.bufferProcessing||!t.bufferedRequest||b(this,t))},a.prototype.setDefaultEncoding=function(t){if("string"==typeof t&&(t=t.toLowerCase()),!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((t+"").toLowerCase())>-1))throw new TypeError("Unknown encoding: "+t);return this._writableState.defaultEncoding=t,this},a.prototype._write=function(t,e,n){n(new Error("_write() is not implemented"))},a.prototype._writev=null,a.prototype.end=function(t,e,n){var r=this._writableState;"function"==typeof t?(n=t,t=null,e=null):"function"==typeof e&&(n=e,e=null),null!==t&&void 0!==t&&this.write(t,e),r.corked&&(r.corked=1,this.uncork()),r.ending||r.finished||S(this,r,n)}}).call(e,n(16),n(44).setImmediate)},function(t,e,n){function r(t,e){this._id=t,this._clearFn=e}var i=Function.prototype.apply;e.setTimeout=function(){return new r(i.call(setTimeout,window,arguments),clearTimeout)},e.setInterval=function(){return new r(i.call(setInterval,window,arguments),clearInterval)},e.clearTimeout=e.clearInterval=function(t){t&&t.close()},r.prototype.unref=r.prototype.ref=function(){},r.prototype.close=function(){this._clearFn.call(window,this._id)},e.enroll=function(t,e){clearTimeout(t._idleTimeoutId),t._idleTimeout=e},e.unenroll=function(t){clearTimeout(t._idleTimeoutId),t._idleTimeout=-1},e._unrefActive=e.active=function(t){clearTimeout(t._idleTimeoutId);var e=t._idleTimeout;e>=0&&(t._idleTimeoutId=setTimeout(function(){t._onTimeout&&t._onTimeout()},e))},n(45),e.setImmediate=setImmediate,e.clearImmediate=clearImmediate},function(t,e,n){(function(t,e){!function(t,n){"use strict";function r(t){"function"!=typeof t&&(t=new Function(""+t));for(var e=new Array(arguments.length-1),n=0;n<e.length;n++)e[n]=arguments[n+1];var r={callback:t,args:e};return v[d]=r,p(d),d++}function i(t){delete v[t]}function o(t){var e=t.callback,r=t.args;switch(r.length){case 0:e();break;case 1:e(r[0]);break;case 2:e(r[0],r[1]);break;case 3:e(r[0],r[1],r[2]);break;default:e.apply(n,r)}}function s(t){if(y)setTimeout(s,0,t);else{var e=v[t];if(e){y=!0;try{o(e)}finally{i(t),y=!1}}}}function a(){p=function(t){e.nextTick(function(){s(t)})}}function c(){if(t.postMessage&&!t.importScripts){var e=!0,n=t.onmessage;return t.onmessage=function(){e=!1},t.postMessage("","*"),t.onmessage=n,e}}function u(){var e="setImmediate$"+Math.random()+"$",n=function(n){n.source===t&&"string"==typeof n.data&&0===n.data.indexOf(e)&&s(+n.data.slice(e.length))};t.addEventListener?t.addEventListener("message",n,!1):t.attachEvent("onmessage",n),p=function(n){t.postMessage(e+n,"*")}}function h(){var t=new MessageChannel;t.port1.onmessage=function(t){var e=t.data;s(e)},p=function(e){t.port2.postMessage(e)}}function f(){var t=g.documentElement;p=function(e){var n=g.createElement("script");n.onreadystatechange=function(){s(e),n.onreadystatechange=null,t.removeChild(n),n=null},t.appendChild(n)}}function l(){p=function(t){setTimeout(s,0,t)}}if(!t.setImmediate){var p,d=1,v={},y=!1,g=t.document,b=Object.getPrototypeOf&&Object.getPrototypeOf(t);b=b&&b.setTimeout?b:t,"[object process]"==={}.toString.call(t.process)?a():c()?u():t.MessageChannel?h():g&&"onreadystatechange"in g.createElement("script")?f():l(),b.setImmediate=r,b.clearImmediate=i}}("undefined"==typeof self?"undefined"==typeof t?this:t:self)}).call(e,function(){return this}(),n(16))},function(t,e){(function(e){function n(t,e){function n(){if(!i){if(r("throwDeprecation"))throw new Error(e);r("traceDeprecation")?console.trace(e):console.warn(e),i=!0}return t.apply(this,arguments)}if(r("noDeprecation"))return t;var i=!1;return n}function r(t){try{if(!e.localStorage)return!1}catch(n){return!1}var r=e.localStorage[t];return null!=r&&"true"===String(r).toLowerCase()}t.exports=n}).call(e,function(){return this}())},function(t,e,n){"use strict";function r(t){if(!t)return"utf8";for(var e;;)switch(t){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return t;default:if(e)return;t=(""+t).toLowerCase(),e=!0}}function i(t){var e=r(t);if("string"!=typeof e&&(b.isEncoding===w||!w(t)))throw new Error("Unknown encoding: "+t);return e||t}function o(t){this.encoding=i(t);var e;switch(this.encoding){case"utf16le":this.text=l,this.end=p,e=4;break;case"utf8":this.fillLast=u,e=4;break;case"base64":this.text=d,this.end=v,e=3;break;default:return this.write=y,void(this.end=g)}this.lastNeed=0,this.lastTotal=0,this.lastChar=b.allocUnsafe(e)}function s(t){return t<=127?0:t>>5===6?2:t>>4===14?3:t>>3===30?4:-1}function a(t,e,n){var r=e.length-1;if(r<n)return 0;var i=s(e[r]);return i>=0?(i>0&&(t.lastNeed=i-1),i):--r<n?0:(i=s(e[r]),i>=0?(i>0&&(t.lastNeed=i-2),i):--r<n?0:(i=s(e[r]),i>=0?(i>0&&(2===i?i=0:t.lastNeed=i-3),i):0))}function c(t,e,n){if(128!==(192&e[0]))return t.lastNeed=0,"�".repeat(n);if(t.lastNeed>1&&e.length>1){if(128!==(192&e[1]))return t.lastNeed=1,"�".repeat(n+1);if(t.lastNeed>2&&e.length>2&&128!==(192&e[2]))return t.lastNeed=2,"�".repeat(n+2)}}function u(t){var e=this.lastTotal-this.lastNeed,n=c(this,t,e);return void 0!==n?n:this.lastNeed<=t.length?(t.copy(this.lastChar,e,0,this.lastNeed),this.lastChar.toString(this.encoding,0,this.lastTotal)):(t.copy(this.lastChar,e,0,t.length),void(this.lastNeed-=t.length))}function h(t,e){var n=a(this,t,e);if(!this.lastNeed)return t.toString("utf8",e);this.lastTotal=n;var r=t.length-(n-this.lastNeed);return t.copy(this.lastChar,0,r),t.toString("utf8",e,r)}function f(t){var e=t&&t.length?this.write(t):"";return this.lastNeed?e+"�".repeat(this.lastTotal-this.lastNeed):e}function l(t,e){if((t.length-e)%2===0){var n=t.toString("utf16le",e);if(n){var r=n.charCodeAt(n.length-1);if(r>=55296&&r<=56319)return this.lastNeed=2,this.lastTotal=4,this.lastChar[0]=t[t.length-2],this.lastChar[1]=t[t.length-1],n.slice(0,-1)}return n}return this.lastNeed=1,this.lastTotal=2,this.lastChar[0]=t[t.length-1],t.toString("utf16le",e,t.length-1)}function p(t){var e=t&&t.length?this.write(t):"";if(this.lastNeed){var n=this.lastTotal-this.lastNeed;return e+this.lastChar.toString("utf16le",0,n)}return e}function d(t,e){var n=(t.length-e)%3;return 0===n?t.toString("base64",e):(this.lastNeed=3-n,this.lastTotal=3,1===n?this.lastChar[0]=t[t.length-1]:(this.lastChar[0]=t[t.length-2],this.lastChar[1]=t[t.length-1]),t.toString("base64",e,t.length-n))}function v(t){var e=t&&t.length?this.write(t):"";return this.lastNeed?e+this.lastChar.toString("base64",0,3-this.lastNeed):e}function y(t){return t.toString(this.encoding)}function g(t){return t&&t.length?this.write(t):""}var b=n(48).Buffer,w=b.isEncoding||function(t){switch(t=""+t,t&&t.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return!0;default:return!1}};e.StringDecoder=o,o.prototype.write=function(t){if(0===t.length)return"";var e,n;if(this.lastNeed){if(e=this.fillLast(t),void 0===e)return"";n=this.lastNeed,this.lastNeed=0}else n=0;return n<t.length?e?e+this.text(t,n):this.text(t,n):e||""},o.prototype.end=f,o.prototype.text=h,o.prototype.fillLast=function(t){return this.lastNeed<=t.length?(t.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed),this.lastChar.toString(this.encoding,0,this.lastTotal)):(t.copy(this.lastChar,this.lastTotal-this.lastNeed,0,t.length),void(this.lastNeed-=t.length))}},function(t,e,n){function r(t,e){for(var n in t)e[n]=t[n]}function i(t,e,n){return s(t,e,n)}var o=n(5),s=o.Buffer;s.from&&s.alloc&&s.allocUnsafe&&s.allocUnsafeSlow?t.exports=o:(r(o,e),e.Buffer=i),r(s,i),i.from=function(t,e,n){if("number"==typeof t)throw new TypeError("Argument must not be a number");return s(t,e,n)},i.alloc=function(t,e,n){if("number"!=typeof t)throw new TypeError("Argument must be a number");var r=s(t);return void 0!==e?"string"==typeof n?r.fill(e,n):r.fill(e):r.fill(0),r},i.allocUnsafe=function(t){if("number"!=typeof t)throw new TypeError("Argument must be a number");return s(t)},i.allocUnsafeSlow=function(t){if("number"!=typeof t)throw new TypeError("Argument must be a number");return o.SlowBuffer(t)}},function(t,e,n){"use strict";function r(t){this.afterTransform=function(e,n){return i(t,e,n)},this.needTransform=!1,this.transforming=!1,this.writecb=null,this.writechunk=null,this.writeencoding=null}function i(t,e,n){var r=t._transformState;r.transforming=!1;var i=r.writecb;if(!i)return t.emit("error",new Error("no writecb in Transform class"));r.writechunk=null,r.writecb=null,null!==n&&void 0!==n&&t.push(n),i(e);var o=t._readableState;o.reading=!1,(o.needReadable||o.length<o.highWaterMark)&&t._read(o.highWaterMark)}function o(t){if(!(this instanceof o))return new o(t);a.call(this,t),this._transformState=new r(this);var e=this;this._readableState.needReadable=!0,this._readableState.sync=!1,t&&("function"==typeof t.transform&&(this._transform=t.transform),"function"==typeof t.flush&&(this._flush=t.flush)),this.once("prefinish",function(){"function"==typeof this._flush?this._flush(function(t,n){s(e,t,n)}):s(e)})}function s(t,e,n){if(e)return t.emit("error",e);null!==n&&void 0!==n&&t.push(n);var r=t._writableState,i=t._transformState;if(r.length)throw new Error("Calling transform done when ws.length != 0");if(i.transforming)throw new Error("Calling transform done when still transforming");return t.push(null)}t.exports=o;var a=n(42),c=n(39);c.inherits=n(33),c.inherits(o,a),o.prototype.push=function(t,e){return this._transformState.needTransform=!1,a.prototype.push.call(this,t,e)},o.prototype._transform=function(t,e,n){throw new Error("_transform() is not implemented")},o.prototype._write=function(t,e,n){var r=this._transformState;if(r.writecb=n,r.writechunk=t,r.writeencoding=e,!r.transforming){var i=this._readableState;(r.needTransform||i.needReadable||i.length<i.highWaterMark)&&this._read(i.highWaterMark)}},o.prototype._read=function(t){var e=this._transformState;null!==e.writechunk&&e.writecb&&!e.transforming?(e.transforming=!0,this._transform(e.writechunk,e.writeencoding,e.afterTransform)):e.needTransform=!0}},function(t,e,n){"use strict";function r(t){return this instanceof r?void i.call(this,t):new r(t)}t.exports=r;var i=n(49),o=n(39);o.inherits=n(33),o.inherits(r,i),r.prototype._transform=function(t,e,n){n(null,t)}},function(t,e,n){t.exports=n(43)},function(t,e,n){t.exports=n(42)},function(t,e,n){t.exports=n(34).Transform},function(t,e,n){t.exports=n(34).PassThrough},function(t,e){e["aes-128-ecb"]={cipher:"AES",key:128,iv:0,mode:"ECB",type:"block"},e["aes-192-ecb"]={cipher:"AES",key:192,iv:0,mode:"ECB",type:"block"},e["aes-256-ecb"]={cipher:"AES",key:256,iv:0,mode:"ECB",type:"block"},e["aes-128-cbc"]={cipher:"AES",key:128,iv:16,mode:"CBC",type:"block"},e["aes-192-cbc"]={cipher:"AES",key:192,iv:16,mode:"CBC",type:"block"},e["aes-256-cbc"]={cipher:"AES",key:256,iv:16,mode:"CBC",type:"block"},e.aes128=e["aes-128-cbc"],e.aes192=e["aes-192-cbc"],e.aes256=e["aes-256-cbc"],e["aes-128-cfb"]={cipher:"AES",key:128,iv:16,mode:"CFB",type:"stream"},e["aes-192-cfb"]={cipher:"AES",key:192,iv:16,mode:"CFB",type:"stream"},e["aes-256-cfb"]={cipher:"AES",key:256,iv:16,mode:"CFB",type:"stream"},e["aes-128-ofb"]={cipher:"AES",key:128,iv:16,mode:"OFB",type:"stream"},e["aes-192-ofb"]={cipher:"AES",key:192,iv:16,mode:"OFB",type:"stream"},e["aes-256-ofb"]={cipher:"AES",key:256,iv:16,mode:"OFB",type:"stream"},e["aes-128-ctr"]={cipher:"AES",key:128,iv:16,mode:"CTR",type:"stream"},e["aes-192-ctr"]={cipher:"AES",key:192,iv:16,mode:"CTR",type:"stream"},e["aes-256-ctr"]={cipher:"AES",key:256,iv:16,mode:"CTR",type:"stream"}},function(t,e,n){(function(e){t.exports=function(t,n,r,i){r/=8,i=i||0;for(var o,s,a,c=0,u=0,h=new e(r),f=new e(i),l=0;;){if(o=t.createHash("md5"),l++>0&&o.update(s),o.update(n),s=o.digest(),a=0,r>0)for(;;){if(0===r)break;if(a===s.length)break;h[c++]=s[a],r--,a++}if(i>0&&a!==s.length)for(;;){if(0===i)break;if(a===s.length)break;f[u++]=s[a],i--,a++}if(0===r&&0===i)break}for(a=0;a<s.length;a++)s[a]=0;return{key:h,iv:f}}}).call(e,n(5).Buffer)},function(t,e,n){(function(e){function r(t,n,s,a){return this instanceof r?(o.call(this),this._cipher=new i.AES(n),this._prev=new e(s.length),this._cache=new e(""),this._secCache=new e(""),this._decrypt=a,s.copy(this._prev),void(this._mode=t)):new r(t,n,s)}var i=n(29),o=n(30),s=n(33);s(r,o),t.exports=r,r.prototype._transform=function(t,e,n){n(null,this._mode.encrypt(this,t,this._decrypt))},r.prototype._flush=function(t){this._cipher.scrub(),t()}}).call(e,n(5).Buffer)},function(t,e){e.encrypt=function(t,e){return t._cipher.encryptBlock(e)},e.decrypt=function(t,e){return t._cipher.decryptBlock(e)}},function(t,e,n){var r=n(60);e.encrypt=function(t,e){var n=r(e,t._prev);return t._prev=t._cipher.encryptBlock(n),t._prev},e.decrypt=function(t,e){var n=t._prev;t._prev=e;var i=t._cipher.decryptBlock(e);return r(i,n)}},function(t,e,n){(function(e){function n(t,n){for(var r=Math.min(t.length,n.length),i=new e(r),o=-1;++o<r;)i.writeUInt8(t[o]^n[o],o);return i}t.exports=n}).call(e,n(5).Buffer)},function(t,e,n){(function(t){function r(e,n,r){var o=n.length,s=i(n,e._cache);return e._cache=e._cache.slice(o),e._prev=t.concat([e._prev,r?n:s]),s}var i=n(60);e.encrypt=function(e,n,i){for(var o,s=new t("");n.length;){if(0===e._cache.length&&(e._cache=e._cipher.encryptBlock(e._prev),e._prev=new t("")),!(e._cache.length<=n.length)){s=t.concat([s,r(e,n,i)]);break}o=e._cache.length,s=t.concat([s,r(e,n.slice(0,o),i)]),n=n.slice(o)}return s}}).call(e,n(5).Buffer)},function(t,e,n){(function(t){function r(t){return t._prev=t._cipher.encryptBlock(t._prev),t._prev}var i=n(60);e.encrypt=function(e,n){for(;e._cache.length<n.length;)e._cache=t.concat([e._cache,r(e)]);var o=e._cache.slice(0,n.length);return e._cache=e._cache.slice(n.length),i(n,o)}}).call(e,n(5).Buffer)},function(t,e,n){(function(t){function r(t){var e=t._cipher.encryptBlock(t._prev);return i(t._prev),e}function i(t){for(var e,n=t.length;n--;){if(e=t.readUInt8(n),255!==e){e++,t.writeUInt8(e,n);break}t.writeUInt8(0,n)}}var o=n(60);e.encrypt=function(e,n){for(;e._cache.length<n.length;)e._cache=t.concat([e._cache,r(e)]);var i=e._cache.slice(0,n.length);return e._cache=e._cache.slice(n.length),o(n,i)}}).call(e,n(5).Buffer)},function(t,e,n){(function(e){function r(t,n,o){return this instanceof r?(a.call(this),this._cache=new i,this._last=void 0,this._cipher=new s.AES(n),this._prev=new e(o.length),o.copy(this._prev),void(this._mode=t)):new r(t,n,o)}function i(){return this instanceof i?void(this.cache=new e("")):new i}function o(t){var e=t[15];if(16!==e)return t.slice(0,16-e)}var s=n(29),a=n(30),c=n(33),u=n(55),h=n(57),f=n(56);c(r,a),r.prototype._transform=function(t,e,n){this._cache.add(t);for(var r,i;r=this._cache.get();)i=this._mode.decrypt(this,r),this.push(i);n()},r.prototype._flush=function(t){var e=this._cache.flush();return e?(this.push(o(this._mode.decrypt(this,e))),void t()):t},i.prototype.add=function(t){this.cache=e.concat([this.cache,t])},i.prototype.get=function(){if(this.cache.length>16){var t=this.cache.slice(0,16);return this.cache=this.cache.slice(16),t}return null},i.prototype.flush=function(){if(this.cache.length)return this.cache};var l={ECB:n(58),CBC:n(59),CFB:n(61),OFB:n(62),CTR:n(63)};t.exports=function(t){function n(t,n,i){var o=u[t];if(!o)throw new TypeError("invalid suite type");if("string"==typeof i&&(i=new e(i)),"string"==typeof n&&(n=new e(n)),n.length!==o.key/8)throw new TypeError("invalid key length "+n.length);if(i.length!==o.iv)throw new TypeError("invalid iv length "+i.length);return"stream"===o.type?new h(l[o.mode],n,i,!0):new r(l[o.mode],n,i)}function i(e,r){var i=u[e];if(!i)throw new TypeError("invalid suite type");var o=f(t,r,i.key,i.iv);return n(e,o.key,o.iv)}return{createDecipher:i,createDecipheriv:n}}}).call(e,n(5).Buffer)},function(t,e){var n=function(){function t(){if(!Y){try{var t=P.getElementsByTagName("body")[0].appendChild(g("span"));t.parentNode.removeChild(t)}catch(e){return}Y=!0;for(var n=W.length,r=0;r<n;r++)W[r]()}}function e(t){Y?t():W[W.length]=t}function r(t){if(typeof U.addEventListener!=x)U.addEventListener("load",t,!1);else if(typeof P.addEventListener!=x)P.addEventListener("load",t,!1);else if(typeof U.attachEvent!=x)b(U,"onload",t);else if("function"==typeof U.onload){var e=U.onload;U.onload=function(){e(),t()}}else U.onload=t}function i(){L?o():s()}function o(){var t=P.getElementsByTagName("body")[0],e=g(B);e.setAttribute("type",R);var n=t.appendChild(e);if(n){var r=0;!function(){if(typeof n.GetVariable!=x){var i=n.GetVariable("$version");i&&(i=i.split(" ")[1].split(","),J.pv=[parseInt(i[0],10),parseInt(i[1],10),parseInt(i[2],10)])}else if(r<10)return r++,void setTimeout(arguments.callee,10);t.removeChild(e),n=null,s()}()}else s()}function s(){var t=F.length;if(t>0)for(var e=0;e<t;e++){var n=F[e].id,r=F[e].callbackFn,i={success:!1,id:n};if(J.pv[0]>0){var o=y(n);if(o)if(!w(F[e].swfVersion)||J.wk&&J.wk<312)if(F[e].expressInstall&&c()){var s={};s.data=F[e].expressInstall,s.width=o.getAttribute("width")||"0",s.height=o.getAttribute("height")||"0",o.getAttribute("class")&&(s.styleclass=o.getAttribute("class")),o.getAttribute("align")&&(s.align=o.getAttribute("align"));for(var f={},l=o.getElementsByTagName("param"),p=l.length,d=0;d<p;d++)"movie"!=l[d].getAttribute("name").toLowerCase()&&(f[l[d].getAttribute("name")]=l[d].getAttribute("value"));u(s,f,n,r)}else h(o),r&&r(i);else _(n,!0),r&&(i.success=!0,i.ref=a(n),r(i))}else if(_(n,!0),r){var v=a(n);v&&typeof v.SetVariable!=x&&(i.success=!0,i.ref=v),r(i)}}}function a(t){var e=null,n=y(t);if(n&&"OBJECT"==n.nodeName)if(typeof n.SetVariable!=x)e=n;else{var r=n.getElementsByTagName(B)[0];r&&(e=r)}return e}function c(){return!$&&w("6.0.65")&&(J.win||J.mac)&&!(J.wk&&J.wk<312)}function u(t,e,n,r){$=!0,T=r||null,k={success:!1,id:n};var i=y(n);if(i){"OBJECT"==i.nodeName?(E=f(i),O=null):(E=i,O=n),t.id=M,(typeof t.width==x||!/%$/.test(t.width)&&parseInt(t.width,10)<310)&&(t.width="310"),(typeof t.height==x||!/%$/.test(t.height)&&parseInt(t.height,10)<137)&&(t.height="137"),P.title=P.title.slice(0,47)+" - Flash Player Installation";var o=J.ie&&J.win?["Active"].concat("").join("X"):"PlugIn",s="MMredirectURL="+U.location.toString().replace(/&/g,"%26")+"&MMplayerType="+o+"&MMdoctitle="+P.title;if(typeof e.flashvars!=x?e.flashvars+="&"+s:e.flashvars=s,J.ie&&J.win&&4!=i.readyState){var a=g("div");n+="SWFObjectNew",a.setAttribute("id",n),i.parentNode.insertBefore(a,i),i.style.display="none",function(){4==i.readyState?i.parentNode.removeChild(i):setTimeout(arguments.callee,10)}()}l(t,e,n)}}function h(t){if(J.ie&&J.win&&4!=t.readyState){var e=g("div");t.parentNode.insertBefore(e,t),e.parentNode.replaceChild(f(t),e),t.style.display="none",function(){4==t.readyState?t.parentNode.removeChild(t):setTimeout(arguments.callee,10)}()}else t.parentNode.replaceChild(f(t),t)}function f(t){var e=g("div");if(J.win&&J.ie)e.innerHTML=t.innerHTML;else{var n=t.getElementsByTagName(B)[0];if(n){var r=n.childNodes;if(r)for(var i=r.length,o=0;o<i;o++)1==r[o].nodeType&&"PARAM"==r[o].nodeName||8==r[o].nodeType||e.appendChild(r[o].cloneNode(!0))}}return e}function l(t,e,n){var r,i=y(n);if(J.wk&&J.wk<312)return r;if(i)if(typeof t.id==x&&(t.id=n),J.ie&&J.win){var o="";for(var s in t)t[s]!=Object.prototype[s]&&("data"==s.toLowerCase()?e.movie=t[s]:"styleclass"==s.toLowerCase()?o+=' class="'+t[s]+'"':"classid"!=s.toLowerCase()&&(o+=" "+s+'="'+t[s]+'"'));var a="";for(var c in e)e[c]!=Object.prototype[c]&&(a+='<param name="'+c+'" value="'+e[c]+'" />');i.outerHTML='<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"'+o+">"+a+"</object>",z[z.length]=t.id,r=y(t.id)}else{var u=g(B);u.setAttribute("type",R);for(var h in t)t[h]!=Object.prototype[h]&&("styleclass"==h.toLowerCase()?u.setAttribute("class",t[h]):"classid"!=h.toLowerCase()&&u.setAttribute(h,t[h]));for(var f in e)e[f]!=Object.prototype[f]&&"movie"!=f.toLowerCase()&&p(u,f,e[f]);i.parentNode.replaceChild(u,i),r=u}return r}function p(t,e,n){var r=g("param");r.setAttribute("name",e),r.setAttribute("value",n),t.appendChild(r)}function d(t){var e=y(t);e&&"OBJECT"==e.nodeName&&(J.ie&&J.win?(e.style.display="none",function(){4==e.readyState?v(t):setTimeout(arguments.callee,10)}()):e.parentNode.removeChild(e))}function v(t){var e=y(t);if(e){for(var n in e)"function"==typeof e[n]&&(e[n]=null);e.parentNode.removeChild(e)}}function y(t){var e=null;try{e=P.getElementById(t)}catch(n){}return e}function g(t){return P.createElement(t)}function b(t,e,n){t.attachEvent(e,n),q[q.length]=[t,e,n]}function w(t){var e=J.pv,n=t.split(".");return n[0]=parseInt(n[0],10),n[1]=parseInt(n[1],10)||0,n[2]=parseInt(n[2],10)||0,e[0]>n[0]||e[0]==n[0]&&e[1]>n[1]||e[0]==n[0]&&e[1]==n[1]&&e[2]>=n[2]}function m(t,e,n,r){if(!J.ie||!J.mac){var i=P.getElementsByTagName("head")[0];if(i){var o=n&&"string"==typeof n?n:"screen";if(r&&(C=null,j=null),!C||j!=o){var s=g("style");s.setAttribute("type","text/css"),s.setAttribute("media",o),C=i.appendChild(s),J.ie&&J.win&&typeof P.styleSheets!=x&&P.styleSheets.length>0&&(C=P.styleSheets[P.styleSheets.length-1]),j=o}J.ie&&J.win?C&&typeof C.addRule==B&&C.addRule(t,e):C&&typeof P.createTextNode!=x&&C.appendChild(P.createTextNode(t+" {"+e+"}"))}}}function _(t,e){if(X){var n=e?"visible":"hidden";Y&&y(t)?y(t).style.visibility=n:m("#"+t,"visibility:"+n)}}function S(t){var e=/[\\\"<>\.;]/,n=null!=e.exec(t);return n&&typeof encodeURIComponent!=x?encodeURIComponent(t):t}var E,O,T,k,C,j,x="undefined",B="object",A="Shockwave Flash",I="ShockwaveFlash.ShockwaveFlash",R="application/x-shockwave-flash",M="SWFObjectExprInst",N="onreadystatechange",U=window,P=document,D=navigator,L=!1,W=[i],F=[],z=[],q=[],Y=!1,$=!1,X=!0,J=function(){var t=typeof P.getElementById!=x&&typeof P.getElementsByTagName!=x&&typeof P.createElement!=x,e=D.userAgent.toLowerCase(),n=D.platform.toLowerCase(),r=n?/win/.test(n):/win/.test(e),i=n?/mac/.test(n):/mac/.test(e),o=!!/webkit/.test(e)&&parseFloat(e.replace(/^.*webkit\/(\d+(\.\d+)?).*$/,"$1")),s=!1,a=[0,0,0],c=null;if(typeof D.plugins!=x&&typeof D.plugins[A]==B)c=D.plugins[A].description,!c||typeof D.mimeTypes!=x&&D.mimeTypes[R]&&!D.mimeTypes[R].enabledPlugin||(L=!0,s=!1,c=c.replace(/^.*\s+(\S+\s+\S+$)/,"$1"),a[0]=parseInt(c.replace(/^(.*)\..*$/,"$1"),10),a[1]=parseInt(c.replace(/^.*\.(.*)\s.*$/,"$1"),10),a[2]=/[a-zA-Z]/.test(c)?parseInt(c.replace(/^.*[a-zA-Z]+(.*)$/,"$1"),10):0);else if(typeof U[["Active"].concat("Object").join("X")]!=x)try{var u=new(window[["Active"].concat("Object").join("X")])(I);u&&(c=u.GetVariable("$version"),c&&(s=!0,c=c.split(" ")[1].split(","),a=[parseInt(c[0],10),parseInt(c[1],10),parseInt(c[2],10)]))}catch(h){}return{w3:t,pv:a,wk:o,ie:s,win:r,mac:i}}();(function(){J.w3&&((typeof P.readyState!=x&&"complete"==P.readyState||typeof P.readyState==x&&(P.getElementsByTagName("body")[0]||P.body))&&t(),Y||(typeof P.addEventListener!=x&&P.addEventListener("DOMContentLoaded",t,!1),J.ie&&J.win&&(P.attachEvent(N,function(){"complete"==P.readyState&&(P.detachEvent(N,arguments.callee),t())}),U==top&&!function(){if(!Y){try{P.documentElement.doScroll("left")}catch(e){return void setTimeout(arguments.callee,0)}t()}}()),J.wk&&!function(){if(!Y)return/loaded|complete/.test(P.readyState)?void t():void setTimeout(arguments.callee,0)}(),r(t)))})(),function(){J.ie&&J.win&&window.attachEvent("onunload",function(){for(var t=q.length,e=0;e<t;e++)q[e][0].detachEvent(q[e][1],q[e][2]);for(var r=z.length,i=0;i<r;i++)d(z[i]);for(var o in J)J[o]=null;J=null;for(var s in n)n[s]=null;n=null})}();return{registerObject:function(t,e,n,r){if(J.w3&&t&&e){var i={};i.id=t,i.swfVersion=e,i.expressInstall=n,i.callbackFn=r,F[F.length]=i,_(t,!1)}else r&&r({success:!1,id:t})},getObjectById:function(t){if(J.w3)return a(t)},embedSWF:function(t,n,r,i,o,s,a,h,f,p){var d={success:!1,id:n};J.w3&&!(J.wk&&J.wk<312)&&t&&n&&r&&i&&o?(_(n,!1),e(function(){r+="",i+="";var e={};if(f&&typeof f===B)for(var v in f)e[v]=f[v];e.data=t,e.width=r,e.height=i;var y={};if(h&&typeof h===B)for(var g in h)y[g]=h[g];if(a&&typeof a===B)for(var b in a)typeof y.flashvars!=x?y.flashvars+="&"+b+"="+a[b]:y.flashvars=b+"="+a[b];if(w(o)){var m=l(e,y,n);e.id==n&&_(n,!0),d.success=!0,d.ref=m}else{if(s&&c())return e.data=s,void u(e,y,n,p);_(n,!0)}p&&p(d)})):p&&p(d)},switchOffAutoHideShow:function(){X=!1},ua:J,getFlashPlayerVersion:function(){return{major:J.pv[0],minor:J.pv[1],release:J.pv[2]}},hasFlashPlayerVersion:w,createSWF:function(t,e,n){return J.w3?l(t,e,n):void 0},showExpressInstall:function(t,e,n,r){J.w3&&c()&&u(t,e,n,r)},removeSWF:function(t){J.w3&&d(t)},createCSS:function(t,e,n,r){J.w3&&m(t,e,n,r)},addDomLoadEvent:e,addLoadEvent:r,getQueryParamValue:function(t){var e=P.location.search||P.location.hash;if(e){if(/\?/.test(e)&&(e=e.split("?")[1]),null==t)return S(e);for(var n=e.split("&"),r=0;r<n.length;r++)if(n[r].substring(0,n[r].indexOf("="))==t)return S(n[r].substring(n[r].indexOf("=")+1))}return""},expressInstallCallback:function(){if($){var t=y(M);t&&E&&(t.parentNode.replaceChild(E,t),O&&(_(O,!0),J.ie&&J.win&&(E.style.display="block")),T&&T(k)),$=!1}}}}();t.exports=n},function(t,e,n){n(1),n(2);!function(){if(window.WEB_SOCKET_FORCE_FLASH);else{if(window.WebSocket)return;if(window.MozWebSocket)return void(window.WebSocket=MozWebSocket)}var t;return t=window.WEB_SOCKET_LOGGER?WEB_SOCKET_LOGGER:window.console&&window.console.log&&window.console.error?window.console:{log:function(){},error:function(){}},10>swfobject.getFlashPlayerVersion().major?void t.error("Flash Player >= 10.0.0 is required."):("file:"==location.protocol&&t.error("WARNING: web-socket-js doesn't work in file:///... URL unless you set Flash Security Settings properly. Open the page via Web server i.e. http://..."),window.WebSocket=function(t,e,n,r,i){var o=this;o.__id=WebSocket.__nextId++,WebSocket.__instances[o.__id]=o,o.readyState=WebSocket.CONNECTING,o.bufferedAmount=0,o.__events={},e?"string"==typeof e&&(e=[e]):e=[],o.__createTask=setTimeout(function(){WebSocket.__addTask(function(){o.__createTask=null,WebSocket.__flash.create(o.__id,t,e,n||null,r||0,i||null)})},0)},WebSocket.prototype.send=function(t){if(this.readyState==WebSocket.CONNECTING)throw"INVALID_STATE_ERR: Web Socket connection has not been established";var e=WebSocket.__flash.send(this.__id,encodeURIComponent(t));return 0>e||(this.bufferedAmount+=e,!1)},WebSocket.prototype.close=function(){return this.__createTask?(clearTimeout(this.__createTask),this.__createTask=null,void(this.readyState=WebSocket.CLOSED)):void(this.readyState!=WebSocket.CLOSED&&this.readyState!=WebSocket.CLOSING&&(this.readyState=WebSocket.CLOSING,WebSocket.__flash.close(this.__id)))},WebSocket.prototype.addEventListener=function(t,e){t in this.__events||(this.__events[t]=[]),this.__events[t].push(e)},WebSocket.prototype.removeEventListener=function(t,e){if(t in this.__events)for(var n=this.__events[t],r=n.length-1;r>=0;--r)if(n[r]===e){n.splice(r,1);break}},WebSocket.prototype.dispatchEvent=function(t){for(var e=this.__events[t.type]||[],n=0;e.length>n;++n)e[n](t);var r=this["on"+t.type];r&&r.apply(this,[t])},WebSocket.prototype.__handleEvent=function(t){"readyState"in t&&(this.readyState=t.readyState),"protocol"in t&&(this.protocol=t.protocol);var e;if("open"==t.type||"error"==t.type)e=this.__createSimpleEvent(t.type);else if("close"==t.type)e=this.__createSimpleEvent("close"),e.wasClean=!!t.wasClean,e.code=t.code,e.reason=t.reason;else{if("message"!=t.type)throw"unknown event type: "+t.type;var n=decodeURIComponent(t.message);e=this.__createMessageEvent("message",n)}this.dispatchEvent(e)},WebSocket.prototype.__createSimpleEvent=function(t){if(document.createEvent&&window.Event){var e=document.createEvent("Event");return e.initEvent(t,!1,!1),e}return{type:t,bubbles:!1,cancelable:!1}},WebSocket.prototype.__createMessageEvent=function(t,e){if(document.createEvent&&window.MessageEvent&&!window.opera){var n=document.createEvent("MessageEvent");return n.initMessageEvent("message",!1,!1,e,null,null,window,null),n}return{type:t,data:e,bubbles:!1,cancelable:!1}},WebSocket.CONNECTING=0,WebSocket.OPEN=1,WebSocket.CLOSING=2,WebSocket.CLOSED=3,WebSocket.__isFlashImplementation=!0,WebSocket.__initialized=!1,WebSocket.__flash=null,WebSocket.__instances={},WebSocket.__tasks=[],WebSocket.__nextId=0,WebSocket.loadFlashPolicyFile=function(t){WebSocket.__addTask(function(){WebSocket.__flash.loadManualPolicyFile(t)})},WebSocket.__initialize=function(){if(!WebSocket.__initialized){if(WebSocket.__initialized=!0,WebSocket.__swfLocation&&(window.WEB_SOCKET_SWF_LOCATION=WebSocket.__swfLocation),!window.WEB_SOCKET_SWF_LOCATION)return void t.error("[WebSocket] set WEB_SOCKET_SWF_LOCATION to location of WebSocketMain.swf");if(!window.WEB_SOCKET_SUPPRESS_CROSS_DOMAIN_SWF_ERROR&&!WEB_SOCKET_SWF_LOCATION.match(/(^|\/)WebSocketMainInsecure\.swf(\?.*)?$/)&&WEB_SOCKET_SWF_LOCATION.match(/^\w+:\/\/([^\/]+)/)){var e=RegExp.$1;location.host!=e&&t.error("[WebSocket] You must host HTML and WebSocketMain.swf in the same host ('"+location.host+"' != '"+e+"'). See also 'How to host HTML file and SWF file in different domains' section in README.md. If you use WebSocketMainInsecure.swf, you can suppress this message by WEB_SOCKET_SUPPRESS_CROSS_DOMAIN_SWF_ERROR = true;")}var n=document.createElement("div");n.id="webSocketContainer",n.style.position="absolute",WebSocket.__isFlashLite()?(n.style.left="0px",n.style.top="0px"):(n.style.left="-100px",n.style.top="-100px");var r=document.createElement("div");r.id="webSocketFlash",n.appendChild(r),document.body.appendChild(n),swfobject.embedSWF(WEB_SOCKET_SWF_LOCATION,"webSocketFlash","1","1","10.0.0",null,null,{hasPriority:!0,swliveconnect:!0,allowScriptAccess:"always"},null,function(e){e.success||t.error("[WebSocket] swfobject.embedSWF failed")})}},WebSocket.__onFlashInitialized=function(){setTimeout(function(){WebSocket.__flash=document.getElementById("webSocketFlash"),WebSocket.__flash.setCallerUrl(location.href),WebSocket.__flash.setDebug(!!window.WEB_SOCKET_DEBUG);for(var t=0;WebSocket.__tasks.length>t;++t)WebSocket.__tasks[t]();WebSocket.__tasks=[]},0)},WebSocket.__onFlashEvent=function(){return setTimeout(function(){try{for(var e=WebSocket.__flash.receiveEvents(),n=0;e.length>n;++n)WebSocket.__instances[e[n].webSocketId].__handleEvent(e[n])}catch(r){t.error(r)}},0),!0},WebSocket.__log=function(e){t.log(decodeURIComponent(e))},WebSocket.__error=function(e){t.error(decodeURIComponent(e))},WebSocket.__addTask=function(t){WebSocket.__flash?t():WebSocket.__tasks.push(t)},WebSocket.__isFlashLite=function(){if(!window.navigator||!window.navigator.mimeTypes)return!1;var t=window.navigator.mimeTypes["application/x-shockwave-flash"];return!!(t&&t.enabledPlugin&&t.enabledPlugin.filename)&&!!t.enabledPlugin.filename.match(/flashlite/i)},void(window.WEB_SOCKET_DISABLE_AUTO_INITIALIZATION||swfobject.addDomLoadEvent(function(){WebSocket.__initialize()})))}()},function(t,e,n){t.exports=n(68)},function(t,e,n){(function(t,r){/*!
		 * Nats
		 * Copyright(c) 2012-2016 Apcera Inc. All rights reserved.
		 * Copyright(c) 2011-2014 Derek Collison (derek.collison@gmail.com)
		 * MIT Licensed
		 */
	"use strict";function i(t){f.EventEmitter.call(this),this.parseOptions(t),this.initState(),this.createConnection()}function o(t){for(var e=t.length-1;e>0;e--){var n=Math.floor(Math.random()*(e+1)),r=t[e];t[e]=t[n],t[n]=r}return t}function s(t){this.url=t,this.didConnect=!1,this.reconnects=0}var a=n(69),c=n(70),u=n(71),h=n(15),f=n(32),l=n(78),p="0.6.8",d=4222,v="nats://localhost:",y=v+d,g=512,b=0,w=1,m=2e3,_=10,S=/^MSG\s+([^\s\r\n]+)\s+([^\s\r\n]+)\s+(([^\s\r\n]+)[^\S\r\n]+)?(\d+)\r\n/i,E=/^\+OK\s*\r\n/i,O=/^-ERR\s+('.+')?\r\n/i,T=/^PING\r\n/i,k=/^PONG\r\n/i,C=/^INFO\s+([^\r\n]+)\r\n/i,j=/^SUB\s+([^\r\n]+)\r\n/i,x="\r\n",B=x.length,A="",I=" ",R="SUB",M="UNSUB",N="CONNECT",U="PING"+x,P="PONG"+x,D="Subject must be supplied",L="Message can't be a function",W="Reply can't be a function",F="Connection closed",z="Message should be a JSON object",q="User and Token can not both be provided",Y=65536;e.version=p;var $=e.createInbox=function(){return"_INBOX."+l.next()};e.connect=function(t){return new i(t)},h.inherits(i,f.EventEmitter),i.prototype.createInbox=$,i.prototype.assignOption=function(t,e,n){void 0===n&&(n=e),void 0!==t[e]&&(this.options[n]=t[e])},i.prototype.parseOptions=function(e){var n=this.options={verbose:!1,pedantic:!1,reconnect:!0,maxReconnectAttempts:_,reconnectTimeWait:m,encoding:"utf8",tls:!1,waitOnFirstConnect:!1};void 0===e?n.url=y:"number"==typeof e?n.url=v+e:"string"==typeof e?n.url=e:"object"==typeof e&&(void 0!==e.port&&(n.url=v+e.port),this.assignOption(e,"url"),this.assignOption(e,"uri","url"),this.assignOption(e,"user"),this.assignOption(e,"pass"),this.assignOption(e,"token"),this.assignOption(e,"password","pass"),this.assignOption(e,"verbose"),this.assignOption(e,"pedantic"),this.assignOption(e,"reconnect"),this.assignOption(e,"maxReconnectAttempts"),this.assignOption(e,"reconnectTimeWait"),this.assignOption(e,"servers"),this.assignOption(e,"urls","servers"),this.assignOption(e,"noRandomize"),this.assignOption(e,"NoRandomize","noRandomize"),this.assignOption(e,"dontRandomize","noRandomize"),this.assignOption(e,"encoding"),this.assignOption(e,"tls"),this.assignOption(e,"secure","tls"),this.assignOption(e,"name"),this.assignOption(e,"client","name"),this.assignOption(e,"yieldTime"),this.assignOption(e,"waitOnFirstConnect"),this.assignOption(e,"json"));var r=this;if(r.user=n.user,r.pass=n.pass,r.token=n.token,r.user&&r.token)throw new Error(q);if(!t.isEncoding(n.encoding))throw new Error("Invalid Encoding:"+n.encoding);r.encoding=n.encoding,r.servers=[],Array.isArray(n.servers)?n.servers.forEach(function(t){r.servers.push(new s(u.parse(t)))}):(void 0===n.url&&(n.url=y),r.servers.push(new s(u.parse(n.url)))),n.noRandomize!==!0&&o(r.servers)},i.prototype.selectServer=function(){var t=this,e=t.servers.shift();if(t.currentServer=e,t.url=e.url,"auth"in e.url&&e.url.auth){var n=e.url.auth.split(":");1!==n.length?(void 0===t.options.user&&(t.user=n[0]),void 0===t.options.pass&&(t.pass=n[1])):void 0===t.options.token&&(t.token=n[0])}t.servers.push(e)},i.prototype.checkTLSMismatch=function(){return this.info.tls_required===!0&&this.options.tls===!1?(this.emit("error","Server requires a secure connection."),this.closeStream(),!0):this.info.tls_required===!1&&this.options.tls!==!1?(this.emit("error","Server does not support a secure connection."),this.closeStream(),!0):this.info.tls_verify===!0&&void 0===this.options.tls.cert&&(this.emit("error","Server requires a client certificate."),this.closeStream(),!0)},i.prototype.connectCB=function(){var t=this.reconnecting,e=t===!0?"reconnect":"connect";this.reconnecting=!1,this.reconnects=0,this.wasConnected=!0,this.currentServer.didConnect=!0,this.emit(e,this),this.flushPending()},i.prototype.setupHandlers=function(){var e=this,n=e.stream;void 0!==n&&(n.on("connect",function(){e.connected=!0}),n.on("close",function(t){e.closeStream(),e.emit("disconnect"),e.closed===!0||e.options.reconnect===!1||e.reconnects>=e.options.maxReconnectAttempts&&e.options.maxReconnectAttempts!==-1?e.emit("close"):e.scheduleReconnect()}),n.on("error",function(t){e.wasConnected===!0&&e.currentServer.didConnect===!0||(e.wasConnected===!1&&e.currentServer.didConnect===!1&&(e.options.waitOnFirstConnect?e.currentServer.didConnect=!0:e.servers.splice(e.servers.length-1,1)),e.wasConnected===!1&&0===e.servers.length&&e.emit("error","Could not connect to server: "+t),e.closeStream())}),n.on("data",function(n){e.inbound?e.inbound=t.concat([e.inbound,n]):e.inbound=n,e.processInbound()}))},i.prototype.sendConnect=function(){var t={lang:"node",version:p,verbose:this.options.verbose,pedantic:this.options.pedantic};void 0!==this.user&&(t.user=this.user,t.pass=this.pass),void 0!==this.token&&(t.auth_token=this.token),void 0!==this.options.name&&(t.name=this.options.name),this.stream.write(N+I+JSON.stringify(t)+x)},i.prototype.createConnection=function(){var e=[],n=[],r=0,i=this;if(null!==i.pending){var o=0;i.pending.forEach(function(s){var a=t.isBuffer(s)?s.length:t.byteLength(s);if(s===U&&null!==i.pongs&&o<i.pongs.length){var c=i.pongs[o++];void 0!==c&&(n.push(s),r+=a,e.push(c))}else s.length>3&&"P"==s[0]&&"U"==s[1]&&"B"==s[2]&&(n.push(s),r+=a)})}this.pongs=e,this.pending=n,this.pSize=r,this.pstate=b,this.info=null,this.infoReceived=!1,this.selectServer(),this.stream=a.createConnection(this.url),this.setupHandlers()},i.prototype.initState=function(){this.ssid=1,this.subs={},this.reconnects=0,this.connected=!1,this.wasConnected=!1,this.reconnecting=!1,this.server=null,this.pending=[]},i.prototype.close=function(){this.closed=!0,this.removeAllListeners(),this.closeStream(),this.ssid=-1,this.subs=null,this.pstate=-1,this.pongs=null,this.pending=null,this.pSize=0},i.prototype.closeStream=function(){null!==this.stream&&(this.stream.end(),this.stream.destroy(),this.stream=null),this.connected!==!0&&this.closed!==!0||(this.pongs=null,this.pending=null,this.pSize=0,this.connected=!1),this.inbound=null},i.prototype.flushPending=function(){if(this.connected!==!1&&null!==this.pending&&0!==this.pending.length&&this.infoReceived===!0){var e=this,n=function(t){return e.pending=[],e.pSize=0,e.stream.write(t)};if(this.pBufs){for(var r=!0,i=0;i<this.pending.length;i++)if(!t.isBuffer(this.pending[i])){r=!1;break}if(r)return n(t.concat(this.pending,this.pSize));var o=this.pending;this.pending=[],this.pSize=0;var s=!0;for(i=0;i<o.length;i++)s=this.stream.write(o[i])&&s;return s}return n(this.pending.join(A))}},i.prototype.stripPendingSubs=function(){var t=this.pending;this.pending=[],this.pSize=0;for(var e=0;e<t.length;e++)j.test(t[e])||this.sendCommand(t[e])},i.prototype.sendCommand=function(e){if(!this.closed&&null!==this.pending&&(this.pending.push(e),t.isBuffer(e)?(this.pSize+=e.length,this.pBufs=!0):this.pSize+=t.byteLength(e),this.connected===!0))if(1===this.pending.length){var n=this;r(function(){n.flushPending()})}else this.pSize>Y&&this.flushPending()},i.prototype.sendSubscriptions=function(){var t="";for(var e in this.subs)if(this.subs.hasOwnProperty(e)){var n,r=this.subs[e];n=r.qgroup?[R,r.subject,r.qgroup,e+x]:[R,r.subject,e+x],t+=n.join(I)}t.length>0&&this.stream.write(t)},i.prototype.processInbound=function(){var e,n,i=this;for(i.stream.resume(),void 0!==i.options.yieldTime&&(n=Date.now());!i.closed&&i.inbound&&i.inbound.length>0;){switch(i.pstate){case b:var o=i.inbound.toString("binary",0,g);if(null!==(e=S.exec(o)))i.payload={subj:e[1],sid:parseInt(e[2],10),reply:e[4],size:parseInt(e[5],10)},i.payload.psize=i.payload.size+B,i.pstate=w;else if(null!==(e=E.exec(o)));else if(null!==(e=O.exec(o)))i.emit("error",e[1]);else if(null!==(e=k.exec(o))){var s=i.pongs&&i.pongs.shift();s&&s()}else if(null!==(e=T.exec(o)))i.sendCommand(P);else{if(null===(e=C.exec(o)))return;if(i.info=JSON.parse(e[1]),i.checkTLSMismatch()===!0)return;if(i.infoReceived===!1){if(i.options.tls!==!1&&i.stream.encrypted!==!0){var a={socket:i.stream};if("object"==typeof i.options.tls)for(var u in i.options.tls)a[u]=i.options.tls[u];i.stream=c.connect(a,function(){i.flushPending()}),i.setupHandlers()}i.sendConnect(),i.sendSubscriptions(),i.pongs.unshift(function(){i.connectCB()}),i.stream.write(U),i.infoReceived=!0,i.stripPendingSubs(),i.flushPending()}}break;case w:if(i.inbound.length<i.payload.psize)return void 0===i.payload.chunks&&(i.payload.chunks=[]),i.payload.chunks.push(i.inbound),i.payload.psize-=i.inbound.length,void(i.inbound=null);if(i.payload.chunks){i.payload.chunks.push(i.inbound.slice(0,i.payload.psize));var h=t.concat(i.payload.chunks,i.payload.size+B);i.payload.msg=h.toString(i.encoding,0,i.payload.size)}else i.payload.msg=i.inbound.toString(i.encoding,0,i.payload.size);if(i.inbound.length===i.payload.psize?i.inbound=null:i.inbound=i.inbound.slice(i.payload.psize),i.processMsg(),i.pstate=b,i.payload=null,void 0!==n&&Date.now()-n>i.options.yieldTime)return i.stream.pause(),void r(i.processInbound.bind(this))}if(e&&!this.closed){var f=e[0].length;f>=i.inbound.length?i.inbound=null:i.inbound=i.inbound.slice(f)}e=null}},i.prototype.processMsg=function(){var e=this.subs[this.payload.sid];if(void 0!==e&&(e.received+=1,e.timeout&&e.received>=e.expected&&(clearTimeout(e.timeout),e.timeout=null),void 0!==e.max&&(e.received===e.max?(delete this.subs[this.payload.sid],this.emit("unsubscribe",this.payload.sid,e.subject)):e.received>e.max&&(this.unsubscribe(this.payload.sid),e.callback=null)),e.callback)){var n=this.payload.msg;if(this.options.json)try{n=JSON.parse(new t(this.payload.msg,this.options.encoding).toString())}catch(r){n=r}e.callback(n,this.payload.reply,this.payload.subj,this.payload.sid)}},i.prototype.addServer=function(t){this.servers.push(new s(u.parse(t))),this.options.noRandomize!==!0&&o(this.servers)},i.prototype.flush=function(t){if(this.closed){if("function"==typeof t)return void t(new Error(F));throw new Error(F)}this.pongs&&(this.pongs.push(t),this.sendCommand(U),this.flushPending())},i.prototype.publish=function(e,n,r,i){if("function"==typeof e&&(i=e,e=void 0),n||(n=A),!e){if(!i)throw new Error(D);i(new Error(D))}if("function"==typeof n){if(i||r)return void i(new Error(L));i=n,n=A,r=void 0}if("function"==typeof r){if(i)return void i(new Error(W));i=r,r=void 0}var o;if(o=void 0===r?"PUB "+e+I:"PUB "+e+I+r+I,"ArrayBuffer"in window&&ArrayBuffer.isView(n)&&(n=t.from(n)),t.isBuffer(n)){var s=new t(o.length+n.length+2*B+n.length.toString().length),a=s.write(o+n.length+x);n.copy(s,a),s.write(x,a+n.length),this.sendCommand(s)}else{var c=n;if(this.options.json){if("object"!=typeof n||Array.isArray(n))throw new Error(z);try{c=JSON.stringify(n)}catch(u){throw new Error(z)}}this.sendCommand(o+t.byteLength(c)+x+c+x)}if(void 0!==i)this.flush(i);else if(this.closed)throw new Error(F)},i.prototype.subscribe=function(t,e,n){if(this.closed)throw new Error(F);var r,i;"function"==typeof e?(n=e,e=void 0):e&&"object"==typeof e&&(r=e.queue,i=e.max),this.ssid+=1,this.subs[this.ssid]={subject:t,callback:n,received:0};var o;return"string"==typeof r?(this.subs[this.ssid].qgroup=r,o=[R,t,r,this.ssid+x]):o=[R,t,this.ssid+x],this.sendCommand(o.join(I)),this.emit("subscribe",this.ssid,t,e),i&&this.unsubscribe(this.ssid,i),this.ssid},i.prototype.unsubscribe=function(t,e){if(t&&!this.closed){var n;n=e?[M,t,e+x]:[M,t+x],this.sendCommand(n.join(I));var r=this.subs[t];void 0!==r&&(r.max=e,(void 0===r.max||r.received>=r.max)&&(delete this.subs[t],this.emit("unsubscribe",t,r.subject)))}},i.prototype.timeout=function(t,e,n,r){if(t){var i=this.subs[t];null!==i&&(i.expected=n,i.timeout=setTimeout(function(){r(t)},e))}},i.prototype.request=function(t,e,n,r){"function"==typeof e&&(r=e,e=A,n=null),"function"==typeof n&&(r=n,n=null);var i=$(),o=this.subscribe(i,n,function(t,e){r(t,e)});return this.publish(t,e,i),o},i.prototype.numSubscriptions=function(){return Object.keys(this.subs).length},i.prototype.reconnect=function(){this.closed||(this.reconnects+=1,this.createConnection(),this.currentServer.didConnect===!0&&this.emit("reconnecting"))},i.prototype.scheduleReconnect=function(){var t=this;if(0!==t.servers.length){t.wasConnected===!0&&(t.reconnecting=!0);var e=0;t.servers[0].didConnect===!0&&(e=this.options.reconnectTimeWait),setTimeout(function(){t.reconnect()},e)}}}).call(e,n(5).Buffer,n(44).setImmediate)},function(t,e,n){(function(t){"use strict";function r(e){var n=this;o.call(this),this.sock=new WebSocket(e),this.sock.addEventListener("open",function(t){n.emit("connect")}),this.sock.addEventListener("message",function(e){n.emit("data",new t(e.data))}),this.sock.addEventListener("error",function(t){n.emit("error",t)}),this.sock.addEventListener("close",function(t){n.emit("close")})}var i=n(15),o=n(32).EventEmitter;i.inherits(r,o),r.prototype.end=function(){this.destroy()},r.prototype.destroy=function(){this.sock.readyState!==WebSocket.CONNECTING&&this.sock.readyState!==WebSocket.OPEN||this.sock.close()},r.prototype.write=function(t){this.sock.readyState===WebSocket.OPEN&&this.sock.send(t)},r.prototype.pause=function(){console.warn("WebSocketProxy stream pause/resume is not supported yet.")},r.prototype.resume=function(){},e.createConnection=function(t){return new r(t.format({protocol:t.protocol,slashes:t.slashes,host:t.host,hostname:t.hostname,port:t.port,pathname:t.pathname,search:t.search,path:t.path,query:t.query,hash:t.hash}))}}).call(e,n(5).Buffer)},function(t,e){e.connect=function(t,e){throw"TLS is not supported in the browser. Use WSS instead."}},function(t,e,n){"use strict";function r(){this.protocol=null,this.slashes=null,this.auth=null,this.host=null,this.port=null,this.hostname=null,this.hash=null,this.search=null,this.query=null,this.pathname=null,this.path=null,this.href=null}function i(t,e,n){if(t&&u.isObject(t)&&t instanceof r)return t;var i=new r;return i.parse(t,e,n),i}function o(t){return u.isString(t)&&(t=i(t)),t instanceof r?t.format():r.prototype.format.call(t)}function s(t,e){return i(t,!1,!0).resolve(e)}function a(t,e){return t?i(t,!1,!0).resolveObject(e):e}var c=n(72),u=n(74);e.parse=i,e.resolve=s,e.resolveObject=a,e.format=o,e.Url=r;var h=/^([a-z0-9.+-]+:)/i,f=/:[0-9]*$/,l=/^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,p=["<",">",'"',"`"," ","\r","\n","\t"],d=["{","}","|","\\","^","`"].concat(p),v=["'"].concat(d),y=["%","/","?",";","#"].concat(v),g=["/","?","#"],b=255,w=/^[+a-z0-9A-Z_-]{0,63}$/,m=/^([+a-z0-9A-Z_-]{0,63})(.*)$/,_={javascript:!0,"javascript:":!0},S={javascript:!0,"javascript:":!0},E={http:!0,https:!0,ftp:!0,gopher:!0,file:!0,"http:":!0,"https:":!0,"ftp:":!0,"gopher:":!0,"file:":!0},O=n(75);r.prototype.parse=function(t,e,n){if(!u.isString(t))throw new TypeError("Parameter 'url' must be a string, not "+typeof t);var r=t.indexOf("?"),i=r!==-1&&r<t.indexOf("#")?"?":"#",o=t.split(i),s=/\\/g;o[0]=o[0].replace(s,"/"),t=o.join(i);var a=t;if(a=a.trim(),!n&&1===t.split("#").length){var f=l.exec(a);if(f)return this.path=a,this.href=a,this.pathname=f[1],f[2]?(this.search=f[2],e?this.query=O.parse(this.search.substr(1)):this.query=this.search.substr(1)):e&&(this.search="",this.query={}),this}var p=h.exec(a);if(p){p=p[0];var d=p.toLowerCase();this.protocol=d,a=a.substr(p.length)}if(n||p||a.match(/^\/\/[^@\/]+@[^@\/]+/)){var T="//"===a.substr(0,2);!T||p&&S[p]||(a=a.substr(2),this.slashes=!0)}if(!S[p]&&(T||p&&!E[p])){for(var k=-1,C=0;C<g.length;C++){var j=a.indexOf(g[C]);j!==-1&&(k===-1||j<k)&&(k=j)}var x,B;B=k===-1?a.lastIndexOf("@"):a.lastIndexOf("@",k),B!==-1&&(x=a.slice(0,B),a=a.slice(B+1),this.auth=decodeURIComponent(x)),k=-1;for(var C=0;C<y.length;C++){var j=a.indexOf(y[C]);j!==-1&&(k===-1||j<k)&&(k=j)}k===-1&&(k=a.length),this.host=a.slice(0,k),a=a.slice(k),this.parseHost(),this.hostname=this.hostname||"";var A="["===this.hostname[0]&&"]"===this.hostname[this.hostname.length-1];if(!A)for(var I=this.hostname.split(/\./),C=0,R=I.length;C<R;C++){var M=I[C];if(M&&!M.match(w)){for(var N="",U=0,P=M.length;U<P;U++)N+=M.charCodeAt(U)>127?"x":M[U];if(!N.match(w)){var D=I.slice(0,C),L=I.slice(C+1),W=M.match(m);W&&(D.push(W[1]),L.unshift(W[2])),L.length&&(a="/"+L.join(".")+a),this.hostname=D.join(".");break}}}this.hostname.length>b?this.hostname="":this.hostname=this.hostname.toLowerCase(),A||(this.hostname=c.toASCII(this.hostname));var F=this.port?":"+this.port:"",z=this.hostname||"";this.host=z+F,this.href+=this.host,A&&(this.hostname=this.hostname.substr(1,this.hostname.length-2),"/"!==a[0]&&(a="/"+a))}if(!_[d])for(var C=0,R=v.length;C<R;C++){var q=v[C];if(a.indexOf(q)!==-1){var Y=encodeURIComponent(q);Y===q&&(Y=escape(q)),a=a.split(q).join(Y)}}var $=a.indexOf("#");$!==-1&&(this.hash=a.substr($),a=a.slice(0,$));var X=a.indexOf("?");if(X!==-1?(this.search=a.substr(X),this.query=a.substr(X+1),e&&(this.query=O.parse(this.query)),a=a.slice(0,X)):e&&(this.search="",this.query={}),a&&(this.pathname=a),E[d]&&this.hostname&&!this.pathname&&(this.pathname="/"),this.pathname||this.search){var F=this.pathname||"",J=this.search||"";this.path=F+J}return this.href=this.format(),this},r.prototype.format=function(){var t=this.auth||"";t&&(t=encodeURIComponent(t),t=t.replace(/%3A/i,":"),t+="@");var e=this.protocol||"",n=this.pathname||"",r=this.hash||"",i=!1,o="";this.host?i=t+this.host:this.hostname&&(i=t+(this.hostname.indexOf(":")===-1?this.hostname:"["+this.hostname+"]"),this.port&&(i+=":"+this.port)),this.query&&u.isObject(this.query)&&Object.keys(this.query).length&&(o=O.stringify(this.query));var s=this.search||o&&"?"+o||"";return e&&":"!==e.substr(-1)&&(e+=":"),this.slashes||(!e||E[e])&&i!==!1?(i="//"+(i||""),n&&"/"!==n.charAt(0)&&(n="/"+n)):i||(i=""),r&&"#"!==r.charAt(0)&&(r="#"+r),s&&"?"!==s.charAt(0)&&(s="?"+s),n=n.replace(/[?#]/g,function(t){return encodeURIComponent(t)}),s=s.replace("#","%23"),e+i+n+s+r},r.prototype.resolve=function(t){return this.resolveObject(i(t,!1,!0)).format()},r.prototype.resolveObject=function(t){if(u.isString(t)){var e=new r;e.parse(t,!1,!0),t=e}for(var n=new r,i=Object.keys(this),o=0;o<i.length;o++){var s=i[o];n[s]=this[s]}if(n.hash=t.hash,""===t.href)return n.href=n.format(),n;if(t.slashes&&!t.protocol){for(var a=Object.keys(t),c=0;c<a.length;c++){var h=a[c];"protocol"!==h&&(n[h]=t[h])}return E[n.protocol]&&n.hostname&&!n.pathname&&(n.path=n.pathname="/"),n.href=n.format(),n}if(t.protocol&&t.protocol!==n.protocol){if(!E[t.protocol]){for(var f=Object.keys(t),l=0;l<f.length;l++){var p=f[l];n[p]=t[p]}return n.href=n.format(),n}if(n.protocol=t.protocol,t.host||S[t.protocol])n.pathname=t.pathname;else{for(var d=(t.pathname||"").split("/");d.length&&!(t.host=d.shift()););t.host||(t.host=""),t.hostname||(t.hostname=""),""!==d[0]&&d.unshift(""),d.length<2&&d.unshift(""),n.pathname=d.join("/")}if(n.search=t.search,n.query=t.query,n.host=t.host||"",n.auth=t.auth,n.hostname=t.hostname||t.host,n.port=t.port,n.pathname||n.search){var v=n.pathname||"",y=n.search||"";n.path=v+y}return n.slashes=n.slashes||t.slashes,n.href=n.format(),n}var g=n.pathname&&"/"===n.pathname.charAt(0),b=t.host||t.pathname&&"/"===t.pathname.charAt(0),w=b||g||n.host&&t.pathname,m=w,_=n.pathname&&n.pathname.split("/")||[],d=t.pathname&&t.pathname.split("/")||[],O=n.protocol&&!E[n.protocol];if(O&&(n.hostname="",n.port=null,n.host&&(""===_[0]?_[0]=n.host:_.unshift(n.host)),n.host="",t.protocol&&(t.hostname=null,t.port=null,t.host&&(""===d[0]?d[0]=t.host:d.unshift(t.host)),t.host=null),w=w&&(""===d[0]||""===_[0])),b)n.host=t.host||""===t.host?t.host:n.host,n.hostname=t.hostname||""===t.hostname?t.hostname:n.hostname,n.search=t.search,n.query=t.query,_=d;else if(d.length)_||(_=[]),_.pop(),_=_.concat(d),n.search=t.search,n.query=t.query;else if(!u.isNullOrUndefined(t.search)){if(O){n.hostname=n.host=_.shift();var T=!!(n.host&&n.host.indexOf("@")>0)&&n.host.split("@");T&&(n.auth=T.shift(),n.host=n.hostname=T.shift())}return n.search=t.search,n.query=t.query,u.isNull(n.pathname)&&u.isNull(n.search)||(n.path=(n.pathname?n.pathname:"")+(n.search?n.search:"")),n.href=n.format(),n}if(!_.length)return n.pathname=null,n.search?n.path="/"+n.search:n.path=null,n.href=n.format(),n;for(var k=_.slice(-1)[0],C=(n.host||t.host||_.length>1)&&("."===k||".."===k)||""===k,j=0,x=_.length;x>=0;x--)k=_[x],"."===k?_.splice(x,1):".."===k?(_.splice(x,1),j++):j&&(_.splice(x,1),j--);if(!w&&!m)for(;j--;j)_.unshift("..");!w||""===_[0]||_[0]&&"/"===_[0].charAt(0)||_.unshift(""),C&&"/"!==_.join("/").substr(-1)&&_.push("");var B=""===_[0]||_[0]&&"/"===_[0].charAt(0);if(O){n.hostname=n.host=B?"":_.length?_.shift():"";var T=!!(n.host&&n.host.indexOf("@")>0)&&n.host.split("@");T&&(n.auth=T.shift(),n.host=n.hostname=T.shift())}return w=w||n.host&&_.length,w&&!B&&_.unshift(""),_.length?n.pathname=_.join("/"):(n.pathname=null,n.path=null),u.isNull(n.pathname)&&u.isNull(n.search)||(n.path=(n.pathname?n.pathname:"")+(n.search?n.search:"")),n.auth=t.auth||n.auth,n.slashes=n.slashes||t.slashes,n.href=n.format(),n},r.prototype.parseHost=function(){var t=this.host,e=f.exec(t);e&&(e=e[0],":"!==e&&(this.port=e.substr(1)),t=t.substr(0,t.length-e.length)),t&&(this.hostname=t)}},function(t,e,n){var r;(function(t,i){!function(o){function s(t){throw RangeError(I[t])}function a(t,e){for(var n=t.length,r=[];n--;)r[n]=e(t[n]);return r}function c(t,e){var n=t.split("@"),r="";n.length>1&&(r=n[0]+"@",t=n[1]),t=t.replace(A,".");var i=t.split("."),o=a(i,e).join(".");return r+o}function u(t){for(var e,n,r=[],i=0,o=t.length;i<o;)e=t.charCodeAt(i++),e>=55296&&e<=56319&&i<o?(n=t.charCodeAt(i++),56320==(64512&n)?r.push(((1023&e)<<10)+(1023&n)+65536):(r.push(e),i--)):r.push(e);return r}function h(t){return a(t,function(t){var e="";return t>65535&&(t-=65536,e+=N(t>>>10&1023|55296),t=56320|1023&t),e+=N(t)}).join("")}function f(t){return t-48<10?t-22:t-65<26?t-65:t-97<26?t-97:_}function l(t,e){return t+22+75*(t<26)-((0!=e)<<5)}function p(t,e,n){var r=0;for(t=n?M(t/T):t>>1,t+=M(t/e);t>R*E>>1;r+=_)t=M(t/R);return M(r+(R+1)*t/(t+O))}function d(t){var e,n,r,i,o,a,c,u,l,d,v=[],y=t.length,g=0,b=C,w=k;for(n=t.lastIndexOf(j),n<0&&(n=0),r=0;r<n;++r)t.charCodeAt(r)>=128&&s("not-basic"),v.push(t.charCodeAt(r));for(i=n>0?n+1:0;i<y;){for(o=g,a=1,c=_;i>=y&&s("invalid-input"),u=f(t.charCodeAt(i++)),(u>=_||u>M((m-g)/a))&&s("overflow"),g+=u*a,l=c<=w?S:c>=w+E?E:c-w,!(u<l);c+=_)d=_-l,a>M(m/d)&&s("overflow"),a*=d;e=v.length+1,w=p(g-o,e,0==o),M(g/e)>m-b&&s("overflow"),b+=M(g/e),g%=e,v.splice(g++,0,b)}return h(v)}function v(t){var e,n,r,i,o,a,c,h,f,d,v,y,g,b,w,O=[];for(t=u(t),y=t.length,e=C,n=0,o=k,a=0;a<y;++a)v=t[a],v<128&&O.push(N(v));for(r=i=O.length,i&&O.push(j);r<y;){for(c=m,a=0;a<y;++a)v=t[a],v>=e&&v<c&&(c=v);for(g=r+1,c-e>M((m-n)/g)&&s("overflow"),n+=(c-e)*g,e=c,a=0;a<y;++a)if(v=t[a],v<e&&++n>m&&s("overflow"),v==e){for(h=n,f=_;d=f<=o?S:f>=o+E?E:f-o,!(h<d);f+=_)w=h-d,b=_-d,O.push(N(l(d+w%b,0))),h=M(w/b);O.push(N(l(h,0))),o=p(n,g,r==i),n=0,++r}++n,++e}return O.join("")}function y(t){return c(t,function(t){return x.test(t)?d(t.slice(4).toLowerCase()):t})}function g(t){return c(t,function(t){return B.test(t)?"xn--"+v(t):t})}var b=("object"==typeof e&&e&&!e.nodeType&&e,"object"==typeof t&&t&&!t.nodeType&&t,"object"==typeof i&&i);b.global!==b&&b.window!==b&&b.self!==b||(o=b);var w,m=2147483647,_=36,S=1,E=26,O=38,T=700,k=72,C=128,j="-",x=/^xn--/,B=/[^\x20-\x7E]/,A=/[\x2E\u3002\uFF0E\uFF61]/g,I={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},R=_-S,M=Math.floor,N=String.fromCharCode;w={version:"1.3.2",ucs2:{decode:u,encode:h},decode:d,encode:v,toASCII:g,toUnicode:y},r=function(){return w}.call(e,n,e,t),!(void 0!==r&&(t.exports=r))}(this)}).call(e,n(73)(t),function(){return this}())},function(t,e){t.exports=function(t){return t.webpackPolyfill||(t.deprecate=function(){},t.paths=[],t.children=[],t.webpackPolyfill=1),t}},function(t,e){"use strict";t.exports={isString:function(t){return"string"==typeof t},isObject:function(t){return"object"==typeof t&&null!==t},isNull:function(t){return null===t},isNullOrUndefined:function(t){return null==t}}},function(t,e,n){"use strict";e.decode=e.parse=n(76),e.encode=e.stringify=n(77)},function(t,e){"use strict";function n(t,e){return Object.prototype.hasOwnProperty.call(t,e)}t.exports=function(t,e,r,i){e=e||"&",r=r||"=";var o={};if("string"!=typeof t||0===t.length)return o;var s=/\+/g;t=t.split(e);var a=1e3;i&&"number"==typeof i.maxKeys&&(a=i.maxKeys);var c=t.length;a>0&&c>a&&(c=a);for(var u=0;u<c;++u){var h,f,l,p,d=t[u].replace(s,"%20"),v=d.indexOf(r);v>=0?(h=d.substr(0,v),f=d.substr(v+1)):(h=d,f=""),l=decodeURIComponent(h),p=decodeURIComponent(f),n(o,l)?Array.isArray(o[l])?o[l].push(p):o[l]=[o[l],p]:o[l]=p}return o}},function(t,e){"use strict";var n=function(t){switch(typeof t){case"string":return t;case"boolean":return t?"true":"false";case"number":return isFinite(t)?t:"";default:return""}};t.exports=function(t,e,r,i){return e=e||"&",r=r||"=",null===t&&(t=void 0),"object"==typeof t?Object.keys(t).map(function(i){var o=encodeURIComponent(n(i))+r;return Array.isArray(t[i])?t[i].map(function(t){return o+encodeURIComponent(n(t))}).join(e):o+encodeURIComponent(n(t[i]))}).join(e):i?encodeURIComponent(n(i))+r+encodeURIComponent(n(t)):""}},function(t,e,n){t.exports=n(79)},function(t,e,n){(function(t){/*!
		 * Nats
		 * Copyright(c) 2016 Apcera Inc. All rights reserved.
		 * MIT Licensed
		 */
	"use strict";function r(){this.buf=new t(p),this.init()}var i=n(4),o="0.6.8",s="0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ",a=36,c=12,u=10,h=0xcfd41b9100000,f=33,l=333,p=c+u;e.version=o,r.prototype.init=function(){this.setPre(),this.initSeqAndInc(),this.fillSeq()},r.prototype.initSeqAndInc=function(){this.seq=Math.floor(Math.random()*h),this.inc=Math.floor(Math.random()*(l-f)+f)},r.prototype.setPre=function(){for(var t=i.randomBytes(c),e=0;e<c;e++){var n=t[e]%a;this.buf[e]=s.charCodeAt(n)}},r.prototype.fillSeq=function(){for(var t=this.seq,e=p-1;e>=c;e--)this.buf[e]=s.charCodeAt(t%a),t=Math.floor(t/a)},r.prototype.next=function(){return this.seq+=this.inc,this.seq>h&&this.setPre(),this.initSeqAndInc(),this.fillSeq(),this.buf.toString("ascii")};var d=new r;e.reset=function(){d.init()},e.next=function(){return d.next()},e._global=d}).call(e,n(5).Buffer)},function(t,e,n){function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var i=(n(1),n(2),function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}());n(81);var o=n(67),s=function(){function t(){r(this,t),"undefined"==typeof window.NAT_SERVERS&&(window.NAT_SERVERS=["wss://rop.mudu.tv:4224"]),this.servers=window.NAT_SERVERS,this.nc=o.connect({servers:this.servers,reconnectTimeWait:0,maxReconnectAttempts:1/0}),this.commentCB=null,this.commentStreamCB=null,this.streamEventCB=null,this.topic_sid_map={},this.hasrun=!1}return i(t,[{key:"Init",value:function(){}},{key:"On",value:function(t,e){"undefined"==typeof this.topic_sid_map[t]&&(this.topic_sid_map[t]=[]),this.topic_sid_map[t].push(this.nc.subscribe(t,e))}},{key:"Remove",value:function(t){if("undefined"!=typeof this.topic_sid_map[t])for(var e;e=this.topic_sid_map[t].pop();)this.nc.unsubscribe(e)}},{key:"Send",value:function(t,e){this.nc.publish(t,e)}},{key:"SetCommentCallBack",value:function(t){this.commentCB=t}},{key:"SetCommentStreamCallBack",value:function(t){this.commentStreamCB=t}},{key:"SetStreamEventCallBack",value:function(t){this.streamEventCB=t}},{key:"Run",value:function(t){var e=this;this.hasrun||(this.hasrun=!0,this.On("comment-"+t,function(t){if(null!=e.commentCB){var n=JSON.parse(t);e.commentCB(n)}}),this.On("stream-event",function(t){if(null!=e.streamEventCB){var n=JSON.parse(t);e.streamEventCB(n)}}),this.On("comment-stream-"+t,function(t){if(null!=e.commentStreamCB){var n=JSON.parse(t);e.commentStreamCB(n)}}))}}]),t}();t.exports=s},function(t,e,n){var r;(function(t,i){(function(){function o(t,e){function n(t){if(n[t]!==y)return n[t];var o;if("bug-string-char-index"==t)o="a"!="a"[0];else if("json"==t)o=n("json-stringify")&&n("json-parse");else{var s,a='{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';if("json-stringify"==t){var u=e.stringify,h="function"==typeof u&&w;if(h){(s=function(){return 1}).toJSON=s;try{h="0"===u(0)&&"0"===u(new r)&&'""'==u(new i)&&u(b)===y&&u(y)===y&&u()===y&&"1"===u(s)&&"[1]"==u([s])&&"[null]"==u([y])&&"null"==u(null)&&"[null,null,null]"==u([y,b,null])&&u({a:[s,!0,!1,null,"\0\b\n\f\r\t"]})==a&&"1"===u(null,s)&&"[\n 1,\n 2\n]"==u([1,2],null,1)&&'"-271821-04-20T00:00:00.000Z"'==u(new c(-864e13))&&'"+275760-09-13T00:00:00.000Z"'==u(new c(864e13))&&'"-000001-01-01T00:00:00.000Z"'==u(new c(-621987552e5))&&'"1969-12-31T23:59:59.999Z"'==u(new c(-1))}catch(f){h=!1}}o=h}if("json-parse"==t){var l=e.parse;if("function"==typeof l)try{if(0===l("0")&&!l(!1)){s=l(a);var p=5==s.a.length&&1===s.a[0];if(p){try{p=!l('"\t"')}catch(f){}if(p)try{p=1!==l("01")}catch(f){}if(p)try{p=1!==l("1.")}catch(f){}}}}catch(f){p=!1}o=p}}return n[t]=!!o}t||(t=u.Object()),e||(e=u.Object());var r=t.Number||u.Number,i=t.String||u.String,s=t.Object||u.Object,c=t.Date||u.Date,h=t.SyntaxError||u.SyntaxError,f=t.TypeError||u.TypeError,l=t.Math||u.Math,p=t.JSON||u.JSON;"object"==typeof p&&p&&(e.stringify=p.stringify,e.parse=p.parse);var d,v,y,g=s.prototype,b=g.toString,w=new c(-0xc782b5b800cec);try{w=w.getUTCFullYear()==-109252&&0===w.getUTCMonth()&&1===w.getUTCDate()&&10==w.getUTCHours()&&37==w.getUTCMinutes()&&6==w.getUTCSeconds()&&708==w.getUTCMilliseconds()}catch(m){}if(!n("json")){var _="[object Function]",S="[object Date]",E="[object Number]",O="[object String]",T="[object Array]",k="[object Boolean]",C=n("bug-string-char-index");if(!w)var j=l.floor,x=[0,31,59,90,120,151,181,212,243,273,304,334],B=function(t,e){return x[e]+365*(t-1970)+j((t-1969+(e=+(e>1)))/4)-j((t-1901+e)/100)+j((t-1601+e)/400)};if((d=g.hasOwnProperty)||(d=function(t){var e,n={};return(n.__proto__=null,n.__proto__={toString:1},n).toString!=b?d=function(t){var e=this.__proto__,n=t in(this.__proto__=null,this);return this.__proto__=e,n}:(e=n.constructor,d=function(t){var n=(this.constructor||e).prototype;return t in this&&!(t in n&&this[t]===n[t])}),n=null,d.call(this,t)}),v=function(t,e){var n,r,i,o=0;(n=function(){this.valueOf=0}).prototype.valueOf=0,r=new n;for(i in r)d.call(r,i)&&o++;return n=r=null,o?v=2==o?function(t,e){var n,r={},i=b.call(t)==_;for(n in t)i&&"prototype"==n||d.call(r,n)||!(r[n]=1)||!d.call(t,n)||e(n)}:function(t,e){var n,r,i=b.call(t)==_;for(n in t)i&&"prototype"==n||!d.call(t,n)||(r="constructor"===n)||e(n);(r||d.call(t,n="constructor"))&&e(n)}:(r=["valueOf","toString","toLocaleString","propertyIsEnumerable","isPrototypeOf","hasOwnProperty","constructor"],v=function(t,e){var n,i,o=b.call(t)==_,s=!o&&"function"!=typeof t.constructor&&a[typeof t.hasOwnProperty]&&t.hasOwnProperty||d;for(n in t)o&&"prototype"==n||!s.call(t,n)||e(n);for(i=r.length;n=r[--i];s.call(t,n)&&e(n));}),v(t,e)},!n("json-stringify")){var A={92:"\\\\",34:'\\"',8:"\\b",12:"\\f",10:"\\n",13:"\\r",9:"\\t"},I="000000",R=function(t,e){return(I+(e||0)).slice(-t)},M="\\u00",N=function(t){for(var e='"',n=0,r=t.length,i=!C||r>10,o=i&&(C?t.split(""):t);n<r;n++){var s=t.charCodeAt(n);switch(s){case 8:case 9:case 10:case 12:case 13:case 34:case 92:e+=A[s];break;default:if(s<32){e+=M+R(2,s.toString(16));break}e+=i?o[n]:t.charAt(n)}}return e+'"'},U=function(t,e,n,r,i,o,s){var a,c,u,h,l,p,g,w,m,_,C,x,A,I,M,P;try{a=e[t]}catch(D){}if("object"==typeof a&&a)if(c=b.call(a),c!=S||d.call(a,"toJSON"))"function"==typeof a.toJSON&&(c!=E&&c!=O&&c!=T||d.call(a,"toJSON"))&&(a=a.toJSON(t));else if(a>-1/0&&a<1/0){if(B){for(l=j(a/864e5),u=j(l/365.2425)+1970-1;B(u+1,0)<=l;u++);for(h=j((l-B(u,0))/30.42);B(u,h+1)<=l;h++);l=1+l-B(u,h),p=(a%864e5+864e5)%864e5,g=j(p/36e5)%24,w=j(p/6e4)%60,m=j(p/1e3)%60,_=p%1e3}else u=a.getUTCFullYear(),h=a.getUTCMonth(),l=a.getUTCDate(),g=a.getUTCHours(),w=a.getUTCMinutes(),m=a.getUTCSeconds(),_=a.getUTCMilliseconds();a=(u<=0||u>=1e4?(u<0?"-":"+")+R(6,u<0?-u:u):R(4,u))+"-"+R(2,h+1)+"-"+R(2,l)+"T"+R(2,g)+":"+R(2,w)+":"+R(2,m)+"."+R(3,_)+"Z"}else a=null;if(n&&(a=n.call(e,t,a)),null===a)return"null";if(c=b.call(a),c==k)return""+a;if(c==E)return a>-1/0&&a<1/0?""+a:"null";if(c==O)return N(""+a);if("object"==typeof a){for(I=s.length;I--;)if(s[I]===a)throw f();if(s.push(a),C=[],M=o,o+=i,c==T){for(A=0,I=a.length;A<I;A++)x=U(A,a,n,r,i,o,s),C.push(x===y?"null":x);P=C.length?i?"[\n"+o+C.join(",\n"+o)+"\n"+M+"]":"["+C.join(",")+"]":"[]"}else v(r||a,function(t){var e=U(t,a,n,r,i,o,s);e!==y&&C.push(N(t)+":"+(i?" ":"")+e)}),P=C.length?i?"{\n"+o+C.join(",\n"+o)+"\n"+M+"}":"{"+C.join(",")+"}":"{}";return s.pop(),P}};e.stringify=function(t,e,n){var r,i,o,s;if(a[typeof e]&&e)if((s=b.call(e))==_)i=e;else if(s==T){o={};for(var c,u=0,h=e.length;u<h;c=e[u++],s=b.call(c),(s==O||s==E)&&(o[c]=1));}if(n)if((s=b.call(n))==E){if((n-=n%1)>0)for(r="",n>10&&(n=10);r.length<n;r+=" ");}else s==O&&(r=n.length<=10?n:n.slice(0,10));return U("",(c={},c[""]=t,c),i,o,r,"",[])}}if(!n("json-parse")){var P,D,L=i.fromCharCode,W={92:"\\",34:'"',47:"/",98:"\b",116:"\t",110:"\n",102:"\f",114:"\r"},F=function(){throw P=D=null,h()},z=function(){for(var t,e,n,r,i,o=D,s=o.length;P<s;)switch(i=o.charCodeAt(P)){case 9:case 10:case 13:case 32:P++;break;case 123:case 125:case 91:case 93:case 58:case 44:return t=C?o.charAt(P):o[P],P++,t;case 34:for(t="@",P++;P<s;)if(i=o.charCodeAt(P),i<32)F();else if(92==i)switch(i=o.charCodeAt(++P)){case 92:case 34:case 47:case 98:case 116:case 110:case 102:case 114:t+=W[i],P++;break;case 117:for(e=++P,n=P+4;P<n;P++)i=o.charCodeAt(P),i>=48&&i<=57||i>=97&&i<=102||i>=65&&i<=70||F();t+=L("0x"+o.slice(e,P));break;default:F()}else{if(34==i)break;for(i=o.charCodeAt(P),e=P;i>=32&&92!=i&&34!=i;)i=o.charCodeAt(++P);t+=o.slice(e,P)}if(34==o.charCodeAt(P))return P++,t;F();default:if(e=P,45==i&&(r=!0,i=o.charCodeAt(++P)),i>=48&&i<=57){for(48==i&&(i=o.charCodeAt(P+1),i>=48&&i<=57)&&F(),r=!1;P<s&&(i=o.charCodeAt(P),i>=48&&i<=57);P++);if(46==o.charCodeAt(P)){for(n=++P;n<s&&(i=o.charCodeAt(n),i>=48&&i<=57);n++);n==P&&F(),P=n}if(i=o.charCodeAt(P),101==i||69==i){for(i=o.charCodeAt(++P),43!=i&&45!=i||P++,n=P;n<s&&(i=o.charCodeAt(n),i>=48&&i<=57);n++);n==P&&F(),P=n}return+o.slice(e,P)}if(r&&F(),"true"==o.slice(P,P+4))return P+=4,!0;if("false"==o.slice(P,P+5))return P+=5,!1;if("null"==o.slice(P,P+4))return P+=4,null;F()}return"$"},q=function(t){var e,n;if("$"==t&&F(),"string"==typeof t){if("@"==(C?t.charAt(0):t[0]))return t.slice(1);if("["==t){for(e=[];t=z(),"]"!=t;n||(n=!0))n&&(","==t?(t=z(),"]"==t&&F()):F()),","==t&&F(),e.push(q(t));return e}if("{"==t){for(e={};t=z(),"}"!=t;n||(n=!0))n&&(","==t?(t=z(),"}"==t&&F()):F()),","!=t&&"string"==typeof t&&"@"==(C?t.charAt(0):t[0])&&":"==z()||F(),e[t.slice(1)]=q(z());return e}F()}return t},Y=function(t,e,n){var r=$(t,e,n);r===y?delete t[e]:t[e]=r},$=function(t,e,n){var r,i=t[e];if("object"==typeof i&&i)if(b.call(i)==T)for(r=i.length;r--;)Y(i,r,n);else v(i,function(t){Y(i,t,n)});return n.call(t,e,i)};e.parse=function(t,e){var n,r;return P=0,D=""+t,n=q(z()),"$"!=z()&&F(),P=D=null,e&&b.call(e)==_?$((r={},r[""]=n,r),"",e):n}}}return e.runInContext=o,e}var s=n(82),a={"function":!0,object:!0},c=a[typeof e]&&e&&!e.nodeType&&e,u=a[typeof window]&&window||this,h=c&&a[typeof t]&&t&&!t.nodeType&&"object"==typeof i&&i;if(!h||h.global!==h&&h.window!==h&&h.self!==h||(u=h),c&&!s)o(u,c);else{var f=u.JSON,l=u.JSON3,p=!1,d=o(u,u.JSON3={noConflict:function(){return p||(p=!0,u.JSON=f,u.JSON3=l,f=l=null),d}});u.JSON={parse:d.parse,stringify:d.stringify}}s&&(r=function(){return d}.call(e,n,e,t),!(void 0!==r&&(t.exports=r)))}).call(this)}).call(e,n(73)(t),function(){return this}())},function(t,e){(function(e){t.exports=e}).call(e,{})}]);
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = messager;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(194).setImmediate, __webpack_require__(194).clearImmediate))

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {var nextTick = __webpack_require__(195).nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) { timeout.close(); };
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
	  delete immediateIds[id];
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(194).setImmediate, __webpack_require__(194).clearImmediate))

/***/ },
/* 195 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** /js/sdk.js
 **/